webpackJsonp([1],{

/***/ "+hrM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/4Cf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/6I1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/XK3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "1d4E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1rJf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1tAE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2B8d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Dfj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2kye":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46ce9210","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "58an":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Flw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Zl2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6+SP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js + 1 modules
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4154764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("RS6h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37c27a69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var confirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var confirm_staticRenderFns = []
var confirm_esExports = { render: confirm_render, staticRenderFns: confirm_staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (confirm_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function confirm_injectStyle (ssrContext) {
  __webpack_require__("pzpp")
}
var confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirm___vue_template_functional__ = false
/* styles */
var confirm___vue_styles__ = confirm_injectStyle
/* scopeId */
var confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confirm___vue_module_identifier__ = null
var confirm_Component = confirm_normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  confirm___vue_template_functional__,
  confirm___vue_styles__,
  confirm___vue_scopeId__,
  confirm___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = __webpack_exports__["a"] = (confirm_Component.exports);


/***/ }),

/***/ "6OpF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6lEy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7xtA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8xMK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8xu2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9sqQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ALsH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0178dc7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("OxkT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CJZ5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CLHC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D+Bg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D42g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DS/O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dzs9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gk1W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GmEV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GoFI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H0sH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IRVY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JWXY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Js7q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KRKC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KkjN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KzRA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LkwW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LmmJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MA8l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MITv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MVsy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var getters_namespaceObject = {};
__webpack_require__.d(getters_namespaceObject, "mpvueInfo", function() { return mpvueInfo; });
__webpack_require__.d(getters_namespaceObject, "title", function() { return getters_title; });
__webpack_require__.d(getters_namespaceObject, "profile", function() { return getters_profile; });
__webpack_require__.d(getters_namespaceObject, "taxonomyList", function() { return taxonomyList; });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-icon-font/dist/vue-iconfont.js
var vue_iconfont = __webpack_require__("Jp/R");
var vue_iconfont_default = /*#__PURE__*/__webpack_require__.n(vue_iconfont);

// EXTERNAL MODULE: ./node_modules/vue-scrollto/vue-scrollto.js
var vue_scrollto = __webpack_require__("bm7V");
var vue_scrollto_default = /*#__PURE__*/__webpack_require__.n(vue_scrollto);

// EXTERNAL MODULE: ./node_modules/vue-touch/dist/vue-touch.js
var vue_touch = __webpack_require__("I0MY");
var vue_touch_default = /*#__PURE__*/__webpack_require__.n(vue_touch);

// EXTERNAL MODULE: ./node_modules/vue-baidu-map/index.js
var vue_baidu_map = __webpack_require__("dAEq");
var vue_baidu_map_default = /*#__PURE__*/__webpack_require__.n(vue_baidu_map);

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue + 3 modules
var flexbox = __webpack_require__("YxJB");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue + 3 modules
var flexbox_item = __webpack_require__("3Lt7");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("NXWw");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/state.js
var state = {
  mpvueInfo: '基于 Vue.js 的小程序开发框架，从底层支持 Vue.js 语法和构建工具体系。',
  title: '软盟',
  profile: {
    attribute: {},
    company: {}
  },
  taxonomyList: [{
    tabId: 0,
    icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_img_wechat.png',
    name: '微信',
    navName: '微信营销',
    tabType: 'woa',
    mediaAvatarShow: true,
    mediaBargeShow: true,
    mediaPlatformShow: false,
    analysisTypes: ['category', 'fansNum', 'avgReadNum'],
    analysisDetailTypes: ['avgReadNumTop', 'avgLikeNumTop', 'avgReadNumUntop', 'avgLikeNumUntop', 'maxReadNum', 'maxLikeNum'],
    iconClass: 'icon-weixinicon',
    iconClassColor: '#63ca71',
    sortName: ['综合排序', '头条价格', '非头条价格', '粉丝量'],
    sortField: ['', 'price', 'price_second', 'fan_num'],
    priceType: ['top', 'non_top'],
    priceTypeName: ['头条价', '非头条价']
  }, {
    tabId: 1,
    icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_img_redbook.png',
    name: '小红书',
    navName: '小红书',
    tabType: 'xhs',
    mediaAvatarShow: true,
    mediaBargeShow: false,
    mediaPlatformShow: false,
    analysisTypes: ['category', 'fansNum', 'avgLikeNum'],
    iconClass: 'icon-xiaohongshu',
    iconClassColor: '#ff0000',
    sortName: ['综合排序', '图文价格', '视频价格', '粉丝量'],
    sortField: ['', 'price_second', 'price', 'fans_num'],
    priceType: ['video', 'imagetext'],
    priceTypeName: ['视频', '图文']
  }, {
    tabId: 2,
    icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_img_weibo.png',
    name: '微博',
    navName: '微博营销',
    tabType: 'weibo',
    mediaAvatarShow: true,
    mediaBargeShow: false,
    mediaPlatformShow: false,
    analysisTypes: ['category', 'fansNum', 'avgLikeNum'],
    iconClass: 'icon-weibo1',
    iconClassColor: '#b6362f',
    sortName: ['综合排序', '价格', '粉丝量', '转发量', '点赞量'],
    sortField: ['', 'price', 'fan_num', 'avg_retweet_num', 'avg_like_num'],
    priceType: ['tweet', 'retweet'],
    priceTypeName: ['直发价', '转发价']
  }, {
    tabId: 3,
    icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_img_video.png',
    name: '短视频',
    navName: '视频营销',
    tabType: 'video',
    mediaAvatarShow: true,
    mediaBargeShow: false,
    mediaPlatformShow: true,
    analysisTypes: ['category', 'fansNum', 'avgPlayNum'],
    iconClass: 'icon-duanshipin',
    iconClassColor: '#ae7af5',
    sortName: ['综合排序', '价格', '播放量', '粉丝量'],
    sortField: ['', 'price', 'avg_play_num', 'fan_num'],
    priceType: ['original_publish', 'publish'],
    priceTypeName: ['原创发布', '发布']
  }, {
    tabId: 4,
    icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_img_live.png',
    name: '网红',
    navName: '网红直播',
    tabType: 'live',
    mediaAvatarShow: true,
    mediaBargeShow: false,
    mediaPlatformShow: true,
    analysisTypes: ['category', 'fansNum', 'avgAudienceNum'],
    iconClass: 'icon-zhibo',
    iconClassColor: '#ed8532',
    sortName: ['综合排序', '价格', '粉丝量'],
    sortField: ['', 'price', 'fan_num'],
    priceType: ['online', 'offline'],
    priceTypeName: ['线上直播', '线下转发']
    // {
    //   tabId: 5,
    //   icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_img_news.png',
    //   name: '软文',
    //   navName: '软文推广',
    //   tabType: 'news',
    //   mediaAvatarShow: false,
    //   mediaBargeShow: false,
    //   analysisTypes: ['category', 'publishRate', 'mbaiduRank'],
    //   iconClass: 'icon-ruanwen-huoyan',
    //   iconClassColor: '#e93f33',
    //   sortName: ['综合排序', '价格', 'PC权重', 'WAP权重', '出稿率'],
    //   sortField: ['', 'price', 'pc_baidu_rank', 'm_baidu_rank', 'publish_rate'],
    //   priceType: [''],
    //   priceTypeName: ['参考价']
    // }
  }]
};

/* harmony default export */ var store_state = (state);
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// mutation 常量

var SET_MPVUEINFO = 'SET_MPVUEINFO';
var SET_PROFILE = 'SET_PROFILE';
var SET_TITLE = 'SET_TITLE';
// CONCATENATED MODULE: ./src/store/mutations.js


var _mutations;



var mutations = (_mutations = {}, defineProperty_default()(_mutations, SET_MPVUEINFO, function (state, mpvueInfo) {
  // eslint-disable-line
  state.mpvueInfo = mpvueInfo;
}), defineProperty_default()(_mutations, SET_TITLE, function (state, title) {
  state.title = title;
}), defineProperty_default()(_mutations, SET_PROFILE, function (state, profile) {
  // eslint-disable-line
  state.profile = profile;
}), _mutations);

/* harmony default export */ var store_mutations = (mutations);
// CONCATENATED MODULE: ./src/store/getters.js
var mpvueInfo = function mpvueInfo(state) {
  return state.mpvueInfo;
};
var getters_title = function title(state) {
  return state.title;
};
var getters_profile = function profile(state) {
  return state.profile;
};
var taxonomyList = function taxonomyList(state) {
  return state.taxonomyList;
};
// EXTERNAL MODULE: ./src/store/actions.js
var actions = __webpack_require__("mUbh");
var actions_default = /*#__PURE__*/__webpack_require__.n(actions);

// CONCATENATED MODULE: ./src/store/index.js







vue_esm["default"].use(vuex_esm["a" /* default */]);
/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({ // eslint-disable-line
  state: store_state,
  mutations: store_mutations,
  actions: actions,
  getters: getters_namespaceObject
}));
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/flyio/dist/npm/fly.js
var npm_fly = __webpack_require__("c1Z7");
var fly_default = /*#__PURE__*/__webpack_require__.n(npm_fly);

// CONCATENATED MODULE: ./src/utils/wx.js
// src/utils/wx.js


/* harmony default export */ var wx = ({
  startPullDownRefresh: function startPullDownRefresh() {
    console.log('startPullDownRefresh');
  },
  showLoading: function showLoading() {
    vue_esm["default"].prototype.$loading('加载中');
  },
  hideLoading: function hideLoading() {
    if (!document.querySelector('.lx-load-mark')) return;
    vue_esm["default"].prototype.$loading.close();
  },
  showToast: function showToast(_ref) {
    var title = _ref.title;

    vue_esm["default"].prototype.$toast.center(title);
  }
});
// CONCATENATED MODULE: ./src/utils/index.js
function formatNumber(n) {
  var str = n.toString();
  return str[1] ? str : '0' + str;
}

function formatTime(date) {
  var tdate = new Date(parseInt(date) * 1000);
  var year = tdate.getFullYear();
  var month = tdate.getMonth() + 1;
  var day = tdate.getDate();

  var hour = tdate.getHours();
  var minute = tdate.getMinutes();
  var second = tdate.getSeconds();

  var t1 = [year, month, day].map(formatNumber).join('.');
  var t2 = [hour, minute, second].map(formatNumber).join(':');
  return t1 + ' ' + t2;
}

function formatDate(date) {
  var tDate = new Date(parseInt(date) * 1000);
  var year = tDate.getFullYear();
  var month = tDate.getMonth() + 1;
  var day = tDate.getDate();

  var t1 = [year, month, day].map(formatNumber).join('.');

  return '' + t1;
}

function formatNumInTenThousand(data) {
  var num = parseInt(data);
  var num2 = num / 10000;
  if (num2 >= 1) {
    return Math.round(num2 * 100) / 100 + '万';
  } else {
    return num;
  }
}

function originalPrice(data) {
  var num = parseInt(data);
  var num2 = num * 2;
  return num2;
}

// 获取cookie、
function getCookie(name) {
  var arr,
      reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)'); // eslint-disable-line
  if (arr = document.cookie.match(reg)) {
    // eslint-disable-line
    return arr[2];
  } else {
    return null;
  }
}

// 设置cookie,增加到vue实例方便全局调用
function setCookie(cName, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = cName + '=' + escape(value) + (expiredays == null ? '' : ';expires=' + exdate.toGMTString());
}

// 删除cookie
function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
  }
}

function isWechat() {
  return (/windowswechat/.test(navigator.userAgent.toLowerCase())
  );
}
// CONCATENATED MODULE: ./src/utils/request.js

// import wx from 'wx';

// import router from '../router/index'


// import {getCookie} from './index';

var request_fly = new fly_default.a(); // 创建fly实例

// fly 默认设置部分
request_fly.config.baseURL = 'https://api.ruan.net/api'; // BaseUrl
request_fly.config.withCredentials = true; // 跨域时是否发送cookie
request_fly.config.timeout = 5000; // timeout时间
request_fly.config.headers = { // 设置头部
  'x-identity': 'advertiser'
  // 'Authorization': `Bearer ${getCookie('token')}`


  // 添加请求拦截器
};request_fly.interceptors.request.use(function (request) {
  // 给所有请求添加自定义header
  // request.headers['X-Tag'] = 'flyio';

  // 判断用户是否有token
  // if (getCookie('token')) {
  //
  // } else {
  //   window.location = '/login';
  //   // wx.redirectTo({url: '/pages/login/login'});
  // }

  // wx.showLoading();

  // 终止请求
  // var err=new Error("xxx")
  // err.request=request
  // return Promise.reject(new Error(""))

  // 可以显式返回request, 也可以不返回，没有返回值时拦截器中默认返回request
  return request;
});

// 添加响应拦截器，响应拦截器会在then/catch处理之前执行
request_fly.interceptors.response.use(function (response) {
  var res = response.data;

  // wx.hideLoading();

  if (!res.success) {
    // Message({
    //   message: res.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })

    return promise_default.a.reject(response.data);
  } else {
    return response.data;
  }
}, function (error) {
  // 发生网络错误后会走到这里
  wx.hideLoading();
  // console.log('err' + error.status); // for debug
  // Message({
  //   message: error.response.data.message,
  //   type: 'error',
  //   duration: 5 * 1000
  // })

  // 401 未知的用户凭证
  if (error.status === 401) {
    delCookie('token');
    // router.push('/login')
  }
  return promise_default.a.reject(error.response.data);
});

/* harmony default export */ var request = (request_fly);
// CONCATENATED MODULE: ./src/api/user.js


/*
 *  账号密码登录
 */
function authLogin(data) {
  return request.request('/auth/authenticate', data, { method: 'POST' });
} /*
  *  账号密码登录
  */
function guestRegister(data) {
  return request.request('/guest', data, { method: 'POST' });
}

/*
 *  账号密码注册
 */
function authRegister(data) {
  return request.request('/auth/signup', data, { method: 'POST' });
}

/*
 *  账号退出登录
 */
function authLogout() {
  return request.request('/auth/logout', { device: 'wap' }, { method: 'POST' });
}

/*
 * 查询用户信息
 */
function fetchUser() {
  return request.request('/personal/profile', {}, { method: 'get' });
}

/*
 * 查询订单状态数量信息
 */
function fetchOrderStatus() {
  return request.request('/personal/transaction_stat', {}, { method: 'get' });
}

/*
 * 查询客户经理信息
 */
function fetchCustomerService() {
  return request.request('/personal/customer_service', {}, { method: 'get' });
}

/*
 * 修改用户信息
 *
 {
 name: vm.name,
 email: vm.email,
 qq: vm.qq,
 company_site: vm.company_site,
 company_name: vm.company_name,
 company_address: vm.company_address
 }
 *
 *
 *
 */
function editUserInfo(params) {
  return request.request('/personal/profile', params, { method: 'post' });
}

/*
 * 修改密码
 */
function changePassword(params) {
  return request.request('/auth/reset_password', params, { method: 'post' });
}

/*
 * 通过微信code获取token，没有token会返回{openid，session_key，unionid}，
 * */
function authToken(code) {
  return request.request('/connect/wx_lite/login', { code: code }, { method: 'get' });
}

/*
 *  通过获取手机号码getphonenumber登录，如果用户不存在，系统将会自动创建用户。验证成功后，会返回token
 * */

function authPhoneNumRegister(data) {
  return request.request('/connect/wx_lite/authenticate', data, { method: 'post' });
}

/*
 *  获取交易流水
 * */

function getFinanceTransaction(page) {
  return request.request('/finance/transaction', {
    page: page,
    status: 'success'
  }, { method: 'get' });
}

/*
 *  获取充值记录
 * */

function getRechargeHistory(page) {
  return request.request('/finance/recharge', {
    page: page,
    status: 'success'
  }, { method: 'get' });
}

/*
 *  获取退款记录
 * */

function getRefundHistory(page) {
  return request.request('/finance/refund', {
    page: page
  }, { method: 'get' });
}

/*
 *  获取消费记录
 * */

function getConsumeHistory(page) {
  return request.request('/finance/consume', {
    page: page
  }, { method: 'get' });
}

/*
 *  authShake接口，获取用户状态
 * */

function authShake() {
  return request.request('/auth/shake', {}, { method: 'get' });
}

/*
 *  获取行业列表
 * */

function getIndustryList() {
  return request.request('/basic_data/industry?scope=all', {}, { method: 'get' });
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0dee7d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/view-box/index.vue
var view_box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tab"},[_vm._t("header"),_vm._v(" "),_c('div',{ref:"viewBoxBody",staticClass:"weui-tab__panel vux-fix-safari-overflow-scrolling",style:({paddingTop: _vm.bodyPaddingTop, paddingBottom: _vm.bodyPaddingBottom}),attrs:{"id":"vux_view_box_body"}},[_vm._t("default")],2),_vm._v(" "),_vm._t("bottom")],2)}
var staticRenderFns = []
var esExports = { render: view_box_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_view_box = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/view-box/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("uRzL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_view_box,
  src_components_view_box,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_view_box = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid_grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681f18f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid.vue
var grid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-grids",class:{
    'vux-grid-no-lr-borders': !_vm.showLrBorders
  }},[_vm._t("default")],2)}
var grid_staticRenderFns = []
var grid_esExports = { render: grid_render, staticRenderFns: grid_staticRenderFns }
/* harmony default export */ var components_grid_grid = (grid_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid.vue
function grid_injectStyle (ssrContext) {
  __webpack_require__("n65B")
}
var grid_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid___vue_template_functional__ = false
/* styles */
var grid___vue_styles__ = grid_injectStyle
/* scopeId */
var grid___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid___vue_module_identifier__ = null
var grid_Component = grid_normalizeComponent(
  grid_grid,
  components_grid_grid,
  grid___vue_template_functional__,
  grid___vue_styles__,
  grid___vue_scopeId__,
  grid___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid = (grid_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-item-click');
      Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-item-click');
      Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14117fd9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid-item.vue
var grid_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-grid",class:{
    'vux-grid-item-no-border': (_vm.isLast && !_vm.$parent.showLrBorders) || (!_vm.isLast && !_vm.$parent.showVerticalDividers),
  },style:(_vm.style),attrs:{"href":"javascript:;"},on:{"click":_vm.onClick}},[(_vm.hasIconSlot || _vm.icon)?_c('div',{staticClass:"weui-grid__icon"},[_vm._t("icon",[_c('img',{attrs:{"src":_vm.icon,"alt":""}})])],2):_vm._e(),_vm._v(" "),(_vm.hasLabelSlot || _vm.label)?_c('p',{staticClass:"weui-grid__label"},[_vm._t("label",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})])],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var grid_item_staticRenderFns = []
var grid_item_esExports = { render: grid_item_render, staticRenderFns: grid_item_staticRenderFns }
/* harmony default export */ var components_grid_grid_item = (grid_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid-item.vue
function grid_item_injectStyle (ssrContext) {
  __webpack_require__("SMmU")
}
var grid_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid_item___vue_template_functional__ = false
/* styles */
var grid_item___vue_styles__ = grid_item_injectStyle
/* scopeId */
var grid_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid_item___vue_module_identifier__ = null
var grid_item_Component = grid_item_normalizeComponent(
  grid_grid_item,
  components_grid_grid_item,
  grid_item___vue_template_functional__,
  grid_item___vue_styles__,
  grid_item___vue_scopeId__,
  grid_item___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid_item = (grid_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vux/src/components/swiper/swiper.js
var swiper = __webpack_require__("NjrX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cf1ed1b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper.vue
var swiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){_vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){_vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}))])}
var swiper_staticRenderFns = []
var swiper_esExports = { render: swiper_render, staticRenderFns: swiper_staticRenderFns }
/* harmony default export */ var src_components_swiper_swiper = (swiper_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper.vue
function swiper_injectStyle (ssrContext) {
  __webpack_require__("tRHA")
}
var swiper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper___vue_template_functional__ = false
/* styles */
var swiper___vue_styles__ = swiper_injectStyle
/* scopeId */
var swiper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper___vue_module_identifier__ = null
var swiper_Component = swiper_normalizeComponent(
  components_swiper_swiper,
  src_components_swiper_swiper,
  swiper___vue_template_functional__,
  swiper___vue_styles__,
  swiper___vue_scopeId__,
  swiper___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_swiper_swiper = (swiper_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9b2d09a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swiper-item"},[_vm._t("default")],2)}
var swiper_item_staticRenderFns = []
var swiper_item_esExports = { render: swiper_item_render, staticRenderFns: swiper_item_staticRenderFns }
/* harmony default export */ var components_swiper_swiper_item = (swiper_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper_item___vue_template_functional__ = false
/* styles */
var swiper_item___vue_styles__ = null
/* scopeId */
var swiper_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper_item___vue_module_identifier__ = null
var swiper_item_Component = swiper_item_normalizeComponent(
  swiper_swiper_item,
  components_swiper_swiper_item,
  swiper_item___vue_template_functional__,
  swiper_item___vue_styles__,
  swiper_item___vue_scopeId__,
  swiper_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swiper_swiper_item = (swiper_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/IndexHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var IndexHeader = ({
  name: 'IndexHeader',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_t'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loginStatus: {}
    };
  },

  methods: {

    // getUserInfo () {
    //   fetchUser().then(resp => {
    //     this.userInfo = resp.data
    //   })
    // }
  },
  mounted: function mounted() {
    this.loginStatus = !!getCookie('token');
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/IndexHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_IndexHeader = ({
  name: 'IndexHeader',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_t'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loginStatus: {}
    };
  },

  methods: {

    // getUserInfo () {
    //   fetchUser().then(resp => {
    //     this.userInfo = resp.data
    //   })
    // }
  },
  mounted: function mounted() {
    this.loginStatus = !!getCookie('token');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59ca9775","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexHeader.vue
var IndexHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-header-container"},[_c('div',{staticClass:"index-header"},[_c('div',{staticClass:"index-header-inner"},[_vm._m(0),_vm._v(" "),(!_vm.loginStatus)?_c('a',{staticClass:"index-header-inner-login",attrs:{"href":'/login?utm_click='+_vm.utmClick}},[_vm._v("登录")]):_vm._e()])])])}
var IndexHeader_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"index-header-inner-left",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"https://www.ruan.net/images/logo.png","alt":""}})])}]
var IndexHeader_esExports = { render: IndexHeader_render, staticRenderFns: IndexHeader_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_IndexHeader = (IndexHeader_esExports);
// CONCATENATED MODULE: ./src/components/IndexHeader.vue
function IndexHeader_injectStyle (ssrContext) {
  __webpack_require__("dcES")
}
var IndexHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var IndexHeader___vue_template_functional__ = false
/* styles */
var IndexHeader___vue_styles__ = IndexHeader_injectStyle
/* scopeId */
var IndexHeader___vue_scopeId__ = "data-v-59ca9775"
/* moduleIdentifier (server only) */
var IndexHeader___vue_module_identifier__ = null
var IndexHeader_Component = IndexHeader_normalizeComponent(
  components_IndexHeader,
  selectortype_template_index_0_src_components_IndexHeader,
  IndexHeader___vue_template_functional__,
  IndexHeader___vue_styles__,
  IndexHeader___vue_scopeId__,
  IndexHeader___vue_module_identifier__
)

/* harmony default export */ var src_components_IndexHeader = (IndexHeader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/IndexSidebar.vue
//
//
//
//
//
//

/* harmony default export */ var IndexSidebar = ({
  name: 'IndexSidebar',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_r'
    }
  },
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/IndexSidebar.vue
//
//
//
//
//
//

/* harmony default export */ var components_IndexSidebar = ({
  name: 'IndexSidebar',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_r'
    }
  },
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0291b18d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexSidebar.vue
var IndexSidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"index-slidebar",attrs:{"href":'/register?utm_click='+_vm.utmClick}},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/slidebar-bg.png","alt":""}})])}
var IndexSidebar_staticRenderFns = []
var IndexSidebar_esExports = { render: IndexSidebar_render, staticRenderFns: IndexSidebar_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_IndexSidebar = (IndexSidebar_esExports);
// CONCATENATED MODULE: ./src/components/IndexSidebar.vue
function IndexSidebar_injectStyle (ssrContext) {
  __webpack_require__("mUOd")
}
var IndexSidebar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var IndexSidebar___vue_template_functional__ = false
/* styles */
var IndexSidebar___vue_styles__ = IndexSidebar_injectStyle
/* scopeId */
var IndexSidebar___vue_scopeId__ = "data-v-0291b18d"
/* moduleIdentifier (server only) */
var IndexSidebar___vue_module_identifier__ = null
var IndexSidebar_Component = IndexSidebar_normalizeComponent(
  components_IndexSidebar,
  selectortype_template_index_0_src_components_IndexSidebar,
  IndexSidebar___vue_template_functional__,
  IndexSidebar___vue_styles__,
  IndexSidebar___vue_scopeId__,
  IndexSidebar___vue_module_identifier__
)

/* harmony default export */ var src_components_IndexSidebar = (IndexSidebar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/IndexFooter.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var IndexFooter = ({
    name: 'IndexFooter',
    data: function data() {
        return {
            dataArray: [],
            showCardIndex: 0,
            openCard: true
        };
    },

    methods: {
        myConsultant: function myConsultant() {
            var _this = this;

            this.showCardIndex = 1;
            this.openCard = false;
            if (this.dataArray === '') {
                console.log(1);
                var fly = new fly_default.a(); // 创建fly实例
                // fly.config.withCredentials = true  // 跨域时是否发送cookie
                fly.request('https://api.ruan.net/api/personal/customer_service', {}, {
                    method: 'get'
                }).then(function (resp) {
                    console.log(resp, 123);
                    if (resp.data.status === 200) {
                        _this.showCardIndex = 1;
                        _this.dataArray = resp.data.data;
                        sessionStorage.setItem('objArr', stringify_default()(resp.data.data));
                    }
                }).catch(function (e) {
                    return console.log('error', e);
                });
            } else {
                this.dataArray = JSON.parse(sessionStorage.getItem('objArr'));
            }
        },
        closeMask: function closeMask(e) {
            if (!event.target.closest('.footer-card')) {
                this.showCardIndex = 0;
                this.openCard = true;
            }
        },
        btnCloseMask: function btnCloseMask() {
            this.openCard = true;
            this.showCardIndex = 0;
        }
    },
    created: function created() {
        this.dataArray = JSON.parse(sessionStorage.getItem('objArr')) ? JSON.parse(sessionStorage.getItem('objArr')) : '';
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/IndexFooter.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_IndexFooter = ({
    name: 'IndexFooter',
    data: function data() {
        return {
            dataArray: [],
            showCardIndex: 0,
            openCard: true
        };
    },

    methods: {
        myConsultant: function myConsultant() {
            var _this = this;

            this.showCardIndex = 1;
            this.openCard = false;
            if (this.dataArray === '') {
                console.log(1);
                var fly = new fly_default.a(); // 创建fly实例
                // fly.config.withCredentials = true  // 跨域时是否发送cookie
                fly.request('https://api.ruan.net/api/personal/customer_service', {}, {
                    method: 'get'
                }).then(function (resp) {
                    console.log(resp, 123);
                    if (resp.data.status === 200) {
                        _this.showCardIndex = 1;
                        _this.dataArray = resp.data.data;
                        sessionStorage.setItem('objArr', stringify_default()(resp.data.data));
                    }
                }).catch(function (e) {
                    return console.log('error', e);
                });
            } else {
                this.dataArray = JSON.parse(sessionStorage.getItem('objArr'));
            }
        },
        closeMask: function closeMask(e) {
            if (!event.target.closest('.footer-card')) {
                this.showCardIndex = 0;
                this.openCard = true;
            }
        },
        btnCloseMask: function btnCloseMask() {
            this.openCard = true;
            this.showCardIndex = 0;
        }
    },
    created: function created() {
        this.dataArray = JSON.parse(sessionStorage.getItem('objArr')) ? JSON.parse(sessionStorage.getItem('objArr')) : '';
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23360561","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexFooter.vue
var IndexFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"new-footer"},[_c('div',{staticClass:"new-footer-inner"},[_c('div',{staticClass:"new-footer-left"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),(_vm.openCard)?_c('div',{staticClass:"new-footer-consult",on:{"click":_vm.myConsultant}},[_c('i',{staticClass:"iconfont icon-kefu"}),_vm._v(" "),_c('span',[_vm._v("专属客服")])]):_c('div',{staticClass:"new-footer-consult",on:{"click":_vm.btnCloseMask}},[_c('i',{staticClass:"iconfont icon-kefu"}),_vm._v(" "),_c('span',[_vm._v("专属客服")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCardIndex == 1),expression:"showCardIndex == 1"}],staticClass:"footer-mask",on:{"click":_vm.closeMask}},[_c('transition',{attrs:{"name":"slide"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCardIndex == 1),expression:"showCardIndex == 1"}],staticClass:"footer-card",attrs:{"id":"footer-card"}},[_c('img',{staticClass:"footer-card-avatar",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/login/tx_.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"footer-card-info"},[_c('div',{staticClass:"footer-card-info-left"},[_c('h3',[_c('span',[_vm._v(_vm._s(_vm.dataArray.name))]),_c('p',[_vm._v("客户经理")])]),_vm._v(" "),_c('a',{staticClass:"footer-card-qq"},[_c('i',{staticClass:"iconfont icon-qq2"}),_vm._v(" "),_c('div',{staticClass:"footer-btn-tel"},[_vm._v(_vm._s(_vm.dataArray.qq))])]),_vm._v(" "),_c('a',{staticClass:"footer-card-qq",attrs:{"href":'tel:'+_vm.dataArray.mobile}},[_c('i',{staticClass:"iconfont icon-mobile-channel"}),_vm._v(" "),_c('div',{staticClass:"footer-btn-tel"},[_vm._v(_vm._s(_vm.dataArray.mobile))])])]),_vm._v(" "),_c('a',{staticClass:"footer-card-ercode",attrs:{"href":_vm.dataArray.wechat_qrcode,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.dataArray.wechat_qrcode,"alt":""}}),_vm._v(" "),_c('p',[_vm._v("微信添加好友")])])])])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCardIndex == 0),expression:"showCardIndex == 0"}],staticClass:"footer-blank"},[_c('transition',{attrs:{"name":"slide"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCardIndex == 1),expression:"showCardIndex == 1"}],staticClass:"footer-card"},[_c('img',{staticClass:"footer-card-avatar",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/login/tx_.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"footer-card-info"},[_c('div',{staticClass:"footer-card-info-left"},[_c('h3',[_c('span',[_vm._v(_vm._s(_vm.dataArray.name))]),_c('p',[_vm._v("客户经理")])]),_vm._v(" "),_c('a',{staticClass:"footer-card-qq",attrs:{"href":"https://html.ecqun.com/kf/sdk/openwin.html?corpid=7160771&cstype=rand&mode=0&cskey=vSnqlUT6WltbRcGIda&scheme=0","target":"_blank"}},[_c('i',{staticClass:"iconfont icon-qq2"}),_vm._v(" "),_c('div',{staticClass:"footer-btn-tel"},[_vm._v(_vm._s(_vm.dataArray.qq))])]),_vm._v(" "),_c('a',{staticClass:"footer-card-qq",attrs:{"href":'tel:'+_vm.dataArray.mobile}},[_c('i',{staticClass:"iconfont icon-mobile-channel"}),_vm._v(" "),_c('div',{staticClass:"footer-btn-tel"},[_vm._v(_vm._s(_vm.dataArray.mobile))])])]),_vm._v(" "),_c('a',{staticClass:"footer-card-ercode",attrs:{"href":_vm.dataArray.wechat_qrcode,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.dataArray.wechat_qrcode,"alt":""}}),_vm._v(" "),_c('p',[_vm._v("微信添加好友")])])])])])],1)])}
var IndexFooter_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"new-footer-sign",attrs:{"href":" tel:17080608737"}},[_c('i',{staticClass:"iconfont icon-dianhua"}),_vm._v(" "),_c('span',{attrs:{"href":"/register"}},[_vm._v("热线电话")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"new-footer-sign",attrs:{"href":"/register","target":"_blank"}},[_c('i',{staticClass:"iconfont  icon-zhuceyaoqing"}),_vm._v(" "),_c('span',[_vm._v("免费注册")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"new-footer-sign",attrs:{"href":"http://chat.ruan.net/","target":"_blank"}},[_c('i',{staticClass:"iconfont icon-zixun"}),_vm._v(" "),_c('span',[_vm._v("在线咨询")])])}]
var IndexFooter_esExports = { render: IndexFooter_render, staticRenderFns: IndexFooter_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_IndexFooter = (IndexFooter_esExports);
// CONCATENATED MODULE: ./src/components/IndexFooter.vue
function IndexFooter_injectStyle (ssrContext) {
  __webpack_require__("nEXI")
}
var IndexFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var IndexFooter___vue_template_functional__ = false
/* styles */
var IndexFooter___vue_styles__ = IndexFooter_injectStyle
/* scopeId */
var IndexFooter___vue_scopeId__ = "data-v-23360561"
/* moduleIdentifier (server only) */
var IndexFooter___vue_module_identifier__ = null
var IndexFooter_Component = IndexFooter_normalizeComponent(
  components_IndexFooter,
  selectortype_template_index_0_src_components_IndexFooter,
  IndexFooter___vue_template_functional__,
  IndexFooter___vue_styles__,
  IndexFooter___vue_scopeId__,
  IndexFooter___vue_module_identifier__
)

/* harmony default export */ var src_components_IndexFooter = (IndexFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/index/index.vue













/* harmony default export */ var pages_index = ({
  components: {
    ViewBox: vux_src_components_view_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  },
  data: function data() {
    return {
      gridNavbarContent: [{
        toPath: '/promotionWechat',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_wechat.png',
        theme: '微信营销'
      }, {
        toPath: '/promotionXhs',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/gris_xhs.png',
        theme: '小红书推广'
      }, {
        toPath: '/promotionWeibo',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_weibo.png',
        theme: '微博营销'
      }, {
        toPath: '/promotionLive',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_live.png',
        theme: '网红直播'
      }, {
        toPath: '/promotionVideo',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_video.png',
        theme: '视频营销'
      }, {
        toPath: '/promotionWxzf',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_wxzf.png',
        theme: '公众号引流'
      }],
      indexResource: [{
        iconName: 'ziyuan1',
        numberIndex: '01',
        themeH3: '资源',
        themeP: '全平台覆盖，全行业整合，海量优质资源'
      }, {
        iconName: 'shuju',
        numberIndex: '02',
        themeH3: '数据',
        themeP: '智能大数据系统，精准定位，精准数据输出'
      }, {
        iconName: 'chuangyi',
        numberIndex: '03',
        themeH3: '创意',
        themeP: '直击人心，匹配品牌调性的刷屏级内容'
      }, {
        iconName: 'jishu',
        numberIndex: '04',
        themeH3: '技术',
        themeP: '后台匹配前端，技术驱动营销，完美效果呈现'
      }, {
        iconName: 'fuwu',
        numberIndex: '05',
        themeH3: '服务',
        themeP: '专业团队一对一VIP服务，量身定制推广策略'
      }, {
        iconName: 'jingyan',
        numberIndex: '06',
        themeH3: '经验',
        themeP: '已为国内外各领域客户完成千万次曝光'
      }],
      solutionList: [{
        toPath: '/solution/appPromotion',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/app_icon.png',
        solutionLabel: 'APP推广'
      }, {
        toPath: '/solution/smallProgram',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/xcx_icon.png',
        solutionLabel: '小程序推广'
      }, {
        toPath: '/solution/game',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/yx_icon.png',
        solutionLabel: '游戏行业推广'
      }, {
        toPath: '/solution/ecommerce',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/ds_icon.png',
        solutionLabel: '电商行业推广'
      }, {
        toPath: '/solution/finance',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/jr_icon.png',
        solutionLabel: '金融行业推广'
      }, {
        toPath: '/solution/microBussiness',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/ws_icon.png',
        solutionLabel: '微商行业推广'
      }, {
        toPath: '/solution/tourism',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/ly_icon.png',
        solutionLabel: '旅游行业推广'
      }, {
        toPath: '/solution/fmcg',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/kx_icon.png',
        solutionLabel: '快消品行业推广'
      }, {
        toPath: '/solution/fashionBeauty',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/mz_icon.png',
        solutionLabel: '时尚美容推广'
      }, {
        toPath: '/solution/newProduct',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/xp_icon.png',
        solutionLabel: '新品推广'
      }, {
        toPath: '/solution/motherChild',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/my_icon.png',
        solutionLabel: '母婴行业推广'
      }, {
        toPath: '/solution/car',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/qc_icon.png',
        solutionLabel: '汽车行业推广'
      }]
    };
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/index/index.vue













/* harmony default export */ var selectortype_script_index_0_src_pages_index = ({
  components: {
    ViewBox: vux_src_components_view_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  },
  data: function data() {
    return {
      gridNavbarContent: [{
        toPath: '/promotionWechat',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_wechat.png',
        theme: '微信营销'
      }, {
        toPath: '/promotionXhs',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/gris_xhs.png',
        theme: '小红书推广'
      }, {
        toPath: '/promotionWeibo',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_weibo.png',
        theme: '微博营销'
      }, {
        toPath: '/promotionLive',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_live.png',
        theme: '网红直播'
      }, {
        toPath: '/promotionVideo',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_video.png',
        theme: '视频营销'
      }, {
        toPath: '/promotionWxzf',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_wxzf.png',
        theme: '公众号引流'
      }],
      indexResource: [{
        iconName: 'ziyuan1',
        numberIndex: '01',
        themeH3: '资源',
        themeP: '全平台覆盖，全行业整合，海量优质资源'
      }, {
        iconName: 'shuju',
        numberIndex: '02',
        themeH3: '数据',
        themeP: '智能大数据系统，精准定位，精准数据输出'
      }, {
        iconName: 'chuangyi',
        numberIndex: '03',
        themeH3: '创意',
        themeP: '直击人心，匹配品牌调性的刷屏级内容'
      }, {
        iconName: 'jishu',
        numberIndex: '04',
        themeH3: '技术',
        themeP: '后台匹配前端，技术驱动营销，完美效果呈现'
      }, {
        iconName: 'fuwu',
        numberIndex: '05',
        themeH3: '服务',
        themeP: '专业团队一对一VIP服务，量身定制推广策略'
      }, {
        iconName: 'jingyan',
        numberIndex: '06',
        themeH3: '经验',
        themeP: '已为国内外各领域客户完成千万次曝光'
      }],
      solutionList: [{
        toPath: '/solution/appPromotion',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/app_icon.png',
        solutionLabel: 'APP推广'
      }, {
        toPath: '/solution/smallProgram',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/xcx_icon.png',
        solutionLabel: '小程序推广'
      }, {
        toPath: '/solution/game',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/yx_icon.png',
        solutionLabel: '游戏行业推广'
      }, {
        toPath: '/solution/ecommerce',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/ds_icon.png',
        solutionLabel: '电商行业推广'
      }, {
        toPath: '/solution/finance',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/jr_icon.png',
        solutionLabel: '金融行业推广'
      }, {
        toPath: '/solution/microBussiness',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/ws_icon.png',
        solutionLabel: '微商行业推广'
      }, {
        toPath: '/solution/tourism',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/ly_icon.png',
        solutionLabel: '旅游行业推广'
      }, {
        toPath: '/solution/fmcg',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/kx_icon.png',
        solutionLabel: '快消品行业推广'
      }, {
        toPath: '/solution/fashionBeauty',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/mz_icon.png',
        solutionLabel: '时尚美容推广'
      }, {
        toPath: '/solution/newProduct',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/xp_icon.png',
        solutionLabel: '新品推广'
      }, {
        toPath: '/solution/motherChild',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/my_icon.png',
        solutionLabel: '母婴行业推广'
      }, {
        toPath: '/solution/car',
        imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/qc_icon.png',
        solutionLabel: '汽车行业推广'
      }]
    };
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-553311fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
var index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_index_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"index-solution",attrs:{"id":"solution"}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"index-solution-content",attrs:{"cols":3,"show-vertical-dividers":false,"show-lr-borders":false}},_vm._l((_vm.solutionList),function(item,index){return _c('router-link',{key:index,staticClass:"index-solution-content-li",attrs:{"to":item.toPath}},[_c('img',{attrs:{"src":item.imgSrc,"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.solutionLabel))])])}))]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"xmb-footer"}),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_index_r"}})],1)}
var index_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-banner"},[_c('div',{staticClass:"index-banner-text"},[_c('img',{staticClass:"index-banner-logo",attrs:{"src":"https://www.ruan.net/images/logo.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("一站式智能广告营销平台")]),_vm._v(" "),_c('ul',{staticClass:"index-banner-nav"},[_c('a',{attrs:{"href":"#brand"}},[_c('li',{staticClass:"index-banner-nav-item"},[_vm._v("\n          品牌服务 >\n        ")])]),_vm._v(" "),_c('a',{attrs:{"href":"#solution"}},[_c('li',{staticClass:"index-banner-nav-item"},[_vm._v("\n          解决方案  >\n        ")])]),_vm._v(" "),_c('a',{attrs:{"href":"/register","target":"_blank"}},[_c('li',{staticClass:"index-banner-nav-item",staticStyle:{"background-color":"#F2AD3FFF"}},[_vm._v("\n          免费注册  >\n        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xmb-choose"},[_c('img',{staticClass:"xmb-choose-title",attrs:{"src":"/static/images/xzxmb.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"xmb-choose-content"},[_c('div',{staticClass:"xmb-choose-content-item"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/gm_icon_26.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("01")]),_vm._v(" "),_c('p',[_vm._v("规模")]),_vm._v(" "),_c('div',{staticClass:"xmb-choose-content-item-sumup"},[_vm._v("1000家合作伙伴，一站式推广，覆盖迅速")])]),_vm._v(" "),_c('div',{staticClass:"xmb-choose-content-item"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/gm_icon_26.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("02")]),_vm._v(" "),_c('p',[_vm._v("高效")]),_vm._v(" "),_c('div',{staticClass:"xmb-choose-content-item-sumup"},[_vm._v("大数据智能匹配资源，百人媒介团队高效执行")])])]),_vm._v(" "),_c('div',{staticClass:"xmb-choose-content-item"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/gm_icon_26.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("03")]),_vm._v(" "),_c('p',[_vm._v("规范")]),_vm._v(" "),_c('div',{staticClass:"xmb-choose-content-item-sumup"},[_vm._v("合同、发票等财务流程规范，资金安全有保证")])]),_vm._v(" "),_c('div',{staticClass:"xmb-choose-content-item"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/gm_icon_26.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("04")]),_vm._v(" "),_c('p',[_vm._v("专业")]),_vm._v(" "),_c('div',{staticClass:"xmb-choose-content-item-sumup"},[_vm._v("专业服务5000多企业客户，品牌推广专业服务商")])]),_vm._v(" "),_c('div',{staticClass:"xmb-choose-content-item"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/gm_icon_26.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("05")]),_vm._v(" "),_c('p',[_vm._v("低价")]),_vm._v(" "),_c('div',{staticClass:"xmb-choose-content-item-sumup"},[_vm._v("一手渠道资源，帮您节省50%以上推广成本")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xmb-brand",attrs:{"id":"brand"}},[_c('img',{staticClass:"xmb-brand-title",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/ppfw_bt.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"xmb-brand-content"},[_c('div',{staticClass:"xmb-brand-content-item"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/rwtg_icon.png","alt":""}}),_vm._v(" "),_c('a',{staticClass:"xmb-brand-content-item-title",attrs:{"href":"/promotionNews","target":"_blank"}},[_vm._v("软文推广")]),_vm._v(" "),_c('div',{staticClass:"xmb-brand-content-item-line"}),_vm._v(" "),_c('div',{staticClass:"xmb-brand-content-item-content"},[_vm._v("为企业提供软文推广、软文发布、软文代写的一站式软文营销服务。")])]),_vm._v(" "),_c('div',{staticClass:"xmb-brand-content-item",staticStyle:{"border":"2px solid #E9333FFF"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/xhstg_icon.png","alt":""}}),_vm._v(" "),_c('a',{staticClass:"xmb-brand-content-item-title",staticStyle:{"background":"rgba(233,51,63,1)"},attrs:{"href":"/promotionXhs","target":"_blank"}},[_vm._v("小红书推广")]),_vm._v(" "),_c('div',{staticClass:"xmb-brand-content-item-line"}),_vm._v(" "),_c('div',{staticClass:"xmb-brand-content-item-content"},[_vm._v("各行业创意推广方案、海量真实资源、高转化成功案例，为您打造最高效的小红书KOL推广。")])]),_vm._v(" "),_c('div',{staticClass:"xmb-brand-content-item",staticStyle:{"border":"2px solid #65AE4EFF"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/wxyx_icon.png","alt":""}}),_vm._v(" "),_c('a',{staticClass:"xmb-brand-content-item-title",staticStyle:{"background":"#65AE4EFF"},attrs:{"href":"/promotionWechat","target":"_blank"}},[_vm._v("微信营销")]),_vm._v(" "),_c('div',{staticClass:"xmb-brand-content-item-line"}),_vm._v(" "),_c('div',{staticClass:"xmb-brand-content-item-content"},[_vm._v("3万多个优质微信自媒体公众号可覆盖200多个行业、500多个领域。")])]),_vm._v(" "),_c('div',{staticClass:"xmb-brand-content-item",staticStyle:{"border":"2px solid #FFD33FFF"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/wbyx_icon.png","alt":""}}),_vm._v(" "),_c('a',{staticClass:"xmb-brand-content-item-title",staticStyle:{"background":"#FFD23BFF"},attrs:{"href":"/promotionWeibo","target":"_blank"}},[_vm._v("微博营销")]),_vm._v(" "),_c('div',{staticClass:"xmb-brand-content-item-line"}),_vm._v(" "),_c('div',{staticClass:"xmb-brand-content-item-content",staticStyle:{"width":"37.4vw"}},[_vm._v("微博红人为广告主“代言”，发布微博“软”广告，全面覆盖6亿微博用户。")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xmb-service"},[_c('img',{staticClass:"xmb-service-title",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/yzfw_bt.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"xmb-service-content"},[_c('div',{staticClass:"xmb-service-item"},[_c('div',{staticClass:"xmb-service-item-title"},[_vm._v("客户接入")]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item-content"},[_vm._v("提出需求、目标，预算")])]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item",staticStyle:{"margin-top":"32.5%"}},[_c('div',{staticClass:"xmb-service-item-title"},[_vm._v("结案报告")]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item-content"},[_vm._v("传播数据透明，效果总结")])]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item",staticStyle:{"margin-top":"32.5%"}},[_c('div',{staticClass:"xmb-service-item-title"},[_vm._v("实时监测")]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item-content"},[_vm._v("投放效果监控，实时优化")])]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item",staticStyle:{"margin-top":"32.5%"}},[_c('div',{staticClass:"xmb-service-item-title"},[_vm._v("客户选择")]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item-content"},[_vm._v("沟通选择方案，协助投放")])]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item",staticStyle:{"position":"absolute","top":"0%","left":"50%"}},[_c('div',{staticClass:"xmb-service-item-title"},[_vm._v("确认目的")]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item-content"},[_vm._v("   品牌营销目标分解")])]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item",staticStyle:{"position":"absolute","top":"30%","left":"45%"}},[_c('div',{staticClass:"xmb-service-item-title"},[_vm._v("     确定受众")]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item-content"},[_vm._v("受众分析，锁定目标群体特征")])]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item",staticStyle:{"position":"absolute","top":"61%","left":"49%"}},[_c('div',{staticClass:"xmb-service-item-title"},[_vm._v(" 媒介策略")]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item-content"},[_vm._v("确定投放渠道，预算分配")])]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item",staticStyle:{"position":"absolute","top":"91%","left":"49%"}},[_c('div',{staticClass:"xmb-service-item-title"},[_vm._v(" 内容策划")]),_vm._v(" "),_c('div',{staticClass:"xmb-service-item-content"},[_vm._v("根据受众制定合适内容方案")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-title",staticStyle:{"margin-bottom":"9%"}},[_c('img',{staticClass:"xmb-solution-title",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/jjfa_bt.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xmb-launch-strategy"},[_c('div',{staticClass:"xmb-launch-strategy-contnet"},[_c('div',{staticClass:"xmb-launch-strategy-contne-item"},[_c('img',{staticClass:"photo-left",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/icon_ppdx.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-title"},[_vm._v("品牌洞悉  卖点分解")]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v("深度挖掘产品卖点与特性，匹配受众需求")])]),_vm._v(" "),_c('div',{staticClass:"xmb-launch-strategy-contne-item"},[_c('img',{staticClass:"photo-left",staticStyle:{"float":"right","margin-right":"7px"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/icon3321.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-title",staticStyle:{"margin-left":"2.333vw"}},[_vm._v("用户画像  精确制导")]),_vm._v(" "),_c('div',{staticClass:"item-content",staticStyle:{"margin-left":"2.333vw"}},[_vm._v("根据品牌目标人群与产品特点，锁定投放受众")])]),_vm._v(" "),_c('div',{staticClass:"xmb-launch-strategy-contne-item"},[_c('img',{staticClass:"photo-left",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/icon_ppdx_64.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-title",staticStyle:{"margin-top":"6.333vw"}},[_vm._v("媒介策略  投放规划")]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v("结合品牌与用户特征，合理规划媒介组合与推广内容，分配推广预算")])])]),_vm._v(" "),_c('div',{staticClass:"xmb-launch-strategy-contne-item"},[_c('img',{staticClass:"photo-left",staticStyle:{"float":"right","margin-right":"7px"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/icon_ppdx_41.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-title",staticStyle:{"margin-left":"2.333vw","margin-top":"6.333vw"}},[_vm._v("渠道匹配  资源选取")]),_vm._v(" "),_c('div',{staticClass:"item-content",staticStyle:{"margin-left":"2.333vw"}},[_vm._v("根据推广策略规划，确定资源的渠道组合，推广周期与发布时间")])]),_vm._v(" "),_c('div',{staticClass:"xmb-launch-strategy-contne-item"},[_c('img',{staticClass:"photo-left",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/icon_ppdx_7.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-title",staticStyle:{"margin-top":"6.333vw"}},[_vm._v("创意策划  制作发布")]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v("对应不同的渠道与受众，策划有针对性的内容发布")])]),_vm._v(" "),_c('div',{staticClass:"xmb-launch-strategy-contne-item",staticStyle:{"border-bottom":"none"}},[_c('img',{staticClass:"photo-left",staticStyle:{"float":"right","margin-right":"7px"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/icon_ppdx_69.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-title",staticStyle:{"margin-left":"2.333vw","margin-top":"6.333vw"}},[_vm._v("效果评估  数据分析")]),_vm._v(" "),_c('div',{staticClass:"item-content",staticStyle:{"margin-left":"2.333vw"}},[_vm._v("投放数据分析与效果评估，为下一次的投放做参考和指引")])])])}]
var index_esExports = { render: index_render, staticRenderFns: index_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_index = (index_esExports);
// CONCATENATED MODULE: ./src/pages/index/index.vue
function index_injectStyle (ssrContext) {
  __webpack_require__("jSle")
  __webpack_require__("H0sH")
}
var index_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var index___vue_template_functional__ = false
/* styles */
var index___vue_styles__ = index_injectStyle
/* scopeId */
var index___vue_scopeId__ = "data-v-553311fe"
/* moduleIdentifier (server only) */
var index___vue_module_identifier__ = null
var index_Component = index_normalizeComponent(
  selectortype_script_index_0_src_pages_index,
  selectortype_template_index_0_src_pages_index,
  index___vue_template_functional__,
  index___vue_styles__,
  index___vue_scopeId__,
  index___vue_module_identifier__
)

/* harmony default export */ var src_pages_index = (index_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b3d2bd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("KkjN")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/box/index.vue
//
//
//
//

/* harmony default export */ var box = ({
  name: 'box',
  props: {
    gap: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/box/index.vue
//
//
//
//

/* harmony default export */ var components_box = ({
  name: 'box',
  props: {
    gap: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08e33d18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/box/index.vue
var box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({margin:_vm.gap})},[_vm._t("default")],2)}
var box_staticRenderFns = []
var box_esExports = { render: box_render, staticRenderFns: box_staticRenderFns }
/* harmony default export */ var src_components_box = (box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/box/index.vue
var box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var box___vue_template_functional__ = false
/* styles */
var box___vue_styles__ = null
/* scopeId */
var box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var box___vue_module_identifier__ = null
var box_Component = box_normalizeComponent(
  components_box,
  src_components_box,
  box___vue_template_functional__,
  box___vue_styles__,
  box___vue_scopeId__,
  box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_box = (box_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionNews/index.vue










/* harmony default export */ var promotionNews = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  },
  data: function data() {
    return {
      tabIndex1: 0
    };
  },


  methods: {
    change_resourceTabIndex: function change_resourceTabIndex(index) {
      this.tabIndex1 = index;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionNews/index.vue










/* harmony default export */ var pages_promotionNews = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  },
  data: function data() {
    return {
      tabIndex1: 0
    };
  },


  methods: {
    change_resourceTabIndex: function change_resourceTabIndex(index) {
      this.tabIndex1 = index;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24458e83","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/promotionNews/index.vue
var promotionNews_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('index-header',{attrs:{"utm-click":"register_rw_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"xmb-classic-case"},[_c('div',{staticClass:"xmb-media-title",staticStyle:{"margin-top":"1%"}},[_vm._v("经典案例")]),_vm._v(" "),_c('div',{staticClass:"xmb-line-b"}),_vm._v(" "),_c('div',{staticClass:"xmb-line-g"}),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar_live"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li_live",class:{ 'new-guest-xhs1-tabbar-li-checked': _vm.tabIndex1 == 0 },on:{"click":function($event){_vm.change_resourceTabIndex(0)}}},[_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li_live",class:{ 'new-guest-xhs1-tabbar-li-checked': _vm.tabIndex1 == 1 },on:{"click":function($event){_vm.change_resourceTabIndex(1)}}},[_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li_live",class:{ 'new-guest-xhs1-tabbar-li-checked': _vm.tabIndex1 == 2 },on:{"click":function($event){_vm.change_resourceTabIndex(2)}}},[_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li_live",class:{ 'new-guest-xhs1-tabbar-li-checked': _vm.tabIndex1 == 3 },staticStyle:{"margin-right":"0"},on:{"click":function($event){_vm.change_resourceTabIndex(3)}}},[_vm._m(7)])]),_vm._v(" "),(_vm.tabIndex1 == 0)?_c('div',{staticClass:"advertising_map_content"},[_c('div',{staticClass:"case-g-line"}),_vm._v(" "),_c('img',{staticClass:"case-y-oblong",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/hulianwang.png","alt":""}}),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"business-content-item"},[_vm._v("\n    戴尔（Dell），是一家总部位于美国德克萨斯州朗德罗克的世界五百强企业,由迈克尔·戴尔于1984年创立。戴尔以生产、设计、销售家用以及办公室电脑而闻名，不过它同时也涉足高端电脑市场，生产与销售服务器、数据储存设备、网络设备等。戴尔公司于1992年进入《财富》杂志500家之列，戴尔因此成为其中最年轻的首席执行官。戴尔公司名列《财富》杂志500家的第48位。自1995年起，戴尔公司一直名列《财富》杂志评选的“最受仰慕的公司”，2001年排名第10位。2011年上升至第6位。\n  ")]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"business-content-item"},[_vm._v("\n戴尔以IT直销享誉全球,主要产品包括家用笔记本,家用台式机,商务电脑,服务器存储,为个人及企业用户提供更专业支持！\n  ")]),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)]):_vm._e(),_vm._v(" "),(_vm.tabIndex1 == 1)?_c('div',{staticClass:"advertising_map_content"},[_c('div',{staticClass:"case-g-line"}),_vm._v(" "),_c('img',{staticClass:"case-y-oblong",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/jiaoyuchuguo.png","alt":""}}),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('div',{staticClass:"business-content-item"},[_vm._v("\n   亨瑞集团（Henry Group）成立于1992年，经过二十多年的深耕、探索和积累，目前在移民留学、北美地产开发、基金投资、北美置业等多个领域内发展成为具有丰富经验和竞争优势的多元化跨国集团。\n  ")]),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('div',{staticClass:"business-content-item"},[_vm._v("\n亨瑞集团具备境内外多重移民留学资质，是目前美、加、英、澳等境内外移民留学收案最多、成功率最高，在移民留学行业中享有盛誉的专业移民留学代理机构。自90年代初进驻中国以来，亨瑞集团以专业的技术水平和良好的信誉得到了美、加、英、澳等国使馆、移民顾问协会、律师协会及权威行业组织的高度认可。在服务境内外申请人的二十年间，亨瑞集团通过遍及全球50余个分支机构的服务网络，成功协助数以万计的申请者顺利移民，同时助力他们的子女赴美加留学，享受世界一流的教育资源。专业高效的业务处理、细致周到的VIP服务，不仅使亨瑞集团在数万名成功移民的申请人中建立了良好的口碑，也使其逐步成长为今日移民行业翘楚，稳居移民业领军地位。在未来的发展中，亨瑞集团将继续密切关注美国等移民局移民政策变化，进一步集中境内外各方面优势资源，结合自身多年办理经验，致力于保持移民申请最高获签率以及行业领先地位，为更多有意出国发展或海外定居的精英人士实现愿望！\n  ")]),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15)]):_vm._e(),_vm._v(" "),(_vm.tabIndex1 == 2)?_c('div',{staticClass:"advertising_map_content"},[_c('div',{staticClass:"case-g-line"}),_vm._v(" "),_c('img',{staticClass:"case-y-oblong",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/yiliao.png","alt":""}}),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('div',{staticClass:"business-content-item"},[_vm._v("\nYestar坚信，只要活的精彩，每个人都是明星！Yestar艺星秉承“你就是明星”的品牌主张，以“做世界一流的医学美容连锁机构”为目标，以“帮助每一位爱美的朋友达成美丽心愿”为使命Yestar坚信，只要活的精彩，每个人都是明星！Yestar艺星秉承“你就是明星”的品牌主张，以“做世界一流的医学美容连锁机构”为目标，以“帮助每一位爱美的朋友达成美丽心愿”为使命\n  ")]),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('div',{staticClass:"business-content-item"},[_vm._v("\n艺星国际医疗美容集团是国际医学美容连锁品牌，旗下拥有数十家医学美容连锁分支机构。 作为亚太地区提供高端医学美容服务的顶级品牌，Yestar艺星引领韩国整形风潮，秉承韩国整形之精髓，兼收并蓄各国审美理念，专注探索医学美容科技新知， 并致力于将高新科技应用于抗衰老、非手术美容、整形 美容、皮肤美容、口腔美容、生活美容等领域，努力创造分享的哲学，始终为顾客提供最为领先、时尚、安全、可靠的医学美容服务。\n  ")]),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19)]):_vm._e(),_vm._v(" "),(_vm.tabIndex1 == 3)?_c('div',{staticClass:"advertising_map_content"},[_c('div',{staticClass:"case-g-line"}),_vm._v(" "),_c('img',{staticClass:"case-y-oblong",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/dianzishangwu.png","alt":""}}),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('div',{staticClass:"business-content-item"},[_vm._v("\n俏十岁CHOISKYCN是以科技面膜为核心产品的顶级抗衰科技护肤品牌。1999年，青年发明家武斌先生带领国内外资深科研人员，历经13年的努力，亿万资产的投入，不计成本的搜寻近千种植物精华，不断汲取来自生物学、医药学、化学、皮肤学和营养学等多重领域的前沿科技，并联合国内外顶级科研机构出品自然、科技、功能性抗衰护肤品。\n  ")]),_vm._v(" "),_vm._m(21),_vm._v(" "),_c('div',{staticClass:"business-content-item"},[_vm._v("\n俏十岁产品类别主要有外用养护：科技面膜及系列护肤品；内服调理：食用菌饮品。作为一个民族品牌，俏十岁在“中国梦”的感召下，在中国面膜领域开辟出一块“科技”新土。俏十岁科技面膜创始人13年的研发心血创造了凝结中华五千年草本精粹的面膜——俏十岁科技面膜，中国第一款拥有自主知识产权并获国家发明专利的中医药科技面膜，也是唯一被国家中医药管理局中国中医药科技开发交流中心列入全国科技成果推广项目的面膜。\n  ")]),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23)]):_vm._e()]),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_rw_r"}})],1)}
var promotionNews_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"promo-banner"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/banner.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"xmb-article-marketing"},[_c('div',{staticClass:"article-title"},[_vm._v("您做软文营销是否被以下问题所困扰？")]),_vm._v(" "),_c('img',{staticClass:"title-left-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/xt.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"article-title-content"},[_c('span',[_vm._v("尝试过多种推广，但成本高、效果差")]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"14%"}},[_vm._v("百度搜索不到企业或产品信息")]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"13.5%"}},[_vm._v("品牌不够知名，客户缺乏信任感")]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"12%"}},[_vm._v("缺乏软文营销经验，效果不理想，需要"),_c('br'),_vm._v(" 更专业的服务商")]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"8.5%"}},[_vm._v("正在做SEO需要把外链永久做到新闻网站")]),_vm._v(" "),_c('img',{staticClass:"title-right-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/ch_1.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"title-bottom-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/xt_icon.png","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"xmb-brief-introduction"},[_c('img',{staticClass:"brief-left-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/ch_2.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"xmb-brief-title"},[_vm._v("我们能做什么？")]),_vm._v(" "),_c('div',{staticClass:"xmb-brief-content"},[_c('img',{staticClass:"brief-right-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/xt_2.png","alt":""}}),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"17.5%","margin-top":"-10%"}},[_vm._v("品牌推广")]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"17.5%","margin-top":"-3%"}},[_vm._v("软文营销")])])]),_vm._v(" "),_c('div',{staticClass:"xmb-brand-promotion"},[_c('div',{staticClass:"xmb-line"}),_vm._v(" "),_c('div',{staticClass:"brand-promotion-title"},[_vm._v("品牌推广")]),_vm._v(" "),_c('div',{staticClass:"xmb-brand-content"},[_c('img',{staticClass:"brand-left-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/xt_3.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("拥有国内1000多合作媒体，覆盖大多数网络媒体、专业及行业媒体、"),_c('br'),_vm._v("国内大型门户网站、地方信息港、专业网络门户等多样化的媒体形式。")]),_vm._v(" "),_c('div',{staticClass:"brand-content"},[_vm._v("1.在分秒之间把信息迅速精准地传播出去。当企业需要危机公关时，软文发布系统可以几小时内同时在数十家知名媒体上发布公告，以将企业的损失降至最低。"),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"2.5%"}},[_vm._v("2. 用新闻的形式推广，可以迅速、低成本地提高企业或者产品的形象，使得更加权威。")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"2%","margin-bottom":"0.7%"}},[_vm._v("3.采用新闻传播模式进行推广可以产生频繁的新闻曝光率。")]),_vm._v("\n            4.根据您的地域覆盖要求，保证新闻稿发布辐射到各专业领域媒体。")])]),_vm._v(" "),_c('img',{staticClass:"brand-bottom-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/pptg_right.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"xmb-Marketing-article"},[_c('div',{staticClass:"xmb-line"}),_vm._v(" "),_c('div',{staticClass:"brand-promotion-title"},[_vm._v("软文营销")]),_vm._v(" "),_c('div',{staticClass:"xmb-Marketing-content"},[_c('img',{staticClass:"Marketing-left-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/xt_4.png","alt":""}}),_vm._v(" "),_c('p',{staticStyle:{"letter-spacing":"0.2vw"}},[_vm._v("1.消费者痛点关键词布局，软文大量曝光露出品牌，激起潜在客户对品"),_c('br'),_vm._v("牌的好奇心；")]),_vm._v(" "),_c('p',{staticStyle:{"top":"23.3%","letter-spacing":"0.1vw"}},[_vm._v("2.品牌口碑关键词布局，让潜在客户提前选择，总有一个理由是想买的"),_c('br'),_vm._v("借口；")]),_vm._v(" "),_c('p',{staticStyle:{"top":"34.7%","letter-spacing":"0.1vw"}},[_vm._v("3.权威媒体为品牌背书，消除顾虑，更值得信赖")])]),_vm._v(" "),_c('img',{staticClass:"Marketing-bottom-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/left_rwyx.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"xmb-media"},[_c('div',{staticClass:"xmb-media-title"},[_vm._v("媒体合作资源")]),_vm._v(" "),_c('div',{staticClass:"xmb-line-b"}),_vm._v(" "),_c('div',{staticClass:"xmb-line-g"}),_vm._v(" "),_c('div',{staticClass:"xmb-media-content"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/tx.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/sh.png","alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"marign-right":"0px"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/xl.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/wy.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/168.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/fh.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/df.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/36Kr.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/hx.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/cyb.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/ql.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/cj.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/z.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/ar.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/jj.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/zy.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/hc.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/cctv.png","alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":"/https://chat.xinmeibao.com/","target":"_blank"}},[_c('div',{staticClass:"xmb-media-btn",staticStyle:{"margin-left":"37%"}},[_vm._v("查看更多")])])]),_vm._v(" "),_c('div',{staticClass:"xmb-discount"},[_c('div',{staticClass:"xmb-media-title"},[_vm._v("最新限时优惠活动")]),_vm._v(" "),_c('div',{staticClass:"xmb-line-b"}),_vm._v(" "),_c('div',{staticClass:"xmb-line-g"})]),_vm._v(" "),_c('div',{staticClass:"xmb-discount-photo"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/yhhd_icon.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/yhhd_icon.png","alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"0px"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/yhhd_icon-2.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"discount-title"},[_vm._v("秒杀")]),_vm._v(" "),_c('div',{staticClass:"discount-title",staticStyle:{"left":"43.4%"}},[_vm._v("秒杀")]),_vm._v(" "),_c('div',{staticClass:"discount-title",staticStyle:{"left":"78.9%"}},[_vm._v("秒杀")]),_vm._v(" "),_c('div',{staticClass:"discount-content-item"},[_vm._v("综合套餐 "),_c('br'),_c('span',[_vm._v("100家")])]),_vm._v(" "),_c('div',{staticClass:"discount-content-item",staticStyle:{"left":"41.9%"}},[_vm._v("综合套餐 "),_c('br'),_c('span',[_vm._v("300家")])]),_vm._v(" "),_c('div',{staticClass:"discount-content-item-price"},[_vm._v("¥2000元")]),_vm._v(" "),_c('div',{staticClass:"discount-content-item-price",staticStyle:{"left":"38.9%"}},[_vm._v("¥4000元")]),_vm._v(" "),_c('div',{staticClass:"discount-content-item-price",staticStyle:{"left":"73.9%","font-size":"3.2vw"}},[_vm._v("门户、科技、"),_c('br'),_vm._v(" 财经"),_c('span',{staticStyle:{"color":"#666666FF"}},[_vm._v("等套餐")])])]),_vm._v(" "),_c('div',{staticClass:"xmb-member-title"},[_vm._v("\n        会员尊享特权\n      ")]),_vm._v(" "),_c('table',[_c('tr',[_c('th',[_vm._v("功能与 "),_c('br'),_vm._v("特权名称")]),_vm._v(" "),_c('th',{staticStyle:{"background":"#4C8EE2FF"}},[_vm._v("单次充值"),_c('br'),_vm._v(" （元）")]),_vm._v(" "),_c('th',{staticStyle:{"background":"#4C8EE2FF"}},[_vm._v("享受折扣")]),_vm._v(" "),_c('th',[_vm._v("享受服务")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("普通会员")]),_vm._v(" "),_c('td',[_vm._v("1000元")]),_vm._v(" "),_c('td',[_vm._v("市场价"),_c('span',[_vm._v("*5折")])]),_vm._v(" "),_c('td',[_vm._v("初级合作阶段，保证效果")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("普通代理")]),_vm._v(" "),_c('td',[_vm._v("5000元")]),_vm._v(" "),_c('td',[_vm._v("市场价"),_c('span',[_vm._v("*4.5折")])]),_vm._v(" "),_c('td',[_vm._v("提供新闻稿外 链优化，标题内容修改服务")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("高级代理")]),_vm._v(" "),_c('td',[_vm._v("一万元")]),_vm._v(" "),_c('td',[_vm._v("市场价"),_c('span',[_vm._v("*4折")])]),_vm._v(" "),_c('td',[_vm._v("提供新闻稿代发，方案执行，数据汇报等服务")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("核心代理")]),_vm._v(" "),_c('td',[_vm._v("十万元")]),_vm._v(" "),_c('td',[_vm._v("待定详谈")]),_vm._v(" "),_c('td',[_vm._v("提供江浙沪城市上门指导服务，独立新闻稿平台")])])]),_vm._v(" "),_c('div',{staticClass:"xmb-member-bottom"},[_c('span',[_vm._v("* 会员充值 ：")]),_vm._v("  预存充值   >   自助发稿   >   一次充值   >   终身会员   >   享受市场最低价！")]),_vm._v(" "),_c('a',{attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_c('div',{staticClass:"xmb-media-btn"},[_vm._v("查看更多")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-service-package"},[_c('div',{staticClass:"xmb-media-title"},[_vm._v("服务套餐")]),_vm._v(" "),_c('div',{staticClass:"xmb-line-b"}),_vm._v(" "),_c('div',{staticClass:"xmb-line-g"}),_vm._v(" "),_c('div',{staticClass:"news-service-package-content clearfix"},[_c('div',{staticClass:"news-service-package-content-li"},[_c('h3',[_vm._v("门户网综合套餐")]),_vm._v(" "),_c('img',{attrs:{"src":"/public/images/xmb_news/news_packeage_01.png","alt":""}}),_vm._v(" "),_c('h4',[_vm._v("十大门户网站")]),_vm._v(" "),_c('div',{staticClass:"news-service-package-price"},[_vm._v("\n                ¥500"),_c('span',[_vm._v("/ 抢购价")])]),_vm._v(" "),_c('a',{staticClass:"news-puchase-btn",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("立即购买")])]),_vm._v(" "),_c('div',{staticClass:"news-service-package-content-li"},[_c('h3',[_vm._v("IT科技类套餐")]),_vm._v(" "),_c('img',{attrs:{"src":"/public/images/xmb_news/news_packeage_02.png","alt":""}}),_vm._v(" "),_c('h4',[_vm._v("十大IT科技网站")]),_vm._v(" "),_c('div',{staticClass:"news-service-package-price"},[_vm._v("\n                ¥600"),_c('span',[_vm._v("/ 抢购价")])]),_vm._v(" "),_c('a',{staticClass:"news-puchase-btn",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("立即购买")])]),_vm._v(" "),_c('div',{staticClass:"news-service-package-content-li"},[_c('h3',[_vm._v("财经媒体套餐")]),_vm._v(" "),_c('img',{attrs:{"src":"/public/images/xmb_news/news_packeage_03.png","alt":""}}),_vm._v(" "),_c('h4',[_vm._v("十大财经类媒体")]),_vm._v(" "),_c('div',{staticClass:"news-service-package-price"},[_vm._v("\n                ¥800"),_c('span',[_vm._v("/ 抢购价")])]),_vm._v(" "),_c('a',{staticClass:"news-puchase-btn",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("立即购买")])]),_vm._v(" "),_c('div',{staticClass:"news-service-package-content-li"},[_c('h3',[_vm._v("女性时尚套餐")]),_vm._v(" "),_c('img',{attrs:{"src":"/public/images/xmb_news/news_packeage_04.png","alt":""}}),_vm._v(" "),_c('h4',[_vm._v("十大女性时尚媒体")]),_vm._v(" "),_c('div',{staticClass:"news-service-package-price"},[_vm._v("\n                ¥900"),_c('span',[_vm._v("/ 抢购价")])]),_vm._v(" "),_c('a',{staticClass:"news-puchase-btn",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("立即购买")])])]),_vm._v(" "),_c('a',{attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/jr_icon.png","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xmb-write"},[_c('div',{staticClass:"xmb-media-title"},[_vm._v("代写服务")]),_vm._v(" "),_c('div',{staticClass:"xmb-line-b"}),_vm._v(" "),_c('div',{staticClass:"xmb-line-g"}),_vm._v(" "),_c('div',{staticClass:"news-write-content"},[_c('div',{staticClass:"news-write-content-li news-write-first"},[_c('div',{staticClass:"news-write-content-first-line clearfix"},[_c('div',{staticClass:"news-write-content-li-circle"}),_vm._v(" "),_c('h4',[_vm._v("质量保障")])]),_vm._v(" "),_c('p',[_vm._v("专业的写作团队，代写有任何不满意的都可以免费修改")])]),_vm._v(" "),_c('div',{staticClass:"news-write-content-li news-write-second"},[_c('div',{staticClass:"news-write-content-first-line clearfix"},[_c('div',{staticClass:"news-write-content-li-circle"}),_vm._v(" "),_c('h4',[_vm._v("速度保障")])]),_vm._v(" "),_c('p',[_vm._v("代写文章二个工作日内交初稿，修改二个工作日内完成")])]),_vm._v(" "),_c('div',{staticClass:"news-write-content-li news-write-third"},[_c('div',{staticClass:"news-write-content-first-line clearfix"},[_c('div',{staticClass:"news-write-content-li-circle"}),_vm._v(" "),_c('h4',[_vm._v("安全保障")])]),_vm._v(" "),_c('p',[_vm._v("代写文章修改多次后仍不满意的可退款，不收取任何费用")])])]),_vm._v(" "),_c('img',{staticClass:"write-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/sc_ch.png","alt":""}}),_vm._v(" "),_c('a',{attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_c('div',{staticClass:"xmb-media-btn"},[_vm._v("免费咨询")])]),_vm._v(" "),_c('img',{staticClass:"write-bottom",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ruanwen_img/xt_icon-1.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-original-write-content-bot"},[_c('div',{staticClass:"news-original-write-bg"},[_c('div',{staticClass:"news-write-bg-title"},[_vm._v("原创软文代写价格")])]),_vm._v(" "),_c('table',{staticClass:"wirte-tabel"},[_c('tr',[_c('th',{staticStyle:{"width":"25%"}},[_vm._v("文章字数")]),_vm._v(" "),_c('th',{staticStyle:{"width":"25%"}},[_vm._v("原价格")]),_vm._v(" "),_c('th',{staticStyle:{"width":"25%"}},[_vm._v("优惠价 * "),_c('span',{staticStyle:{"color":"#4C8EE2FF"}},[_vm._v("5折")])]),_vm._v(" "),_c('th',{staticStyle:{"width":"25%"}},[_vm._v("写手资料")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("普通文章"),_c('br'),_vm._v("（800字）")]),_vm._v(" "),_c('td',{staticClass:"news-dx-original"},[_vm._v("200元/篇")]),_vm._v(" "),_c('td',{staticClass:"news-preferential-price"},[_c('span',[_vm._v("100元")]),_vm._v("/篇")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"2.1vw 3.133vw 3.133vw 3.133vw"}},[_vm._v("新闻专业大学生，经验丰富网络写手\n                    "),_c('div',{staticClass:"write-btn"},[_c('a',{attrs:{"href":"https://i.xinmeibao.com/manuscripts/79ye4sgpik","target":"_blank"}},[_vm._v("查看案例")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("优秀文章"),_c('br'),_vm._v("（1000字）")]),_vm._v(" "),_c('td',{staticClass:"news-dx-original"},[_vm._v("600元/篇")]),_vm._v(" "),_c('td',{staticClass:"news-preferential-price"},[_c('span',[_vm._v("300元")]),_vm._v("/篇")]),_vm._v(" "),_c('td',[_vm._v("实习媒体编辑，专业全职教师"),_c('br'),_vm._v(" "),_c('div',{staticClass:"write-btn"},[_c('a',{attrs:{"href":"https://i.xinmeibao.com/manuscripts/79ye4sgpik","target":"_blank"}},[_vm._v("查看案例")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("高级文章"),_c('br'),_vm._v("（1500字）")]),_vm._v(" "),_c('td',{staticClass:"news-dx-original"},[_vm._v("1000元/篇")]),_vm._v(" "),_c('td',{staticClass:"news-preferential-price"},[_c('span',[_vm._v("500元")]),_vm._v("/篇")]),_vm._v(" "),_c('td',{staticStyle:{"padding":"1.133vw 3.133vw 3.133vw 3.133vw"}},[_vm._v("专业记者，互联网专家"),_c('br'),_vm._v(" "),_c('div',{staticClass:"write-btn"},[_c('a',{attrs:{"href":"https://i.xinmeibao.com/manuscripts/79ye4sgpik","target":"_blank"}},[_vm._v("查看案例")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("专业文章"),_c('br'),_vm._v("（2000字）")]),_vm._v(" "),_c('td',{staticClass:"news-dx-original"},[_vm._v("2000元/篇")]),_vm._v(" "),_c('td',{staticClass:"news-preferential-price"},[_c('span',[_vm._v("1000元")]),_vm._v("/篇")]),_vm._v(" "),_c('td',[_vm._v("资深行业编辑，资深媒体编辑"),_c('br'),_vm._v(" "),_c('div',{staticClass:"write-btn"},[_c('a',{attrs:{"href":"https://i.xinmeibao.com/manuscripts/79ye4sgpik","target":"_blank"}},[_vm._v("查看案例")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"classic-case-item"},[_c('div',{staticClass:"case-blue"}),_vm._v(" "),_c('p',[_vm._v("互联网IT")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"classic-case-item"},[_c('div',{staticClass:"case-blue"}),_vm._v(" "),_c('p',[_vm._v("教育出国")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"classic-case-item"},[_c('div',{staticClass:"case-blue"}),_vm._v(" "),_c('p',[_vm._v("健康医疗")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"classic-case-item"},[_c('div',{staticClass:"case-blue"}),_vm._v(" "),_c('p',[_vm._v("电子商务")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-title"},[_c('p',[_vm._v("企业简介")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-title",staticStyle:{"margin-top":"4%"}},[_c('p',[_vm._v("品牌优势")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-title",staticStyle:{"margin-top":"4%"}},[_c('p',[_vm._v("服务内容")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-item"},[_vm._v("\n新闻稿发布部分案例： "),_c('br'),_vm._v("\nDonews:"),_c('a',{attrs:{"href":"http://www.donews.com/news/detail/4/2951021.html","target":"_blank"}},[_vm._v("http://www.donews.com/news/detail/4/2951021.html")]),_vm._v(" "),_c('br'),_vm._v("It168："),_c('a',{attrs:{"href":"http://notebook.it168.com/a2017/0420/3116/000003116838.shtml","target":"_blank"}},[_vm._v("http://notebook.it168.com/a2017/0420/3116/000003116838.shtml")]),_vm._v(" "),_c('br'),_vm._v("小熊在线:"),_c('a',{attrs:{"href":"http://www.shbear.com/2/lib/201704/20/20170420018.htm","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("http://www.shbear.com/2/lib/201704/20/20170420018.htm")]),_vm._v(" "),_c('br'),_vm._v("飞象网："),_c('a',{attrs:{"href":"http://www.cctime.com/html/2017-4-20/1281551.htm","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("http://www.cctime.com/html/2017-4-20/1281551.htm")]),_vm._v(" "),_c('br'),_vm._v("网易数码："),_c('a',{attrs:{"href":"http://digi.163.com/17/0419/15/CID4SLFO001680MT.html","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("http://digi.163.com/17/0419/15/CID4SLFO001680MT.html")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-title"},[_c('p',[_vm._v("企业简介")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-title",staticStyle:{"margin-top":"4%"}},[_c('p',[_vm._v("品牌优势")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-title",staticStyle:{"margin-top":"4%"}},[_c('p',[_vm._v("服务内容")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-item"},[_vm._v("\n新闻稿发布部分案例： "),_c('br'),_vm._v("\n凤凰网新闻：亨瑞集团携手云南房协搭建海外投融资服务平台"),_c('br'),_c('a',{attrs:{"href":"http://news.ifeng.com/a/20151204/46521998_0.shtml","target":"_blank"}},[_vm._v("http://news.ifeng.com/a/20151204/46521998_0.shtml")]),_vm._v(" "),_c('br'),_vm._v("中安在线：亨瑞集团携手云南房协搭建海外投融资服务平台"),_c('br'),_c('a',{attrs:{"href":"http://www.anhuinews.com/zhuyeguanli/system/2015/12/04/007113881.shtml","target":"_blank"}},[_vm._v("http://www.anhuinews.com/zhuyeguanli/system/2015/12/04/007113881.shtml")]),_vm._v(" "),_c('br'),_vm._v("网易手机：亨瑞集团携手云南房协搭建海外投融资服务平台"),_c('br'),_c('a',{attrs:{"href":"http://help.3g.163.com/0406/15/1203/14/B9TUJS200406002E.html","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("http://help.3g.163.com/0406/15/1203/14/B9TUJS200406002E.html")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-title"},[_c('p',[_vm._v("企业简介")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-title",staticStyle:{"margin-top":"4%"}},[_c('p',[_vm._v("品牌优势")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-title",staticStyle:{"margin-top":"4%"}},[_c('p',[_vm._v("服务内容")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-item"},[_vm._v("\n新闻稿发布部分案例： "),_c('br'),_vm._v("\n腾讯网：艺星整形汇爱慈善金钟国首献大连"),_c('br'),_c('a',{attrs:{"href":"http://ln.qq.com/a/20160126/041567_all.htm","target":"_blank"}},[_vm._v("http://ln.qq.com/a/20160126/041567_all.htm")]),_vm._v(" "),_c('br'),_vm._v("光明网女人：艺星整形汇爱慈善金钟国首献大连"),_c('br'),_c('a',{attrs:{"href":"http://lady.gmw.cn/newspaper/2016-02/02/content_110982467.htm","target":"_blank"}},[_vm._v("http://lady.gmw.cn/newspaper/2016-02/02/content_110982467.htm")]),_vm._v(" "),_c('br'),_vm._v("和讯网：Yestar艺星整形与云南女子击剑达成战略合作"),_c('br'),_c('a',{attrs:{"href":"http://news.hexun.com/2016-01-21/181927488.html","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("http://news.hexun.com/2016-01-21/181927488.html")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-title"},[_c('p',[_vm._v("企业简介")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-title",staticStyle:{"margin-top":"4%"}},[_c('p',[_vm._v("品牌优势")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-title",staticStyle:{"margin-top":"4%"}},[_c('p',[_vm._v("服务内容")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-content-item"},[_vm._v("\n新闻稿发布部分案例： "),_c('br'),_vm._v("\n新浪网：俏十岁将登陆纽约时代广场 展示中国高端面膜品牌魅力 "),_c('br'),_c('a',{attrs:{"href":"http://news.sina.com.cn/o/2016-02-06/doc-ifxpfhzk9038392.shtml","target":"_blank"}},[_vm._v("http://news.sina.com.cn/o/2016-02-06/doc-ifxpfhzk9038392.shtml")]),_vm._v(" "),_c('br'),_vm._v("网易财经：俏十岁将登陆纽约时代广场 展示中国高端面膜品牌魅力"),_c('br'),_c('a',{attrs:{"href":"http://money.163.com/16/0206/16/BF5G98PB00254TI5.html","target":"_blank"}},[_vm._v("http://money.163.com/16/0206/16/BF5G98PB00254TI5.html")]),_vm._v(" "),_c('br'),_vm._v("凤凰网新闻：俏十岁将登陆纽约时代广场 展示中国高端面膜品牌魅力"),_c('br'),_c('a',{attrs:{"href":"http://news.ifeng.com/a/20160206/47382764_0.shtml","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("http://news.ifeng.com/a/20160206/47382764_0.shtml")])])}]
var promotionNews_esExports = { render: promotionNews_render, staticRenderFns: promotionNews_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_promotionNews = (promotionNews_esExports);
// CONCATENATED MODULE: ./src/pages/promotionNews/index.vue
function promotionNews_injectStyle (ssrContext) {
  __webpack_require__("5Zl2")
}
var promotionNews_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var promotionNews___vue_template_functional__ = false
/* styles */
var promotionNews___vue_styles__ = promotionNews_injectStyle
/* scopeId */
var promotionNews___vue_scopeId__ = "data-v-24458e83"
/* moduleIdentifier (server only) */
var promotionNews___vue_module_identifier__ = null
var promotionNews_Component = promotionNews_normalizeComponent(
  pages_promotionNews,
  selectortype_template_index_0_src_pages_promotionNews,
  promotionNews___vue_template_functional__,
  promotionNews___vue_styles__,
  promotionNews___vue_scopeId__,
  promotionNews___vue_module_identifier__
)

/* harmony default export */ var src_pages_promotionNews = (promotionNews_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/IndexAdvantages.vue




/* harmony default export */ var IndexAdvantages = ({
  components: {
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      advantagesFirstP: [{
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark01.png',
        number: '01',
        txtH3: '价格',
        txtP: '全网最低价，所有资源原价直出，无隐形加价'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark02.png',
        number: '02',
        txtH3: '资源',
        txtP: '全平台覆盖，全行业整合，海量优质资源'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark03.png',
        number: '03',
        txtH3: '数据',
        txtP: '智能大数据系统，精确定位，精准数据输出'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark04.png',
        number: '04',
        txtH3: '创意',
        txtP: '直击人心，匹配品牌调性的刷屏级内容'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark05.png',
        number: '05',
        txtH3: '技术',
        txtP: '后台匹配前端，技术驱动营销，完美效果呈现'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark06.png',
        number: '06',
        txtH3: '服务',
        txtP: '专业团队多对一VIP服务，量身定制推广策略'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark07.png',
        number: '07',
        txtH3: '经验',
        txtP: '已为国内外各领域客户完成千万次曝光'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/IndexAdvantages.vue




/* harmony default export */ var components_IndexAdvantages = ({
  components: {
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      advantagesFirstP: [{
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark01.png',
        number: '01',
        txtH3: '价格',
        txtP: '全网最低价，所有资源原价直出，无隐形加价'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark02.png',
        number: '02',
        txtH3: '资源',
        txtP: '全平台覆盖，全行业整合，海量优质资源'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark03.png',
        number: '03',
        txtH3: '数据',
        txtP: '智能大数据系统，精确定位，精准数据输出'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark04.png',
        number: '04',
        txtH3: '创意',
        txtP: '直击人心，匹配品牌调性的刷屏级内容'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark05.png',
        number: '05',
        txtH3: '技术',
        txtP: '后台匹配前端，技术驱动营销，完美效果呈现'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark06.png',
        number: '06',
        txtH3: '服务',
        txtP: '专业团队多对一VIP服务，量身定制推广策略'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wechat/wechat_kcb_mark07.png',
        number: '07',
        txtH3: '经验',
        txtP: '已为国内外各领域客户完成千万次曝光'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ced5f62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexAdvantages.vue
var IndexAdvantages_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kcb-advantages"},[_c('swiper',{attrs:{"aspect-ratio":1280/750,"dots-position":"center","dots-class":"custom-bottom-advantages"}},[_c('swiper-item',{staticClass:"kcb-advantages-firstp"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wechat/woa_mark01.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text txt-normal"},[_vm._v("软盟平台优势")])]),_vm._v(" "),_c('div',{staticClass:"kcb-advantages-firstp-content"},_vm._l((_vm.advantagesFirstP),function(item,index){return _c('div',{key:index,staticClass:"kcb-advantages-firstp-li"},[_c('img',{attrs:{"src":item.imgSrc,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"kcb-kcb-advantages-firstp-li-count"},[_c('div',{staticClass:"kcb-kcb-advantages-firstp-li-count-bg"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.number))])]),_vm._v(" "),_c('div',{staticClass:"kcb-kcb-advantages-firstp-li-text"},[_c('h3',[_vm._v(_vm._s(item.txtH3))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.txtP))])])])}))]),_vm._v(" "),_c('swiper-item',{staticClass:"kcb-advantages-secondp"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wechat/woa_mark01.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text txt-normal"},[_vm._v("软盟平台优势")])]),_vm._v(" "),_c('div',{staticClass:"kcb-advantages-secondp-content"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wechat/kcb-advantages-secondp-arrow.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"kcb-advantages-secondp-content-right"},[_c('h3',[_vm._v("绝对价格优势，用最低成本创造最好效果")]),_vm._v(" "),_c('p',[_vm._v("* 所有资源费用均按原价收取，绝无隐形加价。")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wechat/kcb-advantages-secondp-content.png","alt":""}})])])]),_vm._v(" "),_c('swiper-item',{staticClass:"kcb-advantages-secondp"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wechat/woa_mark01.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text txt-normal"},[_vm._v("软盟平台优势")])]),_vm._v(" "),_c('div',{staticClass:"kcb-advantages-secondp-content kcb-advantages-thirdp"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wechat/kcb-advantages-secondp-arrow.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"kcb-advantages-secondp-content-right"},[_c('h3',[_vm._v("核心技术确保投放效果，降低投放风险")])])]),_vm._v(" "),_c('img',{staticClass:"kcb-advantages-thirdp-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wechat/kcb-advantages-thirdp-content.png","alt":""}})])],1)],1)}
var IndexAdvantages_staticRenderFns = []
var IndexAdvantages_esExports = { render: IndexAdvantages_render, staticRenderFns: IndexAdvantages_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_IndexAdvantages = (IndexAdvantages_esExports);
// CONCATENATED MODULE: ./src/components/IndexAdvantages.vue
function IndexAdvantages_injectStyle (ssrContext) {
  __webpack_require__("MVsy")
  __webpack_require__("u2uO")
}
var IndexAdvantages_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var IndexAdvantages___vue_template_functional__ = false
/* styles */
var IndexAdvantages___vue_styles__ = IndexAdvantages_injectStyle
/* scopeId */
var IndexAdvantages___vue_scopeId__ = "data-v-2ced5f62"
/* moduleIdentifier (server only) */
var IndexAdvantages___vue_module_identifier__ = null
var IndexAdvantages_Component = IndexAdvantages_normalizeComponent(
  components_IndexAdvantages,
  selectortype_template_index_0_src_components_IndexAdvantages,
  IndexAdvantages___vue_template_functional__,
  IndexAdvantages___vue_styles__,
  IndexAdvantages___vue_scopeId__,
  IndexAdvantages___vue_module_identifier__
)

/* harmony default export */ var src_components_IndexAdvantages = (IndexAdvantages_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionWechat/index.vue














/* harmony default export */ var promotionWechat = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    IndexAdvantages: src_components_IndexAdvantages,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      resourceFinance: [],
      resourceFashion: [],
      resourceFood: [],
      resourceIt: []
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com/api/web_wechat', {}, {
        method: 'get'
      }).then(function (resp) {
        var transferData = JSON.parse(resp.data);
        if (transferData.success) {
          var resourceFinance1 = transferData.message.finance;
          _this.resourceFinance = resourceFinance1.slice(0, 6);
          var resourceFashion1 = transferData.message.fashion;
          _this.resourceFashion = resourceFashion1.slice(0, 6);
          var resourceFood1 = transferData.message.food;
          _this.resourceFood = resourceFood1.slice(0, 6);
          var resourceIt1 = transferData.message.IT;
          _this.resourceIt = resourceIt1.slice(0, 6);
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionWechat/index.vue














/* harmony default export */ var pages_promotionWechat = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    IndexAdvantages: src_components_IndexAdvantages,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      resourceFinance: [],
      resourceFashion: [],
      resourceFood: [],
      resourceIt: []
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com/api/web_wechat', {}, {
        method: 'get'
      }).then(function (resp) {
        var transferData = JSON.parse(resp.data);
        if (transferData.success) {
          var resourceFinance1 = transferData.message.finance;
          _this.resourceFinance = resourceFinance1.slice(0, 6);
          var resourceFashion1 = transferData.message.fashion;
          _this.resourceFashion = resourceFashion1.slice(0, 6);
          var resourceFood1 = transferData.message.food;
          _this.resourceFood = resourceFood1.slice(0, 6);
          var resourceIt1 = transferData.message.IT;
          _this.resourceIt = resourceIt1.slice(0, 6);
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61e8741d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/promotionWechat/index.vue
var promotionWechat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('index-header',{attrs:{"utm-click":"register_wx_t"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"xhs-resource"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab"},[_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 0},on:{"click":function($event){_vm.changeResourceTab(0)}}},[_vm._v("财经\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 1},on:{"click":function($event){_vm.changeResourceTab(1)}}},[_vm._v("时尚\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 2},on:{"click":function($event){_vm.changeResourceTab(2)}}},[_vm._v("美食\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 3},on:{"click":function($event){_vm.changeResourceTab(3)}}},[_vm._v("IT科技\n          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 0),expression:"resourceTabIndex == 0"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceFinance),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/woa","target":"_blank"}},[_vm._v("查看报价")])])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 1),expression:"resourceTabIndex == 1"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceFashion),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/woa","target":"_blank"}},[_vm._v("查看报价")])])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 2),expression:"resourceTabIndex == 2"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceFood),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/woa","target":"_blank"}},[_vm._v("查看报价")])])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 3),expression:"resourceTabIndex == 3"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceIt),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/woa","target":"_blank"}},[_vm._v("查看报价")])])])}))]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_wx_r"}})],1)}
var promotionWechat_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-banner"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/banner_wechat.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("精选优质资源")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weibo-advantage"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"border-bottom":"0px solid #efefef","color":"#fff"}},[_vm._v("公众号营销的优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20",staticStyle:{"background":"#fff"}})]),_vm._v(" "),_c('div',{staticClass:"wechat-advantage-content"},[_c('div',{staticClass:"wechat-advantage-content-item"},[_c('img',{staticClass:"advantage-item-1",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/优质资源-icon.png","alt":""}}),_vm._v(" "),_c('h5',[_vm._v("优质资源")]),_vm._v(" "),_c('p',[_vm._v("10万多个优质微信自媒体公众号可覆盖200多个行业、500多个领域。")])]),_vm._v(" "),_c('div',{staticClass:"wechat-advantage-content-item"},[_c('img',{staticClass:"advantage-item-2",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/专业团队-icon.png","alt":""}}),_vm._v(" "),_c('h5',{staticStyle:{"margin-top":"11%"}},[_vm._v("专业团队")]),_vm._v(" "),_c('p',{staticStyle:{"width":"38.933vw"}},[_vm._v("有多年公众号运营经验的团队负责对接，提供多对一VIP服务，及时了对客户解需求进行分析，制定投放策略。")])]),_vm._v(" "),_c('div',{staticClass:"wechat-advantage-content-item"},[_c('img',{staticClass:"advantage-item-3",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/智能-icon.png","alt":""}}),_vm._v(" "),_c('h5',[_vm._v("智能推选、智能投放")]),_vm._v(" "),_c('p',[_vm._v("软盟系统通过大数据对客户的需求进行分析，智能推选资源，智能投放，实时跟踪、反馈投放效果。")])]),_vm._v(" "),_c('div',{staticClass:"wechat-advantage-content-item"},[_c('img',{staticClass:"advantage-item-4",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/权威_icon.png","alt":""}}),_vm._v(" "),_c('h5',{staticStyle:{"margin-top":"11.2%"}},[_vm._v("权威保障")]),_vm._v(" "),_c('p',[_vm._v("软盟平台安全有保证，消费明细可查，所有自媒体均通过实名认证，让您的每一次投放省心、安心，更放心。")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xmb-display-bit"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("广告展示分析")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('p',[_vm._v("广告主可自助选购公众号并指定广告位，以图文形式推送广告。")]),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/picture_wechat_display.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xmb-professional-data"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("专业数据分析")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"xmb-professional-item",staticStyle:{"margin-top":"4%"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/zysjfx01.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"xmb-professional-item-title"},[_vm._v("目标用户数据分析")]),_vm._v(" "),_c('div',{staticClass:"xmb-professional-item-content"},[_vm._v("软盟对公众号设置多达500个标签，"),_c('br'),_vm._v("通过大数据帮您匹配出合适投放的账号，"),_c('br'),_vm._v("并由专业顾问提供渠道策略建议。")])]),_vm._v(" "),_c('div',{staticClass:"xmb-professional-item"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/zysjfx02.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"xmb-professional-item-title",staticStyle:{"left":"49%"}},[_vm._v("大数据匹配账号")]),_vm._v(" "),_c('div',{staticClass:"xmb-professional-item-content"},[_vm._v("根据目标用户分析，专业的策划团队一"),_c('br'),_vm._v("对一帮您定制推广策略，并制定渠道策"),_c('br'),_vm._v("略以及传播周期，优化您的投入产出比。")])]),_vm._v(" "),_c('div',{staticClass:"xmb-professional-item"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/zysjfx03.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"xmb-professional-item-title",staticStyle:{"left":"49%"}},[_vm._v("协助优化文案")]),_vm._v(" "),_c('div',{staticClass:"xmb-professional-item-content"},[_vm._v("根据客户的项目产品特点及受众目标进"),_c('br'),_vm._v("行文案分析，提供合理的优化方案，让"),_c('br'),_vm._v("您的文案更具感染力，全面提升转化率。")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kcb-form"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("推广形式")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"xmb-launch-strategy-contnet"},[_c('div',{staticClass:"xmb-launch-strategy-contne-item"},[_c('img',{staticClass:"photo-left",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/tgxs_icon01.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"item-title"},[_vm._v("选号直投")]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v("       以标题、图片、文案等编辑制作成"),_c('br'),_vm._v("广告物料，直接推送给粉丝，快速获得"),_c('br'),_vm._v("大量曝光，同时锁定潜在用户。")])]),_vm._v(" "),_c('div',{staticClass:"xmb-launch-strategy-contne-item"},[_c('img',{staticClass:"photo-left",staticStyle:{"float":"right","margin-right":"7px"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/tgxs_icon02.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"3.333vw"}},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"item-title",staticStyle:{"margin-left":"2.333vw"}},[_vm._v("媒体主接单")]),_vm._v(" "),_c('div',{staticClass:"item-content",staticStyle:{"margin-left":"2.333vw"}},[_vm._v("       根据广告主填写的投放需求，系统"),_c('br'),_vm._v("会按照媒体受众群体与广告主的需求匹"),_c('br'),_vm._v("配度，自动推送给符合广告主需求的媒"),_c('br'),_vm._v("体主，最后由媒体主接单执行。")])]),_vm._v(" "),_c('div',{staticClass:"xmb-launch-strategy-contne-item",staticStyle:{"border-bottom":"0px dashed #EFEFEFFF"}},[_c('img',{staticClass:"photo-left",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/tgxs_icon03.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"item-title",staticStyle:{"margin-top":"4.333vw"}},[_vm._v("公众号涨粉")]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v("       提供粉丝获取的“定制化” 服务，"),_c('br'),_vm._v("构建“全阶段”涨粉通路，全方位的涨"),_c('br'),_vm._v("粉渠道整合，整合线上、线下多种涨粉"),_c('br'),_vm._v("方式，助力公号实现快速涨粉。")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weibo-market"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("营销效果展示")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('img',{staticClass:"weibo-iphone",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/iphoneX.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"weibo-case-logo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/\nlogo_al.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"weibo-case-account-title"},[_vm._v("【合作微信公众号】")]),_vm._v(" "),_c('img',{staticClass:"weibo-case-account ",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/wechat/\nhzzh.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"business-content-title"},[_c('p',[_vm._v("企业简介")])]),_vm._v(" "),_c('div',{staticClass:"business-content-item"},[_vm._v("\n    京东金融希望通过一个活动，连接数据和AI，实现比你更懂你的极致价值，从而让金融更简单，更平等。通过培养全球技术人才，实现各方的合作互生，探索的无限可能性，最终推动全球智能金融的发展。\n\n  ")]),_vm._v(" "),_c('div',{staticClass:"business-content-title",staticStyle:{"margin-top":"4%"}},[_c('p',[_vm._v("企业简介")])]),_vm._v(" "),_c('div',{staticClass:"business-content-item"},[_vm._v("\n事件营销×微信营销→→→品牌塑造——价值提升——创造声量——高新人才储备金融+AI领域数据探索者挑战赛，创造趣味热点，激发探索精神，打造“猪脸识别”技术挑战赛。\n  ")])])}]
var promotionWechat_esExports = { render: promotionWechat_render, staticRenderFns: promotionWechat_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_promotionWechat = (promotionWechat_esExports);
// CONCATENATED MODULE: ./src/pages/promotionWechat/index.vue
function promotionWechat_injectStyle (ssrContext) {
  __webpack_require__("58an")
  __webpack_require__("6lEy")
}
var promotionWechat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var promotionWechat___vue_template_functional__ = false
/* styles */
var promotionWechat___vue_styles__ = promotionWechat_injectStyle
/* scopeId */
var promotionWechat___vue_scopeId__ = "data-v-61e8741d"
/* moduleIdentifier (server only) */
var promotionWechat___vue_module_identifier__ = null
var promotionWechat_Component = promotionWechat_normalizeComponent(
  pages_promotionWechat,
  selectortype_template_index_0_src_pages_promotionWechat,
  promotionWechat___vue_template_functional__,
  promotionWechat___vue_styles__,
  promotionWechat___vue_scopeId__,
  promotionWechat___vue_module_identifier__
)

/* harmony default export */ var src_pages_promotionWechat = (promotionWechat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionWechatEffect/index.vue










/* harmony default export */ var promotionWechatEffect = ({
  data: function data() {
    return {
      iconType: true,
      advantageList: [{
        iconClass: 'toufangjingzhun',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v1/promo-wechat-effect-product-ad1.png',
        h3Title: '投放精准',
        description: '可基于公众号粉丝性别、类别属性、历史阅读等多维度设定投放条件。'
      }, {
        iconClass: 'baojiaguifan',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v1/promo-wechat-effect-product-ad2.png',
        h3Title: '报价规范',
        description: '广告主可以统一出价和根据实际投放提价，结算按照实际阅读计，成本控制大幅优于传统投放。'
      }, {
        iconClass: 'puguanggaoxiao',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v1/promo-wechat-effect-product-ad3.png',
        h3Title: '曝光高效',
        description: '15万媒体主在线抢单，快速触达千万粉丝。'
      }, {
        iconClass: 'xingshiduoyang',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v1/promo-wechat-effect-product-ad4.png',
        h3Title: '形式多样',
        description: '广告形式多样，包括微信图文、小程序图文、文中贴片三种广告形式。'
      }]
    };
  },

  methods: {},
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionWechatEffect/index.vue










/* harmony default export */ var pages_promotionWechatEffect = ({
  data: function data() {
    return {
      iconType: true,
      advantageList: [{
        iconClass: 'toufangjingzhun',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v1/promo-wechat-effect-product-ad1.png',
        h3Title: '投放精准',
        description: '可基于公众号粉丝性别、类别属性、历史阅读等多维度设定投放条件。'
      }, {
        iconClass: 'baojiaguifan',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v1/promo-wechat-effect-product-ad2.png',
        h3Title: '报价规范',
        description: '广告主可以统一出价和根据实际投放提价，结算按照实际阅读计，成本控制大幅优于传统投放。'
      }, {
        iconClass: 'puguanggaoxiao',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v1/promo-wechat-effect-product-ad3.png',
        h3Title: '曝光高效',
        description: '15万媒体主在线抢单，快速触达千万粉丝。'
      }, {
        iconClass: 'xingshiduoyang',
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v1/promo-wechat-effect-product-ad4.png',
        h3Title: '形式多样',
        description: '广告形式多样，包括微信图文、小程序图文、文中贴片三种广告形式。'
      }]
    };
  },

  methods: {},
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-120916ee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/promotionWechatEffect/index.vue
var promotionWechatEffect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('index-header',{attrs:{"utm-click":"register_wxtf_t"}}),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"id":"container"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"promo-advantage"},[_vm._m(3),_vm._v(" "),_c('flexbox',{attrs:{"orient":"vertical"}},[_c('flexbox-item',{staticClass:"promo-adver-trouble"},[_c('div',{staticClass:"pro-adver-example"},[_c('i',{staticClass:"iconfont icon-baojiahunluanxunjialei"})]),_vm._v(" "),_c('div',{staticClass:"pro-adver-details"},[_c('div',{staticClass:"pro-adver-details-fistline"},[_c('div',{staticClass:"pro-adver-details-fistline-number"},[_vm._v("\n                1\n              ")]),_vm._v(" "),_c('div',{staticClass:"pro-adver-details-fistline-title"},[_vm._v("\n                报价混乱、询价累\n              ")])]),_vm._v(" "),_c('p',{staticClass:"pro-adver-details-text"},[_vm._v("公众号广告报价无参考标准，价格体系混乱，反复询价，沟通效率低。")])])]),_vm._v(" "),_c('flexbox-item',{staticClass:"promo-adver-trouble"},[_c('div',{staticClass:"pro-adver-example"},[_c('i',{staticClass:"iconfont icon-liuliangfensanzhaohaolei"})]),_vm._v(" "),_c('div',{staticClass:"pro-adver-details"},[_c('div',{staticClass:"pro-adver-details-fistline"},[_c('div',{staticClass:"pro-adver-details-fistline-number"},[_vm._v("\n                2\n              ")]),_vm._v(" "),_c('div',{staticClass:"pro-adver-details-fistline-title"},[_vm._v("\n                流量分散、找号累\n              ")])]),_vm._v(" "),_c('p',{staticClass:"pro-adver-details-text"},[_vm._v("中长尾账号数量众多，逐一沟通投放耗费大量时间精力。")])])]),_vm._v(" "),_c('flexbox-item',{staticClass:"promo-adver-trouble"},[_c('div',{staticClass:"pro-adver-example"},[_c('i',{staticClass:"iconfont icon-chengbennankongfengxiangao"})]),_vm._v(" "),_c('div',{staticClass:"pro-adver-details"},[_c('div',{staticClass:"pro-adver-details-fistline"},[_c('div',{staticClass:"pro-adver-details-fistline-number"},[_vm._v("\n                3\n              ")]),_vm._v(" "),_c('div',{staticClass:"pro-adver-details-fistline-title"},[_vm._v("\n                成本难控、风险高\n              ")])]),_vm._v(" "),_c('p',{staticClass:"pro-adver-details-text"},[_vm._v("交易结果无法验证，交易效果无法保障，投放风险高。")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"promo-advantage"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"promo-wechat-effect-advan-container-box"},_vm._l((_vm.advantageList),function(item,index){return _c('div',{key:index,staticClass:"promo-wechat-effect-advan-container"},[_c('icon',{attrs:{"name":item.iconClass,"type":"svg"}}),_vm._v(" "),_c('div',{staticClass:"promo-effect-product-advantage"},[_c('img',{staticClass:"promo-effect-advan-series-number",attrs:{"src":item.imgSrc,"alt":""}}),_vm._v(" "),_c('h3',{staticClass:"promo-effect-advan-title"},[_vm._v(_vm._s(item.h3Title))])]),_vm._v(" "),_c('p',{staticClass:"promo-effect-advan-text"},[_vm._v(_vm._s(item.description))])],1)}))]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#app'),expression:"'#app'"}],staticClass:"scroll-top"},[_c('icon',{attrs:{"name":"arrowup","type":"svg"}})],1)]),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_wxtf_r"}})],1)}
var promotionWechatEffect_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-banner"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/promo-banner-wechat-effect.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-info"},[_c('div',{staticClass:"promo-title-center"},[_c('img',{staticStyle:{"width":"190px"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/txt-en-bg-wechat.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("\n          微信广告投放\n        ")]),_vm._v(" "),_c('div',{staticClass:"h-line"})]),_vm._v(" "),_c('p',[_vm._v("\n        基于阅读计价（CPC）的投放产品，为客户提供基于微信公众号的自助广告投放服务。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-advantage"},[_c('div',{staticClass:"promo-title-left"},[_c('img',{staticClass:"promo-title-en-bg",staticStyle:{"height":"13px"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/promo_wechat_effect_product_introduce.png","alt":""}}),_vm._v(" "),_c('h3',{staticClass:"promo-title-text"},[_vm._v("产品介绍")]),_vm._v(" "),_c('div',{staticClass:"v-line"})]),_vm._v(" "),_c('p',{staticClass:"promo-product-introduce"},[_vm._v("\n        基于阅读计价（CPC）的投放产品，为客户提供基于微信公众号的自助广告投放服务。\n      ")]),_vm._v(" "),_c('img',{staticClass:"promo-product-img",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/promo-wechat-product-introduce.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-title-left"},[_c('img',{staticClass:"promo-title-en-bg",staticStyle:{"height":"13px"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/promo_wechat_effect_product_pain.png","alt":""}}),_vm._v(" "),_c('h3',{staticClass:"promo-title-text"},[_vm._v("微信广告投放之痛")]),_vm._v(" "),_c('div',{staticClass:"v-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-title-left"},[_c('img',{staticClass:"promo-title-en-bg",staticStyle:{"height":"13px"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/promo_wechat_effect_product_advantage.png","alt":""}}),_vm._v(" "),_c('h3',{staticClass:"promo-title-text"},[_vm._v("产品优势")]),_vm._v(" "),_c('div',{staticClass:"v-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-advantage"},[_c('div',{staticClass:"promo-title-left"},[_c('img',{staticClass:"promo-title-en-bg",staticStyle:{"height":"13px"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/promo_wechat_effect_product_process.png","alt":""}}),_vm._v(" "),_c('h3',{staticClass:"promo-title-text"},[_vm._v("投放流程")]),_vm._v(" "),_c('div',{staticClass:"v-line"})]),_vm._v(" "),_c('img',{staticClass:"promo-process",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/promo_process.png","alt":""}})])}]
var promotionWechatEffect_esExports = { render: promotionWechatEffect_render, staticRenderFns: promotionWechatEffect_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_promotionWechatEffect = (promotionWechatEffect_esExports);
// CONCATENATED MODULE: ./src/pages/promotionWechatEffect/index.vue
function promotionWechatEffect_injectStyle (ssrContext) {
  __webpack_require__("q8ob")
  __webpack_require__("cpHA")
}
var promotionWechatEffect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var promotionWechatEffect___vue_template_functional__ = false
/* styles */
var promotionWechatEffect___vue_styles__ = promotionWechatEffect_injectStyle
/* scopeId */
var promotionWechatEffect___vue_scopeId__ = "data-v-120916ee"
/* moduleIdentifier (server only) */
var promotionWechatEffect___vue_module_identifier__ = null
var promotionWechatEffect_Component = promotionWechatEffect_normalizeComponent(
  pages_promotionWechatEffect,
  selectortype_template_index_0_src_pages_promotionWechatEffect,
  promotionWechatEffect___vue_template_functional__,
  promotionWechatEffect___vue_styles__,
  promotionWechatEffect___vue_scopeId__,
  promotionWechatEffect___vue_module_identifier__
)

/* harmony default export */ var src_pages_promotionWechatEffect = (promotionWechatEffect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionWeibo/index.vue














/* harmony default export */ var promotionWeibo = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    IndexAdvantages: src_components_IndexAdvantages,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      resourceTravel: [],
      resourceMoney: [],
      resourceFood: [],
      resourceBeauty: []
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com/api/web_weibo', {}, {
        method: 'get'
      }).then(function (resp) {
        var transferData = JSON.parse(resp.data);
        if (transferData.success) {
          _this.resourceTravel = transferData.message.travel;
          _this.resourceFood = transferData.message.food;
          _this.resourceMoney = transferData.message.money;
          _this.resourceBeauty = transferData.message.beauty;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionWeibo/index.vue














/* harmony default export */ var pages_promotionWeibo = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    IndexAdvantages: src_components_IndexAdvantages,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      resourceTravel: [],
      resourceMoney: [],
      resourceFood: [],
      resourceBeauty: []
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com/api/web_weibo', {}, {
        method: 'get'
      }).then(function (resp) {
        var transferData = JSON.parse(resp.data);
        if (transferData.success) {
          _this.resourceTravel = transferData.message.travel;
          _this.resourceFood = transferData.message.food;
          _this.resourceMoney = transferData.message.money;
          _this.resourceBeauty = transferData.message.beauty;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bce1e128","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/promotionWeibo/index.vue
var promotionWeibo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('index-header',{attrs:{"utm-click":"register_wb_t"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"xhs-resource"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab"},[_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 0},on:{"click":function($event){_vm.changeResourceTab(0)}}},[_vm._v("旅行\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 1},on:{"click":function($event){_vm.changeResourceTab(1)}}},[_vm._v("财经\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 2},on:{"click":function($event){_vm.changeResourceTab(2)}}},[_vm._v("美食\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 3},on:{"click":function($event){_vm.changeResourceTab(3)}}},[_vm._v("美妆\n          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 0),expression:"resourceTabIndex == 0"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceTravel),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/weibo","target":"_blank"}},[_vm._v("查看报价")])])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 1),expression:"resourceTabIndex == 1"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceMoney),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/weibo","target":"_blank"}},[_vm._v("查看报价")])])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 2),expression:"resourceTabIndex == 2"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceFood),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/weibo","target":"_blank"}},[_vm._v("查看报价")])])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 3),expression:"resourceTabIndex == 3"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceBeauty),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/weibo","target":"_blank"}},[_vm._v("查看报价")])])])}))]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==0},on:{"click":function($event){_vm.changeTab(0)}}},[_vm._v("\n                            博文营销\n          ")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==1},on:{"click":function($event){_vm.changeTab(1)}}},[_vm._v("\n                            话题营销\n          ")])]),_vm._v(" "),(_vm.tabIndex1==0)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(4)]):_vm._e(),_vm._v(" "),(_vm.tabIndex1==1)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(5)]):_vm._e()]),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_wb_r"}})],1)}
var promotionWeibo_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"promo-banner",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/weibo/banner_weibo.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("精选优质资源")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weibo-advantage"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"border-bottom":"0px solid #efefef","color":"#fff"}},[_vm._v("微博营销优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20",staticStyle:{"background":"#fff"}}),_vm._v(" "),_c('p',[_vm._v("大数据系统精准人群定向技术，筛选出真正能强化目标品牌个性的微博红人，发布微博“软”广告，全面覆盖6亿微博用户")])]),_vm._v(" "),_c('div',{staticClass:"wechat-advantage-content"},[_c('div',{staticClass:"wechat-advantage-content-item",staticStyle:{"border-bottom":"1px solid #EFEFEFFF","border-right":"1px solid #EFEFEFFF"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/weibo/sjdsj.png","alt":""}}),_vm._v(" "),_c('h5',[_vm._v("社交大数据")]),_vm._v(" "),_c('p',[_vm._v("每月1.98亿用户活跃在微博上，每天8900万活跃用户在浏览微博，可触达的范围注册用户超过6亿。")])]),_vm._v(" "),_c('div',{staticClass:"wechat-advantage-content-item",staticStyle:{"border-bottom":"1px solid #EFEFEFFF"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/weibo/jzcb.png","alt":""}}),_vm._v(" "),_c('h5',[_vm._v("精准传播")]),_vm._v(" "),_c('p',{staticStyle:{"width":"38.933vw"}},[_vm._v("支持年龄、性别、地域、兴趣等多种组合以及高级数据功能，精准识别目标用户，大幅提高广告转化率。")])]),_vm._v(" "),_c('div',{staticClass:"wechat-advantage-content-item",staticStyle:{"border-right":"1px solid #EFEFEFFF"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/weibo/yzfw.png","alt":""}}),_vm._v(" "),_c('h5',[_vm._v("精准传播")]),_vm._v(" "),_c('p',[_vm._v("覆盖超过10亿粉丝，专业的数据分析，为广告主提供高质量的投放资源及营销策略。")])]),_vm._v(" "),_c('div',{staticClass:"wechat-advantage-content-item"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/weibo/xgfk.png","alt":""}}),_vm._v(" "),_c('h5',[_vm._v("精准传播")]),_vm._v(" "),_c('p',[_vm._v("软盟平台安全有保证，消费明细可查，所有自媒体均通过实名认证，让您的每一次投放省心、安心，更放心。")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("微博营销形式")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/weibo/话题营销.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/weibo/博文营销.png\n","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weibo-put-in"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("微博投放策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/weibo/weibo_picture_tfcl_cbmx.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weibo-kol"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("微博KOL分类")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"weibo-kol-content"},[_vm._v("\n      软盟拥有国内最丰富的微博红人资源，同时配备经验丰富的互联网推广运营团队，可满足不同行业品牌的传播需求。\n  ")]),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/weibo/picture_weibo_kolfl_new.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weibo-market"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("营销效果展示")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('img',{staticClass:"weibo-iphone",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/weibo/weibo11.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"weibo-case-logo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/weibo/weibo22.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"weibo-case-account-title"},[_vm._v("【合作微信公众号】")]),_vm._v(" "),_c('img',{staticClass:"weibo-case-account ",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/weibo/weibo33.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"business-content-title"},[_c('p',[_vm._v("企业简介")])]),_vm._v(" "),_c('div',{staticClass:"business-content-item"},[_vm._v("\n    薄荷阅读是一款旨在帮助用户更好的学习外语的，提供打卡类付费课程的应用软件，此次，薄荷阅读推广需要针对英语学习需求的精准人群曝光产品，并且获得用户的转化，让更多人知道，并使用产品。\n\n  ")]),_vm._v(" "),_c('div',{staticClass:"business-content-title",staticStyle:{"margin-top":"4%"}},[_c('p',[_vm._v("企业简介")])]),_vm._v(" "),_c('div',{staticClass:"business-content-item"},[_vm._v("\n微博英语类KOL推广+短视频营销\n设定与品牌用户匹配的类别标签，选取类型相符的KOL大号进行传播，直达精准受众，并加强用户间传播，辅以优惠券形式，利益诱导，强化刺激用户转化\n  ")])])}]
var promotionWeibo_esExports = { render: promotionWeibo_render, staticRenderFns: promotionWeibo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_promotionWeibo = (promotionWeibo_esExports);
// CONCATENATED MODULE: ./src/pages/promotionWeibo/index.vue
function promotionWeibo_injectStyle (ssrContext) {
  __webpack_require__("TavR")
  __webpack_require__("b4zm")
}
var promotionWeibo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var promotionWeibo___vue_template_functional__ = false
/* styles */
var promotionWeibo___vue_styles__ = promotionWeibo_injectStyle
/* scopeId */
var promotionWeibo___vue_scopeId__ = "data-v-bce1e128"
/* moduleIdentifier (server only) */
var promotionWeibo___vue_module_identifier__ = null
var promotionWeibo_Component = promotionWeibo_normalizeComponent(
  pages_promotionWeibo,
  selectortype_template_index_0_src_pages_promotionWeibo,
  promotionWeibo___vue_template_functional__,
  promotionWeibo___vue_styles__,
  promotionWeibo___vue_scopeId__,
  promotionWeibo___vue_module_identifier__
)

/* harmony default export */ var src_pages_promotionWeibo = (promotionWeibo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionLive/index.vue














/* harmony default export */ var promotionLive = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    IndexAdvantages: src_components_IndexAdvantages,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      resourceFashion: [],
      resourceFood: [],
      resourceBeauty: []
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com//api/web_live', {}, {
        method: 'get'
      }).then(function (resp) {
        var transferData = JSON.parse(resp.data);
        if (transferData.success) {
          _this.resourceFashion = transferData.message.fashion;
          _this.resourceFood = transferData.message.mother;
          _this.resourceBeauty = transferData.message.beauty;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionLive/index.vue














/* harmony default export */ var pages_promotionLive = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    IndexAdvantages: src_components_IndexAdvantages,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      resourceFashion: [],
      resourceFood: [],
      resourceBeauty: []
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com//api/web_live', {}, {
        method: 'get'
      }).then(function (resp) {
        var transferData = JSON.parse(resp.data);
        if (transferData.success) {
          _this.resourceFashion = transferData.message.fashion;
          _this.resourceFood = transferData.message.mother;
          _this.resourceBeauty = transferData.message.beauty;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c157e18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/promotionLive/index.vue
var promotionLive_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('index-header',{attrs:{"utm-click":"register_zb_t"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"xhs-resource"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab"},[_c('div',{staticClass:"xhs-resource-tab-inner"},[_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 0},on:{"click":function($event){_vm.changeResourceTab(0)}}},[_vm._v("美妆\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 1},on:{"click":function($event){_vm.changeResourceTab(1)}}},[_vm._v("时尚\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 2},on:{"click":function($event){_vm.changeResourceTab(2)}}},[_vm._v("母婴\n          ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 0),expression:"resourceTabIndex == 0"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceBeauty),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/live?sort_field=&sort_direct=descend&publish_scope=all","target":"_blank"}},[_vm._v("查看报价")])])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 1),expression:"resourceTabIndex == 1"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceFashion),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/live?sort_field=&sort_direct=descend&publish_scope=all","target":"_blank"}},[_vm._v("查看报价")])])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 2),expression:"resourceTabIndex == 2"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceFood),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/live?sort_field=&sort_direct=descend&publish_scope=all","target":"_blank"}},[_vm._v("查看报价")])])])})),_vm._v(" "),_c('a',{staticClass:"xhs-sign",attrs:{"href":"/register"}},[_vm._v("免费注册，获取推广方案>>")])]),_vm._v(" "),_c('div',{staticClass:"wechat-swiper video-swiper"},[_c('swiper',{attrs:{"aspect-ratio":580/375,"dots-class":"custom-bottom-live","dots-position":"center"}},[_c('swiper-item',{staticClass:"swiper-first-screen"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/live_icon02.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text"},[_vm._v("移动直播行业产业链结构")])]),_vm._v(" "),_c('div',{staticClass:"wechat-swiper-content"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/live_4p01.png","alt":""}})])]),_vm._v(" "),_c('swiper-item',{staticClass:"swiper-first-screen"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/live_icon02.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text"},[_vm._v("直播营销受众用户态度及偏好")])]),_vm._v(" "),_c('div',{staticClass:"wechat-swiper-content"},[_c('div',{staticClass:"live-swiper-title-bg"}),_vm._v(" "),_c('div',{staticClass:"live-swiper-title-bg-text"},[_vm._v("软文优于硬广，特定商品更引关注")]),_vm._v(" "),_c('p',{staticClass:"live-swiper-description"},[_vm._v("在受到观看直播用户关注的营销模式TOP4中，只有中插贴片广告一类作为硬广出现，其余三种都是较为创新的内容植入软文类型，说明目前包含直播内容营销、直播互动营销和电商直播的创新广告类型更受用户关注。另一方面，在用户所关注的营销商品类型中，3C数码、服饰箱包、生活类产品作为线上电商常售产品类型占据前三，表明围绕此类产品进行的直播营销能够覆盖到更多的用户。")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/live_4p02.png","alt":""}})])])],1)],1),_vm._v(" "),_c('div',{staticClass:"wechat-swiper video-swiper"},[_vm._m(3),_vm._v(" "),_c('swiper',{attrs:{"aspect-ratio":505/375,"dots-class":"custom-bottom-live","dots-position":"center"}},[_c('swiper-item',{staticClass:"video-first-screen"},[_c('div',{staticClass:"video-swiper-content video-first"},[_c('p',[_vm._v("直播营销总体可被分为两种模式，一类是较为传统和常规化的“硬广”模式，另一类是较为创新和定制化的“直播+”模式。“硬广”模式一般不需要太多的创意与内容制作，广告形式可被复制并重复使用，但缺点在于用户对于广告信息的接受度不高。 而“直播+”模式则是偏向定制化的，需要内容制作且多为单次曝光的营销模式，虽然其每一次的营销形式无法被重复使用，但其丰富多元化的内容及较好的观看体验正在使其成为主流的直播营销形式。整理来看，两种营销模式各有优势，广告主可凭借需求作出相应的选择或结合两者进行整合营销，本报告将对相对创新的“直播+”营销模式做重点解读。")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/live_5p01.png","alt":""}})])]),_vm._v(" "),_c('swiper-item',{staticClass:"video-first-screen"},[_c('div',{staticClass:"video-swiper-content video-second"},[_c('p',[_vm._v("“直播+电商”是营销特征最为明显的一种直播营销模式，主播通常以销售为目的，利用直播作为媒介，对产品进行全方位的介绍和试用。这种营销模式多发生在电商平台内，为提升用户的购物体验而推出，便于用户“边看边买”，而由于电商平台具有极高的用户集中度和购买目的性，通常单次直播营销活动能够带来极高的转化率，尤其是由明星和KOL作为主播带来的消费引导，更能够达到显著的营销效果。")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/live_5p02.png","alt":""}})])])],1)],1),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==0},on:{"click":function($event){_vm.changeTab(0)}}},[_vm._v("快消案例\n        ")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==1},on:{"click":function($event){_vm.changeTab(1)}}},[_vm._v("金融案例\n        ")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==2},on:{"click":function($event){_vm.changeTab(2)}}},[_vm._v("餐饮案例\n        ")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==3},on:{"click":function($event){_vm.changeTab(3)}}},[_vm._v("数码案例\n        ")])]),_vm._v(" "),_c('div',{staticClass:"wechat-line-width-100"}),_vm._v(" "),(_vm.tabIndex1==0)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(5),_vm._v(" "),_vm._m(6)]):_vm._e(),_vm._v(" "),(_vm.tabIndex1==1)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(7),_vm._v(" "),_vm._m(8)]):_vm._e(),_vm._v(" "),(_vm.tabIndex1==2)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(9),_vm._v(" "),_vm._m(10)]):_vm._e(),_vm._v(" "),(_vm.tabIndex1==3)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(11),_vm._v(" "),_vm._m(12)]):_vm._e()])]),_vm._v(" "),_c('index-advantages'),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_zb_r"}})],1)}
var promotionLive_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"promo-banner",attrs:{"href":"https://html.ecqun.com/kf/sdk/openwin.html?corpid=7160771&cstype=rand&mode=0&cskey=vSnqlUT6WltbRcGIda&scheme=0","target":"_blank"}},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/live_banner.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-swiper"},[_c('div',{staticClass:"swiper-first-screen"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/live_icon01.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text"},[_vm._v("网络直播营销市场背景")])]),_vm._v(" "),_c('div',{staticClass:"wechat-swiper-content"},[_c('div',{staticClass:"live-swiper-title-bg"}),_vm._v(" "),_c('div',{staticClass:"live-swiper-title-bg-text"},[_vm._v("直播营销为直播平台和广告主带来双赢")]),_vm._v(" "),_c('img',{staticClass:"live-swiper-firstp-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/live_1p01.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"live-swiper-firstp-text"},[_vm._v("随着直播平台越来越正规化且制作内容越来越精良，在扩大大流量的同时，各平台也致力于摆脱过去大众附加在直插行业之上类似于\"低俗\"的负面标签。以更多创新的、长期的营销模式去吸引大型广告主的合作，不仅能够提高平台本身的商业变现能力，更能够将品牌主与直揺平台的形象一同进行提升，拓宽企业资源，从而实现产业链升级。与直揺相结合的营销方式正是在这一背景下受到了越来越多直播平台的重视。")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("精选优质资源")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("直播形式")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("网红直播案例")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/live_case_left01.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/mzy.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("粉丝数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("924.92W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("阅读量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("8.32W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("37.59W")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("网红直播"),_c('br'),_vm._v("\n            线下打造【果粒梦工厂】活动，邀请多位网红达人参与，并通过直播平台分享美汁源果粒橙活动现场，让没有参加现场的观众也有看到现场盛况，达到二次传播效果，创造一场千万曝光量的盛世直播。\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/live_case_left02.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/wechat_case_logo01.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("粉丝数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("23.75W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("阅读量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("8.26W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("738")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("事件营销×微信营销→→→品牌塑造——价值提升——创造声量——高新人才储备金融+AI领域数据探索者挑战赛，创造趣味热点，激发探索精神，打造“猪脸识别”技术挑战赛\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/live_case_left03.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/jgm.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("粉丝数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("103.95W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("阅读量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("58.42W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("27.65W")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("网红直播"),_c('br'),_vm._v("邀请高人气的网红亲临活动现场，参与“大暑派对”，并直播活动盛况，影响受众，扩散活动，加强麦当劳与“大薯日”的关联性。将直播营销打造成事件营销，用更趣味更直观的感受，引爆活动。\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/live_case_left04.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/live/ms.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("粉丝数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("389.42W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("阅读量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("84.62W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("29.44W")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("网红直播"),_c('br'),_vm._v("\n            针对微软的品牌特点和Surface目标人群分析，邀请了多位不同技能的颜艺达人现场直播解说，利用主播粉丝群的热度，传播品牌，并带领“高冷”微软与500万网友的零距离互动，引发口碑发酵，获取更多精准用户。\n          ")])])}]
var promotionLive_esExports = { render: promotionLive_render, staticRenderFns: promotionLive_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_promotionLive = (promotionLive_esExports);
// CONCATENATED MODULE: ./src/pages/promotionLive/index.vue
function promotionLive_injectStyle (ssrContext) {
  __webpack_require__("7xtA")
  __webpack_require__("pU2I")
}
var promotionLive_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var promotionLive___vue_template_functional__ = false
/* styles */
var promotionLive___vue_styles__ = promotionLive_injectStyle
/* scopeId */
var promotionLive___vue_scopeId__ = "data-v-8c157e18"
/* moduleIdentifier (server only) */
var promotionLive___vue_module_identifier__ = null
var promotionLive_Component = promotionLive_normalizeComponent(
  pages_promotionLive,
  selectortype_template_index_0_src_pages_promotionLive,
  promotionLive___vue_template_functional__,
  promotionLive___vue_styles__,
  promotionLive___vue_scopeId__,
  promotionLive___vue_module_identifier__
)

/* harmony default export */ var src_pages_promotionLive = (promotionLive_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionVideo/index.vue














/* harmony default export */ var promotionVideo = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    IndexAdvantages: src_components_IndexAdvantages,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      resourceFashion: [],
      resourceFood: [],
      resourceBeauty: []
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com//api/web_video', {}, {
        method: 'get'
      }).then(function (resp) {
        console.log(resp, 1212);
        var transferData = JSON.parse(resp.data);
        console.log(transferData, 666);
        if (transferData.success) {
          _this.resourceFashion = transferData.message.fashion;
          _this.resourceFood = transferData.message.food;
          _this.resourceBeauty = transferData.message.beauty;
        }
        console.log(transferData, 666);
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionVideo/index.vue














/* harmony default export */ var pages_promotionVideo = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    IndexAdvantages: src_components_IndexAdvantages,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      resourceFashion: [],
      resourceFood: [],
      resourceBeauty: []
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com//api/web_video', {}, {
        method: 'get'
      }).then(function (resp) {
        console.log(resp, 1212);
        var transferData = JSON.parse(resp.data);
        console.log(transferData, 666);
        if (transferData.success) {
          _this.resourceFashion = transferData.message.fashion;
          _this.resourceFood = transferData.message.food;
          _this.resourceBeauty = transferData.message.beauty;
        }
        console.log(transferData, 666);
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b070c886","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/promotionVideo/index.vue
var promotionVideo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('index-header',{attrs:{"utm-click":"register_wxzf_t"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"wechat-swiper"},[_c('swiper',{attrs:{"aspect-ratio":480/375,"dots-class":"custom-bottom-video","dots-position":"center"}},[_c('swiper-item',{staticClass:"swiper-first-screen"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_icon01.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text"},[_vm._v("用户内容消费习惯影响互联网内容发展")])]),_vm._v(" "),_c('div',{staticClass:"wechat-swiper-content"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_1p01.png","alt":""}})])]),_vm._v(" "),_c('swiper-item',{staticClass:"swiper-second-screen"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_icon01.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text"},[_vm._v("短视频用户特征与全网用户分布")])]),_vm._v(" "),_c('div',{staticClass:"wechat-swiper-content"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_1p02.png","alt":""}})])]),_vm._v(" "),_c('swiper-item',{staticClass:"swiper-second-screen"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_icon01.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text txt-small"},[_vm._v("数据显示，短视频用户的高粘性、高参与、高传播、搭建了品牌与用户沟通的桥梁。")])]),_vm._v(" "),_c('div',{staticClass:"wechat-swiper-content"},[_c('div',{staticClass:"wechat-swiper-content-bg"},[_c('p',[_vm._v("调查显示，短视频用户平均每天观看7.2次，平均每次使用33.6分钟，用户粘性不断增强，短视频逐渐成为用户日常生活的一部分。")]),_vm._v(" "),_c('p',[_vm._v("调查显示，93%的用户会点赞短视频，84.5%的用户会参与短视频的评论，短视频用户的互动需求、参与度不断提高。")]),_vm._v(" "),_c('p',[_vm._v("调查显示，90.6%的用户分享过短视频，达到二次、甚至N次传播，使营销具有“乘法效应”，传播覆盖面广。")])])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"xhs-resource"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab"},[_c('div',{staticClass:"xhs-resource-tab-inner"},[_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 0},on:{"click":function($event){_vm.changeResourceTab(0)}}},[_vm._v("美妆\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 1},on:{"click":function($event){_vm.changeResourceTab(1)}}},[_vm._v("时尚\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 2},on:{"click":function($event){_vm.changeResourceTab(2)}}},[_vm._v("美食\n          ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 0),expression:"resourceTabIndex == 0"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceBeauty),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/video","target":"_blank"}},[_vm._v("查看报价")])])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 1),expression:"resourceTabIndex == 1"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceFashion),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/video","target":"_blank"}},[_vm._v("查看报价")])])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 2),expression:"resourceTabIndex == 2"}],staticClass:"xhs-resource-content"},_vm._l((_vm.resourceFood),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-content-li"},[_c('img',{staticClass:"xhs-resource-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))])]),_vm._v(" "),_c('a',{attrs:{"href":"https://i.xinmeibao.com/resource/video","target":"_blank"}},[_vm._v("查看报价")])])])})),_vm._v(" "),_c('a',{staticClass:"xhs-sign",attrs:{"href":"/register"}},[_vm._v("免费注册，获取推广方案>>")])]),_vm._v(" "),_c('div',{staticClass:"wechat-swiper video-swiper"},[_c('swiper',{attrs:{"aspect-ratio":420/375,"dots-class":"custom-bottom-video","dots-position":"center"}},[_c('swiper-item',{staticClass:"swiper-first-screen"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_icon03.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text"},[_vm._v("数字营销决策者认为短视频营销的优势")])]),_vm._v(" "),_c('div',{staticClass:"wechat-swiper-content"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_4p01.png","alt":""}})])]),_vm._v(" "),_c('swiper-item',{staticClass:"swiper-second-screen"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_icon03.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text"},[_vm._v("短视频用户特征与全网用户分布")])]),_vm._v(" "),_c('div',{staticClass:"wechat-swiper-content"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_4p02.png","alt":""}})])]),_vm._v(" "),_c('swiper-item',{staticClass:"swiper-second-screen"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_icon03.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text txt-small"},[_vm._v("商业模式：原生广告为主的内容营销")])]),_vm._v(" "),_c('p',{staticClass:"weibo-first-p txt-small"},[_vm._v("整体来看，目前短视频行业主要的商业模式是以原生广告为主的内容营销，其营销价值及特点主要有以下几点：")]),_vm._v(" "),_c('div',{staticClass:"wechat-swiper-content"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_4p03.png","alt":""}})])])],1)],1),_vm._v(" "),_c('div',{staticClass:"wechat-swiper video-swiper"},[_vm._m(2),_vm._v(" "),_c('swiper',{attrs:{"aspect-ratio":560/375,"dots-class":"custom-bottom-video","dots-position":"center"}},[_c('swiper-item',{staticClass:"video-first-screen"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_picture_spyc.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"video-swiper-content"},[_c('div',{staticClass:"video-swiper-content-li"},[_c('div',{staticClass:"video-swiper-content-number"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-right"},[_c('h3',[_vm._v("广告形式")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-p"},[_vm._v("广告内容植入到趣味性原创视频，与视频完全融合。")])])]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-li"},[_c('div',{staticClass:"video-swiper-content-number"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-right"},[_c('h3',[_vm._v("亮点")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-p"},[_vm._v("为广告主定制友好的广告形式，广告内容与视频高度融合，产品特点深入用户心中，添加链接入口，为落地页导流。")])])]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-li"},[_c('div',{staticClass:"video-swiper-content-number"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-right"},[_c('h3',[_vm._v("投放目的")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-p"},[_vm._v("品牌推广、商品导流。")])])]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-li"},[_c('div',{staticClass:"video-swiper-content-number"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-right"},[_c('h3',[_vm._v("合适行业")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-p"},[_vm._v("广告展示内容灵活多样，普遍适用各行业广告。如：家电、快消行业等。")])])])])]),_vm._v(" "),_c('swiper-item',{staticClass:"video-first-screen"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_picture_tpgg.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"video-swiper-content"},[_c('div',{staticClass:"video-swiper-content-li"},[_c('div',{staticClass:"video-swiper-content-number"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-right"},[_c('h3',[_vm._v("广告形式")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-p"},[_vm._v("在博主短视频播放前/后插入3秒的贴片广告，增加产品曝光。")])])]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-li"},[_c('div',{staticClass:"video-swiper-content-number"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-right"},[_c('h3',[_vm._v("亮点")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-p"},[_vm._v("视频播放开始后用户关注度高，加入品牌贴片广告，观众印象深刻。")])])]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-li"},[_c('div',{staticClass:"video-swiper-content-number"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-right"},[_c('h3',[_vm._v("投放目的")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-p"},[_vm._v("增加曝光度，提高品牌知名度。")])])]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-li"},[_c('div',{staticClass:"video-swiper-content-number"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-right"},[_c('h3',[_vm._v("合适行业")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-p"},[_vm._v("广告展示内容灵活多样，普遍适用各行业广告。如：网站推广、公众号推广等。")])])])])]),_vm._v(" "),_c('swiper-item',{staticClass:"video-first-screen"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_picture_spzfzf.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"video-swiper-content"},[_c('div',{staticClass:"video-swiper-content-li"},[_c('div',{staticClass:"video-swiper-content-number"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-right"},[_c('h3',[_vm._v("广告形式")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-p"},[_vm._v("短视频网红在自己的主页直/转发送广告主制作的视频，并通过视频文字介绍短视频中产品。")])])]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-li"},[_c('div',{staticClass:"video-swiper-content-number"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-right"},[_c('h3',[_vm._v("亮点")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-p"},[_vm._v("网红账号直接推荐，强化口碑；用短视频的形式演绎传统的广告，效果事半功倍。")])])]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-li"},[_c('div',{staticClass:"video-swiper-content-number"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-right"},[_c('h3',[_vm._v("投放目的")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-p"},[_vm._v("提升销售转化。")])])]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-li"},[_c('div',{staticClass:"video-swiper-content-number"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-content-right"},[_c('h3',[_vm._v("合适行业")]),_vm._v(" "),_c('div',{staticClass:"video-swiper-p"},[_vm._v("广告展示内容灵活多样，普遍适用各行业广告。如：产品众筹、电商等。")])])])])])],1)],1),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==0},on:{"click":function($event){_vm.changeTab(0)}}},[_vm._v("快消案例\n        ")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==1},on:{"click":function($event){_vm.changeTab(1)}}},[_vm._v("电商案例\n        ")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==2},on:{"click":function($event){_vm.changeTab(2)}}},[_vm._v("互联网案例\n        ")])]),_vm._v(" "),_c('div',{staticClass:"wechat-line-width-100"}),_vm._v(" "),(_vm.tabIndex1==0)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(5),_vm._v(" "),_vm._m(6)]):_vm._e(),_vm._v(" "),(_vm.tabIndex1==1)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(7),_vm._v(" "),_vm._m(8)]):_vm._e(),_vm._v(" "),(_vm.tabIndex1==2)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(9),_vm._v(" "),_vm._m(10)]):_vm._e()]),_vm._v(" "),_c('index-advantages')],1),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_video_r"}})],1)}
var promotionVideo_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"promo-banner",attrs:{"href":"https://html.ecqun.com/kf/sdk/openwin.html?corpid=7160771&cstype=rand&mode=0&cskey=vSnqlUT6WltbRcGIda&scheme=0","target":"_blank"}},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_banner.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("精选优质资源")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("合作形式")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-platform"},[_c('div',{staticClass:"video-platform-innner"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_icon02.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text"},[_vm._v("合作平台")])])]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_platform.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("视频案例")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_case_left01.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_case_logo01.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("粉丝数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("8254")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("阅读量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("61.92W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("9162")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("短视频营销+ KOL达人定制"),_c('br'),_vm._v("\n            筛选热门视频平台，选取青春活力高人气的KOL达人，结合平台热点，定制“魔性摇摇舞”，引发粉丝跟风效仿，完成裂变传播\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_case_left02.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_case_logo02.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("粉丝数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("1129")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("阅读量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("36.91W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("906")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("短视频营销+ KOL达人定制"),_c('br'),_vm._v("覆盖热门视频平台，筛选时尚购物类别的精准KOL达人，结合自身特点与平台热点，定制更便于传播品牌的推广内容，让内容影响用户行为，引发粉丝关注，增大产品的曝光同时直接影响粉丝购买。\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_case_left03.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/video/video_case_logo03.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("粉丝数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("684")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("阅读量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("29.34W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("721")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("短视频营销+ KOL达人定制"),_c('br'),_vm._v("通过邀请多位年轻达人拍摄发布#学渣世纪疼妈大赛#视频，发起趣味活动，激发学生用户跟风参与，以此在目标人群内部扩散，传递品牌的核心信息：有了学霸君APP，妈妈再也不用担心我的学习了。\n          ")])])}]
var promotionVideo_esExports = { render: promotionVideo_render, staticRenderFns: promotionVideo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_promotionVideo = (promotionVideo_esExports);
// CONCATENATED MODULE: ./src/pages/promotionVideo/index.vue
function promotionVideo_injectStyle (ssrContext) {
  __webpack_require__("xdSk")
  __webpack_require__("rIdj")
}
var promotionVideo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var promotionVideo___vue_template_functional__ = false
/* styles */
var promotionVideo___vue_styles__ = promotionVideo_injectStyle
/* scopeId */
var promotionVideo___vue_scopeId__ = "data-v-b070c886"
/* moduleIdentifier (server only) */
var promotionVideo___vue_module_identifier__ = null
var promotionVideo_Component = promotionVideo_normalizeComponent(
  pages_promotionVideo,
  selectortype_template_index_0_src_pages_promotionVideo,
  promotionVideo___vue_template_functional__,
  promotionVideo___vue_styles__,
  promotionVideo___vue_scopeId__,
  promotionVideo___vue_module_identifier__
)

/* harmony default export */ var src_pages_promotionVideo = (promotionVideo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionInfoFlow/index.vue











/* harmony default export */ var promotionInfoFlow = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  },
  data: function data() {
    return {
      swiperList: [{
        url: 'javascript:',
        img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_jrtt.png'
      }, {
        url: 'javascript:',
        img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_gdt.png'
      }, {
        url: 'javascript:',
        img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_wxgg.png'
      }, {
        url: 'javascript:',
        img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_wbfst.png'
      }, {
        url: 'javascript:',
        img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_mm.png'
      }, {
        url: 'javascript:',
        img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_UCtt.png'
      }],
      swiperTexts: [{
        hightLightTitle: '今日头条是一款基于数据挖掘的推荐引擎产品',
        text01: '是国内互联网领域成长最快的产品服务之一，是目前资讯类信息流平台最大的平台。',
        title02: '【支持跳转H5页面、一键下载APP】',
        text02: '今日头条累计激活用户数已达5.5亿，日活跃用户超6000万+，用户每日使用时长超过76分钟，同时能5秒快速推广，10秒更新用户模型，为对的用户推送对的广告。'
      }, {
        hightLightTitle: '广点通包含手机腾讯网、QQ空间等众多资源。',
        text01: '通常投放的比较多的是feeds广告',
        title02: '',
        text02: '平台拥有8亿QQ用户、20亿+移动端日均流量、100亿+PC端日均流量，同事适合多种类型的APP投放，实现自助精准投放'
      }, {
        hightLightTitle: '微信广告包括朋友圈广告和公众号广告',
        text01: '以类似朋友圈原创内容形式或者在公众号内部进行展现，可支持跳转到公众号加关注、公众号图文信息以及H5页面、应用下载',
        title02: '',
        text02: '微信属于社交应用排名NO.1，1.9%公众号平均广告点击率朋友圈广告枪战每日12点、18点前后曝光高峰值，实现品牌广告有效转化'
      }, {
        hightLightTitle: '微博“粉丝通”是基于用户兴趣，将企业广告广泛传递给粉丝和潜在粉丝的营销产品。',
        text01: '同时它拥有7大信息流广告展现形式。粉丝通商业化成熟，是目前大多数广告主必投的渠道。',
        title02: '',
        text02: '拥有6.5亿注册用户，3.9亿月活跃用户，同时移动端日活跃用户占比达91%，通过移动社交实现原生传播。'
      }, {
        hightLightTitle: '陌陌是一款基于地理位置的移动社交产品。',
        text01: '基于陌陌海量的用户数据，广告引擎智能匹配目标受众，商家可以与用户进行实时对话，开展新客源，维系老客户。',
        title02: '',
        text02: '具有3亿总注册用户量，人均打开次数10次/天，月活跃用户为7480万，是中国TOP1的LBS社交广告平台，广告点击率高于行业平均值10倍以上。'
      }, {
        hightLightTitle: 'UC头条广告平台主打基于大数据分析用户兴趣标签的信息流广告投放',
        text01: '一方面由UC提供海量流量资源，另一方面则由阿里妈妈提供专业的广告后台和服务支持。',
        title02: '',
        text02: '全球UC浏览器用户达到5亿+，日活跃用户突破1亿+，日点赞数高达40亿，个性化推荐，精准分析和内容匹配能力，平均CPC（单次点击价格）低于同行业。'
      }],
      currentSwiperText: {}
    };
  },

  methods: {
    handleSwiperChange: function handleSwiperChange(idx) {
      this.currentSwiperText = this.swiperTexts[idx];
    }
  },
  mounted: function mounted() {
    this.currentSwiperText = this.swiperTexts[0];
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionInfoFlow/index.vue











/* harmony default export */ var pages_promotionInfoFlow = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  },
  data: function data() {
    return {
      swiperList: [{
        url: 'javascript:',
        img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_jrtt.png'
      }, {
        url: 'javascript:',
        img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_gdt.png'
      }, {
        url: 'javascript:',
        img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_wxgg.png'
      }, {
        url: 'javascript:',
        img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_wbfst.png'
      }, {
        url: 'javascript:',
        img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_mm.png'
      }, {
        url: 'javascript:',
        img: 'https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqud_picture_UCtt.png'
      }],
      swiperTexts: [{
        hightLightTitle: '今日头条是一款基于数据挖掘的推荐引擎产品',
        text01: '是国内互联网领域成长最快的产品服务之一，是目前资讯类信息流平台最大的平台。',
        title02: '【支持跳转H5页面、一键下载APP】',
        text02: '今日头条累计激活用户数已达5.5亿，日活跃用户超6000万+，用户每日使用时长超过76分钟，同时能5秒快速推广，10秒更新用户模型，为对的用户推送对的广告。'
      }, {
        hightLightTitle: '广点通包含手机腾讯网、QQ空间等众多资源。',
        text01: '通常投放的比较多的是feeds广告',
        title02: '',
        text02: '平台拥有8亿QQ用户、20亿+移动端日均流量、100亿+PC端日均流量，同事适合多种类型的APP投放，实现自助精准投放'
      }, {
        hightLightTitle: '微信广告包括朋友圈广告和公众号广告',
        text01: '以类似朋友圈原创内容形式或者在公众号内部进行展现，可支持跳转到公众号加关注、公众号图文信息以及H5页面、应用下载',
        title02: '',
        text02: '微信属于社交应用排名NO.1，1.9%公众号平均广告点击率朋友圈广告枪战每日12点、18点前后曝光高峰值，实现品牌广告有效转化'
      }, {
        hightLightTitle: '微博“粉丝通”是基于用户兴趣，将企业广告广泛传递给粉丝和潜在粉丝的营销产品。',
        text01: '同时它拥有7大信息流广告展现形式。粉丝通商业化成熟，是目前大多数广告主必投的渠道。',
        title02: '',
        text02: '拥有6.5亿注册用户，3.9亿月活跃用户，同时移动端日活跃用户占比达91%，通过移动社交实现原生传播。'
      }, {
        hightLightTitle: '陌陌是一款基于地理位置的移动社交产品。',
        text01: '基于陌陌海量的用户数据，广告引擎智能匹配目标受众，商家可以与用户进行实时对话，开展新客源，维系老客户。',
        title02: '',
        text02: '具有3亿总注册用户量，人均打开次数10次/天，月活跃用户为7480万，是中国TOP1的LBS社交广告平台，广告点击率高于行业平均值10倍以上。'
      }, {
        hightLightTitle: 'UC头条广告平台主打基于大数据分析用户兴趣标签的信息流广告投放',
        text01: '一方面由UC提供海量流量资源，另一方面则由阿里妈妈提供专业的广告后台和服务支持。',
        title02: '',
        text02: '全球UC浏览器用户达到5亿+，日活跃用户突破1亿+，日点赞数高达40亿，个性化推荐，精准分析和内容匹配能力，平均CPC（单次点击价格）低于同行业。'
      }],
      currentSwiperText: {}
    };
  },

  methods: {
    handleSwiperChange: function handleSwiperChange(idx) {
      this.currentSwiperText = this.swiperTexts[idx];
    }
  },
  mounted: function mounted() {
    this.currentSwiperText = this.swiperTexts[0];
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38110136","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/promotionInfoFlow/index.vue
var promotionInfoFlow_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('index-header',{attrs:{"utm-click":"register_xxl_t"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('box',{staticClass:"promo-advantage",attrs:{"gap":"0 15px"}},[_c('div',{staticClass:"promo-title-left"},[_c('img',{staticClass:"promo-title-en-bg",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/txt_en_bg_promotionofadvantage.png","alt":""}}),_vm._v(" "),_c('h3',{staticClass:"promo-title-text"},[_vm._v("信息流广告推广优势")]),_vm._v(" "),_c('div',{staticClass:"v-line"})]),_vm._v(" "),_c('div',{staticClass:"promo-advantage-text"},[_c('p',[_vm._v("\n          信息流广告基于用户行为以及平台上积累的大数据， 与原有内容融合在一起出现，精准投放，转化率高，可以通过让用户参与互动（评论、分享、投票） 等形式提升广告效果。\n        ")])]),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0,"wrap":"wrap","align":"normal"}},[_c('flexbox-item',{staticClass:"vux-1px-b",attrs:{"span":1/2}},[_c('div',{staticClass:"promo-advantage-item vux-1px-r"},[_c('h3',[_vm._v("01")]),_vm._v(" "),_c('div',{staticClass:"circle-107",staticStyle:{"border-color":"#ffb600"}},[_c('p',[_vm._v("\n                受众群庞大"),_c('br'),_vm._v("\n                传播范围广\n              ")])])])]),_vm._v(" "),_c('flexbox-item',{staticClass:"vux-1px-b",attrs:{"span":1/2}},[_c('div',{staticClass:"promo-advantage-item"},[_c('h3',[_vm._v("02")]),_vm._v(" "),_c('div',{staticClass:"circle-107",staticStyle:{"border-color":"#00a5ec"}},[_c('p',[_vm._v("\n                交互型"),_c('br'),_vm._v("\n                传播方式受众"),_c('br'),_vm._v("\n                参与度高\n              ")])])])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/2}},[_c('div',{staticClass:"promo-advantage-item vux-1px-r"},[_c('h3',[_vm._v("03")]),_vm._v(" "),_c('div',{staticClass:"circle-107",staticStyle:{"border-color":"#fd004a"}},[_c('p',[_vm._v("\n                目标受众明确"),_c('br'),_vm._v("\n                广告投放精准\n              ")])])])]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/2}},[_c('div',{staticClass:"promo-advantage-item"},[_c('h3',[_vm._v("04")]),_vm._v(" "),_c('div',{staticClass:"circle-107",staticStyle:{"border-color":"#4d47a4"}},[_c('p',[_vm._v("\n                即时快捷"),_c('br'),_vm._v("\n                广告成本低\n              ")])])])])],1)],1),_vm._v(" "),_c('box',{attrs:{"gap":"0 15px"}},[_c('div',{staticClass:"promo-title-left"},[_c('img',{staticClass:"promo-title-en-bg",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/txt_en_bg_howtoadvertise.png","alt":""}}),_vm._v(" "),_c('h3',{staticClass:"promo-title-text"},[_vm._v("如何进行信息流广告投放")]),_vm._v(" "),_c('div',{staticClass:"v-line"})]),_vm._v(" "),_c('div',[_c('flexbox',{staticClass:"promo-marking-item"},[_c('flexbox-item',{attrs:{"span":1/4}},[_c('div',{staticClass:"promo-marking-item-img"},[_c('p',[_vm._v("\n                目标群体"),_c('br'),_vm._v("\n                需求分析\n              ")])])]),_vm._v(" "),_c('flexbox-item',{staticClass:"promo-marking-item-txt"},[_c('p',[_vm._v("为了让消费者在阅读新闻视频之类的信息时能够关注到你的产品，从而进行感性消费。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"promo-marking-item"},[_c('flexbox-item',{attrs:{"span":1/4}},[_c('div',{staticClass:"promo-marking-item-img red-bg"},[_c('p',[_vm._v("\n                广告图片"),_c('br'),_vm._v("\n                设计\n              ")])])]),_vm._v(" "),_c('flexbox-item',{staticClass:"promo-marking-item-txt"},[_c('p',[_vm._v("为信息流广告设计好创意图，在素材选择方面做到与标题风格一致，每个渠道不一样，展现的效果也不尽相同。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"promo-marking-item"},[_c('flexbox-item',{attrs:{"span":1/4}},[_c('div',{staticClass:"promo-marking-item-img"},[_c('p',[_vm._v("\n                着陆页面"),_c('br'),_vm._v("\n                逻辑顺序\n              ")])])]),_vm._v(" "),_c('flexbox-item',{staticClass:"promo-marking-item-txt"},[_c('p',[_vm._v("真实的用户和数据反馈才是不断修正前进道路的方法，产品的痛点和场景也不是唯一，同样的设置和两套创意需要时间进行检验，来进一步提升转化率。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"promo-marking-item"},[_c('flexbox-item',{attrs:{"span":1/4}},[_c('div',{staticClass:"promo-marking-item-img red-bg"},[_c('p',[_vm._v("\n                信息流广告"),_c('br'),_vm._v("\n                后台投放"),_c('br'),_vm._v("\n                设置\n              ")])])]),_vm._v(" "),_c('flexbox-item',{staticClass:"promo-marking-item-txt"},[_c('p',[_vm._v("通过事件转化的标准为每一个付费的链接都做好记录。再通过热力图的查看，了解当初的每个设置的转化按钮是否能够达到相应的目的。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"promo-marking-item"},[_c('flexbox-item',{attrs:{"span":1/4}},[_c('div',{staticClass:"promo-marking-item-img"},[_c('p',[_vm._v("\n                推广数据"),_c('br'),_vm._v("\n                追踪\n              ")])])]),_vm._v(" "),_c('flexbox-item',{staticClass:"promo-marking-item-txt"},[_c('p',[_vm._v("年龄段选择——性别选择——兴趣爱好选择——栏目选择——手机系统选择。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"promo-marking-item"},[_c('flexbox-item',{attrs:{"span":1/4}},[_c('div',{staticClass:"promo-marking-item-img red-bg"},[_c('p',[_vm._v("\n                A/B创意"),_c('br'),_vm._v("\n                方案测试\n              ")])])]),_vm._v(" "),_c('flexbox-item',{staticClass:"promo-marking-item-txt"},[_c('p',[_vm._v("用户的痛点场景描述（引起共鸣）——造成的困扰和引起的后果（担忧心态）——产品提供的解决方法（用户需求）——品牌背书（信任增强）——风险评估和竞品比较（排除疑虑）。")])])],1)],1)]),_vm._v(" "),_c('div',[_c('box',{attrs:{"gap":"0 15px"}},[_c('div',{staticClass:"promo-title-left"},[_c('img',{staticClass:"promo-title-en-bg",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/txt_en_bg_onthechannel.png","alt":""}}),_vm._v(" "),_c('h3',{staticClass:"promo-title-text"},[_vm._v("投放渠道")]),_vm._v(" "),_c('div',{staticClass:"v-line"})])]),_vm._v(" "),_c('div',[_c('swiper',{staticStyle:{"background":"url('https://static.xinmeibao.com/assets_mobile/v1/promo_xxl_tfqd_picture_bj.png') center","background-size":"cover"},attrs:{"list":_vm.swiperList,"auto":"","aspect-ratio":280/750},on:{"on-index-change":_vm.handleSwiperChange}})],1),_vm._v(" "),_c('box',{attrs:{"gap":"0 15px"}},[_c('div',{staticClass:"promo-channel"},[_c('h4',{staticClass:"colored"},[_vm._v("\n            "+_vm._s(_vm.currentSwiperText.hightLightTitle)+"\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.currentSwiperText.text01)+"\n          ")]),_vm._v(" "),_c('h4',[_vm._v("\n            "+_vm._s(_vm.currentSwiperText.title02)+"\n          ")]),_vm._v(" "),_c('h4',[_vm._v("\n            【投放优势】\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.currentSwiperText.text02)+"\n          ")])])])],1),_vm._v(" "),_c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#app'),expression:"'#app'"}],staticClass:"scroll-top"},[_c('icon',{attrs:{"name":"arrowup","type":"svg"}})],1)],1),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_xxl_r"}})],1)}
var promotionInfoFlow_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-banner"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/promo_banner_Informationflow.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-info"},[_c('div',{staticClass:"promo-title-center"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/txt_en_bg_Informationflow.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("\n          信息流广告\n        ")]),_vm._v(" "),_c('div',{staticClass:"h-line"})]),_vm._v(" "),_c('p',[_vm._v("\n        基于用户“兴趣”标签推荐，可从时间、地域、环境、人群等多维度定向，广告形式更友好，有效降低用户反感度，广告的精准度也有效提升。软盟平台合作渠道覆盖多个高人气平台。\n      ")])])}]
var promotionInfoFlow_esExports = { render: promotionInfoFlow_render, staticRenderFns: promotionInfoFlow_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_promotionInfoFlow = (promotionInfoFlow_esExports);
// CONCATENATED MODULE: ./src/pages/promotionInfoFlow/index.vue
function promotionInfoFlow_injectStyle (ssrContext) {
  __webpack_require__("1d4E")
}
var promotionInfoFlow_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var promotionInfoFlow___vue_template_functional__ = false
/* styles */
var promotionInfoFlow___vue_styles__ = promotionInfoFlow_injectStyle
/* scopeId */
var promotionInfoFlow___vue_scopeId__ = "data-v-38110136"
/* moduleIdentifier (server only) */
var promotionInfoFlow___vue_module_identifier__ = null
var promotionInfoFlow_Component = promotionInfoFlow_normalizeComponent(
  pages_promotionInfoFlow,
  selectortype_template_index_0_src_pages_promotionInfoFlow,
  promotionInfoFlow___vue_template_functional__,
  promotionInfoFlow___vue_styles__,
  promotionInfoFlow___vue_scopeId__,
  promotionInfoFlow___vue_module_identifier__
)

/* harmony default export */ var src_pages_promotionInfoFlow = (promotionInfoFlow_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/mediaIndex/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var mediaIndex = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['taxonomyList'])),
  data: function data() {
    return {
      categories: [{
        icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_wechat.png',
        name: '微信营销',
        tabId: 1
      }, {
        icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_weibo.png',
        name: '微博营销',
        tabId: 2
      }, {
        icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_live.png',
        name: '网红直播',
        tabId: 3
      }, {
        icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_video.png',
        name: '视频营销',
        tabId: 4
      }, {
        icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_news.png',
        name: '软文推广',
        tabId: 0
      }]
    };
  },

  methods: {
    goSearch: function goSearch() {
      this.$router.push('/media?search=true');
      // wx.navigateTo({
      //   url: `../media/media?tab=news&search=true`
      // });
    },
    swiperChange: function swiperChange(e) {},
    animationfinish: function animationfinish(e) {}
  },
  mounted: function mounted() {
    console.log(this.taxonomyList);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/mediaIndex/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_mediaIndex = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['taxonomyList'])),
  data: function data() {
    return {
      categories: [{
        icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_wechat.png',
        name: '微信营销',
        tabId: 1
      }, {
        icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_weibo.png',
        name: '微博营销',
        tabId: 2
      }, {
        icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_live.png',
        name: '网红直播',
        tabId: 3
      }, {
        icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_video.png',
        name: '视频营销',
        tabId: 4
      }, {
        icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_news.png',
        name: '软文推广',
        tabId: 0
      }]
    };
  },

  methods: {
    goSearch: function goSearch() {
      this.$router.push('/media?search=true');
      // wx.navigateTo({
      //   url: `../media/media?tab=news&search=true`
      // });
    },
    swiperChange: function swiperChange(e) {},
    animationfinish: function animationfinish(e) {}
  },
  mounted: function mounted() {
    console.log(this.taxonomyList);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efd2b162","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mediaIndex/index.vue
var mediaIndex_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"page__bd page__bd_spacing"},[_c('flexbox',{attrs:{"gutter":0,"wrap":"wrap"}},_vm._l((_vm.taxonomyList),function(item,index){return _c('flexbox-item',{key:index,staticClass:"weui-flex__item",attrs:{"span":1/3}},[_c('router-link',{staticClass:"placeholder",attrs:{"to":'/media?tab='+item.tabType}},[_c('img',{attrs:{"src":item.icon,"alt":""}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(item.navName))])])],1)}))],1)])}
var mediaIndex_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mediaindex-banner"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/meidaIndex_banner.png","alt":""}})])}]
var mediaIndex_esExports = { render: mediaIndex_render, staticRenderFns: mediaIndex_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_mediaIndex = (mediaIndex_esExports);
// CONCATENATED MODULE: ./src/pages/mediaIndex/index.vue
function mediaIndex_injectStyle (ssrContext) {
  __webpack_require__("uJYL")
}
var mediaIndex_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var mediaIndex___vue_template_functional__ = false
/* styles */
var mediaIndex___vue_styles__ = mediaIndex_injectStyle
/* scopeId */
var mediaIndex___vue_scopeId__ = "data-v-efd2b162"
/* moduleIdentifier (server only) */
var mediaIndex___vue_module_identifier__ = null
var mediaIndex_Component = mediaIndex_normalizeComponent(
  pages_mediaIndex,
  selectortype_template_index_0_src_pages_mediaIndex,
  mediaIndex___vue_template_functional__,
  mediaIndex___vue_styles__,
  mediaIndex___vue_scopeId__,
  mediaIndex___vue_module_identifier__
)

/* harmony default export */ var src_pages_mediaIndex = (mediaIndex_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-focus/dist/vue-focus.common.js
var vue_focus_common = __webpack_require__("2jId");
var vue_focus_common_default = /*#__PURE__*/__webpack_require__.n(vue_focus_common);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-dropdowns/dropdown.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var dropdown = ({
    data: function data() {
        return {
            selectedOption: {
                name: ''
            },
            showMenu: false,
            placeholderText: 'Please select an item'
        };
    },

    props: {
        options: {
            type: [Array, Object]
        },
        selected: {},
        placeholder: [String]
    },

    mounted: function mounted() {
        this.selectedOption = this.selected;
        if (this.placeholder) {
            this.placeholderText = this.placeholder;
        }
    },


    methods: {
        updateOption: function updateOption(option) {
            this.selectedOption = option;
            this.showMenu = false;
            this.$emit('updateOption', this.selectedOption);
        },
        toggleMenu: function toggleMenu() {
            this.showMenu = !this.showMenu;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-dropdowns/dropdown.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var vue_dropdowns_dropdown = ({
    data: function data() {
        return {
            selectedOption: {
                name: ''
            },
            showMenu: false,
            placeholderText: 'Please select an item'
        };
    },

    props: {
        options: {
            type: [Array, Object]
        },
        selected: {},
        placeholder: [String]
    },

    mounted: function mounted() {
        this.selectedOption = this.selected;
        if (this.placeholder) {
            this.placeholderText = this.placeholder;
        }
    },


    methods: {
        updateOption: function updateOption(option) {
            this.selectedOption = option;
            this.showMenu = false;
            this.$emit('updateOption', this.selectedOption);
        },
        toggleMenu: function toggleMenu() {
            this.showMenu = !this.showMenu;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b46ce24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-dropdowns/dropdown.vue
var dropdown_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},[(_vm.selectedOption.name !== undefined)?_c('li',{staticClass:"dropdown-toggle",on:{"click":function($event){_vm.toggleMenu()}}},[_vm._v("\n      "+_vm._s(_vm.selectedOption.name)+"\n      "),_c('span',{staticClass:"caret"})]):_vm._e(),_vm._v(" "),(_vm.selectedOption.name === undefined)?_c('li',{staticClass:"dropdown-toggle",on:{"click":function($event){_vm.toggleMenu()}}},[_vm._v("\n      "+_vm._s(_vm.placeholderText)+"\n      "),_c('span',{staticClass:"caret"})]):_vm._e(),_vm._v(" "),(_vm.showMenu)?_c('ul',{staticClass:"dropdown-menu"},_vm._l((_vm.options),function(option){return _c('li',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.updateOption(option)}}},[_vm._v("\n                "+_vm._s(option.name)+"\n            ")])])})):_vm._e()])}
var dropdown_staticRenderFns = []
var dropdown_esExports = { render: dropdown_render, staticRenderFns: dropdown_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_node_modules_vue_dropdowns_dropdown = (dropdown_esExports);
// CONCATENATED MODULE: ./node_modules/vue-dropdowns/dropdown.vue
function dropdown_injectStyle (ssrContext) {
  __webpack_require__("ULKY")
}
var dropdown_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dropdown___vue_template_functional__ = false
/* styles */
var dropdown___vue_styles__ = dropdown_injectStyle
/* scopeId */
var dropdown___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dropdown___vue_module_identifier__ = null
var dropdown_Component = dropdown_normalizeComponent(
  vue_dropdowns_dropdown,
  selectortype_template_index_0_node_modules_vue_dropdowns_dropdown,
  dropdown___vue_template_functional__,
  dropdown___vue_styles__,
  dropdown___vue_scopeId__,
  dropdown___vue_module_identifier__
)

/* harmony default export */ var node_modules_vue_dropdowns_dropdown = (dropdown_Component.exports);

// CONCATENATED MODULE: ./src/api/cart.js


/*
 * 查询购物车
 */
function fetchCart(taxonomy) {
  return request.request('/cart', { taxonomy: taxonomy }, { method: 'get' });
}

/*
 * 下订单
 */
function createOrder(cartIds, taxonomy) {
  return request.request('/order', {
    cart_ids: cartIds,
    manuscript_id: '',
    taxonomy: taxonomy
  }, { method: 'POST' });
}
// CONCATENATED MODULE: ./src/api/resource.js


/*
 * 查询资源列表（软文，微信，微博，网红，短视频）
 * type(news/woa/weibo/live/video)
 */
function fetchResource(type, params) {
  return request.request('/resource/' + type, params, { method: 'get' });
}

/*
 *  加入购物车
 */
function addToCart(resourceId, type, top) {
  return request.request('/cart', {
    resource_id: resourceId,
    taxonomy: type,
    type: top
  }, { method: 'POST' });
}

/*
 *  从购物车中删除
 */
function deleteFromCart(cartId) {
  return request.request('/cart/' + cartId, {}, { method: 'DELETE' });
}

/*
 *  查询资源详情
 */
function fetchResourceDetail(type, id) {
  return request.request('/resource/' + type + '/' + id, {}, { method: 'get' });
}

/*
 *  加入收藏
 */
function addToCollection(resourceId, type) {
  return request.request('/collection', {
    resource_id: resourceId,
    taxonomy: type
  }, { method: 'POST' });
}

/*
 *  从收藏中删除
 */
function deleteFromCollection(collectionId) {
  return request.request('/collection/' + collectionId, {}, { method: 'DELETE' });
}

/*
 *  查询相关文章
 */
function getRelatedArticles(accountId, taxonomy, limit) {
  return request.request('/resource/release?m=article&account_id=' + accountId + '&taxonomy=' + taxonomy + '&limit=' + limit + '&format=plain', {}, { method: 'GET' });
}
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/actionsheet/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var actionsheet = ({
  name: 'actionsheet',
  mounted: function mounted() {
    var _this = this;

    this.hasHeaderSlot = !!this.$slots.header;
    this.$nextTick(function () {
      _this.$tabbar = document.querySelector('.weui-tabbar');
      _this.$refs.iOSMenu && _this.$refs.iOSMenu.addEventListener('transitionend', _this.onTransitionEnd);
    });
  },

  props: {
    value: Boolean,
    showCancel: Boolean,
    cancelText: String,
    theme: {
      type: String,
      default: 'ios'
    },
    menus: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    closeOnClickingMask: {
      type: Boolean,
      default: true
    },
    closeOnClickingMenu: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasHeaderSlot: false,
      show: false
    };
  },

  methods: {
    onTransitionEnd: function onTransitionEnd() {
      this.$emit(this.show ? 'on-after-show' : 'on-after-hide');
    },
    onMenuClick: function onMenuClick(text, key) {
      if (typeof text === 'string') {
        this.emitEvent('on-click-menu', key, text);
      } else {
        if (text.type !== 'disabled' && text.type !== 'info') {
          if (text.value || text.value === 0) {
            this.emitEvent('on-click-menu', text.value, text);
          } else {
            this.emitEvent('on-click-menu', '', text);
            this.show = false;
          }
        }
      }
    },
    onClickingMask: function onClickingMask() {
      this.$emit('on-click-mask');
      this.closeOnClickingMask && (this.show = false);
    },
    emitEvent: function emitEvent(event, menu, item) {
      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
        var _item = item;
        if ((typeof _item === 'undefined' ? 'undefined' : typeof_default()(_item)) === 'object') {
          _item = JSON.parse(stringify_default()(_item));
        }
        this.$emit(event, menu, _item);
        this.$emit(event + '-' + menu);
        this.closeOnClickingMenu && (this.show = false);
      }
    },
    fixIos: function fixIos(zIndex) {
      if (this.$el.parentNode && this.$el.parentNode.className.indexOf('v-transfer-dom') !== -1) {
        return;
      }
      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
        this.$tabbar.style.zIndex = zIndex;
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this2 = this;

      this.$emit('input', val);
      if (val) {
        this.fixIos(-1);
      } else {
        setTimeout(function () {
          _this2.fixIos(100);
        }, 200);
      }
    },

    value: {
      handler: function handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fixIos(100);
    this.$refs.iOSMenu && this.$refs.iOSMenu.removeEventListener('transitionend', this.onTransitionEnd);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/actionsheet/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_actionsheet = ({
  name: 'actionsheet',
  mounted: function mounted() {
    var _this = this;

    this.hasHeaderSlot = !!this.$slots.header;
    this.$nextTick(function () {
      _this.$tabbar = document.querySelector('.weui-tabbar');
      _this.$refs.iOSMenu && _this.$refs.iOSMenu.addEventListener('transitionend', _this.onTransitionEnd);
    });
  },

  props: {
    value: Boolean,
    showCancel: Boolean,
    cancelText: String,
    theme: {
      type: String,
      default: 'ios'
    },
    menus: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    closeOnClickingMask: {
      type: Boolean,
      default: true
    },
    closeOnClickingMenu: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasHeaderSlot: false,
      show: false
    };
  },

  methods: {
    onTransitionEnd: function onTransitionEnd() {
      this.$emit(this.show ? 'on-after-show' : 'on-after-hide');
    },
    onMenuClick: function onMenuClick(text, key) {
      if (typeof text === 'string') {
        this.emitEvent('on-click-menu', key, text);
      } else {
        if (text.type !== 'disabled' && text.type !== 'info') {
          if (text.value || text.value === 0) {
            this.emitEvent('on-click-menu', text.value, text);
          } else {
            this.emitEvent('on-click-menu', '', text);
            this.show = false;
          }
        }
      }
    },
    onClickingMask: function onClickingMask() {
      this.$emit('on-click-mask');
      this.closeOnClickingMask && (this.show = false);
    },
    emitEvent: function emitEvent(event, menu, item) {
      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
        var _item = item;
        if ((typeof _item === 'undefined' ? 'undefined' : typeof_default()(_item)) === 'object') {
          _item = JSON.parse(stringify_default()(_item));
        }
        this.$emit(event, menu, _item);
        this.$emit(event + '-' + menu);
        this.closeOnClickingMenu && (this.show = false);
      }
    },
    fixIos: function fixIos(zIndex) {
      if (this.$el.parentNode && this.$el.parentNode.className.indexOf('v-transfer-dom') !== -1) {
        return;
      }
      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
        this.$tabbar.style.zIndex = zIndex;
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this2 = this;

      this.$emit('input', val);
      if (val) {
        this.fixIos(-1);
      } else {
        setTimeout(function () {
          _this2.fixIos(100);
        }, 200);
      }
    },

    value: {
      handler: function handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fixIos(100);
    this.$refs.iOSMenu && this.$refs.iOSMenu.removeEventListener('transitionend', this.onTransitionEnd);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63c67ccf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/actionsheet/index.vue
var actionsheet_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-actionsheet"},[_c('transition',{attrs:{"name":"vux-actionsheet-mask"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask weui-mask_transparent",on:{"click":_vm.onClickingMask}})]),_vm._v(" "),(_vm.theme === 'android')?_c('div',{staticClass:"weui-skin_android"},[_c('transition',{attrs:{"name":"vux-android-actionsheet"},on:{"after-enter":function($event){_vm.$emit('on-after-show')},"after-leave":function($event){_vm.$emit('on-after-hide')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-actionsheet"},[_c('div',{staticClass:"weui-actionsheet__menu"},_vm._l((_vm.menus),function(text,key){return _c('div',{staticClass:"weui-actionsheet__cell",domProps:{"innerHTML":_vm._s(text.label || text)},on:{"click":function($event){_vm.onMenuClick(text, key)}}})}))])])],1):_c('div',{ref:"iOSMenu",staticClass:"weui-actionsheet",class:{'weui-actionsheet_toggle': _vm.show}},[_c('div',{staticClass:"weui-actionsheet__menu"},[(_vm.hasHeaderSlot)?_c('div',{staticClass:"weui-actionsheet__cell"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_vm._l((_vm.menus),function(text,key){return _c('div',{staticClass:"weui-actionsheet__cell",class:("vux-actionsheet-menu-" + (text.type || 'default')),domProps:{"innerHTML":_vm._s(text.label || text)},on:{"click":function($event){_vm.onMenuClick(text, key)}}})})],2),_vm._v(" "),(_vm.showCancel)?_c('div',{staticClass:"weui-actionsheet__action",on:{"click":function($event){_vm.emitEvent('on-click-menu', 'cancel')}}},[_c('div',{staticClass:"weui-actionsheet__cell"},[_vm._v(_vm._s(_vm.cancelText || '取消'))])]):_vm._e()])],1)}
var actionsheet_staticRenderFns = []
var actionsheet_esExports = { render: actionsheet_render, staticRenderFns: actionsheet_staticRenderFns }
/* harmony default export */ var src_components_actionsheet = (actionsheet_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/actionsheet/index.vue
function actionsheet_injectStyle (ssrContext) {
  __webpack_require__("9sqQ")
}
var actionsheet_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var actionsheet___vue_template_functional__ = false
/* styles */
var actionsheet___vue_styles__ = actionsheet_injectStyle
/* scopeId */
var actionsheet___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var actionsheet___vue_module_identifier__ = null
var actionsheet_Component = actionsheet_normalizeComponent(
  components_actionsheet,
  src_components_actionsheet,
  actionsheet___vue_template_functional__,
  actionsheet___vue_styles__,
  actionsheet___vue_scopeId__,
  actionsheet___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_actionsheet = (actionsheet_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-368ae452","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/search/index.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-search-box",class:{ 'vux-search-fixed':_vm.isFixed },style:({ top: _vm.isFixed ? _vm.top : '', position: _vm.fixPosition })},[_c('div',{staticClass:"weui-search-bar",class:{'weui-search-bar_focusing': !_vm.isCancel || _vm.currentValue}},[_vm._t("left"),_vm._v(" "),_c('form',{staticClass:"weui-search-bar__form",attrs:{"action":"."},on:{"submit":function($event){$event.preventDefault();_vm.$emit('on-submit', _vm.value)}}},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFixed && _vm.autoFixed),expression:"!isFixed && autoFixed"}],staticClass:"vux-search-mask",attrs:{"for":("search_input_" + _vm.uuid)},on:{"click":_vm.touch}}),_vm._v(" "),_c('div',{staticClass:"weui-search-bar__box"},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"type":"search","autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){_vm.onComposition($event, 'start')},"compositionend":function($event){_vm.onComposition($event, 'end')},"input":[function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value},function($event){_vm.onComposition($event, 'input')}]}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-icon-clear",attrs:{"href":"javascript:"},on:{"click":_vm.clear}})]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFocus && !_vm.value),expression:"!isFocus && !value"}],staticClass:"weui-search-bar__label",attrs:{"for":("search_input_" + _vm.uuid)}},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.placeholder || '搜索'))])])]),_vm._v(" "),_c('a',{staticClass:"weui-search-bar__cancel-btn",attrs:{"href":"javascript:"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText || '取消')+"\n    ")]),_vm._v(" "),_vm._t("right")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFixed),expression:"isFixed"}],staticClass:"weui-cells vux-search_show"},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.results),function(item){return _c('div',{staticClass:"weui-cell weui-cell_access",on:{"click":function($event){_vm.handleResultClick(item)}}},[_c('div',{staticClass:"weui-cell__bd weui-cell_primary"},[_c('p',[_vm._v(_vm._s(item.title))])])])})],2)])}
var search_staticRenderFns = []
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var src_components_search = (search_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/search/index.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("o7jZ")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  components_search,
  src_components_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_search = (search_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        backgroundColor: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.backgroundColor = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.backgroundColor = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        backgroundColor: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.backgroundColor = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.backgroundColor = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9647ef1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var tab_staticRenderFns = []
var tab_esExports = { render: tab_render, staticRenderFns: tab_staticRenderFns }
/* harmony default export */ var components_tab_tab = (tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function tab_injectStyle (ssrContext) {
  __webpack_require__("k359")
}
var tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab___vue_template_functional__ = false
/* styles */
var tab___vue_styles__ = tab_injectStyle
/* scopeId */
var tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab___vue_module_identifier__ = null
var tab_Component = tab_normalizeComponent(
  tab_tab,
  components_tab_tab,
  tab___vue_template_functional__,
  tab___vue_styles__,
  tab___vue_scopeId__,
  tab___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b03591","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02febef1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var inline_desc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var inline_desc_staticRenderFns = []
var inline_desc_esExports = { render: inline_desc_render, staticRenderFns: inline_desc_staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (inline_desc_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function inline_desc_injectStyle (ssrContext) {
  __webpack_require__("Js7q")
}
var inline_desc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_desc___vue_template_functional__ = false
/* styles */
var inline_desc___vue_styles__ = inline_desc_injectStyle
/* scopeId */
var inline_desc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_desc___vue_module_identifier__ = null
var inline_desc_Component = inline_desc_normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  inline_desc___vue_template_functional__,
  inline_desc___vue_styles__,
  inline_desc___vue_scopeId__,
  inline_desc___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = (inline_desc_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  computed: {
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.$parent.labelWidth || width,
        textAlign: this.$parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && this.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  computed: {
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.$parent.labelWidth || width,
        textAlign: this.$parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && this.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3960f4c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-switch/index.vue
var x_switch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-switch weui-cell weui-cell_switch"},[_c('div',{staticClass:"weui-cell__bd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyle),domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-switch",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),(_vm.preventDefault)?_c('div',{staticClass:"vux-x-switch-overlay",on:{"click":_vm.onClick}}):_vm._e()])])}
var x_switch_staticRenderFns = []
var x_switch_esExports = { render: x_switch_render, staticRenderFns: x_switch_staticRenderFns }
/* harmony default export */ var src_components_x_switch = (x_switch_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-switch/index.vue
function x_switch_injectStyle (ssrContext) {
  __webpack_require__("NJcl")
}
var x_switch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_switch___vue_template_functional__ = false
/* styles */
var x_switch___vue_styles__ = x_switch_injectStyle
/* scopeId */
var x_switch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_switch___vue_module_identifier__ = null
var x_switch_Component = x_switch_normalizeComponent(
  components_x_switch,
  src_components_x_switch,
  x_switch___vue_template_functional__,
  x_switch___vue_styles__,
  x_switch___vue_scopeId__,
  x_switch___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_switch = (x_switch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00172c07","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var group_staticRenderFns = []
var group_esExports = { render: group_render, staticRenderFns: group_staticRenderFns }
/* harmony default export */ var src_components_group = (group_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function group_injectStyle (ssrContext) {
  __webpack_require__("vjFQ")
}
var group_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group___vue_template_functional__ = false
/* styles */
var group___vue_styles__ = group_injectStyle
/* scopeId */
var group___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group___vue_module_identifier__ = null
var group_Component = group_normalizeComponent(
  components_group,
  src_components_group,
  group___vue_template_functional__,
  group___vue_styles__,
  group___vue_scopeId__,
  group___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = (group_Component.exports);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/xscroll.js
var xscroll = __webpack_require__("WTNC");
var xscroll_default = /*#__PURE__*/__webpack_require__.n(xscroll);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pulldown.js
var pulldown = __webpack_require__("ypEt");
var pulldown_default = /*#__PURE__*/__webpack_require__.n(pulldown);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pullup.js
var pullup = __webpack_require__("qbvd");
var pullup_default = /*#__PURE__*/__webpack_require__.n(pullup);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var scroller_pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var scroller_pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var components_scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', scroller_pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(scroller_pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(scroller_pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function scroller_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da5f8bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/scroller/index.vue
var scroller_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles)},[_c('div',{staticClass:"xs-container"},[_vm._t("default"),_vm._v(" "),_vm._t("pulldown"),_vm._v(" "),_vm._t("pullup")],2)])}
var scroller_staticRenderFns = []
var scroller_esExports = { render: scroller_render, staticRenderFns: scroller_staticRenderFns }
/* harmony default export */ var src_components_scroller = (scroller_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/scroller/index.vue
function scroller_injectStyle (ssrContext) {
  __webpack_require__("p8U2")
}
var scroller_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var scroller___vue_template_functional__ = false
/* styles */
var scroller___vue_styles__ = scroller_injectStyle
/* scopeId */
var scroller___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var scroller___vue_module_identifier__ = null
var scroller_Component = scroller_normalizeComponent(
  components_scroller,
  src_components_scroller,
  scroller___vue_template_functional__,
  scroller___vue_styles__,
  scroller___vue_scopeId__,
  scroller___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_scroller = (scroller_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/media/index.vue

















/* harmony default export */ var media = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['profile', 'taxonomyList'])),
  components: {
    dropdown: node_modules_vue_dropdowns_dropdown,
    Actionsheet: vux_src_components_actionsheet,
    Search: vux_src_components_search,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Scroller: vux_src_components_scroller
  },
  data: function data() {
    return {
      show1: false,
      menus1: {
        menu1: '综合排序',
        menu2: '粉丝量'
      },
      show2: false,
      menus2: {
        menu1: '从高到低',
        menu2: '从低到高'
      },
      menu1Current: '综合排序',
      menu2Current: '从高到低',
      inputShowed: false,
      activeIndex: 0,
      searchStatus: false,
      searchFilter: {
        q: '',
        _mode: 'es',
        'sort_field': '',
        'sort_direct': 'descend',
        page: 1
      },
      sortDescName: ['从高到低', '从低到高'],
      sortDescNameWeb: [{ name: '从高到低' }, { name: '从低到高' }],
      sortDescValue: ['descend', 'ascend'],
      currentSortField: {
        name: '综合排序'
      },
      currentSortDirect: { name: '从高到低' },
      resourceData: [],
      show4: false,
      show5: false,
      actionMenu: {
        0: '加入到收藏夹',
        1: '加入到购物车'
      },
      priceMenu: {
        0: '',
        1: ''
      },
      currentResource: {},
      currentResourceIndex: {},

      cartGoodsNumber: 0,
      iconLink: '',
      pullupDefaultConfig: {
        content: '上拉加载更多',
        pullUpHeight: 60,
        height: 40,
        autoRefresh: false,
        downContent: '释放后加载',
        upContent: '上拉加载更多',
        loadingContent: '加载中...',
        clsPrefix: 'xs-plugin-pullup-'
      }
    };
  },

  directives: {
    focus: vue_focus_common["focus"]
  },

  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])({
    setTitleVuex: 'SET_TITLE',
    setProfile: 'SET_PROFILE'
  }), {
    log: function log(str) {
      console.log(str);
    },
    click: function click(key) {
      console.log(key);
    },
    showInput: function showInput() {
      this.inputShowed = true;
    },
    hideInput: function hideInput() {
      this.searchFilter.q = '';
      this.inputShowed = false;
    },
    clearInput: function clearInput() {
      this.searchFilter.q = '';
    },
    handlesearch: function handlesearch() {
      this.getDataByTab();
    },
    tabClick: function tabClick(idx) {
      this.$router.push('/media?tab=' + this.taxonomyList[idx].tabType);
      this.activeIndex = idx;
      this.changeNavTitle();
      this.getDataByTab();
      this.getCartNumber();
    },
    getTabStatus: function getTabStatus() {

      if (!this.$route.query.search) {
        this.activeIndex = this.$route.query.tab ? this.taxonomyList.map(function (item) {
          return item.tabType;
        }).indexOf(this.$route.query.tab) : 0;
        this.getDataByTab();
      } else {
        this.resourceData = [];
      }
      this.changeNavTitle();
    },
    changeNavTitle: function changeNavTitle() {
      var title = this.taxonomyList[this.activeIndex].name;
      this.setTitleVuex(title);
      document.title = title;
      this.menu1Current = '综合排序';
      this.menu2Current = '从高到低';
    },
    changeSortField: function changeSortField(e) {
      var _this = this;

      this.menu1Current = this.taxonomyList[this.activeIndex].sortName[e];
      var idx = void 0;
      this.taxonomyList[this.activeIndex].sortName.map(function (item, index) {
        if (item === _this.menu1Current) {
          idx = index;
        }
      });
      this.searchFilter.sort_field = this.taxonomyList[this.activeIndex].sortField[idx];
      this.getDataByTab();
    },
    changeSortDirect: function changeSortDirect(e) {
      var _this2 = this;

      this.menu2Current = this.menus2[e];
      var idx = void 0;
      this.sortDescName.map(function (item, index) {
        if (item === _this2.menu2Current) {
          idx = index;
        }
      });
      this.searchFilter.sort_direct = this.sortDescValue[idx];
      this.getDataByTab();
    },
    getCartNumber: function getCartNumber() {
      var _this3 = this;

      if (!this.profile.id) {
        this.cartGoodsNumber = 0;
      } else {
        fetchCart(this.taxonomyList[this.activeIndex].tabType).then(function (resp) {
          _this3.cartGoodsNumber = resp.data.length;
        }).catch(function (e) {
          return console.log('error', e);
        });
      }
    },
    loadmore: function loadmore(loaded) {
      this.getDataByTab('loadmore');
      setTimeout(function () {
        loaded('done');
      }, 1000);
    },
    stateChange: function stateChange(state) {
      if (state === 'pull' || state === 'trigger') {
        this.iconLink = '#icon-arrow-bottom';
      } else if (state === 'loading') {
        this.iconLink = '#icon-loading';
      } else if (state === 'loaded-done') {
        this.iconLink = '#icon-finish';
      }
    },
    getDataByTab: function getDataByTab(loadmore) {
      var _this4 = this;

      if (loadmore === 'loadmore') {
        ++this.searchFilter.page;
      } else {
        this.searchFilter.page = 1;
        this.resourceData = [];
      }
      var tabType = this.taxonomyList[this.activeIndex].tabType;
      fetchResource(tabType, this.searchFilter).then(function (resp) {
        var resourceDataNew = resp.data.map(function (data) {
          var avgReadNum = formatNumInTenThousand(data.analysis.avg_read_num);
          var fansNum = formatNumInTenThousand(data.analysis.fans_num);
          var avgPlayNum = formatNumInTenThousand(data.analysis.avg_play_num);
          var avgAudienceNum = formatNumInTenThousand(data.analysis.avg_audience_num);
          var price = formatNumInTenThousand(data.quote.price);
          var priceSecond = formatNumInTenThousand(data.quote.price_second);
          var cartStatus = data.cart && data.cart.created_at;
          var likeNum = formatNumInTenThousand(data.analysis.avg_like_num);
          var priceBoxIsShow = false;
          return extends_default()({}, data, {
            avgReadNum: avgReadNum,
            fansNum: fansNum,
            avgPlayNum: avgPlayNum,
            price: price,
            priceSecond: priceSecond,
            cartStatus: cartStatus,
            priceBoxIsShow: priceBoxIsShow,
            likeNum: likeNum,
            avgAudienceNum: avgAudienceNum
          });
        });
        if (loadmore === 'loadmore') {
          _this4.resourceData = _this4.resourceData.concat(resourceDataNew);
        } else {
          _this4.resourceData = resourceDataNew;
        }
        _this4.$nextTick(function () {
          _this4.$refs.scrollerBottom.donePullup();
        });
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleAddToCart: function handleAddToCart(data, index, priceType) {
      var _this5 = this;

      if (!priceType) {
        priceType = this.taxonomyList[this.activeIndex].priceType[0] || '';
      }
      addToCart(data.id, this.taxonomyList[this.activeIndex].tabType, priceType).then(function (resp) {

        _this5.resourceData[index].cart = { item_id: resp.data.item_id };
        _this5.resourceData[index].cartStatus = true;
        _this5.$vux.toast.show({
          text: '成功加入购物车'
        });
        ++_this5.cartGoodsNumber;
      }).catch(function (e) {
        _this5.$vux.toast.show({
          text: e.message
        });
      });
    },
    handleDeleteFromCart: function handleDeleteFromCart(cartId, index) {
      var _this6 = this;

      deleteFromCart(cartId).then(function (resp) {

        _this6.resourceData[index].cart = null;
        _this6.resourceData[index].cartStatus = false;
        --_this6.cartGoodsNumber;
      }).catch(function (e) {});
    },
    console: function (_console) {
      function console(_x) {
        return _console.apply(this, arguments);
      }

      console.toString = function () {
        return _console.toString();
      };

      return console;
    }(function (msg) {
      console.log(msg);
    }),
    actionShow: function actionShow(item, index) {
      this.show4 = true;
      this.currentResource = item;
      this.currentResourceIndex = index;
    },
    handleChoose: function handleChoose(key) {
      var _this7 = this;

      if (key === '1') {
        this.show5 = true;
        this.priceMenu[0] = this.taxonomyList[this.activeIndex].priceTypeName[0] + this.currentResource.price;
        this.priceMenu[1] = this.taxonomyList[this.activeIndex].priceTypeName[1] + this.currentResource.priceSecond;
      } else {
        addToCollection(this.currentResource.id, this.taxonomyList[this.activeIndex].tabType).then(function (resp) {
          _this7.$vux.toast.show({
            text: resp.message
          });
        });
      }
    },
    selectPrice: function selectPrice(key) {
      this.handleAddToCart(this.currentResource, this.currentResourceIndex, this.taxonomyList[this.activeIndex].priceType[key]);
    }
  }),
  beforeMount: function beforeMount() {
    var _this8 = this;

    this.getTabStatus();
    fetchUser().then(function (resp) {
      _this8.setProfile(resp.data);
      _this8.getCartNumber();
    });
  },
  mounted: function mounted() {
    var _this9 = this;

    this.$nextTick(function () {
      _this9.$refs.scrollerBottom.reset({ top: 0 });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/media/index.vue

















/* harmony default export */ var pages_media = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['profile', 'taxonomyList'])),
  components: {
    dropdown: node_modules_vue_dropdowns_dropdown,
    Actionsheet: vux_src_components_actionsheet,
    Search: vux_src_components_search,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    XSwitch: vux_src_components_x_switch,
    Group: vux_src_components_group,
    Scroller: vux_src_components_scroller
  },
  data: function data() {
    return {
      show1: false,
      menus1: {
        menu1: '综合排序',
        menu2: '粉丝量'
      },
      show2: false,
      menus2: {
        menu1: '从高到低',
        menu2: '从低到高'
      },
      menu1Current: '综合排序',
      menu2Current: '从高到低',
      inputShowed: false,
      activeIndex: 0,
      searchStatus: false,
      searchFilter: {
        q: '',
        _mode: 'es',
        'sort_field': '',
        'sort_direct': 'descend',
        page: 1
      },
      sortDescName: ['从高到低', '从低到高'],
      sortDescNameWeb: [{ name: '从高到低' }, { name: '从低到高' }],
      sortDescValue: ['descend', 'ascend'],
      currentSortField: {
        name: '综合排序'
      },
      currentSortDirect: { name: '从高到低' },
      resourceData: [],
      show4: false,
      show5: false,
      actionMenu: {
        0: '加入到收藏夹',
        1: '加入到购物车'
      },
      priceMenu: {
        0: '',
        1: ''
      },
      currentResource: {},
      currentResourceIndex: {},

      cartGoodsNumber: 0,
      iconLink: '',
      pullupDefaultConfig: {
        content: '上拉加载更多',
        pullUpHeight: 60,
        height: 40,
        autoRefresh: false,
        downContent: '释放后加载',
        upContent: '上拉加载更多',
        loadingContent: '加载中...',
        clsPrefix: 'xs-plugin-pullup-'
      }
    };
  },

  directives: {
    focus: vue_focus_common["focus"]
  },

  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])({
    setTitleVuex: 'SET_TITLE',
    setProfile: 'SET_PROFILE'
  }), {
    log: function log(str) {
      console.log(str);
    },
    click: function click(key) {
      console.log(key);
    },
    showInput: function showInput() {
      this.inputShowed = true;
    },
    hideInput: function hideInput() {
      this.searchFilter.q = '';
      this.inputShowed = false;
    },
    clearInput: function clearInput() {
      this.searchFilter.q = '';
    },
    handlesearch: function handlesearch() {
      this.getDataByTab();
    },
    tabClick: function tabClick(idx) {
      this.$router.push('/media?tab=' + this.taxonomyList[idx].tabType);
      this.activeIndex = idx;
      this.changeNavTitle();
      this.getDataByTab();
      this.getCartNumber();
    },
    getTabStatus: function getTabStatus() {

      if (!this.$route.query.search) {
        this.activeIndex = this.$route.query.tab ? this.taxonomyList.map(function (item) {
          return item.tabType;
        }).indexOf(this.$route.query.tab) : 0;
        this.getDataByTab();
      } else {
        this.resourceData = [];
      }
      this.changeNavTitle();
    },
    changeNavTitle: function changeNavTitle() {
      var title = this.taxonomyList[this.activeIndex].name;
      this.setTitleVuex(title);
      document.title = title;
      this.menu1Current = '综合排序';
      this.menu2Current = '从高到低';
    },
    changeSortField: function changeSortField(e) {
      var _this = this;

      this.menu1Current = this.taxonomyList[this.activeIndex].sortName[e];
      var idx = void 0;
      this.taxonomyList[this.activeIndex].sortName.map(function (item, index) {
        if (item === _this.menu1Current) {
          idx = index;
        }
      });
      this.searchFilter.sort_field = this.taxonomyList[this.activeIndex].sortField[idx];
      this.getDataByTab();
    },
    changeSortDirect: function changeSortDirect(e) {
      var _this2 = this;

      this.menu2Current = this.menus2[e];
      var idx = void 0;
      this.sortDescName.map(function (item, index) {
        if (item === _this2.menu2Current) {
          idx = index;
        }
      });
      this.searchFilter.sort_direct = this.sortDescValue[idx];
      this.getDataByTab();
    },
    getCartNumber: function getCartNumber() {
      var _this3 = this;

      if (!this.profile.id) {
        this.cartGoodsNumber = 0;
      } else {
        fetchCart(this.taxonomyList[this.activeIndex].tabType).then(function (resp) {
          _this3.cartGoodsNumber = resp.data.length;
        }).catch(function (e) {
          return console.log('error', e);
        });
      }
    },
    loadmore: function loadmore(loaded) {
      this.getDataByTab('loadmore');
      setTimeout(function () {
        loaded('done');
      }, 1000);
    },
    stateChange: function stateChange(state) {
      if (state === 'pull' || state === 'trigger') {
        this.iconLink = '#icon-arrow-bottom';
      } else if (state === 'loading') {
        this.iconLink = '#icon-loading';
      } else if (state === 'loaded-done') {
        this.iconLink = '#icon-finish';
      }
    },
    getDataByTab: function getDataByTab(loadmore) {
      var _this4 = this;

      if (loadmore === 'loadmore') {
        ++this.searchFilter.page;
      } else {
        this.searchFilter.page = 1;
        this.resourceData = [];
      }
      var tabType = this.taxonomyList[this.activeIndex].tabType;
      fetchResource(tabType, this.searchFilter).then(function (resp) {
        var resourceDataNew = resp.data.map(function (data) {
          var avgReadNum = formatNumInTenThousand(data.analysis.avg_read_num);
          var fansNum = formatNumInTenThousand(data.analysis.fans_num);
          var avgPlayNum = formatNumInTenThousand(data.analysis.avg_play_num);
          var avgAudienceNum = formatNumInTenThousand(data.analysis.avg_audience_num);
          var price = formatNumInTenThousand(data.quote.price);
          var priceSecond = formatNumInTenThousand(data.quote.price_second);
          var cartStatus = data.cart && data.cart.created_at;
          var likeNum = formatNumInTenThousand(data.analysis.avg_like_num);
          var priceBoxIsShow = false;
          return extends_default()({}, data, {
            avgReadNum: avgReadNum,
            fansNum: fansNum,
            avgPlayNum: avgPlayNum,
            price: price,
            priceSecond: priceSecond,
            cartStatus: cartStatus,
            priceBoxIsShow: priceBoxIsShow,
            likeNum: likeNum,
            avgAudienceNum: avgAudienceNum
          });
        });
        if (loadmore === 'loadmore') {
          _this4.resourceData = _this4.resourceData.concat(resourceDataNew);
        } else {
          _this4.resourceData = resourceDataNew;
        }
        _this4.$nextTick(function () {
          _this4.$refs.scrollerBottom.donePullup();
        });
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleAddToCart: function handleAddToCart(data, index, priceType) {
      var _this5 = this;

      if (!priceType) {
        priceType = this.taxonomyList[this.activeIndex].priceType[0] || '';
      }
      addToCart(data.id, this.taxonomyList[this.activeIndex].tabType, priceType).then(function (resp) {

        _this5.resourceData[index].cart = { item_id: resp.data.item_id };
        _this5.resourceData[index].cartStatus = true;
        _this5.$vux.toast.show({
          text: '成功加入购物车'
        });
        ++_this5.cartGoodsNumber;
      }).catch(function (e) {
        _this5.$vux.toast.show({
          text: e.message
        });
      });
    },
    handleDeleteFromCart: function handleDeleteFromCart(cartId, index) {
      var _this6 = this;

      deleteFromCart(cartId).then(function (resp) {

        _this6.resourceData[index].cart = null;
        _this6.resourceData[index].cartStatus = false;
        --_this6.cartGoodsNumber;
      }).catch(function (e) {});
    },
    console: function (_console) {
      function console(_x) {
        return _console.apply(this, arguments);
      }

      console.toString = function () {
        return _console.toString();
      };

      return console;
    }(function (msg) {
      console.log(msg);
    }),
    actionShow: function actionShow(item, index) {
      this.show4 = true;
      this.currentResource = item;
      this.currentResourceIndex = index;
    },
    handleChoose: function handleChoose(key) {
      var _this7 = this;

      if (key === '1') {
        this.show5 = true;
        this.priceMenu[0] = this.taxonomyList[this.activeIndex].priceTypeName[0] + this.currentResource.price;
        this.priceMenu[1] = this.taxonomyList[this.activeIndex].priceTypeName[1] + this.currentResource.priceSecond;
      } else {
        addToCollection(this.currentResource.id, this.taxonomyList[this.activeIndex].tabType).then(function (resp) {
          _this7.$vux.toast.show({
            text: resp.message
          });
        });
      }
    },
    selectPrice: function selectPrice(key) {
      this.handleAddToCart(this.currentResource, this.currentResourceIndex, this.taxonomyList[this.activeIndex].priceType[key]);
    }
  }),
  beforeMount: function beforeMount() {
    var _this8 = this;

    this.getTabStatus();
    fetchUser().then(function (resp) {
      _this8.setProfile(resp.data);
      _this8.getCartNumber();
    });
  },
  mounted: function mounted() {
    var _this9 = this;

    this.$nextTick(function () {
      _this9.$refs.scrollerBottom.reset({ top: 0 });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d48d44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/media/index.vue
var media_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('scroller',{ref:"scrollerBottom",attrs:{"lock-x":"","use-pullup":"","pullup-config":_vm.pullupDefaultConfig,"height":"-92"},on:{"on-pullup-loading":function($event){_vm.getDataByTab('loadmore')}}},[_c('div',{staticClass:"page"},[_c('div',{staticClass:"page__bd"},[_c('search',{ref:"search",attrs:{"auto-fixed":false},on:{"on-submit":_vm.handlesearch},model:{value:(_vm.searchFilter.q),callback:function ($$v) {_vm.$set(_vm.searchFilter, "q", $$v)},expression:"searchFilter.q"}}),_vm._v(" "),_c('tab',{attrs:{"scroll-threshold":5,"active-color":"#ff622b","bar-active-color":"#ff622b"}},_vm._l((_vm.taxonomyList),function(item,index){return _c('tab-item',{key:index,attrs:{"selected":_vm.taxonomyList[_vm.activeIndex].tabType==item.tabType},on:{"on-item-click":function($event){_vm.tabClick(index)}}},[_vm._v("\n            "+_vm._s(item.name||'暂无')+"\n          ")])})),_vm._v(" "),_c('div',{staticClass:"data-list",scopedSlots:_vm._u([{key:"bottom-block",fn:function(props){return [_c('div',{staticClass:"bottom-load-wrapper"},[_vm._v("\n              "+_vm._s(props.stateText)+"\n            ")])]}}])},[_c('flexbox',{staticClass:"sort-box"},[_c('flexbox-item',{staticClass:"vux-1px-r"},[_c('div',{staticClass:"media-sort",on:{"click":function($event){_vm.show1=true}}},[_vm._v(_vm._s(_vm.menu1Current))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"media-sort",on:{"click":function($event){_vm.show2=true}}},[_vm._v(_vm._s(_vm.menu2Current))])])],1),_vm._v(" "),_vm._l((_vm.resourceData),function(item ,index){return _c('div',{key:index,staticClass:"tab-content"},[_c('div',{staticClass:"tab-content-inner"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.taxonomyList[_vm.activeIndex].mediaAvatarShow),expression:"taxonomyList[activeIndex].mediaAvatarShow"}],staticClass:"card-box-img",attrs:{"to":'/media/detail/'+item.id+'?type='+_vm.taxonomyList[_vm.activeIndex].tabType}},[_c('img',{staticClass:"avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.taxonomyList[_vm.activeIndex].mediaBargeShow),expression:"taxonomyList[activeIndex].mediaBargeShow"}],staticClass:"v-barge"},[_c('i',{staticClass:"iconfont icon-v"})]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.taxonomyList[_vm.activeIndex].mediaPlatformShow),expression:"taxonomyList[activeIndex].mediaPlatformShow"}],staticClass:"platform-barge",attrs:{"src":item.platform.icon,"alt":""}})]),_vm._v(" "),_c('router-link',{staticClass:"card-li-info",attrs:{"to":'/media/detail/'+item.id+'?type='+_vm.taxonomyList[_vm.activeIndex].tabType}},[_c('div',{staticClass:"card-content-li"},[_c('div',{staticClass:"card-box-title"},[(_vm.taxonomyList[_vm.activeIndex].tabType=='woa')?_c('i',{staticClass:"iconfont icon-weixinicon"}):_vm._e(),_vm._v(" "),(_vm.taxonomyList[_vm.activeIndex].tabType=='weibo')?_c('i',{staticClass:"iconfont icon-weibo1"}):_vm._e(),_vm._v(" "),(_vm.taxonomyList[_vm.activeIndex].tabType=='live')?_c('i',{staticClass:"iconfont icon-dingdan-wanghongzhibo"}):_vm._e(),_vm._v(" "),(_vm.taxonomyList[_vm.activeIndex].tabType=='video')?_c('i',{staticClass:"iconfont icon-dingdan-duanshipin"}):_vm._e(),_vm._v(" "),(_vm.taxonomyList[_vm.activeIndex].tabType=='xhs')?_c('i',{staticClass:"iconfont icon-xiaohongshu"}):_vm._e(),_vm._v("\n                    "+_vm._s(item.name||'暂无')+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"card-box-description"},[_vm._v("\n                    "+_vm._s(item.description?item.description:'暂无简介')+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"card-box-analysis"},_vm._l((_vm.taxonomyList[_vm.activeIndex].analysisTypes),function(secondItem,secondindex){return _c('div',{key:secondindex},[(secondItem=='category')?_c('div',{staticClass:"card-mark"},[_vm._v(_vm._s(item.category?item.category.name:'暂无')+"\n                      ")]):_vm._e(),_vm._v(" "),(secondItem=='fansNum')?_c('div',{staticClass:"card-mark"},[_vm._v("粉丝"+_vm._s(item.fansNum))]):_vm._e(),_vm._v(" "),(secondItem=='avgReadNum')?_c('div',{staticClass:"card-mark"},[_vm._v("阅读"+_vm._s(item.avgReadNum))]):(secondItem=='avgPlayNum')?_c('div',{staticClass:"card-mark"},[_vm._v("播放"+_vm._s(item.avgPlayNum))]):(secondItem=='avgLikeNum')?_c('div',{staticClass:"card-mark"},[_vm._v("点赞"+_vm._s(item.likeNum))]):(secondItem=='avgAudienceNum')?_c('div',{staticClass:"card-mark"},[_vm._v("观众"+_vm._s(item.avgAudienceNum))]):_vm._e()])})),_vm._v(" "),_c('div',{staticClass:"card-box-price"},_vm._l((_vm.taxonomyList[_vm.activeIndex].priceTypeName),function(pItem,pIndex){return _c('div',{key:pIndex},[(pIndex == 0 )?_c('div',{staticClass:"refer-price"},[_vm._v("\n                        "+_vm._s(pItem)+":"),_c('span',[_vm._v("￥"+_vm._s(item.price?item.price+'元':'-'))])]):_vm._e(),_vm._v(" "),(pIndex == 1)?_c('div',{staticClass:"refer-price"},[_vm._v(_vm._s(pItem)+":"),_c('span',[_vm._v("￥"+_vm._s(item.priceSecond?item.priceSecond+'元':'-'))])]):_vm._e()])}))])]),_vm._v(" "),_c('div',[(_vm.taxonomyList[_vm.activeIndex].tabType!='news')?_c('div',{staticClass:"card-operation three-dot"},[_c('i',{staticClass:"iconfont icon-sangedian",on:{"click":function($event){_vm.actionShow(item,index)}},model:{value:(_vm.show4),callback:function ($$v) {_vm.show4=$$v},expression:"show4"}})]):_vm._e()])],1)])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceData.length===0),expression:"resourceData.length===0"}]},[_c('h4',{staticStyle:{"text-align":"center","margin-top":"100px"}},[_vm._v("切换标签搜索指定内容")]),_vm._v(" "),_c('img',{staticClass:"search-blank",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/search-blank.png","alt":""}}),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","color":"#999"}},[_vm._v("\n              当前没有搜索数据~\n            ")])])],2)],1)])]),_vm._v(" "),(_vm.profile.id)?_c('router-link',{staticClass:"float-shaopcar",attrs:{"to":'/cart?tab='+_vm.activeIndex}},[_c('i',{staticClass:"iconfont icon-gouwuche-xuanfu"}),_vm._v(" "),_c('div',{staticClass:"cart-goods-number"},[_vm._v(_vm._s(_vm.cartGoodsNumber))])]):_vm._e(),_vm._v(" "),_c('actionsheet',{directives:[{name:"show",rawName:"v-show",value:(_vm.show1),expression:"show1"}],attrs:{"menus":_vm.taxonomyList[_vm.activeIndex].sortName},on:{"on-click-menu":_vm.changeSortField},model:{value:(_vm.show1),callback:function ($$v) {_vm.show1=$$v},expression:"show1"}}),_vm._v(" "),_c('actionsheet',{directives:[{name:"show",rawName:"v-show",value:(_vm.show2),expression:"show2"}],attrs:{"menus":_vm.menus2},on:{"on-click-menu":_vm.changeSortDirect},model:{value:(_vm.show2),callback:function ($$v) {_vm.show2=$$v},expression:"show2"}}),_vm._v(" "),_c('actionsheet',{directives:[{name:"show",rawName:"v-show",value:(_vm.show4),expression:"show4"}],attrs:{"menus":_vm.actionMenu,"close-on-clicking-mask":true},on:{"on-click-menu":_vm.handleChoose},model:{value:(_vm.show4),callback:function ($$v) {_vm.show4=$$v},expression:"show4"}}),_vm._v(" "),_c('actionsheet',{directives:[{name:"show",rawName:"v-show",value:(_vm.show5),expression:"show5"}],attrs:{"menus":_vm.priceMenu,"close-on-clicking-mask":true},on:{"on-click-menu":_vm.selectPrice},model:{value:(_vm.show5),callback:function ($$v) {_vm.show5=$$v},expression:"show5"}})],1)}
var media_staticRenderFns = []
var media_esExports = { render: media_render, staticRenderFns: media_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_media = (media_esExports);
// CONCATENATED MODULE: ./src/pages/media/index.vue
function media_injectStyle (ssrContext) {
  __webpack_require__("KzRA")
  __webpack_require__("ZbPA")
}
var media_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var media___vue_template_functional__ = false
/* styles */
var media___vue_styles__ = media_injectStyle
/* scopeId */
var media___vue_scopeId__ = "data-v-26d48d44"
/* moduleIdentifier (server only) */
var media___vue_module_identifier__ = null
var media_Component = media_normalizeComponent(
  pages_media,
  selectortype_template_index_0_src_pages_media,
  media___vue_template_functional__,
  media___vue_styles__,
  media___vue_scopeId__,
  media___vue_module_identifier__
)

/* harmony default export */ var src_pages_media = (media_Component.exports);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe.js
var photoswipe = __webpack_require__("i7N3");
var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe-ui-default.js
var photoswipe_ui_default = __webpack_require__("72M0");
var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      return this.photoswipe.getCurrentIndex();
    },
    close: function close() {
      this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      return this.photoswipe.getCurrentIndex();
    },
    close: function close() {
      this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb62591c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/previewer/index.vue
var previewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp vux-previewer",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"pswp__bg"}),_vm._v(" "),_c('div',{staticClass:"pswp__scroll-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pswp__ui pswp__ui--hidden"},[_c('div',{staticClass:"pswp__top-bar"},[_c('div',{staticClass:"pswp__counter"}),_vm._v(" "),_vm._t("button-after"),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--close",attrs:{"title":"Close (Esc)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--share",attrs:{"title":"Share"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--fs",attrs:{"title":"Toggle fullscreen"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--zoom",attrs:{"title":"Zoom in/out"}}),_vm._v(" "),_vm._t("button-before"),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--left",attrs:{"title":"Previous (arrow left)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--right",attrs:{"title":"Next (arrow right)"}}),_vm._v(" "),_vm._m(3)])])])}
var previewer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__container"},[_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__preloader"},[_c('div',{staticClass:"pswp__preloader__icn"},[_c('div',{staticClass:"pswp__preloader__cut"},[_c('div',{staticClass:"pswp__preloader__donut"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__share-modal pswp__share-modal--hidden pswp__single-tap"},[_c('div',{staticClass:"pswp__share-tooltip"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__caption"},[_c('div',{staticClass:"pswp__caption__center"})])}]
var previewer_esExports = { render: previewer_render, staticRenderFns: previewer_staticRenderFns }
/* harmony default export */ var src_components_previewer = (previewer_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/previewer/index.vue
function previewer_injectStyle (ssrContext) {
  __webpack_require__("IRVY")
  __webpack_require__("nUus")
}
var previewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var previewer___vue_template_functional__ = false
/* styles */
var previewer___vue_styles__ = previewer_injectStyle
/* scopeId */
var previewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var previewer___vue_module_identifier__ = null
var previewer_Component = previewer_normalizeComponent(
  components_previewer,
  src_components_previewer,
  previewer___vue_template_functional__,
  previewer___vue_styles__,
  previewer___vue_scopeId__,
  previewer___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_previewer = (previewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/mediaDetail/index.vue










/* harmony default export */ var mediaDetail = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['taxonomyList'])),
  components: {
    Previewer: vux_src_components_previewer,
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      type: '',
      taxonomy: '',
      id: '',
      detailData: {
        quote: {},
        analysis: {},
        category: {},
        cart: {},
        platform: {}
      },
      collectionStatus: false,
      cartNum: 0,
      relatedArticleData: [],
      unfold: false,
      qrImg: [],
      selectedPrice: 0
    };
  },

  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])({
    setTitleVuex: 'SET_TITLE'
  }), {
    changeNavTitle: function changeNavTitle(navTitle) {
      this.setTitleVuex(navTitle);
      document.title = navTitle;
    },
    getDetail: function getDetail() {
      var _this = this;

      fetchResourceDetail(this.type, this.id).then(function (resp) {
        _this.detailData = extends_default()({}, resp.data, {
          publishRate: formatNumInTenThousand(resp.data.analysis.publish_rate),
          pcBaiduRank: formatNumInTenThousand(resp.data.analysis.pc_baidu_rank),
          mBaiduRank: formatNumInTenThousand(resp.data.analysis.m_baidu_rank),

          avgReadNumTop: formatNumInTenThousand(resp.data.analysis.avg_read_num_top),
          avgReadNumUntop: formatNumInTenThousand(resp.data.analysis.avg_read_num_untop),
          avgLikeNumTop: formatNumInTenThousand(resp.data.analysis.avg_like_num_top),
          avgLikeNumUntop: formatNumInTenThousand(resp.data.analysis.avg_like_num_untop),
          maxReadNum: formatNumInTenThousand(resp.data.analysis.max_read_num),

          avgRetweetNum: formatNumInTenThousand(resp.data.analysis.avg_retweet_num),
          avgLikeNum: formatNumInTenThousand(resp.data.analysis.avg_like_num),
          avgCommentNum: formatNumInTenThousand(resp.data.analysis.avg_comment_num),
          maxRetweetNum: formatNumInTenThousand(resp.data.analysis.max_retweet_num),
          maxLikeNum: formatNumInTenThousand(resp.data.analysis.max_like_num),
          maxCommentNum: formatNumInTenThousand(resp.data.analysis.max_comment_num),

          fansNum: formatNumInTenThousand(resp.data.analysis.fans_num),
          avgAudienceNum: formatNumInTenThousand(resp.data.analysis.avg_audience_num),
          maxAudienceNum: formatNumInTenThousand(resp.data.analysis.max_audience_num),

          avgPlayNum: formatNumInTenThousand(resp.data.analysis.avg_play_num),
          readNum: formatNumInTenThousand(resp.data.analysis.avg_read_num),

          priceValidityEnd: resp.data.quote.price_validity_end ? formatDate(resp.data.quote.price_validity_end) : '',
          price: resp.data.quote.price,
          priceSecond: resp.data.quote.price_second,
          cartStatus: resp.data.cart && resp.data.cart.created_at
        });

        _this.collectionStatus = resp.data.collection && resp.data.collection.created_at;
        _this.changeNavTitle(_this.detailData.name);
        _this.selectedPrice = _this.detailData.price || _this.detailData.priceSecond;
        _this.qrImg = [{
          src: resp.data.qrcode
        }];

        getRelatedArticles(resp.data.account_id, resp.data.taxonomy, 10).then(function (res) {
          _this.relatedArticleData = res.data;
          if (_this.relatedArticleData.length <= 3) {
            _this.unfold = true;
          }
        });
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changePriceStatus: function changePriceStatus(num) {
      if (num === 1) {
        this.selectedPrice = this.detailData.quote.price;
      }
      if (num === 2) {
        this.selectedPrice = this.detailData.quote.price_second;
      }
    },
    handleAddToCart: function handleAddToCart(action) {
      var _this2 = this;

      var top = this.selectedPrice === this.detailData.price ? this.taxonomy.priceType[0] : this.taxonomy.priceType[1];
      addToCart(this.detailData.id, this.type, top).then(function (res) {
        if (action === 'goToCart') {
          _this2.$router.push('/cart');
        } else {
          _this2.getDetail();
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleDeleteFromCart: function handleDeleteFromCart() {
      var _this3 = this;

      deleteFromCart(this.detailData.cart.item_id).then(function (resp) {
        _this3.getDetail();
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleAddToCollection: function handleAddToCollection() {
      var _this4 = this;

      addToCollection(this.detailData.id, this.type).then(function (resp) {
        _this4.getDetail();
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleDeleteFromCollection: function handleDeleteFromCollection() {
      var _this5 = this;

      deleteFromCollection(this.detailData.collection.id).then(function (resp) {
        _this5.getDetail();
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleCollectionClick: function handleCollectionClick() {
      this.collectionStatus ? this.handleDeleteFromCollection() : this.handleAddToCollection();
    },
    getCartNum: function getCartNum() {
      var _this6 = this;

      if (this.profile && this.profile.id) {
        fetchCart(this.type).then(function (resp) {
          _this6.cartNum = resp.data.length;
        }).catch(function (e) {
          return console.log('error', e);
        });
      }
    },
    goToCart: function goToCart() {
      var idx = 0;
      if (this.type === 'news') {
        idx = 0;
      }
      if (this.type === 'woa') {
        idx = 1;
      }
      if (this.type === 'weibo') {
        idx = 2;
      }
      if (this.type === 'live') {
        idx = 3;
      }
      if (this.type === 'video') {
        idx = 4;
      }
      this.$router.push('/cart?tab=' + idx);
    },
    unfoldRelatedArticles: function unfoldRelatedArticles() {
      this.unfold = true;
    },
    openQrcode: function openQrcode() {
      this.$refs.previewer.show(0);
    }
  }),
  mounted: function mounted() {
    var _this7 = this;

    if (this.$route.query.type && this.$route.params.id) {
      this.type = this.$route.query.type;
      this.id = this.$route.params.id;
      this.taxonomyList.map(function (item) {
        if (item.tabType === _this7.type) {
          _this7.taxonomy = item;
        }
      });
    }
    this.getDetail();
    this.getCartNum();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/mediaDetail/index.vue










/* harmony default export */ var pages_mediaDetail = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['taxonomyList'])),
  components: {
    Previewer: vux_src_components_previewer,
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      type: '',
      taxonomy: '',
      id: '',
      detailData: {
        quote: {},
        analysis: {},
        category: {},
        cart: {},
        platform: {}
      },
      collectionStatus: false,
      cartNum: 0,
      relatedArticleData: [],
      unfold: false,
      qrImg: [],
      selectedPrice: 0
    };
  },

  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])({
    setTitleVuex: 'SET_TITLE'
  }), {
    changeNavTitle: function changeNavTitle(navTitle) {
      this.setTitleVuex(navTitle);
      document.title = navTitle;
    },
    getDetail: function getDetail() {
      var _this = this;

      fetchResourceDetail(this.type, this.id).then(function (resp) {
        _this.detailData = extends_default()({}, resp.data, {
          publishRate: formatNumInTenThousand(resp.data.analysis.publish_rate),
          pcBaiduRank: formatNumInTenThousand(resp.data.analysis.pc_baidu_rank),
          mBaiduRank: formatNumInTenThousand(resp.data.analysis.m_baidu_rank),

          avgReadNumTop: formatNumInTenThousand(resp.data.analysis.avg_read_num_top),
          avgReadNumUntop: formatNumInTenThousand(resp.data.analysis.avg_read_num_untop),
          avgLikeNumTop: formatNumInTenThousand(resp.data.analysis.avg_like_num_top),
          avgLikeNumUntop: formatNumInTenThousand(resp.data.analysis.avg_like_num_untop),
          maxReadNum: formatNumInTenThousand(resp.data.analysis.max_read_num),

          avgRetweetNum: formatNumInTenThousand(resp.data.analysis.avg_retweet_num),
          avgLikeNum: formatNumInTenThousand(resp.data.analysis.avg_like_num),
          avgCommentNum: formatNumInTenThousand(resp.data.analysis.avg_comment_num),
          maxRetweetNum: formatNumInTenThousand(resp.data.analysis.max_retweet_num),
          maxLikeNum: formatNumInTenThousand(resp.data.analysis.max_like_num),
          maxCommentNum: formatNumInTenThousand(resp.data.analysis.max_comment_num),

          fansNum: formatNumInTenThousand(resp.data.analysis.fans_num),
          avgAudienceNum: formatNumInTenThousand(resp.data.analysis.avg_audience_num),
          maxAudienceNum: formatNumInTenThousand(resp.data.analysis.max_audience_num),

          avgPlayNum: formatNumInTenThousand(resp.data.analysis.avg_play_num),
          readNum: formatNumInTenThousand(resp.data.analysis.avg_read_num),

          priceValidityEnd: resp.data.quote.price_validity_end ? formatDate(resp.data.quote.price_validity_end) : '',
          price: resp.data.quote.price,
          priceSecond: resp.data.quote.price_second,
          cartStatus: resp.data.cart && resp.data.cart.created_at
        });

        _this.collectionStatus = resp.data.collection && resp.data.collection.created_at;
        _this.changeNavTitle(_this.detailData.name);
        _this.selectedPrice = _this.detailData.price || _this.detailData.priceSecond;
        _this.qrImg = [{
          src: resp.data.qrcode
        }];

        getRelatedArticles(resp.data.account_id, resp.data.taxonomy, 10).then(function (res) {
          _this.relatedArticleData = res.data;
          if (_this.relatedArticleData.length <= 3) {
            _this.unfold = true;
          }
        });
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changePriceStatus: function changePriceStatus(num) {
      if (num === 1) {
        this.selectedPrice = this.detailData.quote.price;
      }
      if (num === 2) {
        this.selectedPrice = this.detailData.quote.price_second;
      }
    },
    handleAddToCart: function handleAddToCart(action) {
      var _this2 = this;

      var top = this.selectedPrice === this.detailData.price ? this.taxonomy.priceType[0] : this.taxonomy.priceType[1];
      addToCart(this.detailData.id, this.type, top).then(function (res) {
        if (action === 'goToCart') {
          _this2.$router.push('/cart');
        } else {
          _this2.getDetail();
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleDeleteFromCart: function handleDeleteFromCart() {
      var _this3 = this;

      deleteFromCart(this.detailData.cart.item_id).then(function (resp) {
        _this3.getDetail();
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleAddToCollection: function handleAddToCollection() {
      var _this4 = this;

      addToCollection(this.detailData.id, this.type).then(function (resp) {
        _this4.getDetail();
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleDeleteFromCollection: function handleDeleteFromCollection() {
      var _this5 = this;

      deleteFromCollection(this.detailData.collection.id).then(function (resp) {
        _this5.getDetail();
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleCollectionClick: function handleCollectionClick() {
      this.collectionStatus ? this.handleDeleteFromCollection() : this.handleAddToCollection();
    },
    getCartNum: function getCartNum() {
      var _this6 = this;

      if (this.profile && this.profile.id) {
        fetchCart(this.type).then(function (resp) {
          _this6.cartNum = resp.data.length;
        }).catch(function (e) {
          return console.log('error', e);
        });
      }
    },
    goToCart: function goToCart() {
      var idx = 0;
      if (this.type === 'news') {
        idx = 0;
      }
      if (this.type === 'woa') {
        idx = 1;
      }
      if (this.type === 'weibo') {
        idx = 2;
      }
      if (this.type === 'live') {
        idx = 3;
      }
      if (this.type === 'video') {
        idx = 4;
      }
      this.$router.push('/cart?tab=' + idx);
    },
    unfoldRelatedArticles: function unfoldRelatedArticles() {
      this.unfold = true;
    },
    openQrcode: function openQrcode() {
      this.$refs.previewer.show(0);
    }
  }),
  mounted: function mounted() {
    var _this7 = this;

    if (this.$route.query.type && this.$route.params.id) {
      this.type = this.$route.query.type;
      this.id = this.$route.params.id;
      this.taxonomyList.map(function (item) {
        if (item.tabType === _this7.type) {
          _this7.taxonomy = item;
        }
      });
    }
    this.getDetail();
    this.getCartNum();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f4ec0aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mediaDetail/index.vue
var mediaDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page-scroll-container"},[_c('div',{staticClass:"page-hd"},[(_vm.type!=='news')?_c('div',{staticClass:"brand"},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.detailData.avatar,"alt":""}}),_vm._v(" "),(_vm.type=='weibo'&&_vm.detailData.verification_type!='')?_c('div',{staticClass:"v-barge"},[_c('i',{staticClass:"iconfont icon-v"})]):_vm._e(),_vm._v(" "),(_vm.detailData.platform&&(_vm.type=='video'||_vm.type=='live'))?_c('img',{staticClass:"platform-icon",attrs:{"src":_vm.detailData.platform.icon,"mode":"aspectFit"}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page__title"},[(_vm.type=='news')?_c('i',{staticClass:"iconfont icon-ruanwen-huoyan",staticStyle:{"color":"#e93f33","vertical-align":"baseline"}}):_vm._e(),_vm._v("\n        "+_vm._s(_vm.detailData.name)+"\n        "),(_vm.type=='woa')?_c('i',{staticClass:"iconfont icon-erweima",on:{"click":_vm.openQrcode}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('previewer',{ref:"previewer",attrs:{"list":_vm.qrImg}})],1)]),_vm._v(" "),_c('div',{staticClass:"page__desc"},[(_vm.type=='news')?_c('div',{staticClass:"w-100"},[_c('p',[_vm._v(_vm._s(_vm.detailData.platform.name))]),_vm._v(" "),_c('p',{staticClass:"label"},[_vm._v("门户")])]):_c('div',{staticClass:"w-100"},[_c('p',[_vm._v(_vm._s(_vm.detailData.fansNum))]),_vm._v(" "),_c('p',{staticClass:"label"},[_vm._v("粉丝")])]),_vm._v(" "),_c('div',{staticClass:"line-h-17"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"w-80"},[_c('p',[_vm._v(_vm._s(_vm.detailData.category?_vm.detailData.category.name:'暂无'))]),_vm._v(" "),_c('p',{staticClass:"label"},[_vm._v("分类")])]),_vm._v(" "),_c('div',{staticClass:"line-h-17"}),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('p',[_vm._v(_vm._s(_vm.detailData.area||'暂无'))]),_vm._v(" "),_c('p',{staticClass:"label"},[_vm._v("地区")])])]),_vm._v(" "),_c('div',{staticClass:"price-and-favorite"},[_c('span',{staticClass:"price"},[_vm._v("\n        ¥ "+_vm._s(_vm.selectedPrice)+"\n      ")]),_vm._v(" "),_c('span',{staticClass:"btn-favorite",class:{'active':_vm.collectionStatus},on:{"click":_vm.handleCollectionClick}},[_c('i',{staticClass:"iconfont",class:{'icon-heartcoloring':_vm.collectionStatus,'icon-hearto':!_vm.collectionStatus}}),_vm._v("\n        收藏\n      ")])]),_vm._v(" "),_c('div',{staticClass:"price-type"},[_c('div',[(_vm.detailData.price)?_c('div',{staticClass:"price-type-item",class:{'active':_vm.selectedPrice === _vm.detailData.price},on:{"click":function($event){_vm.changePriceStatus(1)}}},[_vm._v("\n            "+_vm._s(_vm.taxonomy.priceTypeName&&_vm.taxonomy.priceTypeName[0])+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.detailData.priceSecond)?_c('div',{staticClass:"price-type-item",class:{'active':_vm.selectedPrice === _vm.detailData.priceSecond},on:{"click":function($event){_vm.changePriceStatus(2)}}},[_vm._v("\n            "+_vm._s(_vm.taxonomy.priceTypeName&&_vm.taxonomy.priceTypeName[1])+"\n          ")]):_vm._e()]),_vm._v(" "),(_vm.detailData.priceValidityEnd)?_c('div',{staticStyle:{"padding":"10px 21px"}},[_vm._v("\n          有效期至："+_vm._s(_vm.detailData.priceValidityEnd)+"\n        ")]):_vm._e()]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"page-bd"},[_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-bd resource-info"},[_vm._v("\n          "+_vm._s(_vm.detailData.description||'暂无描述')+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"box"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"box-bd"},[(_vm.type==='news')?_c('div',{staticClass:"reference-data"},[_c('div',{staticClass:"reference-data-item bb0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.publishRate)+"%")]),_vm._v(" "),_c('p',[_vm._v("出稿率")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.pcBaiduRank))]),_vm._v(" "),_c('p',[_vm._v("PC权重")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item br0 bb0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.mBaiduRank))]),_vm._v(" "),_c('p',[_vm._v("WAP权重")])])]):_vm._e(),_vm._v(" "),(_vm.type==='woa')?_c('div',{staticClass:"reference-data"},[_c('div',{staticClass:"reference-data-item"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgReadNumTop))]),_vm._v(" "),_c('p',[_vm._v("头条平均阅读")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgLikeNumTop))]),_vm._v(" "),_c('p',[_vm._v("头条平均点赞")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item br0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgReadNumUntop))]),_vm._v(" "),_c('p',[_vm._v("非头条平均阅读")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgLikeNumUntop))]),_vm._v(" "),_c('p',[_vm._v("非头条平均点赞")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.maxReadNum))]),_vm._v(" "),_c('p',[_vm._v("最高阅读")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0 br0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.maxLikeNum))]),_vm._v(" "),_c('p',[_vm._v("最高点赞")])])]):_vm._e(),_vm._v(" "),(_vm.type==='weibo')?_c('div',{staticClass:"reference-data"},[_c('div',{staticClass:"reference-data-item"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgRetweetNum))]),_vm._v(" "),_c('p',[_vm._v("平均转发")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgLikeNum))]),_vm._v(" "),_c('p',[_vm._v("平均点赞")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item br0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgCommentNum))]),_vm._v(" "),_c('p',[_vm._v("平均评论")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.maxRetweetNum))]),_vm._v(" "),_c('p',[_vm._v("最高转发")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.maxLikeNum))]),_vm._v(" "),_c('p',[_vm._v("最高点赞")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0 br0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.maxCommentNum))]),_vm._v(" "),_c('p',[_vm._v("最高评论")])])]):_vm._e(),_vm._v(" "),(_vm.type==='live')?_c('div',{staticClass:"reference-data"},[_c('div',{staticClass:"reference-data-item bb0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.fansNum))]),_vm._v(" "),_c('p',[_vm._v("粉丝")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgAudienceNum))]),_vm._v(" "),_c('p',[_vm._v("平均观众")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0 br0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.maxAudienceNum))]),_vm._v(" "),_c('p',[_vm._v("最高观众")])])]):_vm._e(),_vm._v(" "),(_vm.type==='video')?_c('div',{staticClass:"reference-data"},[_c('div',{staticClass:"reference-data-item bb0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgLikeNum))]),_vm._v(" "),_c('p',[_vm._v("平均点赞")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgCommentNum))]),_vm._v(" "),_c('p',[_vm._v("平均评论")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0 br0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgPlayNum))]),_vm._v(" "),_c('p',[_vm._v("平均播放")])])]):_vm._e(),_vm._v(" "),(_vm.type==='xhs')?_c('div',{staticClass:"reference-data"},[_c('div',{staticClass:"reference-data-item"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgLikeNum))]),_vm._v(" "),_c('p',[_vm._v("平均获赞")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgRetweetNum))]),_vm._v(" "),_c('p',[_vm._v("平均收藏")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item br0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.avgCommentNum))]),_vm._v(" "),_c('p',[_vm._v("平均评论")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.maxLikeNum))]),_vm._v(" "),_c('p',[_vm._v("最高获赞")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.maxRetweetNum))]),_vm._v(" "),_c('p',[_vm._v("最高收藏")])]),_vm._v(" "),_c('div',{staticClass:"reference-data-item bb0 br0"},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.detailData.maxCommentNum))]),_vm._v(" "),_c('p',[_vm._v("最高评论")])])]):_vm._e()])]),_vm._v(" "),(_vm.type==='news')?_c('div',{staticClass:"box"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"box-bd"},[_c('div',{staticClass:"news-detail"},[_c('div',{staticClass:"news-detail-item"},[_c('span',[_vm._v("新闻源：")]),_vm._v(_vm._s(_vm.detailData.news_source==='1'?'是':'否')+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"news-detail-item"},[_c('span',[_vm._v("入口级别：")]),_vm._v(_vm._s(_vm.detailData.entry_type_text)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"news-detail-item"},[_c('span',[_vm._v("可发媒体：")]),_vm._v(_vm._s(_vm.detailData.special_industry_text)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"news-detail-item"},[_c('span',[_vm._v("链接类型：")]),_vm._v(_vm._s(_vm.detailData.link_type_text)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"news-detail-item"},[_c('span',[_vm._v("发稿速度：")]),_vm._v(_vm._s(_vm.detailData.publish_speed_text)+"\n            ")]),_vm._v(" "),_c('a',{staticClass:"news-detail-item bb0 ",attrs:{"href":this.detailData.url,"target":"_blank"}},[_c('span',[_vm._v("案例链接")]),_c('i',{staticClass:"iconfont icon-youjiantou",staticStyle:{"float":"right"}})])])])]):_vm._e(),_vm._v(" "),(_vm.relatedArticleData.length!==0&&(_vm.type==='woa'||_vm.type==='weibo'))?_c('div',{staticClass:"box"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"box-bd"},[_c('div',{staticClass:"related-articles",class:{'open':_vm.unfold}},_vm._l((_vm.relatedArticleData),function(item,index){return _c('div',{key:index,staticClass:"related-articles-item"},[(_vm.type==='woa')?_c('div',{staticClass:"img-cover"},[_c('img',{attrs:{"src":item.cover}})]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[(_vm.type==='woa')?_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))]):_vm._e(),_vm._v(" "),(_vm.type==='weibo')?_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.content))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"info"},[(item.is_top&&_vm.type==='woa')?_c('span',{staticClass:"is-top"},[_vm._v("头条")]):_vm._e(),_vm._v(" "),(_vm.type==='woa')?_c('span',{staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(item.quote&&item.quote.read_num)+"阅读")]):_vm._e(),_vm._v(" "),(_vm.type==='weibo')?_c('span',{staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(item.quote&&item.quote.comment_num)+"评论")]):_vm._e(),_vm._v(" "),(_vm.type==='weibo')?_c('span',{staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(item.quote&&item.quote.retweet_num)+"转发")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.quote&&item.quote.like_num)+"点赞")])])])])})),_vm._v(" "),(!_vm.unfold)?_c('div',{staticClass:"unfold-see-more",on:{"click":_vm.unfoldRelatedArticles}},[_vm._v("展开查看更多")]):_vm._e()])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"detail-tab-bar"},[_c('div',{staticClass:"cart-action"},[(!_vm.detailData.cartStatus)?_c('div',{staticClass:"add-to-cart",on:{"click":function($event){_vm.handleAddToCart()}}},[_c('i',{staticClass:"iconfont icon-tianjiadaoxuanhaoche"}),_vm._v("\n        加入选号车\n      ")]):_c('div',{staticClass:"add-to-cart active",on:{"click":function($event){_vm.handleDeleteFromCart()}}},[_vm._v("\n        已加入选号车\n      ")])]),_vm._v(" "),_c('div',{staticClass:"weui-flex__item add-pay",on:{"click":function($event){_vm.handleAddToCart('goToCart')}}},[_vm._v("\n      立刻投放\n    ")])]),_vm._v(" "),_c('div',{staticClass:"cart-btn",on:{"click":_vm.goToCart}},[_c('i',{staticClass:"iconfont icon-gouwuche-xuanfu"}),_vm._v(" "),_c('div',{staticClass:"cart-num"},[_vm._v(_vm._s(_vm.cartNum))])])])}
var mediaDetail_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advantage"},[_c('span',[_c('i',{staticClass:"iconfont icon-checkcircleoutline",staticStyle:{"color":"#E61F42"}}),_vm._v("\n          担保交易\n      ")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"iconfont icon-checkcircleoutline",staticStyle:{"color":"#E61F42"}}),_vm._v("\n          极速确认\n      ")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"iconfont icon-checkcircleoutline",staticStyle:{"color":"#E61F42"}}),_vm._v("\n          一对一服务\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-hd"},[_c('div',{staticClass:"block-2-15"}),_vm._v("\n          资源介绍\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-hd"},[_c('div',{staticClass:"block-2-15"}),_vm._v("\n          媒体数据参考\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-hd"},[_c('div',{staticClass:"block-2-15"}),_vm._v("\n          详细信息\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-hd"},[_c('div',{staticClass:"block-2-15"}),_vm._v("\n          相关文章\n        ")])}]
var mediaDetail_esExports = { render: mediaDetail_render, staticRenderFns: mediaDetail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_mediaDetail = (mediaDetail_esExports);
// CONCATENATED MODULE: ./src/pages/mediaDetail/index.vue
function mediaDetail_injectStyle (ssrContext) {
  __webpack_require__("X+PL")
}
var mediaDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var mediaDetail___vue_template_functional__ = false
/* styles */
var mediaDetail___vue_styles__ = mediaDetail_injectStyle
/* scopeId */
var mediaDetail___vue_scopeId__ = "data-v-7f4ec0aa"
/* moduleIdentifier (server only) */
var mediaDetail___vue_module_identifier__ = null
var mediaDetail_Component = mediaDetail_normalizeComponent(
  pages_mediaDetail,
  selectortype_template_index_0_src_pages_mediaDetail,
  mediaDetail___vue_template_functional__,
  mediaDetail___vue_styles__,
  mediaDetail___vue_scopeId__,
  mediaDetail___vue_module_identifier__
)

/* harmony default export */ var src_pages_mediaDetail = (mediaDetail_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-checkbox-radio/dist/index.js
var dist = __webpack_require__("nnYD");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout.vue
//
//
//
//
//
//

/* harmony default export */ var swipeout = ({
  name: 'swipeout'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout.vue
//
//
//
//
//
//

/* harmony default export */ var swipeout_swipeout = ({
  name: 'swipeout'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c00178","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swipeout/swipeout.vue
var swipeout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swipeout"},[_vm._t("default")],2)}
var swipeout_staticRenderFns = []
var swipeout_esExports = { render: swipeout_render, staticRenderFns: swipeout_staticRenderFns }
/* harmony default export */ var components_swipeout_swipeout = (swipeout_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swipeout/swipeout.vue
function swipeout_injectStyle (ssrContext) {
  __webpack_require__("UuM9")
}
var swipeout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swipeout___vue_template_functional__ = false
/* styles */
var swipeout___vue_styles__ = swipeout_injectStyle
/* scopeId */
var swipeout___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swipeout___vue_module_identifier__ = null
var swipeout_Component = swipeout_normalizeComponent(
  swipeout_swipeout,
  components_swipeout_swipeout,
  swipeout___vue_template_functional__,
  swipeout___vue_styles__,
  swipeout___vue_scopeId__,
  swipeout___vue_module_identifier__
)

/* harmony default export */ var src_components_swipeout_swipeout = (swipeout_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout-item.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var swipeout_item = ({
  name: 'swipeout-item',
  props: {
    sensitivity: {
      type: Number,
      default: 0
    },
    autoCloseOnButtonClick: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    threshold: {
      type: Number,
      default: 0.3
    },
    underlayColor: String,
    transitionMode: {
      type: String,
      default: 'reveal'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },

  methods: {
    render: function render() {
      this.target = this.$refs.content;
      if (this.$slots['left-menu']) {
        this.hasLeftMenu = true;
        this.caculateMenuWidth('left');
      }
      if (this.$slots['right-menu']) {
        this.hasRightMenu = true;
        this.caculateMenuWidth('right');
      }
    },
    caculateMenuWidth: function caculateMenuWidth(direction) {
      var list = this.$slots[direction + '-menu'][0].children.filter(function (one) {
        return one.tag;
      });
      var width = 0;
      list.forEach(function (one) {
        var propsData = one.componentOptions ? one.componentOptions.propsData : {};
        width += propsData.width || 80;
      });
      this[direction + 'MenuWidth'] = width;
    },
    onContentClick: function onContentClick() {
      if (this.styles.transform.indexOf('(0px, 0, 0)') === -1) {
        this._setClose(200);
      }
    },
    onItemClick: function onItemClick() {
      if (this.autoCloseOnButtonClick) {
        this._setClose();
      }
    },
    start: function start(ev) {
      if (this.disabled || this.isOpen || ev.target.nodeName.toLowerCase() === 'button') {
        return;
      }
      if (this.$parent.$options._componentTag === 'swipeout') {
        var openItems = this.$parent.$children.filter(function (item) {
          return item.$data.styles.transform.indexOf('(0px, 0, 0)') === -1;
        });
        if (openItems.length > 0) {
          openItems.forEach(function (item) {
            item.setOffset(0, true);
          });
          ev.preventDefault();
          return;
        }
      }
      var touch = ev.touches ? ev.touches[0] : ev;
      this.pageX = touch.pageX;
      this.pageY = touch.pageY;
    },
    move: function move(ev) {
      if (this.disabled) {
        return;
      }
      if (ev.target.nodeName.toLowerCase() === 'button') {
        ev.preventDefault();
        return;
      }
      if (this.pageX === undefined) {
        ev.preventDefault();
        return;
      }

      var touch = ev.touches ? ev.touches[0] : ev;
      this.distX = touch.pageX - this.pageX;
      this.distY = touch.pageY - this.pageY;

      if (!this.direction) {
        this.direction = this.distX > 0 ? 'left' : 'right';
      }

      if (this.direction === 'right' && this.distX > 0 && this.hasRightMenu || this.direction === 'left' && this.distX < 0 && this.hasLeftMenu) {
        this.valid = true;
        ev.preventDefault();
      }

      if (this.valid === undefined) {
        if (this.distX > 0 && this.hasLeftMenu === false) {
          this.valid = false;
        } else if (this.distX < 0 && this.hasRightMenu === false) {
          this.valid = false;
        } else if (Math.abs(this.distX) > this.sensitivity || Math.abs(this.distY) > this.sensitivity) {
          this.valid = Math.abs(this.distX) > Math.abs(this.distY);
        } else {
          ev.preventDefault();
        }
      }

      if (this.valid === true) {
        if (Math.abs(this.distX) <= this.menuWidth) {
          this.setOffset(this.distX, false);
        } else {
          var extra = (Math.abs(this.distX) - this.menuWidth) * 0.5;
          var offset = (this.menuWidth + extra) * (this.distX < 0 ? -1 : 1);
          this.setOffset(offset, false);
        }
        ev.preventDefault();
      }
    },
    end: function end(ev) {
      if (this.disabled) {
        return;
      }
      if (ev.target.nodeName.toLowerCase() === 'button') {
        return;
      }
      if (this.valid === true) {
        if (this.distX < 0 && this.direction === 'right') {
          var threshold = this.threshold <= 1 ? this.rightMenuWidth * this.threshold : this.threshold;

          if (this.distX < -threshold) {
            this.setOffset(-this.rightMenuWidth, true);
            this.$emit('on-open');
            this.isOpen = true;
          } else {
            this._setClose();
          }
        } else if (this.distX > 0 && this.direction === 'left') {
          var _threshold = this.threshold <= 1 ? this.leftMenuWidth * this.threshold : this.threshold;

          if (this.distX > _threshold) {
            this.setOffset(this.leftMenuWidth, true);
            this.$emit('on-open');
            this.isOpen = true;
          } else {
            this._setClose();
          }
        }
      } else if (this.pageX !== undefined) {}

      this.pageX = this.pageY = this.valid = undefined;
      this.direction = '';
    },
    setOffset: function setOffset(x) {
      var _this2 = this;

      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var force = arguments[2];

      this.isAnimated = animated;
      if (this.disabled && !force) {
        return;
      }
      if (this.direction === 'right' && x > 0 || this.direction === 'left' && x < 0) {
        x = 0;
      }

      if (x === 0) {
        setTimeout(function () {
          _this2.isOpen = false;
        }, 300);
      }

      if (x < 0 && Math.abs(x) === this.rightMenuWidth) {
        this.distX = -this.rightMenuWidth;
      } else if (x > 0 && Math.abs(x) === this.leftMenuWidth) {
        this.distX = this.leftMenuWidth;
      }
      if (animated && this.target) {
        this.target && this.target.classList.add('vux-swipeout-content-animated');
        var cb = function (self, target) {
          return function () {
            target.classList.remove('vux-swipeout-content-animated');
            self.isAnimated = false;
            target.removeEventListener('webkitTransitionEnd', cb);
            target.removeEventListener('transitionend', cb);
          };
        }(this, this.target);

        this.target.addEventListener('webkitTransitionEnd', cb);
        this.target.addEventListener('transitionend', cb);
      }
      this.styles.transform = 'translate3d(' + x + 'px, 0, 0)';
    },
    _setClose: function _setClose() {
      var _this3 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.setOffset(0, true);
      this.$emit('on-close');
      if (!delay) {
        this.isOpen = false;
      } else {
        setTimeout(function () {
          _this3.isOpen = false;
        }, delay);
      }
      this.distX = 0;
    },
    open: function open() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';

      this.setOffset(position === 'right' ? -this.rightMenuWidth : this.leftMenuWidth, true, true);
    },
    close: function close() {
      this.setOffset(0, true, true);
    }
  },
  computed: {
    menuWidth: function menuWidth() {
      if (!this.hasLeftMenu && this.hasRightMenu) {
        return this.rightMenuWidth;
      }
      if (this.hasLeftMenu && !this.hasRightMenu) {
        return this.leftMenuWidth;
      }
      if (this.hasLeftMenu && this.hasRightMenu) {
        return this.distX < 0 ? this.rightMenuWidth : this.leftMenuWidth;
      }
    },
    buttonBoxStyle: function buttonBoxStyle() {
      return {
        backgroundColor: this.underlayColor
      };
    },
    leftButtonBoxStyle: function leftButtonBoxStyle() {
      var styles = JSON.parse(stringify_default()(this.buttonBoxStyle));
      if (this.transitionMode === 'follow') {
        var offset = this.styles.transform.indexOf('(0px, 0, 0)') === -1 ? this.leftMenuWidth - this.distX : this.leftMenuWidth;
        styles.transform = 'translate3d(-' + offset + 'px, 0, 0)';
      }
      return styles;
    },
    rightButtonBoxStyle: function rightButtonBoxStyle() {
      var styles = JSON.parse(stringify_default()(this.buttonBoxStyle));
      if (this.transitionMode === 'follow') {
        var offset = this.styles.transform.indexOf('(0px, 0, 0)') === -1 ? this.rightMenuWidth - Math.abs(this.distX) : this.rightMenuWidth;
        if (offset < 0) {
          offset = 0;
        }
        if (this.isAnimated) {
          styles.transition = 'transform 0.2s';
        }
        styles.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }
      return styles;
    }
  },
  data: function data() {
    return {
      pageX: undefined,
      pageY: undefined,
      distX: 0,
      distY: 0,
      hasLeftMenu: false,
      hasRightMenu: false,
      animated: false,
      isAnimated: false,
      isOpen: false,
      styles: {
        transform: 'translate3d(0px, 0, 0)'
      },
      direction: '',
      leftMenuWidth: 160,
      rightMenuWidth: 160
    };
  },

  watch: {
    disabled: function disabled(newVal, oldVal) {
      if (newVal === true && !oldVal) {
        this.setOffset(0, true, true);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout-item.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var swipeout_swipeout_item = ({
  name: 'swipeout-item',
  props: {
    sensitivity: {
      type: Number,
      default: 0
    },
    autoCloseOnButtonClick: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    threshold: {
      type: Number,
      default: 0.3
    },
    underlayColor: String,
    transitionMode: {
      type: String,
      default: 'reveal'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },

  methods: {
    render: function render() {
      this.target = this.$refs.content;
      if (this.$slots['left-menu']) {
        this.hasLeftMenu = true;
        this.caculateMenuWidth('left');
      }
      if (this.$slots['right-menu']) {
        this.hasRightMenu = true;
        this.caculateMenuWidth('right');
      }
    },
    caculateMenuWidth: function caculateMenuWidth(direction) {
      var list = this.$slots[direction + '-menu'][0].children.filter(function (one) {
        return one.tag;
      });
      var width = 0;
      list.forEach(function (one) {
        var propsData = one.componentOptions ? one.componentOptions.propsData : {};
        width += propsData.width || 80;
      });
      this[direction + 'MenuWidth'] = width;
    },
    onContentClick: function onContentClick() {
      if (this.styles.transform.indexOf('(0px, 0, 0)') === -1) {
        this._setClose(200);
      }
    },
    onItemClick: function onItemClick() {
      if (this.autoCloseOnButtonClick) {
        this._setClose();
      }
    },
    start: function start(ev) {
      if (this.disabled || this.isOpen || ev.target.nodeName.toLowerCase() === 'button') {
        return;
      }
      if (this.$parent.$options._componentTag === 'swipeout') {
        var openItems = this.$parent.$children.filter(function (item) {
          return item.$data.styles.transform.indexOf('(0px, 0, 0)') === -1;
        });
        if (openItems.length > 0) {
          openItems.forEach(function (item) {
            item.setOffset(0, true);
          });
          ev.preventDefault();
          return;
        }
      }
      var touch = ev.touches ? ev.touches[0] : ev;
      this.pageX = touch.pageX;
      this.pageY = touch.pageY;
    },
    move: function move(ev) {
      if (this.disabled) {
        return;
      }
      if (ev.target.nodeName.toLowerCase() === 'button') {
        ev.preventDefault();
        return;
      }
      if (this.pageX === undefined) {
        ev.preventDefault();
        return;
      }

      var touch = ev.touches ? ev.touches[0] : ev;
      this.distX = touch.pageX - this.pageX;
      this.distY = touch.pageY - this.pageY;

      if (!this.direction) {
        this.direction = this.distX > 0 ? 'left' : 'right';
      }

      if (this.direction === 'right' && this.distX > 0 && this.hasRightMenu || this.direction === 'left' && this.distX < 0 && this.hasLeftMenu) {
        this.valid = true;
        ev.preventDefault();
      }

      if (this.valid === undefined) {
        if (this.distX > 0 && this.hasLeftMenu === false) {
          this.valid = false;
        } else if (this.distX < 0 && this.hasRightMenu === false) {
          this.valid = false;
        } else if (Math.abs(this.distX) > this.sensitivity || Math.abs(this.distY) > this.sensitivity) {
          this.valid = Math.abs(this.distX) > Math.abs(this.distY);
        } else {
          ev.preventDefault();
        }
      }

      if (this.valid === true) {
        if (Math.abs(this.distX) <= this.menuWidth) {
          this.setOffset(this.distX, false);
        } else {
          var extra = (Math.abs(this.distX) - this.menuWidth) * 0.5;
          var offset = (this.menuWidth + extra) * (this.distX < 0 ? -1 : 1);
          this.setOffset(offset, false);
        }
        ev.preventDefault();
      }
    },
    end: function end(ev) {
      if (this.disabled) {
        return;
      }
      if (ev.target.nodeName.toLowerCase() === 'button') {
        return;
      }
      if (this.valid === true) {
        if (this.distX < 0 && this.direction === 'right') {
          var threshold = this.threshold <= 1 ? this.rightMenuWidth * this.threshold : this.threshold;

          if (this.distX < -threshold) {
            this.setOffset(-this.rightMenuWidth, true);
            this.$emit('on-open');
            this.isOpen = true;
          } else {
            this._setClose();
          }
        } else if (this.distX > 0 && this.direction === 'left') {
          var _threshold = this.threshold <= 1 ? this.leftMenuWidth * this.threshold : this.threshold;

          if (this.distX > _threshold) {
            this.setOffset(this.leftMenuWidth, true);
            this.$emit('on-open');
            this.isOpen = true;
          } else {
            this._setClose();
          }
        }
      } else if (this.pageX !== undefined) {}

      this.pageX = this.pageY = this.valid = undefined;
      this.direction = '';
    },
    setOffset: function setOffset(x) {
      var _this2 = this;

      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var force = arguments[2];

      this.isAnimated = animated;
      if (this.disabled && !force) {
        return;
      }
      if (this.direction === 'right' && x > 0 || this.direction === 'left' && x < 0) {
        x = 0;
      }

      if (x === 0) {
        setTimeout(function () {
          _this2.isOpen = false;
        }, 300);
      }

      if (x < 0 && Math.abs(x) === this.rightMenuWidth) {
        this.distX = -this.rightMenuWidth;
      } else if (x > 0 && Math.abs(x) === this.leftMenuWidth) {
        this.distX = this.leftMenuWidth;
      }
      if (animated && this.target) {
        this.target && this.target.classList.add('vux-swipeout-content-animated');
        var cb = function (self, target) {
          return function () {
            target.classList.remove('vux-swipeout-content-animated');
            self.isAnimated = false;
            target.removeEventListener('webkitTransitionEnd', cb);
            target.removeEventListener('transitionend', cb);
          };
        }(this, this.target);

        this.target.addEventListener('webkitTransitionEnd', cb);
        this.target.addEventListener('transitionend', cb);
      }
      this.styles.transform = 'translate3d(' + x + 'px, 0, 0)';
    },
    _setClose: function _setClose() {
      var _this3 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.setOffset(0, true);
      this.$emit('on-close');
      if (!delay) {
        this.isOpen = false;
      } else {
        setTimeout(function () {
          _this3.isOpen = false;
        }, delay);
      }
      this.distX = 0;
    },
    open: function open() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';

      this.setOffset(position === 'right' ? -this.rightMenuWidth : this.leftMenuWidth, true, true);
    },
    close: function close() {
      this.setOffset(0, true, true);
    }
  },
  computed: {
    menuWidth: function menuWidth() {
      if (!this.hasLeftMenu && this.hasRightMenu) {
        return this.rightMenuWidth;
      }
      if (this.hasLeftMenu && !this.hasRightMenu) {
        return this.leftMenuWidth;
      }
      if (this.hasLeftMenu && this.hasRightMenu) {
        return this.distX < 0 ? this.rightMenuWidth : this.leftMenuWidth;
      }
    },
    buttonBoxStyle: function buttonBoxStyle() {
      return {
        backgroundColor: this.underlayColor
      };
    },
    leftButtonBoxStyle: function leftButtonBoxStyle() {
      var styles = JSON.parse(stringify_default()(this.buttonBoxStyle));
      if (this.transitionMode === 'follow') {
        var offset = this.styles.transform.indexOf('(0px, 0, 0)') === -1 ? this.leftMenuWidth - this.distX : this.leftMenuWidth;
        styles.transform = 'translate3d(-' + offset + 'px, 0, 0)';
      }
      return styles;
    },
    rightButtonBoxStyle: function rightButtonBoxStyle() {
      var styles = JSON.parse(stringify_default()(this.buttonBoxStyle));
      if (this.transitionMode === 'follow') {
        var offset = this.styles.transform.indexOf('(0px, 0, 0)') === -1 ? this.rightMenuWidth - Math.abs(this.distX) : this.rightMenuWidth;
        if (offset < 0) {
          offset = 0;
        }
        if (this.isAnimated) {
          styles.transition = 'transform 0.2s';
        }
        styles.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }
      return styles;
    }
  },
  data: function data() {
    return {
      pageX: undefined,
      pageY: undefined,
      distX: 0,
      distY: 0,
      hasLeftMenu: false,
      hasRightMenu: false,
      animated: false,
      isAnimated: false,
      isOpen: false,
      styles: {
        transform: 'translate3d(0px, 0, 0)'
      },
      direction: '',
      leftMenuWidth: 160,
      rightMenuWidth: 160
    };
  },

  watch: {
    disabled: function disabled(newVal, oldVal) {
      if (newVal === true && !oldVal) {
        this.setOffset(0, true, true);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3693486","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swipeout/swipeout-item.vue
var swipeout_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swipeout-item",on:{"touchstart":_vm.start,"mousedown":_vm.start,"touchmove":_vm.move,"mousemove":_vm.move,"touchend":_vm.end,"mouseup":_vm.end,"touchcancel":_vm.end}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.distX >= 0),expression:"distX >= 0"}],staticClass:"vux-swipeout-button-box vux-swipeout-button-box-left",style:(_vm.leftButtonBoxStyle)},[_vm._t("left-menu")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.distX <= 0),expression:"distX <= 0"}],staticClass:"vux-swipeout-button-box",style:(_vm.rightButtonBoxStyle)},[_vm._t("right-menu")],2),_vm._v(" "),_c('div',{ref:"content",staticClass:"vux-swipeout-content",style:(_vm.styles),on:{"mousedown":_vm.onContentClick,"touchstart":_vm.onContentClick}},[_vm._t("content")],2)])}
var swipeout_item_staticRenderFns = []
var swipeout_item_esExports = { render: swipeout_item_render, staticRenderFns: swipeout_item_staticRenderFns }
/* harmony default export */ var components_swipeout_swipeout_item = (swipeout_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swipeout/swipeout-item.vue
var swipeout_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swipeout_item___vue_template_functional__ = false
/* styles */
var swipeout_item___vue_styles__ = null
/* scopeId */
var swipeout_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swipeout_item___vue_module_identifier__ = null
var swipeout_item_Component = swipeout_item_normalizeComponent(
  swipeout_swipeout_item,
  components_swipeout_swipeout_item,
  swipeout_item___vue_template_functional__,
  swipeout_item___vue_styles__,
  swipeout_item___vue_scopeId__,
  swipeout_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swipeout_swipeout_item = (swipeout_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout-button.vue
//
//
//
//
//
//
//

/* harmony default export */ var swipeout_button = ({
  name: 'swipeout-button',
  props: {
    text: String,
    backgroundColor: String,
    type: String,
    width: {
      type: Number,
      default: 80
    }
  },
  methods: {
    onButtonClick: function onButtonClick() {
      if (this.$parent.$options._componentTag === 'swipeout-item') {
        this.$parent.onItemClick(this.text);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout-button.vue
//
//
//
//
//
//
//

/* harmony default export */ var swipeout_swipeout_button = ({
  name: 'swipeout-button',
  props: {
    text: String,
    backgroundColor: String,
    type: String,
    width: {
      type: Number,
      default: 80
    }
  },
  methods: {
    onButtonClick: function onButtonClick() {
      if (this.$parent.$options._componentTag === 'swipeout-item') {
        this.$parent.onItemClick(this.text);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a60440d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swipeout/swipeout-button.vue
var swipeout_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vux-swipeout-button",class:{'vux-swipeout-button-primary': _vm.type === 'primary', 'vux-swipeout-button-warn': _vm.type === 'warn', 'vux-swipeout-button-default': _vm.type === 'default'},style:({width: (_vm.width + "px"), backgroundColor: _vm.backgroundColor}),attrs:{"type":"button"},on:{"click":_vm.onButtonClick}},[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var swipeout_button_staticRenderFns = []
var swipeout_button_esExports = { render: swipeout_button_render, staticRenderFns: swipeout_button_staticRenderFns }
/* harmony default export */ var components_swipeout_swipeout_button = (swipeout_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swipeout/swipeout-button.vue
var swipeout_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swipeout_button___vue_template_functional__ = false
/* styles */
var swipeout_button___vue_styles__ = null
/* scopeId */
var swipeout_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swipeout_button___vue_module_identifier__ = null
var swipeout_button_Component = swipeout_button_normalizeComponent(
  swipeout_swipeout_button,
  components_swipeout_swipeout_button,
  swipeout_button___vue_template_functional__,
  swipeout_button___vue_styles__,
  swipeout_button___vue_scopeId__,
  swipeout_button___vue_module_identifier__
)

/* harmony default export */ var src_components_swipeout_swipeout_button = (swipeout_button_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13ee6e34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var icon_staticRenderFns = []
var icon_esExports = { render: icon_render, staticRenderFns: icon_staticRenderFns }
/* harmony default export */ var src_components_icon = (icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function icon_injectStyle (ssrContext) {
  __webpack_require__("zvuZ")
}
var icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var icon___vue_template_functional__ = false
/* styles */
var icon___vue_styles__ = icon_injectStyle
/* scopeId */
var icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var icon___vue_module_identifier__ = null
var icon_Component = icon_normalizeComponent(
  components_icon,
  src_components_icon,
  icon___vue_template_functional__,
  icon___vue_styles__,
  icon___vue_scopeId__,
  icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = (icon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var check_icon = ({
  name: 'check-icon',
  components: {
    Icon: vux_src_components_icon
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_check_icon = ({
  name: 'check-icon',
  components: {
    Icon: vux_src_components_icon
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e492186","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/check-icon/index.vue
var check_icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-check-icon",on:{"click":_vm.updateValue}},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'default' && _vm.value),expression:"type === 'default' && value"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'plain' && _vm.value),expression:"type === 'plain' && value"}],attrs:{"type":"success_circle"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.value),expression:"!value"}],attrs:{"type":"circle"}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)}
var check_icon_staticRenderFns = []
var check_icon_esExports = { render: check_icon_render, staticRenderFns: check_icon_staticRenderFns }
/* harmony default export */ var src_components_check_icon = (check_icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/check-icon/index.vue
function check_icon_injectStyle (ssrContext) {
  __webpack_require__("fBOH")
}
var check_icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var check_icon___vue_template_functional__ = false
/* styles */
var check_icon___vue_styles__ = check_icon_injectStyle
/* scopeId */
var check_icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var check_icon___vue_module_identifier__ = null
var check_icon_Component = check_icon_normalizeComponent(
  components_check_icon,
  src_components_check_icon,
  check_icon___vue_template_functional__,
  check_icon___vue_styles__,
  check_icon___vue_scopeId__,
  check_icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_check_icon = (check_icon_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/sticky/sticky.js
var sticky = __webpack_require__("58JO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/sticky/index.vue
//
//
//
//
//
//



/* harmony default export */ var components_sticky = ({
  name: 'sticky',
  data: function data() {
    return {
      initTimes: 0
    };
  },
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.bindSticky);
  },
  activated: function activated() {
    if (this.initTimes > 0) {
      this.bindSticky();
    }
    this.initTimes++;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.bindSticky();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.bindSticky);
  },

  methods: {
    bindSticky: function bindSticky() {
      var _this2 = this;

      if (this.disabled) {
        return;
      }
      this.$nextTick(function () {
        Object(sticky["a" /* default */])(_this2.$el, {
          scrollBox: _this2.scrollBox,
          offset: _this2.offset,
          checkStickySupport: typeof _this2.checkStickySupport === 'undefined' ? true : _this2.checkStickySupport
        });
      });
    }
  },
  props: ['scrollBox', 'offset', 'checkStickySupport', 'disabled']
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/sticky/index.vue
//
//
//
//
//
//



/* harmony default export */ var src_components_sticky = ({
  name: 'sticky',
  data: function data() {
    return {
      initTimes: 0
    };
  },
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.bindSticky);
  },
  activated: function activated() {
    if (this.initTimes > 0) {
      this.bindSticky();
    }
    this.initTimes++;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.bindSticky();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.bindSticky);
  },

  methods: {
    bindSticky: function bindSticky() {
      var _this2 = this;

      if (this.disabled) {
        return;
      }
      this.$nextTick(function () {
        Object(sticky["a" /* default */])(_this2.$el, {
          scrollBox: _this2.scrollBox,
          offset: _this2.offset,
          checkStickySupport: typeof _this2.checkStickySupport === 'undefined' ? true : _this2.checkStickySupport
        });
      });
    }
  },
  props: ['scrollBox', 'offset', 'checkStickySupport', 'disabled']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-166dec05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/sticky/index.vue
var sticky_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-sticky-box"},[_vm._t("default")],2)}
var sticky_staticRenderFns = []
var sticky_esExports = { render: sticky_render, staticRenderFns: sticky_staticRenderFns }
/* harmony default export */ var vux_src_components_sticky = (sticky_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/sticky/index.vue
function sticky_injectStyle (ssrContext) {
  __webpack_require__("QcHK")
}
var sticky_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sticky___vue_template_functional__ = false
/* styles */
var sticky___vue_styles__ = sticky_injectStyle
/* scopeId */
var sticky___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sticky___vue_module_identifier__ = null
var sticky_Component = sticky_normalizeComponent(
  src_components_sticky,
  vux_src_components_sticky,
  sticky___vue_template_functional__,
  sticky___vue_styles__,
  sticky___vue_scopeId__,
  sticky___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_sticky = (sticky_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/cart/index.vue















/* harmony default export */ var cart = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['taxonomyList', 'profile'])),
  data: function data() {
    return {
      activeIndex: 0,
      totalPrice: 0,
      chargePrice: 0,
      cartData: [],
      selectAll: true,
      selelctAllValue: 'all',
      touchModel: {
        startX: 0,
        moveX: 0,
        endX: 0,
        disX: 0,
        currentIdx: 0
      },
      orderNumber: 0,
      iconLink: ''
    };
  },

  components: {
    Checkbox: dist["Checkbox"],
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swipeout: src_components_swipeout_swipeout,
    SwipeoutItem: src_components_swipeout_swipeout_item,
    SwipeoutButton: src_components_swipeout_swipeout_button,
    CheckIcon: vux_src_components_check_icon,
    Sticky: node_modules_vux_src_components_sticky
  },
  methods: {
    tabClick: function tabClick(idx) {
      this.$router.push('/cart?tab=' + idx);
      this.activeIndex = idx;
      this.getData();
    },
    getTabStatus: function getTabStatus() {

      if (this.$route.query.tab) {
        this.activeIndex = parseInt(this.$route.query.tab);
        this.getData();
      } else {
        this.getData();
      }
    },
    mathTotalPrice: function mathTotalPrice() {
      var totalPrice = 0;
      var chargeRatio = this.profile.price_level.service_rate;
      this.cartData.map(function (item) {
        if (item.checked) {
          totalPrice = totalPrice + parseInt(item.price);
        }
      });
      this.chargePrice = (totalPrice * chargeRatio).toFixed(2);
      this.totalPrice = (totalPrice * (1 + chargeRatio)).toFixed(2);
    },
    checkboxChange: function checkboxChange(idx) {
      this.cartData[idx].checked = !this.cartData[idx].checked;
      this.mathTotalPrice();
    },
    checkboxAllChange: function checkboxAllChange() {
      var checkboxItems = this.cartData;
      if (this.selectAll === true) {
        this.selectAll = false;
        for (var i = 0, lenI = checkboxItems.length; i < lenI; ++i) {
          checkboxItems[i].checked = false;
        }
      } else {
        this.selectAll = true;
        for (var _i = 0, _lenI = checkboxItems.length; _i < _lenI; ++_i) {
          checkboxItems[_i].checked = true;
        }
      }
      this.cartData = checkboxItems;
      this.mathTotalPrice();
    },
    getData: function getData() {
      var _this = this;

      this.cartData = [];
      fetchCart(this.taxonomyList[this.activeIndex].tabType).then(function (resp) {
        _this.orderNumber = resp.data.length;
        _this.cartData = resp.data.map(function (data) {
          var price = parseFloat(data.price);
          return extends_default()({}, data, {
            price: price,
            checked: true
          });
        });
        _this.mathTotalPrice();
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleCreateOrder: function handleCreateOrder() {
      var _this2 = this;

      var cartIdsArray = [];
      this.cartData.map(function (item) {
        if (item.checked) {
          cartIdsArray.push(item.item_id);
        }
      });
      var cartIds = cartIdsArray.join();
      createOrder(cartIds, this.taxonomyList[this.activeIndex].tabType).then(function (resp) {
        _this2.$router.push('/order');
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleCleanCart: function handleCleanCart() {
      var _this3 = this;

      var cartIds = this.cartData.map(function (item) {
        return item.item_id;
      }).join();
      console.log(cartIds);
      deleteFromCart(cartIds).then(function (resp) {
        _this3.getData();
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleRemoveFromCart: function handleRemoveFromCart(id) {
      var _this4 = this;

      deleteFromCart(id).then(function (resp) {
        _this4.getData();
      }).catch(function (e) {
        return console.log('error', e);
      });
    }
  },
  mounted: function mounted() {
    this.getTabStatus();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/cart/index.vue















/* harmony default export */ var pages_cart = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['taxonomyList', 'profile'])),
  data: function data() {
    return {
      activeIndex: 0,
      totalPrice: 0,
      chargePrice: 0,
      cartData: [],
      selectAll: true,
      selelctAllValue: 'all',
      touchModel: {
        startX: 0,
        moveX: 0,
        endX: 0,
        disX: 0,
        currentIdx: 0
      },
      orderNumber: 0,
      iconLink: ''
    };
  },

  components: {
    Checkbox: dist["Checkbox"],
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swipeout: src_components_swipeout_swipeout,
    SwipeoutItem: src_components_swipeout_swipeout_item,
    SwipeoutButton: src_components_swipeout_swipeout_button,
    CheckIcon: vux_src_components_check_icon,
    Sticky: node_modules_vux_src_components_sticky
  },
  methods: {
    tabClick: function tabClick(idx) {
      this.$router.push('/cart?tab=' + idx);
      this.activeIndex = idx;
      this.getData();
    },
    getTabStatus: function getTabStatus() {

      if (this.$route.query.tab) {
        this.activeIndex = parseInt(this.$route.query.tab);
        this.getData();
      } else {
        this.getData();
      }
    },
    mathTotalPrice: function mathTotalPrice() {
      var totalPrice = 0;
      var chargeRatio = this.profile.price_level.service_rate;
      this.cartData.map(function (item) {
        if (item.checked) {
          totalPrice = totalPrice + parseInt(item.price);
        }
      });
      this.chargePrice = (totalPrice * chargeRatio).toFixed(2);
      this.totalPrice = (totalPrice * (1 + chargeRatio)).toFixed(2);
    },
    checkboxChange: function checkboxChange(idx) {
      this.cartData[idx].checked = !this.cartData[idx].checked;
      this.mathTotalPrice();
    },
    checkboxAllChange: function checkboxAllChange() {
      var checkboxItems = this.cartData;
      if (this.selectAll === true) {
        this.selectAll = false;
        for (var i = 0, lenI = checkboxItems.length; i < lenI; ++i) {
          checkboxItems[i].checked = false;
        }
      } else {
        this.selectAll = true;
        for (var _i = 0, _lenI = checkboxItems.length; _i < _lenI; ++_i) {
          checkboxItems[_i].checked = true;
        }
      }
      this.cartData = checkboxItems;
      this.mathTotalPrice();
    },
    getData: function getData() {
      var _this = this;

      this.cartData = [];
      fetchCart(this.taxonomyList[this.activeIndex].tabType).then(function (resp) {
        _this.orderNumber = resp.data.length;
        _this.cartData = resp.data.map(function (data) {
          var price = parseFloat(data.price);
          return extends_default()({}, data, {
            price: price,
            checked: true
          });
        });
        _this.mathTotalPrice();
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleCreateOrder: function handleCreateOrder() {
      var _this2 = this;

      var cartIdsArray = [];
      this.cartData.map(function (item) {
        if (item.checked) {
          cartIdsArray.push(item.item_id);
        }
      });
      var cartIds = cartIdsArray.join();
      createOrder(cartIds, this.taxonomyList[this.activeIndex].tabType).then(function (resp) {
        _this2.$router.push('/order');
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleCleanCart: function handleCleanCart() {
      var _this3 = this;

      var cartIds = this.cartData.map(function (item) {
        return item.item_id;
      }).join();
      console.log(cartIds);
      deleteFromCart(cartIds).then(function (resp) {
        _this3.getData();
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleRemoveFromCart: function handleRemoveFromCart(id) {
      var _this4 = this;

      deleteFromCart(id).then(function (resp) {
        _this4.getData();
      }).catch(function (e) {
        return console.log('error', e);
      });
    }
  },
  mounted: function mounted() {
    this.getTabStatus();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b85052b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cart/index.vue
var cart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-page"},[_c('div',{staticClass:"page__bd"},[_c('sticky',{attrs:{"scroll-box":"vux_view_box_body","check-sticky-support":false}},[_c('tab',{attrs:{"scroll-threshold":5,"active-color":"#ff622b","bar-active-color":"#ff622b"}},_vm._l((_vm.taxonomyList),function(item,index){return _c('tab-item',{key:index,attrs:{"selected":_vm.taxonomyList[_vm.activeIndex].tabType==item.tabType},on:{"on-item-click":_vm.tabClick}},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")])}))],1),_vm._v(" "),_c('div',{staticClass:"data-list"},[_c('swipeout',_vm._l((_vm.cartData),function(item ,index){return _c('swipeout-item',{key:index,attrs:{"transition-mode":"follow"}},[_c('div',{attrs:{"slot":"right-menu"},slot:"right-menu"},[_c('swipeout-button',{attrs:{"width":100,"type":"warn"},nativeOn:{"click":function($event){_vm.handleRemoveFromCart(item.item_id)}}},[_vm._v("删除\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"resource-box",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"resource-box-checkbox",on:{"click":function($event){_vm.checkboxChange(index)}}},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(item.checked),expression:"item.checked"}],attrs:{"name":"checked","type":"svg"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!item.checked),expression:"!item.checked"}],attrs:{"name":"unchecked","type":"svg"}})],1),_vm._v(" "),_c('div',{staticClass:"resource-box-avatar"},[_c('img',{attrs:{"src":item.resource.avatar,"alt":""}})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"resource-box-info"},[_c('div',{staticClass:"resource-box-title"},[(_vm.taxonomyList[_vm.activeIndex].tabType=='woa')?_c('icon',{attrs:{"name":"weixinicon","type":"svg"}}):(_vm.taxonomyList[_vm.activeIndex].tabType=='weibo')?_c('icon',{attrs:{"name":"weibo1","type":"svg"}}):(_vm.taxonomyList[_vm.activeIndex].tabType=='live')?_c('icon',{attrs:{"name":"zhibo","type":"svg"}}):(_vm.taxonomyList[_vm.activeIndex].tabType=='video')?_c('icon',{attrs:{"name":"duanshipin","type":"svg"}}):(_vm.taxonomyList[_vm.activeIndex].tabType=='xhs')?_c('icon',{staticStyle:{"font-size":"60px","display":"inline-block","vertical-align":"middle"},attrs:{"name":"xiaohongshu","type":"svg"}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.subject))])],1),_vm._v(" "),_c('div',{staticClass:"resource-box-description"},[_c('icon',{attrs:{"name":"meitibeizhu-icon","type":"svg"}}),_vm._v("\n                  "+_vm._s(item.resource.description?item.resource.description:'暂无简介')+"\n                ")],1),_vm._v(" "),_c('div',{staticClass:"resource-box-price"},[_vm._v("\n                  "+_vm._s(item.type_text)+"价 "),_c('span',{staticClass:"price-unit"},[_vm._v("￥")]),_vm._v(" "),_c('span',{staticClass:"price-value"},[_vm._v(_vm._s(item.price))])])])])])])}))],1)],1),_vm._v(" "),_c('div',{staticClass:"cart-tab-bar"},[_c('div',{staticClass:"all-select",on:{"click":function($event){_vm.checkboxAllChange()}}},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectAll),expression:"selectAll"}],attrs:{"name":"checked","type":"svg"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.selectAll),expression:"!selectAll"}],attrs:{"name":"unchecked","type":"svg"}}),_vm._v(" "),_c('span',[_vm._v("全选")])],1),_vm._v(" "),_c('div',{staticClass:"all-clear",on:{"click":_vm.handleCleanCart}},[_vm._v("一键清空")]),_vm._v(" "),_c('div',{staticClass:"all-price"},[_c('div',[_vm._v("合计:"),_c('span',{staticClass:"price-unit"},[_vm._v("￥")]),_c('span',{staticClass:"price-value"},[_vm._v(_vm._s(_vm.totalPrice))])]),_vm._v(" "),_c('div',{staticClass:"charge-price"},[_vm._v("含服务费 "+_vm._s(_vm.chargePrice))])]),_vm._v(" "),_c('div',{staticClass:"all-order",on:{"click":_vm.handleCreateOrder}},[_vm._v("下单("+_vm._s(_vm.orderNumber)+")")])])])}
var cart_staticRenderFns = []
var cart_esExports = { render: cart_render, staticRenderFns: cart_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_cart = (cart_esExports);
// CONCATENATED MODULE: ./src/pages/cart/index.vue
function cart_injectStyle (ssrContext) {
  __webpack_require__("a761")
}
var cart_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cart___vue_template_functional__ = false
/* styles */
var cart___vue_styles__ = cart_injectStyle
/* scopeId */
var cart___vue_scopeId__ = "data-v-6b85052b"
/* moduleIdentifier (server only) */
var cart___vue_module_identifier__ = null
var cart_Component = cart_normalizeComponent(
  pages_cart,
  selectortype_template_index_0_src_pages_cart,
  cart___vue_template_functional__,
  cart___vue_styles__,
  cart___vue_scopeId__,
  cart___vue_module_identifier__
)

/* harmony default export */ var src_pages_cart = (cart_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-pull-to/dist/vue-pull-to.js
var vue_pull_to = __webpack_require__("08a9");
var vue_pull_to_default = /*#__PURE__*/__webpack_require__.n(vue_pull_to);

// CONCATENATED MODULE: ./src/api/order.js


/*
 * 查询订单
 */
function fetchOrder(status, page) {
  return request.request('/order_resource', {
    status: status,
    page: page
  }, { method: 'get' });
}

/*
 * 查询订单详情
 */
function fetchOrderDetail(orderId) {
  return request.request('/order_resource/' + orderId, {}, { method: 'get' });
}

/*
 * 查询订单详情
 */
function orderPay(orderId) {
  return request.request('payment/request', { order_id: orderId }, { method: 'post' });
}

/*
 * 查询稿件
 */
function fetchManuscripts(taxonomy) {
  return request.request('/manuscripts', {
    taxonomy: taxonomy,
    used_status: -1,
    page: 1
  }, { method: 'get' });
}

/*
 * 选择稿件
 */
function chooseManuscript(orderId, manuscriptId) {
  return request.request('/order_resource/' + orderId, { manuscript_id: manuscriptId }, { method: 'put' });
}

/*
 * 支付接口 获取charge包  用来传给pingpp
 */
function createChargePackage(data) {
  return request.request('/payment/recharge', data, { method: 'post' });
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/index.vue















/* harmony default export */ var order = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['taxonomyList']), {
    navbarSliderClass: function navbarSliderClass() {
      if (this.activeIndex === 0) {
        return 'weui-navbar__slider_0';
      }
      if (this.activeIndex === 1) {
        return 'weui-navbar__slider_1';
      }
      if (this.activeIndex === 2) {
        return 'weui-navbar__slider_2';
      }
      if (this.activeIndex === 3) {
        return 'weui-navbar__slider_3';
      }
    }
  }),
  data: function data() {
    return {
      tabs: [{
        tabName: '全部订单',
        orderStatus: ''
      }, {
        tabName: '待支付',
        orderStatus: 'unpaid'
      }, {
        tabName: '发布中',
        orderStatus: 'pending'
      }, {
        tabName: '已完成',
        orderStatus: 'completed'
      }],
      activeIndex: 0,
      orderData: [],
      page: 1
    };
  },

  components: {
    PullTo: vue_pull_to_default.a,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swipeout: src_components_swipeout_swipeout,
    SwipeoutItem: src_components_swipeout_swipeout_item,
    SwipeoutButton: src_components_swipeout_swipeout_button,
    CheckIcon: vux_src_components_check_icon,
    Sticky: node_modules_vux_src_components_sticky
  },
  methods: {
    tabClick: function tabClick(idx) {
      this.activeIndex = idx;
      this.getOrder();
    },
    getOrder: function getOrder(more) {
      var _this = this;

      if (more === 'more') {
        this.page++;
      } else {
        this.page = 1;
        this.orderData = [];
      }
      fetchOrder(this.tabs[this.activeIndex].orderStatus, this.page).then(function (resp) {
        var orderData = resp.data.map(function (item) {
          var createAt = formatDate(item.created_at);
          return extends_default()({}, item, {
            created_at: createAt,
            subject: item.items[0].subject
          });
        });
        if (more === 'more') {
          _this.orderData = _this.orderData.concat(orderData);
        } else {
          _this.orderData = orderData;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    }
  },
  mounted: function mounted() {

    if (this.$route.query.tab) {
      this.activeIndex = parseInt(this.$route.query.tab);
    }
    this.getOrder();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/order/index.vue















/* harmony default export */ var pages_order = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['taxonomyList']), {
    navbarSliderClass: function navbarSliderClass() {
      if (this.activeIndex === 0) {
        return 'weui-navbar__slider_0';
      }
      if (this.activeIndex === 1) {
        return 'weui-navbar__slider_1';
      }
      if (this.activeIndex === 2) {
        return 'weui-navbar__slider_2';
      }
      if (this.activeIndex === 3) {
        return 'weui-navbar__slider_3';
      }
    }
  }),
  data: function data() {
    return {
      tabs: [{
        tabName: '全部订单',
        orderStatus: ''
      }, {
        tabName: '待支付',
        orderStatus: 'unpaid'
      }, {
        tabName: '发布中',
        orderStatus: 'pending'
      }, {
        tabName: '已完成',
        orderStatus: 'completed'
      }],
      activeIndex: 0,
      orderData: [],
      page: 1
    };
  },

  components: {
    PullTo: vue_pull_to_default.a,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swipeout: src_components_swipeout_swipeout,
    SwipeoutItem: src_components_swipeout_swipeout_item,
    SwipeoutButton: src_components_swipeout_swipeout_button,
    CheckIcon: vux_src_components_check_icon,
    Sticky: node_modules_vux_src_components_sticky
  },
  methods: {
    tabClick: function tabClick(idx) {
      this.activeIndex = idx;
      this.getOrder();
    },
    getOrder: function getOrder(more) {
      var _this = this;

      if (more === 'more') {
        this.page++;
      } else {
        this.page = 1;
        this.orderData = [];
      }
      fetchOrder(this.tabs[this.activeIndex].orderStatus, this.page).then(function (resp) {
        var orderData = resp.data.map(function (item) {
          var createAt = formatDate(item.created_at);
          return extends_default()({}, item, {
            created_at: createAt,
            subject: item.items[0].subject
          });
        });
        if (more === 'more') {
          _this.orderData = _this.orderData.concat(orderData);
        } else {
          _this.orderData = orderData;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    }
  },
  mounted: function mounted() {

    if (this.$route.query.tab) {
      this.activeIndex = parseInt(this.$route.query.tab);
    }
    this.getOrder();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-090fb431","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/index.vue
var order_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-page"},[_c('div',{staticClass:"page__bd"},[_c('sticky',{attrs:{"scroll-box":"vux_view_box_body","check-sticky-support":false}},[_c('tab',{attrs:{"scroll-threshold":5,"active-color":"#ff622b","bar-active-color":"#ff622b"}},_vm._l((_vm.tabs),function(item,index){return _c('tab-item',{key:index,attrs:{"selected":_vm.activeIndex==index},on:{"on-item-click":_vm.tabClick}},[_vm._v("\n          "+_vm._s(item.tabName)+"\n        ")])}))],1),_vm._v(" "),_c('div',{staticClass:"data-list"},_vm._l((_vm.orderData),function(item ,index){return _c('router-link',{key:index,staticClass:"order-data-li",attrs:{"to":'/order/detail/'+item.order_id}},[(item.taxonomy != 'news')?_c('div',{staticClass:"order-data-li-inner"},[_c('div',{staticClass:"order-card-top"},[_c('div',{staticClass:"order-type-icon"},[(item.taxonomy == 'woa')?_c('i',{staticClass:"iconfont icon-dingdan-weixin"}):(item.taxonomy == 'weibo')?_c('i',{staticClass:"iconfont icon-dingdan-weibo"}):(item.taxonomy == 'video')?_c('i',{staticClass:"iconfont icon-dingdan-wanghongzhibo"}):(item.taxonomy == 'live')?_c('i',{staticClass:"iconfont icon-dingdan-duanshipin"}):_c('i',{staticClass:"iconfont icon-xiaohongshuicon"})]),_vm._v(" "),_c('div',{staticClass:"order-card-info"},[_c('div',{staticClass:"order-card-details"},[_c('div',{staticClass:"order-card-details-left"},[_c('div',{staticClass:"order-title"},[_vm._v(_vm._s(item.taxonomy_text))]),_vm._v(" "),_c('div',{staticClass:"order-created"},[_vm._v(_vm._s(item.created_at))])]),_vm._v(" "),_c('div',{staticClass:"order-status"},[(item.completed_at)?_c('i',{staticClass:"iconfont icon-yiwancheng"}):(item.paid_at)?_c('p',[_vm._v("发布中")]):_c('p',[_vm._v("待支付")])])]),_vm._v(" "),_c('div',{staticClass:"order-card-accounts"},[_vm._v(_vm._s(item.subject)+"   等共"+_vm._s(item.body))])])]),_vm._v(" "),_c('div',{staticClass:"order-lack-manuscript"},[(!item.manuscript)?_c('div',{staticClass:"order-tips"},[_c('i',{staticClass:"iconfont icon-tishi-tianjiagaojian"}),_vm._v(" "),_c('p',[_vm._v("缺少稿件，请前往PC端添加")])]):_c('div'),_vm._v(" "),_c('div',{staticClass:"order-sum"},[_vm._v("合计："),_c('span',[_vm._v("￥"+_vm._s(item.amount))])])])]):_vm._e()])}))],1)])}
var order_staticRenderFns = []
var order_esExports = { render: order_render, staticRenderFns: order_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_order = (order_esExports);
// CONCATENATED MODULE: ./src/pages/order/index.vue
function order_injectStyle (ssrContext) {
  __webpack_require__("gbDm")
}
var order_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var order___vue_template_functional__ = false
/* styles */
var order___vue_styles__ = order_injectStyle
/* scopeId */
var order___vue_scopeId__ = "data-v-090fb431"
/* moduleIdentifier (server only) */
var order___vue_module_identifier__ = null
var order_Component = order_normalizeComponent(
  pages_order,
  selectortype_template_index_0_src_pages_order,
  order___vue_template_functional__,
  order___vue_styles__,
  order___vue_scopeId__,
  order___vue_module_identifier__
)

/* harmony default export */ var src_pages_order = (order_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/orderDetail/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var orderDetail = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['profile'])),
  data: function data() {
    return {
      orderStatusItems: ['创建稿件', '待支付', '待发布', '发布完成'],
      orderStatus: '',
      orderId: '',
      orderData: {}
    };
  },

  methods: {
    getOrderDetail: function getOrderDetail() {
      var _this2 = this;

      fetchOrderDetail(this.orderId).then(function (resp) {
        var createdTime = formatTime(resp.data.created_at);
        var paidTime = resp.data.paid_at ? formatTime(resp.data.paid_at) : '';
        _this2.orderData = extends_default()({}, resp.data, {
          completed_at: formatTime(resp.data.completed_at),
          orderId: resp.data.order_id,
          orderTaxonomy: resp.data.taxonomy_text,
          createdTime: createdTime,
          paidTime: paidTime
        });
        if (resp.data.completed_at) {
          _this2.orderStatus = 3;
        } else if (resp.data.paid_at) {
          _this2.orderStatus = 2;
        } else if (resp.data.manuscript) {
          _this2.orderStatus = 1;
        } else {
          _this2.orderStatus = 0;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handchooseManuscript: function handchooseManuscript() {},
    handlePay: function handlePay() {
      var balance = parseInt(this.profile.balance);
      var amount = parseInt(this.orderData.amount);
      // const _this = this
      // 判断用户余额是否充足
      if (balance < amount) {
        console.log('余额不足');
        this.$vux.confirm.show({
          content: '支付失败，账户余额不足，请先充值',
          onConfirm: function onConfirm() {
            // console.log(this) // 非当前 vm
            // console.log(_this) // 当前 vm
            // _this.$router.replace(`/recharge`)
          }
        });
      } else {
        var _this = this;
        this.$vux.confirm.show({
          content: '\u786E\u8BA4\u4E3A\u8BA2\u5355\u652F\u4ED8' + amount + '\u5143',
          onConfirm: function onConfirm() {
            // console.log(this) // 非当前 vm
            // console.log(_this) // 当前 vm
            orderPay(_this.orderId).then(function (resp) {
              _this.getOrderDetail();
              _this.$router.replace('/pay-success');
            }).catch(function (e) {
              console.log(e);
            });
          }
        });
      }
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.orderId = this.$route.params.id;
      this.getOrderDetail();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/orderDetail/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var pages_orderDetail = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['profile'])),
  data: function data() {
    return {
      orderStatusItems: ['创建稿件', '待支付', '待发布', '发布完成'],
      orderStatus: '',
      orderId: '',
      orderData: {}
    };
  },

  methods: {
    getOrderDetail: function getOrderDetail() {
      var _this2 = this;

      fetchOrderDetail(this.orderId).then(function (resp) {
        var createdTime = formatTime(resp.data.created_at);
        var paidTime = resp.data.paid_at ? formatTime(resp.data.paid_at) : '';
        _this2.orderData = extends_default()({}, resp.data, {
          completed_at: formatTime(resp.data.completed_at),
          orderId: resp.data.order_id,
          orderTaxonomy: resp.data.taxonomy_text,
          createdTime: createdTime,
          paidTime: paidTime
        });
        if (resp.data.completed_at) {
          _this2.orderStatus = 3;
        } else if (resp.data.paid_at) {
          _this2.orderStatus = 2;
        } else if (resp.data.manuscript) {
          _this2.orderStatus = 1;
        } else {
          _this2.orderStatus = 0;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handchooseManuscript: function handchooseManuscript() {},
    handlePay: function handlePay() {
      var balance = parseInt(this.profile.balance);
      var amount = parseInt(this.orderData.amount);
      // const _this = this
      // 判断用户余额是否充足
      if (balance < amount) {
        console.log('余额不足');
        this.$vux.confirm.show({
          content: '支付失败，账户余额不足，请先充值',
          onConfirm: function onConfirm() {
            // console.log(this) // 非当前 vm
            // console.log(_this) // 当前 vm
            // _this.$router.replace(`/recharge`)
          }
        });
      } else {
        var _this = this;
        this.$vux.confirm.show({
          content: '\u786E\u8BA4\u4E3A\u8BA2\u5355\u652F\u4ED8' + amount + '\u5143',
          onConfirm: function onConfirm() {
            // console.log(this) // 非当前 vm
            // console.log(_this) // 当前 vm
            orderPay(_this.orderId).then(function (resp) {
              _this.getOrderDetail();
              _this.$router.replace('/pay-success');
            }).catch(function (e) {
              console.log(e);
            });
          }
        });
      }
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.orderId = this.$route.params.id;
      this.getOrderDetail();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-454c665a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderDetail/index.vue
var orderDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page__bd"},[_c('div',{staticClass:"order-info"},[(_vm.orderStatus == 0)?_c('div',{staticClass:"order-info-list"},[_c('p',[_vm._v("待创建稿件：")]),_vm._v(" "),_c('p',[_vm._v("当前缺少稿件，请添加")])]):(_vm.orderStatus == 1)?_c('div',{staticClass:"order-info-list"},[_c('p',[_vm._v("待支付订单：")]),_vm._v(" "),_c('p',[_vm._v("已创建稿件，请支付订单")])]):(_vm.orderStatus == 2)?_c('div',{staticClass:"order-info-list"},[_c('p',[_vm._v("待执行订单：")]),_vm._v(" "),_c('p',[_vm._v("请等待媒体发布")])]):_c('div',{staticClass:"order-info-list"},[_c('p',[_vm._v("已完成订单：")]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-yiwancheng"})]),_vm._v(" "),_c('div',{staticClass:"order-info-list"},[_c('p',[_vm._v("订单编号：")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.orderId))])]),_vm._v(" "),_c('div',{staticClass:"order-info-list"},[_c('p',[_vm._v("订单类型：")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.orderData.orderTaxonomy))])]),_vm._v(" "),_c('div',{staticClass:"order-info-list"},[_c('p',[_vm._v("创建时间：")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.orderData.createdTime))])]),_vm._v(" "),_c('div',{staticClass:"order-info-list"},[_c('p',[_vm._v("服务费：")]),_vm._v(" "),_c('p',[_vm._v("￥"+_vm._s(_vm.orderData.amount_extra))])]),_vm._v(" "),_c('div',{staticClass:"order-info-list"},[_c('p',[_vm._v("实付款：")]),_vm._v(" "),_c('p',[_vm._v("￥"+_vm._s(_vm.orderData.amount))])]),_vm._v(" "),_c('div',{staticClass:"weui-cell order-info-list"},[_c('p',[_vm._v("已退款金额：")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.orderData.amount_refunded))])])]),_vm._v(" "),_c('div',{staticClass:"box resource-list"},[_c('div',{staticClass:"box-header"},[_vm._v("媒体列表")]),_vm._v(" "),_c('div',{staticClass:"box-body"},_vm._l((_vm.orderData.items),function(item,index){return _c('div',{key:index,staticClass:"resource-item",attrs:{"direction":"space-between"}},[_c('img',{staticClass:"resource-avatar",attrs:{"src":item.thumb,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"resource-info"},[_c('h4',[_vm._v(_vm._s(item.subject))]),_vm._v(" "),_c('div',{staticClass:"resource-description"},[_vm._v(_vm._s(item.description?item.description:'暂无描述'))]),_vm._v(" "),_c('div',{staticClass:"resource-other"},[_c('div',{staticClass:"media-res-status"},[_vm._v(_vm._s(item.process_status_text))]),_vm._v(" "),_c('div',{staticClass:"media-res-type-price"},[_c('p',[_vm._v(_vm._s(item.type_text))]),_vm._v(" "),_c('span',[_vm._v("￥"+_vm._s(item.price))])])])])])}))]),_vm._v(" "),_c('div',{staticClass:"box manuscript-box"},[_c('div',{staticClass:"box-header"},[_vm._v("稿件信息")]),_vm._v(" "),(_vm.orderStatus==0)?_c('p',{staticClass:"choose-manuscript-none"},[_vm._v("当前没有可使用的订单")]):_c('div',{staticClass:"box-body weui-panel__bd"},[_c('div',{staticClass:"weui-media-box weui-media-box_text"},[_c('h4',{staticClass:"weui-media-box__title"},[_vm._v("稿件标题")]),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc"},[_vm._v(_vm._s(_vm.orderData.manuscript&&_vm.orderData.manuscript.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-media-box weui-media-box_text"},[_c('h4',{staticClass:"weui-media-box__title"},[_vm._v("稿件描述")]),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc"},[_vm._v(_vm._s(_vm.orderData.manuscript&&_vm.orderData.manuscript.description))])]),_vm._v(" "),_c('div',{staticClass:"weui-media-box weui-media-box_text"},[_c('h4',{staticClass:"weui-media-box__title"},[_vm._v("稿件链接")]),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc"},[_vm._v(_vm._s(_vm.orderData.manuscript&&_vm.orderData.manuscript.url))])])]),_vm._v(" "),(_vm.orderStatus!=0)?_c('div',{staticClass:"manuscript-waining"},[_c('i',{staticClass:"iconfont icon-tishi-tianjiagaojian"}),_vm._v("发稿过程中，稿件将不能修改，如需要修改稿件，请联系客服\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"order-status-panel"},[_c('div',{staticClass:"order-status-line"}),_vm._v(" "),_c('div',{staticClass:"order-status-step"},[_c('div',{staticClass:"order-status-step-li"},[_c('div',{staticClass:"order-status-step-li-left"},[_c('div',{staticClass:"order-circle-outter",class:{orderOrange:_vm.orderStatus == 0}},[_c('div',{staticClass:"order-circle",class:{orderCircleOrange:_vm.orderStatus >= 0}})]),_vm._v(" "),_c('p',[_vm._v("创建稿件")])]),_vm._v(" "),(_vm.orderStatus > 0)?_c('div',{staticClass:"order-status-step-li-create-time"},[_vm._v(_vm._s(_vm.orderData.createdTime))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"order-status-step-li"},[_c('div',{staticClass:"order-status-step-li-left"},[_c('div',{staticClass:"order-circle-outter",class:{orderOrange:_vm.orderStatus == 1}},[_c('div',{staticClass:"order-circle",class:{orderCircleOrange:_vm.orderStatus >= 1}})]),_vm._v(" "),_c('p',[_vm._v("支付订单")])]),_vm._v(" "),(_vm.orderStatus > 1)?_c('div',{staticClass:"order-status-step-li-create-time"},[_vm._v(_vm._s(_vm.orderData.paidTime))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"order-status-step-li"},[_c('div',{staticClass:"order-status-step-li-left"},[_c('div',{staticClass:"order-circle-outter",class:{orderOrange:_vm.orderStatus == 2}},[_c('div',{staticClass:"order-circle",class:{orderCircleOrange:_vm.orderStatus >= 2}})]),_vm._v(" "),_c('p',[_vm._v("等待发布")])])]),_vm._v(" "),_c('div',{staticClass:"order-status-step-li"},[_c('div',{staticClass:"order-status-step-li-left"},[_c('div',{staticClass:"order-circle-outter",class:{orderOrange:_vm.orderStatus == 3}},[_c('div',{staticClass:"order-circle",class:{orderCircleOrange:_vm.orderStatus >= 3}})]),_vm._v(" "),_c('p',[_vm._v("发布完成")])]),_vm._v(" "),(_vm.orderStatus > 2)?_c('div',{staticClass:"order-status-step-li-create-time"},[_vm._v(_vm._s(_vm.orderData.completed_at))]):_vm._e()])])]),_vm._v(" "),(_vm.orderStatus==0)?_c('router-link',{staticClass:"pay-btn",attrs:{"to":'/manuscript?taxonomy='+ _vm.orderData.taxonomy +'&orderId=' + _vm.orderId}},[_vm._v("\n      选择稿件\n    ")]):_vm._e(),_vm._v(" "),(_vm.orderStatus==1)?_c('div',{staticClass:"pay-btn",on:{"click":_vm.handlePay}},[_vm._v("\n      马上支付\n    ")]):_vm._e()],1)])}
var orderDetail_staticRenderFns = []
var orderDetail_esExports = { render: orderDetail_render, staticRenderFns: orderDetail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_orderDetail = (orderDetail_esExports);
// CONCATENATED MODULE: ./src/pages/orderDetail/index.vue
function orderDetail_injectStyle (ssrContext) {
  __webpack_require__("DS/O")
}
var orderDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var orderDetail___vue_template_functional__ = false
/* styles */
var orderDetail___vue_styles__ = orderDetail_injectStyle
/* scopeId */
var orderDetail___vue_scopeId__ = "data-v-454c665a"
/* moduleIdentifier (server only) */
var orderDetail___vue_module_identifier__ = null
var orderDetail_Component = orderDetail_normalizeComponent(
  pages_orderDetail,
  selectortype_template_index_0_src_pages_orderDetail,
  orderDetail___vue_template_functional__,
  orderDetail___vue_styles__,
  orderDetail___vue_scopeId__,
  orderDetail___vue_module_identifier__
)

/* harmony default export */ var src_pages_orderDetail = (orderDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/manuscript/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Use Vuex



/* harmony default export */ var manuscript = ({
  data: function data() {
    return {
      orderId: '',
      taxonomy: '',
      manuscriptItems: []
    };
  },

  components: {},
  methods: {
    getMenuscript: function getMenuscript() {
      var _this2 = this;

      fetchManuscripts(this.taxonomy).then(function (resp) {
        console.log(resp, 321);
        _this2.manuscriptItems = resp.data.map(function (data) {
          var createdAt = formatTime(data.created_at);
          return {
            title: data.title,
            createdAt: createdAt,
            description: data.description,
            manuscriptId: data.manuscript_id
          };
        });
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleChoose: function handleChoose(manuscriptId) {
      var _this = this;
      this.$vux.confirm.show({
        content: '是否选择当前稿件作为该订单的稿件',
        onConfirm: function onConfirm() {
          // console.log(this) // 非当前 vm
          // console.log(_this) // 当前 vm
          chooseManuscript(_this.orderId, manuscriptId).then(function (resp) {
            console.log(resp, 123);
            _this.$router.replace('/order/detail/' + _this.orderId);
          }).catch(function (e) {
            return console.log('error', e);
          });
        }
      });
    }
  },
  mounted: function mounted() {
    if (this.$route.query.taxonomy && this.$route.query.orderId) {
      this.orderId = this.$route.query.orderId;
      this.taxonomy = this.$route.query.taxonomy;
      this.getMenuscript();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/manuscript/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Use Vuex



/* harmony default export */ var pages_manuscript = ({
  data: function data() {
    return {
      orderId: '',
      taxonomy: '',
      manuscriptItems: []
    };
  },

  components: {},
  methods: {
    getMenuscript: function getMenuscript() {
      var _this2 = this;

      fetchManuscripts(this.taxonomy).then(function (resp) {
        console.log(resp, 321);
        _this2.manuscriptItems = resp.data.map(function (data) {
          var createdAt = formatTime(data.created_at);
          return {
            title: data.title,
            createdAt: createdAt,
            description: data.description,
            manuscriptId: data.manuscript_id
          };
        });
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleChoose: function handleChoose(manuscriptId) {
      var _this = this;
      this.$vux.confirm.show({
        content: '是否选择当前稿件作为该订单的稿件',
        onConfirm: function onConfirm() {
          // console.log(this) // 非当前 vm
          // console.log(_this) // 当前 vm
          chooseManuscript(_this.orderId, manuscriptId).then(function (resp) {
            console.log(resp, 123);
            _this.$router.replace('/order/detail/' + _this.orderId);
          }).catch(function (e) {
            return console.log('error', e);
          });
        }
      });
    }
  },
  mounted: function mounted() {
    if (this.$route.query.taxonomy && this.$route.query.orderId) {
      this.orderId = this.$route.query.orderId;
      this.taxonomy = this.$route.query.taxonomy;
      this.getMenuscript();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d839a216","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/manuscript/index.vue
var manuscript_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page__bd"},[_vm._l((_vm.manuscriptItems),function(item,index){return _c('div',{key:index,staticClass:"card",on:{"click":function($event){_vm.handleChoose(item.manuscriptId)}}},[_c('div',{staticClass:"card-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"card-description"},[_c('i',{staticClass:"iconfont icon-meitibeizhu-icon"}),_vm._v("\n        "+_vm._s(item.description)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"card-time"},[_vm._v("\n        "+_vm._s(item.createdAt)+"\n      ")])])}),_vm._v(" "),(_vm.manuscriptItems.length===0)?_c('div',{staticClass:"none-data"},[_vm._v("\n      无任何稿件信息，请前往PC端创建\n    ")]):_vm._e()],2)])}
var manuscript_staticRenderFns = []
var manuscript_esExports = { render: manuscript_render, staticRenderFns: manuscript_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_manuscript = (manuscript_esExports);
// CONCATENATED MODULE: ./src/pages/manuscript/index.vue
function manuscript_injectStyle (ssrContext) {
  __webpack_require__("akPl")
}
var manuscript_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var manuscript___vue_template_functional__ = false
/* styles */
var manuscript___vue_styles__ = manuscript_injectStyle
/* scopeId */
var manuscript___vue_scopeId__ = "data-v-d839a216"
/* moduleIdentifier (server only) */
var manuscript___vue_module_identifier__ = null
var manuscript_Component = manuscript_normalizeComponent(
  pages_manuscript,
  selectortype_template_index_0_src_pages_manuscript,
  manuscript___vue_template_functional__,
  manuscript___vue_styles__,
  manuscript___vue_scopeId__,
  manuscript___vue_module_identifier__
)

/* harmony default export */ var src_pages_manuscript = (manuscript_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/recharge-success/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var recharge_success = ({
  data: function data() {
    return {
      userInfo: {},
      time: ''
    };
  },

  methods: {
    getUserInfo: function getUserInfo() {
      var _this = this;

      fetchUser().then(function (resp) {
        _this.userInfo = resp.data;
      });
    }
  },
  mounted: function mounted() {
    this.getUserInfo();
    var time = new Date().valueOf() / 1000;
    this.time = formatDate(time);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/recharge-success/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_recharge_success = ({
  data: function data() {
    return {
      userInfo: {},
      time: ''
    };
  },

  methods: {
    getUserInfo: function getUserInfo() {
      var _this = this;

      fetchUser().then(function (resp) {
        _this.userInfo = resp.data;
      });
    }
  },
  mounted: function mounted() {
    this.getUserInfo();
    var time = new Date().valueOf() / 1000;
    this.time = formatDate(time);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-549b43b7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/recharge-success/index.vue
var recharge_success_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"weui-msg"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"weui-msg__text-area"},[_c('div',{staticClass:"weui-msg__title"},[_vm._v("充值成功")]),_vm._v(" "),_c('div',{staticClass:"weui-msg__desc"},[_vm._v("账户余额：￥ "+_vm._s(_vm.userInfo.balance)+"元")]),_vm._v(" "),_c('div',{staticClass:"weui-msg__desc smaller"},[_vm._v("充值时间："+_vm._s(_vm.time))])])]),_vm._v(" "),_c('img',{staticClass:"pay-success-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/pay-success-bg.png","alt":""}})])}
var recharge_success_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-msg__icon-area"},[_c('i',{staticClass:"iconfont icon-checkboxround1"})])}]
var recharge_success_esExports = { render: recharge_success_render, staticRenderFns: recharge_success_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_recharge_success = (recharge_success_esExports);
// CONCATENATED MODULE: ./src/pages/recharge-success/index.vue
function recharge_success_injectStyle (ssrContext) {
  __webpack_require__("D+Bg")
}
var recharge_success_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var recharge_success___vue_template_functional__ = false
/* styles */
var recharge_success___vue_styles__ = recharge_success_injectStyle
/* scopeId */
var recharge_success___vue_scopeId__ = "data-v-549b43b7"
/* moduleIdentifier (server only) */
var recharge_success___vue_module_identifier__ = null
var recharge_success_Component = recharge_success_normalizeComponent(
  pages_recharge_success,
  selectortype_template_index_0_src_pages_recharge_success,
  recharge_success___vue_template_functional__,
  recharge_success___vue_styles__,
  recharge_success___vue_scopeId__,
  recharge_success___vue_module_identifier__
)

/* harmony default export */ var src_pages_recharge_success = (recharge_success_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pay-success/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pay_success = ({
  data: function data() {
    return {
      userInfo: {},
      time: ''
    };
  },

  methods: {
    getUserInfo: function getUserInfo() {
      var _this = this;

      fetchUser().then(function (resp) {
        _this.userInfo = resp.data;
      });
    }
  },
  mounted: function mounted() {
    this.getUserInfo();
    var time = new Date().valueOf() / 1000;
    this.time = formatDate(time);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/pay-success/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_pay_success = ({
  data: function data() {
    return {
      userInfo: {},
      time: ''
    };
  },

  methods: {
    getUserInfo: function getUserInfo() {
      var _this = this;

      fetchUser().then(function (resp) {
        _this.userInfo = resp.data;
      });
    }
  },
  mounted: function mounted() {
    this.getUserInfo();
    var time = new Date().valueOf() / 1000;
    this.time = formatDate(time);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20cd6573","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pay-success/index.vue
var pay_success_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"weui-msg"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"weui-msg__text-area"},[_c('div',{staticClass:"weui-msg__title"},[_vm._v("支付成功")]),_vm._v(" "),_c('div',{staticClass:"weui-msg__desc"},[_vm._v("账户余额：￥ "+_vm._s(_vm.userInfo.balance)+"元")]),_vm._v(" "),_c('div',{staticClass:"weui-msg__desc smaller"},[_vm._v("支付时间："+_vm._s(_vm.time))])])]),_vm._v(" "),_c('img',{staticClass:"pay-success-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/pay-success-bg.png"}})])}
var pay_success_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-msg__icon-area"},[_c('i',{staticClass:"iconfont icon-checkboxround1",staticStyle:{"color":"#ff622b","font-size":"90px"}})])}]
var pay_success_esExports = { render: pay_success_render, staticRenderFns: pay_success_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_pay_success = (pay_success_esExports);
// CONCATENATED MODULE: ./src/pages/pay-success/index.vue
function pay_success_injectStyle (ssrContext) {
  __webpack_require__("su3c")
}
var pay_success_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pay_success___vue_template_functional__ = false
/* styles */
var pay_success___vue_styles__ = pay_success_injectStyle
/* scopeId */
var pay_success___vue_scopeId__ = "data-v-20cd6573"
/* moduleIdentifier (server only) */
var pay_success___vue_module_identifier__ = null
var pay_success_Component = pay_success_normalizeComponent(
  pages_pay_success,
  selectortype_template_index_0_src_pages_pay_success,
  pay_success___vue_template_functional__,
  pay_success___vue_styles__,
  pay_success___vue_scopeId__,
  pay_success___vue_module_identifier__
)

/* harmony default export */ var src_pages_pay_success = (pay_success_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar_tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9137330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
var tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tabbar"},[_vm._t("default")],2)}
var tabbar_staticRenderFns = []
var tabbar_esExports = { render: tabbar_render, staticRenderFns: tabbar_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar = (tabbar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar.vue
function tabbar_injectStyle (ssrContext) {
  __webpack_require__("LkwW")
}
var tabbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar___vue_template_functional__ = false
/* styles */
var tabbar___vue_styles__ = tabbar_injectStyle
/* scopeId */
var tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar___vue_module_identifier__ = null
var tabbar_Component = tabbar_normalizeComponent(
  tabbar_tabbar,
  components_tabbar_tabbar,
  tabbar___vue_template_functional__,
  tabbar___vue_styles__,
  tabbar___vue_scopeId__,
  tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar = (tabbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var components_badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9e5ce22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/badge/index.vue
var badge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['vux-badge', {'vux-badge-dot': typeof _vm.text === 'undefined', 'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1}],domProps:{"textContent":_vm._s(_vm.text)}})}
var badge_staticRenderFns = []
var badge_esExports = { render: badge_render, staticRenderFns: badge_staticRenderFns }
/* harmony default export */ var src_components_badge = (badge_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/badge/index.vue
function badge_injectStyle (ssrContext) {
  __webpack_require__("OECo")
}
var badge_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var badge___vue_template_functional__ = false
/* styles */
var badge___vue_styles__ = badge_injectStyle
/* scopeId */
var badge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var badge___vue_module_identifier__ = null
var badge_Component = badge_normalizeComponent(
  components_badge,
  src_components_badge,
  badge___vue_template_functional__,
  badge___vue_styles__,
  badge___vue_scopeId__,
  badge___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_badge = (badge_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fcb5c5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-tabbar__item",class:{'weui-bar__item_on': _vm.isActive, 'vux-tabbar-simple': _vm.simple},attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.onItemClick(true)}}},[(!_vm.simple)?_c('div',{staticClass:"weui-tabbar__icon",class:[_vm.iconClass || _vm.$parent.iconClass, {'vux-reddot': _vm.showDot}]},[(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive))?_vm._t("icon"):_vm._e(),_vm._v(" "),(!_vm.simple && _vm.hasActiveIcon && _vm.isActive)?_vm._t("icon-active"):_vm._e(),_vm._v(" "),(_vm.badge)?_c('sup',[_c('badge',{attrs:{"text":_vm.badge}})],1):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"weui-tabbar__label"},[_vm._t("label")],2)])}
var tabbar_item_staticRenderFns = []
var tabbar_item_esExports = { render: tabbar_item_render, staticRenderFns: tabbar_item_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar_item = (tabbar_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar_item___vue_template_functional__ = false
/* styles */
var tabbar_item___vue_styles__ = null
/* scopeId */
var tabbar_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar_item___vue_module_identifier__ = null
var tabbar_item_Component = tabbar_item_normalizeComponent(
  tabbar_tabbar_item,
  components_tabbar_tabbar_item,
  tabbar_item___vue_template_functional__,
  tabbar_item___vue_styles__,
  tabbar_item___vue_scopeId__,
  tabbar_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar_item = (tabbar_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/confirm/index.vue + 7 modules
var components_confirm = __webpack_require__("62KO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/me/index.vue













/* harmony default export */ var me = ({
  name: 'IndexFooter',
  data: function data() {
    return {
      userInfo: {},
      orderStatus: {},
      dataArray: [],
      customerService: {},
      qrImages: []
    };
  },

  components: {
    Previewer: vux_src_components_previewer,
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Confirm: components_confirm["a" /* default */]
  },
  methods: {
    getUserInfo: function getUserInfo() {
      var _this = this;

      fetchUser().then(function (resp) {
        _this.userInfo = resp.data;
      });
    },
    logout: function logout() {
      var _this2 = this;

      authLogout().then(function (res) {
        delCookie('token');
        _this2.$router.push('/');
      });
    },
    contactService: function contactService(phoneNum) {
      console.log(phoneNum);
      window.location.href = 'tel:' + phoneNum;
    },
    openQrcode: function openQrcode(index) {
      this.$refs.previewer.show(index);
    },
    jumpToOrder: function jumpToOrder(tab) {
      this.$router.push('/order?tab=' + tab);
    },
    myConsultant: function myConsultant() {
      var _this3 = this;

      if (this.dataArray === '') {
        console.log(1);
        var fly = new fly_default.a();

        fly.request('https://api.ruan.net/api/personal/customer_service', {}, {
          method: 'get'
        }).then(function (resp) {
          console.log(resp, 123);
          if (resp.data.status === 200) {
            _this3.showCardIndex = 1;
            _this3.dataArray = resp.data.data;
            sessionStorage.setItem('objArr', stringify_default()(resp.data.data));
          }
        }).catch(function (e) {
          return console.log('error', e);
        });
      } else {
        this.dataArray = JSON.parse(sessionStorage.getItem('objArr'));
      }
    }
  },
  created: function created() {
    this.dataArray = JSON.parse(sessionStorage.getItem('objArr')) ? JSON.parse(sessionStorage.getItem('objArr')) : '';
    this.myConsultant();
  },
  mounted: function mounted() {
    var _this4 = this;

    this.getUserInfo();
    fetchOrderStatus().then(function (resp) {
      _this4.orderStatus = resp.data;
    });
    fetchCustomerService().then(function (resp) {
      _this4.customerService = resp.data;
      console.log(_this4.customerService.wechat_qrcode);
      _this4.qrImages = [{
        thumb: 'https://static.xinmeibao.com/assets_mobile/v1/icon-qcode2.png',
        src: _this4.customerService.wechat_qrcode,
        caption: '', // Optional
        srcset: ''
      }];
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/me/index.vue













/* harmony default export */ var pages_me = ({
  name: 'IndexFooter',
  data: function data() {
    return {
      userInfo: {},
      orderStatus: {},
      dataArray: [],
      customerService: {},
      qrImages: []
    };
  },

  components: {
    Previewer: vux_src_components_previewer,
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Confirm: components_confirm["a" /* default */]
  },
  methods: {
    getUserInfo: function getUserInfo() {
      var _this = this;

      fetchUser().then(function (resp) {
        _this.userInfo = resp.data;
      });
    },
    logout: function logout() {
      var _this2 = this;

      authLogout().then(function (res) {
        delCookie('token');
        _this2.$router.push('/');
      });
    },
    contactService: function contactService(phoneNum) {
      console.log(phoneNum);
      window.location.href = 'tel:' + phoneNum;
    },
    openQrcode: function openQrcode(index) {
      this.$refs.previewer.show(index);
    },
    jumpToOrder: function jumpToOrder(tab) {
      this.$router.push('/order?tab=' + tab);
    },
    myConsultant: function myConsultant() {
      var _this3 = this;

      if (this.dataArray === '') {
        console.log(1);
        var fly = new fly_default.a();

        fly.request('https://api.ruan.net/api/personal/customer_service', {}, {
          method: 'get'
        }).then(function (resp) {
          console.log(resp, 123);
          if (resp.data.status === 200) {
            _this3.showCardIndex = 1;
            _this3.dataArray = resp.data.data;
            sessionStorage.setItem('objArr', stringify_default()(resp.data.data));
          }
        }).catch(function (e) {
          return console.log('error', e);
        });
      } else {
        this.dataArray = JSON.parse(sessionStorage.getItem('objArr'));
      }
    }
  },
  created: function created() {
    this.dataArray = JSON.parse(sessionStorage.getItem('objArr')) ? JSON.parse(sessionStorage.getItem('objArr')) : '';
    this.myConsultant();
  },
  mounted: function mounted() {
    var _this4 = this;

    this.getUserInfo();
    fetchOrderStatus().then(function (resp) {
      _this4.orderStatus = resp.data;
    });
    fetchCustomerService().then(function (resp) {
      _this4.customerService = resp.data;
      console.log(_this4.customerService.wechat_qrcode);
      _this4.qrImages = [{
        thumb: 'https://static.xinmeibao.com/assets_mobile/v1/icon-qcode2.png',
        src: _this4.customerService.wechat_qrcode,
        caption: '', // Optional
        srcset: ''
      }];
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c31d0e54","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/me/index.vue
var me_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"footer-card",attrs:{"id":"footer-card"}},[_c('img',{staticClass:"footer-card-avatar",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/login/tx_.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"footer-card-info"},[_c('div',{staticClass:"footer-card-info-left"},[_c('h3',[_c('span',[_vm._v(_vm._s(_vm.dataArray.name))]),_c('p',[_vm._v("客户经理")])]),_vm._v(" "),_c('a',{staticClass:"footer-card-qq",attrs:{"href":'tel:'+_vm.dataArray.mobile}},[_c('i',{staticClass:"iconfont icon-mobile-channel"}),_vm._v(" "),_c('div',{staticClass:"footer-btn-tel"},[_vm._v(_vm._s(_vm.dataArray.mobile))])])]),_vm._v(" "),_c('a',{staticClass:"footer-card-ercode",attrs:{"href":_vm.dataArray.wechat_qrcode,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.dataArray.wechat_qrcode,"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"me-operate-list"},[_c('div',{staticClass:"me-operate-list-li"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"me-operate-list-li-right"},[_vm._v("\n            "+_vm._s(_vm.userInfo.name)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"me-operate-list-li"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"me-operate-list-li-right"},[_vm._v("\n            "+_vm._s(_vm.userInfo.mobile)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"me-operate-list-li"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"me-operate-list-li-right"},[_vm._v("\n            "+_vm._s(_vm.userInfo.balance)+"元\n          ")])]),_vm._v(" "),_c('div',{staticClass:"me-operate-list-li"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"me-operate-list-li-right"},[_c('router-link',{attrs:{"to":"/changePwd"}},[_c('i',{staticClass:"iconfont icon-youjiantou"})])],1)])]),_vm._v(" "),_c('div',{staticClass:"exit-account",on:{"click":_vm.logout}},[_vm._v("退出账号")])])])}
var me_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header",staticStyle:{"width":"100%","position":"absolute","top":"0px","left":"0px","z-index":"100"}},[_c('div',{staticClass:"vux-header-left"},[_c('a',{staticClass:"vux-header-back"}),_vm._v(" "),_c('div',{staticClass:"left-arrow"})]),_vm._v(" "),_c('div',{staticClass:"vux-header-title-area"},[_c('div',{staticClass:"header-title"},[_vm._v("\n        个人中心\n      ")])]),_vm._v(" "),_c('div',{staticClass:"vux-header-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-xmb"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/login/xmb_logo.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"logo-xmb-title"},[_vm._v("一站式智能广告营销平台")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"me-operate-list-li-left"},[_c('img',{staticClass:"me-operate-list-li-left-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/login/yhm.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"me-operate-list-li-p"},[_vm._v("用户名")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"me-operate-list-li-left"},[_c('img',{staticClass:"me-operate-list-li-left-photo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/icon-me-phone.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"me-operate-list-li-p"},[_vm._v("手机号")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"me-operate-list-li-left"},[_c('img',{staticClass:"me-operate-list-li-left-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/login/zh_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"me-operate-list-li-p"},[_vm._v("账户余额")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"me-operate-list-li-left"},[_c('img',{staticClass:"me-operate-list-li-left-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/login/suo_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"me-operate-list-li-p"},[_vm._v("修改密码")])])}]
var me_esExports = { render: me_render, staticRenderFns: me_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_me = (me_esExports);
// CONCATENATED MODULE: ./src/pages/me/index.vue
function me_injectStyle (ssrContext) {
  __webpack_require__("ugrf")
}
var me_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var me___vue_template_functional__ = false
/* styles */
var me___vue_styles__ = me_injectStyle
/* scopeId */
var me___vue_scopeId__ = "data-v-c31d0e54"
/* moduleIdentifier (server only) */
var me___vue_module_identifier__ = null
var me_Component = me_normalizeComponent(
  pages_me,
  selectortype_template_index_0_src_pages_me,
  me___vue_template_functional__,
  me___vue_styles__,
  me___vue_scopeId__,
  me___vue_module_identifier__
)

/* harmony default export */ var src_pages_me = (me_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pages_profile = ({
  data: function data() {
    return {
      userInfo: {
        company: {}
      }
    };
  },

  methods: {
    getUserInfo: function getUserInfo() {
      var _this = this;

      fetchUser().then(function (resp) {
        _this.userInfo = resp.data;
      });
    }
  },
  mounted: function mounted() {
    this.getUserInfo();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_pages_profile = ({
  data: function data() {
    return {
      userInfo: {
        company: {}
      }
    };
  },

  methods: {
    getUserInfo: function getUserInfo() {
      var _this = this;

      fetchUser().then(function (resp) {
        _this.userInfo = resp.data;
      });
    }
  },
  mounted: function mounted() {
    this.getUserInfo();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5467955e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/index.vue
var profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page__bd"},[_c('div',[_c('router-link',{staticClass:"profile-row-padding",attrs:{"to":'/profile/edit?type=用户名称&value='+_vm.userInfo.name}},[_c('div',{staticClass:"profile-label"},[_vm._v("用户名称")]),_vm._v(" "),_c('div',{staticClass:"profile-value"},[_vm._v(_vm._s(_vm.userInfo.name)),_c('i',{staticClass:"iconfont icon-youjiantou"})])]),_vm._v(" "),_c('div',{staticClass:"profile-row-padding"},[_c('div',{staticClass:"profile-label"},[_vm._v("手机号码")]),_vm._v(" "),_c('div',{staticClass:"profile-value"},[_vm._v(_vm._s(_vm.userInfo.mobile))])]),_vm._v(" "),_c('router-link',{staticClass:"profile-row-padding",attrs:{"to":'/profile/edit?type=邮箱&value='+_vm.userInfo.email}},[_c('div',{staticClass:"profile-label"},[_vm._v("邮箱")]),_vm._v(" "),_c('div',{staticClass:"profile-value"},[_vm._v("\n          "+_vm._s(_vm.userInfo.email)+"\n          "),_c('i',{staticClass:"iconfont icon-youjiantou"})])]),_vm._v(" "),_c('router-link',{staticClass:"profile-row-padding",attrs:{"to":'/profile/edit?type=QQ号码&value='+_vm.userInfo.qq}},[_c('div',{staticClass:"profile-label"},[_vm._v("QQ号码")]),_vm._v(" "),_c('div',{staticClass:"profile-value"},[_vm._v(_vm._s(_vm.userInfo.qq)),_c('i',{staticClass:"iconfont icon-youjiantou"})])]),_vm._v(" "),_c('router-link',{staticClass:"profile-row-padding",attrs:{"to":'/profile/edit?type=企业名称&value='+_vm.userInfo.company.name}},[_c('div',{staticClass:"profile-label"},[_vm._v("企业名称")]),_vm._v(" "),_c('div',{staticClass:"profile-value"},[_vm._v(_vm._s(_vm.userInfo.company.name)),_c('i',{staticClass:"iconfont icon-youjiantou"})])]),_vm._v(" "),_c('router-link',{staticClass:"profile-row-padding",attrs:{"to":'/profile/edit?type=企业地址&value='+_vm.userInfo.company.address}},[_c('div',{staticClass:"profile-label"},[_vm._v("企业地址")]),_vm._v(" "),_c('div',{staticClass:"profile-value"},[_vm._v(_vm._s(_vm.userInfo.company.address)),_c('i',{staticClass:"iconfont icon-youjiantou"})])]),_vm._v(" "),_c('router-link',{staticClass:"profile-row-padding",attrs:{"to":'/profile/edit?type=企业网址&value='+_vm.userInfo.company.site}},[_c('div',{staticClass:"profile-label"},[_vm._v("企业网址")]),_vm._v(" "),_c('div',{staticClass:"profile-value"},[_vm._v(_vm._s(_vm.userInfo.company.site)),_c('i',{staticClass:"iconfont icon-youjiantou"})])])],1)])])}
var profile_staticRenderFns = []
var profile_esExports = { render: profile_render, staticRenderFns: profile_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_profile = (profile_esExports);
// CONCATENATED MODULE: ./src/pages/profile/index.vue
function profile_injectStyle (ssrContext) {
  __webpack_require__("2kye")
}
var profile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var profile___vue_template_functional__ = false
/* styles */
var profile___vue_styles__ = profile_injectStyle
/* scopeId */
var profile___vue_scopeId__ = "data-v-5467955e"
/* moduleIdentifier (server only) */
var profile___vue_module_identifier__ = null
var profile_Component = profile_normalizeComponent(
  selectortype_script_index_0_src_pages_profile,
  selectortype_template_index_0_src_pages_profile,
  profile___vue_template_functional__,
  profile___vue_styles__,
  profile___vue_scopeId__,
  profile___vue_module_identifier__
)

/* harmony default export */ var src_pages_profile = (profile_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js + 1 modules
var base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var components_toast = __webpack_require__("rLAy");

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: components_toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        width: this.labelWidthComputed || this.$parent.labelWidth || this.labelWidthComputed,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }

      var selection = this.$refs.input.selectionStart;
      var direction = newVal.length - oldVal.length;
      selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
      this.lastDirection = direction;
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: components_toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        width: this.labelWidthComputed || this.$parent.labelWidth || this.labelWidthComputed,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }

      var selection = this.$refs.input.selectionStart;
      var direction = newVal.length - oldVal.length;
      selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
      this.lastDirection = direction;
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d662f60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"click":function($event){return _vm.clear($event)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("y8mh")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = (x_input_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/changePwd/index.vue







/* harmony default export */ var changePwd = ({
  components: {
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button

  },
  data: function data() {
    return {
      passwordModel: {
        password: '',
        password_confirmation: '',
        password_old: ''
      }
    };
  },

  methods: {
    handleChangePwd: function handleChangePwd() {
      var _this = this;

      changePassword(this.passwordModel).then(function (resp) {
        _this.$vux.toast.show({
          text: '密码修改成功',
          type: 'success',
          time: 3000,
          onHide: function onHide() {
            this.$router.go(-1);
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/changePwd/index.vue







/* harmony default export */ var pages_changePwd = ({
  components: {
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button

  },
  data: function data() {
    return {
      passwordModel: {
        password: '',
        password_confirmation: '',
        password_old: ''
      }
    };
  },

  methods: {
    handleChangePwd: function handleChangePwd() {
      var _this = this;

      changePassword(this.passwordModel).then(function (resp) {
        _this.$vux.toast.show({
          text: '密码修改成功',
          type: 'success',
          time: 3000,
          onHide: function onHide() {
            this.$router.go(-1);
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fec63de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/changePwd/index.vue
var changePwd_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page__bd"},[_c('div',{staticClass:"login-group"},[_c('img',{staticClass:"big_logo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/login/xmb_logo_big.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-ziyuanxhdpi"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"type":"password","max":11,"is-type":"china-mobile","placeholder":"原密码"},model:{value:(_vm.passwordModel.password),callback:function ($$v) {_vm.$set(_vm.passwordModel, "password", $$v)},expression:"passwordModel.password"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-xieboke"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"type":"password","placeholder":"新密码"},model:{value:(_vm.passwordModel.password_confirmation),callback:function ($$v) {_vm.$set(_vm.passwordModel, "password_confirmation", $$v)},expression:"passwordModel.password_confirmation"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-xieboke"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"type":"password","placeholder":"确认密码"},model:{value:(_vm.passwordModel.password_old),callback:function ($$v) {_vm.$set(_vm.passwordModel, "password_old", $$v)},expression:"passwordModel.password_old"}})],1)]),_vm._v(" "),_c('div',{staticClass:"submit-btn",on:{"click":_vm.handleChangePwd}},[_vm._v("\n      确认修改\n    ")])])])}
var changePwd_staticRenderFns = []
var changePwd_esExports = { render: changePwd_render, staticRenderFns: changePwd_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_changePwd = (changePwd_esExports);
// CONCATENATED MODULE: ./src/pages/changePwd/index.vue
function changePwd_injectStyle (ssrContext) {
  __webpack_require__("bPw3")
}
var changePwd_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var changePwd___vue_template_functional__ = false
/* styles */
var changePwd___vue_styles__ = changePwd_injectStyle
/* scopeId */
var changePwd___vue_scopeId__ = "data-v-7fec63de"
/* moduleIdentifier (server only) */
var changePwd___vue_module_identifier__ = null
var changePwd_Component = changePwd_normalizeComponent(
  pages_changePwd,
  selectortype_template_index_0_src_pages_changePwd,
  changePwd___vue_template_functional__,
  changePwd___vue_styles__,
  changePwd___vue_scopeId__,
  changePwd___vue_module_identifier__
)

/* harmony default export */ var src_pages_changePwd = (changePwd_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profileEdit/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var profileEdit = ({
  data: function data() {
    return {
      userInfo: {
        name: '',
        email: '',
        qq: '',
        company: ''
      },
      type: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])({
    setTitleVuex: 'SET_TITLE'
  }), {
    // 修改小程序头部名称
    changeNavTitle: function changeNavTitle(title) {
      var newTitle = '\u4FEE\u6539' + title;
      this.setTitleVuex(newTitle);
      // wx.setNavigationBarTitle({
      //   title: '修改' + title
      // });
    },
    getUserInfo: function getUserInfo() {
      var _this = this;

      fetchUser().then(function (resp) {
        _this.userInfo = {
          name: resp.data.name,
          email: resp.data.email,
          qq: resp.data.qq,
          company: resp.data.company
        };
      });
    },
    handleSave: function handleSave() {
      var _this2 = this;

      editUserInfo(this.userInfo).then(function (resp) {
        _this2.$router.go(-1);
      }).catch(function (err) {
        if (err.status === 422) {
          _this2.$vux.toast.show({
            text: err.message,
            time: 3000
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
      this.changeNavTitle(this.type);
    }
    this.getUserInfo();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profileEdit/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_profileEdit = ({
  data: function data() {
    return {
      userInfo: {
        name: '',
        email: '',
        qq: '',
        company: ''
      },
      type: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])({
    setTitleVuex: 'SET_TITLE'
  }), {
    // 修改小程序头部名称
    changeNavTitle: function changeNavTitle(title) {
      var newTitle = '\u4FEE\u6539' + title;
      this.setTitleVuex(newTitle);
      // wx.setNavigationBarTitle({
      //   title: '修改' + title
      // });
    },
    getUserInfo: function getUserInfo() {
      var _this = this;

      fetchUser().then(function (resp) {
        _this.userInfo = {
          name: resp.data.name,
          email: resp.data.email,
          qq: resp.data.qq,
          company: resp.data.company
        };
      });
    },
    handleSave: function handleSave() {
      var _this2 = this;

      editUserInfo(this.userInfo).then(function (resp) {
        _this2.$router.go(-1);
      }).catch(function (err) {
        if (err.status === 422) {
          _this2.$vux.toast.show({
            text: err.message,
            time: 3000
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
      this.changeNavTitle(this.type);
    }
    this.getUserInfo();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b355b672","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profileEdit/index.vue
var profileEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page__bd"},[_c('div',{staticClass:"weui-cells weui-cells_after-title"},[_c('div',{staticClass:"weui-cell weui-cell_input"},[_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.type==='用户名称'),expression:"type==='用户名称'"},{name:"model",rawName:"v-model",value:(_vm.userInfo.name),expression:"userInfo.name"}],staticClass:"weui-input",attrs:{"placeholder":"请输入"},domProps:{"value":(_vm.userInfo.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "name", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.type==='邮箱'),expression:"type==='邮箱'"},{name:"model",rawName:"v-model",value:(_vm.userInfo.email),expression:"userInfo.email"}],staticClass:"weui-input",attrs:{"placeholder":"请输入"},domProps:{"value":(_vm.userInfo.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "email", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.type==='QQ号码'),expression:"type==='QQ号码'"},{name:"model",rawName:"v-model",value:(_vm.userInfo.qq),expression:"userInfo.qq"}],staticClass:"weui-input",attrs:{"placeholder":"请输入"},domProps:{"value":(_vm.userInfo.qq)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "qq", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.type==='企业名称'),expression:"type==='企业名称'"},{name:"model",rawName:"v-model",value:(_vm.userInfo.company.name),expression:"userInfo.company.name"}],staticClass:"weui-input",attrs:{"placeholder":"请输入"},domProps:{"value":(_vm.userInfo.company.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo.company, "name", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.type==='企业地址'),expression:"type==='企业地址'"},{name:"model",rawName:"v-model",value:(_vm.userInfo.company.address),expression:"userInfo.company.address"}],staticClass:"weui-input",attrs:{"placeholder":"请输入"},domProps:{"value":(_vm.userInfo.company.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo.company, "address", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.type==='企业网址'),expression:"type==='企业网址'"},{name:"model",rawName:"v-model",value:(_vm.userInfo.company.site),expression:"userInfo.company.site"}],staticClass:"weui-input",attrs:{"placeholder":"请输入"},domProps:{"value":(_vm.userInfo.company.site)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo.company, "site", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"save-btn",on:{"click":function($event){_vm.handleSave()}}},[_vm._v("\n      保存\n    ")])])])}
var profileEdit_staticRenderFns = []
var profileEdit_esExports = { render: profileEdit_render, staticRenderFns: profileEdit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_profileEdit = (profileEdit_esExports);
// CONCATENATED MODULE: ./src/pages/profileEdit/index.vue
function profileEdit_injectStyle (ssrContext) {
  __webpack_require__("StpQ")
}
var profileEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var profileEdit___vue_template_functional__ = false
/* styles */
var profileEdit___vue_styles__ = profileEdit_injectStyle
/* scopeId */
var profileEdit___vue_scopeId__ = "data-v-b355b672"
/* moduleIdentifier (server only) */
var profileEdit___vue_module_identifier__ = null
var profileEdit_Component = profileEdit_normalizeComponent(
  pages_profileEdit,
  selectortype_template_index_0_src_pages_profileEdit,
  profileEdit___vue_template_functional__,
  profileEdit___vue_styles__,
  profileEdit___vue_scopeId__,
  profileEdit___vue_module_identifier__
)

/* harmony default export */ var src_pages_profileEdit = (profileEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/rechargeHistory/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var rechargeHistory = ({
  data: function data() {
    return {
      historyItems: {},
      page: 1
    };
  },

  components: {
    PullTo: vue_pull_to_default.a
  },
  methods: {
    getHistory: function getHistory(isNew) {
      var _this = this;

      if (isNew === 'new') {
        this.page++;
      } else {
        this.page = 1;
      }
      getFinanceTransaction(this.page).then(function (resp) {
        var historyItems = resp.data.map(function (item) {
          var createAt = formatTime(item.created_at);
          return extends_default()({
            createAt: createAt
          }, item);
        });
        if (isNew === 'new') {
          _this.historyItems = _this.historyItems.concat(historyItems);
        } else {
          _this.historyItems = historyItems;
        }
      });
    }
  },
  mounted: function mounted() {
    this.getHistory();
  }
  // onReachBottom () {
  //   this.getHistory('new');
  // }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/rechargeHistory/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var pages_rechargeHistory = ({
  data: function data() {
    return {
      historyItems: {},
      page: 1
    };
  },

  components: {
    PullTo: vue_pull_to_default.a
  },
  methods: {
    getHistory: function getHistory(isNew) {
      var _this = this;

      if (isNew === 'new') {
        this.page++;
      } else {
        this.page = 1;
      }
      getFinanceTransaction(this.page).then(function (resp) {
        var historyItems = resp.data.map(function (item) {
          var createAt = formatTime(item.created_at);
          return extends_default()({
            createAt: createAt
          }, item);
        });
        if (isNew === 'new') {
          _this.historyItems = _this.historyItems.concat(historyItems);
        } else {
          _this.historyItems = historyItems;
        }
      });
    }
  },
  mounted: function mounted() {
    this.getHistory();
  }
  // onReachBottom () {
  //   this.getHistory('new');
  // }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c21af16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rechargeHistory/index.vue
var rechargeHistory_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pull-to',{on:{"infinite-scroll":function($event){_vm.getHistory('new')}}},[_c('div',{staticClass:"page"},[_c('div',{staticClass:"page__bd page__bd_spacing"},[_vm._l((_vm.historyItems),function(item,index){return _c('flexbox',{key:index,staticClass:"weui-cell weui-cell_access history-list",attrs:{"hover-class":"weui-cell_active"}},[_c('flexbox-item',{staticClass:"weui-cell__bd weui-cell_primary"},[_c('div',{staticClass:"weui-media-box__title weui-media-box__title_in-text"},[_c('span',{staticClass:"recharge-title"},[_vm._v(_vm._s(item.subject))]),_vm._v(" "),(item.object ==='recharge')?_c('span',{staticClass:"recharge-title-tips"},[_vm._v("成功")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-media-box__desc"},[_vm._v("\n            "+_vm._s(item.createAt)+"\n          ")])]),_vm._v(" "),_c('flexbox-item',{staticClass:"recharge-list-right"},[_c('div',{staticClass:"recharge-type"},[_vm._v("\n            "+_vm._s(item.object_text)+"\n          ")]),_vm._v(" "),_c('div',[(item.object ==='purchase')?_c('span',[_vm._v("-")]):_c('span',{staticStyle:{"color":"#ff622b"}},[_vm._v("+")]),_vm._v(" "),_c('span',{staticClass:"recharge-amount",class:{'recharge-active':item.object ==='recharge'}},[_vm._v(_vm._s(item.amount)+"元")])])])],1)}),_vm._v(" "),(_vm.historyItems.length === 0)?_c('div',[_c('h4',{staticStyle:{"text-align":"center","margin-top":"100px"}},[_vm._v("切换标签搜索指定内容")]),_vm._v(" "),_c('img',{staticClass:"search-blank",staticStyle:{"width":"176px"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/data-blank.png","alt":""}}),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","color":"#999"}},[_vm._v("\n          当前没有搜索数据~\n        ")])]):_vm._e()],2)])])}
var rechargeHistory_staticRenderFns = []
var rechargeHistory_esExports = { render: rechargeHistory_render, staticRenderFns: rechargeHistory_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_rechargeHistory = (rechargeHistory_esExports);
// CONCATENATED MODULE: ./src/pages/rechargeHistory/index.vue
function rechargeHistory_injectStyle (ssrContext) {
  __webpack_require__("8xu2")
}
var rechargeHistory_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var rechargeHistory___vue_template_functional__ = false
/* styles */
var rechargeHistory___vue_styles__ = rechargeHistory_injectStyle
/* scopeId */
var rechargeHistory___vue_scopeId__ = "data-v-4c21af16"
/* moduleIdentifier (server only) */
var rechargeHistory___vue_module_identifier__ = null
var rechargeHistory_Component = rechargeHistory_normalizeComponent(
  pages_rechargeHistory,
  selectortype_template_index_0_src_pages_rechargeHistory,
  rechargeHistory___vue_template_functional__,
  rechargeHistory___vue_styles__,
  rechargeHistory___vue_scopeId__,
  rechargeHistory___vue_module_identifier__
)

/* harmony default export */ var src_pages_rechargeHistory = (rechargeHistory_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/login/index.vue












/* harmony default export */ var pages_login = (extends_default()({
  components: {
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button

  },
  data: function data() {
    return {
      loginModel: {
        tabIndex: 0,
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        captcha_token: '',
        captcha_sms: '',
        scope: 'mobile_signup',
        device: 'wap'
      },
      loginMode2: {
        tabIndex: 0,
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        captcha_token: '',
        captcha_sms: '',
        scope: 'mobile_signup',
        device: 'wap'
      },
      captchaImg: '',
      smsCount: 0,
      smsDisable: false
    };
  },


  methods: {
    changeTab: function changeTab(index) {
      this.loginModel.tabIndex = index;
      console.log(index);
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login() {
      var _this2 = this;

      authLogin(this.loginMode2).then(function (res) {
        setCookie('token', stringify_default()(res.data.token));
        fetchUser().then(function (resp) {
          _this2.setProfile(resp.data);
        });
        _this2.$router.push('/me');
      }).catch(function (e) {
        _this2.$vux.toast.show({
          text: e.message,
          type: 'cancel'
        });
        _this2.getCaptcha();
        _this2.loginMode2.captcha = '';
        console.log('登录失败', e);
      });
    },
    getTextCaptcha: function getTextCaptcha() {
      var _this3 = this;

      if (!this.smsDisable) {
        if (!this.loginModel.captcha) {
          this.$vux.toast.show({
            text: '请输入正确的验证码',
            time: 1000
          });
          this.getCaptcha();
          return false;
        } else if (!this.loginModel.mobile) {
          this.$vux.toast.show({
            text: '请输入手机号',
            time: 1000
          });
          return false;
        } else {
          var textCaptchaModel = {
            captcha: this.loginModel.captcha,
            captcha_token: this.loginModel.captcha_token,
            mobile: this.loginModel.mobile,
            scope: 'mobile_signup'
          };
          var fly = new fly_default.a();
          fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
            method: 'post'
          }).then(function (resp) {
            if (!resp.data.success) {
              _this3.getCaptcha();
            } else {
              _this3.smsCountDown();
            }
            _this3.$vux.toast.show({
              text: resp.data.message,
              time: 1000
            });
          }).catch(function (e) {
            return console.log('获取短信验证码失败', e);
          });
        }
      }
    },
    register: function register() {
      var _this4 = this;

      authRegister(this.loginModel).then(function (res) {
        _this4.$vux.toast.show({
          text: '注册成功',
          time: 1000
        });
        _this4.$router.replace('/register-profile');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 1000
        });
      });
    },
    getCaptcha: function getCaptcha() {
      var _this5 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this5.captchaImg = resp.data.data.src;
        _this5.loginModel.captcha_token = resp.data.data.captcha_token;
        _this5.loginMode2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    }
  }

}, Object(vuex_esm["c" /* mapMutations */])({
  setProfile: 'SET_PROFILE'
}), {
  getCaptcha: function getCaptcha() {
    var _this6 = this;

    var fly = new fly_default.a();
    fly.config.withCredentials = true;
    fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
      method: 'post'
    }).then(function (resp) {
      _this6.captchaImg = resp.data.data.src;
      _this6.loginMode2.captcha_token = resp.data.data.captcha_token;
    }).catch(function (e) {
      return console.log('error', e);
    });
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/login/index.vue












/* harmony default export */ var selectortype_script_index_0_src_pages_login = (extends_default()({
  components: {
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button

  },
  data: function data() {
    return {
      loginModel: {
        tabIndex: 0,
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        captcha_token: '',
        captcha_sms: '',
        scope: 'mobile_signup',
        device: 'wap'
      },
      loginMode2: {
        tabIndex: 0,
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        captcha_token: '',
        captcha_sms: '',
        scope: 'mobile_signup',
        device: 'wap'
      },
      captchaImg: '',
      smsCount: 0,
      smsDisable: false
    };
  },


  methods: {
    changeTab: function changeTab(index) {
      this.loginModel.tabIndex = index;
      console.log(index);
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login() {
      var _this2 = this;

      authLogin(this.loginMode2).then(function (res) {
        setCookie('token', stringify_default()(res.data.token));
        fetchUser().then(function (resp) {
          _this2.setProfile(resp.data);
        });
        _this2.$router.push('/me');
      }).catch(function (e) {
        _this2.$vux.toast.show({
          text: e.message,
          type: 'cancel'
        });
        _this2.getCaptcha();
        _this2.loginMode2.captcha = '';
        console.log('登录失败', e);
      });
    },
    getTextCaptcha: function getTextCaptcha() {
      var _this3 = this;

      if (!this.smsDisable) {
        if (!this.loginModel.captcha) {
          this.$vux.toast.show({
            text: '请输入正确的验证码',
            time: 1000
          });
          this.getCaptcha();
          return false;
        } else if (!this.loginModel.mobile) {
          this.$vux.toast.show({
            text: '请输入手机号',
            time: 1000
          });
          return false;
        } else {
          var textCaptchaModel = {
            captcha: this.loginModel.captcha,
            captcha_token: this.loginModel.captcha_token,
            mobile: this.loginModel.mobile,
            scope: 'mobile_signup'
          };
          var fly = new fly_default.a();
          fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
            method: 'post'
          }).then(function (resp) {
            if (!resp.data.success) {
              _this3.getCaptcha();
            } else {
              _this3.smsCountDown();
            }
            _this3.$vux.toast.show({
              text: resp.data.message,
              time: 1000
            });
          }).catch(function (e) {
            return console.log('获取短信验证码失败', e);
          });
        }
      }
    },
    register: function register() {
      var _this4 = this;

      authRegister(this.loginModel).then(function (res) {
        _this4.$vux.toast.show({
          text: '注册成功',
          time: 1000
        });
        _this4.$router.replace('/register-profile');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 1000
        });
      });
    },
    getCaptcha: function getCaptcha() {
      var _this5 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this5.captchaImg = resp.data.data.src;
        _this5.loginModel.captcha_token = resp.data.data.captcha_token;
        _this5.loginMode2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    }
  }

}, Object(vuex_esm["c" /* mapMutations */])({
  setProfile: 'SET_PROFILE'
}), {
  getCaptcha: function getCaptcha() {
    var _this6 = this;

    var fly = new fly_default.a();
    fly.config.withCredentials = true;
    fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
      method: 'post'
    }).then(function (resp) {
      _this6.captchaImg = resp.data.data.src;
      _this6.loginMode2.captcha_token = resp.data.data.captcha_token;
    }).catch(function (e) {
      return console.log('error', e);
    });
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21f5e3e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/index.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',[_c('div',{staticClass:"page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tab-user"},[_c('div',{staticClass:"tab-li",class:{ 'tab-li-checked': _vm.loginModel.tabIndex == 0 },on:{"click":function($event){_vm.changeTab(0)}}},[_vm._v("\n      登录\n    ")]),_vm._v(" "),_c('div',{staticClass:"tab-li",class:{ 'tab-li-checked': _vm.loginModel.tabIndex == 1 },on:{"click":function($event){_vm.changeTab(1)}}},[_vm._v("\n      注册\n    ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginModel.tabIndex == 0),expression:"loginModel.tabIndex == 0"}],staticClass:"login"},[_c('div',{staticClass:"page__bd"},[_c('group',{staticClass:"login-group"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-shouji"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"is-type":"china-mobile","placeholder":"请输入手机号","required":""},model:{value:(_vm.loginMode2.mobile),callback:function ($$v) {_vm.$set(_vm.loginMode2, "mobile", $$v)},expression:"loginMode2.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-ziyuanxhdpi"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"type":"password","placeholder":"请输入密码","required":""},model:{value:(_vm.loginMode2.password),callback:function ($$v) {_vm.$set(_vm.loginMode2, "password", $$v)},expression:"loginMode2.password"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li",staticStyle:{"width":"48vw","position":"relative"}},[_c('i',{staticClass:"iconfont icon-tupianyanzhengma"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入验证码","label-width":"200"},model:{value:(_vm.loginMode2.captcha),callback:function ($$v) {_vm.$set(_vm.loginMode2, "captcha", $$v)},expression:"loginMode2.captcha"}}),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})],1),_vm._v(" "),_c('div',[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login()}}},[_vm._v("立即登录")])],1)]),_vm._v(" "),_c('flexbox',{staticClass:"other-operate"},[_c('flexbox-item',[_c('router-link',{staticClass:"weui-flex__item",attrs:{"to":"/forgotPwd"}},[_vm._v("\n            忘记密码？\n          ")])],1),_vm._v(" "),_c('flexbox-item')],1)],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginModel.tabIndex == 1),expression:"loginModel.tabIndex == 1"}],staticClass:"register"},[_c('div',{staticClass:"page__bd"},[_c('group',{staticClass:"login-group"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-shouji"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"is-type":"china-mobile","placeholder":"请输入手机号"},model:{value:(_vm.loginModel.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel, "mobile", $$v)},expression:"loginModel.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-xieboke"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请设置登录密码"},model:{value:(_vm.loginModel.password),callback:function ($$v) {_vm.$set(_vm.loginModel, "password", $$v)},expression:"loginModel.password"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li",staticStyle:{"width":"48vw","position":"relative"}},[_c('i',{staticClass:"iconfont icon-tupianyanzhengma"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入验证码","label-width":"200"},model:{value:(_vm.loginModel.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha", $$v)},expression:"loginModel.captcha"}}),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li",staticStyle:{"width":"48vw","position":"relative"}},[_c('i',{staticClass:"iconfont icon-sadasuande"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码"},model:{value:(_vm.loginModel.captcha_sms),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha_sms", $$v)},expression:"loginModel.captcha_sms"}}),_vm._v(" "),_c('div',{staticClass:"get-message-code",class:{disable:_vm.smsDisable},attrs:{"slot":"right-full-height","disabled":_vm.smsDisable},on:{"click":_vm.getTextCaptcha},slot:"right-full-height"},[_vm._v(_vm._s(_vm.smsCount || '获取验证码')+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"user-sign-service"},[_c('i',{staticClass:"iconfont icon-xuanzhong"}),_vm._v(" "),_c('p',[_vm._v("我已阅读并同意"),_c('a',{attrs:{"href":"/agreement"}},[_vm._v("《服务条款》")])])]),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.register()}}},[_vm._v("注册")])],1)])],1)])])])}
var login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page__hd"},[_c('div',{staticClass:"page__title"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":"http://ruanmeng_site.test/images/logo.png","alt":""}})])])])}]
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_login = (login_esExports);
// CONCATENATED MODULE: ./src/pages/login/index.vue
function login_injectStyle (ssrContext) {
  __webpack_require__("eoOV")
  __webpack_require__("Spra")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = "data-v-21f5e3e0"
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  selectortype_script_index_0_src_pages_login,
  selectortype_template_index_0_src_pages_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var src_pages_login = (login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/register/index.vue












/* harmony default export */ var pages_register = (extends_default()({
  components: {
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button

  },
  data: function data() {
    return {
      loginModel: {
        tabIndex: 0,
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        captcha_token: '',
        captcha_sms: '',
        ruanmeng: 'ruanmeng',
        scope: 'mobile_signup',
        device: 'wap'
      },
      loginMode2: {
        tabIndex: 0,
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        captcha_token: '',
        captcha_sms: '',
        ruanmeng: 'ruanmeng',
        scope: 'mobile_signup',
        device: 'wap'
      },
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false
    };
  },


  methods: {
    changeTab: function changeTab(index) {
      this.loginModel.tabIndex = index;
      console.log(index);
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login() {
      var _this2 = this;

      authLogin(this.loginMode2).then(function (res) {
        setCookie('token', stringify_default()(res.data.token));
        fetchUser().then(function (resp) {
          _this2.setProfile(resp.data);
        });
        _this2.$router.push('/me');
      }).catch(function (e) {
        _this2.$vux.toast.show({
          text: e.message,
          type: 'cancel'
        });
        _this2.getCaptcha();
        _this2.loginMode2.captcha = '';
        console.log('登录失败', e);
      });
    },
    getTextCaptcha: function getTextCaptcha() {
      var _this3 = this;

      if (!this.smsDisable) {
        if (!this.loginModel.captcha) {
          this.$vux.toast.show({
            text: '请输入正确的验证码',
            time: 1000
          });
          this.getCaptcha();
          return false;
        } else if (!this.loginModel.mobile) {
          this.$vux.toast.show({
            text: '请输入手机号',
            time: 1000
          });
          return false;
        } else {
          var textCaptchaModel = {
            captcha: this.loginModel.captcha,
            captcha_token: this.loginModel.captcha_token,
            mobile: this.loginModel.mobile,
            scope: 'mobile_signup'
          };
          var fly = new fly_default.a();
          fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
            method: 'post'
          }).then(function (resp) {
            if (!resp.data.success) {
              _this3.getCaptcha();
            } else {
              _this3.smsCountDown();
            }
            _this3.$vux.toast.show({
              text: resp.data.message,
              time: 1000
            });
          }).catch(function (e) {
            return console.log('获取短信验证码失败', e);
          });
        }
      }
    },
    register: function register() {
      var _this4 = this;

      authRegister(this.loginModel).then(function (res) {
        _this4.$vux.toast.show({
          text: '注册成功',
          time: 1000
        });
        _this4.$router.replace('/register-profile');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 1000
        });
      });
    },
    getCaptcha: function getCaptcha() {
      var _this5 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this5.captchaImg = resp.data.data.src;
        _this5.loginModel.captcha_token = resp.data.data.captcha_token;
        _this5.loginMode2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    }
  }

}, Object(vuex_esm["c" /* mapMutations */])({
  setProfile: 'SET_PROFILE'
}), {
  getCaptcha: function getCaptcha() {
    var _this6 = this;

    var fly = new fly_default.a();
    fly.config.withCredentials = true;
    fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
      method: 'post'
    }).then(function (resp) {
      _this6.captchaImg = resp.data.data.src;
      _this6.loginMode2.captcha_token = resp.data.data.captcha_token;
    }).catch(function (e) {
      return console.log('error', e);
    });
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/register/index.vue












/* harmony default export */ var selectortype_script_index_0_src_pages_register = (extends_default()({
  components: {
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button

  },
  data: function data() {
    return {
      loginModel: {
        tabIndex: 0,
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        captcha_token: '',
        captcha_sms: '',
        ruanmeng: 'ruanmeng',
        scope: 'mobile_signup',
        device: 'wap'
      },
      loginMode2: {
        tabIndex: 0,
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        captcha_token: '',
        captcha_sms: '',
        ruanmeng: 'ruanmeng',
        scope: 'mobile_signup',
        device: 'wap'
      },
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false
    };
  },


  methods: {
    changeTab: function changeTab(index) {
      this.loginModel.tabIndex = index;
      console.log(index);
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login() {
      var _this2 = this;

      authLogin(this.loginMode2).then(function (res) {
        setCookie('token', stringify_default()(res.data.token));
        fetchUser().then(function (resp) {
          _this2.setProfile(resp.data);
        });
        _this2.$router.push('/me');
      }).catch(function (e) {
        _this2.$vux.toast.show({
          text: e.message,
          type: 'cancel'
        });
        _this2.getCaptcha();
        _this2.loginMode2.captcha = '';
        console.log('登录失败', e);
      });
    },
    getTextCaptcha: function getTextCaptcha() {
      var _this3 = this;

      if (!this.smsDisable) {
        if (!this.loginModel.captcha) {
          this.$vux.toast.show({
            text: '请输入正确的验证码',
            time: 1000
          });
          this.getCaptcha();
          return false;
        } else if (!this.loginModel.mobile) {
          this.$vux.toast.show({
            text: '请输入手机号',
            time: 1000
          });
          return false;
        } else {
          var textCaptchaModel = {
            captcha: this.loginModel.captcha,
            captcha_token: this.loginModel.captcha_token,
            mobile: this.loginModel.mobile,
            scope: 'mobile_signup'
          };
          var fly = new fly_default.a();
          fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
            method: 'post'
          }).then(function (resp) {
            if (!resp.data.success) {
              _this3.getCaptcha();
            } else {
              _this3.smsCountDown();
            }
            _this3.$vux.toast.show({
              text: resp.data.message,
              time: 1000
            });
          }).catch(function (e) {
            return console.log('获取短信验证码失败', e);
          });
        }
      }
    },
    register: function register() {
      var _this4 = this;

      authRegister(this.loginModel).then(function (res) {
        _this4.$vux.toast.show({
          text: '注册成功',
          time: 1000
        });
        _this4.$router.replace('/register-profile');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 1000
        });
      });
    },
    getCaptcha: function getCaptcha() {
      var _this5 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this5.captchaImg = resp.data.data.src;
        _this5.loginModel.captcha_token = resp.data.data.captcha_token;
        _this5.loginMode2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    }
  }

}, Object(vuex_esm["c" /* mapMutations */])({
  setProfile: 'SET_PROFILE'
}), {
  getCaptcha: function getCaptcha() {
    var _this6 = this;

    var fly = new fly_default.a();
    fly.config.withCredentials = true;
    fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
      method: 'post'
    }).then(function (resp) {
      _this6.captchaImg = resp.data.data.src;
      _this6.loginMode2.captcha_token = resp.data.data.captcha_token;
    }).catch(function (e) {
      return console.log('error', e);
    });
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2d008d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/index.vue
var register_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',[_c('div',{staticClass:"page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tab-user"},[_c('div',{staticClass:"tab-li",class:{ 'tab-li-checked': _vm.loginModel.tabIndex == 1 },on:{"click":function($event){_vm.changeTab(1)}}},[_vm._v("\n            登录\n        ")]),_vm._v(" "),_c('div',{staticClass:"tab-li",class:{ 'tab-li-checked': _vm.loginModel.tabIndex == 0 },on:{"click":function($event){_vm.changeTab(0)}}},[_vm._v("\n            注册\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginModel.tabIndex == 1),expression:"loginModel.tabIndex == 1"}],staticClass:"login"},[_c('div',{staticClass:"page__bd"},[_c('group',{staticClass:"login-group"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-shouji"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"is-type":"china-mobile","placeholder":"请输入手机号","required":""},model:{value:(_vm.loginMode2.mobile),callback:function ($$v) {_vm.$set(_vm.loginMode2, "mobile", $$v)},expression:"loginMode2.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-ziyuanxhdpi"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"type":"password","placeholder":"请输入密码","required":""},model:{value:(_vm.loginMode2.password),callback:function ($$v) {_vm.$set(_vm.loginMode2, "password", $$v)},expression:"loginMode2.password"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li",staticStyle:{"width":"48vw","position":"relative"}},[_c('i',{staticClass:"iconfont icon-tupianyanzhengma"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入验证码","label-width":"200"},model:{value:(_vm.loginMode2.captcha),callback:function ($$v) {_vm.$set(_vm.loginMode2, "captcha", $$v)},expression:"loginMode2.captcha"}}),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})],1),_vm._v(" "),_c('div',[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login()}}},[_vm._v("立即登录")])],1)]),_vm._v(" "),_c('flexbox',{staticClass:"other-operate"},[_c('flexbox-item',[_c('router-link',{staticClass:"weui-flex__item",attrs:{"to":"/forgotPwd"}},[_vm._v("\n                        忘记密码？\n                    ")])],1),_vm._v(" "),_c('flexbox-item')],1)],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginModel.tabIndex == 0),expression:"loginModel.tabIndex == 0"}],staticClass:"register"},[_c('div',{staticClass:"page__bd"},[_c('group',{staticClass:"login-group"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-shouji"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"is-type":"china-mobile","placeholder":"请输入手机号"},model:{value:(_vm.loginModel.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel, "mobile", $$v)},expression:"loginModel.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-xieboke"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请设置登录密码"},model:{value:(_vm.loginModel.password),callback:function ($$v) {_vm.$set(_vm.loginModel, "password", $$v)},expression:"loginModel.password"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li",staticStyle:{"width":"48vw","position":"relative"}},[_c('i',{staticClass:"iconfont icon-tupianyanzhengma"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入验证码","label-width":"200"},model:{value:(_vm.loginModel.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha", $$v)},expression:"loginModel.captcha"}}),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li",staticStyle:{"width":"48vw","position":"relative"}},[_c('i',{staticClass:"iconfont icon-sadasuande"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码"},model:{value:(_vm.loginModel.captcha_sms),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha_sms", $$v)},expression:"loginModel.captcha_sms"}}),_vm._v(" "),_c('div',{staticClass:"get-message-code",class:{disable:_vm.smsDisable},attrs:{"slot":"right-full-height","disabled":_vm.smsDisable},on:{"click":_vm.getTextCaptcha},slot:"right-full-height"},[_vm._v(_vm._s(_vm.smsCount || '获取验证码')+"\n                    ")])],1),_vm._v(" "),_c('div',{staticClass:"user-sign-service"},[_c('i',{staticClass:"iconfont icon-xuanzhong"}),_vm._v(" "),_c('p',[_vm._v("我已阅读并同意"),_c('a',{attrs:{"href":"/agreement"}},[_vm._v("《服务条款》")])])]),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.register()}}},[_vm._v("注册")])],1)])],1)])])])}
var register_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page__hd"},[_c('div',{staticClass:"page__title"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":"http://ruanmeng_site.test/images/logo.png","alt":""}})])])])}]
var register_esExports = { render: register_render, staticRenderFns: register_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_register = (register_esExports);
// CONCATENATED MODULE: ./src/pages/register/index.vue
function register_injectStyle (ssrContext) {
  __webpack_require__("D42g")
  __webpack_require__("Wmg/")
}
var register_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var register___vue_template_functional__ = false
/* styles */
var register___vue_styles__ = register_injectStyle
/* scopeId */
var register___vue_scopeId__ = "data-v-f2d008d8"
/* moduleIdentifier (server only) */
var register___vue_module_identifier__ = null
var register_Component = register_normalizeComponent(
  selectortype_script_index_0_src_pages_register,
  selectortype_template_index_0_src_pages_register,
  register___vue_template_functional__,
  register___vue_styles__,
  register___vue_scopeId__,
  register___vue_module_identifier__
)

/* harmony default export */ var src_pages_register = (register_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/scroller.js
var picker_scroller = __webpack_require__("+geU");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/index.js
var components_flexbox = __webpack_require__("F3HL");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/chain.js
var chain = __webpack_require__("zDi5");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/value2name.js
var value2name = __webpack_require__("NE4E");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/is-array.js
var is_array = __webpack_require__("cEdU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var picker = ({
  name: 'picker',
  components: {
    Flexbox: components_flexbox["a" /* Flexbox */],
    FlexboxItem: components_flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new picker_scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new picker_scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_picker = ({
  name: 'picker',
  components: {
    Flexbox: components_flexbox["a" /* Flexbox */],
    FlexboxItem: components_flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new picker_scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new picker_scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e92ef554","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/picker/index.vue
var picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-picker"},[_c('flexbox',{attrs:{"gutter":0}},_vm._l((_vm.currentData),function(one,index){return _c('flexbox-item',{key:index,staticStyle:{"margin-left":"0"},attrs:{"span":_vm.columnWidth && _vm.columnWidth[index]}},[_c('div',{staticClass:"vux-picker-item",attrs:{"id":("vux-picker-" + _vm.uuid + "-" + index)}})])}))],1)}
var picker_staticRenderFns = []
var picker_esExports = { render: picker_render, staticRenderFns: picker_staticRenderFns }
/* harmony default export */ var src_components_picker = (picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/index.vue
function picker_injectStyle (ssrContext) {
  __webpack_require__("mT/2")
}
var picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var picker___vue_template_functional__ = false
/* styles */
var picker___vue_styles__ = picker_injectStyle
/* scopeId */
var picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var picker___vue_module_identifier__ = null
var picker_Component = picker_normalizeComponent(
  components_picker,
  src_components_picker,
  picker___vue_template_functional__,
  picker___vue_styles__,
  picker___vue_scopeId__,
  picker___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_picker = (picker_Component.exports);

// EXTERNAL MODULE: ./node_modules/array-find/find.js
var find = __webpack_require__("NXHL");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var components_selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var components_selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: components_selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ac472c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/selector/index.vue
var selector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-selector weui-cell",class:{
    'weui-cell_select': !_vm.readonly,
    'weui-cell_select-after': _vm.title
  }},[(_vm.title)?_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.cleanStyle({
        width: _vm.$parent.labelWidth,
        textAlign: _vm.$parent.labelAlign,
        marginRight: _vm.$parent.labelMarginRight
      })),attrs:{"for":("vux-selector-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_vm._v(" "),(!_vm.readonly)?_c('div',{staticClass:"weui-cell__bd"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-select",style:(_vm.cleanStyle({
        direction: _vm.direction,
        color: _vm.color
      })),attrs:{"id":("vux-selector-" + _vm.uuid),"name":_vm.name},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[(_vm.showPlaceholder)?_c('option',{domProps:{"value":_vm.value === null ? 'null' : '',"selected":_vm.isEmptyValue(_vm.value) && !!_vm.placeholder}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.fixIos)?_c('option',{attrs:{"disabled":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.processOptions),function(one){return _c('option',{domProps:{"value":one.key}},[_vm._v(_vm._s(one.value))])})],2)]):_c('div',{staticClass:"weui-cell__ft vux-selector-readonly"},[_vm._v("\n    "+_vm._s(_vm._f("findByKey")(_vm.value,_vm.processOptions))+"\n  ")])])}
var selector_staticRenderFns = []
var selector_esExports = { render: selector_render, staticRenderFns: selector_staticRenderFns }
/* harmony default export */ var src_components_selector = (selector_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/selector/index.vue
function selector_injectStyle (ssrContext) {
  __webpack_require__("b8fh")
}
var selector_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var selector___vue_template_functional__ = false
/* styles */
var selector___vue_styles__ = selector_injectStyle
/* scopeId */
var selector___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var selector___vue_module_identifier__ = null
var selector_Component = selector_normalizeComponent(
  components_selector,
  src_components_selector,
  selector___vue_template_functional__,
  selector___vue_styles__,
  selector___vue_scopeId__,
  selector___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_selector = (selector_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.js
var vue_select = __webpack_require__("T1ft");
var vue_select_default = /*#__PURE__*/__webpack_require__.n(vue_select);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/registerProfile/index.vue











/* harmony default export */ var registerProfile = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['profile'])),
  components: {
    vSelect: vue_select_default.a,
    Picker: vux_src_components_picker,
    XButton: vux_src_components_x_button,
    Selector: vux_src_components_selector,
    Group: vux_src_components_group
  },
  data: function data() {
    return {
      industryList: [],
      industryIndex: '',
      taxonomiesList: [{
        name: '软文营销',
        active: false
      }, {
        name: '微信公众号',
        active: false
      }, {
        name: '微博',
        active: false
      }, {
        name: '短视频',
        active: false
      }, {
        name: '视频直播',
        active: false
      }, {
        name: '信息流',
        active: false
      }]
    };
  },

  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])({
    setProfile: 'SET_PROFILE'
  }), {
    handleIndustrySelect: function handleIndustrySelect(e) {
      var idx = e.mp.detail.value;
      this.industryIndex = idx;
      this.profile.attribute.industry = this.industryList[idx];
    },
    handleTaxonomySelect: function handleTaxonomySelect(item, index) {
      var taxonomies = this.profile.attribute.taxonomies;
      var idx = taxonomies.indexOf(item.name);
      if (idx !== -1) {
        taxonomies.splice(idx, 1);
        this.taxonomiesList[index].active = false;
      } else {
        this.profile.attribute.taxonomies.push(item.name);
        this.taxonomiesList[index].active = true;
      }
      this.profile.attribute.taxonomies = taxonomies;
    },
    submitInfo: function submitInfo() {
      var _this = this;

      if (!this.profile.name || !this.profile.qq || !this.profile.company.name || !this.profile.attribute.industry || this.profile.attribute.taxonomies.length === 0) {
        this.$vux.toast.show({
          text: '请正确填写资料信息',
          time: 1000
        });
      } else {
        this.setProfile(this.profile);
        var profile = this.profile;
        profile.scope = 'attribute';
        editUserInfo(profile).then(function (res) {
          console.log('第一次注册填写资料提交成功', res);
          _this.$router.push('/');
        }).catch(function (err) {
          return console.log('修改资料错误', err);
        });
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    getIndustryList().then(function (res) {
      _this2.industryList = res.data.map(function (data) {
        return data.name;
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/registerProfile/index.vue











/* harmony default export */ var pages_registerProfile = ({
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['profile'])),
  components: {
    vSelect: vue_select_default.a,
    Picker: vux_src_components_picker,
    XButton: vux_src_components_x_button,
    Selector: vux_src_components_selector,
    Group: vux_src_components_group
  },
  data: function data() {
    return {
      industryList: [],
      industryIndex: '',
      taxonomiesList: [{
        name: '软文营销',
        active: false
      }, {
        name: '微信公众号',
        active: false
      }, {
        name: '微博',
        active: false
      }, {
        name: '短视频',
        active: false
      }, {
        name: '视频直播',
        active: false
      }, {
        name: '信息流',
        active: false
      }]
    };
  },

  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])({
    setProfile: 'SET_PROFILE'
  }), {
    handleIndustrySelect: function handleIndustrySelect(e) {
      var idx = e.mp.detail.value;
      this.industryIndex = idx;
      this.profile.attribute.industry = this.industryList[idx];
    },
    handleTaxonomySelect: function handleTaxonomySelect(item, index) {
      var taxonomies = this.profile.attribute.taxonomies;
      var idx = taxonomies.indexOf(item.name);
      if (idx !== -1) {
        taxonomies.splice(idx, 1);
        this.taxonomiesList[index].active = false;
      } else {
        this.profile.attribute.taxonomies.push(item.name);
        this.taxonomiesList[index].active = true;
      }
      this.profile.attribute.taxonomies = taxonomies;
    },
    submitInfo: function submitInfo() {
      var _this = this;

      if (!this.profile.name || !this.profile.qq || !this.profile.company.name || !this.profile.attribute.industry || this.profile.attribute.taxonomies.length === 0) {
        this.$vux.toast.show({
          text: '请正确填写资料信息',
          time: 1000
        });
      } else {
        this.setProfile(this.profile);
        var profile = this.profile;
        profile.scope = 'attribute';
        editUserInfo(profile).then(function (res) {
          console.log('第一次注册填写资料提交成功', res);
          _this.$router.push('/');
        }).catch(function (err) {
          return console.log('修改资料错误', err);
        });
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    getIndustryList().then(function (res) {
      _this2.industryList = res.data.map(function (data) {
        return data.name;
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ef194f9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/registerProfile/index.vue
var registerProfile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page__bd page__bd_spacing"},[_c('div',{staticClass:"weui-cells weui-cells_after-title"},[_c('div',{staticClass:"weui-cell weui-cell_input"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.name),expression:"profile.name"}],staticClass:"weui-input",domProps:{"value":(_vm.profile.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"weui-cell weui-cell_input"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.qq),expression:"profile.qq"}],staticClass:"weui-input",attrs:{"type":"number"},domProps:{"value":(_vm.profile.qq)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "qq", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"weui-cell weui-cell_input"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.company.name),expression:"profile.company.name"}],staticClass:"weui-input",attrs:{"placeholder-style":"color:#dedede","placeholder":"非公司请填写个人"},domProps:{"value":(_vm.profile.company.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile.company, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"taxonomy-list"},[_c('h4',[_vm._v("推广类型")]),_vm._v(" "),_c('div',{staticClass:"weui-flex taxonomies"},_vm._l((_vm.taxonomiesList),function(item,index){return _c('div',{key:index,staticClass:"taxonomic-item",class:{'active':item.active},on:{"click":function($event){_vm.handleTaxonomySelect(item,index)}}},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")])}))]),_vm._v(" "),_c('group',[_c('selector',{attrs:{"title":"所属行业","options":_vm.industryList},model:{value:(_vm.profile.attribute.industry),callback:function ($$v) {_vm.$set(_vm.profile.attribute, "industry", $$v)},expression:"profile.attribute.industry"}})],1),_vm._v(" "),_c('div',{staticClass:"weui-btn-area",staticStyle:{"margin-top":"100px"}},[_c('x-button',{staticStyle:{"background":"#ff622b"},attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submitInfo($event)}}},[_vm._v("提交")])],1)],1)])}
var registerProfile_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell__hd"},[_c('div',{staticClass:"weui-label"},[_vm._v("姓名")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell__hd"},[_c('div',{staticClass:"weui-label"},[_vm._v("联系QQ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell__hd"},[_c('div',{staticClass:"weui-label"},[_vm._v("公司名称")])])}]
var registerProfile_esExports = { render: registerProfile_render, staticRenderFns: registerProfile_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_registerProfile = (registerProfile_esExports);
// CONCATENATED MODULE: ./src/pages/registerProfile/index.vue
function registerProfile_injectStyle (ssrContext) {
  __webpack_require__("mEq0")
  __webpack_require__("RCUt")
}
var registerProfile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var registerProfile___vue_template_functional__ = false
/* styles */
var registerProfile___vue_styles__ = registerProfile_injectStyle
/* scopeId */
var registerProfile___vue_scopeId__ = "data-v-5ef194f9"
/* moduleIdentifier (server only) */
var registerProfile___vue_module_identifier__ = null
var registerProfile_Component = registerProfile_normalizeComponent(
  pages_registerProfile,
  selectortype_template_index_0_src_pages_registerProfile,
  registerProfile___vue_template_functional__,
  registerProfile___vue_styles__,
  registerProfile___vue_scopeId__,
  registerProfile___vue_module_identifier__
)

/* harmony default export */ var src_pages_registerProfile = (registerProfile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/forgotPwd/index.vue








/* harmony default export */ var forgotPwd = ({
  components: {
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        comfirmpwd: '',
        identity: 'advertiser',
        captcha: '',
        captcha_token: '',
        captcha_sms: '',
        scope: 'mobile_forgot'
      },
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false
    };
  },

  methods: {
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        console.log(_this.smsCount);
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    register: function register() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.request('https://api.ruan.net/api/auth/forgot_password', this.loginModel, {
        method: 'post'
      }).then(function (resp) {
        if (resp.data.success) {

          console.log('密码修改成功');
          _this2.$router.replace('/login');
        }
        _this2.$vux.toast.show({
          text: resp.data.message,
          time: 1000
        });
      }).catch(function (e) {
        return console.log('重置密码失败', e);
      });
    },
    getTextCaptcha: function getTextCaptcha() {
      var _this3 = this;

      if (!this.loginModel.captcha) {
        this.$vux.toast.show({
          text: '请输入正确的验证码',
          time: 1000
        });
        this.getCaptcha();
      }
      if (!this.loginModel.mobile) {
        this.$vux.toast.show({
          text: '请输入手机号',
          time: 1000
        });
      }
      var textCaptchaModel = {
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        mobile: this.loginModel.mobile,
        scope: 'mobile_forgot'
      };
      var fly = new fly_default.a();
      fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
        method: 'post'
      }).then(function (resp) {
        if (!resp.data.success) {
          _this3.getCaptcha();
        } else {
          _this3.smsCountDown();
        }
        _this3.$vux.toast.show({
          text: resp.data.message,
          time: 1000
        });
      }).catch(function (e) {
        return console.log('获取短信验证码失败', e);
      });
    },
    getCaptcha: function getCaptcha() {
      var _this4 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this4.captchaImg = resp.data.data.src;
        _this4.loginModel.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/forgotPwd/index.vue








/* harmony default export */ var pages_forgotPwd = ({
  components: {
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        comfirmpwd: '',
        identity: 'advertiser',
        captcha: '',
        captcha_token: '',
        captcha_sms: '',
        scope: 'mobile_forgot'
      },
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false
    };
  },

  methods: {
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        console.log(_this.smsCount);
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    register: function register() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.request('https://api.ruan.net/api/auth/forgot_password', this.loginModel, {
        method: 'post'
      }).then(function (resp) {
        if (resp.data.success) {

          console.log('密码修改成功');
          _this2.$router.replace('/login');
        }
        _this2.$vux.toast.show({
          text: resp.data.message,
          time: 1000
        });
      }).catch(function (e) {
        return console.log('重置密码失败', e);
      });
    },
    getTextCaptcha: function getTextCaptcha() {
      var _this3 = this;

      if (!this.loginModel.captcha) {
        this.$vux.toast.show({
          text: '请输入正确的验证码',
          time: 1000
        });
        this.getCaptcha();
      }
      if (!this.loginModel.mobile) {
        this.$vux.toast.show({
          text: '请输入手机号',
          time: 1000
        });
      }
      var textCaptchaModel = {
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        mobile: this.loginModel.mobile,
        scope: 'mobile_forgot'
      };
      var fly = new fly_default.a();
      fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
        method: 'post'
      }).then(function (resp) {
        if (!resp.data.success) {
          _this3.getCaptcha();
        } else {
          _this3.smsCountDown();
        }
        _this3.$vux.toast.show({
          text: resp.data.message,
          time: 1000
        });
      }).catch(function (e) {
        return console.log('获取短信验证码失败', e);
      });
    },
    getCaptcha: function getCaptcha() {
      var _this4 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this4.captchaImg = resp.data.data.src;
        _this4.loginModel.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12cbf393","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/forgotPwd/index.vue
var forgotPwd_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"page__bd"},[_c('group',{staticClass:"login-group"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-shouji"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"is-type":"china-mobile","placeholder":"请输入手机号码"},model:{value:(_vm.loginModel.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel, "mobile", $$v)},expression:"loginModel.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li",staticStyle:{"width":"48vw","position":"relative"}},[_c('i',{staticClass:"iconfont icon-tupianyanzhengma"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入验证码","label-width":"200"},model:{value:(_vm.loginModel.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha", $$v)},expression:"loginModel.captcha"}}),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li",staticStyle:{"width":"48vw","position":"relative"}},[_c('i',{staticClass:"iconfont icon-sadasuande"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码"},model:{value:(_vm.loginModel.captcha_sms),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha_sms", $$v)},expression:"loginModel.captcha_sms"}}),_vm._v(" "),_c('div',{staticClass:"get-message-code",class:{disable:_vm.smsDisable},attrs:{"slot":"right-full-height","disabled":_vm.smsDisable},on:{"click":_vm.getTextCaptcha},slot:"right-full-height"},[_vm._v(_vm._s(_vm.smsCount || '获取验证码')+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-xieboke"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"type":"password","placeholder":"请设置新密码"},model:{value:(_vm.loginModel.password),callback:function ($$v) {_vm.$set(_vm.loginModel, "password", $$v)},expression:"loginModel.password"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-xieboke"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"type":"password","placeholder":"请再次输入密码"},model:{value:(_vm.loginModel.comfirmpwd),callback:function ($$v) {_vm.$set(_vm.loginModel, "comfirmpwd", $$v)},expression:"loginModel.comfirmpwd"}})],1),_vm._v(" "),_c('div',[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.register()}}},[_vm._v("提交")])],1)])],1)])}
var forgotPwd_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page__hd"},[_c('div',{staticClass:"page__title"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/login/xmb_logo_big.png","alt":""}})])])])}]
var forgotPwd_esExports = { render: forgotPwd_render, staticRenderFns: forgotPwd_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_forgotPwd = (forgotPwd_esExports);
// CONCATENATED MODULE: ./src/pages/forgotPwd/index.vue
function forgotPwd_injectStyle (ssrContext) {
  __webpack_require__("xLFd")
  __webpack_require__("qpl0")
}
var forgotPwd_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var forgotPwd___vue_template_functional__ = false
/* styles */
var forgotPwd___vue_styles__ = forgotPwd_injectStyle
/* scopeId */
var forgotPwd___vue_scopeId__ = "data-v-12cbf393"
/* moduleIdentifier (server only) */
var forgotPwd___vue_module_identifier__ = null
var forgotPwd_Component = forgotPwd_normalizeComponent(
  pages_forgotPwd,
  selectortype_template_index_0_src_pages_forgotPwd,
  forgotPwd___vue_template_functional__,
  forgotPwd___vue_styles__,
  forgotPwd___vue_scopeId__,
  forgotPwd___vue_module_identifier__
)

/* harmony default export */ var src_pages_forgotPwd = (forgotPwd_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/collect/index.vue











/* harmony default export */ var collect = ({
  data: function data() {
    return {
      tabs: [{
        tabName: '软文',
        navName: '软文推广',
        tabType: 'news',
        sortField: ['', 'price', 'pc_baidu_rank', 'm_baidu_rank', 'publish_rate'],
        priceType: [],
        priceTypeName: []
      }, {
        tabName: '微信',
        navName: '微信营销',
        tabType: 'woa',
        sortField: ['', 'price', 'price_second', 'fan_num'],
        priceType: ['top', 'non_top'],
        priceTypeName: ['头条价', '非头条价']
      }, {
        tabName: '微博',
        navName: '微博营销',
        tabType: 'weibo',
        sortField: ['', 'price', 'fan_num', 'avg_retweet_num', 'avg_like_num'],
        priceType: ['tweet', 'retweet'],
        priceTypeName: ['直发价', '转发价']
      }, {
        tabName: '网红',
        navName: '网红直播',
        tabType: 'live',
        sortField: ['', 'price', 'fan_num'],
        priceType: ['online', 'offline'],
        priceTypeName: ['线上直播', '线下转发']
      }, {
        tabName: '短视频',
        navName: '视频营销',
        tabType: 'video',
        sortField: ['', 'price', 'avg_play_num', 'fan_num'],
        priceType: ['original_publish', 'publish'],
        priceTypeName: ['原创发布', '发布']
      }],
      activeIndex: 0,
      resourceData: []
    };
  },

  components: {
    PullTo: vue_pull_to_default.a,
    Actionsheet: vux_src_components_actionsheet,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  },
  directives: {
    focus: vue_focus_common["focus"]
  },
  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])({
    setTitleVuex: 'SET_TITLE'
  }), {
    tabClick: function tabClick(idx) {
      this.activeIndex = idx;
      this.getDataByTab();
    },
    getDataByTab: function getDataByTab(type) {
      var _this2 = this;

      this.resourceData = [];
      var tabType = this.tabs[this.activeIndex].tabType;
      fetchResource(tabType, { group_type: 'collect', per_page: 100 }).then(function (resp) {
        var resourceDataNew = resp.data.map(function (data) {
          var avgReadNum = formatNumInTenThousand(data.analysis.avg_read_num);
          var fansNum = formatNumInTenThousand(data.analysis.fans_num);
          var avgPlayNum = formatNumInTenThousand(data.analysis.avg_play_num);
          var price = formatNumInTenThousand(data.quote.price);
          var priceSecond = formatNumInTenThousand(data.quote.price_second);
          var cartStatus = data.cart && data.cart.created_at;
          var likeNum = formatNumInTenThousand(data.analysis.avg_like_num);
          var priceBoxIsShow = false;
          return {
            id: data.id,
            avatar: data.avatar,
            name: data.name,
            cart: data.cart,
            category: data.category,
            analysis: data.analysis,
            quote: data.quote,
            description: data.description,
            publish_rate: data.analysis.publish_rate,
            remark: data.remark,
            weight: data.weight,
            taxonomy: data.taxonomy,
            collectionId: data.collection.id,
            avgReadNum: avgReadNum,
            fansNum: fansNum,
            avgPlayNum: avgPlayNum,
            price: price,
            priceSecond: priceSecond,
            cartStatus: cartStatus,
            priceBoxIsShow: priceBoxIsShow,
            type: type,
            likeNum: likeNum
          };
        });
        if (type === 'new') {
          _this2.resourceData = _this2.resourceData.concat(resourceDataNew);
        } else {
          _this2.resourceData = resourceDataNew;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleCancelCollect: function handleCancelCollect(data) {
      var _this = this;
      this.$vux.confirm.show({
        content: '确定取消收藏？',
        onConfirm: function onConfirm() {
          deleteFromCollection(data.collectionId).then(function (resp) {
            _this.$vux.toast.show({
              text: resp.message
            });
            _this.getDataByTab();
          }).catch(function (e) {});
        }
      });
    },
    getTabStatus: function getTabStatus() {

      if (this.$route) {
        this.activeIndex = 0;
        this.getDataByTab();
      } else {
        this.resourceData = [];
      }
    }
  }),
  beforeMount: function beforeMount() {
    this.getTabStatus();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/collect/index.vue











/* harmony default export */ var pages_collect = ({
  data: function data() {
    return {
      tabs: [{
        tabName: '软文',
        navName: '软文推广',
        tabType: 'news',
        sortField: ['', 'price', 'pc_baidu_rank', 'm_baidu_rank', 'publish_rate'],
        priceType: [],
        priceTypeName: []
      }, {
        tabName: '微信',
        navName: '微信营销',
        tabType: 'woa',
        sortField: ['', 'price', 'price_second', 'fan_num'],
        priceType: ['top', 'non_top'],
        priceTypeName: ['头条价', '非头条价']
      }, {
        tabName: '微博',
        navName: '微博营销',
        tabType: 'weibo',
        sortField: ['', 'price', 'fan_num', 'avg_retweet_num', 'avg_like_num'],
        priceType: ['tweet', 'retweet'],
        priceTypeName: ['直发价', '转发价']
      }, {
        tabName: '网红',
        navName: '网红直播',
        tabType: 'live',
        sortField: ['', 'price', 'fan_num'],
        priceType: ['online', 'offline'],
        priceTypeName: ['线上直播', '线下转发']
      }, {
        tabName: '短视频',
        navName: '视频营销',
        tabType: 'video',
        sortField: ['', 'price', 'avg_play_num', 'fan_num'],
        priceType: ['original_publish', 'publish'],
        priceTypeName: ['原创发布', '发布']
      }],
      activeIndex: 0,
      resourceData: []
    };
  },

  components: {
    PullTo: vue_pull_to_default.a,
    Actionsheet: vux_src_components_actionsheet,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  },
  directives: {
    focus: vue_focus_common["focus"]
  },
  methods: extends_default()({}, Object(vuex_esm["c" /* mapMutations */])({
    setTitleVuex: 'SET_TITLE'
  }), {
    tabClick: function tabClick(idx) {
      this.activeIndex = idx;
      this.getDataByTab();
    },
    getDataByTab: function getDataByTab(type) {
      var _this2 = this;

      this.resourceData = [];
      var tabType = this.tabs[this.activeIndex].tabType;
      fetchResource(tabType, { group_type: 'collect', per_page: 100 }).then(function (resp) {
        var resourceDataNew = resp.data.map(function (data) {
          var avgReadNum = formatNumInTenThousand(data.analysis.avg_read_num);
          var fansNum = formatNumInTenThousand(data.analysis.fans_num);
          var avgPlayNum = formatNumInTenThousand(data.analysis.avg_play_num);
          var price = formatNumInTenThousand(data.quote.price);
          var priceSecond = formatNumInTenThousand(data.quote.price_second);
          var cartStatus = data.cart && data.cart.created_at;
          var likeNum = formatNumInTenThousand(data.analysis.avg_like_num);
          var priceBoxIsShow = false;
          return {
            id: data.id,
            avatar: data.avatar,
            name: data.name,
            cart: data.cart,
            category: data.category,
            analysis: data.analysis,
            quote: data.quote,
            description: data.description,
            publish_rate: data.analysis.publish_rate,
            remark: data.remark,
            weight: data.weight,
            taxonomy: data.taxonomy,
            collectionId: data.collection.id,
            avgReadNum: avgReadNum,
            fansNum: fansNum,
            avgPlayNum: avgPlayNum,
            price: price,
            priceSecond: priceSecond,
            cartStatus: cartStatus,
            priceBoxIsShow: priceBoxIsShow,
            type: type,
            likeNum: likeNum
          };
        });
        if (type === 'new') {
          _this2.resourceData = _this2.resourceData.concat(resourceDataNew);
        } else {
          _this2.resourceData = resourceDataNew;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleCancelCollect: function handleCancelCollect(data) {
      var _this = this;
      this.$vux.confirm.show({
        content: '确定取消收藏？',
        onConfirm: function onConfirm() {
          deleteFromCollection(data.collectionId).then(function (resp) {
            _this.$vux.toast.show({
              text: resp.message
            });
            _this.getDataByTab();
          }).catch(function (e) {});
        }
      });
    },
    getTabStatus: function getTabStatus() {

      if (this.$route) {
        this.activeIndex = 0;
        this.getDataByTab();
      } else {
        this.resourceData = [];
      }
    }
  }),
  beforeMount: function beforeMount() {
    this.getTabStatus();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bff38fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/collect/index.vue
var collect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pull-to',{on:{"infinite-scroll":function($event){_vm.getDataByTab('new')}}},[_c('div',{staticClass:"page"},[_c('div',{staticClass:"page__bd"},[_c('tab',{attrs:{"scroll-threshold":5,"active-color":"#ff622b","bar-active-color":"#ff622b"}},_vm._l((_vm.tabs),function(item,index){return _c('tab-item',{key:index,attrs:{"selected":_vm.activeIndex==index},on:{"on-item-click":_vm.tabClick}},[_vm._v("\n          "+_vm._s(item.tabName)+"\n        ")])})),_vm._v(" "),_c('div',{staticClass:"weui-tab__panel"},[_vm._l((_vm.resourceData),function(item ,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceData.length!=0),expression:"resourceData.length!=0"}],key:index,staticClass:"tab-content"},[_c('div',{staticClass:"tab-content-inner"},[(_vm.activeIndex>=1)?_c('router-link',{staticClass:"card-box-img",attrs:{"to":'/media/detail/'+item.id+'?type='+_vm.tabs[_vm.activeIndex].tabType}},[_c('img',{attrs:{"src":item.avatar,"alt":""}})]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"card-li-info",attrs:{"to":'/media/detail/'+item.id+'?type='+_vm.tabs[_vm.activeIndex].tabType}},[_c('div',{staticClass:"card-content-li"},[_c('div',{staticClass:"firstline"},[(_vm.activeIndex==0)?_c('i',{staticClass:"iconfont icon-ruanwen-huoyan"}):_vm._e(),_vm._v(" "),(_vm.activeIndex==1)?_c('i',{staticClass:"iconfont icon-weixinicon"}):_vm._e(),_vm._v(" "),(_vm.activeIndex==2)?_c('i',{staticClass:"iconfont icon-weibo1"}):_vm._e(),_vm._v(" "),(_vm.activeIndex==3)?_c('i',{staticClass:"iconfont icon-dingdan-wanghongzhibo"}):_vm._e(),_vm._v(" "),(_vm.activeIndex==4)?_c('i',{staticClass:"iconfont icon-dingdan-duanshipin"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-box-title"},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('div',{staticClass:"firstline"},[_c('div',{staticClass:"card-box-description"},[_vm._v(_vm._s(item.description?item.description:'暂无简介'))])]),_vm._v(" "),_c('div',{staticClass:"firstline"},[_c('div',{staticClass:"card-mark"},[_vm._v(_vm._s(item.category.name))]),_vm._v(" "),(_vm.activeIndex==0)?_c('div',{staticClass:"card-mark"},[_vm._v("出稿率"+_vm._s(item.publish_rate)+"%")]):_c('div',{staticClass:"card-mark"},[_vm._v("粉丝"+_vm._s(item.fansNum)+"\n                  ")]),_vm._v(" "),(_vm.activeIndex==0)?_c('div',{staticClass:"card-mark"},[_c('i',{staticClass:"iconfont icon-baiduicon"}),_vm._v("\n                    "+_vm._s(item.weight)+"\n                  ")]):(_vm.activeIndex==1)?_c('div',{staticClass:"card-mark"},[_vm._v("阅读"+_vm._s(item.avgReadNum))]):(_vm.activeIndex==2)?_c('div',{staticClass:"card-mark"},[_vm._v("点赞"+_vm._s(item.likeNum))]):(_vm.activeIndex==3)?_c('div',{staticClass:"card-mark"},[_vm._v("点赞"+_vm._s(item.likeNum))]):_c('div',{staticClass:"card-mark"},[_vm._v("播放"+_vm._s(item.avgPlayNum))])]),_vm._v(" "),_c('div',{staticClass:"firstline"},[_c('div',{staticClass:"firstline-left"},[(_vm.activeIndex==0)?_c('div',{staticClass:"refer-price"},[_vm._v("参考价:"),_c('span',[_vm._v("￥"+_vm._s(item.quote.price)+"元")])]):(_vm.activeIndex==1)?_c('div',{staticClass:"refer-price"},[_vm._v("\n                      头条价："),_c('span',[_vm._v("￥"+_vm._s(item.price?item.price+'元':'-'))])]):(_vm.activeIndex==2)?_c('div',{staticClass:"refer-price"},[_vm._v("\n                      直发价："),_c('span',[_vm._v("￥"+_vm._s(item.price?item.price+'元':'-'))])]):(_vm.activeIndex==3)?_c('div',{staticClass:"refer-price"},[_vm._v("线上直播："),_c('span',[_vm._v("￥"+_vm._s(item.price)+"元")])]):(_vm.activeIndex==4)?_c('div',{staticClass:"refer-price"},[_vm._v("原创发布："),_c('span',[_vm._v("￥"+_vm._s(item.price)+"元")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"firstline-left"},[(_vm.activeIndex==0)?_c('div',{staticClass:"refer-price"}):(_vm.activeIndex==1)?_c('div',{staticClass:"refer-price"},[_vm._v("非头条价："),_c('span',[_vm._v(_vm._s(item.priceSecond?item.priceSecond+'元':'-'))])]):(_vm.activeIndex==2)?_c('div',{staticClass:"refer-price"},[_vm._v("转发价："),_c('span',[_vm._v(_vm._s(item.priceSecond))])]):(_vm.activeIndex==3)?_c('div',{staticClass:"refer-price"},[_vm._v("线下活动："),_c('span',[_vm._v(_vm._s(item.price)+"元")])]):(_vm.activeIndex==4)?_c('div',{staticClass:"refer-price"},[_vm._v("发布："),_c('span',[_vm._v(_vm._s(item.price)+"元")])]):_vm._e()])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"card-operation"},[_c('i',{staticClass:"iconfont icon-shoucang",on:{"click":function($event){_vm.handleCancelCollect(item)}}})])])],1)])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceData.length===0),expression:"resourceData.length===0"}]},[_c('h4',{staticStyle:{"text-align":"center","margin-top":"100px"}},[_vm._v("切换标签搜索指定内容")]),_vm._v(" "),_c('img',{staticClass:"search-blank",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/search-blank.png","alt":""}}),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","color":"#999"}},[_vm._v("\n            当前没有搜索数据~\n          ")])])],2)],1)])])}
var collect_staticRenderFns = []
var collect_esExports = { render: collect_render, staticRenderFns: collect_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_collect = (collect_esExports);
// CONCATENATED MODULE: ./src/pages/collect/index.vue
function collect_injectStyle (ssrContext) {
  __webpack_require__("fGAH")
}
var collect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var collect___vue_template_functional__ = false
/* styles */
var collect___vue_styles__ = collect_injectStyle
/* scopeId */
var collect___vue_scopeId__ = "data-v-6bff38fe"
/* moduleIdentifier (server only) */
var collect___vue_module_identifier__ = null
var collect_Component = collect_normalizeComponent(
  pages_collect,
  selectortype_template_index_0_src_pages_collect,
  collect___vue_template_functional__,
  collect___vue_styles__,
  collect___vue_scopeId__,
  collect___vue_module_identifier__
)

/* harmony default export */ var src_pages_collect = (collect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/finance/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var finance = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }],
      promoAdvantages: [{
        iconName: 'shuju1',
        iconSize: '12.5vw',
        iconPosition: '-21%',
        iconLeft: '-9%',
        promoAdvanTitle: '数据分析 ',
        promoAdvanDescription: '市场分析、竞品分析、本品分析、受众分析;'
      }, {
        iconName: 'ico_yishenggongzuozhan_meilifangan',
        iconSize: '12.5vw',
        iconPosition: '-8%',
        iconLeft: '-9%',
        promoAdvanTitle: '推广方案',
        promoAdvanDescription: '根据分析数据与传播目标，匹配最佳媒体投放组合，规划传播策略与推广方案;'
      }, {
        iconName: 'koubei',
        iconSize: '11.5vw',
        iconPosition: '14%',
        iconLeft: '12%',
        promoAdvanTitle: '创意投放 ',
        promoAdvanDescription: '通过文案、海报、视频、话题营销等各种类型的传播方式，为品牌宣传;'
      }, {
        iconName: 'shuju',
        iconSize: '15.5vw',
        iconPosition: '-28%',
        iconLeft: '-30%',
        promoAdvanTitle: '数据检测',
        promoAdvanDescription: '根据推广情况监测各渠道数据效果，及时优化反馈;'
      }, {
        iconName: 'youhuayunhang',
        iconSize: '11.5vw',
        iconPosition: '8%',
        iconLeft: '6%',
        promoAdvanTitle: '实时优化',
        promoAdvanDescription: '运营团队全程跟进，实时优化推广方案，以达到最佳传播效果;'
      }],
      bigDataContent: [{
        bigDataTitle: '市场分析',
        bigDataP1: '市场规模',
        bigDataP2: '行业现状',
        bigDataP3: '市场投放'
      }, {
        bigDataTitle: '竞品分析 ',
        bigDataP1: '竞品特点',
        bigDataP2: '竞品投放',
        bigDataP3: '竞品卖点'
      }, {
        bigDataTitle: '自身分析 ',
        bigDataP1: '品牌现状',
        bigDataP2: '品牌特点',
        bigDataP3: '投放情况'
      }, {
        bigDataTitle: '用户分析 ',
        bigDataP1: '用户年龄',
        bigDataP2: '用户属性',
        bigDataP3: '用户习惯'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/finance/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var solution_finance = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }],
      promoAdvantages: [{
        iconName: 'shuju1',
        iconSize: '12.5vw',
        iconPosition: '-21%',
        iconLeft: '-9%',
        promoAdvanTitle: '数据分析 ',
        promoAdvanDescription: '市场分析、竞品分析、本品分析、受众分析;'
      }, {
        iconName: 'ico_yishenggongzuozhan_meilifangan',
        iconSize: '12.5vw',
        iconPosition: '-8%',
        iconLeft: '-9%',
        promoAdvanTitle: '推广方案',
        promoAdvanDescription: '根据分析数据与传播目标，匹配最佳媒体投放组合，规划传播策略与推广方案;'
      }, {
        iconName: 'koubei',
        iconSize: '11.5vw',
        iconPosition: '14%',
        iconLeft: '12%',
        promoAdvanTitle: '创意投放 ',
        promoAdvanDescription: '通过文案、海报、视频、话题营销等各种类型的传播方式，为品牌宣传;'
      }, {
        iconName: 'shuju',
        iconSize: '15.5vw',
        iconPosition: '-28%',
        iconLeft: '-30%',
        promoAdvanTitle: '数据检测',
        promoAdvanDescription: '根据推广情况监测各渠道数据效果，及时优化反馈;'
      }, {
        iconName: 'youhuayunhang',
        iconSize: '11.5vw',
        iconPosition: '8%',
        iconLeft: '6%',
        promoAdvanTitle: '实时优化',
        promoAdvanDescription: '运营团队全程跟进，实时优化推广方案，以达到最佳传播效果;'
      }],
      bigDataContent: [{
        bigDataTitle: '市场分析',
        bigDataP1: '市场规模',
        bigDataP2: '行业现状',
        bigDataP3: '市场投放'
      }, {
        bigDataTitle: '竞品分析 ',
        bigDataP1: '竞品特点',
        bigDataP2: '竞品投放',
        bigDataP3: '竞品卖点'
      }, {
        bigDataTitle: '自身分析 ',
        bigDataP1: '品牌现状',
        bigDataP2: '品牌特点',
        bigDataP3: '投放情况'
      }, {
        bigDataTitle: '用户分析 ',
        bigDataP1: '用户年龄',
        bigDataP2: '用户属性',
        bigDataP3: '用户习惯'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0baaebe4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/solution/finance/index.vue
var finance_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_jr_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"finance-intelligent-data"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"finance-intelligent-data-content"},_vm._l((_vm.bigDataContent),function(item,index){return _c('div',{key:index,staticClass:"finance-intelligent-data-content-li"},[_c('h3',[_vm._v(_vm._s(item.bigDataTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.bigDataP1))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.bigDataP2))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.bigDataP3))])])}))]),_vm._v(" "),_c('div',{staticClass:"finance-app-advantages"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"finance-promo-advan-content"},_vm._l((_vm.promoAdvantages),function(item,index){return _c('div',{key:index,staticClass:"finance-promo-advan-content-li"},[_c('div',{staticClass:"finance-promo-advantages-fistline"},[_c('div',{staticClass:"finance-icon-box"},[_c('icon',{style:({marginTop:item.iconPosition,fontSize:item.iconSize,marginLeft:item.iconLeft}),attrs:{"type":"svg","name":item.iconName}})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.promoAdvanTitle))])]),_vm._v(" "),_c('p',{staticClass:"finance-promo-advantages-description"},[_vm._v(_vm._s(item.promoAdvanDescription))])])}))]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_jr_r"}})],1)}
var finance_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solution-banner"},[_c('div',{staticClass:"banner-text"},[_c('p',[_vm._v("覆/盖/精/准/用/户/同/时/提/"),_c('br'),_vm._v("高/公/信/力")]),_vm._v(" "),_c('div',{staticClass:"banner-btn"},[_c('a',{staticClass:"click-to-consult",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("助您实现品牌价值")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("金融行业推广困境")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-extend"},[_c('img',{staticClass:"finance-promo-trouble-pic",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/finance/tgkj_sc.png","alt":"金融行业推广困境"}}),_vm._v(" "),_c('div',{staticClass:"finance-extend-item"},[_c('div',{staticClass:"finance-extend-item-title"},[_vm._v("行业乱象")]),_vm._v(" "),_c('div',{staticClass:"finance-extend-item-content"},[_vm._v("个别投机品牌扰乱"),_c('br'),_vm._v("行业口碑")])]),_vm._v(" "),_c('div',{staticClass:"finance-extend-item",staticStyle:{"top":"11%","left":"20.5%"}},[_c('div',{staticClass:"finance-extend-item-title"},[_vm._v("品牌公信力不足")]),_vm._v(" "),_c('div',{staticClass:"finance-extend-item-content"},[_vm._v("难以获取用户信任")])]),_vm._v(" "),_c('div',{staticClass:"finance-extend-item",staticStyle:{"top":"25%","left":"40.5%"}},[_c('div',{staticClass:"finance-extend-item-title"},[_vm._v("推广渠道不明确")]),_vm._v(" "),_c('div',{staticClass:"finance-extend-item-content"},[_vm._v("难以获取精准用户")])]),_vm._v(" "),_c('div',{staticClass:"finance-extend-item",staticStyle:{"top":"8%","left":"60.5%"}},[_c('div',{staticClass:"finance-extend-item-title"},[_vm._v("竞品截流")]),_vm._v(" "),_c('div',{staticClass:"finance-extend-item-content"},[_vm._v("广告投放费用巨大"),_c('br'),_vm._v("却难获成效")])]),_vm._v(" "),_c('div',{staticClass:"finance-extend-item",staticStyle:{"top":"28%","left":"80%"}},[_c('div',{staticClass:"finance-extend-item-title"},[_vm._v("反馈信息不足")]),_vm._v(" "),_c('div',{staticClass:"finance-extend-item-content"},[_vm._v("广告投放后"),_c('br'),_vm._v("数据不明确")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"color":"#fff"}},[_vm._v("智能大数据分析")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20",staticStyle:{"margin-bottom":"10px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("金融行业推广策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finanace-self-advantages"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("金融行业推广方式")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"finanace-self-advantages-content"},[_c('div',{staticClass:"self-advantages-content-item"},[_c('div',{staticClass:"advantages-title"},[_vm._v("\n        口碑营销\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        通过新闻稿件全网渠道扩散，树立品牌正面口碑，建立用户对品牌的信任;\n      ")])]),_vm._v(" "),_c('div',{staticClass:"self-advantages-content-item"},[_c('div',{staticClass:"advantages-title"},[_vm._v("产品评测")]),_vm._v(" "),_c('p',[_vm._v("\n        邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;\n      ")])]),_vm._v(" "),_c('div',{staticClass:"self-advantages-content-item"},[_c('div',{staticClass:"advantages-title"},[_vm._v("金融自媒体")]),_vm._v(" "),_c('p',[_vm._v("\n        借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;\n      ")])]),_vm._v(" "),_c('div',{staticClass:"self-advantages-content-item"},[_c('div',{staticClass:"advantages-title"},[_vm._v("趣味短视频")]),_vm._v(" "),_c('p',[_vm._v("\n将枯燥的金融内容与时下热点结合，用创意包装品牌与产品，获得更多关注;\n      ")])]),_vm._v(" "),_c('div',{staticClass:"self-advantages-content-item"},[_c('div',{staticClass:"advantages-title"},[_vm._v("跨界合作")]),_vm._v(" "),_c('p',[_vm._v("通过大数据分析精准用户的兴趣领域，然后结合品牌与产品进行跨界合作，获取用户信赖与喜爱;")])]),_vm._v(" "),_c('div',{staticClass:"self-advantages-content-item"},[_c('div',{staticClass:"advantages-title"},[_vm._v("硬广投放")]),_vm._v(" "),_c('p',[_vm._v("\n        以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化;\n      ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"financial-industry-promotion"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("金融行业推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20",staticStyle:{"margin-bottom":"6%"}})]),_vm._v(" "),_c('div',{staticClass:"financial-industry-promotion-content"},[_c('div',{staticClass:"industry-content"},[_vm._v("\n          智能大数据分析，"),_c('br'),_vm._v("直达精准金融需求"),_c('br'),_vm._v("用户\n        ")]),_vm._v(" "),_c('div',{staticClass:"industry-title"},[_vm._v("精准用"),_c('br'),_vm._v("户获取\n        ")]),_vm._v(" "),_c('div',{staticClass:"industry-content",staticStyle:{"margin-top":"21%","margin-left":"63%"}},[_vm._v("\n          权威大号媒体，助"),_c('br'),_vm._v("力品牌公信力\n        ")]),_vm._v(" "),_c('div',{staticClass:"industry-title",staticStyle:{"margin-top":"-9%","margin-left":"18%"}},[_vm._v("海量权"),_c('br'),_vm._v(" 威资源  ")]),_vm._v(" "),_c('div',{staticClass:"industry-content",staticStyle:{"margin-top":"19%","margin-left":"6%"}},[_vm._v("\n         百万流量资源全平"),_c('br'),_vm._v("台覆盖，获取更多"),_c('br'),_vm._v("关注\n        ")]),_vm._v(" "),_c('div',{staticClass:"industry-title",staticStyle:{"margin-top":"-14%","margin-left":"68%"}},[_vm._v("全平台"),_c('br'),_vm._v("   覆盖  ")]),_vm._v(" "),_c('div',{staticClass:"industry-content",staticStyle:{"margin-top":"17%","margin-left":"62%"}},[_vm._v("\n          专属定制媒介组合、"),_c('br'),_vm._v("内容运营、投放策"),_c('br'),_vm._v("略，全方位整合营"),_c('br'),_vm._v("销\n        ")]),_vm._v(" "),_c('div',{staticClass:"industry-title",staticStyle:{"margin-top":"-16%","margin-left":"18%"}},[_vm._v("专业营 "),_c('br'),_vm._v("销经验  ")]),_vm._v(" "),_c('div',{staticClass:"industry-content",staticStyle:{"margin-top":"19%","margin-left":"5%"}},[_vm._v("\n          专项服务团队多对"),_c('br'),_vm._v("一服务跟进，7X12"),_c('br'),_vm._v("小时配合指导操作\n        ")]),_vm._v(" "),_c('div',{staticClass:"industry-title",staticStyle:{"margin-top":"-13%","margin-left":"68%"}},[_vm._v("高效专 "),_c('br'),_vm._v("属服务  ")])])])}]
var finance_esExports = { render: finance_render, staticRenderFns: finance_staticRenderFns }
/* harmony default export */ var pages_solution_finance = (finance_esExports);
// CONCATENATED MODULE: ./src/pages/solution/finance/index.vue
function finance_injectStyle (ssrContext) {
  __webpack_require__("vF4t")
}
var finance_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var finance___vue_template_functional__ = false
/* styles */
var finance___vue_styles__ = finance_injectStyle
/* scopeId */
var finance___vue_scopeId__ = "data-v-0baaebe4"
/* moduleIdentifier (server only) */
var finance___vue_module_identifier__ = null
var finance_Component = finance_normalizeComponent(
  solution_finance,
  pages_solution_finance,
  finance___vue_template_functional__,
  finance___vue_styles__,
  finance___vue_scopeId__,
  finance___vue_module_identifier__
)

/* harmony default export */ var src_pages_solution_finance = (finance_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/appPromotion/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var appPromotion = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        iconName: 'yingyongshangdiantuiguang',
        promoWaysTitle: '应用商店推广',
        promoWaysDescription: '上架各大应用商店，进行关键词覆盖、换量合作、广告投放等推广; '
      }, {
        iconName: 'xinxiliuguanggao1',
        promoWaysTitle: '信息流广告',
        promoWaysDescription: '筛选目标用户精准直达，通过各平台信息流广告实现优质曝光;'
      }, {
        iconName: 'shijianyingxiao1',
        promoWaysTitle: '事件营销',
        promoWaysDescription: '针对APP特点，制定个性化事件营销方案推广，吸引用户兴趣与关注;'
      }, {
        iconName: 'hongrentuiguang',
        promoWaysTitle: '红人推广',
        promoWaysDescription: '利用网红效应，选取受众相符的网红大号对粉丝推荐引导;'
      }, {
        iconName: 'gongguanruanwen',
        promoWaysTitle: '公关软文',
        promoWaysDescription: '科技报道，新闻稿件，软性植入，优化搜索情况，树立APP在网络上的正面形象; '
      }, {
        iconName: 'shipintoufang',
        promoWaysTitle: '视频投放',
        promoWaysDescription: '制作创意宣传视频，通过数据筛选精准用户，投放于各类视频网站;'
      }],
      promoAdvantages: [{
        iconName: 'jingzhunyonghuhuoqu1',
        promoAdvanTitle: '精准用户获取  ',
        promoAdvanDescription: '基于智能大数据分析，精确获取目标用户网络偏好;'
      }, {
        iconName: 'hailiangyouzhiziyuan',
        promoAdvanTitle: '海量优质资源',
        promoAdvanDescription: '覆盖90%以上有传播价值的媒体资源;'
      }, {
        iconName: 'yingyongshangdianyouhua',
        promoAdvanTitle: '应用商店优化 ',
        promoAdvanDescription: '提供数据分析、数据监测、关键词优化、榜单效果、竞品分析等全景化 ASO 营销服务;'
      }, {
        iconName: 'zhuanyeyingxiaojingyan',
        promoAdvanTitle: '专业营销经验 ',
        promoAdvanDescription: '根据推广情况监测各渠道数据效果，及时优化反馈;'
      }, {
        iconName: 'gaoxiaozhuanshufuwu',
        promoAdvanTitle: '高效专属服务',
        promoAdvanDescription: '专业运营团队跟进，实时优化推广方案，以达到最佳传播效果;'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/appPromotion/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var solution_appPromotion = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        iconName: 'yingyongshangdiantuiguang',
        promoWaysTitle: '应用商店推广',
        promoWaysDescription: '上架各大应用商店，进行关键词覆盖、换量合作、广告投放等推广; '
      }, {
        iconName: 'xinxiliuguanggao1',
        promoWaysTitle: '信息流广告',
        promoWaysDescription: '筛选目标用户精准直达，通过各平台信息流广告实现优质曝光;'
      }, {
        iconName: 'shijianyingxiao1',
        promoWaysTitle: '事件营销',
        promoWaysDescription: '针对APP特点，制定个性化事件营销方案推广，吸引用户兴趣与关注;'
      }, {
        iconName: 'hongrentuiguang',
        promoWaysTitle: '红人推广',
        promoWaysDescription: '利用网红效应，选取受众相符的网红大号对粉丝推荐引导;'
      }, {
        iconName: 'gongguanruanwen',
        promoWaysTitle: '公关软文',
        promoWaysDescription: '科技报道，新闻稿件，软性植入，优化搜索情况，树立APP在网络上的正面形象; '
      }, {
        iconName: 'shipintoufang',
        promoWaysTitle: '视频投放',
        promoWaysDescription: '制作创意宣传视频，通过数据筛选精准用户，投放于各类视频网站;'
      }],
      promoAdvantages: [{
        iconName: 'jingzhunyonghuhuoqu1',
        promoAdvanTitle: '精准用户获取  ',
        promoAdvanDescription: '基于智能大数据分析，精确获取目标用户网络偏好;'
      }, {
        iconName: 'hailiangyouzhiziyuan',
        promoAdvanTitle: '海量优质资源',
        promoAdvanDescription: '覆盖90%以上有传播价值的媒体资源;'
      }, {
        iconName: 'yingyongshangdianyouhua',
        promoAdvanTitle: '应用商店优化 ',
        promoAdvanDescription: '提供数据分析、数据监测、关键词优化、榜单效果、竞品分析等全景化 ASO 营销服务;'
      }, {
        iconName: 'zhuanyeyingxiaojingyan',
        promoAdvanTitle: '专业营销经验 ',
        promoAdvanDescription: '根据推广情况监测各渠道数据效果，及时优化反馈;'
      }, {
        iconName: 'gaoxiaozhuanshufuwu',
        promoAdvanTitle: '高效专属服务',
        promoAdvanDescription: '专业运营团队跟进，实时优化推广方案，以达到最佳传播效果;'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ea8a94a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/solution/appPromotion/index.vue
var appPromotion_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_app_t"}}),_vm._v(" "),_c('div',{staticClass:"solution-banner"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('img',{staticClass:"app-promo-trouble-pic",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/app/apptgkj.png","alt":"app推广困境"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"finance-promo-ways-box"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"finance-promo-ways-content"},_vm._l((_vm.promoWays),function(item,index){return _c('div',{key:index,staticClass:"finance-promo-ways-content-li"},[_c('div',{staticClass:"finance-promo-ways-firstline"},[_c('div',{staticClass:"app-icon-box"},[_c('icon',{attrs:{"type":"svg","name":item.iconName}})],1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(item.promoWaysTitle))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.promoWaysDescription))])])}))]),_vm._v(" "),_c('div',{staticClass:"finance-app-advantages"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"finance-promo-advan-content"},_vm._l((_vm.promoAdvantages),function(item,index){return _c('div',{key:index,staticClass:"finance-promo-advan-content-li"},[_c('div',{staticClass:"finance-promo-advantages-fistline"},[_c('div',{staticClass:"finance-icon-box-app"},[_c('icon',{attrs:{"type":"svg","name":item.iconName}})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.promoAdvanTitle))])]),_vm._v(" "),_c('p',{staticClass:"finance-promo-advantages-description"},[_vm._v(_vm._s(item.promoAdvanDescription))])])}))]),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_app_r"}})],1)}
var appPromotion_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("APP推广困境")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-promo-strategy-box "},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"color":"#fff"}},[_vm._v("APP推广策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"finance-box"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("APP推广方式")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("APP推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])}]
var appPromotion_esExports = { render: appPromotion_render, staticRenderFns: appPromotion_staticRenderFns }
/* harmony default export */ var pages_solution_appPromotion = (appPromotion_esExports);
// CONCATENATED MODULE: ./src/pages/solution/appPromotion/index.vue
function appPromotion_injectStyle (ssrContext) {
  __webpack_require__("PylY")
}
var appPromotion_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var appPromotion___vue_template_functional__ = false
/* styles */
var appPromotion___vue_styles__ = appPromotion_injectStyle
/* scopeId */
var appPromotion___vue_scopeId__ = "data-v-7ea8a94a"
/* moduleIdentifier (server only) */
var appPromotion___vue_module_identifier__ = null
var appPromotion_Component = appPromotion_normalizeComponent(
  solution_appPromotion,
  pages_solution_appPromotion,
  appPromotion___vue_template_functional__,
  appPromotion___vue_styles__,
  appPromotion___vue_scopeId__,
  appPromotion___vue_module_identifier__
)

/* harmony default export */ var src_pages_solution_appPromotion = (appPromotion_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/newProduct/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var newProduct = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/newProduct/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var solution_newProduct = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-506a1011","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/solution/newProduct/index.vue
var newProduct_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_wxb_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_wxb_r"}})],1)}
var newProduct_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solution-banner"},[_c('div',{staticClass:"banner-text"},[_c('a',{staticClass:"click-to-consult",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("我要推广")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("新品推广困境")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-promo-pic"},[_c('div',{staticClass:"promo-pic-item"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/appPromotion/cprzbz.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("产品认知不足")])]),_vm._v(" "),_c('div',{staticClass:"promo-pic-item",staticStyle:{"margin-left":"15%"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/appPromotion/cpxrbz.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("产品信任不足")])]),_vm._v(" "),_c('div',{staticClass:"promo-pic-item-1"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/appPromotion/gmdlbz.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("购买动力不足")])]),_vm._v(" "),_c('div',{staticClass:"promo-pic-item-1",staticStyle:{"margin-left":"12%"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/appPromotion/xlbz.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("销量不足")])]),_vm._v(" "),_c('div',{staticClass:"promo-pic-item-1",staticStyle:{"margin-left":"12%"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/appPromotion/llbg.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("流量不够")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-data-analyse"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("智能大数据分析")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-analyse-contnet-item text-center"},[_c('div',{staticClass:"data-analysis-tit"},[_vm._v("行业分析")]),_vm._v(" "),_c('p',[_vm._v("市场规模 市场容量 品类分析 产品分析   ")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item text-center"},[_c('div',{staticClass:"data-analysis-tit"},[_vm._v("竞品分析")]),_vm._v(" "),_c('p',[_vm._v("竞品规模 竞品特点 竞品价格 竞品卖点  ")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item text-center"},[_c('div',{staticClass:"data-analysis-tit"},[_vm._v("用户分析")]),_vm._v(" "),_c('p',[_vm._v("用户年龄 用户属性 用户行为 用户习惯   ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("新品推广策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/appPromotion/sjfx.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"12%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("数据分析 ")]),_vm._v(" "),_c('p',[_vm._v(" 汽车行业分析、竞品分析、本品分析、受众"),_c('br'),_vm._v("分析、媒体数据分析 ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('div',{staticClass:"app-content-text",staticStyle:{"margin-left":"-24%","margin-top":"14%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("推广方案 ")]),_vm._v(" "),_c('p',[_vm._v("根据分析数据与传播目标，匹配最佳媒体投"),_c('br'),_vm._v("放组合，规划传播策略与推广方案 ")])]),_vm._v(" "),_c('img',{staticStyle:{"margin-left":"5vw"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/appPromotion/tgfa.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/appPromotion/cytf.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"14%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("创意投放")]),_vm._v(" "),_c('p',[_vm._v("通过文案、海报、视频、话题营销等各种类"),_c('br'),_vm._v("型的传播方式，为品牌宣传")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"15%","margin-left":"-24%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("数据监测")]),_vm._v(" "),_c('p',[_vm._v("根据推广情况监测各渠道数据效果，及时优"),_c('br'),_vm._v("化反馈")])]),_vm._v(" "),_c('img',{staticStyle:{"margin-left":"5vw"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/appPromotion/sjjc.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li",staticStyle:{"margin-bottom":"9%"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/appPromotion/kbtg.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"15%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("口碑推广")]),_vm._v(" "),_c('p',[_vm._v("通过口碑引导，加深用户认知与好感度")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-promo-method"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"color":"#fff"}},[_vm._v("新品行业推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-method-content"},[_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("口碑维护")]),_vm._v(" "),_c('p',[_vm._v("利用kol的粉丝效应进行产品口碑教育引"),_c('br'),_vm._v("导，获取好感")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("事件营销")]),_vm._v(" "),_c('p',[_vm._v("为新品定制个性化方案引爆事件，吸引用"),_c('br'),_vm._v("户眼球\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("借势营销")]),_vm._v(" "),_c('p',[_vm._v("跟踪热点事件，与新品进行创意结合，获"),_c('br'),_vm._v("取流量\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("硬广投放")]),_vm._v(" "),_c('p',[_vm._v("基于精准用户习惯，与针对性的进行硬广"),_c('br'),_vm._v("投放，强势曝光\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("视频营销")]),_vm._v(" "),_c('p',[_vm._v("利用当下最流行，人气最高传播形式，定"),_c('br'),_vm._v("制特色视频，进行更广泛传播\n          ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-advantages"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("新品推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"app-advance-content"},[_c('div',{staticClass:"app-advance-content-item"},[_c('div',{staticClass:"title-item-h"},[_vm._v("海量优质资源\n        ")]),_vm._v(" "),_c('p',[_vm._v("覆盖90%以上有传播价值"),_c('br'),_vm._v("的媒体资源")])]),_vm._v(" "),_c('div',{staticClass:"app-advance-content-item"},[_c('div',{staticClass:"title-item-h"},[_vm._v("专业营销经验\n        ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"8%"}},[_vm._v("专属定制媒介组合、 "),_c('br'),_vm._v("内容运营、投放策略， "),_c('br'),_vm._v("全方位整合营销")])]),_vm._v(" "),_c('div',{staticClass:"app-advance-content-item"},[_c('div',{staticClass:"title-item-h"},[_vm._v("智能精准数据\n        ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"4%"}},[_vm._v("拥有专业技术团队，"),_c('br'),_vm._v(" 提供精确市场、 "),_c('br'),_vm._v("用户分析数据，精准输出")])]),_vm._v(" "),_c('div',{staticClass:"app-advance-content-item"},[_c('div',{staticClass:"title-item-h"},[_vm._v("高效专属服务\n        ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"8%"}},[_vm._v("专项服务团队多对一服务跟进， "),_c('br'),_vm._v("7*12小时配合指导操作")])])])])}]
var newProduct_esExports = { render: newProduct_render, staticRenderFns: newProduct_staticRenderFns }
/* harmony default export */ var pages_solution_newProduct = (newProduct_esExports);
// CONCATENATED MODULE: ./src/pages/solution/newProduct/index.vue
function newProduct_injectStyle (ssrContext) {
  __webpack_require__("ALsH")
}
var newProduct_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var newProduct___vue_template_functional__ = false
/* styles */
var newProduct___vue_styles__ = newProduct_injectStyle
/* scopeId */
var newProduct___vue_scopeId__ = "data-v-506a1011"
/* moduleIdentifier (server only) */
var newProduct___vue_module_identifier__ = null
var newProduct_Component = newProduct_normalizeComponent(
  solution_newProduct,
  pages_solution_newProduct,
  newProduct___vue_template_functional__,
  newProduct___vue_styles__,
  newProduct___vue_scopeId__,
  newProduct___vue_module_identifier__
)

/* harmony default export */ var src_pages_solution_newProduct = (newProduct_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/game/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var game = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }]

    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/game/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var solution_game = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }]

    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27cd12c5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/solution/game/index.vue
var game_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_game_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_game_r"}})],1)}
var game_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solution-banner"},[_c('div',{staticClass:"banner-text"},[_c('p',[_c('span',{staticStyle:{"color":"#F652E2FF"}},[_vm._v(" ·手游")]),_vm._v("   "),_c('span',{staticStyle:{"color":"#FF725DFF"}},[_vm._v("·页游")]),_vm._v("   "),_c('span',{staticStyle:{"color":"#00B4FFFF"}},[_vm._v(" ·端游")]),_vm._v("  · "),_c('br'),_vm._v("\n一站式解决方案，助您达成推广目标\n\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-trouble"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("新品推广困境")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/game/xtgkj.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"game-trouble-content"},[_vm._v("知名度 "),_c('br'),_vm._v("  不足")]),_vm._v(" "),_c('div',{staticClass:"game-trouble-content",staticStyle:{"top":"21%","left":"26.7%"}},[_vm._v("    推广  "),_c('br'),_vm._v("转化率低")]),_vm._v(" "),_c('div',{staticClass:"game-trouble-content",staticStyle:{"top":"21%","left":"62.5%"}},[_vm._v("   推广  "),_c('br'),_vm._v("成本高")]),_vm._v(" "),_c('div',{staticClass:"game-trouble-content",staticStyle:{"left":"79.4%","top":"53.4%"}},[_vm._v("    推广  "),_c('br'),_vm._v("方式单一")]),_vm._v(" "),_c('div',{staticClass:"game-trouble-content",staticStyle:{"left":"44.8%","top":"64.4%"}},[_vm._v("     用户 "),_c('br'),_vm._v(" 粘性不够 ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-data-analyse"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("智能大数据分析")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"newproduct-data-analyse-content"},[_c('div',{staticClass:"newproduct-data-analyse-content-li"},[_c('div',{staticClass:"data-analyse-li"},[_c('div',{staticClass:"data-analyse-li-title"},[_vm._v("\n                行业分析\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  市场规模\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  市场容量\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  市场投放\n              ")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li",staticStyle:{"left":"54.7%","top":"0%"}},[_c('div',{staticClass:"data-analyse-li-title"},[_vm._v("\n                  竞品分析\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  竞品类型\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  竞品特点\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  竞品投放\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  竞品卖点\n              ")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li",staticStyle:{"left":"3%","top":"51%"}},[_c('div',{staticClass:"data-analyse-li-title"},[_vm._v("\n                用户分析\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  用户年龄\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  用户属性\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  用户行为\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  用户习惯\n              ")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li",staticStyle:{"left":"54.7%","top":"51%"}},[_c('div',{staticClass:"data-analyse-li-title"},[_vm._v("\n                自身分析\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  游戏现状\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  游戏特点\n              ")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-li-content"},[_c('span',{staticClass:"circle-li"}),_vm._v("  投放情况\n              ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("游戏行业推广策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-promo-advan-content"},[_c('div',{staticClass:"finance-promo-advan-content-li"},[_c('div',{staticClass:"finance-promo-advantages-fistline"},[_c('div',{staticClass:"finance-promo-advantages-description"},[_vm._v("\n      数据分析\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n      游戏行业市场分析、竞品分析、本品分析、受众分析。\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"finance-promo-advan-content-li"},[_c('div',{staticClass:"finance-promo-advantages-fistline"},[_c('div',{staticClass:"finance-promo-advantages-description"},[_vm._v("\n    推广方案\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n    根据分析数据与传播目标，规划传播策略与推广方案。\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"finance-promo-advan-content-li"},[_c('div',{staticClass:"finance-promo-advantages-fistline"},[_c('div',{staticClass:"finance-promo-advantages-description"},[_vm._v("\n数据监测\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n根据推广情况监测各渠道数据效果，及时优化反馈。\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"finance-promo-advan-content-li"},[_c('div',{staticClass:"finance-promo-advantages-fistline"},[_c('div',{staticClass:"finance-promo-advantages-description"},[_vm._v("\n创意投放\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n通过文案、海报、视频、话题营销等各种类型的传播，"),_c('br'),_vm._v("为游戏宣传。\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"finance-promo-advan-content-li"},[_c('div',{staticClass:"finance-promo-advantages-fistline"},[_c('div',{staticClass:"finance-promo-advantages-description"},[_vm._v("\n实时优化\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n专业运营团队全程跟进，实时优化推广方案，以达到"),_c('br'),_vm._v("最佳传播效果。\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-promo-method"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"color":"#fff"}},[_vm._v("游戏行业推广策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-method-content"},[_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("网红直播")]),_vm._v(" "),_c('p',[_vm._v("游戏类网红直播游戏过程，通过有渲染力"),_c('br'),_vm._v("的方式影响粉丝，刺激粉丝尝试游戏。")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("硬广投放")]),_vm._v(" "),_c('p',[_vm._v("基于精准游戏用户习惯，有针对性的进行"),_c('br'),_vm._v("硬广投放，强势曝光\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("借势营销")]),_vm._v(" "),_c('p',[_vm._v("跟踪热点事件，与游戏进行创意结合，"),_c('br'),_vm._v("获取流量转移\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("微博红人")]),_vm._v(" "),_c('p',[_vm._v("借助微博红人的影响力与粉丝效应，通过"),_c('br'),_vm._v("福利活动、内容转评等，刺激转化\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("软文公关")]),_vm._v(" "),_c('p',[_vm._v("软文稿件，软性植入，推广游戏，优化搜"),_c('br'),_vm._v("索情况，获得更多曝光\n                    ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-advantages"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("软盟游戏行业推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"finance-app-content-li"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/game/yhhq.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"app-content-text"},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("精准用户获取")]),_vm._v(" "),_c('p',[_vm._v("智能大数据分析，直达精准游戏玩家。 ")])])]),_vm._v(" "),_c('div',{staticClass:"finance-app-content-li"},[_c('div',{staticClass:"app-content-text"},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("全渠道媒体资源 ")]),_vm._v(" "),_c('p',[_vm._v("百万优质媒体资源，挖掘庞大的潜在玩家。 ")])]),_vm._v(" "),_c('img',{staticStyle:{"margin-left":"12vw"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/game/yhhq.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"finance-app-content-li"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/game/tszh.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"6%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("提升转化率")]),_vm._v(" "),_c('p',[_vm._v("舆情监测，实时优化投放效果，提高广告投"),_c('br'),_vm._v("放性价比，减少用户流失。 ")])])]),_vm._v(" "),_c('div',{staticClass:"finance-app-content-li"},[_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"6%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("专业营销经验")]),_vm._v(" "),_c('p',[_vm._v("定制媒介组合、内容运营、投放策略，营销"),_c('br'),_vm._v("形式多样化。")])]),_vm._v(" "),_c('img',{staticStyle:{"margin-left":"12vw"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/game/yxjy.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"finance-app-content-li",staticStyle:{"border-bottom":"1px solid #FFF"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/game/zsfw.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"6%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("高效专属服务")]),_vm._v(" "),_c('p',[_vm._v("专项服务团队多对一服务跟进，7*12小时"),_c('br'),_vm._v("配合指导操作。 ")])])])])}]
var game_esExports = { render: game_render, staticRenderFns: game_staticRenderFns }
/* harmony default export */ var pages_solution_game = (game_esExports);
// CONCATENATED MODULE: ./src/pages/solution/game/index.vue
function game_injectStyle (ssrContext) {
  __webpack_require__("d1Qw")
}
var game_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var game___vue_template_functional__ = false
/* styles */
var game___vue_styles__ = game_injectStyle
/* scopeId */
var game___vue_scopeId__ = "data-v-27cd12c5"
/* moduleIdentifier (server only) */
var game___vue_module_identifier__ = null
var game_Component = game_normalizeComponent(
  solution_game,
  pages_solution_game,
  game___vue_template_functional__,
  game___vue_styles__,
  game___vue_scopeId__,
  game___vue_module_identifier__
)

/* harmony default export */ var src_pages_solution_game = (game_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/motherChild/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var motherChild = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/motherChild/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var solution_motherChild = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0914712c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/solution/motherChild/index.vue
var motherChild_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_wxb_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_wxb_r"}})],1)}
var motherChild_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solution-banner"},[_c('div',{staticClass:"banner-text"},[_c('a',{staticClass:"click-to-consult",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("立刻咨询")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("母婴行业推广困境")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-promo-pic"},[_c('div',{staticClass:"newproduct-promo-pic-p"},[_vm._v("市场潜力大"),_c('br'),_vm._v("  竞争激烈")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-j"},[_vm._v("品牌信任"),_c('br'),_vm._v("  难获取")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-n"},[_vm._v("    粘性差"),_c('br'),_vm._v("忠诚度不足")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-m"},[_vm._v("传播费用高"),_c('br'),_vm._v("    效果差")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-x"},[_vm._v("渠道多"),_c('br'),_vm._v("选择多")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-data-analyse"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"color":"#ffffff"}},[_vm._v("智能大数据分析")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"data-analysis-con"},[_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-title-m"},[_vm._v("行业分析 ")]),_vm._v(" "),_c('div',{staticClass:"data-title-n"},[_vm._v("市场规模 市场容量 品类分析 产品分析")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-title-m"},[_vm._v("竞品分析 ")]),_vm._v(" "),_c('div',{staticClass:"data-title-n"},[_vm._v("竞品规模 竞品特点 竞品价格 竞品卖点")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-title-m"},[_vm._v("自身分析 ")]),_vm._v(" "),_c('div',{staticClass:"data-title-n"},[_vm._v("品牌现状 品牌特点 产品分析 投放情况")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-title-m"},[_vm._v("用户分析 ")]),_vm._v(" "),_c('div',{staticClass:"data-title-n"},[_vm._v("用户年龄 用户属性 用户行为 用户习惯 ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("母婴行业推广策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"9%","margin-left":"35%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("数据分析 ")]),_vm._v(" "),_c('p',[_vm._v(" 母婴行业分析、竞品分析、本品分析、受众"),_c('br'),_vm._v("分析、 媒体数据分析")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li-2"},[_c('div',{staticClass:"app-content-text"},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("推广方案 ")]),_vm._v(" "),_c('p',[_vm._v("根据分析数据与传播目标，匹配最佳媒体投"),_c('br'),_vm._v("放组合，规划传播策略与推广方案 ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li-3"},[_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"8%","margin-left":"35%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("创意投放")]),_vm._v(" "),_c('p',[_vm._v("通过文案、海报、视频、话题营销等各种类"),_c('br'),_vm._v("型的传播方式，为品牌宣传")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li-4"},[_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"9%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("数据监测")]),_vm._v(" "),_c('p',[_vm._v("根据推广情况监测各渠道数据效果，及时优"),_c('br'),_vm._v("化反馈")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li-5"},[_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"8%","margin-left":"35%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("实时优化")]),_vm._v(" "),_c('p',[_vm._v("专业运营团队全程跟进，实时优化推广方案， "),_c('br'),_vm._v("以达到最佳传播效果")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mother-style-recommend"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("母婴行业推广方式")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"mother-style-con"},[_c('div',{staticClass:"mother-style-con-item"},[_c('div',{staticClass:"style-con-item-title"},[_vm._v("红人推广 ")]),_vm._v(" "),_c('p',[_vm._v("利用网红效应，选取受众相符的网红大号对粉丝推荐引导，直接影响粉丝购买决策；")])]),_vm._v(" "),_c('div',{staticClass:"mother-style-con-item"},[_c('div',{staticClass:"style-con-item-title"},[_vm._v("硬广投放 ")]),_vm._v(" "),_c('p',[_vm._v("基于用户习惯，有针对性的进行硬广投放，获取精准人群，权威网站硬广提升品牌信任；")])]),_vm._v(" "),_c('div',{staticClass:"mother-style-con-item"},[_c('div',{staticClass:"style-con-item-title"},[_vm._v("社媒营销 ")]),_vm._v(" "),_c('p',[_vm._v("社媒覆盖，保持话题性，增强与受众的互动，有效增加粉丝黏性，完成数据转化；")])]),_vm._v(" "),_c('div',{staticClass:"mother-style-con-item"},[_c('div',{staticClass:"style-con-item-title"},[_vm._v("口碑营销 ")]),_vm._v(" "),_c('p',[_vm._v("通过新闻稿件全网渠道扩散，树立品牌正面口碑，建立用户对品牌的信任；")])]),_vm._v(" "),_c('div',{staticClass:"mother-style-bg"},[_c('div',{staticClass:"mother-style-bg-title"},[_vm._v("产品评测 ")]),_vm._v(" "),_c('p',[_vm._v("邀请母婴类媒体大号针对品牌特色产品进行测评，"),_c('br'),_vm._v("横向对比，突出优势；")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-advantages"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("软盟母婴行业推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('img',{staticClass:"finance-app-advantages-left-pic",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/motherChild/tgys_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region"},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("精准用户获取")]),_vm._v(" "),_c('p',[_vm._v("智能大数据分析，直达有购物"),_c('br'),_vm._v("需求的精准用户; ")])]),_vm._v(" "),_c('img',{staticClass:"yzzy_icon",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/motherChild/yzzy_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region"},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("海量优质资源")]),_vm._v(" "),_c('p',[_vm._v("全渠道，具有传播价值的快消"),_c('br'),_vm._v("媒体资源覆盖，为广告主完成"),_c('br'),_vm._v("曝光，流量抢占； ")])]),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-top":"4%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("提升转化率")]),_vm._v(" "),_c('p',[_vm._v("舆情监测，实时优化投放效果，"),_c('br'),_vm._v("提高广告投放性价比，减少用"),_c('br'),_vm._v("户流失;  ")])]),_vm._v(" "),_c('img',{staticClass:"yzzy_icon-1",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/motherChild/yxjy_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-top":"5%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("专业营销经验    ")]),_vm._v(" "),_c('p',[_vm._v("专属定制媒介组合、内容运营、"),_c('br'),_vm._v(" 投放策略，全方位整合营销; ")])]),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-top":"7%","margin-left":"5%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("高效专属服务    ")]),_vm._v(" "),_c('p',[_vm._v("专项服务团队多对一服务跟进，"),_c('br'),_vm._v("7X12 小时配合指导操作;")])])])}]
var motherChild_esExports = { render: motherChild_render, staticRenderFns: motherChild_staticRenderFns }
/* harmony default export */ var pages_solution_motherChild = (motherChild_esExports);
// CONCATENATED MODULE: ./src/pages/solution/motherChild/index.vue
function motherChild_injectStyle (ssrContext) {
  __webpack_require__("1rJf")
}
var motherChild_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var motherChild___vue_template_functional__ = false
/* styles */
var motherChild___vue_styles__ = motherChild_injectStyle
/* scopeId */
var motherChild___vue_scopeId__ = "data-v-0914712c"
/* moduleIdentifier (server only) */
var motherChild___vue_module_identifier__ = null
var motherChild_Component = motherChild_normalizeComponent(
  solution_motherChild,
  pages_solution_motherChild,
  motherChild___vue_template_functional__,
  motherChild___vue_styles__,
  motherChild___vue_scopeId__,
  motherChild___vue_module_identifier__
)

/* harmony default export */ var src_pages_solution_motherChild = (motherChild_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/fashionBeauty/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var fashionBeauty = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/fashionBeauty/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var solution_fashionBeauty = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd2052dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/solution/fashionBeauty/index.vue
var fashionBeauty_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_wxb_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_wxb_r"}})],1)}
var fashionBeauty_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solution-banner"},[_c('div',{staticClass:"banner-text"},[_c('h4',[_vm._v("大数据海量覆盖目标人群")]),_vm._v(" "),_c('p',[_vm._v("  定制营销方案实现转化")]),_vm._v(" "),_c('a',{staticClass:"click-to-consult",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("立刻咨询")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("时尚美容行业推广困境")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-promo-pic"},[_c('div',{staticClass:"newproduct-promo-pic-p"},[_vm._v("营销环境 "),_c('br'),_vm._v("复杂，不知如"),_c('br'),_vm._v("何抉择 ")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-j"},[_vm._v("市场潜力"),_c('br'),_vm._v("大，竞争"),_c('br'),_vm._v("激烈")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-n"},[_vm._v("购买动力"),_c('br'),_vm._v("不足 ")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-m"},[_vm._v("推广成"),_c('br'),_vm._v("本高，流量"),_c('br'),_vm._v("获取难 ")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-x"},[_vm._v("品牌信任"),_c('br'),_vm._v("不足 ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-data-analyse"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"color":"#ffffff"}},[_vm._v("智能大数据分析")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"data-analysis-con"},[_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-title-m"},[_vm._v("行业分析 ")]),_vm._v(" "),_c('div',{staticClass:"data-title-n"},[_vm._v("市场规模 市场容量 品类分析 产品分析")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-title-m"},[_vm._v("竞品分析 ")]),_vm._v(" "),_c('div',{staticClass:"data-title-n"},[_vm._v("竞品规模 竞品特点 竞品价格 竞品卖点")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-title-m"},[_vm._v("自身分析 ")]),_vm._v(" "),_c('div',{staticClass:"data-title-n"},[_vm._v("品牌现状 品牌特点 产品分析 投放情况")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-title-m"},[_vm._v("用户分析 ")]),_vm._v(" "),_c('div',{staticClass:"data-title-n"},[_vm._v("用户年龄 用户属性 用户行为 用户习惯 ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("时尚美容行业推广策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"9%","margin-left":"35%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("数据分析 ")]),_vm._v(" "),_c('p',[_vm._v(" 时尚美容行业分析、竞品分析、本品分析、 "),_c('br'),_vm._v("受众分析、 媒体数据分析")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li-2"},[_c('div',{staticClass:"app-content-text"},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("推广方案 ")]),_vm._v(" "),_c('p',[_vm._v("根据分析数据与传播目标，匹配最佳媒体投"),_c('br'),_vm._v("放组合，规划传播策略与推广方案 ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li-3"},[_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"8%","margin-left":"35%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("创意投放")]),_vm._v(" "),_c('p',[_vm._v("通过文案、海报、视频、话题营销等各种类"),_c('br'),_vm._v("型的传播方式，为品牌宣传")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li-4"},[_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"9%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("数据监测")]),_vm._v(" "),_c('p',[_vm._v("根据推广情况监测各渠道数据效果，及时优"),_c('br'),_vm._v("化反馈")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li-5"},[_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"8%","margin-left":"35%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("实时优化")]),_vm._v(" "),_c('p',[_vm._v("专业运营团队全程跟进，实时优化推广方案， "),_c('br'),_vm._v("以达到最佳传播效果")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mother-style-recommend"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("时尚美容行业推广方式")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"beauty-style-recommend"},[_c('div',{staticClass:"beauty-style-recommend-item"},[_c('div',{staticClass:"beauty-circle"},[_c('p',[_vm._v("微博"),_c('br'),_vm._v("红人")])]),_vm._v(" "),_c('h5',[_vm._v("借助微博红人的影响力与粉丝效应，通过福利活动、 "),_c('br'),_vm._v("内容转评等，刺激转化；")])]),_vm._v(" "),_c('div',{staticClass:"beauty-style-recommend-item"},[_c('div',{staticClass:"beauty-circle"},[_c('p',[_vm._v("产品"),_c('br'),_vm._v("评测")])]),_vm._v(" "),_c('h5',[_vm._v("邀请时尚美容类媒体达人针对品牌特色产品进行测评， "),_c('br'),_vm._v("横向对比，突出优势；")])]),_vm._v(" "),_c('div',{staticClass:"beauty-style-recommend-item"},[_c('div',{staticClass:"beauty-circle"},[_c('p',[_vm._v("口碑"),_c('br'),_vm._v("营销")])]),_vm._v(" "),_c('h5',[_vm._v("通过新闻稿件全网渠道扩散，树立品牌正面口碑，建"),_c('br'),_vm._v("立用户对品牌的信任；")])]),_vm._v(" "),_c('div',{staticClass:"beauty-style-recommend-item"},[_c('div',{staticClass:"beauty-circle"},[_c('p',[_vm._v("事件"),_c('br'),_vm._v("营销")])]),_vm._v(" "),_c('h5',[_vm._v("定制个性化事件营销方案，基于全网渠道信息扩散、"),_c('br'),_vm._v(" 舆论发酵、话题把控等运作，吸引用户眼球；")])]),_vm._v(" "),_c('div',{staticClass:"beauty-style-recommend-item"},[_c('div',{staticClass:"beauty-circle"},[_c('p',[_vm._v("网红"),_c('br'),_vm._v(" 直播")])]),_vm._v(" "),_c('h5',[_vm._v("时尚美容类网红直播植入产品，通过有渲染力的方式 "),_c('br'),_vm._v("影响粉丝，刺激粉丝了解购买；")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-advantages"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("软盟时尚美容行业推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('img',{staticClass:"finance-app-advantages-left-pic",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/fashionBeauty/tgys_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region"},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("精准用户获取")]),_vm._v(" "),_c('p',[_vm._v("智能大数据分析，直达有购物"),_c('br'),_vm._v("需求的精准用户; ")])]),_vm._v(" "),_c('img',{staticClass:"yzzy_icon",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/fashionBeauty/hlzy.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region"},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("海量优质资源")]),_vm._v(" "),_c('p',[_vm._v("全渠道，具有传播价值的快消"),_c('br'),_vm._v("媒体资源覆盖，为广告主完成"),_c('br'),_vm._v("曝光，流量抢占； ")])]),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-top":"2%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("提升转化率  ")]),_vm._v(" "),_c('p',[_vm._v("舆情监测，实时优化投放效果，"),_c('br'),_vm._v("提高广告投放性价比，减少用"),_c('br'),_vm._v("户流失;  ")])]),_vm._v(" "),_c('img',{staticClass:"yzzy_icon",staticStyle:{"margin-top":"25.667vw"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/fashionBeauty/yxjy.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-top":"9%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("专业营销经验    ")]),_vm._v(" "),_c('p',[_vm._v("专属定制媒介组合、内容运营、"),_c('br'),_vm._v(" 投放策略，全方位整合营销; ")])]),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-top":"4%","margin-left":"8%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("高效专属服务    ")]),_vm._v(" "),_c('p',[_vm._v("专项服务团队多对一服务跟进，"),_c('br'),_vm._v("7X12 小时配合指导操作;")])])])}]
var fashionBeauty_esExports = { render: fashionBeauty_render, staticRenderFns: fashionBeauty_staticRenderFns }
/* harmony default export */ var pages_solution_fashionBeauty = (fashionBeauty_esExports);
// CONCATENATED MODULE: ./src/pages/solution/fashionBeauty/index.vue
function fashionBeauty_injectStyle (ssrContext) {
  __webpack_require__("sck6")
}
var fashionBeauty_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var fashionBeauty___vue_template_functional__ = false
/* styles */
var fashionBeauty___vue_styles__ = fashionBeauty_injectStyle
/* scopeId */
var fashionBeauty___vue_scopeId__ = "data-v-cd2052dc"
/* moduleIdentifier (server only) */
var fashionBeauty___vue_module_identifier__ = null
var fashionBeauty_Component = fashionBeauty_normalizeComponent(
  solution_fashionBeauty,
  pages_solution_fashionBeauty,
  fashionBeauty___vue_template_functional__,
  fashionBeauty___vue_styles__,
  fashionBeauty___vue_scopeId__,
  fashionBeauty___vue_module_identifier__
)

/* harmony default export */ var src_pages_solution_fashionBeauty = (fashionBeauty_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/fmcg/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var fmcg = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/fmcg/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var solution_fmcg = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-232d3012","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/solution/fmcg/index.vue
var fmcg_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_wxb_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_wxb_r"}})],1)}
var fmcg_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solution-banner"},[_c('div',{staticClass:"banner-text"},[_c('h3',[_vm._v("快消品行业推广解决方案")]),_vm._v(" "),_c('h4',[_vm._v("大数据海量覆盖目标人群"),_c('br'),_vm._v(" 为快消品提供 "),_c('span',[_vm._v("一站式营销方案")])]),_vm._v(" "),_c('a',{staticClass:"click-to-consult",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("立刻咨询")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("快销品行业推广困境")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-promo-pic"},[_c('div',{staticClass:"newproduct-promo-pic-p"},[_c('span',[_vm._v("竞品")]),_vm._v(" "),_c('br'),_vm._v("竞品繁多"),_c('br'),_vm._v(" 竞争激烈")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-j"},[_c('span',[_vm._v("品牌")]),_c('br'),_vm._v("缺乏品牌信任")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-n"},[_c('span',[_vm._v("营销 ")]),_c('br'),_vm._v("营销环境复杂 "),_c('br'),_vm._v("不知如何抉择")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-m"},[_c('span',[_vm._v("价格 ")]),_c('br'),_vm._v("  价格战疲乏")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-x"},[_c('span',[_vm._v("运营")]),_c('br'),_vm._v(" 运营成本高"),_c('br'),_vm._v(" 流量获取难")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-data-analyse"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"color":"#ffffff"}},[_vm._v("智能大数据分析")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"data-analysis-con"},[_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-title-m"},[_vm._v("行业分析 ")]),_vm._v(" "),_c('div',{staticClass:"data-title-n"},[_vm._v("市场规模"),_c('br'),_vm._v(" 市场容量"),_c('br'),_vm._v(" 品类分析"),_c('br'),_vm._v(" 产品分析")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-title-m"},[_vm._v("竞品分析 ")]),_vm._v(" "),_c('div',{staticClass:"data-title-n"},[_vm._v("竞品规模"),_c('br'),_vm._v(" 竞品特点"),_c('br'),_vm._v(" 竞品价格"),_c('br'),_vm._v(" 竞品投放")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-title-m"},[_vm._v("自身分析 ")]),_vm._v(" "),_c('div',{staticClass:"data-title-n"},[_vm._v("品牌现状"),_c('br'),_vm._v(" 品牌特点"),_c('br'),_vm._v(" 产品分析"),_c('br'),_vm._v(" 投放情况")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-title-m"},[_vm._v("用户分析 ")]),_vm._v(" "),_c('div',{staticClass:"data-title-n"},[_vm._v("用户年龄"),_c('br'),_vm._v(" 用户属性"),_c('br'),_vm._v(" 媒体偏好"),_c('br'),_vm._v(" 触网习惯")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("快销品行业推广策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-promo-method-content"},[_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("数据分析 ")]),_vm._v(" "),_c('p',[_vm._v("快销行业分析、竞品分析、本品分析、受众"),_c('br'),_vm._v("分析、 媒体数据分析")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("推广方案")]),_vm._v(" "),_c('p',[_vm._v("根据分析数据与传播目标，匹配最佳媒体投"),_c('br'),_vm._v("放组合，规划传播策略与推广方案\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("创意投放")]),_vm._v(" "),_c('p',[_vm._v("通过文案、海报、视频、话题营销等各种类"),_c('br'),_vm._v("型的传播方式，为品牌宣传\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("数据监测")]),_vm._v(" "),_c('p',[_vm._v("根据推广情况监测各渠道数据效果，及时优"),_c('br'),_vm._v("化反馈\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("实时优化")]),_vm._v(" "),_c('p',[_vm._v("专业运营团队全程跟进，实时优化推广方案， "),_c('br'),_vm._v("以达到最佳传播效果\n        ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mother-style-recommend"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("快销品行业推广方式")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"beauty-style-recommend"},[_c('div',{staticClass:"beauty-style-recommend-item"},[_c('p',[_vm._v("社媒"),_c('br'),_vm._v("营销 ")]),_vm._v(" "),_c('h5',[_vm._v("社媒覆盖，保持话题性，增强与受众的互动，"),_c('br'),_vm._v("有效增加粉丝黏性，完成数据转化； ")])]),_vm._v(" "),_c('div',{staticClass:"beauty-style-recommend-item"},[_c('p',[_vm._v("口碑 "),_c('br'),_vm._v("营销  ")]),_vm._v(" "),_c('h5',[_vm._v("通过新闻稿件全网渠道扩散，树立品牌正面口碑， "),_c('br'),_vm._v("建立用户对品牌的信任； ")])]),_vm._v(" "),_c('div',{staticClass:"beauty-style-recommend-item"},[_c('p',[_vm._v("红人 "),_c('br'),_vm._v("推广  ")]),_vm._v(" "),_c('h5',[_vm._v("利用网红效应，选取受众相符的网红大号 "),_c('br'),_vm._v("对粉丝推荐引导，直接影响粉丝购买决策； ")])]),_vm._v(" "),_c('div',{staticClass:"beauty-style-recommend-item"},[_c('p',[_vm._v("视频"),_c('br'),_vm._v(" 营销  ")]),_vm._v(" "),_c('h5',[_vm._v("利用当下最流行，人气最高的传播形式，"),_c('br'),_vm._v(" 定制特色视频，进行更广泛传播； ")])]),_vm._v(" "),_c('div',{staticClass:"beauty-style-recommend-item"},[_c('p',[_vm._v("硬广"),_c('br'),_vm._v(" 投放")]),_vm._v(" "),_c('h5',[_vm._v("基于用户习惯，有针对性的进行硬广投放， "),_c('br'),_vm._v("获取精准人群，权威网站硬广提升品牌信任； ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-advantages"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("软盟快销品行业推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('img',{staticClass:"finance-app-advantages-left-pic",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/fmcg/tgys_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-left":"-15%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("精准用户获取")]),_vm._v(" "),_c('p',[_vm._v("智能大数据分析，直达有购物"),_c('br'),_vm._v("需求的精准用户; ")])]),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-top":"6%","margin-left":"10%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("海量优质资源")]),_vm._v(" "),_c('p',[_vm._v("全渠道，具有传播价值的快消"),_c('br'),_vm._v("媒体资源覆盖，为广告主完成"),_c('br'),_vm._v("曝光，流量抢占； ")])]),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-top":"4%","margin-left":"-15%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("提升转化率  ")]),_vm._v(" "),_c('p',[_vm._v("舆情监测，实时优化投放效果，"),_c('br'),_vm._v("提高广告投放性价比，减少用"),_c('br'),_vm._v("户流失;  ")])]),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-top":"5%","margin-left":"10%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("专业营销经验    ")]),_vm._v(" "),_c('p',[_vm._v("专属定制媒介组合、内容运营、"),_c('br'),_vm._v(" 投放策略，全方位整合营销; ")])]),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-top":"8%","margin-left":"-15%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("高效专属服务    ")]),_vm._v(" "),_c('p',[_vm._v("专项服务团队多对一服务跟进，"),_c('br'),_vm._v("7X12 小时配合指导操作;")])])])}]
var fmcg_esExports = { render: fmcg_render, staticRenderFns: fmcg_staticRenderFns }
/* harmony default export */ var pages_solution_fmcg = (fmcg_esExports);
// CONCATENATED MODULE: ./src/pages/solution/fmcg/index.vue
function fmcg_injectStyle (ssrContext) {
  __webpack_require__("MITv")
}
var fmcg_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var fmcg___vue_template_functional__ = false
/* styles */
var fmcg___vue_styles__ = fmcg_injectStyle
/* scopeId */
var fmcg___vue_scopeId__ = "data-v-232d3012"
/* moduleIdentifier (server only) */
var fmcg___vue_module_identifier__ = null
var fmcg_Component = fmcg_normalizeComponent(
  solution_fmcg,
  pages_solution_fmcg,
  fmcg___vue_template_functional__,
  fmcg___vue_styles__,
  fmcg___vue_scopeId__,
  fmcg___vue_module_identifier__
)

/* harmony default export */ var src_pages_solution_fmcg = (fmcg_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/tourism/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tourism = ({
  name: 'index',
  data: function data() {
    return {
      promoAdvantages: [{
        iconName: 'shuju1',
        iconSize: '12.5vw',
        iconPosition: '13%',
        iconLeft: '-9%',
        promoAdvanTitle: '数据分析 ',
        promoAdvanDescription: '旅游行业分析、竞品分析、本品分析、受众分析、 媒体数据分析;'
      }, {
        iconName: 'ico_yishenggongzuozhan_meilifangan',
        iconSize: '12.5vw',
        iconPosition: '14%',
        iconLeft: '-9%',
        promoAdvanTitle: '推广方案',
        promoAdvanDescription: '根据分析数据与传播目标，匹配最佳媒体投组合，规划传播策略与推广方案;'
      }, {
        iconName: 'koubei',
        iconSize: '11.5vw',
        iconPosition: '20%',
        iconLeft: '12%',
        promoAdvanTitle: '创意投放 ',
        promoAdvanDescription: '通过文案、海报、视频、话题营销等各种类型的传播方式，为品牌宣传;'
      }, {
        iconName: 'shuju',
        iconSize: '15.5vw',
        iconPosition: '-11%',
        iconLeft: '-30%',
        promoAdvanTitle: '数据检测',
        promoAdvanDescription: '根据推广情况监测各渠道数据效果，及时优化反馈;'
      }, {
        iconName: 'youhuayunhang',
        iconSize: '11.5vw',
        iconPosition: '8%',
        iconLeft: '6%',
        promoAdvanTitle: '实时优化',
        promoAdvanDescription: '专业运营团队全程跟进，实时优化推广方案， 以达到最佳传播效果;'
      }],
      promoMethod: [{
        promoAdvanTitle: '社媒营销    ',
        promoAdvanDescription: '社媒覆盖，保持话题性，增强与受众的互动，有效增加粉丝黏性，完成数据转化;'
      }, {
        promoAdvanTitle: '口碑营销  ',
        promoAdvanDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑，建立用户对品牌的信任;'
      }, {
        promoAdvanTitle: '红人推广   ',
        promoAdvanDescription: '利用网红效应，选取受众相符的网红大号对粉丝推荐引导，直接影响粉丝购买决策;'
      }, {
        promoAdvanTitle: '产品评测   ',
        promoAdvanDescription: '邀请母婴类媒体大号针对品牌特色产品进行测评，横向对比，突出优势；；'
      }, {
        promoAdvanTitle: '硬广投放   ',
        promoAdvanDescription: '基于用户习惯，有针对性的进行硬广投放，获取精准人群，权威网站硬广提升品牌信任；'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/tourism/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var solution_tourism = ({
  name: 'index',
  data: function data() {
    return {
      promoAdvantages: [{
        iconName: 'shuju1',
        iconSize: '12.5vw',
        iconPosition: '13%',
        iconLeft: '-9%',
        promoAdvanTitle: '数据分析 ',
        promoAdvanDescription: '旅游行业分析、竞品分析、本品分析、受众分析、 媒体数据分析;'
      }, {
        iconName: 'ico_yishenggongzuozhan_meilifangan',
        iconSize: '12.5vw',
        iconPosition: '14%',
        iconLeft: '-9%',
        promoAdvanTitle: '推广方案',
        promoAdvanDescription: '根据分析数据与传播目标，匹配最佳媒体投组合，规划传播策略与推广方案;'
      }, {
        iconName: 'koubei',
        iconSize: '11.5vw',
        iconPosition: '20%',
        iconLeft: '12%',
        promoAdvanTitle: '创意投放 ',
        promoAdvanDescription: '通过文案、海报、视频、话题营销等各种类型的传播方式，为品牌宣传;'
      }, {
        iconName: 'shuju',
        iconSize: '15.5vw',
        iconPosition: '-11%',
        iconLeft: '-30%',
        promoAdvanTitle: '数据检测',
        promoAdvanDescription: '根据推广情况监测各渠道数据效果，及时优化反馈;'
      }, {
        iconName: 'youhuayunhang',
        iconSize: '11.5vw',
        iconPosition: '8%',
        iconLeft: '6%',
        promoAdvanTitle: '实时优化',
        promoAdvanDescription: '专业运营团队全程跟进，实时优化推广方案， 以达到最佳传播效果;'
      }],
      promoMethod: [{
        promoAdvanTitle: '社媒营销    ',
        promoAdvanDescription: '社媒覆盖，保持话题性，增强与受众的互动，有效增加粉丝黏性，完成数据转化;'
      }, {
        promoAdvanTitle: '口碑营销  ',
        promoAdvanDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑，建立用户对品牌的信任;'
      }, {
        promoAdvanTitle: '红人推广   ',
        promoAdvanDescription: '利用网红效应，选取受众相符的网红大号对粉丝推荐引导，直接影响粉丝购买决策;'
      }, {
        promoAdvanTitle: '产品评测   ',
        promoAdvanDescription: '邀请母婴类媒体大号针对品牌特色产品进行测评，横向对比，突出优势；；'
      }, {
        promoAdvanTitle: '硬广投放   ',
        promoAdvanDescription: '基于用户习惯，有针对性的进行硬广投放，获取精准人群，权威网站硬广提升品牌信任；'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eb0510c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/solution/tourism/index.vue
var tourism_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_ds_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"finance-app-advantages"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"finance-promo-advan-content"},_vm._l((_vm.promoAdvantages),function(item,index){return _c('div',{key:index,staticClass:"finance-promo-advan-content-li"},[_c('div',{staticClass:"finance-promo-advantages-fistline"},[_c('div',{staticClass:"finance-icon-box"},[_c('icon',{style:({marginTop:item.iconPosition,fontSize:item.iconSize,marginLeft:item.iconLeft}),attrs:{"type":"svg","name":item.iconName}})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.promoAdvanTitle))])]),_vm._v(" "),_c('p',{staticClass:"finance-promo-advantages-description"},[_vm._v(_vm._s(item.promoAdvanDescription))])])}))]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_ds_r"}})],1)}
var tourism_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solution-banner"},[_c('div',{staticClass:"banner-text"},[_c('a',{staticClass:"click-to-consult",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("立刻咨询")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-trouble"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("旅游行业推广困境")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic"},[_c('div',{staticClass:"newproduct-promo-pic-p"},[_vm._v("市场潜力"),_c('br'),_vm._v("大，竞争"),_c('br'),_vm._v("激烈 ")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-j"},[_vm._v("     获取"),_c('br'),_vm._v("资源门槛高，"),_c('br'),_vm._v("    渠道少 ")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-n"},[_vm._v("产品特色"),_c('br'),_vm._v("不清晰，难"),_c('br'),_vm._v("以传播 ")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-m"},[_vm._v("信息传播"),_c('br'),_vm._v("不到位，资"),_c('br'),_vm._v("源浪费 ")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-x"},[_vm._v("推广"),_c('br'),_vm._v("成本高，转"),_c('br'),_vm._v("化不足 ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-data-analyse"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"color":"#fff"}},[_vm._v("智能大数据分析")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"mother-child-data-analyse-content"},[_c('div',{staticClass:"data-content-li"},[_c('div',{staticClass:"data-content-title"},[_c('h3',[_vm._v("行业分析")])]),_vm._v(" "),_c('div',{staticClass:"data-content-line-l"}),_vm._v(" "),_c('p',[_vm._v("市场规模"),_c('br'),_vm._v("行业现状"),_c('br'),_vm._v("市场容量"),_c('br'),_vm._v("品类分析")])]),_vm._v(" "),_c('div',{staticClass:"data-content-li"},[_c('div',{staticClass:"data-content-title"},[_c('h3',{staticStyle:{"margin-left":"13%"}},[_vm._v("竞品分析")])]),_vm._v(" "),_c('div',{staticClass:"data-content-line-l"}),_vm._v(" "),_c('p',[_vm._v("竞品规模"),_c('br'),_vm._v("竞品特点"),_c('br'),_vm._v("竞品价格"),_c('br'),_vm._v("竞品投放")])]),_vm._v(" "),_c('div',{staticClass:"data-content-li"},[_c('div',{staticClass:"data-content-title"},[_c('h3',{staticStyle:{"margin-left":"12%"}},[_vm._v("自身分析")])]),_vm._v(" "),_c('div',{staticClass:"data-content-line-l"}),_vm._v(" "),_c('p',[_vm._v("品牌现状"),_c('br'),_vm._v("品牌特点"),_c('br'),_vm._v("产品分析"),_c('br'),_vm._v("投放情况")])]),_vm._v(" "),_c('div',{staticClass:"data-content-li"},[_c('div',{staticClass:"data-content-title"},[_c('h3',{staticStyle:{"margin-left":"13%"}},[_vm._v("用户分析")])]),_vm._v(" "),_c('div',{staticClass:"data-content-line-l"}),_vm._v(" "),_c('p',[_vm._v("用户年龄"),_c('br'),_vm._v("用户属性"),_c('br'),_vm._v("媒体偏好"),_c('br'),_vm._v("触网习惯")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("旅游行业推广策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-promo-method tourism-promo-method"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("旅游行业推广方式")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"tourism-promo-content"},[_c('div',{staticClass:"tourism-promo-big"},[_c('h3',[_vm._v("微信公众号 ")]),_vm._v(" "),_c('p',[_vm._v("与高人气旅游领域的微信自媒体合作，借助其影响力，通过创"),_c('br'),_vm._v("意图文、H5、视频等形式介绍传播产品；")])]),_vm._v(" "),_c('div',{staticClass:"tourism-promo-content-li"},[_c('div',{staticClass:"promo-ways-mark"},[_c('i',{staticClass:"iconfont icon-weibo1"})]),_vm._v(" "),_c('div',{staticClass:"promo-ways-details"},[_c('h3',[_vm._v("微博红人")]),_vm._v(" "),_c('p',[_vm._v("借助微博红人的影响力，通过福利活动、内容转评等，刺激购买；  ")])])]),_vm._v(" "),_c('div',{staticClass:"tourism-promo-content-li"},[_c('div',{staticClass:"promo-ways-mark"},[_c('i',{staticClass:"iconfont icon-xinxiliuguanggao"})]),_vm._v(" "),_c('div',{staticClass:"promo-ways-details"},[_c('h3',[_vm._v("信息流广告")]),_vm._v(" "),_c('p',[_vm._v("筛选目标用户精准直达，通过各平台信息流广告实现优质曝光； ")])])]),_vm._v(" "),_c('div',{staticClass:"tourism-promo-content-li"},[_c('div',{staticClass:"promo-ways-mark"},[_c('i',{staticClass:"iconfont icon-koubeichuanbo"})]),_vm._v(" "),_c('div',{staticClass:"promo-ways-details"},[_c('h3',[_vm._v("口碑传播")]),_vm._v(" "),_c('p',[_vm._v("通过新闻稿件全网渠道扩散，树立品牌正面口碑，建立用户对品牌的信任； ")])])]),_vm._v(" "),_c('div',{staticClass:"tourism-promo-content-li-4"},[_c('div',{staticClass:"promo-ways-details"},[_c('h3',[_vm._v("短视频营销")]),_vm._v(" "),_c('p',[_vm._v("利用当下最流行，人气最高的传播形式，定制特色短视频宣传，进行更广泛传播；")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-advantages"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("软盟旅游行业推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('img',{staticClass:"finance-app-advantages-left-pic",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/tourism/tgys_icon_1.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region"},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("精准用户获取")]),_vm._v(" "),_c('p',[_vm._v("智能大数据分析，直达有购物"),_c('br'),_vm._v("需求的精准用户; ")])]),_vm._v(" "),_c('img',{staticClass:"yzzy_icon",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/tourism/hlyzzy.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region"},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("海量优质资源")]),_vm._v(" "),_c('p',[_vm._v("全渠道，具有传播价值的旅游"),_c('br'),_vm._v("类媒体资源覆盖，为广告主完"),_c('br'),_vm._v("成曝光，流量抢占;")])]),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-top":"3%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("提升转化率  ")]),_vm._v(" "),_c('p',[_vm._v("舆情监测，实时优化投放效果，"),_c('br'),_vm._v("提高广告投放性价比，减少用"),_c('br'),_vm._v("户流失;  ")])]),_vm._v(" "),_c('img',{staticClass:"yzzy_icon",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/tourism/zyyxjy.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-top":"9%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("专业营销经验    ")]),_vm._v(" "),_c('p',[_vm._v("专属定制媒介组合、内容运营、"),_c('br'),_vm._v(" 投放策略，全方位整合营销; ")])]),_vm._v(" "),_c('div',{staticClass:"finance-app-text-region",staticStyle:{"margin-top":"5%","margin-left":"-21%"}},[_c('div',{staticClass:"finance-app-text-m"},[_vm._v("高效专属服务    ")]),_vm._v(" "),_c('p',[_vm._v("专项服务团队多对一服务跟进，"),_c('br'),_vm._v("7X12 小时配合指导操作;")])])])}]
var tourism_esExports = { render: tourism_render, staticRenderFns: tourism_staticRenderFns }
/* harmony default export */ var pages_solution_tourism = (tourism_esExports);
// CONCATENATED MODULE: ./src/pages/solution/tourism/index.vue
function tourism_injectStyle (ssrContext) {
  __webpack_require__("2Dfj")
}
var tourism_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tourism___vue_template_functional__ = false
/* styles */
var tourism___vue_styles__ = tourism_injectStyle
/* scopeId */
var tourism___vue_scopeId__ = "data-v-0eb0510c"
/* moduleIdentifier (server only) */
var tourism___vue_module_identifier__ = null
var tourism_Component = tourism_normalizeComponent(
  solution_tourism,
  pages_solution_tourism,
  tourism___vue_template_functional__,
  tourism___vue_styles__,
  tourism___vue_scopeId__,
  tourism___vue_module_identifier__
)

/* harmony default export */ var src_pages_solution_tourism = (tourism_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/car/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var car = ({
  name: 'index',

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/car/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var solution_car = ({
  name: 'index',

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e6ce938","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/solution/car/index.vue
var car_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_car_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_car_r"}})],1)}
var car_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solution-banner"},[_c('div',{staticClass:"banner-text"},[_c('p',[_vm._v("全渠道、大数据锁定精准用户,为汽车品牌\n        提供一站式营销方案")])]),_vm._v(" "),_c('a',{staticClass:"click-to-consult",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("立刻咨询")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-trouble"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("汽车行业推广困境")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"}),_vm._v(" "),_c('div',{staticClass:"game-trouble-bg"},[_c('div',{staticClass:"game-trouble-bg-item",staticStyle:{"top":"45%","left":"9%"}},[_vm._v("市场潜力大，竞争激烈")]),_vm._v(" "),_c('div',{staticClass:"game-trouble-bg-item",staticStyle:{"top":"36%","left":"42%"}},[_vm._v("营销环境复杂"),_c('br'),_vm._v("不知如何抉择 ")]),_vm._v(" "),_c('div',{staticClass:"game-trouble-bg-item",staticStyle:{"top":"59%","left":"47%"}},[_vm._v("运营成本高，流量获取难")]),_vm._v(" "),_c('div',{staticClass:"game-trouble-bg-item",staticStyle:{"top":"45%","left":"69%"}},[_vm._v("受众品牌偏好度高 ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-data-analyse"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"color":"#ffffff"}},[_vm._v("智能大数据分析")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-analyse-contnet-item text-center"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/hyfx.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-title"},[_vm._v("行业分析"),_c('br'),_vm._v("+")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("市场规模")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("行业现状")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("政策法规")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("品类分析")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item text-center"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/jpfx.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-title"},[_vm._v("竞品分析"),_c('br'),_vm._v("+")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("竞品规模")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("竞品特点")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("竞品价格")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("竞品投放")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item text-center"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/zsfx.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-title"},[_vm._v("自身分析"),_c('br'),_vm._v("+")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("品牌现状")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("品牌特点")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("产品分析")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("投放情况")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item text-center",staticStyle:{"margin-right":"0px"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/yhfx.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-title"},[_vm._v("用户分析"),_c('br'),_vm._v("+")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("用户年龄")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("用户属性")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("媒体偏好")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("触网习惯")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("汽车行业推广策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('img',{staticClass:"not-1",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/sjfx_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"8%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("数据分析 ")]),_vm._v(" "),_c('p',[_vm._v(" 汽车行业分析、竞品分析、本品分析、受众"),_c('br'),_vm._v("分析、媒体数据分析 ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('div',{staticClass:"app-content-text"},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("推广方案 ")]),_vm._v(" "),_c('p',[_vm._v("根据分析数据与传播目标，匹配最佳媒体投"),_c('br'),_vm._v("放组合，规划传播策略与推广方案 ")])]),_vm._v(" "),_c('img',{staticClass:"not-2",staticStyle:{"margin-left":"5vw"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/tgfa_icon.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('img',{staticClass:"not-3",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/cytf_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"6%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("创意投放")]),_vm._v(" "),_c('p',[_vm._v("通过文案、海报、视频、话题营销等各种类"),_c('br'),_vm._v("型的传播方式，为品牌宣传")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"6%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("数据监测")]),_vm._v(" "),_c('p',[_vm._v("根据推广情况监测各渠道数据效果，及时优"),_c('br'),_vm._v("化反馈")])]),_vm._v(" "),_c('img',{staticClass:"not-4",staticStyle:{"margin-left":"5vw"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/sjjc_icon.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li",staticStyle:{"border-bottom":"1px solid #FFF"}},[_c('img',{staticClass:"not-5",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/ssyh_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"6%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("实时优化")]),_vm._v(" "),_c('p',[_vm._v("专业运营团队全程跟进，实时优化推广方案， "),_c('br'),_vm._v("以达到最佳传播效果")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-promo-method"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("汽车行业推广方式")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"promo-method-content"},[_c('div',{staticClass:"promo-method-content-li"},[_c('img',{staticClass:"pic-1",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/smyx_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"promo-method-content-text"},[_c('div',{staticClass:"promo-method-content-title"},[_vm._v("社媒营销")]),_vm._v(" "),_c('p',[_vm._v("社媒覆盖，保持话题性，增强与受众的互动，有效增加粉"),_c('br'),_vm._v("丝黏性，完成数据转化；")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('img',{staticClass:"pic-2",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/ygtf_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"promo-method-content-text"},[_c('div',{staticClass:"promo-method-content-title"},[_vm._v("硬广投放")]),_vm._v(" "),_c('p',[_vm._v("基于用户习惯，有针对性的进行硬 广投放，获取精准人群，"),_c('br'),_vm._v("权威网站硬广提升品牌信任；")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('img',{staticClass:"pic-3",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/kbyx_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"promo-method-content-text"},[_c('div',{staticClass:"promo-method-content-title"},[_vm._v("口碑营销")]),_vm._v(" "),_c('p',[_vm._v("通过新闻稿件全网渠道扩散，树立品牌正面口碑，建立"),_c('br'),_vm._v("用户对品牌的信任；")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('img',{staticClass:"pic-4",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/cppc_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"promo-method-content-text"},[_c('div',{staticClass:"promo-method-content-title"},[_vm._v("产品评测")]),_vm._v(" "),_c('p',[_vm._v("邀请汽车类媒体针对品牌特色产品进行测评，横向对比，"),_c('br'),_vm._v("突出优势；")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('img',{staticClass:"pic-5",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/car/dspyx_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"promo-method-content-text"},[_c('div',{staticClass:"promo-method-content-title"},[_vm._v("短视频营销")]),_vm._v(" "),_c('p',[_vm._v("利用当下最流行，人气最高的传播形式，定制特色短视"),_c('br'),_vm._v("频宣传，进行更广泛传播；")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-advantages"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("软盟汽车行业推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"app-advance-content"},[_c('div',{staticClass:"finance-app-advantages-item"},[_c('div',{staticClass:"app-text-content"},[_c('div',{staticClass:"app-title-l"},[_vm._v("精准用户获取")]),_vm._v(" "),_c('p',[_vm._v("智能大数据分析，获取媒体投放数据，打击"),_c('br'),_vm._v("竞品，直达精准用户;")])])]),_vm._v(" "),_c('div',{staticClass:"finance-app-advantages-item-r"},[_c('div',{staticClass:"app-text-content-r"},[_c('div',{staticClass:"app-title-r"},[_vm._v("优质汽车资源")]),_vm._v(" "),_c('p',[_vm._v("全渠道，具有传播价 值的汽车媒体资源覆"),_c('br'),_vm._v("盖，为广告主完成曝光，流量抢占;")])])]),_vm._v(" "),_c('div',{staticClass:"finance-app-advantages-item-2"},[_c('div',{staticClass:"app-text-content"},[_c('div',{staticClass:"app-title-l"},[_vm._v("提升转化率")]),_vm._v(" "),_c('p',[_vm._v("舆情监测，实时优化投放效果，提高广告投"),_c('br'),_vm._v("放性价比，减少用户流失;")])])]),_vm._v(" "),_c('div',{staticClass:"finance-app-advantages-item-r-2"},[_c('div',{staticClass:"app-text-content-r"},[_c('div',{staticClass:"app-title-r"},[_vm._v("专业营销经验")]),_vm._v(" "),_c('p',[_vm._v("专属定制媒介组合、内容运营、投放策略，"),_c('br'),_vm._v("全方位整合营销;")])])]),_vm._v(" "),_c('div',{staticClass:"finance-app-advantages-item-3"},[_c('div',{staticClass:"app-text-content"},[_c('div',{staticClass:"app-title-l"},[_vm._v("高效专属服务")]),_vm._v(" "),_c('p',[_vm._v("专项服务团队多对一服务跟进，7X12小时"),_c('br'),_vm._v("配合指导操作;")])])])])])}]
var car_esExports = { render: car_render, staticRenderFns: car_staticRenderFns }
/* harmony default export */ var pages_solution_car = (car_esExports);
// CONCATENATED MODULE: ./src/pages/solution/car/index.vue
function car_injectStyle (ssrContext) {
  __webpack_require__("ZdbJ")
}
var car_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var car___vue_template_functional__ = false
/* styles */
var car___vue_styles__ = car_injectStyle
/* scopeId */
var car___vue_scopeId__ = "data-v-0e6ce938"
/* moduleIdentifier (server only) */
var car___vue_module_identifier__ = null
var car_Component = car_normalizeComponent(
  solution_car,
  pages_solution_car,
  car___vue_template_functional__,
  car___vue_styles__,
  car___vue_scopeId__,
  car___vue_module_identifier__
)

/* harmony default export */ var src_pages_solution_car = (car_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/ecommerce/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ecommerce = ({
  name: 'index',
  data: function data() {
    return {
      promoAdvantages: [{
        iconName: 'shuju1',
        iconSize: '12.5vw',
        iconPosition: '13%',
        iconLeft: '-9%',
        promoAdvanTitle: '数据分析 ',
        promoAdvanDescription: '电商市场分析、竞品分析、本品分析、受众分析、 媒体数据分析;'
      }, {
        iconName: 'ico_yishenggongzuozhan_meilifangan',
        iconSize: '12.5vw',
        iconPosition: '14%',
        iconLeft: '-9%',
        promoAdvanTitle: '推广方案',
        promoAdvanDescription: '根据分析数据与传播目标，匹配最佳媒体投放组合，规划传播策略与推广方案;'
      }, {
        iconName: 'koubei',
        iconSize: '11.5vw',
        iconPosition: '20%',
        iconLeft: '12%',
        promoAdvanTitle: '创意投放 ',
        promoAdvanDescription: '通过文案、海报、视频、话题营销等各种类型的传播方式，为品牌宣传;'
      }, {
        iconName: 'shuju',
        iconSize: '15.5vw',
        iconPosition: '-11%',
        iconLeft: '-30%',
        promoAdvanTitle: '数据检测',
        promoAdvanDescription: '根据推广情况监测各渠道数据效果，及时优化反馈;'
      }, {
        iconName: 'youhuayunhang',
        iconSize: '11.5vw',
        iconPosition: '8%',
        iconLeft: '6%',
        promoAdvanTitle: '实时优化',
        promoAdvanDescription: '专业运营团队全程跟进，实时优化推广方案， 以达到最佳传播效果;'
      }],
      promoMethod: [{
        promoAdvanTitle: '社媒营销    ',
        promoAdvanDescription: '社媒覆盖，保持话题性，增强与受众的互动，有效增加粉丝黏性，完成数据转化;'
      }, {
        promoAdvanTitle: '口碑营销  ',
        promoAdvanDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑，建立用户对品牌的信任;'
      }, {
        promoAdvanTitle: '红人推广   ',
        promoAdvanDescription: '利用网红效应，选取受众相符的网红大号对粉丝推荐引导，直接影响粉丝购买决策;'
      }, {
        promoAdvanTitle: '产品评测   ',
        promoAdvanDescription: '邀请母婴类媒体大号针对品牌特色产品进行测评，横向对比，突出优势；；'
      }, {
        promoAdvanTitle: '硬广投放   ',
        promoAdvanDescription: '基于用户习惯，有针对性的进行硬广投放，获取精准人群，权威网站硬广提升品牌信任；'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/ecommerce/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var solution_ecommerce = ({
  name: 'index',
  data: function data() {
    return {
      promoAdvantages: [{
        iconName: 'shuju1',
        iconSize: '12.5vw',
        iconPosition: '13%',
        iconLeft: '-9%',
        promoAdvanTitle: '数据分析 ',
        promoAdvanDescription: '电商市场分析、竞品分析、本品分析、受众分析、 媒体数据分析;'
      }, {
        iconName: 'ico_yishenggongzuozhan_meilifangan',
        iconSize: '12.5vw',
        iconPosition: '14%',
        iconLeft: '-9%',
        promoAdvanTitle: '推广方案',
        promoAdvanDescription: '根据分析数据与传播目标，匹配最佳媒体投放组合，规划传播策略与推广方案;'
      }, {
        iconName: 'koubei',
        iconSize: '11.5vw',
        iconPosition: '20%',
        iconLeft: '12%',
        promoAdvanTitle: '创意投放 ',
        promoAdvanDescription: '通过文案、海报、视频、话题营销等各种类型的传播方式，为品牌宣传;'
      }, {
        iconName: 'shuju',
        iconSize: '15.5vw',
        iconPosition: '-11%',
        iconLeft: '-30%',
        promoAdvanTitle: '数据检测',
        promoAdvanDescription: '根据推广情况监测各渠道数据效果，及时优化反馈;'
      }, {
        iconName: 'youhuayunhang',
        iconSize: '11.5vw',
        iconPosition: '8%',
        iconLeft: '6%',
        promoAdvanTitle: '实时优化',
        promoAdvanDescription: '专业运营团队全程跟进，实时优化推广方案， 以达到最佳传播效果;'
      }],
      promoMethod: [{
        promoAdvanTitle: '社媒营销    ',
        promoAdvanDescription: '社媒覆盖，保持话题性，增强与受众的互动，有效增加粉丝黏性，完成数据转化;'
      }, {
        promoAdvanTitle: '口碑营销  ',
        promoAdvanDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑，建立用户对品牌的信任;'
      }, {
        promoAdvanTitle: '红人推广   ',
        promoAdvanDescription: '利用网红效应，选取受众相符的网红大号对粉丝推荐引导，直接影响粉丝购买决策;'
      }, {
        promoAdvanTitle: '产品评测   ',
        promoAdvanDescription: '邀请母婴类媒体大号针对品牌特色产品进行测评，横向对比，突出优势；；'
      }, {
        promoAdvanTitle: '硬广投放   ',
        promoAdvanDescription: '基于用户习惯，有针对性的进行硬广投放，获取精准人群，权威网站硬广提升品牌信任；'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e13ab06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/solution/ecommerce/index.vue
var ecommerce_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_ds_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"finance-app-advantages"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"finance-promo-advan-content"},_vm._l((_vm.promoAdvantages),function(item,index){return _c('div',{key:index,staticClass:"finance-promo-advan-content-li"},[_c('div',{staticClass:"finance-promo-advantages-fistline"},[_c('div',{staticClass:"finance-icon-box"},[_c('icon',{style:({marginTop:item.iconPosition,fontSize:item.iconSize,marginLeft:item.iconLeft}),attrs:{"type":"svg","name":item.iconName}})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.promoAdvanTitle))])]),_vm._v(" "),_c('p',{staticClass:"finance-promo-advantages-description"},[_vm._v(_vm._s(item.promoAdvanDescription))])])}))]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_ds_r"}})],1)}
var ecommerce_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solution-banner"},[_c('div',{staticClass:"banner-text"},[_c('h2',[_vm._v("电商行业推广解决方案   ")]),_vm._v(" "),_c('p',[_vm._v("智能营销解决方案\n        实现转化与成交")]),_vm._v(" "),_c('a',{staticClass:"click-to-consult",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("立刻咨询")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-trouble"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("电商行业推广困境")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/ecommerce/tgkj.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"game-trouble-item buy-0"},[_vm._v("购买动力不足")]),_vm._v(" "),_c('div',{staticClass:"game-trouble-item buy-1"},[_vm._v("知名度不足")]),_vm._v(" "),_c('div',{staticClass:"game-trouble-item buy-2"},[_vm._v("运营成本高")]),_vm._v(" "),_c('div',{staticClass:"game-trouble-item buy-3"},[_vm._v("低价薄利销量不足")]),_vm._v(" "),_c('div',{staticClass:"game-trouble-item buy-4"},[_vm._v("用户粘性不够")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-data-analyse"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"color":"#fff"}},[_vm._v("智能大数据分析")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"mother-child-data-analyse-content"},[_c('div',{staticClass:"data-content-li"},[_c('div',{staticClass:"data-content-title"},[_c('h3',[_vm._v("行业分析")])]),_vm._v(" "),_c('div',{staticClass:"data-content-title-line"}),_vm._v(" "),_c('p',[_vm._v("市场规模"),_c('br'),_vm._v("市场容量"),_c('br'),_vm._v("品类分析"),_c('br'),_vm._v("产品分析")])]),_vm._v(" "),_c('div',{staticClass:"data-content-li",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"data-content-title"},[_c('h3',[_vm._v("竞品分析")])]),_vm._v(" "),_c('div',{staticClass:"data-content-title-line"}),_vm._v(" "),_c('p',[_vm._v("竞品规模"),_c('br'),_vm._v("竞品特点"),_c('br'),_vm._v("竞品价格"),_c('br'),_vm._v("竞品卖点")])]),_vm._v(" "),_c('div',{staticClass:"data-content-li"},[_c('div',{staticClass:"data-content-title"},[_c('h3',[_vm._v("自身分析")])]),_vm._v(" "),_c('div',{staticClass:"data-content-title-line"}),_vm._v(" "),_c('p',[_vm._v("品牌现状"),_c('br'),_vm._v("品牌特点"),_c('br'),_vm._v("投放情况")])]),_vm._v(" "),_c('div',{staticClass:"data-content-li",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"data-content-title"},[_c('h3',[_vm._v("用户分析")])]),_vm._v(" "),_c('div',{staticClass:"data-content-title-line"}),_vm._v(" "),_c('p',[_vm._v("用户年龄"),_c('br'),_vm._v("用户属性"),_c('br'),_vm._v("用户行为"),_c('br'),_vm._v("用户习惯")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("电商行业推广策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-promo-method tourism-promo-method"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("电商行业推广方式")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"tourism-promo-content"},[_c('div',{staticClass:"tourism-promo-content-li"},[_c('div',{staticClass:"promo-ways-mark"},[_c('i',{staticClass:"iconfont icon-wanghongzhibo1"})]),_vm._v(" "),_c('div',{staticClass:"promo-ways-details"},[_c('h3',[_vm._v("网红直播")]),_vm._v(" "),_c('p',[_vm._v("直播有渲染力的内容传播形式，感染受众情绪，影响粉丝的购买决策；")])])]),_vm._v(" "),_c('div',{staticClass:"tourism-promo-content-li"},[_c('div',{staticClass:"promo-ways-mark"},[_c('i',{staticClass:"iconfont icon-koubeichuanbo"})]),_vm._v(" "),_c('div',{staticClass:"promo-ways-details"},[_c('h3',[_vm._v("口碑传播")]),_vm._v(" "),_c('p',[_vm._v("利用kol的粉丝效应进行品牌口碑传播，获取流量，提升品牌知名度； ")])])]),_vm._v(" "),_c('div',{staticClass:"tourism-promo-content-li"},[_c('div',{staticClass:"promo-ways-mark"},[_c('i',{staticClass:"iconfont icon-weibo1"})]),_vm._v(" "),_c('div',{staticClass:"promo-ways-details"},[_c('h3',[_vm._v("微博红人")]),_vm._v(" "),_c('p',[_vm._v("借助微博红人的影响力，通过福利活动、内容转评等，刺激购买；  ")])])]),_vm._v(" "),_c('div',{staticClass:"tourism-promo-content-li"},[_c('div',{staticClass:"promo-ways-mark"},[_c('i',{staticClass:"iconfont icon-xinxiliuguanggao"})]),_vm._v(" "),_c('div',{staticClass:"promo-ways-details"},[_c('h3',[_vm._v("信息流广告")]),_vm._v(" "),_c('p',[_vm._v("筛选目标用户精准直达，通过各平台信息流广告实现优质曝光； ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-xmb-advantages"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("软盟电商行业推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"fashionbeauty-advan-content"},[_c('div',{staticClass:"fashionbeauty-advan-content-item"},[_c('div',{staticClass:"advan-content-item-title"},[_vm._v("精准用户获取")]),_vm._v(" "),_c('p',[_vm._v("智能大数据分析，直达有购物需求的精准用户; ")])]),_vm._v(" "),_c('div',{staticClass:"fashionbeauty-advan-content-item"},[_c('div',{staticClass:"advan-content-item-title"},[_vm._v("提升电商品牌知名度 ")]),_vm._v(" "),_c('p',[_vm._v("全渠道，覆盖90%以上有传播价值的媒体资源，强势曝光，流量抢占; ")])]),_vm._v(" "),_c('div',{staticClass:"fashionbeauty-advan-content-item"},[_c('div',{staticClass:"advan-content-item-title"},[_vm._v("提升转化率   ")]),_vm._v(" "),_c('p',{staticStyle:{"width":"38vw"}},[_vm._v("舆情监测，实时优化投放效果，提高广告投放性价比，减少用户流失; ")])]),_vm._v(" "),_c('div',{staticClass:"fashionbeauty-advan-content-item"},[_c('div',{staticClass:"advan-content-item-title"},[_vm._v("专业营销经验")]),_vm._v(" "),_c('p',{staticStyle:{"width":"42vw"}},[_vm._v("专属定制媒介组合、内容运营、 投放策略，全方位整合营销; ")])]),_vm._v(" "),_c('div',{staticClass:"fashionbeauty-advan-content-item"},[_c('div',{staticClass:"advan-content-item-title"},[_vm._v("高效专属服务 ")]),_vm._v(" "),_c('p',{staticStyle:{"width":"42vw"}},[_vm._v("专项服务团队多对一服务跟进，7X12 小时配合指导操作;")])])])])}]
var ecommerce_esExports = { render: ecommerce_render, staticRenderFns: ecommerce_staticRenderFns }
/* harmony default export */ var pages_solution_ecommerce = (ecommerce_esExports);
// CONCATENATED MODULE: ./src/pages/solution/ecommerce/index.vue
function ecommerce_injectStyle (ssrContext) {
  __webpack_require__("boBm")
}
var ecommerce_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ecommerce___vue_template_functional__ = false
/* styles */
var ecommerce___vue_styles__ = ecommerce_injectStyle
/* scopeId */
var ecommerce___vue_scopeId__ = "data-v-2e13ab06"
/* moduleIdentifier (server only) */
var ecommerce___vue_module_identifier__ = null
var ecommerce_Component = ecommerce_normalizeComponent(
  solution_ecommerce,
  pages_solution_ecommerce,
  ecommerce___vue_template_functional__,
  ecommerce___vue_styles__,
  ecommerce___vue_scopeId__,
  ecommerce___vue_module_identifier__
)

/* harmony default export */ var src_pages_solution_ecommerce = (ecommerce_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/microBussiness/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var microBussiness = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/microBussiness/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var solution_microBussiness = ({
  name: 'index',
  data: function data() {
    return {
      promoWays: [{
        promoWaysTitle: '口碑营销',
        promoWaysDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑， 建立用户对品牌的信任;'
      }, {
        promoWaysTitle: '产品评测  ',
        promoWaysDescription: '邀请金融类媒体针对品牌特色产品进行测评，横向对比，突出优势;'
      }, {
        promoWaysTitle: '金融自媒体',
        promoWaysDescription: '借助金融自媒体大号的影响力为品牌背书，获取粉丝好感度;'
      }, {
        promoWaysTitle: '趣味短视频',
        promoWaysDescription: '将枯燥的金融内容与时下热点结合，用创意包装品\n'
      }, {
        promoWaysTitle: '跨界合作',
        promoWaysDescription: '通过大数据分析用户的兴趣领域，然后结合品牌与产品进行跨界合作;'
      }, {
        promoWaysTitle: '硬广投放',
        promoWaysDescription: '以创意海报、走心视频等丰富形式强势植入大流量平台，获取流量转化'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1096d1d9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/solution/microBussiness/index.vue
var microBussiness_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_wxb_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_wxb_r"}})],1)}
var microBussiness_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solution-banner"},[_c('div',{staticClass:"banner-text"},[_c('p',[_vm._v("多渠道整合智能营销，助力微商，实现品效合一\n      ")]),_vm._v(" "),_c('a',{staticClass:"click-to-consult",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("我要推广")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("微商行业推广困境")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-promo-pic"},[_c('div',{staticClass:"newproduct-promo-pic-p"},[_vm._v("知名度有限")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-j"},[_vm._v("搜索广告限制投放")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-n"},[_vm._v("公信力不足")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-m"},[_vm._v("新广告法管控限制")]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-pic-x"},[_vm._v("推广单一，囤货滞销")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-data-analyse"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"color":"#ffffff"}},[_vm._v("智能大数据分析")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"newproduct-data-analyse-contnet"},[_c('div',{staticClass:"data-analyse-contnet-item text-center"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/microBussiness/hyfx.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-title"},[_vm._v("行业分析"),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"#DE736D","font-weight":"600"}},[_vm._v("+")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("市场规模")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("行业现状")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("政策法规")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("品类分析")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item text-center"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/microBussiness/jpfx.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-title"},[_vm._v("竞品分析"),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"#DD9455","font-weight":"600"}},[_vm._v("+")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("竞品规模")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("竞品特点")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("竞品价格")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("竞品覆盖")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item text-center"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/microBussiness/zsfx.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-title"},[_vm._v("自身分析"),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"#60B9E5","font-weight":"600"}},[_vm._v("+")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("品牌现状")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("品牌特点")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("产品分析")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("投放情况")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item text-center",staticStyle:{"margin-right":"0px"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/microBussiness/yhfx.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-title"},[_vm._v("用户分析"),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"#89C0C0","font-weight":"600"}},[_vm._v("+")])]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("用户年龄")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("用户属性")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("媒体偏好")]),_vm._v(" "),_c('div',{staticClass:"data-analyse-contnet-item-ideas"},[_vm._v("触网习惯")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("微商行业推广策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/microBussiness/sjfx.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"6%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("数据分析 ")]),_vm._v(" "),_c('p',[_vm._v(" 微商行业分析、竞品分析、本品分析、受众"),_c('br'),_vm._v("分析、媒体数据分析 ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('div',{staticClass:"app-content-text"},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("推广方案 ")]),_vm._v(" "),_c('p',[_vm._v("根据分析数据与传播目标，匹配最佳媒体投"),_c('br'),_vm._v("放组合，规划传播策略与推广方案 ")])]),_vm._v(" "),_c('img',{staticStyle:{"margin-left":"5vw"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/microBussiness/tgfa.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/microBussiness/tgtg.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"6%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("推广托管")]),_vm._v(" "),_c('p',[_vm._v("帮助微商管理和优化在互联网上进行的营销"),_c('br'),_vm._v("活动（产品推广、招商代理、网站推广等）")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li"},[_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"6%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("数据监测")]),_vm._v(" "),_c('p',[_vm._v("根据推广情况监测各渠道数据效果，及时优"),_c('br'),_vm._v("化反馈")])]),_vm._v(" "),_c('img',{staticStyle:{"margin-left":"5vw"},attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/microBussiness/sjjc.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-content-li",staticStyle:{"border-bottom":"1px solid #FFF"}},[_c('img',{attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/microBussiness/ssyh.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"app-content-text",staticStyle:{"margin-top":"6%"}},[_c('div',{staticClass:"app-content-text-title"},[_vm._v("实时优化")]),_vm._v(" "),_c('p',[_vm._v("专业运营团队全程跟进，实时优化推广方案， "),_c('br'),_vm._v("以达到最佳传播效果")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-promo-method"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"color":"#fff"}},[_vm._v("微商行业推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-method-content"},[_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("软文稿件")]),_vm._v(" "),_c('p',[_vm._v("通过稿件新闻、论坛贴吧、问答、微商商"),_c('br'),_vm._v("业网等进行市场引导覆盖.")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("网红直播")]),_vm._v(" "),_c('p',[_vm._v("利用有渲染力的直播形式与粉丝效应，感"),_c('br'),_vm._v("染受众情绪，影响粉丝的购买决策。\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("硬广投放")]),_vm._v(" "),_c('p',[_vm._v("基于用户习惯，有针对性的进行硬广投"),_c('br'),_vm._v("放，获取精准人群，权威网站硬广提升品"),_c('br'),_vm._v("牌信任。\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("微信营销")]),_vm._v(" "),_c('p',[_vm._v("社媒覆盖，保持话题性，增强与受众的互"),_c('br'),_vm._v("动，有效增加粉丝黏性，完成数据转化。\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"promo-method-content-li"},[_c('div',{staticClass:"method-li-pos"},[_c('div',{staticClass:"promo-method-content-li-content"},[_vm._v("借势营销")]),_vm._v(" "),_c('p',[_vm._v("跟踪热点事件，与品牌产品进行创意结"),_c('br'),_vm._v("合，获取流量转移。\n          ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-advantages"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("微商行业推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"app-advance-content"},[_c('div',{staticClass:"finance-app-advantages-item"},[_c('div',{staticClass:"app-text-content"},[_c('div',{staticClass:"app-title-l"},[_vm._v("精准用户获取")]),_vm._v(" "),_c('p',[_vm._v("智能大数据分析，获取媒体投放数据，打击"),_c('br'),_vm._v("竞品，直达精准用户。")])])]),_vm._v(" "),_c('div',{staticClass:"finance-app-advantages-item-r"},[_c('div',{staticClass:"app-text-content-r"},[_c('div',{staticClass:"app-title-r"},[_vm._v("海量优质微商资源")]),_vm._v(" "),_c('p',[_vm._v("全渠道，各细分品类，具有传播价值的媒体"),_c('br'),_vm._v("资源覆盖，为广告主完成曝光，流量抢占。")])])]),_vm._v(" "),_c('div',{staticClass:"finance-app-advantages-item-2"},[_c('div',{staticClass:"app-text-content"},[_c('div',{staticClass:"app-title-l"},[_vm._v("提升转化率")]),_vm._v(" "),_c('p',[_vm._v("舆情监测，实时优化投放效果，提高广告投"),_c('br'),_vm._v("放性价比，减少用户流失。")])])]),_vm._v(" "),_c('div',{staticClass:"finance-app-advantages-item-r-2"},[_c('div',{staticClass:"app-text-content-r"},[_c('div',{staticClass:"app-title-r"},[_vm._v("专业营销经验")]),_vm._v(" "),_c('p',[_vm._v("专属定制媒介组合、内容运营、投放策略，"),_c('br'),_vm._v("全方位整合营销。")])])]),_vm._v(" "),_c('div',{staticClass:"finance-app-advantages-item-3"},[_c('div',{staticClass:"app-text-content"},[_c('div',{staticClass:"app-title-l"},[_vm._v("高效专属服务")]),_vm._v(" "),_c('p',[_vm._v("专项服务团队多对一服务跟进，7*12小时"),_c('br'),_vm._v("配合指导操作。")])])])])])}]
var microBussiness_esExports = { render: microBussiness_render, staticRenderFns: microBussiness_staticRenderFns }
/* harmony default export */ var pages_solution_microBussiness = (microBussiness_esExports);
// CONCATENATED MODULE: ./src/pages/solution/microBussiness/index.vue
function microBussiness_injectStyle (ssrContext) {
  __webpack_require__("/XK3")
}
var microBussiness_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var microBussiness___vue_template_functional__ = false
/* styles */
var microBussiness___vue_styles__ = microBussiness_injectStyle
/* scopeId */
var microBussiness___vue_scopeId__ = "data-v-1096d1d9"
/* moduleIdentifier (server only) */
var microBussiness___vue_module_identifier__ = null
var microBussiness_Component = microBussiness_normalizeComponent(
  solution_microBussiness,
  pages_solution_microBussiness,
  microBussiness___vue_template_functional__,
  microBussiness___vue_styles__,
  microBussiness___vue_scopeId__,
  microBussiness___vue_module_identifier__
)

/* harmony default export */ var src_pages_solution_microBussiness = (microBussiness_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/smallProgram/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var smallProgram = ({
  name: 'index',
  data: function data() {
    return {};
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/solution/smallProgram/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var solution_smallProgram = ({
  name: 'index',
  data: function data() {
    return {};
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-370e0ef8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/solution/smallProgram/index.vue
var smallProgram_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_mp_t"}}),_vm._v(" "),_c('div',{staticClass:"solution-banner"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('img',{staticClass:"wechat-trouble-pic",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/smallProgram/tgkj_sc.png","alt":""}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_mp_r"}})],1)}
var smallProgram_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("微信小程序推广困境")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-trouble-content"},[_c('div',{staticClass:"wechat-trouble-content-item"},[_c('div',{staticClass:"trouble-title"},[_vm._v("缺乏入口? ")]),_vm._v(" "),_c('div',{staticClass:"trouble-content"},[_vm._v("不知道该怎样让更多人看到小程序  ")])]),_vm._v(" "),_c('div',{staticClass:"wechat-trouble-content-item",staticStyle:{"margin-left":"13%"}},[_c('div',{staticClass:"trouble-title"},[_vm._v("缺乏流量？")]),_vm._v(" "),_c('div',{staticClass:"trouble-content"},[_vm._v("不知道该怎样让更多人点进小程序   ")])]),_vm._v(" "),_c('div',{staticClass:"wechat-trouble-content-item",staticStyle:{"margin-top":"7%"}},[_c('div',{staticClass:"trouble-title"},[_vm._v("缺乏经验？   ")]),_vm._v(" "),_c('div',{staticClass:"trouble-content"},[_vm._v("不知道小程序的更多内部规则与流量"),_c('br'),_vm._v("侧重等    ")])]),_vm._v(" "),_c('div',{staticClass:"wechat-trouble-content-item",staticStyle:{"margin-left":"13%","margin-top":"7%"}},[_c('div',{staticClass:"trouble-title"},[_vm._v("缺乏运营？  ")]),_vm._v(" "),_c('div',{staticClass:"trouble-content"},[_vm._v("制作了一个小程序却不知道该如何"),_c('br'),_vm._v("运作   ")])]),_vm._v(" "),_c('div',{staticClass:"wechat-trouble-content-item",staticStyle:{"margin-top":"3%"}},[_c('div',{staticClass:"trouble-title"},[_vm._v("缺乏内容？   ")]),_vm._v(" "),_c('div',{staticClass:"trouble-content"},[_vm._v("不知道如何从文案设计优化小程序来"),_c('br'),_vm._v("达到用户留存     ")])]),_vm._v(" "),_c('div',{staticClass:"wechat-trouble-content-item",staticStyle:{"margin-left":"13%","margin-top":"3%"}},[_c('div',{staticClass:"trouble-title"},[_vm._v("缺乏转化？  ")]),_vm._v(" "),_c('div',{staticClass:"trouble-content"},[_vm._v("不知道该如何将现有用户变现，完成"),_c('br'),_vm._v("销售转化     ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-data-analyse"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("微信小程序推广策略")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})]),_vm._v(" "),_c('div',{staticClass:"microbusiness-data-analyse-content"},[_c('div',{staticClass:"wechat-content-li"},[_c('div',{staticClass:"wechat-content-li-title"},[_vm._v("\n          平台分析\n        ")]),_vm._v(" "),_c('p',[_vm._v("分析小程序平台的 "),_c('br'),_vm._v("  最新政策 "),_c('br'),_vm._v("与推广渠道 ")])]),_vm._v(" "),_c('div',{staticClass:"wechat-content-li"},[_c('div',{staticClass:"wechat-content-li-title"},[_vm._v("\n            本品分析\n        ")]),_vm._v(" "),_c('p',[_vm._v("分析广告主 "),_c('br'),_vm._v("自身产品特点 "),_c('br'),_vm._v("与推广需求  ")])]),_vm._v(" "),_c('div',{staticClass:"wechat-content-li"},[_c('div',{staticClass:"wechat-content-li-title"},[_vm._v("\n            竞品分析\n        ")]),_vm._v(" "),_c('p',[_vm._v("分析竞品投放情况与 "),_c('br'),_vm._v("运营情况 ")])]),_vm._v(" "),_c('div',{staticClass:"wechat-content-li"},[_c('div',{staticClass:"wechat-content-li-title"},[_vm._v("\n            推广方案\n        ")]),_vm._v(" "),_c('p',[_vm._v("根据分析数据 "),_c('br'),_vm._v("规划传播策略 "),_c('br'),_vm._v("与推广方案 ")])]),_vm._v(" "),_c('div',{staticClass:"wechat-content-li"},[_c('div',{staticClass:"wechat-content-li-title"},[_vm._v("\n            专业指导\n        ")]),_vm._v(" "),_c('p',[_vm._v("专业运营团队 "),_c('br'),_vm._v("全程跟进 "),_c('br'),_vm._v("指导投放运营 ")])]),_vm._v(" "),_c('div',{staticClass:"wechat-content-li"},[_c('div',{staticClass:"wechat-content-li-title"},[_vm._v("\n            数据监测\n        ")]),_vm._v(" "),_c('p',[_vm._v("根据投放情况监测"),_c('br'),_vm._v(" 各渠道投放数据 "),_c('br'),_vm._v("及时优化反馈  ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newproduct-promo-method"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',{staticStyle:{"color":"#fff"}},[_vm._v("微信小程序推广方式")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20",staticStyle:{"margin-bottom":"15px"}})]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-method-item"},[_c('div',{staticClass:"promo-method-item-title"},[_vm._v("关键词搜索 ")]),_vm._v(" "),_c('div',{staticClass:"promo-method-item-content"},[_vm._v("关键词推广与搜索广"),_c('br'),_vm._v("告，实现直接强"),_c('br'),_vm._v("关联曝光；")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-method-item"},[_c('div',{staticClass:"promo-method-item-title"},[_vm._v("官方广告位 ")]),_vm._v(" "),_c('div',{staticClass:"promo-method-item-content"},[_vm._v("包含附近的小程序广"),_c('br'),_vm._v(" 告，公众号文章内部广告，"),_c('br'),_vm._v(" 官方广告位投放渠"),_c('br'),_vm._v(" 道，流量稳定；")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-method-item"},[_c('div',{staticClass:"promo-method-item-title"},[_vm._v("公众号跳转  ")]),_vm._v(" "),_c('div',{staticClass:"promo-method-item-content"},[_vm._v("基于公众号的置入跳 "),_c('br'),_vm._v("转链接，包含文章、菜单 "),_c('br'),_vm._v("等形式，完成用户"),_c('br'),_vm._v(" 激活与转化；")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-method-item"},[_c('div',{staticClass:"promo-method-item-title"},[_vm._v("分享拉新 ")]),_vm._v(" "),_c('div',{staticClass:"promo-method-item-content"},[_vm._v("以各种创新形式及 "),_c('br'),_vm._v("利益诱导的转发到群，分 "),_c('br'),_vm._v("享好友。基于用户习惯，"),_c('br'),_vm._v(" 推广更友好"),_c('br'),_vm._v(" 更便捷；")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-method-item"},[_c('div',{staticClass:"promo-method-item-title"},[_vm._v("推送促活 ")]),_vm._v(" "),_c('div',{staticClass:"promo-method-item-content"},[_vm._v("微信内部对用户生成 "),_c('br'),_vm._v("小程序模板消息推送，可用"),_c('br'),_vm._v(" 于提示更新、促销、"),_c('br'),_vm._v(" 日常打卡等，实现 "),_c('br'),_vm._v("变现与转化；")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-method-item"},[_c('div',{staticClass:"promo-method-item-title"},[_vm._v("线下二维码 ")]),_vm._v(" "),_c('div',{staticClass:"promo-method-item-content"},[_vm._v("因地制宜，分渠道投 "),_c('br'),_vm._v("放线下小程序码，掌握"),_c('br'),_vm._v(" 转化情况；")])]),_vm._v(" "),_c('div',{staticClass:"newproduct-promo-method-item"},[_c('div',{staticClass:"promo-method-item-title"},[_vm._v("第三方推广 ")]),_vm._v(" "),_c('div',{staticClass:"promo-method-item-content"},[_vm._v("投放至小程序商店、 "),_c('br'),_vm._v("媒体大号、微信社群等， "),_c('br'),_vm._v("粉丝精准，见"),_c('br'),_vm._v(" 效更快；")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-app-advantages"},[_c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("软盟小程序推广优势")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20",staticStyle:{"margin-bottom":"15px"}})]),_vm._v(" "),_c('div',{staticClass:"kcb-wechat-advan-content"},[_c('div',{staticClass:"kcb-wechat-advan-content-li"},[_c('div',{staticClass:"text-content"},[_c('h3',[_vm._v("关键词搜索")]),_vm._v(" "),_c('p',[_vm._v("关键词推广与搜索广告，实现直接强关联曝光")])])]),_vm._v(" "),_c('div',{staticClass:"kcb-wechat-advan-content-li"},[_c('div',{staticClass:"text-content",staticStyle:{"margin-left":"4%","margin-top":"2%"}},[_c('h3',[_vm._v("智能精准数据")]),_vm._v(" "),_c('p',[_vm._v("拥有专业技术团队，提供精确商务、用户定位，"),_c('br'),_vm._v(" 精准数据输出 ")])])]),_vm._v(" "),_c('div',{staticClass:"kcb-wechat-advan-content-li"},[_c('div',{staticClass:"text-content",staticStyle:{"margin-top":"2%"}},[_c('h3',[_vm._v("专业营销经验 ")]),_vm._v(" "),_c('p',[_vm._v("专属定制媒介组合、内容运营、投放策略，全方 "),_c('br'),_vm._v("位整合营销 ")])])]),_vm._v(" "),_c('div',{staticClass:"kcb-wechat-advan-content-li"},[_c('div',{staticClass:"text-content",staticStyle:{"margin-left":"4%","margin-top":"2%"}},[_c('h3',[_vm._v("高效专属服务")]),_vm._v(" "),_c('p',[_vm._v("专项服务团队多对一服务跟进，7X12小时配合 "),_c('br'),_vm._v("指导操作 ")])])])])])}]
var smallProgram_esExports = { render: smallProgram_render, staticRenderFns: smallProgram_staticRenderFns }
/* harmony default export */ var pages_solution_smallProgram = (smallProgram_esExports);
// CONCATENATED MODULE: ./src/pages/solution/smallProgram/index.vue
function smallProgram_injectStyle (ssrContext) {
  __webpack_require__("UGB3")
}
var smallProgram_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var smallProgram___vue_template_functional__ = false
/* styles */
var smallProgram___vue_styles__ = smallProgram_injectStyle
/* scopeId */
var smallProgram___vue_scopeId__ = "data-v-370e0ef8"
/* moduleIdentifier (server only) */
var smallProgram___vue_module_identifier__ = null
var smallProgram_Component = smallProgram_normalizeComponent(
  solution_smallProgram,
  pages_solution_smallProgram,
  smallProgram___vue_template_functional__,
  smallProgram___vue_styles__,
  smallProgram___vue_scopeId__,
  smallProgram___vue_module_identifier__
)

/* harmony default export */ var src_pages_solution_smallProgram = (smallProgram_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionToutiao/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var promotionToutiao = ({
  data: function data() {
    return {
      whyChooseContent: [{
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao1.png',
        whyText: '5秒算出用户兴趣，根据兴趣智能推荐新闻；'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao2.png',
        whyText: '手机消耗人们大量时间，看新闻排在第2位；'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao3.png',
        whyText: '2017年8月新闻资讯APP活跃用户排行榜头条2.4亿人活跃；'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao4.png',
        whyText: '今日头条自己也有新闻；'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao5.png',
        whyText: '后台灵活操作，实时数据报表；'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao6.png',
        whyText: '精准定向广告投放，让广告主的预算花的值；'
      }],
      styleToutiaoContent: [{
        styleH3: '信息流广告',
        whyText: '原生形式  投放灵活  多维定向'
      }, {
        styleH3: '开屏广告',
        whyText: '开机必看  全屏醒目  海量触大'
      }, {
        styleH3: '详情页广告',
        whyText: '阅读路径拦截  成本控制  智能竞价工具'
      }, {
        styleH3: '视频广告',
        whyText: '形式原生  超长播放   互动传播'
      }],
      commonQuestionContent: [{
        styleH3: '01今日头条广告怎么收费？',
        whyText: '今日头条支持按照CPC、CPM的形式收费，具体收费价格，请联系我们的在线客服。'
      }, {
        styleH3: '02今日头条广告与搜索引擎竞价广告有什么区别？',
        whyText: '今日头条广告与搜索引擎广告都具备精准定向的特点，不同的是今日头条是基于用户兴趣向用户推荐其感兴趣的内容，而搜索引擎广告是根据用户搜索词触发广告，二者在定向基于的数据方面是不同的。基于兴趣爱好的定向是基于用户潜在需求的定向，而基于搜索词的定向是基于用户及时需求的定向。'
      }, {
        styleH3: '03今日头条广告是竞价广告吗？',
        whyText: '今日头条广告是需要竞价的，由于设置同一定向条件的广告主太多，而广告位置有限，因此需要广告主进行竞价，出价越高，获得越多的展示机会。'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionToutiao/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var pages_promotionToutiao = ({
  data: function data() {
    return {
      whyChooseContent: [{
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao1.png',
        whyText: '5秒算出用户兴趣，根据兴趣智能推荐新闻；'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao2.png',
        whyText: '手机消耗人们大量时间，看新闻排在第2位；'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao3.png',
        whyText: '2017年8月新闻资讯APP活跃用户排行榜头条2.4亿人活跃；'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao4.png',
        whyText: '今日头条自己也有新闻；'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao5.png',
        whyText: '后台灵活操作，实时数据报表；'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/solution/toutiao6.png',
        whyText: '精准定向广告投放，让广告主的预算花的值；'
      }],
      styleToutiaoContent: [{
        styleH3: '信息流广告',
        whyText: '原生形式  投放灵活  多维定向'
      }, {
        styleH3: '开屏广告',
        whyText: '开机必看  全屏醒目  海量触大'
      }, {
        styleH3: '详情页广告',
        whyText: '阅读路径拦截  成本控制  智能竞价工具'
      }, {
        styleH3: '视频广告',
        whyText: '形式原生  超长播放   互动传播'
      }],
      commonQuestionContent: [{
        styleH3: '01今日头条广告怎么收费？',
        whyText: '今日头条支持按照CPC、CPM的形式收费，具体收费价格，请联系我们的在线客服。'
      }, {
        styleH3: '02今日头条广告与搜索引擎竞价广告有什么区别？',
        whyText: '今日头条广告与搜索引擎广告都具备精准定向的特点，不同的是今日头条是基于用户兴趣向用户推荐其感兴趣的内容，而搜索引擎广告是根据用户搜索词触发广告，二者在定向基于的数据方面是不同的。基于兴趣爱好的定向是基于用户潜在需求的定向，而基于搜索词的定向是基于用户及时需求的定向。'
      }, {
        styleH3: '03今日头条广告是竞价广告吗？',
        whyText: '今日头条广告是需要竞价的，由于设置同一定向条件的广告主太多，而广告位置有限，因此需要广告主进行竞价，出价越高，获得越多的展示机会。'
      }]
    };
  },

  methods: {},
  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63565df6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/promotionToutiao/index.vue
var promotionToutiao_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_tt_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"why-toutiao"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"why-toutiao-content"},_vm._l((_vm.whyChooseContent),function(item,index){return _c('div',{key:index,staticClass:"why-toutiao-content-li"},[_c('img',{attrs:{"src":item.imgSrc,"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.whyText))])])}))]),_vm._v(" "),_c('div',{staticClass:"style-toutiao"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"style-toutiao-content"},_vm._l((_vm.styleToutiaoContent),function(item,index){return _c('div',{key:index,staticClass:"style-toutiao-content-li"},[_c('h3',[_vm._v(_vm._s(item.styleH3))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.whyText))])])}))]),_vm._v(" "),_c('div',{staticClass:"common-question-toutiao"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"common-question-toutiao-content"},_vm._l((_vm.commonQuestionContent),function(item,index){return _c('div',{key:item,staticClass:"common-question-toutiao-li"},[_c('h3',[_vm._v(_vm._s(item.styleH3))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.whyText))])])}))]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_tt_r"}})],1)}
var promotionToutiao_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toutiao-banner"},[_c('div',{staticClass:"banner-text"},[_c('img',{staticClass:"banner-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/solution/todayHeadline_logo_banner.png","alt":""}}),_vm._v(" "),_c('h3',[_vm._v("一站式解决广告主多样化营销诉求"),_c('br'),_vm._v("\n        打造属于你的\"头条营销\"")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"what-toutiao"},[_c('div',{staticClass:"toutiao-title"},[_c('h3',[_vm._v("什么是今日头条广告")]),_vm._v(" "),_c('p',[_vm._v("WHAT IS TODAY'S HEADLINE")])]),_vm._v(" "),_c('div',{staticClass:"what-description"},[_vm._v("\n      今日头条是基于用户兴趣推荐内容的资讯阅读平台，拥有4亿用户，其信息流广告将广告融入内容中，使得广告不对用户产生干扰，用户体验好。基于用户兴趣的内容推荐，使得广告投放精准，转化率高。灵活的计费方式，可以尽可能的节省成本。\n    ")]),_vm._v(" "),_c('img',{staticClass:"what-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/solution/todayHeadline_whatpic.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toutiao-title"},[_c('h3',[_vm._v("为什么选择今日头条")]),_vm._v(" "),_c('p',[_vm._v("WHY CHOOSE TODAY'S HEADLINES")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toutiao-title"},[_c('h3',[_vm._v("今日头条的广告样式")]),_vm._v(" "),_c('p',[_vm._v("TODAY'S HEADLINE ADVERTISING STYLE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toutiao-title"},[_c('h3',[_vm._v("常见问题")]),_vm._v(" "),_c('p',[_vm._v("COMMON PROBLEMS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delivery-process-toutiao"},[_c('div',{staticClass:"toutiao-title"},[_c('h3',[_vm._v("投放流程")]),_vm._v(" "),_c('p',[_vm._v("DELIVERY PROCESS")])]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/solution/toutiao_process.png","alt":""}})])}]
var promotionToutiao_esExports = { render: promotionToutiao_render, staticRenderFns: promotionToutiao_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_promotionToutiao = (promotionToutiao_esExports);
// CONCATENATED MODULE: ./src/pages/promotionToutiao/index.vue
function promotionToutiao_injectStyle (ssrContext) {
  __webpack_require__("OXMm")
}
var promotionToutiao_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var promotionToutiao___vue_template_functional__ = false
/* styles */
var promotionToutiao___vue_styles__ = promotionToutiao_injectStyle
/* scopeId */
var promotionToutiao___vue_scopeId__ = "data-v-63565df6"
/* moduleIdentifier (server only) */
var promotionToutiao___vue_module_identifier__ = null
var promotionToutiao_Component = promotionToutiao_normalizeComponent(
  pages_promotionToutiao,
  selectortype_template_index_0_src_pages_promotionToutiao,
  promotionToutiao___vue_template_functional__,
  promotionToutiao___vue_styles__,
  promotionToutiao___vue_scopeId__,
  promotionToutiao___vue_module_identifier__
)

/* harmony default export */ var src_pages_promotionToutiao = (promotionToutiao_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionDouyin/index.vue







var caseList = [{ imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/douyin/douyin_case01.png' }, { imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/douyin/douyin_case02.png' }, { imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/douyin/douyin_case03.png' }];
/* harmony default export */ var promotionDouyin = ({
  data: function data() {
    return {
      douyinTabIndex: '0',
      resourceMZ: [{
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/4b7a71ba37c545ca74a16b91ab623600.jpeg',
        name: 'm哥',
        fansNum: '2763.3W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/c76933118374a7435d0c5de3120df11f.jpeg',
        name: '彭十六elf',
        fansNum: '1362.2w'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/031261921a2fc9427537155e5b86b48b.jpeg',
        name: '乔万旭',
        fansNum: '613.4w'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/5f76f44de84a9eec38b5b9c826c87e5f.jpeg',
        name: '张凯毅Kevin',
        fansNum: '683W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/97cc77687708668a023746404d9ddc96.jpeg',
        name: '认真少女_颜九',
        fansNum: '523.8W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/d853ee81d6bbde5f34a8f8f71b587724.jpeg',
        name: '谷大喵',
        fansNum: '298.3W'
      }],
      resourceCar: [{
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/bcaed98ce5f47636986983cb3665cb95.jpeg',
        name: '车老湿',
        fansNum: '51.1W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/633472ad735baccb656fbe17eae851f6.jpeg',
        name: '疯狂特效师',
        fansNum: '202.5W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/031261921a2fc9427537155e5b86b48b.jpeg',
        name: '车圈女神美丽姐',
        fansNum: '123.7W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/27445ab166b9c68882db3f773277675a.jpg',
        name: '*^_^*爱闪亮*^',
        fansNum: '120.9W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/b6f865cb2a4e810e55305a44a330aa16.jpeg',
        name: '王乙清',
        fansNum: '80.9W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/d21eeb73a3bee29b016e8b643bca99b7.jpeg',
        name: '=-张越',
        fansNum: '153.6W'
      }],
      resourceFahion: [{
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/f89df74090a61adec0fd4f0319bf0273.jpeg',
        name: '绝世的容颜',
        fansNum: '253.3W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/b3005da03a102a3bdbe679fccd947d6c.jpeg',
        name: '霹雳无敌璟儿',
        fansNum: '149.8W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/965d77f14410beab30c8fc228d731ba8.jpeg',
        name: 'Tender黄梦',
        fansNum: '400.4W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/8775f0cb9d5956177650a11a6f78e34c.jpg',
        name: '线条君LineDancer',
        fansNum: '392.5W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/a2fe0e4cbb4bbb864ee2f1738a8ef0a9.jpeg',
        name: '小不忍则卖大萌哥',
        fansNum: '175.5W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/a67bc9510516205d436b3c0a9bdec831.jpeg',
        name: 'I\'m～Ming周智明',
        fansNum: '209.8W'
      }],
      caseList: caseList,
      caseIndex: 0
    };
  },

  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  methods: {
    changeDouyinTab: function changeDouyinTab(index) {
      this.douyinTabIndex = index;
    },
    caseIndexChange: function caseIndexChange(index) {
      this.caseIndex = index;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionDouyin/index.vue







var promotionDouyin_caseList = [{ imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/douyin/douyin_case01.png' }, { imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/douyin/douyin_case02.png' }, { imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/douyin/douyin_case03.png' }];
/* harmony default export */ var pages_promotionDouyin = ({
  data: function data() {
    return {
      douyinTabIndex: '0',
      resourceMZ: [{
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/4b7a71ba37c545ca74a16b91ab623600.jpeg',
        name: 'm哥',
        fansNum: '2763.3W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/c76933118374a7435d0c5de3120df11f.jpeg',
        name: '彭十六elf',
        fansNum: '1362.2w'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/031261921a2fc9427537155e5b86b48b.jpeg',
        name: '乔万旭',
        fansNum: '613.4w'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/5f76f44de84a9eec38b5b9c826c87e5f.jpeg',
        name: '张凯毅Kevin',
        fansNum: '683W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/97cc77687708668a023746404d9ddc96.jpeg',
        name: '认真少女_颜九',
        fansNum: '523.8W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/d853ee81d6bbde5f34a8f8f71b587724.jpeg',
        name: '谷大喵',
        fansNum: '298.3W'
      }],
      resourceCar: [{
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/bcaed98ce5f47636986983cb3665cb95.jpeg',
        name: '车老湿',
        fansNum: '51.1W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/633472ad735baccb656fbe17eae851f6.jpeg',
        name: '疯狂特效师',
        fansNum: '202.5W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/031261921a2fc9427537155e5b86b48b.jpeg',
        name: '车圈女神美丽姐',
        fansNum: '123.7W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/27445ab166b9c68882db3f773277675a.jpg',
        name: '*^_^*爱闪亮*^',
        fansNum: '120.9W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/b6f865cb2a4e810e55305a44a330aa16.jpeg',
        name: '王乙清',
        fansNum: '80.9W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/d21eeb73a3bee29b016e8b643bca99b7.jpeg',
        name: '=-张越',
        fansNum: '153.6W'
      }],
      resourceFahion: [{
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/f89df74090a61adec0fd4f0319bf0273.jpeg',
        name: '绝世的容颜',
        fansNum: '253.3W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/b3005da03a102a3bdbe679fccd947d6c.jpeg',
        name: '霹雳无敌璟儿',
        fansNum: '149.8W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/965d77f14410beab30c8fc228d731ba8.jpeg',
        name: 'Tender黄梦',
        fansNum: '400.4W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/8775f0cb9d5956177650a11a6f78e34c.jpg',
        name: '线条君LineDancer',
        fansNum: '392.5W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/a2fe0e4cbb4bbb864ee2f1738a8ef0a9.jpeg',
        name: '小不忍则卖大萌哥',
        fansNum: '175.5W'
      }, {
        imgSrc: 'https://static.xinmeibao.com/uploads/000003/a67bc9510516205d436b3c0a9bdec831.jpeg',
        name: 'I\'m～Ming周智明',
        fansNum: '209.8W'
      }],
      caseList: promotionDouyin_caseList,
      caseIndex: 0
    };
  },

  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  methods: {
    changeDouyinTab: function changeDouyinTab(index) {
      this.douyinTabIndex = index;
    },
    caseIndexChange: function caseIndexChange(index) {
      this.caseIndex = index;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f176f856","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/promotionDouyin/index.vue
var promotionDouyin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_dy_t"}}),_vm._v(" "),_c('div',{staticClass:"toutiao-banner"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"douyin-resource"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"douyin-resource-tab-bg"}),_vm._v(" "),_c('div',{staticClass:"douyin-resource-tab"},[_c('div',{staticClass:"douyin-resource-tab-li",class:{'douyin-resource-tab-li-checked':_vm.douyinTabIndex==0},on:{"click":function($event){_vm.changeDouyinTab(0)}}},[_vm._v("美妆")]),_vm._v(" "),_c('div',{staticClass:"douyin-resource-tab-li",class:{'douyin-resource-tab-li-checked':_vm.douyinTabIndex==1},on:{"click":function($event){_vm.changeDouyinTab(1)}}},[_vm._v("汽车")]),_vm._v(" "),_c('div',{staticClass:"douyin-resource-tab-li",class:{'douyin-resource-tab-li-checked':_vm.douyinTabIndex==2},on:{"click":function($event){_vm.changeDouyinTab(2)}}},[_vm._v("时尚")])]),_vm._v(" "),_c('div',{staticClass:"douyin-resource-content"},[_vm._l((_vm.resourceMZ),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.douyinTabIndex==0),expression:"douyinTabIndex==0"}],key:index,staticClass:"douyin-resource-content-li"},[_c('div',{staticClass:"douyin-resource-avatar-bg"},[_c('div',{staticClass:"douyin-resource-avatar"},[_c('img',{attrs:{"src":item.imgSrc,"alt":""}})]),_vm._v(" "),_c('img',{staticClass:"douyin-resource-platform",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/douyin/douyin.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"douyin-resource-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"douyin-fansnum"},[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(item.fansNum))])]),_vm._v(" "),_c('a',{staticClass:"douyin-look-price",attrs:{"href":"/media?tab=video"}},[_vm._v("查看报价")])])}),_vm._v(" "),_vm._l((_vm.resourceCar),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.douyinTabIndex==1),expression:"douyinTabIndex==1"}],key:index,staticClass:"douyin-resource-content-li"},[_c('div',{staticClass:"douyin-resource-avatar-bg"},[_c('div',{staticClass:"douyin-resource-avatar"},[_c('img',{attrs:{"src":item.imgSrc,"alt":""}})]),_vm._v(" "),_c('img',{staticClass:"douyin-resource-platform",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/douyin/douyin.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"douyin-resource-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"douyin-fansnum"},[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(item.fansNum))])]),_vm._v(" "),_c('a',{staticClass:"douyin-look-price",attrs:{"href":"/media?tab=video"}},[_vm._v("查看报价")])])}),_vm._v(" "),_vm._l((_vm.resourceFahion),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.douyinTabIndex==2),expression:"douyinTabIndex==2"}],key:index,staticClass:"douyin-resource-content-li"},[_c('div',{staticClass:"douyin-resource-avatar-bg"},[_c('div',{staticClass:"douyin-resource-avatar"},[_c('img',{attrs:{"src":item.imgSrc,"alt":""}})]),_vm._v(" "),_c('img',{staticClass:"douyin-resource-platform",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/douyin/douyin.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"douyin-resource-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"douyin-fansnum"},[_vm._v("粉丝数  "),_c('span',[_vm._v(_vm._s(item.fansNum))])]),_vm._v(" "),_c('a',{staticClass:"douyin-look-price",attrs:{"href":"/media?tab=video"}},[_vm._v("查看报价")])])})],2)]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"model-douyin"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"model-douyin-content"},[_c('div',{staticClass:"model-douyin-tabbar-bg"}),_vm._v(" "),_c('div',{staticClass:"model-douyin-tabbar"},[_c('div',{staticClass:"model-douyin-tabbar-li",class:{active:_vm.douyinTabIndex == 0},on:{"click":function($event){_vm.changeDouyinTab(0)}}},[_vm._v("KOL广告投放")]),_vm._v(" "),_c('div',{staticClass:"model-douyin-tabbar-li",class:{active:_vm.douyinTabIndex == 1},on:{"click":function($event){_vm.changeDouyinTab(1)}}},[_vm._v("开屏广告")]),_vm._v(" "),_c('div',{staticClass:"model-douyin-tabbar-li",class:{active:_vm.douyinTabIndex == 2},on:{"click":function($event){_vm.changeDouyinTab(2)}}},[_vm._v("信息流广告")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.douyinTabIndex == 0),expression:"douyinTabIndex == 0"}],staticClass:"model-douyin-content-li"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/douyin/modal_kol.png","alt":""}}),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.douyinTabIndex == 1),expression:"douyinTabIndex == 1"}],staticClass:"model-douyin-content-li"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/douyin/modal_open.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"model-douyin-content-li-text"},[_vm._v("\n          开屏广告是抖音短视频开机第一入口，是一个全屏广告，抖音潮人全 量触达，无论是动态还是静态的全屏展示都能给人超强的视觉冲击。 开屏广告的售卖方式为CPT（广告主可以选择在全天24小时内任一 时间段投放广告，用户只要在这段时间内打开抖音APP，即可看到广 告。在这一时间内无论广告展示多少次都不会收取广告费用）\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.douyinTabIndex == 2),expression:"douyinTabIndex == 2"}],staticClass:"model-douyin-content-li"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/douyin/modal_dsp.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"model-douyin-content-li-text"},[_vm._v("\n          信息流广告可以将用户的观看体验升级，在这里，抖音的信息流广告 不仅仅是创意平移，而是创意定制。抖音的信息流广告更原生、更前 置、并且还具有高互动的特点。更原生：全屏视频信息流是在第4位出现，能够让抖音范儿创意展示； 更前置：转化按钮在用户的第一视觉入口展示，便捷跳转减少流失； 高互动：可点赞、转发、评论丰富评论提升用户品牌好感度；\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"douyin-case"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"douyin-case-content"},[_c('swiper',{attrs:{"height":"1040px","dots-position":"center","loop":"","auto":"","interval":3000}},_vm._l((_vm.caseList),function(item,index){return _c('swiper-item',{key:index,staticClass:"douyin-lunbo-pic"},[_c('img',{attrs:{"src":item.imgSrc}})])}))],1)]),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_dy_r"}})],1)}
var promotionDouyin_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"douyin-pattern"},[_c('div',{staticClass:"common-title"},[_c('div',{staticClass:"common-title-01"}),_vm._v(" "),_c('p',[_vm._v("颠覆短视频"),_c('span',[_vm._v("行业格局")])])]),_vm._v(" "),_c('div',{staticClass:"douyin-pattern-content"},[_c('div',{staticClass:"douyin-pattern-gloabl"},[_c('p',[_vm._v("抖音火遍全球")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/douyin/global_01.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"douyin-pattern-gloabl"},[_c('p',[_vm._v("全球火爆布局")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/douyin/global_02.png","alt":""}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"douyin-social"},[_c('div',{staticClass:"common-title"},[_c('div',{staticClass:"common-title-02"}),_vm._v(" "),_c('p',[_vm._v("“智能社交”强化创作者与粉丝关系,"),_c('br'),_vm._v("构建抖音短视频平台内容的"),_c('span',[_vm._v("智能社交生态")])])]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/douyin/intelligent_promotion.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-title"},[_c('div',{staticClass:"common-title-03"}),_vm._v(" "),_c('p',[_vm._v("精选"),_c('span',[_vm._v("优质资源")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"douyin-promotion"},[_c('div',{staticClass:"common-title"},[_c('div',{staticClass:"common-title-04"}),_vm._v(" "),_c('p',[_vm._v("抖音推广"),_c('span',[_vm._v("就找软盟")])])]),_vm._v(" "),_c('div',{staticClass:"douyin-promotion-content"},[_c('div',{staticClass:"douyin-promotion-content-li"},[_c('div',{staticClass:"douyin-promotion-content-li-inner douyin-promotion-first"},[_c('div',{staticClass:"douyin-promotion-h3"},[_vm._v("专业策划团队")]),_vm._v(" "),_c('div',{staticClass:"douyin-promotion-p"},[_vm._v("燃爆的视频话题策划")])])]),_vm._v(" "),_c('div',{staticClass:"douyin-promotion-content-li"},[_c('div',{staticClass:"douyin-promotion-content-li-inner douyin-promotion-second"},[_c('div',{staticClass:"douyin-promotion-h3"},[_vm._v("专业优化团队")]),_vm._v(" "),_c('div',{staticClass:"douyin-promotion-p"},[_vm._v("专人跟进数据效果监控优化\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"douyin-promotion-content-li"},[_c('div',{staticClass:"douyin-promotion-content-li-inner douyin-promotion-third"},[_c('div',{staticClass:"douyin-promotion-h3"},[_vm._v("独有大数据系统")]),_vm._v(" "),_c('div',{staticClass:"douyin-promotion-p"},[_vm._v("软盟独创“智汇云”"),_c('br'),_vm._v("大数据系统")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-title"},[_c('div',{staticClass:"common-title-05"}),_vm._v(" "),_c('p',[_vm._v("合作形式")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"model-douyin-content-li-text"},[_c('h3',{staticStyle:{"color":"#fff"}},[_vm._v("——非标广告指的是非官方的广告。")]),_vm._v("\n          KOL广告投放是根据投放需求筛选出最合适的博主供品牌选择，无论是时尚、美妆类还是母婴、旅行、生活方式类等等。这些博主是我们认为最适合分享您的产品、最具相关性的达人，在节省您宝贵时间的同时，也希望能帮您找到最合适的代言人；\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-title"},[_c('div',{staticClass:"common-title-06"}),_vm._v(" "),_c('p',[_vm._v("精选"),_c('span',[_vm._v("案例")])])])}]
var promotionDouyin_esExports = { render: promotionDouyin_render, staticRenderFns: promotionDouyin_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_promotionDouyin = (promotionDouyin_esExports);
// CONCATENATED MODULE: ./src/pages/promotionDouyin/index.vue
function promotionDouyin_injectStyle (ssrContext) {
  __webpack_require__("csIS")
}
var promotionDouyin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var promotionDouyin___vue_template_functional__ = false
/* styles */
var promotionDouyin___vue_styles__ = promotionDouyin_injectStyle
/* scopeId */
var promotionDouyin___vue_scopeId__ = "data-v-f176f856"
/* moduleIdentifier (server only) */
var promotionDouyin___vue_module_identifier__ = null
var promotionDouyin_Component = promotionDouyin_normalizeComponent(
  pages_promotionDouyin,
  selectortype_template_index_0_src_pages_promotionDouyin,
  promotionDouyin___vue_template_functional__,
  promotionDouyin___vue_styles__,
  promotionDouyin___vue_scopeId__,
  promotionDouyin___vue_module_identifier__
)

/* harmony default export */ var src_pages_promotionDouyin = (promotionDouyin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionXhs/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var promotionXhs = ({
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      xhsInspirationContent: [{
        xhsNumber: '1',
        xhsText: '筛选高质高 权重账号'
      }, {
        xhsNumber: '2',
        xhsText: '把控内容设 置关键字'
      }, {
        xhsNumber: '3',
        xhsText: '网红联动霸 屏策略'
      }, {
        xhsNumber: '4',
        xhsText: '精通推荐 机制'
      }],
      resourceFood: [],
      resourceBeauty: [],
      resourceMother: [],
      resourceFashion: []
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },

    //  客户案例的切换
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  },

  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionXhs/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var pages_promotionXhs = ({
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      xhsInspirationContent: [{
        xhsNumber: '1',
        xhsText: '筛选高质高 权重账号'
      }, {
        xhsNumber: '2',
        xhsText: '把控内容设 置关键字'
      }, {
        xhsNumber: '3',
        xhsText: '网红联动霸 屏策略'
      }, {
        xhsNumber: '4',
        xhsText: '精通推荐 机制'
      }],
      resourceFood: [],
      resourceBeauty: [],
      resourceMother: [],
      resourceFashion: []
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },

    //  客户案例的切换
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  },

  components: {
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d3d84d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/promotionXhs/index.vue
var promotionXhs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('index-header',{attrs:{"utm-click":"register_xhs_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==0},on:{"click":function($event){_vm.changeTab(0)}}},[_vm._v("明星推荐")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==1},on:{"click":function($event){_vm.changeTab(1)}}},[_vm._v("红人推荐")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==2},on:{"click":function($event){_vm.changeTab(2)}}},[_vm._v("素人分享")])]),_vm._v(" "),(_vm.tabIndex1==0)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(3),_vm._v(" "),_vm._m(4)]):_vm._e(),_vm._v(" "),(_vm.tabIndex1==1)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(5),_vm._v(" "),_vm._m(6)]):_vm._e(),_vm._v(" "),(_vm.tabIndex1==2)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(7),_vm._v(" "),_vm._m(8)]):_vm._e()]),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('div',{staticClass:"xhs-inspiration"},[_vm._m(11),_vm._v(" "),_c('img',{staticClass:"xhs-strategy",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/xhs/tfqf01.png","alt":""}}),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('div',{staticClass:"xhs-inspiration-circle"}),_vm._v(" "),_c('div',{staticClass:"xhs-inspiration-step"},_vm._l((_vm.xhsInspirationContent),function(item,index){return _c('div',{key:index,staticClass:"xhs-inspiration-step-li"},[_c('div',{staticClass:"xhs-inspiration-step-li-number"},[_vm._v(_vm._s(item.xhsNumber))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.xhsText))])])})),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-btn",staticStyle:{"margin-left":"32%","margin-top":"8%"},attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("立即咨询推广")])]),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_xhs_r"}})],1)}
var promotionXhs_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toutiao-banner"},[_c('a',{attrs:{"target":"_blank","href":"https://chat.xinmeibao.com/"}},[_vm._v("我要推广")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs-prospect"},[_c('div',{staticClass:"toutiao-title"},[_vm._v("\n       前景广阔\n        "),_c('div',{staticClass:"toutiao-title-line"}),_vm._v(" "),_c('div',{staticClass:"toutiao-title-content"},[_vm._v(" 小红书2018年海淘电商app应用排名第一，当前用户数已"),_c('br'),_vm._v("突破 "),_c('span',[_vm._v("1亿")])])]),_vm._v(" "),_c('div',{staticClass:"xhs-prospect-content"},[_c('div',{staticClass:"xhs-prospect-sex clearfix",staticStyle:{"margin-top":"46px"}},[_c('img',{staticClass:"xhs-prospect-mark",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/xhs/xhs123.png","alt":""}}),_vm._v(" "),_c('h3',[_vm._v("性别分布")]),_vm._v(" "),_c('div',{staticClass:"xhs-prospect-text"},[_vm._v("女性群体占据大多数，这和小红书APP的定位有关。小红书主要是以购物、穿搭、护肤、美妆、美食为主的跨境电商平台，女性更注重于这方面的内容。")]),_vm._v(" "),_c('img',{staticClass:"xhs-sex-ratio",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/xhs/qjgk_sex_distribution.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"xhs-prospect-sex clearfix",staticStyle:{"margin-top":"72px"}},[_c('img',{staticClass:"xhs-prospect-mark",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/xhs/qjgk_icon_age.png","alt":""}}),_vm._v(" "),_c('h3',[_vm._v("年龄分布")]),_vm._v(" "),_c('div',{staticClass:"xhs-prospect-text"},[_vm._v("小红书近90%的用户年龄集中在20~39岁，用户有着追求美的事物和为美付出努力的想法，这与小红书的目标相一致，并有利于双方共同发展。")]),_vm._v(" "),_c('img',{staticClass:"xhs-sex-ratio",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/xhs/age_distribution.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"xhs-prospect-sex clearfix",staticStyle:{"margin-top":"107px"}},[_c('img',{staticClass:"xhs-prospect-mark",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/xhs/qjgk_icon_sex.png","alt":""}}),_vm._v(" "),_c('h3',[_vm._v("地区分布")]),_vm._v(" "),_c('div',{staticClass:"xhs-prospect-text"},[_vm._v("多数用户分布在经济较为发达的地区。时尚潮流更容易在经济发达地区传播，用户的购买能力也更强。")]),_vm._v(" "),_c('img',{staticClass:"xhs-sex-ratio",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/xhs/area_chart.png","alt":""}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toutiao-title",staticStyle:{"margin-top":"5.5%"}},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("精选优质资源")]),_vm._v(" "),_c('div',{staticClass:"toutiao-title-line",staticStyle:{"margin":"2% auto 0"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/xhs/superstar_picture.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"xhs1-case-title"},[_vm._v("明星效应：")]),_vm._v(" "),_c('div',{staticClass:"xhs1-case-content-title"},[_vm._v("真实分享（原创图文&视频介绍）")]),_vm._v(" "),_c('div',{staticClass:"xhs1-case-content-title"},[_vm._v("带动话题 + 网红响应 + kol扩散 + 引导转化")]),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-btn",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("点击免费咨询")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-pic-1",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/xhs/reds_recommended_picture.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"xhs1-case-title"},[_vm._v("红人推荐：")]),_vm._v(" "),_c('div',{staticClass:"xhs1-case-content-title"},[_vm._v("单品测评+专业合集测评")]),_vm._v(" "),_c('div',{staticClass:"xhs1-case-content-title"},[_vm._v("个性展示 + 个人品牌 +粉丝追随 + 响应明星话题")]),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-btn",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("点击免费咨询")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-pic-2",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/xhs/plain_recommendation_picture.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"xhs1-case-title"},[_vm._v("素人分享：")]),_vm._v(" "),_c('div',{staticClass:"xhs1-case-content-title"},[_vm._v("真实分享（原创图文&视频介绍）")]),_vm._v(" "),_c('div',{staticClass:"xhs1-case-content-title"},[_vm._v("大量素人扩散 + 响应明星/红人话题 + 霸屏关键词")]),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-btn",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("点击免费咨询")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-spread"},[_c('div',{staticClass:"toutiao-title",staticStyle:{"margin-top":"5.5%"}},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("推广策略")]),_vm._v(" "),_c('div',{staticClass:"toutiao-title-line",staticStyle:{"margin":"2% auto 0"}})]),_vm._v(" "),_c('p',[_c('span'),_vm._v(" 利用网红制造品牌势能品牌高度，以此作为品牌背书和获取消费者的信任感。大量投放小红书上的中小KOL制造热度，形成跟风效应，在小红书发酵成为网红产品。"),_c('br'),_vm._v(" "),_c('span'),_vm._v(" 利用微商代理、网络炒作，在朋友圈、新闻媒体、社交平台曝光明星和网红的内容，将热度扩散到整个网络。\n    ")]),_vm._v(" "),_c('img',{staticClass:"new-guest-spread-photo",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/xhs/tgcl_xhszt_content.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs-idea"},[_c('div',{staticClass:"toutiao-title",staticStyle:{"margin-top":"5.5%"}},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("推广策略")]),_vm._v(" "),_c('div',{staticClass:"toutiao-title-line",staticStyle:{"margin":"2% auto 0"}})]),_vm._v(" "),_c('img',{staticClass:"new-guest-spread-chart",attrs:{"src":"http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/xhs/cych_content.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toutiao-title",staticStyle:{"margin-top":"5.5%"}},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("投放启发")]),_vm._v(" "),_c('div',{staticClass:"toutiao-title-line",staticStyle:{"margin":"2% auto 0"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("基于内部机器推荐算法定制小红书营销策略，"),_c('br'),_vm._v("\n        让好的品牌广告在合适的时间、合适的地点（场景），以合适"),_c('br'),_vm._v("\n        的形式遇上合适的人")])}]
var promotionXhs_esExports = { render: promotionXhs_render, staticRenderFns: promotionXhs_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_promotionXhs = (promotionXhs_esExports);
// CONCATENATED MODULE: ./src/pages/promotionXhs/index.vue
function promotionXhs_injectStyle (ssrContext) {
  __webpack_require__("a3SX")
}
var promotionXhs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var promotionXhs___vue_template_functional__ = false
/* styles */
var promotionXhs___vue_styles__ = promotionXhs_injectStyle
/* scopeId */
var promotionXhs___vue_scopeId__ = "data-v-3d3d84d8"
/* moduleIdentifier (server only) */
var promotionXhs___vue_module_identifier__ = null
var promotionXhs_Component = promotionXhs_normalizeComponent(
  pages_promotionXhs,
  selectortype_template_index_0_src_pages_promotionXhs,
  promotionXhs___vue_template_functional__,
  promotionXhs___vue_styles__,
  promotionXhs___vue_scopeId__,
  promotionXhs___vue_module_identifier__
)

/* harmony default export */ var src_pages_promotionXhs = (promotionXhs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/agreement/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var agreement = ({
  name: 'index'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/agreement/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pages_agreement = ({
  name: 'index'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68f2c0ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/agreement/index.vue
var agreement_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var agreement_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"agreement-container-top"},[_c('h1',[_vm._v("软盟用户服务协议")]),_vm._v(" "),_c('p',{staticClass:"agreement-time"},[_vm._v("2018-4-11  11:05")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content"},[_c('p',[_vm._v("本协议为用户与武汉智汇互动信息科技有限公司就软盟（www.xinmeibao.com/）平台使用相关事宜而签订，具有法律效力。用户注册时，请认真阅读本协议，尤其是限制用户权利的条款，并选择接受或不接受本协议。用户的注册及使用行为即表示用户已充分阅读、理解并接受本协议的全部内容，并自愿接受本协议各项条款的约束。")]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("一、定义")]),_vm._v(" "),_c('p',[_vm._v("在本协议中所使用的下列词语，除非另有定义，应具有以下含义：")]),_vm._v(" "),_c('p',[_vm._v("1. 本公司：指武汉智汇互动信息科技有限公司。")]),_vm._v(" "),_c('p',[_vm._v("2. 本网站：指软盟平台(www.xinmeibao.com/)。")]),_vm._v(" "),_c('p',[_vm._v("3. 用户：指符合本协议所规定的条件，同意遵守本网站各种规则、条款（包括但不限于本协议），并使用本网站的自然人、法人或其它组织。")]),_vm._v(" "),_c('p',[_vm._v("4. 本协议：指本公司与用户就本网站的注册、使用相关事宜签署的《软盟用户服务协议》。")])])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("一、定义")]),_vm._v(" "),_c('p',[_vm._v("在本协议中所使用的下列词语，除非另有定义，应具有以下含义：")]),_vm._v(" "),_c('p',[_vm._v("1. 本公司：指武汉智汇互动信息科技有限公司。")]),_vm._v(" "),_c('p',[_vm._v("2. 本网站：指软盟平台(www.xinmeibao.com/)。")]),_vm._v(" "),_c('p',[_vm._v("3. 用户：指符合本协议所规定的条件，同意遵守本网站各种规则、条款（包括但不限于本协议），并使用本网站的自然人、法人或其它组织。")]),_vm._v(" "),_c('p',[_vm._v("4. 本协议：指本公司与用户就本网站的注册、使用相关事宜签署的《软盟用户服务协议》。")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("二、用户资格")]),_vm._v(" "),_c('p',[_vm._v("1. 符合下列条件之一的自然人、法人或其它组织可以注册为本网站用户，使用本网站服务：")]),_vm._v(" "),_c('p',[_vm._v("(1) 年满十八周岁，且具有完全民事权利能力和民事行为能力的自然人（未满十八周岁的自然人应经其监护人书面同意）；")]),_vm._v(" "),_c('p',[_vm._v("(2) 根据中华人民共和国法律或其注册地法律、法规合法成立并有效存续的法人或其它组织；")]),_vm._v(" "),_c('p',[_vm._v("(3) 无民事行为能力人、限制民事行为能力人以及无经营资格或无特定经营资格的法人或其它组织不应注册为本网站用户或超过其民事行为能力范围从事交易，若出现前述情形，且合同效力未得到有效补正，本协议自始无效；本公司及本网站一经发现，有权立即注销该用户，且有权要求其赔偿因此给本公司及本网站造成的一切损失")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("三、用户权利和义务")]),_vm._v(" "),_c('p',[_vm._v("1. 用户有权根据本协议及本网站相关规定，使用本网站提供的服务，包括但不限于利用本网站发布任务信息、参与本网站的有关活动等；")]),_vm._v(" "),_c('p',[_vm._v("2. 用户应保证所有注册信息是真实准确的，包括但不限于真实名称/姓名、注册证号/身份证号、联系电话、地址、邮政编码、电子邮件、支付宝账号、粉丝数、朋友圈数量等，并保证本公司及本网站可通过上述联系方式及时与用户取得联系；若注册信息有变更，用户应及时更新；")]),_vm._v(" "),_c('p',[_vm._v("3. 用户用于登录软盟平台（www.xinmeibao.com/）的用户名、密码均由用户自行设置并保管。双方确认，用户在软盟平台操作的任何行为包括但不限于修改、重置用户信息、报价、收款账户、收款人信息等，均视为用户真实意思的表示。用户应妥善保管用户名和密码，因用户名、密码泄露而导致的损失，均由用户自行承担；用户不得擅自转让或授权他人使用其在本网站的用户名、密码，否则应自行承担由此引起的一切后果；")]),_vm._v(" "),_c('p',[_vm._v("4. 用户应保证其身份及发布的推广内容符合《中国人民共和国广告法》等相关法律法规的规定，不得以虚假或引人误解的内容欺骗、误导消费者；")]),_vm._v(" "),_c('p',[_vm._v("5. 用户不得在本网站传播任何假冒伪劣产品或服务信息，包括但不限于假冒或仿冒他人专利、认证、商标的产品、不符合国家标准或行业标准的产品、过期变质产品、虚假服务等；")]),_vm._v(" "),_c('p',[_vm._v("6. 用户不得在本网站发布国家禁止发布、侵犯他人知识产权或其他合法权益的信息，也不得发布违背社会公共利益或公共道德的信息；")]),_vm._v(" "),_c('p',[_vm._v("7. 用户使用本网站时应当遵守诚实信用原则，不得采取不正当竞争行为，不得扰乱网上交易的正常秩序，不得从事与网上交易无关的行为；")]),_vm._v(" "),_c('p',[_vm._v("8. 用户承诺其在本网站实施的所有行为均符合国家法律、法规、社会公共利益、公共道德及本网站的相关规定；")]),_vm._v(" "),_c('p',[_vm._v("9. 用户应自行承担因使用本网站所产生的相关税费，包括但不限于所得税、营业税、增值税、平台服务费等；")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("10. 用户不得使用以下方式登录本网站或破坏本网站提供的服务：")]),_vm._v(" "),_c('p',[_vm._v("(1) 以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它自动方式访问或登录本网站；")]),_vm._v(" "),_c('p',[_vm._v("(2) 通过任何方式对本网站内部结构造成或可能造成不合理或不合比例的重大负荷的行为；")]),_vm._v(" "),_c('p',[_vm._v("(3) 通过任何方式干扰或试图干扰本网站的正常工作或本网站进行的任何活动。")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("11. 用户同意接收来自本网站的信息，包括但不限于活动信息、交易信息、促销信息等；")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("12. 用户不得实施以下作弊行为：")]),_vm._v(" "),_c('p',[_vm._v("(1)通过人工及程序制造的无效点击提高流量，包括但不限于通过代理服务点击、互换点击等虚假无效点击；")]),_vm._v(" "),_c('p',[_vm._v("(2)任何非正常的产品投放形式，任何以文字诱导或强制用户点击的行为；")]),_vm._v(" "),_c('p',[_vm._v("(3)上传虚假截图。")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("13. 用户同意本公司及本网站可在以下事项中使用用户的相关信息：")]),_vm._v(" "),_c('p',[_vm._v("(1) 向用户及时发送重要通知，如软件更新、本协议条款的变更；")]),_vm._v(" "),_c('p',[_vm._v("(2) 本公司及本网站进行审计、数据分析和研究等，以改进产品、服务及与用户之间的沟通；")]),_vm._v(" "),_c('p',[_vm._v("(3) 依本协议约定，本公司及本网站管理、审查用户信息及进行处理措施；")]),_vm._v(" "),_c('p',[_vm._v("(4) 本公司及本网站自行判断为合理使用的情形；")]),_vm._v(" "),_c('p',[_vm._v("(5) 适用法律法规规定的其他事项。")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("四、本公司、本网站权利义务")]),_vm._v(" "),_c('p',[_vm._v("1. 本公司及本网站将在现有技术水平的基础上努力确保本网站正常运行，尽力避免服务中断或将中断时间限制在可行的最短时间内，尽最大努力保证用户在本网上的活动顺利进行；")]),_vm._v(" "),_c('p',[_vm._v("2. 本网站将对用户使用本网站过程中所遇到的问题及时反馈；")]),_vm._v(" "),_c('p',[_vm._v("3. 本公司及本网站有权对用户的注册信息进行查阅，若本公司及本网站对用户的注册信息有合理怀疑时，有权向用户发出询问函要求用户做出解释、改正；若情况严重，本公司及本网站可不经通知用户直接采取删除信息、注销账号等处理方式而无需承担任何责任；")]),_vm._v(" "),_c('p',[_vm._v("4. 用户因使用本网站服务而与本网站其他用户产生纠纷的，可向本网站反馈纠纷情况，本网站收到反馈后，可通过电子邮件、电话等方式向纠纷双方了解情况，并将所了解的情况通过电子邮件通知双方，但本网站仅限于了解情况，并不介入双方之间纠纷的解决，亦无义务向纠纷双方提供任何资料；若用户需本网站提供相关资料，应向司法、行政部门求助，由司法、行政部门依照法定程序要求本网站提供相关资料；")]),_vm._v(" "),_c('p',[_vm._v("5. 因网上信息平台的特殊性，本公司及本网站不能对用户在本网站进行的所有行为进行审查。若本公司及本网站所掌握的情况认定用户在本网站的行为存在违法、违反本协议规定或其他不当行为的，本公司及本网站有权向用户核实有关情况，并根据具体情形采取向用户发出警告通知、删除用户相关信息、限制用户活动直至停止该用户提供服务等处理措施；")]),_vm._v(" "),_c('p',[_vm._v("6. 本公司及本网站发现用户有下列行为时，可根据情节轻重不通知用户直接采取限制账户、删除账户或其他限制性处理措施：发布虚假信息、借本网站规避费用、借本网站炒作、欺诈、与网上交易无关或不是以交易为目的、恶意竞价、扰乱或试图扰乱正常交易秩序、违反公共利益或其它损害或可能损害本公司、本网站或其他用户合法利益的行为。")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("五、服务的中断和终止")]),_vm._v(" "),_c('p',[_vm._v("1. 本网站未向用户收取相关服务费用的情况下，可自行决定以包括但不限于本网站认为用户已违反本协议或用户超过90天内未登录本网站任何理由终止对用户的服务，并不再保存用户在本网站的全部资料而无需通知该用户（包括但不限于用户信息、商品信息、交易信息等）。服务终止后，本网站没有义务为用户保留其资料或与之相关的任何信息，或转发任何未曾阅读或发送的信息给用户或第三方；")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("2. 用户向本网站提出注销用户身份的，本网站经审核同意后注销，本协议自注销之时起即终止，但本网站仍保留下列权利：")]),_vm._v(" "),_c('p',[_vm._v("(1) 有权保留被注销用户的资料，包括但不限于用户注册信息、交易记录等；")]),_vm._v(" "),_c('p',[_vm._v("(2) 如用户在注销前在本网站存在违法或违反本协议的行为，本网站仍可行使本协议所规定的权利。")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("3. 用户如存在下列情况，本网站可通过注销用户账户的方式终止服务：")]),_vm._v(" "),_c('p',[_vm._v("(1) 本公司及本网站根据所掌握的情况，认定用户存在违法、违反本协议相关规定或其它不当行为的；")]),_vm._v(" "),_c('p',[_vm._v("(2) 用户注册信息及提供的资料有虚假内容的；")]),_vm._v(" "),_c('p',[_vm._v("(3) 出现本协议第三条第12款行为的；")]),_vm._v(" "),_c('p',[_vm._v("(4) 本公司及本网站认为需终止服务的其它情况。")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("六、免责声明")]),_vm._v(" "),_c('p',[_vm._v("当用户接受本协议时，用户应仔细阅读了解并同意以下条款∶")]),_vm._v(" "),_c('p',[_vm._v("1. 用户使用本网站之风险由用户自行承担。本公司依据现有技术提供服务，尽管本公司将尽合理努力维护本网站的正常运行，但本公司无法随时预见到任何技术上的问题或其他困难，该等问题或困难可能导致用户的使用受到影响（包括但不限于交易延迟、交易失败等），请用户谨慎考虑使用本网站所提供服务可能带来的风险；")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("3. 是否经由本网站下载或取得任何资料，由用户自行考虑、衡量并且自负风险，因下载任何资料而导致用户电脑系统的任何损坏或资料流失，用户自行负责；")]),_vm._v(" "),_c('p',[_vm._v("4. 用户经由本网站取得的建议和资讯，无论其形式或表现，绝不构成本协议未明示规定的任何保证；")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("5. 基于以下原因而造成用户的利润、商誉或其它无形损失，本网站不承担任何直接或间接赔偿责任：")]),_vm._v(" "),_c('p',[_vm._v("(1) 本网站的暂停使用或无法使用；")]),_vm._v(" "),_c('p',[_vm._v("(2) 用户的资料遭到未获授权的存取或变更；")]),_vm._v(" "),_c('p',[_vm._v("(3) 本网站中任何第三方之声明或行为。")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("6. 对于用户所发布任务、推广信息的合法性、真实性、品质以及用户履行交易的能力等，本网站无事先审查义务且不承担任何连带责任；若有任何第三方因用户发布的信息而向本公司及本网站主张权利，本公司及本网站将根据情况将用户信息告知第三方，由用户和第三方自行解决；若本公司及本网站因第三方主张权利而遭受任何损失，用户应负责赔偿；")]),_vm._v(" "),_c('p',[_vm._v("7. 本网站提供与其它网站或资源的链接，用户可能会因此链接至其它运营商经营的网站，但不表示本网站与这些运营商有任何关系，本网站不对上述链接网站及其网页内容进行管理监督。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、物品或服务所产生的任何损害或损失，本网站不负任何直接或间接赔偿责任；")]),_vm._v(" "),_c('p',[_vm._v("8. 本网站仅为用户提供交易平台，用户因使用本网站与任何第三方产生的纠纷均与本公司及本网站无关，本公司及本网站不承担任何责任。")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("七、知识产权")]),_vm._v(" "),_c('p',[_vm._v("1. 所有本网站的内容，包括但不限于作品、图片、档案、资料、网站构架、网站版面的安排、网页设计、软件、经由本网站呈现的推广信息或资讯，均由本公司及本网站或相关权利人依法享有相应知识产权（包括但不限于著作权、商标权、专利权或其它专属权利等），用户仅在符合本网站使用目的前提下被许可浏览和使用本网站。未经本公司及本网站或相关权利人明示授权，用户不得复制、修改、出租、出借、出售、传送、删除、添加本网站的内容，或根据上述网站资料和资源制作成任何种类物品；")]),_vm._v(" "),_c('p',[_vm._v("(1) 年满十八周岁，且具有完全民事权利能力和民事行为能力的自然人（未满十八周岁的自然人应经其监护人书面同意）；")]),_vm._v(" "),_c('p',[_vm._v("(2) 根据中华人民共和国法律或其注册地法律、法规合法成立并有效存续的法人或其它组织；")]),_vm._v(" "),_c('p',[_vm._v("(3) 无民事行为能力人、限制民事行为能力人以及无经营资格或无特定经营资格的法人或其它组织不应注册为本网站用户或超过其民事行为能力范围从事交易，若出现前述情形，且合同效力未得到有效补正，本协议自始无效；本公司及本网站一经发现，有权立即注销该用户，且有权要求其赔偿因此给本公司及本网站造成的一切损失。")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("八、不可抗力")]),_vm._v(" "),_c('p',[_vm._v("本公司及本网站对因超出合理控制之外的原因、事件或其他因素导致的未能履行本协议下的任何义务不承担责任。该等原因、事件或其他因素包括但不限于战争、台风、水灾、火灾、雷击或地震、罢工、暴动、黑客攻击、网络病毒、电信部门技术管制、政府行为或任何其它自然或人为造成的灾难等情况。")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("九、特别声明")]),_vm._v(" "),_c('p',[_vm._v("1. 提供直供服务的用户同意本公司及本网站可根据市场情况和服务费费率调整、自动更改相应的对外报价。如果需要，用户可以根据需求在此基础上再次自行进行修改；")]),_vm._v(" "),_c('p',[_vm._v("2. 本协议可由本网站随时更新，更新后的协议条款一旦公布即代替原来的协议条款，本网站不再另行通知，用户可在本网站自行查阅最新版协议条款。在本网站修改协议条款后，如果用户不接受修改后的条款，可立即停止使用本网站提供的服务，用户继续使用本网站提供的服务将被视为接受修改后的协议。")])]),_vm._v(" "),_c('div',{staticClass:"agreement-content-li"},[_c('p',[_vm._v("十、法律适用与争议解决")]),_vm._v(" "),_c('p',[_vm._v("1. 本协议之订立、生效、解释、履行、修订与争议解决均适用中华人民共和国法律；")]),_vm._v(" "),_c('p',[_vm._v("2. 因本协议所生之相关争议，均应提交武汉市洪山区人民法院诉讼解决。")])])])}]
var agreement_esExports = { render: agreement_render, staticRenderFns: agreement_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_agreement = (agreement_esExports);
// CONCATENATED MODULE: ./src/pages/agreement/index.vue
function agreement_injectStyle (ssrContext) {
  __webpack_require__("/6I1")
}
var agreement_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var agreement___vue_template_functional__ = false
/* styles */
var agreement___vue_styles__ = agreement_injectStyle
/* scopeId */
var agreement___vue_scopeId__ = "data-v-68f2c0ca"
/* moduleIdentifier (server only) */
var agreement___vue_module_identifier__ = null
var agreement_Component = agreement_normalizeComponent(
  pages_agreement,
  selectortype_template_index_0_src_pages_agreement,
  agreement___vue_template_functional__,
  agreement___vue_styles__,
  agreement___vue_scopeId__,
  agreement___vue_module_identifier__
)

/* harmony default export */ var src_pages_agreement = (agreement_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguest/index.vue















/* harmony default export */ var newguest = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */]
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      solutionList: [{
        toPath: '/solution/appPromotion',
        iconName: 'jiejuefangan_apptuiguang',
        solutionLabel: 'APP推广'
      }, {
        toPath: '/solution/smallProgram',
        iconName: 'jiejuefangan_xiaochengxutuiguang',
        solutionLabel: '小程序推广'
      }, {
        toPath: '/solution/game',
        iconName: 'jiejuefangan-youxihangyetuiguang',
        solutionLabel: '游戏行业推广'
      }, {
        toPath: '/solution/ecommerce',
        iconName: 'jiejuefangan_dianshanghangyetuiguang',
        solutionLabel: '电商行业推广'
      }, {
        toPath: '/solution/finance',
        iconName: 'jiejuefangan_jinronghangyetuiguang',
        solutionLabel: '金融行业推广'
      }, {
        toPath: '/solution/microBussiness',
        iconName: 'jiejuefangan_weishanghangyetuiguang',
        solutionLabel: '微商行业推广'
      }, {
        toPath: '/solution/tourism',
        iconName: 'jiejuefangan_lvyouhangyetuiguang',
        solutionLabel: '旅游行业推广'
      }, {
        toPath: '/solution/fmcg',
        iconName: 'jiejuefangan_kuaixiaopinhangyetuiguang',
        solutionLabel: '快消品行业推广'
      }, {
        toPath: '/solution/fashionBeauty',
        iconName: 'jiejuefangan_shishangmeirongtuiguang',
        solutionLabel: '时尚美容推广'
      }, {
        toPath: '/solution/newProduct',
        iconName: 'jiejuefangan_xinpintuiguang',
        solutionLabel: '新品推广'
      }, {
        toPath: '/solution/motherChild',
        iconName: 'jiejuefangan_muyinghangyetuiguang',
        solutionLabel: '母婴行业推广'
      }, {
        toPath: '/solution/car',
        iconName: 'jiejuefangan_qichehangyetuiguang',
        solutionLabel: '汽车行业推广'
      }],
      smsCount: 0,
      smsDisable: false
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        window._taq.push({ convert_id: '1613933449992238', event_type: 'form' });
        _this4.$router.push('/media');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguest/index.vue















/* harmony default export */ var pages_newguest = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */]
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      solutionList: [{
        toPath: '/solution/appPromotion',
        iconName: 'jiejuefangan_apptuiguang',
        solutionLabel: 'APP推广'
      }, {
        toPath: '/solution/smallProgram',
        iconName: 'jiejuefangan_xiaochengxutuiguang',
        solutionLabel: '小程序推广'
      }, {
        toPath: '/solution/game',
        iconName: 'jiejuefangan-youxihangyetuiguang',
        solutionLabel: '游戏行业推广'
      }, {
        toPath: '/solution/ecommerce',
        iconName: 'jiejuefangan_dianshanghangyetuiguang',
        solutionLabel: '电商行业推广'
      }, {
        toPath: '/solution/finance',
        iconName: 'jiejuefangan_jinronghangyetuiguang',
        solutionLabel: '金融行业推广'
      }, {
        toPath: '/solution/microBussiness',
        iconName: 'jiejuefangan_weishanghangyetuiguang',
        solutionLabel: '微商行业推广'
      }, {
        toPath: '/solution/tourism',
        iconName: 'jiejuefangan_lvyouhangyetuiguang',
        solutionLabel: '旅游行业推广'
      }, {
        toPath: '/solution/fmcg',
        iconName: 'jiejuefangan_kuaixiaopinhangyetuiguang',
        solutionLabel: '快消品行业推广'
      }, {
        toPath: '/solution/fashionBeauty',
        iconName: 'jiejuefangan_shishangmeirongtuiguang',
        solutionLabel: '时尚美容推广'
      }, {
        toPath: '/solution/newProduct',
        iconName: 'jiejuefangan_xinpintuiguang',
        solutionLabel: '新品推广'
      }, {
        toPath: '/solution/motherChild',
        iconName: 'jiejuefangan_muyinghangyetuiguang',
        solutionLabel: '母婴行业推广'
      }, {
        toPath: '/solution/car',
        iconName: 'jiejuefangan_qichehangyetuiguang',
        solutionLabel: '汽车行业推广'
      }],
      smsCount: 0,
      smsDisable: false
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        window._taq.push({ convert_id: '1613933449992238', event_type: 'form' });
        _this4.$router.push('/media');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f04e114c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newguest/index.vue
var newguest_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('index-header',{attrs:{"utm-click":"register_rw_t"}}),_vm._v(" "),_c('div',{staticClass:"wechat-flooing-banner"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kcb-free-customize"},[_c('h3',{staticClass:"wechat-flooing-title"},[_vm._v("免费获取定制推广方案")]),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize",staticStyle:{"background-color":"#f4f4f4"}},[_c('div',{staticClass:"login-group-li",staticStyle:{"background-color":"#fff"}},[_c('i',{staticClass:"iconfont icon-yonghu1"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel, "mobile", $$v)},expression:"loginModel.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left",staticStyle:{"background-color":"#fff"}},[_c('i',{staticClass:"iconfont icon-yanzhengma"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"验证码","label-width":"200"},model:{value:(_vm.loginModel.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha", $$v)},expression:"loginModel.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left",staticStyle:{"background-color":"#fff"}},[_c('i',{staticClass:"iconfont icon-yanzhengma1"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"短信验证码","label-width":"200"},model:{value:(_vm.loginModel.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel, "msgcode", $$v)},expression:"loginModel.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",staticStyle:{"background-color":"#fff"},attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha()}},slot:"right-full-height"},[_vm._v(_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login()}}},[_vm._v("免费获取定制推广方案")])],1)])],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"index-solution"},[_c('h3',{staticClass:"wechat-flooing-title"},[_vm._v("软盟解决方案")]),_vm._v(" "),_c('div',{staticClass:"index-solution-content",attrs:{"cols":3,"show-vertical-dividers":false,"show-lr-borders":false}},_vm._l((_vm.solutionList),function(item,index){return _c('div',{key:index,staticClass:"index-solution-content-li"},[_c('icon',{attrs:{"type":"svg","name":item.iconName}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.solutionLabel))])],1)}))]),_vm._v(" "),_c('div',{staticClass:"kcb-free-kol"},[_c('h3',{staticClass:"wechat-flooing-title"},[_vm._v("获取KOL大号报价单")]),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box",staticStyle:{"background-color":"#fff"}},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-yonghu1"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel2.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel2, "mobile", $$v)},expression:"loginModel2.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"验证码","label-width":"200"},model:{value:(_vm.loginModel2.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel2, "captcha", $$v)},expression:"loginModel2.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma1"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"短信验证码","label-width":"200"},model:{value:(_vm.loginModel2.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel2, "msgcode", $$v)},expression:"loginModel2.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha(2)}},slot:"right-full-height"},[_vm._v("\n          "+_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n        ")])]),_vm._v(" "),_c('div',[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login(2)}}},[_vm._v("我要注册，查看报价")])],1)]),_vm._v(" "),_c('p',{staticClass:"kcb-footer"},[_vm._v("版权所有:武汉智汇互动信息科技有限公司 ")])],1),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_rw_r"}})],1)}
var newguest_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kcb-unique"},[_c('h3',{staticClass:"wechat-flooing-title"},[_vm._v("软盟独有优势")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/wechat-flooring-unique.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kcb-promote-ways"},[_c('h3',{staticClass:"wechat-flooing-title"},[_vm._v("软盟推广形式")]),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-content"},[_c('div',{staticClass:"kcb-promote-ways-content-li"},[_c('img',{staticStyle:{"margin-right":"22px"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/wechat-flooring-ways01.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-text",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"kcb-promote-ways-text-title"},[_c('div',{staticClass:"kcb-number",staticStyle:{"background-color":"#94d59f"}},[_vm._v("1")]),_vm._v(" "),_c('p',[_vm._v("选号直投")])]),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-text-desc"},[_vm._v("以标题、图片、文案等编辑制作成广告物料，直接推送给粉丝，快速获得大量曝光，同时锁定潜在用户;")])])]),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-content-li"},[_c('div',{staticClass:"kcb-promote-ways-text"},[_c('div',{staticClass:"kcb-promote-ways-text-title",staticStyle:{"margin-right":"22px"}},[_c('div',{staticClass:"kcb-number",staticStyle:{"background-color":"#f4b94c"}},[_vm._v("2")]),_vm._v(" "),_c('p',[_vm._v("媒体主接单")])]),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-text-desc"},[_vm._v("根据广告主填写的投放需求，系统会按照媒体受众群体与广告主的需求匹配度，自动推送给符合广告主需求的媒体主，最后由媒体主接单执行;\n          ")])]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/wechat-flooring-ways02.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-content-li"},[_c('img',{staticStyle:{"margin-right":"22px"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/wechat-flooring-ways03.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-text"},[_c('div',{staticClass:"kcb-promote-ways-text-title"},[_c('div',{staticClass:"kcb-number",staticStyle:{"background-color":"#7bbdfa"}},[_vm._v("3")]),_vm._v(" "),_c('p',[_vm._v("公众号涨粉")])]),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-text-desc"},[_vm._v("提供粉丝获取的“定制化” 服务，构建“全阶段”涨粉通路，全方位的涨粉渠道整合，整合线上、线下多种涨粉方式，助力公号实现快速涨粉;\n          ")])])])])])}]
var newguest_esExports = { render: newguest_render, staticRenderFns: newguest_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_newguest = (newguest_esExports);
// CONCATENATED MODULE: ./src/pages/newguest/index.vue
function newguest_injectStyle (ssrContext) {
  __webpack_require__("KRKC")
  __webpack_require__("CJZ5")
}
var newguest_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var newguest___vue_template_functional__ = false
/* styles */
var newguest___vue_styles__ = newguest_injectStyle
/* scopeId */
var newguest___vue_scopeId__ = "data-v-f04e114c"
/* moduleIdentifier (server only) */
var newguest___vue_module_identifier__ = null
var newguest_Component = newguest_normalizeComponent(
  pages_newguest,
  selectortype_template_index_0_src_pages_newguest,
  newguest___vue_template_functional__,
  newguest___vue_styles__,
  newguest___vue_scopeId__,
  newguest___vue_module_identifier__
)

/* harmony default export */ var src_pages_newguest = (newguest_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguestwx/index.vue















/* harmony default export */ var newguestwx = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */]
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      solutionList: [{
        toPath: '/solution/appPromotion',
        iconName: 'jiejuefangan_apptuiguang',
        solutionLabel: 'APP推广'
      }, {
        toPath: '/solution/smallProgram',
        iconName: 'jiejuefangan_xiaochengxutuiguang',
        solutionLabel: '小程序推广'
      }, {
        toPath: '/solution/game',
        iconName: 'jiejuefangan-youxihangyetuiguang',
        solutionLabel: '游戏行业推广'
      }, {
        toPath: '/solution/ecommerce',
        iconName: 'jiejuefangan_dianshanghangyetuiguang',
        solutionLabel: '电商行业推广'
      }, {
        toPath: '/solution/finance',
        iconName: 'jiejuefangan_jinronghangyetuiguang',
        solutionLabel: '金融行业推广'
      }, {
        toPath: '/solution/microBussiness',
        iconName: 'jiejuefangan_weishanghangyetuiguang',
        solutionLabel: '微商行业推广'
      }, {
        toPath: '/solution/tourism',
        iconName: 'jiejuefangan_lvyouhangyetuiguang',
        solutionLabel: '旅游行业推广'
      }, {
        toPath: '/solution/fmcg',
        iconName: 'jiejuefangan_kuaixiaopinhangyetuiguang',
        solutionLabel: '快消品行业推广'
      }, {
        toPath: '/solution/fashionBeauty',
        iconName: 'jiejuefangan_shishangmeirongtuiguang',
        solutionLabel: '时尚美容推广'
      }, {
        toPath: '/solution/newProduct',
        iconName: 'jiejuefangan_xinpintuiguang',
        solutionLabel: '新品推广'
      }, {
        toPath: '/solution/motherChild',
        iconName: 'jiejuefangan_muyinghangyetuiguang',
        solutionLabel: '母婴行业推广'
      }, {
        toPath: '/solution/car',
        iconName: 'jiejuefangan_qichehangyetuiguang',
        solutionLabel: '汽车行业推广'
      }],
      smsCount: 0,
      smsDisable: false
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        window._taq.push({ convert_id: '1613933449992238', event_type: 'form' });
        _this4.$router.push('/media?tab=woa');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguestwx/index.vue















/* harmony default export */ var pages_newguestwx = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */]
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      solutionList: [{
        toPath: '/solution/appPromotion',
        iconName: 'jiejuefangan_apptuiguang',
        solutionLabel: 'APP推广'
      }, {
        toPath: '/solution/smallProgram',
        iconName: 'jiejuefangan_xiaochengxutuiguang',
        solutionLabel: '小程序推广'
      }, {
        toPath: '/solution/game',
        iconName: 'jiejuefangan-youxihangyetuiguang',
        solutionLabel: '游戏行业推广'
      }, {
        toPath: '/solution/ecommerce',
        iconName: 'jiejuefangan_dianshanghangyetuiguang',
        solutionLabel: '电商行业推广'
      }, {
        toPath: '/solution/finance',
        iconName: 'jiejuefangan_jinronghangyetuiguang',
        solutionLabel: '金融行业推广'
      }, {
        toPath: '/solution/microBussiness',
        iconName: 'jiejuefangan_weishanghangyetuiguang',
        solutionLabel: '微商行业推广'
      }, {
        toPath: '/solution/tourism',
        iconName: 'jiejuefangan_lvyouhangyetuiguang',
        solutionLabel: '旅游行业推广'
      }, {
        toPath: '/solution/fmcg',
        iconName: 'jiejuefangan_kuaixiaopinhangyetuiguang',
        solutionLabel: '快消品行业推广'
      }, {
        toPath: '/solution/fashionBeauty',
        iconName: 'jiejuefangan_shishangmeirongtuiguang',
        solutionLabel: '时尚美容推广'
      }, {
        toPath: '/solution/newProduct',
        iconName: 'jiejuefangan_xinpintuiguang',
        solutionLabel: '新品推广'
      }, {
        toPath: '/solution/motherChild',
        iconName: 'jiejuefangan_muyinghangyetuiguang',
        solutionLabel: '母婴行业推广'
      }, {
        toPath: '/solution/car',
        iconName: 'jiejuefangan_qichehangyetuiguang',
        solutionLabel: '汽车行业推广'
      }],
      smsCount: 0,
      smsDisable: false
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        window._taq.push({ convert_id: '1613933449992238', event_type: 'form' });
        _this4.$router.push('/media?tab=woa');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-292f6404","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newguestwx/index.vue
var newguestwx_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('index-header',{attrs:{"title":"微信精准营销平台"}}),_vm._v(" "),_c('div',{staticClass:"wechat-flooing-banner"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kcb-free-customize"},[_c('h3',{staticClass:"wechat-flooing-title"},[_vm._v("免费获取定制推广方案")]),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize",staticStyle:{"background-color":"#f4f4f4"}},[_c('div',{staticClass:"login-group-li",staticStyle:{"background-color":"#fff"}},[_c('i',{staticClass:"iconfont icon-yonghu1"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel, "mobile", $$v)},expression:"loginModel.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left",staticStyle:{"background-color":"#fff"}},[_c('i',{staticClass:"iconfont icon-yanzhengma"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"验证码","label-width":"200"},model:{value:(_vm.loginModel.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha", $$v)},expression:"loginModel.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left",staticStyle:{"background-color":"#fff"}},[_c('i',{staticClass:"iconfont icon-yanzhengma1"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"短信验证码","label-width":"200"},model:{value:(_vm.loginModel.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel, "msgcode", $$v)},expression:"loginModel.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",staticStyle:{"background-color":"#fff"},attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha()}},slot:"right-full-height"},[_vm._v(_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login()}}},[_vm._v("免费获取定制推广方案")])],1)])],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"index-solution"},[_c('h3',{staticClass:"wechat-flooing-title"},[_vm._v("软盟解决方案")]),_vm._v(" "),_c('div',{staticClass:"index-solution-content",attrs:{"cols":3,"show-vertical-dividers":false,"show-lr-borders":false}},_vm._l((_vm.solutionList),function(item,index){return _c('div',{key:index,staticClass:"index-solution-content-li"},[_c('icon',{attrs:{"type":"svg","name":item.iconName}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.solutionLabel))])],1)}))]),_vm._v(" "),_c('div',{staticClass:"kcb-free-kol"},[_c('h3',{staticClass:"wechat-flooing-title"},[_vm._v("获取微信大号报价单")]),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box",staticStyle:{"background-color":"#fff"}},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-yonghu1"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel2.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel2, "mobile", $$v)},expression:"loginModel2.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"验证码","label-width":"200"},model:{value:(_vm.loginModel2.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel2, "captcha", $$v)},expression:"loginModel2.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma1"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"短信验证码","label-width":"200"},model:{value:(_vm.loginModel2.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel2, "msgcode", $$v)},expression:"loginModel2.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha(2)}},slot:"right-full-height"},[_vm._v("\n          "+_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n        ")])]),_vm._v(" "),_c('div',[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login(2)}}},[_vm._v("我要注册，查看报价")])],1)]),_vm._v(" "),_c('p',{staticClass:"kcb-footer"},[_vm._v("版权所有:武汉智汇互动信息科技有限公司 ")])],1),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_rw_r"}})],1)}
var newguestwx_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kcb-unique"},[_c('h3',{staticClass:"wechat-flooing-title"},[_vm._v("软盟独有优势")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/wechat-flooring-unique.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kcb-promote-ways"},[_c('h3',{staticClass:"wechat-flooing-title"},[_vm._v("软盟推广形式")]),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-content"},[_c('div',{staticClass:"kcb-promote-ways-content-li"},[_c('img',{staticStyle:{"margin-right":"22px"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/wechat-flooring-ways01.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-text",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"kcb-promote-ways-text-title"},[_c('div',{staticClass:"kcb-number",staticStyle:{"background-color":"#94d59f"}},[_vm._v("1")]),_vm._v(" "),_c('p',[_vm._v("选号直投")])]),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-text-desc"},[_vm._v("以标题、图片、文案等编辑制作成广告物料，直接推送给粉丝，快速获得大量曝光，同时锁定潜在用户;")])])]),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-content-li"},[_c('div',{staticClass:"kcb-promote-ways-text"},[_c('div',{staticClass:"kcb-promote-ways-text-title",staticStyle:{"margin-right":"22px"}},[_c('div',{staticClass:"kcb-number",staticStyle:{"background-color":"#f4b94c"}},[_vm._v("2")]),_vm._v(" "),_c('p',[_vm._v("媒体主接单")])]),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-text-desc"},[_vm._v("根据广告主填写的投放需求，系统会按照媒体受众群体与广告主的需求匹配度，自动推送给符合广告主需求的媒体主，最后由媒体主接单执行;\n          ")])]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/wechat-flooring-ways02.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-content-li"},[_c('img',{staticStyle:{"margin-right":"22px"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/wechat-flooring-ways03.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-text"},[_c('div',{staticClass:"kcb-promote-ways-text-title"},[_c('div',{staticClass:"kcb-number",staticStyle:{"background-color":"#7bbdfa"}},[_vm._v("3")]),_vm._v(" "),_c('p',[_vm._v("公众号涨粉")])]),_vm._v(" "),_c('div',{staticClass:"kcb-promote-ways-text-desc"},[_vm._v("提供粉丝获取的“定制化” 服务，构建“全阶段”涨粉通路，全方位的涨粉渠道整合，整合线上、线下多种涨粉方式，助力公号实现快速涨粉;\n          ")])])])])])}]
var newguestwx_esExports = { render: newguestwx_render, staticRenderFns: newguestwx_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_newguestwx = (newguestwx_esExports);
// CONCATENATED MODULE: ./src/pages/newguestwx/index.vue
function newguestwx_injectStyle (ssrContext) {
  __webpack_require__("ejnP")
  __webpack_require__("5Flw")
}
var newguestwx_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var newguestwx___vue_template_functional__ = false
/* styles */
var newguestwx___vue_styles__ = newguestwx_injectStyle
/* scopeId */
var newguestwx___vue_scopeId__ = "data-v-292f6404"
/* moduleIdentifier (server only) */
var newguestwx___vue_module_identifier__ = null
var newguestwx_Component = newguestwx_normalizeComponent(
  pages_newguestwx,
  selectortype_template_index_0_src_pages_newguestwx,
  newguestwx___vue_template_functional__,
  newguestwx___vue_styles__,
  newguestwx___vue_scopeId__,
  newguestwx___vue_module_identifier__
)

/* harmony default export */ var src_pages_newguestwx = (newguestwx_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LandingPageHeader = ({
  name: 'LandingPageHeader',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_t'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loginStatus: {}
    };
  },

  methods: {
    // getUserInfo () {
    //   fetchUser().then(resp => {
    //     this.userInfo = resp.data
    //   })
    // }
  },
  mounted: function mounted() {
    this.loginStatus = !!getCookie('token');
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_LandingPageHeader = ({
  name: 'LandingPageHeader',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_t'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loginStatus: {}
    };
  },

  methods: {
    // getUserInfo () {
    //   fetchUser().then(resp => {
    //     this.userInfo = resp.data
    //   })
    // }
  },
  mounted: function mounted() {
    this.loginStatus = !!getCookie('token');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39dbf8bb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPageHeader.vue
var LandingPageHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-header-container"},[_c('div',{staticClass:"index-header"},[_c('div',{staticClass:"index-header-inner"},[_c('a',{staticClass:"index-header-inner-left",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/logo@2x.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"index-header-line"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.title||'新媒体精准营销平台'))])]),_vm._v(" "),(!_vm.loginStatus)?_c('a',{staticClass:"index-header-inner-login",attrs:{"href":'/register?utm_click='+_vm.utmClick}},[_vm._v("立即注册")]):_vm._e()])])])}
var LandingPageHeader_staticRenderFns = []
var LandingPageHeader_esExports = { render: LandingPageHeader_render, staticRenderFns: LandingPageHeader_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_LandingPageHeader = (LandingPageHeader_esExports);
// CONCATENATED MODULE: ./src/components/LandingPageHeader.vue
function LandingPageHeader_injectStyle (ssrContext) {
  __webpack_require__("Dzs9")
}
var LandingPageHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LandingPageHeader___vue_template_functional__ = false
/* styles */
var LandingPageHeader___vue_styles__ = LandingPageHeader_injectStyle
/* scopeId */
var LandingPageHeader___vue_scopeId__ = "data-v-39dbf8bb"
/* moduleIdentifier (server only) */
var LandingPageHeader___vue_module_identifier__ = null
var LandingPageHeader_Component = LandingPageHeader_normalizeComponent(
  components_LandingPageHeader,
  selectortype_template_index_0_src_components_LandingPageHeader,
  LandingPageHeader___vue_template_functional__,
  LandingPageHeader___vue_styles__,
  LandingPageHeader___vue_scopeId__,
  LandingPageHeader___vue_module_identifier__
)

/* harmony default export */ var src_components_LandingPageHeader = (LandingPageHeader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageFooter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LandingPageFooter = ({
  name: 'landingPageFooter',
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageFooter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_LandingPageFooter = ({
  name: 'landingPageFooter',
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-504d61a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPageFooter.vue
var LandingPageFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-footer"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"index-footer-contact-ways"},[_c('h3',[_vm._v("400-858-1399")]),_vm._v(" "),_c('p',[_vm._v("免费咨询热线")]),_vm._v(" "),_c('div',{staticClass:"consult-qq"},[_c('div',{staticClass:"consult-icon-box icon-chat"},[_c('icon',{attrs:{"type":"svg","name":"qq"}})],1),_vm._v(" "),_c('span',[_vm._v("4008581399")])])])])}
var LandingPageFooter_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-footer-left"},[_c('img',{staticClass:"index-footer-ercode",attrs:{"alt":"","src":"https://static.xinmeibao.com/assets/v3/images/footer_kcbewm.png"}}),_vm._v(" "),_c('img',{staticClass:"index-footer-ercode",attrs:{"alt":"","src":"https://static.xinmeibao.com/assets/v3/images/footer_kcbxcx.png"}})])}]
var LandingPageFooter_esExports = { render: LandingPageFooter_render, staticRenderFns: LandingPageFooter_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_LandingPageFooter = (LandingPageFooter_esExports);
// CONCATENATED MODULE: ./src/components/LandingPageFooter.vue
function LandingPageFooter_injectStyle (ssrContext) {
  __webpack_require__("2B8d")
}
var LandingPageFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LandingPageFooter___vue_template_functional__ = false
/* styles */
var LandingPageFooter___vue_styles__ = LandingPageFooter_injectStyle
/* scopeId */
var LandingPageFooter___vue_scopeId__ = "data-v-504d61a4"
/* moduleIdentifier (server only) */
var LandingPageFooter___vue_module_identifier__ = null
var LandingPageFooter_Component = LandingPageFooter_normalizeComponent(
  components_LandingPageFooter,
  selectortype_template_index_0_src_components_LandingPageFooter,
  LandingPageFooter___vue_template_functional__,
  LandingPageFooter___vue_styles__,
  LandingPageFooter___vue_scopeId__,
  LandingPageFooter___vue_module_identifier__
)

/* harmony default export */ var src_components_LandingPageFooter = (LandingPageFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguestwx2/index.vue
















/* harmony default export */ var newguestwx2 = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LandingPageHeader: src_components_LandingPageHeader,
    LandingPageFooter: src_components_LandingPageFooter,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */]
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      solutionList: [{
        toPath: '/solution/appPromotion',
        iconName: 'jiejuefangan_apptuiguang',
        solutionLabel: 'APP推广'
      }, {
        toPath: '/solution/smallProgram',
        iconName: 'jiejuefangan_xiaochengxutuiguang',
        solutionLabel: '小程序推广'
      }, {
        toPath: '/solution/game',
        iconName: 'jiejuefangan-youxihangyetuiguang',
        solutionLabel: '游戏行业推广'
      }, {
        toPath: '/solution/ecommerce',
        iconName: 'jiejuefangan_dianshanghangyetuiguang',
        solutionLabel: '电商行业推广'
      }, {
        toPath: '/solution/finance',
        iconName: 'jiejuefangan_jinronghangyetuiguang',
        solutionLabel: '金融行业推广'
      }, {
        toPath: '/solution/microBussiness',
        iconName: 'jiejuefangan_weishanghangyetuiguang',
        solutionLabel: '微商行业推广'
      }, {
        toPath: '/solution/tourism',
        iconName: 'jiejuefangan_lvyouhangyetuiguang',
        solutionLabel: '旅游行业推广'
      }, {
        toPath: '/solution/fmcg',
        iconName: 'jiejuefangan_kuaixiaopinhangyetuiguang',
        solutionLabel: '快消品行业推广'
      }, {
        toPath: '/solution/fashionBeauty',
        iconName: 'jiejuefangan_shishangmeirongtuiguang',
        solutionLabel: '时尚美容推广'
      }, {
        toPath: '/solution/newProduct',
        iconName: 'jiejuefangan_xinpintuiguang',
        solutionLabel: '新品推广'
      }, {
        toPath: '/solution/motherChild',
        iconName: 'jiejuefangan_muyinghangyetuiguang',
        solutionLabel: '母婴行业推广'
      }, {
        toPath: '/solution/car',
        iconName: 'jiejuefangan_qichehangyetuiguang',
        solutionLabel: '汽车行业推广'
      }],
      smsCount: 0,
      smsDisable: false,
      scrollTop: 0
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        window._taq.push({ convert_id: '1613933449992238', event_type: 'form' });
        _this4.$router.push('/media?tab=woa');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    },
    goAnchor: function goAnchor(selector) {
      console.log(this.$parent.$parent.$refs.viewBox.scrollTo);
      var anchor = this.$el.querySelector(selector);

      this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100);
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguestwx2/index.vue
















/* harmony default export */ var pages_newguestwx2 = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LandingPageHeader: src_components_LandingPageHeader,
    LandingPageFooter: src_components_LandingPageFooter,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */]
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      solutionList: [{
        toPath: '/solution/appPromotion',
        iconName: 'jiejuefangan_apptuiguang',
        solutionLabel: 'APP推广'
      }, {
        toPath: '/solution/smallProgram',
        iconName: 'jiejuefangan_xiaochengxutuiguang',
        solutionLabel: '小程序推广'
      }, {
        toPath: '/solution/game',
        iconName: 'jiejuefangan-youxihangyetuiguang',
        solutionLabel: '游戏行业推广'
      }, {
        toPath: '/solution/ecommerce',
        iconName: 'jiejuefangan_dianshanghangyetuiguang',
        solutionLabel: '电商行业推广'
      }, {
        toPath: '/solution/finance',
        iconName: 'jiejuefangan_jinronghangyetuiguang',
        solutionLabel: '金融行业推广'
      }, {
        toPath: '/solution/microBussiness',
        iconName: 'jiejuefangan_weishanghangyetuiguang',
        solutionLabel: '微商行业推广'
      }, {
        toPath: '/solution/tourism',
        iconName: 'jiejuefangan_lvyouhangyetuiguang',
        solutionLabel: '旅游行业推广'
      }, {
        toPath: '/solution/fmcg',
        iconName: 'jiejuefangan_kuaixiaopinhangyetuiguang',
        solutionLabel: '快消品行业推广'
      }, {
        toPath: '/solution/fashionBeauty',
        iconName: 'jiejuefangan_shishangmeirongtuiguang',
        solutionLabel: '时尚美容推广'
      }, {
        toPath: '/solution/newProduct',
        iconName: 'jiejuefangan_xinpintuiguang',
        solutionLabel: '新品推广'
      }, {
        toPath: '/solution/motherChild',
        iconName: 'jiejuefangan_muyinghangyetuiguang',
        solutionLabel: '母婴行业推广'
      }, {
        toPath: '/solution/car',
        iconName: 'jiejuefangan_qichehangyetuiguang',
        solutionLabel: '汽车行业推广'
      }],
      smsCount: 0,
      smsDisable: false,
      scrollTop: 0
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        window._taq.push({ convert_id: '1613933449992238', event_type: 'form' });
        _this4.$router.push('/media?tab=woa');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    },
    goAnchor: function goAnchor(selector) {
      console.log(this.$parent.$parent.$refs.viewBox.scrollTo);
      var anchor = this.$el.querySelector(selector);

      this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100);
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ba9adac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newguestwx2/index.vue
var newguestwx2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('landing-page-header',{attrs:{"title":"微信精准营销无差价资源平台"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kcb-unique"},[_vm._m(1),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-yonghu1",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel, "mobile", $$v)},expression:"loginModel.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"图形验证码","label-width":"200"},model:{value:(_vm.loginModel.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha", $$v)},expression:"loginModel.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码","label-width":"200"},model:{value:(_vm.loginModel.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel, "msgcode", $$v)},expression:"loginModel.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha()}},slot:"right-full-height"},[_vm._v("\n          "+_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login()}}},[_vm._v("一键获取精准的媒体资源报价")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"jxyzzz"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"jxyzzz-tabs"},[_c('div',{staticClass:"tabs"},[_c('a',{staticStyle:{"color":"#40BDA0"},attrs:{"href":"javascript:"}},[_vm._v("财经商业")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("时尚")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("美食")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("IT科技")])]),_vm._v(" "),_c('div',{staticClass:"active"})]),_vm._v(" "),_c('div',{staticClass:"jxyzzz-items"},[_c('div',{staticClass:"jxyzzz-item"},[_vm._m(3),_vm._v(" "),_c('div',[_c('h4',[_vm._v("新闻早餐")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('a',{staticClass:"btn",attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("查看报价")])])]),_vm._v(" "),_c('div',{staticClass:"jxyzzz-item"},[_vm._m(5),_vm._v(" "),_c('div',[_c('h4',[_vm._v("卡娃微卡")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('a',{staticClass:"btn",attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("查看报价")])])]),_vm._v(" "),_c('div',{staticClass:"jxyzzz-item"},[_vm._m(7),_vm._v(" "),_c('div',[_c('h4',[_vm._v("有品生活")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('a',{staticClass:"btn",attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("查看报价")])])]),_vm._v(" "),_c('div',{staticClass:"jxyzzz-item"},[_vm._m(9),_vm._v(" "),_c('div',[_c('h4',[_vm._v("卡妞范儿")]),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('a',{staticClass:"btn",attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("查看报价")])])]),_vm._v(" "),_c('div',{staticClass:"jxyzzz-item"},[_vm._m(11),_vm._v(" "),_c('div',[_c('h4',[_vm._v("天天炫拍")]),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('a',{staticClass:"btn",attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("查看报价")])])]),_vm._v(" "),_c('div',{staticClass:"jxyzzz-item"},[_vm._m(13),_vm._v(" "),_c('div',[_c('h4',[_vm._v("了不起我的国")]),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('a',{staticClass:"btn",attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("查看报价")])])])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"btn-register",attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("立即注册，查看微信资源表")])])]),_vm._v(" "),_c('div',{staticClass:"hylx"},[_vm._m(15),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","color":"#999"}},[_vm._v("大号价格透明可查，按效果付费成本可控")]),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"btn-register",attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("我要注册，查看报价")])])]),_vm._v(" "),_c('div',{staticClass:"jxal"},[_vm._m(17),_vm._v(" "),_c('div',{staticClass:"jxyzzz-tabs"},[_c('div',{staticClass:"tabs"},[_c('a',{staticStyle:{"color":"#40BDA0"},attrs:{"href":"javascript:"}},[_vm._v("金融案例")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("汽车案例")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("时尚案例")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("其他案例")])]),_vm._v(" "),_c('div',{staticClass:"active"})]),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"btn-register",attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("马上注册，获取行业定制方案")])])]),_vm._v(" "),_vm._m(19),_vm._v(" "),_c('div',{staticClass:"kcb-unique",attrs:{"id":"register"}},[_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-yonghu1",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel2.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel2, "mobile", $$v)},expression:"loginModel2.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"图形验证码","label-width":"200"},model:{value:(_vm.loginModel2.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel2, "captcha", $$v)},expression:"loginModel2.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码","label-width":"200"},model:{value:(_vm.loginModel2.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel2, "msgcode", $$v)},expression:"loginModel2.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha(2)}},slot:"right-full-height"},[_vm._v("\n          "+_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"register-text"},[_c('p',{staticClass:"register-text-1"},[_vm._v("软盟—"),_c('span',[_vm._v("26万+一线品牌客户共同选择")])]),_vm._v(" "),_c('p',{staticClass:"register-tex2"},[_c('span',[_vm._v("1000万+")]),_vm._v("流量覆盖，多家主流媒体战略合作")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login(2)}}},[_vm._v("一键获取精准的媒体资源报价")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"jxal"},[_vm._m(22),_vm._v(" "),_c('div',{staticClass:"pphz-tabs"},[_c('div',{staticClass:"tabs"},[_c('a',{staticStyle:{"color":"#40BDA0"},attrs:{"href":"javascript:"}},[_vm._v("金融")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("互联网")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("科技")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("汽车")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("教育")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("时尚")])]),_vm._v(" "),_c('div',{staticClass:"active"})]),_vm._v(" "),_vm._m(23)]),_vm._v(" "),_c('landing-page-footer')],1)}
var newguestwx2_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-flooing-banner"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/wxldy_01_banner_fg.png","alt":""}}),_vm._v(" "),_c('a',{staticClass:"banner-btn",attrs:{"href":"https://chat.xinmeibao.com/","target":"_blank"}},[_vm._v("立即咨询")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"line-l"}),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"color":"#40BDA0","font-weight":"bold"}},[_vm._v("2万+")]),_vm._v("微信大号资源报价单等你拿")]),_vm._v(" "),_c('div',{staticClass:"line-r"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"line-l"}),_vm._v(" "),_c('div',[_vm._v("精选优质资源")]),_vm._v(" "),_c('div',{staticClass:"line-r"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/tx01.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("粉丝数 "),_c('span',[_vm._v("245W+")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/tx02.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("粉丝数 "),_c('span',[_vm._v("1600W+")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/tx03.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("粉丝数 "),_c('span',[_vm._v("200W+")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/tx04.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("粉丝数 "),_c('span',[_vm._v("500W+")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/tx05.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("粉丝数 "),_c('span',[_vm._v("660W+")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/tx06.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("粉丝数 "),_c('span',[_vm._v("90W+")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"line-l"}),_vm._v(" "),_c('div',[_vm._v("软盟—肃清行业乱象")]),_vm._v(" "),_c('div',{staticClass:"line-r"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hylx-items"},[_c('div',{staticClass:"hylx-item"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/tfjz.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"hylx-item"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/jgtmwcj.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"hylx-item"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/hlzy.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"hylx-item"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/lsdz.png","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"line-l"}),_vm._v(" "),_c('div',[_vm._v("精选案例")]),_vm._v(" "),_c('div',{staticClass:"line-r"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jxal-content"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/khal_jdjr.png","alt":""}}),_vm._v(" "),_c('h4',[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"cbxg-items"},[_c('div',{staticClass:"cbxg-item"},[_c('h5',[_vm._v("粉丝数")]),_vm._v(" "),_c('p',[_vm._v("23.75W+")])]),_vm._v(" "),_c('div',{staticClass:"cbxg-item"},[_c('h5',[_vm._v("阅读量")]),_vm._v(" "),_c('p',[_vm._v("8.26W+")])]),_vm._v(" "),_c('div',{staticClass:"cbxg-item"},[_c('h5',[_vm._v("点赞数")]),_vm._v(" "),_c('p',[_vm._v("738")])])]),_vm._v(" "),_c('h4',[_vm._v("案例亮点")]),_vm._v(" "),_c('p',[_vm._v("确定推广方向、定位推广内容市场价值，抓住时事热点，利用热门事件和流行词为话题，直接给用户带来巨大的价值同时还帮助用户的品牌做到相应的推广，从而做到了一举两得。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hylx"},[_c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"line-l"}),_vm._v(" "),_c('div',[_vm._v("选号直投/媒体主接单/公众号涨粉")]),_vm._v(" "),_c('div',{staticClass:"line-r"})]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","color":"#999"}},[_vm._v("推广形式多样，效果保障")]),_vm._v(" "),_c('div',{staticClass:"hylx-items",staticStyle:{"text-align":"center","padding-bottom":"20px"}},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhzt.png","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"line-l"}),_vm._v(" "),_c('div',[_vm._v("获取更精准的微信大号资源报价")]),_vm._v(" "),_c('div',{staticClass:"line-r"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"color":"#999","text-align":"center"}},[_c('span',{staticStyle:{"color":"#40BDA0"}},[_vm._v("200+")]),_vm._v("行业定制方案等你拿")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"line-l"}),_vm._v(" "),_c('div',[_vm._v("品牌合作伙伴")]),_vm._v(" "),_c('div',{staticClass:"line-r"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pphz-content"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/logo_partners.png","alt":""}})])}]
var newguestwx2_esExports = { render: newguestwx2_render, staticRenderFns: newguestwx2_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_newguestwx2 = (newguestwx2_esExports);
// CONCATENATED MODULE: ./src/pages/newguestwx2/index.vue
function newguestwx2_injectStyle (ssrContext) {
  __webpack_require__("SQp4")
  __webpack_require__("1tAE")
}
var newguestwx2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var newguestwx2___vue_template_functional__ = false
/* styles */
var newguestwx2___vue_styles__ = newguestwx2_injectStyle
/* scopeId */
var newguestwx2___vue_scopeId__ = "data-v-4ba9adac"
/* moduleIdentifier (server only) */
var newguestwx2___vue_module_identifier__ = null
var newguestwx2_Component = newguestwx2_normalizeComponent(
  pages_newguestwx2,
  selectortype_template_index_0_src_pages_newguestwx2,
  newguestwx2___vue_template_functional__,
  newguestwx2___vue_styles__,
  newguestwx2___vue_scopeId__,
  newguestwx2___vue_module_identifier__
)

/* harmony default export */ var src_pages_newguestwx2 = (newguestwx2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageHeaderXhs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LandingPageHeaderXhs = ({
  name: 'LandingPageHeader',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_t'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loginStatus: {}
    };
  },

  methods: {
    // getUserInfo () {
    //   fetchUser().then(resp => {
    //     this.userInfo = resp.data
    //   })
    // }
  },
  mounted: function mounted() {
    this.loginStatus = !!getCookie('token');
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageHeaderXhs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_LandingPageHeaderXhs = ({
  name: 'LandingPageHeader',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_t'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loginStatus: {}
    };
  },

  methods: {
    // getUserInfo () {
    //   fetchUser().then(resp => {
    //     this.userInfo = resp.data
    //   })
    // }
  },
  mounted: function mounted() {
    this.loginStatus = !!getCookie('token');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf449fb0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPageHeaderXhs.vue
var LandingPageHeaderXhs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-header-container"},[_c('div',{staticClass:"index-header"},[_c('div',{staticClass:"index-header-inner"},[_c('a',{staticClass:"index-header-inner-left",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/logo@2x.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"index-header-line"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.title||'新媒体精准营销平台'))])]),_vm._v(" "),(!_vm.loginStatus)?_c('a',{staticClass:"index-header-inner-login",attrs:{"href":'/register?utm_click='+_vm.utmClick}},[_vm._v("立即注册")]):_vm._e()])])])}
var LandingPageHeaderXhs_staticRenderFns = []
var LandingPageHeaderXhs_esExports = { render: LandingPageHeaderXhs_render, staticRenderFns: LandingPageHeaderXhs_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_LandingPageHeaderXhs = (LandingPageHeaderXhs_esExports);
// CONCATENATED MODULE: ./src/components/LandingPageHeaderXhs.vue
function LandingPageHeaderXhs_injectStyle (ssrContext) {
  __webpack_require__("LmmJ")
}
var LandingPageHeaderXhs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LandingPageHeaderXhs___vue_template_functional__ = false
/* styles */
var LandingPageHeaderXhs___vue_styles__ = LandingPageHeaderXhs_injectStyle
/* scopeId */
var LandingPageHeaderXhs___vue_scopeId__ = "data-v-cf449fb0"
/* moduleIdentifier (server only) */
var LandingPageHeaderXhs___vue_module_identifier__ = null
var LandingPageHeaderXhs_Component = LandingPageHeaderXhs_normalizeComponent(
  components_LandingPageHeaderXhs,
  selectortype_template_index_0_src_components_LandingPageHeaderXhs,
  LandingPageHeaderXhs___vue_template_functional__,
  LandingPageHeaderXhs___vue_styles__,
  LandingPageHeaderXhs___vue_scopeId__,
  LandingPageHeaderXhs___vue_module_identifier__
)

/* harmony default export */ var src_components_LandingPageHeaderXhs = (LandingPageHeaderXhs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageFooterXhs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LandingPageFooterXhs = ({
  name: 'landingPageFooterXhs',
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageFooterXhs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_LandingPageFooterXhs = ({
  name: 'landingPageFooterXhs',
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4980e65c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPageFooterXhs.vue
var LandingPageFooterXhs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-footer"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"index-footer-contact-ways"},[_c('h3',[_vm._v("400-858-1399")]),_vm._v(" "),_c('p',[_vm._v("免费咨询热线")]),_vm._v(" "),_c('div',{staticClass:"consult-qq"},[_c('div',{staticClass:"consult-icon-box icon-chat"},[_c('icon',{attrs:{"type":"svg","name":"qq"}})],1),_vm._v(" "),_c('span',[_vm._v("4008581399")])])])])}
var LandingPageFooterXhs_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-footer-left"},[_c('img',{staticClass:"index-footer-ercode",attrs:{"alt":"","src":"https://static.xinmeibao.com/assets/v3/images/footer_kcbewm.png"}}),_vm._v(" "),_c('img',{staticClass:"index-footer-ercode",attrs:{"alt":"","src":"https://static.xinmeibao.com/assets/v3/images/footer_kcbxcx.png"}})])}]
var LandingPageFooterXhs_esExports = { render: LandingPageFooterXhs_render, staticRenderFns: LandingPageFooterXhs_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_LandingPageFooterXhs = (LandingPageFooterXhs_esExports);
// CONCATENATED MODULE: ./src/components/LandingPageFooterXhs.vue
function LandingPageFooterXhs_injectStyle (ssrContext) {
  __webpack_require__("suTl")
}
var LandingPageFooterXhs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LandingPageFooterXhs___vue_template_functional__ = false
/* styles */
var LandingPageFooterXhs___vue_styles__ = LandingPageFooterXhs_injectStyle
/* scopeId */
var LandingPageFooterXhs___vue_scopeId__ = "data-v-4980e65c"
/* moduleIdentifier (server only) */
var LandingPageFooterXhs___vue_module_identifier__ = null
var LandingPageFooterXhs_Component = LandingPageFooterXhs_normalizeComponent(
  components_LandingPageFooterXhs,
  selectortype_template_index_0_src_components_LandingPageFooterXhs,
  LandingPageFooterXhs___vue_template_functional__,
  LandingPageFooterXhs___vue_styles__,
  LandingPageFooterXhs___vue_scopeId__,
  LandingPageFooterXhs___vue_module_identifier__
)

/* harmony default export */ var src_components_LandingPageFooterXhs = (LandingPageFooterXhs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguestxhs1/index.vue




















/* harmony default export */ var newguestxhs1 = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LandingPageHeader: src_components_LandingPageHeader,
    LandingPageHeaderXhs: src_components_LandingPageHeaderXhs,
    LandingPageFooter: src_components_LandingPageFooter,
    LandingPageFooterXhs: src_components_LandingPageFooterXhs,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false,
      scrollTop: 0,
      tabIndex: 0,
      xhsImgList: ['https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_age.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_area.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_sex.png'],
      xhsImgList1: [{
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_200.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_100.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_50.png'
      }],
      xhsImgList1_index: 0,
      xhs1_swiper_index: 0,
      currentIndex: 0
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        _this4.$router.push('/media?tab=xhs');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    },
    goAnchor: function goAnchor(selector) {
      console.log(this.$parent.$parent.$refs.viewBox.scrollTo);
      var anchor = this.$el.querySelector(selector);

      this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100);
    },
    changeTab: function changeTab(index) {
      this.tabIndex = index;
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguestxhs1/index.vue




















/* harmony default export */ var pages_newguestxhs1 = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LandingPageHeader: src_components_LandingPageHeader,
    LandingPageHeaderXhs: src_components_LandingPageHeaderXhs,
    LandingPageFooter: src_components_LandingPageFooter,
    LandingPageFooterXhs: src_components_LandingPageFooterXhs,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false,
      scrollTop: 0,
      tabIndex: 0,
      xhsImgList: ['https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_age.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_area.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_sex.png'],
      xhsImgList1: [{
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_200.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_100.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_50.png'
      }],
      xhsImgList1_index: 0,
      xhs1_swiper_index: 0,
      currentIndex: 0
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        _this4.$router.push('/media?tab=xhs');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    },
    goAnchor: function goAnchor(selector) {
      console.log(this.$parent.$parent.$refs.viewBox.scrollTo);
      var anchor = this.$el.querySelector(selector);

      this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100);
    },
    changeTab: function changeTab(index) {
      this.tabIndex = index;
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-379bddad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newguestxhs1/index.vue
var newguestxhs1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('landing-page-header-xhs',{attrs:{"title":"小红书推广精准营销平台"}}),_vm._v(" "),_c('div',{staticClass:"wechat-flooing-banner"},[_c('a',{on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhsldy_01_banner.png","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"kcb-unique"},[_vm._m(0),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-yonghu1",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel, "mobile", $$v)},expression:"loginModel.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"图形验证码","label-width":"200"},model:{value:(_vm.loginModel.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha", $$v)},expression:"loginModel.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码","label-width":"200"},model:{value:(_vm.loginModel.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel, "msgcode", $$v)},expression:"loginModel.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha()}},slot:"right-full-height"},[_vm._v("\n                    "+_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login()}}},[_vm._v("一键获取小红书折扣底价")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"kcb-prospect"},[_c('h3',[_vm._v("前景广阔")]),_vm._v(" "),_c('p',[_vm._v("小红书当前用户数已突破1亿，2018年海淘电商APP应用排名第一")]),_vm._v(" "),_c('swiper',{attrs:{"aspect-ratio":374/690,"dots-class":"xhs1-custom-bottom","dots-position":"center"}},_vm._l((_vm.xhsImgList),function(item,index){return _c('swiper-item',{key:index,staticClass:"swiper-demo-img"},[_c('img',{staticClass:"kcb-prospect-pic",attrs:{"src":item}})])}))],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"kcb-xhs1-swiper"},[_c('swiper',{attrs:{"aspect-ratio":480/750,"auto":"","loop":"","interval":3000,"dots-position":"center"}},[_c('swiper-item',[_c('a',{on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('img',{staticClass:"kcb-swiper-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_200.png"}})])]),_vm._v(" "),_c('swiper-item',[_c('a',{on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('img',{staticClass:"kcb-swiper-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_100.png"}})])]),_vm._v(" "),_c('swiper-item',[_c('a',{on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('img',{staticClass:"kcb-swiper-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_50.png"}})])])],1)],1),_vm._v(" "),_c('div',{staticClass:"new-guest-kcb-rules"},[_c('div',{staticClass:"new-guest-kcb-rules-h3"},[_vm._v("软盟——深耕小红书推广机制")]),_vm._v(" "),_c('div',{staticClass:"new-guest-kcb-rules-h3-p"},[_vm._v("红人大号粉丝真实价格超低，按效果付费成本可控")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("免费注册，获取推广方案")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==0},on:{"click":function($event){_vm.changeTab(0)}}},[_vm._v("母婴案例")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==1},on:{"click":function($event){_vm.changeTab(1)}}},[_vm._v("生活案例")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==2},on:{"click":function($event){_vm.changeTab(2)}}},[_vm._v("时尚案例")])]),_vm._v(" "),(_vm.tabIndex==0)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(5),_vm._v(" "),_vm._m(6)]):_vm._e(),_vm._v(" "),(_vm.tabIndex==1)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(7),_vm._v(" "),_vm._m(8)]):_vm._e(),_vm._v(" "),(_vm.tabIndex==2)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(9),_vm._v(" "),_vm._m(10)]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("马上注册，获取行业定制方案")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-discount"},[_c('swiper',{attrs:{"aspect-ratio":1058/750,"show-dots":false,"dots-position":"center"}},[_c('swiper-item',[_c('h3',[_vm._v("红人号低至200元，选购10个另享9折优惠")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-discount-swiper-li"},[_c('div',{staticClass:"new-guest-xhs1-sale-box"},[_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_01.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_02.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_03.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_04.png"}})]),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign-fff",attrs:{"target":"_blank"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("马上注册，抢购特价套餐")])])]),_vm._v(" "),_c('swiper-item',[_c('h3',[_vm._v("红人号选10送5")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-discount-swiper-li"},[_c('div',{staticClass:"new-guest-xhs1-sale-box"},[_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_05.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_06.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_07.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_08.png"}})]),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign-fff",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("马上注册，抢购特价套餐")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"kcb-unique",attrs:{"id":"register"}},[_vm._m(11),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-yonghu1",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel2.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel2, "mobile", $$v)},expression:"loginModel2.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"图形验证码","label-width":"200"},model:{value:(_vm.loginModel2.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel2, "captcha", $$v)},expression:"loginModel2.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码","label-width":"200"},model:{value:(_vm.loginModel2.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel2, "msgcode", $$v)},expression:"loginModel2.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha(2)}},slot:"right-full-height"},[_vm._v("\n                    "+_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login(2)}}},[_vm._v("一键获取小红书折扣底价")])],1)])],1),_vm._v(" "),_c('landing-page-footer-xhs'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_index_xhs1"}})],1)}
var newguestxhs1_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"wechat-flooing-title-first"},[_vm._v("小红书推广100元起")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-cover"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_text_01.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("服务客户10000+ "),_c('br'),_vm._v("\n            覆盖母婴、电商、美妆、家居、"),_c('br'),_vm._v("\n            服装、食品等"),_c('br'),_vm._v("\n            行业均有成熟解决方案")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-fans-relaible"},[_c('h3',[_vm._v("红人号粉丝"),_c('span',[_vm._v("真实可靠")]),_vm._v(" "),_c('br'),_vm._v("人工"),_c('span',[_vm._v("层层筛选")]),_vm._v(",绝无刷粉水号")]),_vm._v(" "),_c('div',{staticClass:"new-guest-fans-relaible-content"},[_c('div',{staticClass:"new-guest-fans-relaible-content-li"},[_c('div',{staticClass:"new-guest-fans-circle"},[_c('i',{staticClass:"iconfont icon-qianyuehongren"})]),_vm._v(" "),_c('h3',[_vm._v("98256+")]),_vm._v(" "),_c('p',[_vm._v("签约优质小红"),_c('br'),_vm._v("书红人")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-fans-relaible-content-li"},[_c('div',{staticClass:"new-guest-fans-circle"},[_c('i',{staticClass:"iconfont icon-xinmeitizhanghao"})]),_vm._v(" "),_c('h3',[_vm._v("794528+")]),_vm._v(" "),_c('p',[_vm._v("优质新媒体"),_c('br'),_vm._v("大号")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-fans-relaible-content-li"},[_c('div',{staticClass:"new-guest-fans-circle"},[_c('i',{staticClass:"iconfont icon-qianyuehongren"})]),_vm._v(" "),_c('h3',[_c('span',[_vm._v("覆盖行业")]),_vm._v("93+")]),_vm._v(" "),_c('p',[_vm._v("200+领域"),_c('br'),_vm._v("复投率86%以上")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-kcb-rules-content"},[_c('div',{staticClass:"new-guest-kcb-rules-content-li"},[_c('div',{staticClass:"new-guest-kcb-rules-content-li-icon"},[_c('i',{staticClass:"iconfont icon-xiaoshi-1"})]),_vm._v(" "),_c('div',{staticClass:"new-guest-kcb-rules-content-li-text"},[_c('h3',[_vm._v("转化效果可观")]),_vm._v(" "),_c('p',[_vm._v("客户复投率86%，推广上线评论点赞暴增，7天销量翻倍；\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-kcb-rules-content-li"},[_c('div',{staticClass:"new-guest-kcb-rules-content-li-icon"},[_c('i',{staticClass:"iconfont icon-xiaoshi-"})]),_vm._v(" "),_c('div',{staticClass:"new-guest-kcb-rules-content-li-text"},[_c('h3',[_vm._v("海量资源粉丝真实无水分")]),_vm._v(" "),_c('p',[_vm._v("人工层层精准筛选10万+优质红人号，剔除僵尸粉灌水号，投放后效果立竿见影；")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-kcb-rules-content-li"},[_c('div',{staticClass:"new-guest-kcb-rules-content-li-icon"},[_c('i',{staticClass:"iconfont icon-xiaoshi-3"})]),_vm._v(" "),_c('div',{staticClass:"new-guest-kcb-rules-content-li-text"},[_c('h3',[_vm._v("专家一对一24小时服务  ")]),_vm._v(" "),_c('p',[_vm._v("小红书专家深耕推荐机制，免费量身定制推广笔记，推广笔记留存率100%；")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-kcb-rules-content-li"},[_c('div',{staticClass:"new-guest-kcb-rules-content-li-icon"},[_c('i',{staticClass:"iconfont icon-xiaoshi-2"})]),_vm._v(" "),_c('div',{staticClass:"new-guest-kcb-rules-content-li-text"},[_c('h3',[_vm._v("满意再扣款  ")]),_vm._v(" "),_c('p',[_vm._v("服务10000+客户，经验丰富推广专家一对一全程跟踪，保障投放效果；\n                    ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_vm._v("服务"),_c('span',[_vm._v("10000+ ")]),_vm._v("客户 推广笔记"),_c('span',[_vm._v("留存率")]),_vm._v("100%")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_logo1.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_pic1.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("200W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("6000+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("转发量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("4000+")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("专题策划+内容种草+热门tag投放"),_c('br'),_vm._v("15位小红书中部母婴类KOL，依托于更垂直的粉丝覆盖，将产品卖点更亲和的方式输出，辐射影响200万+用户，以痛点强化卖点，为粉丝种草产品。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_logo2.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_pic2.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("10W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("1000+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("转发量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("1000+")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("专题策划+内容种草+热门tag"),_c('br'),_vm._v(" 投放10位小红书尾部KOL试水，粉丝与话题合计辐射影响10万+用户，以切身体验影响核心受众，增加产品曝光量。\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_logo3.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_pic3.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("50W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("10000+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("转发量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("100000+")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("专题策划+内容种草+热门tag"),_c('br'),_vm._v("投放30位小红书达人，成功覆盖50万＋粉丝，短期内集中曝光大众对于产品的认知，扩大品牌知名度，强势种草转化销售")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"wechat-flooing-title-first"},[_vm._v("小红书推广100元起")])])}]
var newguestxhs1_esExports = { render: newguestxhs1_render, staticRenderFns: newguestxhs1_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_newguestxhs1 = (newguestxhs1_esExports);
// CONCATENATED MODULE: ./src/pages/newguestxhs1/index.vue
function newguestxhs1_injectStyle (ssrContext) {
  __webpack_require__("s3+5")
  __webpack_require__("O0bA")
}
var newguestxhs1_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var newguestxhs1___vue_template_functional__ = false
/* styles */
var newguestxhs1___vue_styles__ = newguestxhs1_injectStyle
/* scopeId */
var newguestxhs1___vue_scopeId__ = "data-v-379bddad"
/* moduleIdentifier (server only) */
var newguestxhs1___vue_module_identifier__ = null
var newguestxhs1_Component = newguestxhs1_normalizeComponent(
  pages_newguestxhs1,
  selectortype_template_index_0_src_pages_newguestxhs1,
  newguestxhs1___vue_template_functional__,
  newguestxhs1___vue_styles__,
  newguestxhs1___vue_scopeId__,
  newguestxhs1___vue_module_identifier__
)

/* harmony default export */ var src_pages_newguestxhs1 = (newguestxhs1_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguestxhs2/index.vue




















/* harmony default export */ var newguestxhs2 = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LandingPageHeader: src_components_LandingPageHeader,
    LandingPageHeaderXhs: src_components_LandingPageHeaderXhs,
    LandingPageFooter: src_components_LandingPageFooter,
    LandingPageFooterXhs: src_components_LandingPageFooterXhs,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false,
      scrollTop: 0,
      tabIndex: 0,
      xhsImgList: ['https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_age.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_area.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_sex.png'],
      xhsImgList1: [{
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_200.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_100.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_50.png'
      }],
      xhsImgList1_index: 0,
      xhs1_swiper_index: 0,
      currentIndex: 0
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        _this4.$router.push('/media?tab=xhs');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    },
    goAnchor: function goAnchor(selector) {
      console.log(this.$parent.$parent.$refs.viewBox.scrollTo);
      var anchor = this.$el.querySelector(selector);

      this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100);
    },
    changeTab: function changeTab(index) {
      this.tabIndex = index;
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguestxhs2/index.vue




















/* harmony default export */ var pages_newguestxhs2 = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LandingPageHeader: src_components_LandingPageHeader,
    LandingPageHeaderXhs: src_components_LandingPageHeaderXhs,
    LandingPageFooter: src_components_LandingPageFooter,
    LandingPageFooterXhs: src_components_LandingPageFooterXhs,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false,
      scrollTop: 0,
      tabIndex: 0,
      xhsImgList: ['https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_age.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_area.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_sex.png'],
      xhsImgList1: [{
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_200.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_100.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_50.png'
      }],
      xhsImgList1_index: 0,
      xhs1_swiper_index: 0,
      currentIndex: 0
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        _this4.$router.push('/media?tab=xhs');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    },
    goAnchor: function goAnchor(selector) {
      console.log(this.$parent.$parent.$refs.viewBox.scrollTo);
      var anchor = this.$el.querySelector(selector);

      this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100);
    },
    changeTab: function changeTab(index) {
      this.tabIndex = index;
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57934083","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newguestxhs2/index.vue
var newguestxhs2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('landing-page-header-xhs',{attrs:{"title":"小红书推广精准营销平台"}}),_vm._v(" "),_c('a',{staticClass:"wechat-flooing-banner",on:{"click":function($event){_vm.goAnchor('#register')}}}),_vm._v(" "),_c('div',{staticClass:"kcb-unique"},[_vm._m(0),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-yonghu1",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel, "mobile", $$v)},expression:"loginModel.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"图形验证码","label-width":"200"},model:{value:(_vm.loginModel.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha", $$v)},expression:"loginModel.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码","label-width":"200"},model:{value:(_vm.loginModel.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel, "msgcode", $$v)},expression:"loginModel.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha()}},slot:"right-full-height"},[_vm._v("\n                    "+_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login()}}},[_vm._v("一键获取小红书折扣底价")])],1)])],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"kcb-xhs1-swiper"},[_c('swiper',{attrs:{"aspect-ratio":569/750,"auto":"","loop":"","interval":3000,"dots-position":"center"}},[_c('swiper-item',[_c('a',{on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('img',{staticClass:"kcb-swiper-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs2_01.jpg"}})])]),_vm._v(" "),_c('swiper-item',[_c('a',{on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('img',{staticClass:"kcb-swiper-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs2_02.jpg"}})])])],1)],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"xhs2-rules"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs2-rules-title.png","alt":""}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"xhs2-sign",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("\n            马上注册，获取行业定制方案\n        ")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==0},on:{"click":function($event){_vm.changeTab(0)}}},[_vm._v("母婴案例")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==1},on:{"click":function($event){_vm.changeTab(1)}}},[_vm._v("生活案例")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==2},on:{"click":function($event){_vm.changeTab(2)}}},[_vm._v("时尚案例")])]),_vm._v(" "),(_vm.tabIndex==0)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(5),_vm._v(" "),_vm._m(6)]):_vm._e(),_vm._v(" "),(_vm.tabIndex==1)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(7),_vm._v(" "),_vm._m(8)]):_vm._e(),_vm._v(" "),(_vm.tabIndex==2)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(9),_vm._v(" "),_vm._m(10)]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("马上注册，获取行业定制方案")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-discount"},[_c('swiper',{attrs:{"aspect-ratio":1058/750,"show-dots":false,"dots-position":"center"}},[_c('swiper-item',[_c('h3',[_vm._v("红人号低至200元，选购10个另享9折优惠")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-discount-swiper-li"},[_c('div',{staticClass:"new-guest-xhs1-sale-box"},[_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_01.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_02.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_03.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_04.png"}})]),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign-fff",attrs:{"target":"_blank"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("马上注册，抢购特价套餐")])])]),_vm._v(" "),_c('swiper-item',[_c('h3',[_vm._v("红人号选10送5")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-discount-swiper-li"},[_c('div',{staticClass:"new-guest-xhs1-sale-box"},[_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_05.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_06.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_07.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_08.png"}})]),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign-fff",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("马上注册，抢购特价套餐")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"kcb-unique",attrs:{"id":"register"}},[_vm._m(11),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-yonghu1",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel2.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel2, "mobile", $$v)},expression:"loginModel2.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"图形验证码","label-width":"200"},model:{value:(_vm.loginModel2.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel2, "captcha", $$v)},expression:"loginModel2.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码","label-width":"200"},model:{value:(_vm.loginModel2.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel2, "msgcode", $$v)},expression:"loginModel2.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha(2)}},slot:"right-full-height"},[_vm._v("\n                    "+_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login(2)}}},[_vm._v("一键获取小红书折扣底价")])],1)])],1),_vm._v(" "),_c('landing-page-footer-xhs'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_index_xhs1"}})],1)}
var newguestxhs2_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"wechat-flooing-title-first"},[_vm._v("小红书推广100元起")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs2-promotion-advantage"},[_c('div',{staticClass:"xhs2-common-title"},[_vm._v("\n            软盟小红书"),_c('span',[_vm._v("推广优势")])]),_vm._v(" "),_c('div',{staticClass:"xhs2-promotion-outter"},[_c('div',{staticClass:"xhs2-promotion-inner"},[_c('div',{staticClass:"xhs2-promotion-other-platfom"},[_c('h3',[_vm._v("其他平台小红书推广")]),_vm._v(" "),_c('p',[_vm._v("1、报价虚高，达人号1000元起；")]),_vm._v(" "),_c('p',[_vm._v("2、红人号质量差，点赞评论低；")]),_vm._v(" "),_c('p',[_vm._v("3、笔记客户自己写，不能引起客户共鸣，转化差；")]),_vm._v(" "),_c('p',[_vm._v("4、推广笔记经常被删，无法保障留存；")]),_vm._v(" "),_c('p',[_vm._v("5、一个客服服务多家客户，服务差响应时间长。")]),_vm._v(" "),_c('p',[_vm._v("6、先付款后投放，效果无法保障。")])]),_vm._v(" "),_c('img',{staticClass:"xhs2-vs",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs2_vs.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"xhs2-promotion-other-platfom"},[_c('h3',{staticStyle:{"color":"#ff2741"}},[_vm._v("软盟平台小红书推广")]),_vm._v(" "),_c('p',[_vm._v("1、价格透明，不赚差价，小红书达人号低至100元；")]),_vm._v(" "),_c('p',[_vm._v("2、人工层层筛选，剔除灌水号，粉丝真实转化80%以上；")]),_vm._v(" "),_c('p',[_vm._v("3、专家免费撰写笔记，深度了解客户心理；")]),_vm._v(" "),_c('p',[_vm._v("4、评论点赞均不低于300；")]),_vm._v(" "),_c('p',[_vm._v("5、深耕小红书推广机制，笔记留存率100%，被删补发；")]),_vm._v(" "),_c('p',[_vm._v("6、专家24小时一对一服务，客户满意效果后再付款；")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs2-hongren-account-box"},[_c('div',{staticClass:"xhs2-hongren-account"},[_c('div',{staticClass:"xhs2-common-title"},[_c('span',[_vm._v("优质红人号")]),_vm._v("  粉丝真实可靠\n            ")]),_vm._v(" "),_c('div',{staticClass:"xhs2-hongren-account-content"},[_c('div',{staticClass:"xhs2-hongren-account-content-li"},[_c('div',{staticClass:"xhs2-hongren-account-content-li-inner"},[_c('div',{staticClass:"xhs2-hongren-account-circle"},[_c('i',{staticClass:"iconfont icon-qianyuehongren"})]),_vm._v(" "),_c('h3',[_vm._v("98256+")]),_vm._v(" "),_c('p',[_vm._v("签约优质小红"),_c('br'),_vm._v("书红人")])])]),_vm._v(" "),_c('div',{staticClass:"xhs2-hongren-account-content-li"},[_c('div',{staticClass:"xhs2-hongren-account-content-li-inner"},[_c('div',{staticClass:"xhs2-hongren-account-circle"},[_c('i',{staticClass:"iconfont icon-xinmeitizhanghao"})]),_vm._v(" "),_c('h3',[_vm._v("794528+")]),_vm._v(" "),_c('p',[_vm._v("优质新媒体"),_c('br'),_vm._v("大号")])])]),_vm._v(" "),_c('div',{staticClass:"xhs2-hongren-account-content-li"},[_c('div',{staticClass:"xhs2-hongren-account-content-li-inner"},[_c('div',{staticClass:"xhs2-hongren-account-circle"},[_c('i',{staticClass:"iconfont icon-hangye"})]),_vm._v(" "),_c('h3',[_vm._v("93+")]),_vm._v(" "),_c('p',[_vm._v("行业被覆盖"),_c('br'),_vm._v("200+领域"),_c('br'),_vm._v("复投率86%以上")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("服务客户10000+,覆盖母婴、电商、美妆、"),_c('br'),_vm._v("\n            家居、服装、食品等行业"),_c('br'),_vm._v("\n            均有成熟解决方案")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs2-common-title"},[_vm._v("\n            服务客户"),_c('span',{staticStyle:{"letter-spacing":"0"}},[_vm._v("10000+ ")]),_vm._v(" 笔记留存"),_c('span',{staticStyle:{"letter-spacing":"0"}},[_vm._v("100%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_logo1.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_pic1.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("200W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("6000+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("转发量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("4000+")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("专题策划+内容种草+热门tag投放"),_c('br'),_vm._v("15位小红书中部母婴类KOL，依托于更垂直的粉丝覆盖，将产品卖点更亲和的方式输出，辐射影响200万+用户，以痛点强化卖点，为粉丝种草产品。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_logo2.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_pic2.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("10W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("1000+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("转发量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("1000+")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("专题策划+内容种草+热门tag"),_c('br'),_vm._v(" 投放10位小红书尾部KOL试水，粉丝与话题合计辐射影响10万+用户，以切身体验影响核心受众，增加产品曝光量。\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_logo3.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_pic3.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("50W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("10000+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("转发量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("100000+")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("专题策划+内容种草+热门tag"),_c('br'),_vm._v("投放30位小红书达人，成功覆盖50万＋粉丝，短期内集中曝光大众对于产品的认知，扩大品牌知名度，强势种草转化销售")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"wechat-flooing-title-first"},[_vm._v("小红书推广100元起")])])}]
var newguestxhs2_esExports = { render: newguestxhs2_render, staticRenderFns: newguestxhs2_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_newguestxhs2 = (newguestxhs2_esExports);
// CONCATENATED MODULE: ./src/pages/newguestxhs2/index.vue
function newguestxhs2_injectStyle (ssrContext) {
  __webpack_require__("8xMK")
  __webpack_require__("bwKU")
}
var newguestxhs2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var newguestxhs2___vue_template_functional__ = false
/* styles */
var newguestxhs2___vue_styles__ = newguestxhs2_injectStyle
/* scopeId */
var newguestxhs2___vue_scopeId__ = "data-v-57934083"
/* moduleIdentifier (server only) */
var newguestxhs2___vue_module_identifier__ = null
var newguestxhs2_Component = newguestxhs2_normalizeComponent(
  pages_newguestxhs2,
  selectortype_template_index_0_src_pages_newguestxhs2,
  newguestxhs2___vue_template_functional__,
  newguestxhs2___vue_styles__,
  newguestxhs2___vue_scopeId__,
  newguestxhs2___vue_module_identifier__
)

/* harmony default export */ var src_pages_newguestxhs2 = (newguestxhs2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageFooterDouble.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LandingPageFooterDouble = ({
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageFooterDouble.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_LandingPageFooterDouble = ({
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c323770","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPageFooterDouble.vue
var LandingPageFooterDouble_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-footer"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"index-footer-contact-ways"},[_c('h3',[_vm._v("400-858-1399")]),_vm._v(" "),_c('p',[_vm._v("免费咨询热线")]),_vm._v(" "),_c('div',{staticClass:"consult-qq"},[_c('div',{staticClass:"consult-icon-box icon-chat"},[_c('icon',{attrs:{"type":"svg","name":"qq"}})],1),_vm._v(" "),_c('span',[_vm._v("4008581399")])])])])}
var LandingPageFooterDouble_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-footer-left"},[_c('img',{staticClass:"index-footer-ercode",attrs:{"alt":"","src":"https://static.xinmeibao.com/assets/v3/images/footer_kcbewm.png"}}),_vm._v(" "),_c('img',{staticClass:"index-footer-ercode",attrs:{"alt":"","src":"https://static.xinmeibao.com/assets/v3/images/footer_kcbxcx.png"}})])}]
var LandingPageFooterDouble_esExports = { render: LandingPageFooterDouble_render, staticRenderFns: LandingPageFooterDouble_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_LandingPageFooterDouble = (LandingPageFooterDouble_esExports);
// CONCATENATED MODULE: ./src/components/LandingPageFooterDouble.vue
function LandingPageFooterDouble_injectStyle (ssrContext) {
  __webpack_require__("xDlu")
}
var LandingPageFooterDouble_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LandingPageFooterDouble___vue_template_functional__ = false
/* styles */
var LandingPageFooterDouble___vue_styles__ = LandingPageFooterDouble_injectStyle
/* scopeId */
var LandingPageFooterDouble___vue_scopeId__ = "data-v-0c323770"
/* moduleIdentifier (server only) */
var LandingPageFooterDouble___vue_module_identifier__ = null
var LandingPageFooterDouble_Component = LandingPageFooterDouble_normalizeComponent(
  components_LandingPageFooterDouble,
  selectortype_template_index_0_src_components_LandingPageFooterDouble,
  LandingPageFooterDouble___vue_template_functional__,
  LandingPageFooterDouble___vue_styles__,
  LandingPageFooterDouble___vue_scopeId__,
  LandingPageFooterDouble___vue_module_identifier__
)

/* harmony default export */ var src_components_LandingPageFooterDouble = (LandingPageFooterDouble_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/double12/index.vue



















/* harmony default export */ var double12 = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LandingPageHeader: src_components_LandingPageHeader,
    LandingPageFooter: src_components_LandingPageFooter,
    LandingPageFooterDouble: src_components_LandingPageFooterDouble,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      scrollTop: 0,
      tabIndex: 0,
      tabIndex1: 0,
      currentIndex: 0,
      liveData1: [],
      liveData2: [],
      liveData3: [],
      videoData1: [],
      videoData2: [],
      videoData3: [],
      weiboData1: [],
      woaData1: [],
      xhsData1: [],
      xhsData2: [],
      xhsData3: []
    };
  },

  filters: {
    originalPrice: function originalPrice(value) {
      var num = parseInt(value);
      var num2 = num * 2;
      return num2;
    },
    formatNumInTenThousand: function formatNumInTenThousand(data) {
      var num = parseInt(data);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  methods: {
    changeKingTab: function changeKingTab(index) {
      this.tabIndex1 = index;
    },
    changeTab: function changeTab(index) {
      this.tabIndex = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com//api/wap_12', {}, {
        method: 'get'
      }).then(function (resp) {
        var transferData = JSON.parse(resp.data);
        if (transferData.success) {
          var doubleData = transferData.message;
          var liveData = doubleData.live;
          _this.liveData1 = liveData.slice(0, 3);
          _this.liveData2 = liveData.slice(3, 6);
          _this.liveData3 = liveData.slice(6, 9);
          var xhsData = doubleData.xhs;
          _this.xhsData1 = xhsData.slice(0, 3);
          _this.xhsData2 = xhsData.slice(3, 6);
          _this.xhsData3 = xhsData.slice(6, 9);
          var videoData = doubleData.video;
          _this.videoData1 = videoData.slice(0, 3);
          _this.videoData2 = videoData.slice(3, 6);
          _this.videoData3 = videoData.slice(6, 9);
          var weiboData = doubleData.weibo;
          _this.weiboData1 = weiboData.slice(0, 4);
          var woaData = doubleData.woa;
          _this.woaData1 = woaData.slice(0, 4);
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleAddToCart: function handleAddToCart(id, taxonomy, type, redirect) {
      var _this2 = this;

      addToCart(id, taxonomy, type, redirect).then(function (resp) {
        if (resp.status) {
          console.log(resp, 258);
          _this2.$vux.toast.show({
            text: '成功加入购物车'
          });
          if (redirect) {
            switch (taxonomy) {
              case 'xhs':
                _this2.$router.push('/cart?tab=2');
                break;
              case 'woa':
                _this2.$router.push('/cart?tab=0');
                break;
              case 'weibo':
                _this2.$router.push('/cart?tab=4');
                break;
              case 'video':
                _this2.$router.push('/cart?tab=1');
                break;
              case 'live':
                _this2.$router.push('/cart?tab=3');
                break;
            }
          }
        }
      }).catch(function (e) {
        if (e.status === 401) {
          _this2.$vux.toast.show({
            text: e.message
          });
          _this2.$router.push('/login');
        } else if (e.status === 422) {
          _this2.$vux.toast.show({
            text: e.message
          });
        }
      });
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/double12/index.vue



















/* harmony default export */ var pages_double12 = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LandingPageHeader: src_components_LandingPageHeader,
    LandingPageFooter: src_components_LandingPageFooter,
    LandingPageFooterDouble: src_components_LandingPageFooterDouble,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      scrollTop: 0,
      tabIndex: 0,
      tabIndex1: 0,
      currentIndex: 0,
      liveData1: [],
      liveData2: [],
      liveData3: [],
      videoData1: [],
      videoData2: [],
      videoData3: [],
      weiboData1: [],
      woaData1: [],
      xhsData1: [],
      xhsData2: [],
      xhsData3: []
    };
  },

  filters: {
    originalPrice: function originalPrice(value) {
      var num = parseInt(value);
      var num2 = num * 2;
      return num2;
    },
    formatNumInTenThousand: function formatNumInTenThousand(data) {
      var num = parseInt(data);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  methods: {
    changeKingTab: function changeKingTab(index) {
      this.tabIndex1 = index;
    },
    changeTab: function changeTab(index) {
      this.tabIndex = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com//api/wap_12', {}, {
        method: 'get'
      }).then(function (resp) {
        var transferData = JSON.parse(resp.data);
        if (transferData.success) {
          var doubleData = transferData.message;
          var liveData = doubleData.live;
          _this.liveData1 = liveData.slice(0, 3);
          _this.liveData2 = liveData.slice(3, 6);
          _this.liveData3 = liveData.slice(6, 9);
          var xhsData = doubleData.xhs;
          _this.xhsData1 = xhsData.slice(0, 3);
          _this.xhsData2 = xhsData.slice(3, 6);
          _this.xhsData3 = xhsData.slice(6, 9);
          var videoData = doubleData.video;
          _this.videoData1 = videoData.slice(0, 3);
          _this.videoData2 = videoData.slice(3, 6);
          _this.videoData3 = videoData.slice(6, 9);
          var weiboData = doubleData.weibo;
          _this.weiboData1 = weiboData.slice(0, 4);
          var woaData = doubleData.woa;
          _this.woaData1 = woaData.slice(0, 4);
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    handleAddToCart: function handleAddToCart(id, taxonomy, type, redirect) {
      var _this2 = this;

      addToCart(id, taxonomy, type, redirect).then(function (resp) {
        if (resp.status) {
          console.log(resp, 258);
          _this2.$vux.toast.show({
            text: '成功加入购物车'
          });
          if (redirect) {
            switch (taxonomy) {
              case 'xhs':
                _this2.$router.push('/cart?tab=2');
                break;
              case 'woa':
                _this2.$router.push('/cart?tab=0');
                break;
              case 'weibo':
                _this2.$router.push('/cart?tab=4');
                break;
              case 'video':
                _this2.$router.push('/cart?tab=1');
                break;
              case 'live':
                _this2.$router.push('/cart?tab=3');
                break;
            }
          }
        }
      }).catch(function (e) {
        if (e.status === 401) {
          _this2.$vux.toast.show({
            text: e.message
          });
          _this2.$router.push('/login');
        } else if (e.status === 422) {
          _this2.$vux.toast.show({
            text: e.message
          });
        }
      });
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6a543be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/double12/index.vue
var double12_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"double12-blank"}),_vm._v(" "),_c('div',{staticClass:"double12-banner"}),_vm._v(" "),_c('div',{staticClass:"double12-super"},[_c('img',{staticClass:"double-common-title",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/double12-title-01.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-super-content"},[_c('swiper',{attrs:{"loop":"","auto":"","aspect-ratio":1190/750,"dots-position":"center","dots-class":"double12-dots-super"}},[_c('swiper-item',[_c('div',{staticClass:"double12-super-column"},_vm._l((_vm.liveData1),function(item,index){return _c('div',{key:index,staticClass:"double12-super-li"},[_c('div',{staticClass:"double12-super-li-left"},[_c('img',{staticClass:"double12-super-li-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-super-li-discount"},[_vm._v("5.0折")])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-info"},[_c('div',{staticClass:"double12-super-li-fansnum"},[_vm._v("粉丝数："+_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-type"},[_vm._v(_vm._s(item.category))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-online"},[_vm._v("线上直播："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(item.price)))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-original"},[_vm._v("原价："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(_vm._f("originalPrice")(item.price))))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-operation"},[_c('div',{staticClass:"double12-super-li-addcar",on:{"click":function($event){_vm.handleAddToCart(item.id,'live','online')}}},[_vm._v("加入购物车")]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-purchase",on:{"click":function($event){_vm.handleAddToCart(item.id,'live','online','true')}}},[_vm._v("立即"),_c('br'),_vm._v("抢购")])])])])}))]),_vm._v(" "),_c('swiper-item',[_c('div',{staticClass:"double12-super-column"},_vm._l((_vm.liveData2),function(item,index){return _c('div',{key:index,staticClass:"double12-super-li"},[_c('div',{staticClass:"double12-super-li-left"},[_c('img',{staticClass:"double12-super-li-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-super-li-discount"},[_vm._v("5.0折")])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-info"},[_c('div',{staticClass:"double12-super-li-fansnum"},[_vm._v("粉丝数："+_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-type"},[_vm._v(_vm._s(item.category))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-online"},[_vm._v("线上直播："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(item.price)))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-original"},[_vm._v("原价："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(_vm._f("originalPrice")(item.price))))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-operation"},[_c('div',{staticClass:"double12-super-li-addcar",on:{"click":function($event){_vm.handleAddToCart(item.id,'live','online')}}},[_vm._v("加入购物车")]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-purchase",on:{"click":function($event){_vm.handleAddToCart(item.id,'live','online','true')}}},[_vm._v("立即"),_c('br'),_vm._v("抢购")])])])])}))]),_vm._v(" "),_c('swiper-item',[_c('div',{staticClass:"double12-super-column"},_vm._l((_vm.liveData3),function(item,index){return _c('div',{key:index,staticClass:"double12-super-li"},[_c('div',{staticClass:"double12-super-li-left"},[_c('img',{staticClass:"double12-super-li-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-super-li-discount"},[_vm._v("5.0折")])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-info"},[_c('div',{staticClass:"double12-super-li-fansnum"},[_vm._v("粉丝数："+_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-type"},[_vm._v(_vm._s(item.category))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-online"},[_vm._v("线上直播："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(item.price)))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-original"},[_vm._v("原价："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(_vm._f("originalPrice")(item.price))))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-operation"},[_c('div',{staticClass:"double12-super-li-addcar",on:{"click":function($event){_vm.handleAddToCart(item.id,'live','online')}}},[_vm._v("加入购物车")]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-purchase",on:{"click":function($event){_vm.handleAddToCart(item.id,'live','online','true')}}},[_vm._v("立即"),_c('br'),_vm._v("抢购")])])])])}))])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"double12-grass"},[_c('img',{staticClass:"double-common-title",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/double12-title-02.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-super-content"},[_c('swiper',{attrs:{"loop":"","auto":"","aspect-ratio":1190/750,"dots-position":"center","dots-class":"double12-dots-grass"}},[_c('swiper-item',[_c('div',{staticClass:"double12-super-column"},_vm._l((_vm.xhsData1),function(item,index){return _c('div',{key:index,staticClass:"double12-super-li"},[_c('div',{staticClass:"double12-super-li-left"},[_c('img',{staticClass:"double12-super-li-avatar",attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-super-li-discount"},[_vm._v("5.0折")])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-info"},[_c('div',{staticClass:"double12-super-li-fansnum"},[_vm._v("粉丝数："+_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-type"},[_vm._v(_vm._s(item.category))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-online"},[_vm._v("图文价："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(item.price_second)))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-original"},[_vm._v("原价："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(_vm._f("originalPrice")(item.price_second))))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-operation"},[_c('div',{staticClass:"double12-super-li-addcar",on:{"click":function($event){_vm.handleAddToCart(item.id,'xhs','imagetext')}}},[_vm._v("加入购物车")]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-purchase",on:{"click":function($event){_vm.handleAddToCart(item.id,'xhs','imagetext','true')}}},[_vm._v("立即"),_c('br'),_vm._v("抢购")])])])])}))]),_vm._v(" "),_c('swiper-item',[_c('div',{staticClass:"double12-super-column"},_vm._l((_vm.xhsData2),function(item,index){return _c('div',{key:index,staticClass:"double12-super-li"},[_c('div',{staticClass:"double12-super-li-left"},[_c('img',{staticClass:"double12-super-li-avatar",attrs:{"src":'https://api.ruan.net/api/service/cv_image?src=' + item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-super-li-discount"},[_vm._v("5.0折")])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-info"},[_c('div',{staticClass:"double12-super-li-fansnum"},[_vm._v("粉丝数："+_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-type"},[_vm._v(_vm._s(item.category))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-online"},[_vm._v("图文价："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(item.price_second)))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-original"},[_vm._v("原价："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(_vm._f("originalPrice")(item.price_second))))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-operation"},[_c('div',{staticClass:"double12-super-li-addcar",on:{"click":function($event){_vm.handleAddToCart(item.id,'xhs','imagetext')}}},[_vm._v("加入购物车")]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-purchase",on:{"click":function($event){_vm.handleAddToCart(item.id,'xhs','imagetext','true')}}},[_vm._v("立即"),_c('br'),_vm._v("抢购")])])])])}))]),_vm._v(" "),_c('swiper-item',[_c('div',{staticClass:"double12-super-column"},_vm._l((_vm.xhsData3),function(item,index){return _c('div',{key:index,staticClass:"double12-super-li"},[_c('div',{staticClass:"double12-super-li-left"},[_c('img',{staticClass:"double12-super-li-avatar",attrs:{"src":'https://api.ruan.net/api/service/cv_image?src=' + 'https://api.ruan.net/api/service/cv_image?src=' + item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-super-li-discount"},[_vm._v("5.0折")])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-info"},[_c('div',{staticClass:"double12-super-li-fansnum"},[_vm._v("粉丝数："+_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-type"},[_vm._v(_vm._s(item.category))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-online"},[_vm._v("图文价："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(item.price_second)))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-original"},[_vm._v("原价："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(_vm._f("originalPrice")(item.price_second))))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-operation"},[_c('div',{staticClass:"double12-super-li-addcar",on:{"click":function($event){_vm.handleAddToCart(item.id,'xhs','imagetext')}}},[_vm._v("加入购物车")]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-purchase",on:{"click":function($event){_vm.handleAddToCart(item.id,'xhs','imagetext','true')}}},[_vm._v("立即"),_c('br'),_vm._v("抢购")])])])])}))])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"double12-favorite"},[_c('img',{staticClass:"double-common-title",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/double12-title-03.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-super-content"},[_c('swiper',{attrs:{"loop":"","auto":"","aspect-ratio":1190/750,"dots-position":"center","dots-class":"double12-dots-favorite"}},[_c('swiper-item',[_c('div',{staticClass:"double12-super-column"},_vm._l((_vm.videoData1),function(item,index){return _c('div',{key:index,staticClass:"double12-super-li"},[_c('div',{staticClass:"double12-super-li-left"},[_c('img',{staticClass:"double12-super-li-avatar",attrs:{"src":'https://api.ruan.net/api/service/cv_image?src=' + item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-super-li-discount"},[_vm._v("5.0折")])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-info"},[_c('div',{staticClass:"double12-super-li-fansnum"},[_vm._v("粉丝数："+_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-type"},[_vm._v(_vm._s(item.category))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-online"},[_vm._v("原创+发布："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(item.price)))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-original"},[_vm._v("原价："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(_vm._f("originalPrice")(item.price))))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-operation"},[_c('div',{staticClass:"double12-super-li-addcar",on:{"click":function($event){_vm.handleAddToCart(item.id,'video','original_publish')}}},[_vm._v("加入购物车")]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-purchase",on:{"click":function($event){_vm.handleAddToCart(item.id,'video','original_publish','true')}}},[_vm._v("立即"),_c('br'),_vm._v("抢购")])])])])}))]),_vm._v(" "),_c('swiper-item',[_c('div',{staticClass:"double12-super-column"},_vm._l((_vm.videoData2),function(item,index){return _c('div',{key:index,staticClass:"double12-super-li"},[_c('div',{staticClass:"double12-super-li-left"},[_c('img',{staticClass:"double12-super-li-avatar",attrs:{"src":'https://api.ruan.net/api/service/cv_image?src=' + item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-super-li-discount"},[_vm._v("5.0折")])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-info"},[_c('div',{staticClass:"double12-super-li-fansnum"},[_vm._v("粉丝数："+_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-type"},[_vm._v(_vm._s(item.category))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-online"},[_vm._v("原创+发布："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(item.price)))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-original"},[_vm._v("原价："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(_vm._f("originalPrice")(item.price))))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-operation"},[_c('div',{staticClass:"double12-super-li-addcar",on:{"click":function($event){_vm.handleAddToCart(item.id,'video','original_publish')}}},[_vm._v("加入购物车")]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-purchase",on:{"click":function($event){_vm.handleAddToCart(item.id,'video','original_publish','true')}}},[_vm._v("立即"),_c('br'),_vm._v("抢购")])])])])}))]),_c('swiper-item',[_c('div',{staticClass:"double12-super-column"},_vm._l((_vm.videoData3),function(item,index){return _c('div',{key:index,staticClass:"double12-super-li"},[_c('div',{staticClass:"double12-super-li-left"},[_c('img',{staticClass:"double12-super-li-avatar",attrs:{"src":'https://api.ruan.net/api/service/cv_image?src=' + item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-super-li-discount"},[_vm._v("5.0折")])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-info"},[_c('div',{staticClass:"double12-super-li-fansnum"},[_vm._v("粉丝数："+_vm._s(_vm._f("formatNumInTenThousand")(item.fans_num)))]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-type"},[_vm._v(_vm._s(item.category))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-online"},[_vm._v("原创+发布："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(item.price)))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-original"},[_vm._v("原价："),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(_vm._f("originalPrice")(item.price))))])]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-operation"},[_c('div',{staticClass:"double12-super-li-addcar",on:{"click":function($event){_vm.handleAddToCart(item.id,'video','original_publish')}}},[_vm._v("加入购物车")]),_vm._v(" "),_c('div',{staticClass:"double12-super-li-purchase",on:{"click":function($event){_vm.handleAddToCart(item.id,'video','original_publish','true')}}},[_vm._v("立即"),_c('br'),_vm._v("抢购")])])])])}))])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"double12-kingflow"},[_c('img',{staticClass:"double-common-title",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/double12-title-04.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-tabbar"},[_c('div',{staticClass:"double12-kingflow-tabbar-li",class:{'double12-kingflow-tabbar-li-checked':_vm.tabIndex1==0},on:{"click":function($event){_vm.changeKingTab(0)}}},[_vm._v("微信KOL")]),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-tabbar-li",class:{'double12-kingflow-tabbar-li-checked':_vm.tabIndex1==1},on:{"click":function($event){_vm.changeKingTab(1)}}},[_vm._v("微博KOL")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndex1==0),expression:"tabIndex1==0"}],staticClass:"double12-kingflow-content"},_vm._l((_vm.woaData1),function(item,index){return _c('div',{key:index,staticClass:"double12-kingflow-content-li"},[_c('div',{staticClass:"double12-kingflow-content-li-type"},[_vm._v(_vm._s(item.category))]),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-content-li-discount"},[_vm._v("5.0折")]),_vm._v(" "),_c('img',{staticClass:"double12-kingflow-avatar",attrs:{"src":'https://api.ruan.net/api/service/cv_image?src=' + item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-toutiao"},[_vm._v("头条:"),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(item.price)))])]),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-original"},[_vm._v("原价:"),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(_vm._f("originalPrice")(item.price))))])]),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-operation"},[_c('div',{staticClass:"double12-kingflow-addcar",on:{"click":function($event){_vm.handleAddToCart(item.id,'woa','top')}}},[_vm._v("加入购物车")]),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-purchase",on:{"click":function($event){_vm.handleAddToCart(item.id,'woa','top','true')}}},[_vm._v("立即抢购")])])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndex1==1),expression:"tabIndex1==1"}],staticClass:"double12-kingflow-content"},_vm._l((_vm.weiboData1),function(item,index){return _c('div',{key:index,staticClass:"double12-kingflow-content-li"},[_c('div',{staticClass:"double12-kingflow-content-li-type"},[_vm._v(_vm._s(item.category))]),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-content-li-discount"},[_vm._v("5.0折")]),_vm._v(" "),_c('img',{staticClass:"double12-kingflow-avatar",attrs:{"src":'https://api.ruan.net/api/service/cv_image?src=' + item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-toutiao"},[_vm._v("直发:"),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(item.price)))])]),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-original"},[_vm._v("原价:"),_c('span',[_vm._v("￥"+_vm._s(_vm._f("formatNumInTenThousand")(_vm._f("originalPrice")(item.price))))])]),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-operation"},[_c('div',{staticClass:"double12-kingflow-addcar",on:{"click":function($event){_vm.handleAddToCart(item.id,'weibo','tweet')}}},[_vm._v("加入购物车")]),_vm._v(" "),_c('div',{staticClass:"double12-kingflow-purchase",on:{"click":function($event){_vm.handleAddToCart(item.id,'weibo','tweet','true')}}},[_vm._v("立即抢购")])])])}))]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case"},[_c('img',{staticClass:"double-common-title",staticStyle:{"margin-top":"30px"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/double12-title-05.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==0},on:{"click":function($event){_vm.changeTab(0)}}},[_vm._v("母婴案例")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==1},on:{"click":function($event){_vm.changeTab(1)}}},[_vm._v("生活案例")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==2},on:{"click":function($event){_vm.changeTab(2)}}},[_vm._v("时尚案例")])]),_vm._v(" "),(_vm.tabIndex==0)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(1),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.tabIndex==1)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(3),_vm._v(" "),_vm._m(4)]):_vm._e(),_vm._v(" "),(_vm.tabIndex==2)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(5),_vm._v(" "),_vm._m(6)]):_vm._e()]),_vm._v(" "),_c('landing-page-footer-double'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_index_double12"}})],1)}
var double12_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double12-header"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/logo@2x.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"double12-operation"},[_c('a',{staticClass:"double12-operation-login",attrs:{"href":"/login"}},[_vm._v("登录")]),_vm._v(" "),_c('a',{staticClass:"double12-operation-sign",attrs:{"href":"/register"}},[_vm._v("注册")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_logo1.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_pic1.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("200W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("6000+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("转发量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("4000+")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("专题策划+内容种草+热门tag投放"),_c('br'),_vm._v("15位小红书中部母婴类KOL，依托于更垂直的粉丝覆盖，将产品卖点更亲和的方式输出，辐射影响200万+用户，以痛点强化卖点，为粉丝种草产品。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_logo2.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_pic2.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("10W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("1000+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("转发量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("1000+")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("专题策划+内容种草+热门tag"),_c('br'),_vm._v(" 投放10位小红书尾部KOL试水，粉丝与话题合计辐射影响10万+用户，以切身体验影响核心受众，增加产品曝光量。\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_logo3.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_pic3.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("50W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("10000+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("转发量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("100000+")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("专题策划+内容种草+热门tag"),_c('br'),_vm._v("投放30位小红书达人，成功覆盖50万＋粉丝，短期内集中曝光大众对于产品的认知，扩大品牌知名度，强势种草转化销售")])])}]
var double12_esExports = { render: double12_render, staticRenderFns: double12_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_double12 = (double12_esExports);
// CONCATENATED MODULE: ./src/pages/double12/index.vue
function double12_injectStyle (ssrContext) {
  __webpack_require__("QzC3")
  __webpack_require__("JWXY")
}
var double12_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var double12___vue_template_functional__ = false
/* styles */
var double12___vue_styles__ = double12_injectStyle
/* scopeId */
var double12___vue_scopeId__ = "data-v-c6a543be"
/* moduleIdentifier (server only) */
var double12___vue_module_identifier__ = null
var double12_Component = double12_normalizeComponent(
  pages_double12,
  selectortype_template_index_0_src_pages_double12,
  double12___vue_template_functional__,
  double12___vue_styles__,
  double12___vue_scopeId__,
  double12___vue_module_identifier__
)

/* harmony default export */ var src_pages_double12 = (double12_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageHeaderKol.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LandingPageHeaderKol = ({
  name: 'LandingPageHeader',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_t'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loginStatus: {}
    };
  },

  methods: {
    // getUserInfo () {
    //   fetchUser().then(resp => {
    //     this.userInfo = resp.data
    //   })
    // }
  },
  mounted: function mounted() {
    this.loginStatus = !!getCookie('token');
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageHeaderKol.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_LandingPageHeaderKol = ({
  name: 'LandingPageHeader',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_t'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loginStatus: {}
    };
  },

  methods: {
    // getUserInfo () {
    //   fetchUser().then(resp => {
    //     this.userInfo = resp.data
    //   })
    // }
  },
  mounted: function mounted() {
    this.loginStatus = !!getCookie('token');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51af3403","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPageHeaderKol.vue
var LandingPageHeaderKol_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-header-container"},[_c('div',{staticClass:"index-header"},[_c('div',{staticClass:"index-header-inner"},[_c('a',{staticClass:"index-header-inner-left",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/logo@2x.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"index-header-line"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.title||'新媒体精准营销平台'))])]),_vm._v(" "),(!_vm.loginStatus)?_c('a',{staticClass:"index-header-inner-login",attrs:{"href":'/register?utm_click='+_vm.utmClick}},[_vm._v("立即注册")]):_vm._e()])])])}
var LandingPageHeaderKol_staticRenderFns = []
var LandingPageHeaderKol_esExports = { render: LandingPageHeaderKol_render, staticRenderFns: LandingPageHeaderKol_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_LandingPageHeaderKol = (LandingPageHeaderKol_esExports);
// CONCATENATED MODULE: ./src/components/LandingPageHeaderKol.vue
function LandingPageHeaderKol_injectStyle (ssrContext) {
  __webpack_require__("6+SP")
}
var LandingPageHeaderKol_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LandingPageHeaderKol___vue_template_functional__ = false
/* styles */
var LandingPageHeaderKol___vue_styles__ = LandingPageHeaderKol_injectStyle
/* scopeId */
var LandingPageHeaderKol___vue_scopeId__ = "data-v-51af3403"
/* moduleIdentifier (server only) */
var LandingPageHeaderKol___vue_module_identifier__ = null
var LandingPageHeaderKol_Component = LandingPageHeaderKol_normalizeComponent(
  components_LandingPageHeaderKol,
  selectortype_template_index_0_src_components_LandingPageHeaderKol,
  LandingPageHeaderKol___vue_template_functional__,
  LandingPageHeaderKol___vue_styles__,
  LandingPageHeaderKol___vue_scopeId__,
  LandingPageHeaderKol___vue_module_identifier__
)

/* harmony default export */ var src_components_LandingPageHeaderKol = (LandingPageHeaderKol_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageFooterKol.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LandingPageFooterKol = ({
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPageFooterKol.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_LandingPageFooterKol = ({
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9b49fdc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPageFooterKol.vue
var LandingPageFooterKol_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-footer"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"index-footer-contact-ways"},[_c('h3',[_vm._v("400-858-1399")]),_vm._v(" "),_c('p',[_vm._v("免费咨询热线")]),_vm._v(" "),_c('div',{staticClass:"consult-qq"},[_c('div',{staticClass:"consult-icon-box icon-chat"},[_c('icon',{attrs:{"type":"svg","name":"qq"}})],1),_vm._v(" "),_c('span',[_vm._v("4008581399")])])])])}
var LandingPageFooterKol_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-footer-left"},[_c('img',{staticClass:"index-footer-ercode",attrs:{"alt":"","src":"https://static.xinmeibao.com/assets/v3/images/footer_kcbewm.png"}}),_vm._v(" "),_c('img',{staticClass:"index-footer-ercode",attrs:{"alt":"","src":"https://static.xinmeibao.com/assets/v3/images/footer_kcbxcx.png"}})])}]
var LandingPageFooterKol_esExports = { render: LandingPageFooterKol_render, staticRenderFns: LandingPageFooterKol_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_LandingPageFooterKol = (LandingPageFooterKol_esExports);
// CONCATENATED MODULE: ./src/components/LandingPageFooterKol.vue
function LandingPageFooterKol_injectStyle (ssrContext) {
  __webpack_require__("NzE6")
}
var LandingPageFooterKol_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LandingPageFooterKol___vue_template_functional__ = false
/* styles */
var LandingPageFooterKol___vue_styles__ = LandingPageFooterKol_injectStyle
/* scopeId */
var LandingPageFooterKol___vue_scopeId__ = "data-v-a9b49fdc"
/* moduleIdentifier (server only) */
var LandingPageFooterKol___vue_module_identifier__ = null
var LandingPageFooterKol_Component = LandingPageFooterKol_normalizeComponent(
  components_LandingPageFooterKol,
  selectortype_template_index_0_src_components_LandingPageFooterKol,
  LandingPageFooterKol___vue_template_functional__,
  LandingPageFooterKol___vue_styles__,
  LandingPageFooterKol___vue_scopeId__,
  LandingPageFooterKol___vue_module_identifier__
)

/* harmony default export */ var src_components_LandingPageFooterKol = (LandingPageFooterKol_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguestkol/index.vue

















/* harmony default export */ var newguestkol = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LandingPageHeaderKol: src_components_LandingPageHeaderKol,
    LandingPageFooter: src_components_LandingPageFooter,
    LandingPageFooterKol: src_components_LandingPageFooterKol,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */]
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false,
      scrollTop: 0,
      tabIndex: 0,
      woakol: [{
        avatar: 'https://wx.qlogo.cn/mmhead/Q3auHgzwzM5SUtLag6HZn4E3Sqnmfqj11pDjia1V63wHKpzvNVicukicA/0',
        name: '她街拍',
        fansnum: '160万',
        price: '¥120000'
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180627/5a15a04862c0e.png',
        name: '十点读书会',
        fansnum: '155万',
        price: '¥83369 '
      }, {
        avatar: 'https://static.xinmeibao.com/face/woa/20180913144550NAZJUg.jpg?x-oss-process=image/crop,x_173,y_173,w_82,h_82',
        name: '有格',
        fansnum: '305万',
        price: '¥120000'
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180627/5a16dd3eb95a5.png',
        name: '不二大叔',
        fansnum: '330万',
        price: '¥150000'
      }],
      weibokol: [{
        avatar: 'http://tva3.sinaimg.cn/crop.0.0.750.750.180/9d02006bjw8f3jt6jndtmj20ku0ku3zo.jpg',
        name: '虫虫Chonny',
        fansnum: '334.18万',
        price: '¥136800'
      }, {
        avatar: 'http://tvax2.sinaimg.cn/crop.0.10.1125.1125.180/006q8szCly8fgq42km241j30v90vtq6j.jpg',
        name: 'Pony__朴惠敏',
        fansnum: '707.16万',
        price: '¥250800 '
      }, {
        avatar: 'http://tvax4.sinaimg.cn/crop.0.0.512.512.180/0065Ippvly8fsmie45toej30e80e875l.jpg',
        name: '温婉Wenwan_',
        fansnum: '270.52万',
        price: '¥242000'
      }, {
        avatar: 'http://tvax2.sinaimg.cn/crop.14.0.722.722.180/006USit1ly8fkz1xw8g57j30ku0k2ab5.jpg',
        name: '七舅脑爷',
        fansnum: '198.02万',
        price: '¥137800'
      }],
      xhskol: [{
        avatar: 'https://static.xinmeibao.com/assets_web/img/5d4a8ad5d4f65690dccf08ee0d63bd30.jpg',
        name: 'Ritatawang',
        fansnum: '344.92万',
        price: '¥154000'
      }, {
        avatar: 'https://static.xinmeibao.com/assets_web/img/ecf6e7190e6c058a3306f30f216d4920.jpg',
        name: '大睿睿',
        fansnum: '190.17万',
        price: '¥114950 '
      }, {
        avatar: 'https://static.xinmeibao.com/assets_web/img/7b3c3c1c5c14732d05511d84155600d3.jpg',
        name: '周韦彤Cica',
        fansnum: '1.72万',
        price: '¥192390'
      }, {
        avatar: 'https://static.xinmeibao.com/assets_web/img/043fb1bbfa1a08c4a60f4f993ec52ca7.jpg',
        name: '吉克隽逸',
        fansnum: '37.93万',
        price: '¥230000'
      }],
      videokol: [{
        avatar: 'https://static.xinmeibao.com/uploads/1/180904/258069659aae4fd58582a6d8bfff0171.jpg',
        name: '小黎喵7',
        fansnum: '29万',
        price: '¥10769'
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180615/592bfd5a2b3d01316.jpg',
        name: '最热视频精选',
        fansnum: '17万',
        price: '¥762 '
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180615/BMjAxODA1MTEyMzM5NTBfNjYzMDUzNjlfMV9oZDk0OV81ODY=_s.jpg',
        name: '叫我小马林🔥',
        fansnum: '147万',
        price: '¥455444'
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180627/5a16dd3eb95a5.png',
        name: '微在不懂爱',
        fansnum: '81万',
        price: '¥150000'
      }],
      livekol: [{
        avatar: 'https://static.xinmeibao.com/uploads/000000/180614/1b3f8354c927659291b90e4f02c2814c.jpg',
        name: '陈老师-陈思雨',
        fansnum: '23万',
        price: '¥7139'
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180614/42401b2a3d009de1087df7eda218544c.jpg',
        name: '尤马马',
        fansnum: '88万',
        price: '¥24684 '
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000003/3d1fc859de3096b6147d31e2716b21d7.jpg',
        name: 'Reginachenchen',
        fansnum: '226.6万',
        price: '¥9680'
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180614/fb75a7c8b0b1b886b39f6ace01bff195.jpg',
        name: '兔牙妹199',
        fansnum: '71万',
        price: '¥7502'
      }],
      tabIndexKol: '0',
      tabIndexPar: '0',
      financeImgList: [{ 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/爱钱进.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/百度有钱花.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/凤凰金融.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/金银猫.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/京东金融.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/你我贷.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/平安银行.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/浦发银行.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/钱多多.png' }],
      itImgList: [{ 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/boss直聘.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/爱回收.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/爱奇艺.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/薄荷阅读.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/京东.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/每日优鲜.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/苏宁.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/天天P图.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/网易严选.png' }],
      technologyImgList: [{ 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/3M.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/OPPO.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/vivo.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/百度.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/大疆无人机.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/戴尔.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/飞利浦.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/华为.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/佳能.png' }],
      carImgList: [{ 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/奥迪.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/宝马.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/奔驰.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/吉利.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/捷豹.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/凯迪拉克.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/雷克萨斯.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/路虎.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/沃尔沃.png' }],
      educationImgList: [{ 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/VIPKID.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/哒哒英语.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/环球雅思.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/金吉列留学.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/尚德机构.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/星火教育.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/学而思.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/英孚教育.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/英语流利说.png' }],
      fashioneImgList: [{ 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/Dior.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/FARFETCH.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/HM.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/HUGOBOSS.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/Lamer.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/YSL.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/纪梵希.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/丝芙兰.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/雅诗兰黛.png' }]
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        _this4.$router.push('/media');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    },
    goAnchor: function goAnchor(selector) {
      console.log(this.$parent.$parent.$refs.viewBox.scrollTo);
      var anchor = this.$el.querySelector(selector);

      this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100);
    },
    changeTab: function changeTab(index) {
      this.tabIndex = index;
    },
    changeKolTab: function changeKolTab(index) {
      this.tabIndexKol = index;
    },
    changePartnersTab: function changePartnersTab(index) {
      this.tabIndexPar = index;
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguestkol/index.vue

















/* harmony default export */ var pages_newguestkol = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LandingPageHeaderKol: src_components_LandingPageHeaderKol,
    LandingPageFooter: src_components_LandingPageFooter,
    LandingPageFooterKol: src_components_LandingPageFooterKol,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */]
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false,
      scrollTop: 0,
      tabIndex: 0,
      woakol: [{
        avatar: 'https://wx.qlogo.cn/mmhead/Q3auHgzwzM5SUtLag6HZn4E3Sqnmfqj11pDjia1V63wHKpzvNVicukicA/0',
        name: '她街拍',
        fansnum: '160万',
        price: '¥120000'
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180627/5a15a04862c0e.png',
        name: '十点读书会',
        fansnum: '155万',
        price: '¥83369 '
      }, {
        avatar: 'https://static.xinmeibao.com/face/woa/20180913144550NAZJUg.jpg?x-oss-process=image/crop,x_173,y_173,w_82,h_82',
        name: '有格',
        fansnum: '305万',
        price: '¥120000'
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180627/5a16dd3eb95a5.png',
        name: '不二大叔',
        fansnum: '330万',
        price: '¥150000'
      }],
      weibokol: [{
        avatar: 'http://tva3.sinaimg.cn/crop.0.0.750.750.180/9d02006bjw8f3jt6jndtmj20ku0ku3zo.jpg',
        name: '虫虫Chonny',
        fansnum: '334.18万',
        price: '¥136800'
      }, {
        avatar: 'http://tvax2.sinaimg.cn/crop.0.10.1125.1125.180/006q8szCly8fgq42km241j30v90vtq6j.jpg',
        name: 'Pony__朴惠敏',
        fansnum: '707.16万',
        price: '¥250800 '
      }, {
        avatar: 'http://tvax4.sinaimg.cn/crop.0.0.512.512.180/0065Ippvly8fsmie45toej30e80e875l.jpg',
        name: '温婉Wenwan_',
        fansnum: '270.52万',
        price: '¥242000'
      }, {
        avatar: 'http://tvax2.sinaimg.cn/crop.14.0.722.722.180/006USit1ly8fkz1xw8g57j30ku0k2ab5.jpg',
        name: '七舅脑爷',
        fansnum: '198.02万',
        price: '¥137800'
      }],
      xhskol: [{
        avatar: 'https://static.xinmeibao.com/assets_web/img/5d4a8ad5d4f65690dccf08ee0d63bd30.jpg',
        name: 'Ritatawang',
        fansnum: '344.92万',
        price: '¥154000'
      }, {
        avatar: 'https://static.xinmeibao.com/assets_web/img/ecf6e7190e6c058a3306f30f216d4920.jpg',
        name: '大睿睿',
        fansnum: '190.17万',
        price: '¥114950 '
      }, {
        avatar: 'https://static.xinmeibao.com/assets_web/img/7b3c3c1c5c14732d05511d84155600d3.jpg',
        name: '周韦彤Cica',
        fansnum: '1.72万',
        price: '¥192390'
      }, {
        avatar: 'https://static.xinmeibao.com/assets_web/img/043fb1bbfa1a08c4a60f4f993ec52ca7.jpg',
        name: '吉克隽逸',
        fansnum: '37.93万',
        price: '¥230000'
      }],
      videokol: [{
        avatar: 'https://static.xinmeibao.com/uploads/1/180904/258069659aae4fd58582a6d8bfff0171.jpg',
        name: '小黎喵7',
        fansnum: '29万',
        price: '¥10769'
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180615/592bfd5a2b3d01316.jpg',
        name: '最热视频精选',
        fansnum: '17万',
        price: '¥762 '
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180615/BMjAxODA1MTEyMzM5NTBfNjYzMDUzNjlfMV9oZDk0OV81ODY=_s.jpg',
        name: '叫我小马林🔥',
        fansnum: '147万',
        price: '¥455444'
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180627/5a16dd3eb95a5.png',
        name: '微在不懂爱',
        fansnum: '81万',
        price: '¥150000'
      }],
      livekol: [{
        avatar: 'https://static.xinmeibao.com/uploads/000000/180614/1b3f8354c927659291b90e4f02c2814c.jpg',
        name: '陈老师-陈思雨',
        fansnum: '23万',
        price: '¥7139'
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180614/42401b2a3d009de1087df7eda218544c.jpg',
        name: '尤马马',
        fansnum: '88万',
        price: '¥24684 '
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000003/3d1fc859de3096b6147d31e2716b21d7.jpg',
        name: 'Reginachenchen',
        fansnum: '226.6万',
        price: '¥9680'
      }, {
        avatar: 'https://static.xinmeibao.com/uploads/000000/180614/fb75a7c8b0b1b886b39f6ace01bff195.jpg',
        name: '兔牙妹199',
        fansnum: '71万',
        price: '¥7502'
      }],
      tabIndexKol: '0',
      tabIndexPar: '0',
      financeImgList: [{ 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/爱钱进.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/百度有钱花.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/凤凰金融.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/金银猫.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/京东金融.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/你我贷.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/平安银行.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/浦发银行.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/钱多多.png' }],
      itImgList: [{ 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/boss直聘.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/爱回收.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/爱奇艺.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/薄荷阅读.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/京东.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/每日优鲜.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/苏宁.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/天天P图.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/网易严选.png' }],
      technologyImgList: [{ 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/3M.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/OPPO.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/vivo.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/百度.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/大疆无人机.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/戴尔.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/飞利浦.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/华为.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/佳能.png' }],
      carImgList: [{ 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/奥迪.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/宝马.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/奔驰.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/吉利.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/捷豹.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/凯迪拉克.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/雷克萨斯.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/路虎.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/沃尔沃.png' }],
      educationImgList: [{ 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/VIPKID.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/哒哒英语.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/环球雅思.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/金吉列留学.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/尚德机构.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/星火教育.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/学而思.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/英孚教育.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/英语流利说.png' }],
      fashioneImgList: [{ 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/Dior.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/FARFETCH.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/HM.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/HUGOBOSS.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/Lamer.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/YSL.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/纪梵希.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/丝芙兰.png' }, { 'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/雅诗兰黛.png' }]
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        _this4.$router.push('/media');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    },
    goAnchor: function goAnchor(selector) {
      console.log(this.$parent.$parent.$refs.viewBox.scrollTo);
      var anchor = this.$el.querySelector(selector);

      this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100);
    },
    changeTab: function changeTab(index) {
      this.tabIndex = index;
    },
    changeKolTab: function changeKolTab(index) {
      this.tabIndexKol = index;
    },
    changePartnersTab: function changePartnersTab(index) {
      this.tabIndexPar = index;
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2efad7a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newguestkol/index.vue
var newguestkol_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('landing-page-header-kol',{attrs:{"title":"KOL精准资源平台"}}),_vm._v(" "),_c('a',{staticClass:"wechat-flooing-banner",on:{"click":function($event){_vm.goAnchor('#register')}}}),_vm._v(" "),_c('div',{staticClass:"kcb-unique"},[_vm._m(0),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-yonghu1",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel, "mobile", $$v)},expression:"loginModel.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"图形验证码","label-width":"200"},model:{value:(_vm.loginModel.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha", $$v)},expression:"loginModel.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码","label-width":"200"},model:{value:(_vm.loginModel.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel, "msgcode", $$v)},expression:"loginModel.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha()}},slot:"right-full-height"},[_vm._v("\n                    "+_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login()}}},[_vm._v("一键获取媒体资源报价")])],1)])],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"kol-promotion"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"kol-promotion-tab"},[_c('div',{staticClass:"kol-promotion-tab-li",class:{'kol-actived':_vm.tabIndexKol==0},on:{"click":function($event){_vm.changeKolTab(0)}}},[_vm._v("微信KOL")]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-tab-li",class:{'kol-actived':_vm.tabIndexKol==1},on:{"click":function($event){_vm.changeKolTab(1)}}},[_vm._v("微博KOL")]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-tab-li",class:{'kol-actived':_vm.tabIndexKol==2},on:{"click":function($event){_vm.changeKolTab(2)}}},[_vm._v("小红书KOL")]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-tab-li",class:{'kol-actived':_vm.tabIndexKol==3},on:{"click":function($event){_vm.changeKolTab(3)}}},[_vm._v("短视频KOL")]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-tab-li",class:{'kol-actived':_vm.tabIndexKol==4},on:{"click":function($event){_vm.changeKolTab(4)}}},[_vm._v("直播KOL")])]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-content-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndexKol==0),expression:"tabIndexKol==0"}],staticClass:"kol-promotion-content"},_vm._l((_vm.woakol),function(item,index){return _c('div',{key:index,staticClass:"kol-promotion-content-li"},[_c('div',{staticClass:"kol-promotion-recent"},[_vm._v("最新")]),_vm._v(" "),_c('img',{attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"kol-promotion-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-fans"},[_vm._v("粉丝数:"+_vm._s(item.fansnum))]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-info"},[_c('div',{staticClass:"kol-promotion-info-type"},[_vm._v("头条")]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-price"},[_vm._v(_vm._s(item.price))])]),_vm._v(" "),_c('a',{staticClass:"kol-look-price",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("查看详情")])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndexKol==1),expression:"tabIndexKol==1"}],staticClass:"kol-promotion-content"},_vm._l((_vm.weibokol),function(item,index){return _c('div',{key:index,staticClass:"kol-promotion-content-li"},[_c('div',{staticClass:"kol-promotion-recent"},[_vm._v("最新")]),_vm._v(" "),_c('img',{attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"kol-promotion-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-fans"},[_vm._v("粉丝数:"+_vm._s(item.fansnum))]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-info"},[_c('div',{staticClass:"kol-promotion-info-type"},[_vm._v("直发")]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-price"},[_vm._v(_vm._s(item.price))])]),_vm._v(" "),_c('a',{staticClass:"kol-look-price",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("查看详情")])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndexKol==2),expression:"tabIndexKol==2"}],staticClass:"kol-promotion-content"},_vm._l((_vm.xhskol),function(item,index){return _c('div',{key:index,staticClass:"kol-promotion-content-li"},[_c('div',{staticClass:"kol-promotion-recent"},[_vm._v("最新")]),_vm._v(" "),_c('img',{attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"kol-promotion-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-fans"},[_vm._v("粉丝数:"+_vm._s(item.fansnum))]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-info"},[_c('div',{staticClass:"kol-promotion-info-type"},[_vm._v("图文")]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-price"},[_vm._v(_vm._s(item.price))])]),_vm._v(" "),_c('a',{staticClass:"kol-look-price",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("查看详情")])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndexKol==3),expression:"tabIndexKol==3"}],staticClass:"kol-promotion-content"},_vm._l((_vm.videokol),function(item,index){return _c('div',{key:index,staticClass:"kol-promotion-content-li"},[_c('div',{staticClass:"kol-promotion-recent"},[_vm._v("最新")]),_vm._v(" "),_c('img',{attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"kol-promotion-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-fans"},[_vm._v("粉丝数:"+_vm._s(item.fansnum))]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-info"},[_c('div',{staticClass:"kol-promotion-info-type"},[_vm._v("原创")]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-price"},[_vm._v(_vm._s(item.price))])]),_vm._v(" "),_c('a',{staticClass:"kol-look-price",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("查看详情")])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndexKol==4),expression:"tabIndexKol==4"}],staticClass:"kol-promotion-content"},_vm._l((_vm.livekol),function(item,index){return _c('div',{key:index,staticClass:"kol-promotion-content-li"},[_c('div',{staticClass:"kol-promotion-recent"},[_vm._v("最新")]),_vm._v(" "),_c('img',{attrs:{"src":item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"kol-promotion-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-fans"},[_vm._v("粉丝数:"+_vm._s(item.fansnum))]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-info"},[_c('div',{staticClass:"kol-promotion-info-type"},[_vm._v("线上")]),_vm._v(" "),_c('div',{staticClass:"kol-promotion-price"},[_vm._v(_vm._s(item.price))])]),_vm._v(" "),_c('a',{staticClass:"kol-look-price",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("查看详情")])])}))])]),_vm._v(" "),_c('div',{staticClass:"kol-service"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"kol-service-content-li-box"},[_c('div',{staticClass:"kol-service-content-li kol-wechat"},[_vm._m(4),_vm._v(" "),_c('a',{staticClass:"kol-consult",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("点击咨询")])]),_vm._v(" "),_c('div',{staticClass:"kol-service-content-li kol-video"},[_vm._m(5),_vm._v(" "),_c('a',{staticClass:"kol-consult",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("点击咨询")])]),_vm._v(" "),_c('div',{staticClass:"kol-service-content-li kol-live"},[_vm._m(6),_vm._v(" "),_c('a',{staticClass:"kol-consult",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("点击咨询")])]),_vm._v(" "),_c('div',{staticClass:"kol-service-content-li kol-weibo"},[_vm._m(7),_vm._v(" "),_c('a',{staticClass:"kol-consult",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("点击咨询")])]),_vm._v(" "),_c('div',{staticClass:"kol-service-content-li kol-xhs"},[_vm._m(8),_vm._v(" "),_c('a',{staticClass:"kol-consult",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("点击咨询")])])])]),_vm._v(" "),_c('div',{staticClass:"kol-customize"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"kol-customize-content"},[_c('div',{staticClass:"kol-customize-content-li",staticStyle:{"background":"#fbe5cc"}},[_c('div',{staticClass:"kol-customize-content-li-inner"},[_c('h3',[_vm._v("快消行业推广")]),_vm._v(" "),_c('p',[_vm._v("大数据海量覆盖目标人群，为快消品提供一站式营销方案；")]),_vm._v(" "),_c('div',{staticClass:"kol-icon-and-arrow"},[_c('i',{staticClass:"iconfont icon-jiejuefangan_kuaixiaopinhangyetuiguang"}),_vm._v(" "),_c('div',{staticClass:"kol-arrow",on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('i',{staticClass:"iconfont icon-jiantouyou"})])])])]),_vm._v(" "),_c('div',{staticClass:"kol-customize-content-li",staticStyle:{"background":"#f9d7e4"}},[_c('div',{staticClass:"kol-customize-content-li-inner"},[_c('h3',[_vm._v("母婴行业推广")]),_vm._v(" "),_c('p',[_vm._v("多渠道整合智能营销，助您在母婴市场中脱颖而出；")]),_vm._v(" "),_c('div',{staticClass:"kol-icon-and-arrow"},[_c('i',{staticClass:"iconfont icon-jiejuefangan_icon-jiejuefangan_muyinghangyetuiguang"}),_vm._v(" "),_c('div',{staticClass:"kol-arrow",on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('i',{staticClass:"iconfont icon-jiantouyou"})])])])]),_vm._v(" "),_c('div',{staticClass:"kol-customize-content-li",staticStyle:{"background":"#ebd2c5"}},[_c('div',{staticClass:"kol-customize-content-li-inner"},[_c('h3',[_vm._v("游戏行业推广")]),_vm._v(" "),_c('p',[_vm._v("手游、页游、端游，一 站式助您达成推广目标；")]),_vm._v(" "),_c('div',{staticClass:"kol-icon-and-arrow"},[_c('i',{staticClass:"iconfont icon-jiejuefangan-youxihangyetuiguang"}),_vm._v(" "),_c('div',{staticClass:"kol-arrow",on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('i',{staticClass:"iconfont icon-jiantouyou"})])])])]),_vm._v(" "),_c('div',{staticClass:"kol-customize-content-li",staticStyle:{"background":"#d1f4fe"}},[_c('div',{staticClass:"kol-customize-content-li-inner"},[_c('h3',[_vm._v("旅游行业推广")]),_vm._v(" "),_c('p',[_vm._v("精准投放，品效合一定制方案为您带来更多客户；")]),_vm._v(" "),_c('div',{staticClass:"kol-icon-and-arrow"},[_c('i',{staticClass:"iconfont icon-jiejuefangan_lvyouhangyetuiguang"}),_vm._v(" "),_c('div',{staticClass:"kol-arrow",on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('i',{staticClass:"iconfont icon-jiantouyou"})])])])]),_vm._v(" "),_c('div',{staticClass:"kol-customize-content-li",staticStyle:{"background":"#fbe7c5"}},[_c('div',{staticClass:"kol-customize-content-li-inner"},[_c('h3',[_vm._v("APP推广")]),_vm._v(" "),_c('p',[_vm._v("全渠道、大数据锁定精准用户量身定制推广解决方案；")]),_vm._v(" "),_c('div',{staticClass:"kol-icon-and-arrow"},[_c('i',{staticClass:"iconfont icon-jiejuefangan_apptuiguang"}),_vm._v(" "),_c('div',{staticClass:"kol-arrow",on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('i',{staticClass:"iconfont icon-jiantouyou"})])])])]),_vm._v(" "),_c('div',{staticClass:"kol-customize-content-li",staticStyle:{"background":"#e2d7fd"}},[_c('div',{staticClass:"kol-customize-content-li-inner"},[_c('h3',[_vm._v("电商行业推广")]),_vm._v(" "),_c('p',[_vm._v("智能营销解决方案，实现转化与成交；")]),_vm._v(" "),_c('div',{staticClass:"kol-icon-and-arrow"},[_c('i',{staticClass:"iconfont icon-jiejuefangan_dianshanghangyetuiguang"}),_vm._v(" "),_c('div',{staticClass:"kol-arrow",on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('i',{staticClass:"iconfont icon-jiantouyou"})])])])]),_vm._v(" "),_c('div',{staticClass:"kol-customize-content-li",staticStyle:{"background":"#faddc2"}},[_c('div',{staticClass:"kol-customize-content-li-inner"},[_c('h3',[_vm._v("金融行业推广")]),_vm._v(" "),_c('p',[_vm._v("覆盖精准用户同时提高公信力，助您实现品牌价值；")]),_vm._v(" "),_c('div',{staticClass:"kol-icon-and-arrow"},[_c('i',{staticClass:"iconfont icon-jiejuefangan_jinronghangyetuiguang"}),_vm._v(" "),_c('div',{staticClass:"kol-arrow",on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('i',{staticClass:"iconfont icon-jiantouyou"})])])])]),_vm._v(" "),_c('div',{staticClass:"kol-customize-content-li",staticStyle:{"background":"#d7e4fd"}},[_c('div',{staticClass:"kol-customize-content-li-inner"},[_c('h3',[_vm._v("汽车行业推广")]),_vm._v(" "),_c('p',[_vm._v("全渠道、大数据锁定精准用户为汽车品牌提供一站式方案；")]),_vm._v(" "),_c('div',{staticClass:"kol-icon-and-arrow"},[_c('i',{staticClass:"iconfont icon-jiejuefangan_qichehangyetuiguang"}),_vm._v(" "),_c('div',{staticClass:"kol-arrow",on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('i',{staticClass:"iconfont icon-jiantouyou"})])])])]),_vm._v(" "),_c('div',{staticClass:"kol-customize-content-li",staticStyle:{"background":"#f8c6e4"}},[_c('div',{staticClass:"kol-customize-content-li-inner"},[_c('h3',[_vm._v("美容行业推广")]),_vm._v(" "),_c('p',[_vm._v("智能大数据精准锁定目标群体，定制营销方案实现转化；")]),_vm._v(" "),_c('div',{staticClass:"kol-icon-and-arrow"},[_c('i',{staticClass:"iconfont icon-jiejuefangan_shishangmeirongtuiguang"}),_vm._v(" "),_c('div',{staticClass:"kol-arrow",on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('i',{staticClass:"iconfont icon-jiantouyou"})])])])]),_vm._v(" "),_c('div',{staticClass:"kol-customize-content-li",staticStyle:{"background":"#cfeed4"}},[_c('div',{staticClass:"kol-customize-content-li-inner"},[_c('h3',[_vm._v("微商行业推广")]),_vm._v(" "),_c('p',[_vm._v("多渠道整合智能营销助力实现品效合一；")]),_vm._v(" "),_c('div',{staticClass:"kol-icon-and-arrow"},[_c('i',{staticClass:"iconfont icon-jiejuefangan_weishanghangyetuiguang"}),_vm._v(" "),_c('div',{staticClass:"kol-arrow",on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('i',{staticClass:"iconfont icon-jiantouyou"})])])])])]),_vm._v(" "),_c('a',{staticClass:"kol-look-more",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("查看更多行业解决方案")])]),_vm._v(" "),_c('div',{staticClass:"kol-kcb-partners"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"kol-kcb-partners-box"},[_c('div',{staticClass:"kol-kcb-partners-tab"},[_c('div',{staticClass:"kol-kcb-partners-tab-li",class:{'partner-actived':_vm.tabIndexPar==0},on:{"click":function($event){_vm.changePartnersTab(0)}}},[_vm._v("金融")]),_vm._v(" "),_c('div',{staticClass:"kol-kcb-partners-tab-li",class:{'partner-actived':_vm.tabIndexPar==1},on:{"click":function($event){_vm.changePartnersTab(1)}}},[_vm._v("互联网")]),_vm._v(" "),_c('div',{staticClass:"kol-kcb-partners-tab-li",class:{'partner-actived':_vm.tabIndexPar==2},on:{"click":function($event){_vm.changePartnersTab(2)}}},[_vm._v("科技")]),_vm._v(" "),_c('div',{staticClass:"kol-kcb-partners-tab-li",class:{'partner-actived':_vm.tabIndexPar==3},on:{"click":function($event){_vm.changePartnersTab(3)}}},[_vm._v("汽车")]),_vm._v(" "),_c('div',{staticClass:"kol-kcb-partners-tab-li",class:{'partner-actived':_vm.tabIndexPar==4},on:{"click":function($event){_vm.changePartnersTab(4)}}},[_vm._v("教育")]),_vm._v(" "),_c('div',{staticClass:"kol-kcb-partners-tab-li",class:{'partner-actived':_vm.tabIndexPar==5},on:{"click":function($event){_vm.changePartnersTab(5)}}},[_vm._v("时尚")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndexPar==0),expression:"tabIndexPar==0"}],staticClass:"kol-kcb-partners-content"},_vm._l((_vm.financeImgList),function(item,index){return _c('img',{key:index,staticClass:"kol-kcb-partners-content-li",attrs:{"src":item.imgSrc,"alt":""}})})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndexPar==1),expression:"tabIndexPar==1"}],staticClass:"kol-kcb-partners-content"},_vm._l((_vm.itImgList),function(item,index){return _c('img',{key:index,staticClass:"kol-kcb-partners-content-li",attrs:{"src":item.imgSrc,"alt":""}})})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndexPar==2),expression:"tabIndexPar==2"}],staticClass:"kol-kcb-partners-content"},_vm._l((_vm.technologyImgList),function(item,index){return _c('img',{key:index,staticClass:"kol-kcb-partners-content-li",attrs:{"src":item.imgSrc,"alt":""}})})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndexPar==3),expression:"tabIndexPar==3"}],staticClass:"kol-kcb-partners-content"},_vm._l((_vm.carImgList),function(item,index){return _c('img',{key:index,staticClass:"kol-kcb-partners-content-li",attrs:{"src":item.imgSrc,"alt":""}})})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndexPar==4),expression:"tabIndexPar==4"}],staticClass:"kol-kcb-partners-content"},_vm._l((_vm.educationImgList),function(item,index){return _c('img',{key:index,staticClass:"kol-kcb-partners-content-li",attrs:{"src":item.imgSrc,"alt":""}})})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabIndexPar==5),expression:"tabIndexPar==5"}],staticClass:"kol-kcb-partners-content"},_vm._l((_vm.fashioneImgList),function(item,index){return _c('img',{key:index,staticClass:"kol-kcb-partners-content-li",attrs:{"src":item.imgSrc,"alt":""}})}))])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==0},on:{"click":function($event){_vm.changeTab(0)}}},[_vm._v("互联网案例")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==1},on:{"click":function($event){_vm.changeTab(1)}}},[_vm._v("快消案例")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==2},on:{"click":function($event){_vm.changeTab(2)}}},[_vm._v("电商案例")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==3},on:{"click":function($event){_vm.changeTab(3)}}},[_vm._v("母婴案例")])]),_vm._v(" "),(_vm.tabIndex==0)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(12),_vm._v(" "),_vm._m(13)]):_vm._e(),_vm._v(" "),(_vm.tabIndex==1)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(14),_vm._v(" "),_vm._m(15)]):_vm._e(),_vm._v(" "),(_vm.tabIndex==2)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(16),_vm._v(" "),_vm._m(17)]):_vm._e(),_vm._v(" "),(_vm.tabIndex==3)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(18),_vm._v(" "),_vm._m(19)]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("马上注册，获取行业定制方案")])]),_vm._v(" "),_c('div',{staticClass:"kcb-unique",attrs:{"id":"register"}},[_vm._m(20),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-yonghu1",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel2.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel2, "mobile", $$v)},expression:"loginModel2.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"图形验证码","label-width":"200"},model:{value:(_vm.loginModel2.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel2, "captcha", $$v)},expression:"loginModel2.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码","label-width":"200"},model:{value:(_vm.loginModel2.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel2, "msgcode", $$v)},expression:"loginModel2.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha(2)}},slot:"right-full-height"},[_vm._v("\n                    "+_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login(2)}}},[_vm._v("一键获取媒体资源报价")])],1)])],1),_vm._v(" "),_c('landing-page-footer-kol'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_index_kol"}})],1)}
var newguestkol_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"wechat-flooing-title-first"},[_vm._v("50万+资源报价单等你拿")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kol-how-to-do"},[_c('div',{staticClass:"kol-common-title"},[_c('p',[_vm._v("成功的公司是"),_c('br'),_vm._v(" "),_c('span',[_vm._v("如何做KOL推广的？")])])]),_vm._v(" "),_c('div',{staticClass:"kol-how-to-do-li-first"},[_c('p',[_vm._v("推广方式一：付费投放KOL做软植入")])]),_vm._v(" "),_c('div',{staticClass:"kol-how-to-do-li-second"},[_c('p',[_vm._v("推广方式二：借助明星形象/周边")])]),_vm._v(" "),_c('div',{staticClass:"kol-how-to-do-li-third"},[_c('p',[_vm._v("推广方式三：寻找行业权威、达人")])]),_vm._v(" "),_c('div',{staticClass:"kol-how-to-do-li-fourth"},[_c('p',[_vm._v("推广方式四：利用公司的资源自产KOL")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kol-common-title"},[_c('p',[_vm._v("软盟"),_c('br'),_vm._v(" "),_c('span',[_vm._v("KOL推广")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kol-common-title"},[_c('p',[_vm._v("软盟平台"),_c('br'),_vm._v(" "),_c('span',[_vm._v("服务内容")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kol-service-content-li-left"},[_c('div',{staticClass:"kol-service-content-li-circle"},[_c('i',{staticClass:"iconfont icon-weixinicon"})]),_vm._v(" "),_c('div',{staticClass:"kol-service-content-li-text"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/kol_service_text_wechat.png","alt":""}}),_vm._v(" "),_c('p',[_c('span',[_vm._v("30万+")]),_vm._v("微信大号、自媒体")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kol-service-content-li-left"},[_c('div',{staticClass:"kol-service-content-li-circle"},[_c('i',{staticClass:"iconfont icon-duanshipinyingxiao"})]),_vm._v(" "),_c('div',{staticClass:"kol-service-content-li-text"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/kol_service_text_video.png","alt":""}}),_vm._v(" "),_c('p',[_c('span',[_vm._v("100万+")]),_vm._v(" 视频主资源")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kol-service-content-li-left"},[_c('div',{staticClass:"kol-service-content-li-circle"},[_c('i',{staticClass:"iconfont icon-wanghongzhibo"})]),_vm._v(" "),_c('div',{staticClass:"kol-service-content-li-text"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/kol_service_text_live.png","alt":""}}),_vm._v(" "),_c('p',[_c('span',[_vm._v("3万+")]),_vm._v("  人气网红主播")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kol-service-content-li-left"},[_c('div',{staticClass:"kol-service-content-li-circle"},[_c('i',{staticClass:"iconfont icon-weibo1"})]),_vm._v(" "),_c('div',{staticClass:"kol-service-content-li-text"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/kol_service_text_weibo.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("微博红人大号 覆盖4亿用户")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kol-service-content-li-left"},[_c('div',{staticClass:"kol-service-content-li-circle"},[_c('i',{staticClass:"iconfont icon-xiaohongshu"})]),_vm._v(" "),_c('div',{staticClass:"kol-service-content-li-text"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/kol_service_text_xhs.png","alt":""}}),_vm._v(" "),_c('p',[_c('span',[_vm._v("10万+")]),_vm._v("  线下最热门的“种草机”")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kol-common-title"},[_c('p',[_vm._v("软盟行业"),_c('br'),_vm._v(" "),_c('span',[_vm._v("定制服务")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kol-common-title"},[_c('p',[_vm._v("软盟品牌"),_c('br'),_vm._v(" "),_c('span',[_vm._v("合作伙伴")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kol-common-title"},[_c('p',[_vm._v("软盟品牌"),_c('br'),_vm._v(" "),_c('span',[_vm._v("推广案例")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_case_kol_logo1.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_kol_case_pic1.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("30W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点击量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("23W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("注册量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("8W+")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("信息流广告。利用用户类型相似的平台媒体，创作能吸引目标群关注的内容，进行推广导流，为B站吸纳更多用户。选择在腾讯广点通QQ空间投放，该媒体平台与哔哩哔哩的主要用户群体学生党非常吻合。 通过筛选B站创")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_case_kol_logo2.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_kol_case_pic2.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("8254+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点击量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("561.92W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("注册量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("9162")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("短视频营销+ KOL达人定制\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_case_kol_logo3.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_kol_case_pic3.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("1129")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点击量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("36.91W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("注册量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("906")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("专题策划+内容种草+热门tag"),_c('br'),_vm._v("短视频营销+ KOL达人。定制覆盖热门视频平台，筛选时尚购物类别的精准KOL达人，结合自身特点与平台热点，定制更便于传播品牌的推广内容，让内容影响用户行为，引发粉丝")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_case_kol_logo4.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_kol_case_pic4.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("6648")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点击量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("53.65W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("注册量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("4087")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("短视频营销+ KOL达人定制"),_c('br'),_vm._v("邀请儿童网红拍摄#美妈拉拉队#创意视频，并在短视频平台上发起趣味活动，邀请美妈和宝宝参与欢唱，并为参与用户送出品牌礼物，以此开发品牌新用户。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"wechat-flooing-title-first"},[_vm._v("50万+资源报价单等你拿")])])}]
var newguestkol_esExports = { render: newguestkol_render, staticRenderFns: newguestkol_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_newguestkol = (newguestkol_esExports);
// CONCATENATED MODULE: ./src/pages/newguestkol/index.vue
function newguestkol_injectStyle (ssrContext) {
  __webpack_require__("x39u")
  __webpack_require__("Gk1W")
}
var newguestkol_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var newguestkol___vue_template_functional__ = false
/* styles */
var newguestkol___vue_styles__ = newguestkol_injectStyle
/* scopeId */
var newguestkol___vue_scopeId__ = "data-v-2efad7a0"
/* moduleIdentifier (server only) */
var newguestkol___vue_module_identifier__ = null
var newguestkol_Component = newguestkol_normalizeComponent(
  pages_newguestkol,
  selectortype_template_index_0_src_pages_newguestkol,
  newguestkol___vue_template_functional__,
  newguestkol___vue_styles__,
  newguestkol___vue_scopeId__,
  newguestkol___vue_module_identifier__
)

/* harmony default export */ var src_pages_newguestkol = (newguestkol_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionWxzf/index.vue














/* harmony default export */ var promotionWxzf = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    IndexAdvantages: src_components_IndexAdvantages,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      resourceTabIndex1: '0',
      resourceFashion: [],
      resourceFood: [],
      resourceBeauty: [],
      resourceTypical: [{
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource01.png',
        resourceTitle: '免费纸巾机',
        resourceText: '扫码免费，领取纸巾'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource02.png',
        resourceTitle: '免费照片机',
        resourceText: '扫码免费，打印照片'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource03.png',
        resourceTitle: '移动支付',
        resourceText: '线下高频制作，无意识流量导入'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource04.png',
        resourceTitle: '免费纸巾机',
        resourceText: '扫码测体脂,9项数据让你更了解自己'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource05.png',
        resourceTitle: 'WIFI',
        resourceText: '选择商超、学校、医院、景区、连锁、车站等'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource06.png',
        resourceTitle: '粉丝池',
        resourceText: '根据公众号与用户使用习惯设定'
      }]
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },
    changeResourceTab1: function changeResourceTab1(index) {
      this.resourceTabIndex1 = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com//api/web_live', {}, {
        method: 'get'
      }).then(function (resp) {
        var transferData = JSON.parse(resp.data);
        if (transferData.success) {
          _this.resourceFashion = transferData.message.fashion;
          _this.resourceFood = transferData.message.mother;
          _this.resourceBeauty = transferData.message.beauty;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/promotionWxzf/index.vue














/* harmony default export */ var pages_promotionWxzf = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    IndexHeader: src_components_IndexHeader,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    IndexAdvantages: src_components_IndexAdvantages,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      resourceTabIndex1: '0',
      resourceFashion: [],
      resourceFood: [],
      resourceBeauty: [],
      resourceTypical: [{
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource01.png',
        resourceTitle: '免费纸巾机',
        resourceText: '扫码免费，领取纸巾'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource02.png',
        resourceTitle: '免费照片机',
        resourceText: '扫码免费，打印照片'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource03.png',
        resourceTitle: '移动支付',
        resourceText: '线下高频制作，无意识流量导入'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource04.png',
        resourceTitle: '免费纸巾机',
        resourceText: '扫码测体脂,9项数据让你更了解自己'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource05.png',
        resourceTitle: 'WIFI',
        resourceText: '选择商超、学校、医院、景区、连锁、车站等'
      }, {
        imgSrc: 'https://static.xinmeibao.com/assets_mobile/v3/wxzf/resource06.png',
        resourceTitle: '粉丝池',
        resourceText: '根据公众号与用户使用习惯设定'
      }]
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },
    changeResourceTab1: function changeResourceTab1(index) {
      this.resourceTabIndex1 = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com//api/web_live', {}, {
        method: 'get'
      }).then(function (resp) {
        var transferData = JSON.parse(resp.data);
        if (transferData.success) {
          _this.resourceFashion = transferData.message.fashion;
          _this.resourceFood = transferData.message.mother;
          _this.resourceBeauty = transferData.message.beauty;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35b78196","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/promotionWxzf/index.vue
var promotionWxzf_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('index-header',{attrs:{"utm-click":"register_zb_t"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"wechat-swiper"},[_c('swiper',{attrs:{"aspect-ratio":490/375,"dots-class":"custom-bottom-wxzf","dots-position":"center"}},[_c('swiper-item',{staticClass:"swiper-first-screen"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/wxzf_icon01.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text"},[_vm._v("多渠道整合  全方位覆盖")])]),_vm._v(" "),_c('div',{staticClass:"wechat-swiper-content"},[_c('div',{staticClass:"wxzf-firstp-li"},[_c('div',{staticClass:"wxzf-firstp-li-title-bg"}),_vm._v(" "),_c('div',{staticClass:"wxzf-firstp-li-title-text"},[_vm._v("自有校园媒介")]),_vm._v(" "),_c('p',[_vm._v("共享打印云机全国铺设签约学校400所，已进驻200所，机器铺设500台，覆盖全国学生用户达400万，线下合作智能终端设备高达5万＋台。")])]),_vm._v(" "),_c('div',{staticClass:"wxzf-firstp-li"},[_c('div',{staticClass:"wxzf-firstp-li-title-bg"}),_vm._v(" "),_c('div',{staticClass:"wxzf-firstp-li-title-text"},[_vm._v("校园渠道整合")]),_vm._v(" "),_c('p',[_vm._v("目前拥有全国1000所高校场地资源，上万个高校意见领袖，5万＋个合作学生社团，两万个校园传播渠道，对华中高校市场形成了全方位、立体化的覆盖。")])]),_vm._v(" "),_c('div',{staticClass:"wxzf-firstp-li"},[_c('div',{staticClass:"wxzf-firstp-li-title-bg"}),_vm._v(" "),_c('div',{staticClass:"wxzf-firstp-li-title-text"},[_vm._v("自媒体平台")]),_vm._v(" "),_c('p',[_vm._v("集采性价比最高的校园媒介，合作的掌上大学、微之家覆盖全国2000多所高校超过1万个自媒体平台，累积过亿粉丝群体资源，合作的子谦传媒，云校推等校园线下平面广告载体，合作各大校园APP，综合流量可达千万/天，全方位覆盖。")])]),_vm._v(" "),_c('div',{staticClass:"wxzf-firstp-li"},[_c('div',{staticClass:"wxzf-firstp-li-title-bg"}),_vm._v(" "),_c('div',{staticClass:"wxzf-firstp-li-title-text"},[_vm._v("社群")]),_vm._v(" "),_c('p',[_vm._v("拥有全国上万个各类兴趣爱好微信群、QQ群、能让信息快速直达高校学生。")])])])]),_vm._v(" "),_c('swiper-item',{staticClass:"swiper-first-screen"},[_c('div',{staticClass:"wechat-swiper-title"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/wxzf_icon01.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"wechat-swiper-title-text"},[_vm._v("我们的优势")])]),_vm._v(" "),_c('div',{staticClass:"wechat-swiper-content"},[_c('div',{staticClass:"wechat-second-content"},[_c('div',{staticClass:"wechat-second-content-li"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/wxzf_firstp_01.png","alt":""}}),_vm._v(" "),_c('h3',[_vm._v("专业团队")]),_vm._v(" "),_c('p',[_vm._v("一对一，定制服务"),_c('br'),_vm._v("\n                  专业团队为您分析产品")])]),_vm._v(" "),_c('div',{staticClass:"wechat-second-content-li"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/wxzf_firstp_02.png","alt":""}}),_vm._v(" "),_c('h3',[_vm._v("全网覆盖")]),_vm._v(" "),_c('p',[_vm._v("线上线下覆盖各个场景"),_c('br'),_vm._v("\n                  海量渠道资源"),_c('br'),_vm._v("\n                  综合流量可达上千万/天")])]),_vm._v(" "),_c('div',{staticClass:"wechat-second-content-li"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/wxzf_firstp_03.png","alt":""}}),_vm._v(" "),_c('h3',[_vm._v("稽核保障")]),_vm._v(" "),_c('p',[_vm._v("多重稽核机制"),_c('br'),_vm._v("\n                  严格验证，确保真实粉丝")])]),_vm._v(" "),_c('div',{staticClass:"wechat-second-content-li"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/wxzf_firstp_04.png","alt":""}}),_vm._v(" "),_c('h3',[_vm._v("低价获客")]),_vm._v(" "),_c('p',[_vm._v("成本是其他广告的10%-60%"),_c('br'),_vm._v("\n                  是传统地推成本的5—10%"),_c('br'),_vm._v("\n                  高性价比、低费效比")])])])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"xhs-resource"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"xhs-resource-content"},_vm._l((_vm.resourceTypical),function(item,index){return _c('div',{key:index,staticClass:"xhs-resource-li"},[_c('img',{staticClass:"xhs-resource-cover",attrs:{"src":item.imgSrc,"alt":""}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(item.resourceTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.resourceText))])])})),_vm._v(" "),_c('a',{staticClass:"xhs-sign",attrs:{"href":"/register"}},[_vm._v("免费注册，获取推广方案>>")])]),_vm._v(" "),_c('div',{staticClass:"xhs-resource"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab"},[_c('div',{staticClass:"xhs-resource-tab-inner"},[_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 0},on:{"click":function($event){_vm.changeResourceTab(0)}}},[_vm._v("按场景加粉\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 1},on:{"click":function($event){_vm.changeResourceTab(1)}}},[_vm._v("按性别加粉\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 2},on:{"click":function($event){_vm.changeResourceTab(2)}}},[_vm._v("按地区加粉\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex == 3},on:{"click":function($event){_vm.changeResourceTab(3)}}},[_vm._v("按终端加粉\n          ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 0),expression:"resourceTabIndex == 0"}],staticClass:"xhs-resource-content-customize"},[_vm._m(3),_vm._v(" "),_c('img',{staticClass:"xhs-resource-content-cover01",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/scene.png","alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 1),expression:"resourceTabIndex == 1"}],staticClass:"xhs-resource-content-customize"},[_vm._m(4),_vm._v(" "),_c('img',{staticClass:"xhs-resource-content-cover02",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/sex.png","alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 2),expression:"resourceTabIndex == 2"}],staticClass:"xhs-resource-content-customize"},[_vm._m(5),_vm._v(" "),_c('img',{staticClass:"xhs-resource-content-cover03",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/area.png","alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex == 3),expression:"resourceTabIndex == 3"}],staticClass:"xhs-resource-content-customize"},[_vm._m(6),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('div',{staticClass:"xhs-resource"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab"},[_c('div',{staticClass:"xhs-resource-tab-inner"},[_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex1 == 0},on:{"click":function($event){_vm.changeResourceTab1(0)}}},[_vm._v("微信公众号\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex1 == 1},on:{"click":function($event){_vm.changeResourceTab1(1)}}},[_vm._v("小程序\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex1 == 2},on:{"click":function($event){_vm.changeResourceTab1(2)}}},[_vm._v("APP下载注册\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex1 == 3},on:{"click":function($event){_vm.changeResourceTab1(3)}}},[_vm._v("粉丝交易\n          ")]),_vm._v(" "),_c('div',{staticClass:"xhs-resource-tab-li",class:{'xhs-resource-tab-li-checked':_vm.resourceTabIndex1 == 4},on:{"click":function($event){_vm.changeResourceTab1(4)}}},[_vm._v("互动广告\n          ")])])]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex1 == 0),expression:"resourceTabIndex1 == 0"}],staticClass:"service-progect-pic service-01",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/wechat.png","alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex1 == 1),expression:"resourceTabIndex1 == 1"}],staticClass:"service-progect-pic service-02",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/miniprogram.png","alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex1 == 2),expression:"resourceTabIndex1 == 2"}],staticClass:"service-progect-pic service-03",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/app.png","alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex1 == 3),expression:"resourceTabIndex1 == 3"}],staticClass:"service-progect-pic service-04",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/fanstrade.png","alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.resourceTabIndex1 == 4),expression:"resourceTabIndex1 == 4"}],staticClass:"service-progect-pic service-01",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/hdgg.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar wxzf-cooperation"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==0},on:{"click":function($event){_vm.changeTab(0)}}},[_vm._v("快消案例\n        ")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex1==1},on:{"click":function($event){_vm.changeTab(1)}}},[_vm._v("金融案例\n        ")])]),_vm._v(" "),_c('div',{staticClass:"wechat-line-width-100"}),_vm._v(" "),(_vm.tabIndex1==0)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(10),_vm._v(" "),_vm._m(11)]):_vm._e(),_vm._v(" "),(_vm.tabIndex1==1)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(12),_vm._v(" "),_vm._m(13)]):_vm._e()])]),_vm._v(" "),_c('index-advantages'),_vm._v(" "),_c('index-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_wxzf_r"}})],1)}
var promotionWxzf_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"promo-banner",attrs:{"href":"https://html.ecqun.com/kf/sdk/openwin.html?corpid=7160771&cstype=rand&mode=0&cskey=vSnqlUT6WltbRcGIda&scheme=0","target":"_blank"}},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/wxzf_banner.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("精选优质资源")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("精选定制专属粉丝")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs-resource-content-top"},[_c('div',{staticClass:"wxzf-line-12"}),_vm._v(" "),_c('p',[_vm._v("线下设备覆盖各个场景，包括学校、商场、酒店、机场、车站、医院、写字楼、KTV、旅游景点等人群活跃的地点。粉丝精准，活跃度高，质量较高。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs-resource-content-top"},[_c('div',{staticClass:"wxzf-line-12"}),_vm._v(" "),_c('p',[_vm._v("根据客户需求，有针对性地增加男性或女性粉丝。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs-resource-content-top"},[_c('div',{staticClass:"wxzf-line-12"}),_vm._v(" "),_c('p',[_vm._v("拥有线下共享终端10万＋台，覆盖超过300个城市，覆盖人群超1亿，根据客户需求，可选择省、城市加粉，满足您特定区域的需求。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs-resource-content-top"},[_c('div',{staticClass:"wxzf-line-12"}),_vm._v(" "),_c('p',[_vm._v("线下设备覆盖各个场景，包括学校、商场、酒店、机场、车站、医院、写字楼、KTV、旅游景点等人群活跃的地点。粉丝精准，活跃度高，质量较高。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs-resource-content-cover04"},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/android.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/iphone.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("服务项目")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-common-title"},[_c('h3',[_vm._v("合作案例")]),_vm._v(" "),_c('div',{staticClass:"underline-width-20"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content wxzf-cooperation-content"},[_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/wxzf_case_left01.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/wxzf_case_logo01.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("粉丝数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("50W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("时间")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("20天")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("大招一百通过校园及校园周边线下共享设备—共享纸巾机，实现精准高校粉的引流。\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content wxzf-cooperation-content sxs"},[_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/wxzf_case_left02.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v3/wxzf/wxzf_case_logo02.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("粉丝数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("100W")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("时间")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("45天")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("由于实习僧是专注于为广大学生用户提供优质的实习岗位的招聘垂直平台，故将场景主要选择为高校粉。通过校园及校园周边线下共享设备（免费WiFi、共享纸巾机、共享打印机、共享体重秤……）等，达到拉新的作用。\n          ")])])}]
var promotionWxzf_esExports = { render: promotionWxzf_render, staticRenderFns: promotionWxzf_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_promotionWxzf = (promotionWxzf_esExports);
// CONCATENATED MODULE: ./src/pages/promotionWxzf/index.vue
function promotionWxzf_injectStyle (ssrContext) {
  __webpack_require__("bLMB")
  __webpack_require__("iJmC")
}
var promotionWxzf_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var promotionWxzf___vue_template_functional__ = false
/* styles */
var promotionWxzf___vue_styles__ = promotionWxzf_injectStyle
/* scopeId */
var promotionWxzf___vue_scopeId__ = "data-v-35b78196"
/* moduleIdentifier (server only) */
var promotionWxzf___vue_module_identifier__ = null
var promotionWxzf_Component = promotionWxzf_normalizeComponent(
  pages_promotionWxzf,
  selectortype_template_index_0_src_pages_promotionWxzf,
  promotionWxzf___vue_template_functional__,
  promotionWxzf___vue_styles__,
  promotionWxzf___vue_scopeId__,
  promotionWxzf___vue_module_identifier__
)

/* harmony default export */ var src_pages_promotionWxzf = (promotionWxzf_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguestxhs3/index.vue




















/* harmony default export */ var newguestxhs3 = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LandingPageHeader: src_components_LandingPageHeader,
    LandingPageHeaderXhs: src_components_LandingPageHeaderXhs,
    LandingPageFooter: src_components_LandingPageFooter,
    LandingPageFooterXhs: src_components_LandingPageFooterXhs,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false,
      scrollTop: 0,
      tabIndex: 0,
      xhsImgList: ['https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_age.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_area.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_sex.png'],
      xhsImgList1: [{
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_200.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_100.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_50.png'
      }],
      xhsImgList1_index: 0,
      xhs1_swiper_index: 0,
      currentIndex: 0
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        _this4.$router.push('/media?tab=xhs');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    },
    goAnchor: function goAnchor(selector) {
      console.log(this.$parent.$parent.$refs.viewBox.scrollTo);
      var anchor = this.$el.querySelector(selector);

      this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100);
    },
    changeTab: function changeTab(index) {
      this.tabIndex = index;
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newguestxhs3/index.vue




















/* harmony default export */ var pages_newguestxhs3 = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LandingPageHeader: src_components_LandingPageHeader,
    LandingPageHeaderXhs: src_components_LandingPageHeaderXhs,
    LandingPageFooter: src_components_LandingPageFooter,
    LandingPageFooterXhs: src_components_LandingPageFooterXhs,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false,
      scrollTop: 0,
      tabIndex: 0,
      xhsImgList: ['https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_age.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_area.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_sex.png'],
      xhsImgList1: [{
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_200.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_100.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_50.png'
      }],
      xhsImgList1_index: 0,
      xhs1_swiper_index: 0,
      currentIndex: 0
    };
  },

  methods: {
    getCaptcha: function getCaptcha() {
      var _this2 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
        method: 'post'
      }).then(function (resp) {
        _this2.captchaImg = resp.data.data.src;
        _this2.loginModel.captcha_token = resp.data.data.captcha_token;
        _this2.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this3 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
          method: 'post'
        }).then(function (resp) {
          if (!resp.data.success) {
            _this3.getCaptcha();
          } else {
            _this3.smsCountDown();
          }
          _this3.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this4 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this4.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        _this4.$router.push('/media?tab=xhs');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this4.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this4.getCaptcha();
        _this4.loginModel.captcha = '';
        _this4.loginModel2.captcha = '';
      });
    },
    goAnchor: function goAnchor(selector) {
      console.log(this.$parent.$parent.$refs.viewBox.scrollTo);
      var anchor = this.$el.querySelector(selector);

      this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100);
    },
    changeTab: function changeTab(index) {
      this.tabIndex = index;
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a85337c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newguestxhs3/index.vue
var newguestxhs3_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('landing-page-header-x',{attrs:{"title":"小红书推广精准营销平台"}}),_vm._v(" "),_c('div',{staticClass:"wechat-flooing-banner"},[_c('a',{on:{"click":function($event){_vm.goAnchor('#register')}}},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhsldy_03_banner.png","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"kcb-unique"},[_vm._m(0),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-yonghu1",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel, "mobile", $$v)},expression:"loginModel.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"图形验证码","label-width":"200"},model:{value:(_vm.loginModel.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha", $$v)},expression:"loginModel.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码","label-width":"200"},model:{value:(_vm.loginModel.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel, "msgcode", $$v)},expression:"loginModel.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha()}},slot:"right-full-height"},[_vm._v("\n                    "+_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login()}}},[_vm._v("一键获取小红书折扣底价")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"xhs-outter"},[_c('div',{staticClass:"xhs-inner"},[_c('div',{staticClass:"new-guest-xhs3"},[_c('h3',[_vm._v("软盟深耕小红书推广")]),_vm._v(" "),_c('p',[_vm._v("免费量身定制推广笔记")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("立即推广 >>")])]),_vm._v(" "),_c('div',{staticClass:"xhs3-institute"},[_c('h3',[_vm._v("软盟小红书研究院")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs3_institute_pic.png","alt":""}}),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("查看资源报价 >>")])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"xhs3-variety-forms"},[_c('h3',[_vm._v("软盟定制玩法 形式多样")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs3_form.png","alt":""}}),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("马上注册，定制新玩法 >>")])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==0},on:{"click":function($event){_vm.changeTab(0)}}},[_vm._v("母婴案例")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==1},on:{"click":function($event){_vm.changeTab(1)}}},[_vm._v("生活案例")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{'new-guest-xhs1-tabbar-li-checked':_vm.tabIndex==2},on:{"click":function($event){_vm.changeTab(2)}}},[_vm._v("时尚案例")])]),_vm._v(" "),(_vm.tabIndex==0)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(8),_vm._v(" "),_vm._m(9)]):_vm._e(),_vm._v(" "),(_vm.tabIndex==1)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(10),_vm._v(" "),_vm._m(11)]):_vm._e(),_vm._v(" "),(_vm.tabIndex==2)?_c('div',{staticClass:"new-guest-xhs1-out"},[_vm._m(12),_vm._v(" "),_vm._m(13)]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("注册账号，立刻推广>>")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-fans-relaible"},[_c('h3',[_vm._v("海量高质资源")]),_vm._v(" "),_c('p',[_vm._v("红人号粉丝粘性高，真实可靠，人工筛选，绝无刷粉水号")]),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("选择资源立刻投放 >>")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-discount"},[_c('swiper',{attrs:{"aspect-ratio":1170/750,"dots-position":"center"}},[_c('swiper-item',[_c('h3',[_vm._v("红人号低至200元，选购10个另享9折优惠")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-discount-swiper-li"},[_c('div',{staticClass:"new-guest-xhs1-sale-box"},[_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_01.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_02.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_03.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_04.png"}})]),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign",attrs:{"target":"_blank"},on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("马上注册，抢购特价套餐")])])]),_vm._v(" "),_c('swiper-item',[_c('h3',[_vm._v("红人号选10送5")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-discount-swiper-li"},[_c('div',{staticClass:"new-guest-xhs1-sale-box"},[_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_05.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_06.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_07.png"}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-sale-li",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_sell_08.png"}})]),_vm._v(" "),_c('a',{staticClass:"new-guest-xhs1-sign",on:{"click":function($event){_vm.goAnchor('#register')}}},[_vm._v("马上注册，抢购特价套餐")])])])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"kcb-unique",attrs:{"id":"register"}},[_vm._m(15),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize"},[_c('div',{staticClass:"login-group-li"},[_c('i',{staticClass:"iconfont icon-yonghu1",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel2.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel2, "mobile", $$v)},expression:"loginModel2.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"图形验证码","label-width":"200"},model:{value:(_vm.loginModel2.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel2, "captcha", $$v)},expression:"loginModel2.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('i',{staticClass:"iconfont icon-yanzhengma",attrs:{"slot":"label"},slot:"label"}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码","label-width":"200"},model:{value:(_vm.loginModel2.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel2, "msgcode", $$v)},expression:"loginModel2.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha(2)}},slot:"right-full-height"},[_vm._v("\n                    "+_vm._s(_vm.smsCount==0?'获取验证码':_vm.smsCount)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login(2)}}},[_vm._v("一键获取小红书折扣底价")])],1)])],1),_vm._v(" "),_c('landing-page-footer-xhs'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_index_xhs1"}})],1)}
var newguestxhs3_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"wechat-flooing-title-first"},[_vm._v("小红书万粉号200元起")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs3-promotion-type"},[_c('div',{staticClass:"xhs3-promotion-type-li"},[_c('div',{staticClass:"xhs3-promotion-type-li-circle"},[_vm._v("100%")]),_vm._v(" "),_c('p',[_vm._v("推广笔记留存率")])]),_vm._v(" "),_c('div',{staticClass:"xhs3-promotion-type-li"},[_c('div',{staticClass:"xhs3-promotion-type-li-circle"},[_vm._v("超80%")]),_vm._v(" "),_c('p',[_vm._v("推广转化率")])]),_vm._v(" "),_c('div',{staticClass:"xhs3-promotion-type-li"},[_c('div',{staticClass:"xhs3-promotion-type-li-circle"},[_vm._v("10万+")]),_vm._v(" "),_c('p',[_vm._v("高质量小红书KOL")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("经数据研究表明，小红书1.5亿+用户中 ，"),_c('br'),_vm._v("\n              90后高消费力女性占比最高\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs3-brand-grass"},[_c('h3',[_vm._v("软盟助力打造品牌种草机")]),_vm._v(" "),_c('p',[_vm._v("种草= 细分圈层+“洗脑”文案+实效流量")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs3_grass.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs3-brand-grass"},[_c('h3',[_vm._v("软盟推广策略 执行把控有保障")]),_vm._v(" "),_c('p',[_vm._v("精选高质网红、编辑优质干货内容，为品牌打造“现象级刷屏”")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs3_strategy.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs3-brand-grass"},[_c('h3',[_vm._v("软盟品牌推广定制案例解析")]),_vm._v(" "),_c('p',[_vm._v("深挖产品卖点，洞察用户心理，结合使用场景定制推广")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs3_strategy_cover.png","alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs3_case_analyse.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xhs3-promo-advantage"},[_c('h3',[_vm._v("软盟小红书推广优势")]),_vm._v(" "),_c('div',{staticClass:"xhs3-promo-advantage-box"},[_c('div',{staticClass:"xhs3-promo-advantage-li"},[_c('div',{staticClass:"xhs3-promo-character"},[_c('i',{staticClass:"iconfont icon-baojiahunluanxunjialei"}),_vm._v(" "),_c('span',[_vm._v("报价")])]),_vm._v(" "),_c('div',{staticClass:"xhs3-promo-border"},[_c('div',{staticClass:"xhs3-promo-border-top"},[_c('p',[_vm._v("报价虚高"),_c('br'),_vm._v("隐形增收")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs3_wrong.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"xhs3-promo-border-top",staticStyle:{"border-bottom":"none"}},[_c('p',{staticStyle:{"color":"#ff2741"}},[_vm._v("软盟"),_c('br'),_vm._v("价格透明"),_c('br'),_vm._v("不赚差价")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs3_right.png","alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"xhs3-promo-advantage-li"},[_c('div',{staticClass:"xhs3-promo-character"},[_c('i',{staticClass:"iconfont icon-hailiangyouzhiziyuan"}),_vm._v(" "),_c('span',[_vm._v("资源")])]),_vm._v(" "),_c('div',{staticClass:"xhs3-promo-border"},[_c('div',{staticClass:"xhs3-promo-border-top"},[_c('p',[_vm._v("红人大号"),_c('br'),_vm._v("质量参差"),_c('br'),_vm._v("不齐")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs3_wrong.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"xhs3-promo-border-top",staticStyle:{"border-bottom":"none","padding-top":"0"}},[_c('p',{staticStyle:{"color":"#ff2741"}},[_vm._v("\n                    软盟"),_c('br'),_vm._v("\n                    人工筛选"),_c('br'),_vm._v("\n                    智能监测\n                  ")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs3_right.png","alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"xhs3-promo-advantage-li"},[_c('div',{staticClass:"xhs3-promo-character"},[_c('i',{staticClass:"iconfont icon-gaoxiaozhuanshufuwu"}),_vm._v(" "),_c('span',[_vm._v("服务")])]),_vm._v(" "),_c('div',{staticClass:"xhs3-promo-border"},[_c('div',{staticClass:"xhs3-promo-border-top"},[_c('p',[_vm._v("不含撰写"),_c('br'),_vm._v("留存率差")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs3_wrong.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"xhs3-promo-border-top",staticStyle:{"border-bottom":"none"}},[_c('p',{staticStyle:{"color":"#ff2741"}},[_vm._v("软盟"),_c('br'),_vm._v("专业撰写"),_c('br'),_vm._v("确保留存")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/xhs3_right.png","alt":""}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_vm._v("服务"),_c('span',[_vm._v("10000+ ")]),_vm._v("客户 推广笔记"),_c('span',[_vm._v("留存率")]),_vm._v("100%")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_logo1.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_pic1.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("200W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("6000+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("转发量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("4000+")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("专题策划+内容种草+热门tag投放"),_c('br'),_vm._v("15位小红书中部母婴类KOL，依托于更垂直的粉丝覆盖，将产品卖点更亲和的方式输出，辐射影响200万+用户，以痛点强化卖点，为粉丝种草产品。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_logo2.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_pic2.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("10W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("1000+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("转发量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("1000+")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("专题策划+内容种草+热门tag"),_c('br'),_vm._v(" 投放10位小红书尾部KOL试水，粉丝与话题合计辐射影响10万+用户，以切身体验影响核心受众，增加产品曝光量。\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-content"},[_c('img',{staticClass:"new-guest-xhs1-case-logo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_logo3.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"new-guest-xhs1-case-pic",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs1_case_pic3.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-xhs1-case-bot"},[_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("传播效果")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("曝光量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("50W+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("点赞数")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("10000+")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li"},[_c('div',{staticClass:"new-guest-xhs1-case-number-li-text"},[_vm._v("转发量")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-number-li-num"},[_vm._v("100000+")])])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-case-effect"},[_vm._v("案例亮点")]),_vm._v(" "),_c('p',{staticClass:"new-guest-xhs1-case-light"},[_vm._v("专题策划+内容种草+热门tag"),_c('br'),_vm._v("投放30位小红书达人，成功覆盖50万＋粉丝，短期内集中曝光大众对于产品的认知，扩大品牌知名度，强势种草转化销售")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-guest-fans-relaible-content"},[_c('div',{staticClass:"new-guest-fans-relaible-content-li"},[_c('div',{staticClass:"new-guest-fans-circle"},[_c('i',{staticClass:"iconfont icon-qianyuehongren"})]),_vm._v(" "),_c('h3',[_vm._v("98256+")]),_vm._v(" "),_c('p',[_vm._v("签约优质小红"),_c('br'),_vm._v("书红人")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-fans-relaible-content-li"},[_c('div',{staticClass:"new-guest-fans-circle"},[_c('i',{staticClass:"iconfont icon-xinmeitizhanghao"})]),_vm._v(" "),_c('h3',[_vm._v("794528+")]),_vm._v(" "),_c('p',[_vm._v("优质新媒体"),_c('br'),_vm._v("大号")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-fans-relaible-content-li"},[_c('div',{staticClass:"new-guest-fans-circle"},[_c('i',{staticClass:"iconfont icon-qianyuehongren"})]),_vm._v(" "),_c('h3',[_c('span',[_vm._v("覆盖行业")]),_vm._v("93+")]),_vm._v(" "),_c('p',[_vm._v("200+领域"),_c('br'),_vm._v("复投率86%以上")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"wechat-flooing-title-first"},[_vm._v("小红书万粉号200元起")])])}]
var newguestxhs3_esExports = { render: newguestxhs3_render, staticRenderFns: newguestxhs3_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_newguestxhs3 = (newguestxhs3_esExports);
// CONCATENATED MODULE: ./src/pages/newguestxhs3/index.vue
function newguestxhs3_injectStyle (ssrContext) {
  __webpack_require__("c/XZ")
  __webpack_require__("/4Cf")
}
var newguestxhs3_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var newguestxhs3___vue_template_functional__ = false
/* styles */
var newguestxhs3___vue_styles__ = newguestxhs3_injectStyle
/* scopeId */
var newguestxhs3___vue_scopeId__ = "data-v-a85337c0"
/* moduleIdentifier (server only) */
var newguestxhs3___vue_module_identifier__ = null
var newguestxhs3_Component = newguestxhs3_normalizeComponent(
  pages_newguestxhs3,
  selectortype_template_index_0_src_pages_newguestxhs3,
  newguestxhs3___vue_template_functional__,
  newguestxhs3___vue_styles__,
  newguestxhs3___vue_scopeId__,
  newguestxhs3___vue_module_identifier__
)

/* harmony default export */ var src_pages_newguestxhs3 = (newguestxhs3_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LivePageHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LivePageHeader = ({
  name: 'LivePageHeader',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_t'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loginStatus: {}
    };
  },

  methods: {
    // getUserInfo () {
    //   fetchUser().then(resp => {
    //     this.userInfo = resp.data
    //   })
    // }
  },
  mounted: function mounted() {
    this.loginStatus = !!getCookie('token');
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LivePageHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_LivePageHeader = ({
  name: 'LivePageHeader',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_t'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loginStatus: {}
    };
  },

  methods: {
    // getUserInfo () {
    //   fetchUser().then(resp => {
    //     this.userInfo = resp.data
    //   })
    // }
  },
  mounted: function mounted() {
    this.loginStatus = !!getCookie('token');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02624bde","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LivePageHeader.vue
var LivePageHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-header-container"},[_c('div',{staticClass:"index-header"},[_c('div',{staticClass:"index-header-inner"},[_c('a',{staticClass:"index-header-inner-left",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/logo@2x.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.title||'网红直播推广精准营销平台'))])]),_vm._v(" "),_c('p',{staticClass:"Sign_in"},[_vm._v("登录")]),_vm._v(" "),(!_vm.loginStatus)?_c('a',{staticClass:"index-header-inner-login",attrs:{"href":'/register?utm_click='+_vm.utmClick}},[_vm._v("注册")]):_vm._e()])])])}
var LivePageHeader_staticRenderFns = []
var LivePageHeader_esExports = { render: LivePageHeader_render, staticRenderFns: LivePageHeader_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_LivePageHeader = (LivePageHeader_esExports);
// CONCATENATED MODULE: ./src/components/LivePageHeader.vue
function LivePageHeader_injectStyle (ssrContext) {
  __webpack_require__("GoFI")
}
var LivePageHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LivePageHeader___vue_template_functional__ = false
/* styles */
var LivePageHeader___vue_styles__ = LivePageHeader_injectStyle
/* scopeId */
var LivePageHeader___vue_scopeId__ = "data-v-02624bde"
/* moduleIdentifier (server only) */
var LivePageHeader___vue_module_identifier__ = null
var LivePageHeader_Component = LivePageHeader_normalizeComponent(
  components_LivePageHeader,
  selectortype_template_index_0_src_components_LivePageHeader,
  LivePageHeader___vue_template_functional__,
  LivePageHeader___vue_styles__,
  LivePageHeader___vue_scopeId__,
  LivePageHeader___vue_module_identifier__
)

/* harmony default export */ var src_components_LivePageHeader = (LivePageHeader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LivePageFooter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LivePageFooter = ({
  name: 'landingPageFooterXhs',
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LivePageFooter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_LivePageFooter = ({
  name: 'landingPageFooterXhs',
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18967977","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LivePageFooter.vue
var LivePageFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-footer"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"index-footer-contact-ways"},[_c('h3',[_vm._v("400-858-1399")]),_vm._v(" "),_c('p',[_vm._v("免费咨询热线")]),_vm._v(" "),_c('div',{staticClass:"consult-qq"},[_c('div',{staticClass:"consult-icon-box icon-chat"},[_c('icon',{attrs:{"type":"svg","name":"qq"}})],1),_vm._v(" "),_c('span',[_vm._v("4008581399")])])])])}
var LivePageFooter_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-footer-left"},[_c('img',{staticClass:"index-footer-ercode",attrs:{"alt":"","src":"https://static.xinmeibao.com/assets/v3/images/footer_kcbewm.png"}}),_vm._v(" "),_c('img',{staticClass:"index-footer-ercode",attrs:{"alt":"","src":"https://static.xinmeibao.com/assets/v3/images/footer_kcbxcx.png"}})])}]
var LivePageFooter_esExports = { render: LivePageFooter_render, staticRenderFns: LivePageFooter_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_LivePageFooter = (LivePageFooter_esExports);
// CONCATENATED MODULE: ./src/components/LivePageFooter.vue
function LivePageFooter_injectStyle (ssrContext) {
  __webpack_require__("XdBe")
}
var LivePageFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LivePageFooter___vue_template_functional__ = false
/* styles */
var LivePageFooter___vue_styles__ = LivePageFooter_injectStyle
/* scopeId */
var LivePageFooter___vue_scopeId__ = "data-v-18967977"
/* moduleIdentifier (server only) */
var LivePageFooter___vue_module_identifier__ = null
var LivePageFooter_Component = LivePageFooter_normalizeComponent(
  components_LivePageFooter,
  selectortype_template_index_0_src_components_LivePageFooter,
  LivePageFooter___vue_template_functional__,
  LivePageFooter___vue_styles__,
  LivePageFooter___vue_scopeId__,
  LivePageFooter___vue_module_identifier__
)

/* harmony default export */ var src_components_LivePageFooter = (LivePageFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/live/index.vue





















/* harmony default export */ var live = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LivePageHeader: src_components_LivePageHeader,
    LandingPageHeader: src_components_LandingPageHeader,
    LandingPageHeaderXhs: src_components_LandingPageHeaderXhs,
    LandingPageFooter: src_components_LandingPageFooter,
    LivePageFooter: src_components_LivePageFooter,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: 0,
      tabIndex1: 0,
      tabIndex2: 0,
      resourceTabIndex: 0,
      resourceTravel: [],
      resourceMoney: [],
      resourceFood: [],
      resourceBeauty: [],
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false,
      scrollTop: 0,
      xhsImgList: ['https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_age.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_area.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_sex.png'],
      xhsImgList1: [{
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_200.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_100.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_50.png'
      }],
      xhsImgList1_index: 0,
      xhs1_swiper_index: 0,
      currentIndex: 0
    };
  },

  methods: {
    handleDoubleData: function handleDoubleData() {
      var _this2 = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com//api/web_weibo', {}, { method: 'get' }).then(function (resp) {
        var transferData = JSON.parse(resp.data);
        if (transferData.success) {
          _this2.resourceTravel = transferData.message.travel;
          _this2.resourceFood = transferData.message.food;
          _this2.resourceMoney = transferData.message.money;
          _this2.resourceBeauty = transferData.message.beauty;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getCaptcha: function getCaptcha() {
      var _this3 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, { method: 'post' }).then(function (resp) {
        _this3.captchaImg = resp.data.data.src;
        _this3.loginModel.captcha_token = resp.data.data.captcha_token;
        _this3.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this4 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, { method: 'post' }).then(function (resp) {
          if (!resp.data.success) {
            _this4.getCaptcha();
          } else {
            _this4.smsCountDown();
          }
          _this4.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this5 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this5.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        _this5.$router.push('/media?tab=xhs');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this5.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this5.getCaptcha();
        _this5.loginModel.captcha = '';
        _this5.loginModel2.captcha = '';
      });
    },
    goAnchor: function goAnchor(selector) {
      console.log(this.$parent.$parent.$refs.viewBox.scrollTo);
      var anchor = this.$el.querySelector(selector);

      this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100);
    },
    changeTab: function changeTab(index) {
      this.tabIndex = index;
    },
    change_resourceTabIndex: function change_resourceTabIndex(index) {
      this.tabIndex1 = index;
    },
    change_caseTab: function change_caseTab(index) {
      this.tabIndex2 = index;
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/live/index.vue





















/* harmony default export */ var pages_live = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    LivePageHeader: src_components_LivePageHeader,
    LandingPageHeader: src_components_LandingPageHeader,
    LandingPageHeaderXhs: src_components_LandingPageHeaderXhs,
    LandingPageFooter: src_components_LandingPageFooter,
    LivePageFooter: src_components_LivePageFooter,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    XInput: vux_src_components_x_input,
    Group: vux_src_components_group,
    Toast: components_toast["a" /* default */],
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: 0,
      tabIndex1: 0,
      tabIndex2: 0,
      resourceTabIndex: 0,
      resourceTravel: [],
      resourceMoney: [],
      resourceFood: [],
      resourceBeauty: [],
      loginModel: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      loginModel2: {
        mobile: '',
        password: '',
        identity: 'advertiser',
        captcha: '',
        msgcode: '',
        captcha_token: '',
        device: 'wap'
      },
      getTextCode: '获取验证码',
      captchaImg: '/static/images/vcode.jpg',
      smsCount: 0,
      smsDisable: false,
      scrollTop: 0,
      xhsImgList: ['https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_age.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_area.png', 'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_sex.png'],
      xhsImgList1: [{
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_200.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_100.png'
      }, {
        img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_50.png'
      }],
      xhsImgList1_index: 0,
      xhs1_swiper_index: 0,
      currentIndex: 0
    };
  },

  methods: {
    handleDoubleData: function handleDoubleData() {
      var _this2 = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com//api/web_weibo', {}, { method: 'get' }).then(function (resp) {
        var transferData = JSON.parse(resp.data);
        if (transferData.success) {
          _this2.resourceTravel = transferData.message.travel;
          _this2.resourceFood = transferData.message.food;
          _this2.resourceMoney = transferData.message.money;
          _this2.resourceBeauty = transferData.message.beauty;
        }
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getCaptcha: function getCaptcha() {
      var _this3 = this;

      var fly = new fly_default.a();
      fly.config.withCredentials = true;
      fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, { method: 'post' }).then(function (resp) {
        _this3.captchaImg = resp.data.data.src;
        _this3.loginModel.captcha_token = resp.data.data.captcha_token;
        _this3.loginModel2.captcha_token = resp.data.data.captcha_token;
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    getTextCaptcha: function getTextCaptcha(type) {
      var _this4 = this;

      if (!this.smsDisable) {
        if (type === 2) {
          if (!this.loginModel2.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel2.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        } else {
          if (!this.loginModel.captcha) {
            this.$vux.toast.show({
              text: '请输入正确的验证码',
              time: 1000
            });
            this.getCaptcha();
            return false;
          } else if (!this.loginModel.mobile) {
            this.$vux.toast.show({
              text: '请输入手机号',
              time: 1000
            });
            return false;
          }
        }

        var textCaptchaModel = type === 2 ? {
          captcha: this.loginModel2.captcha,
          captcha_token: this.loginModel2.captcha_token,
          mobile: this.loginModel2.mobile,
          scope: 'mobile_signup'
        } : {
          captcha: this.loginModel.captcha,
          captcha_token: this.loginModel.captcha_token,
          mobile: this.loginModel.mobile,
          scope: 'mobile_signup'
        };
        var fly = new fly_default.a();
        fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, { method: 'post' }).then(function (resp) {
          if (!resp.data.success) {
            _this4.getCaptcha();
          } else {
            _this4.smsCountDown();
          }
          _this4.$vux.toast.show({
            text: resp.data.message,
            time: 1000
          });
        }).catch(function (e) {
          return console.log('获取短信验证码失败', e);
        });
      }
    },
    smsCountDown: function smsCountDown() {
      var _this = this;
      _this.smsCount = 60;
      _this.smsDisable = true;
      var interval = window.setInterval(function () {
        --_this.smsCount;
        if (_this.smsCount === 0) {
          _this.smsDisable = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    login: function login(type) {
      var _this5 = this;

      var password = Math.random().toString().substr(2).slice(0, 6);

      var registerModel = type === 2 ? {
        mobile: this.loginModel2.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel2.captcha,
        captcha_token: this.loginModel2.captcha_token,
        captcha_sms: this.loginModel2.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      } : {
        mobile: this.loginModel.mobile,
        password: password,
        identity: 'advertiser',
        captcha: this.loginModel.captcha,
        captcha_token: this.loginModel.captcha_token,
        captcha_sms: this.loginModel.msgcode,
        scope: 'mobile_signup',
        device: 'wap'
      };
      authRegister(registerModel).then(function (res) {
        _this5.$vux.toast.show({
          text: res.message,
          time: 1000
        });
        _this5.$router.push('/media?tab=xhs');
      }).catch(function (e) {
        console.log('注册失败', e);
        _this5.$vux.toast.show({
          text: e.message,
          type: 'cancel',
          time: 2000
        });
        _this5.getCaptcha();
        _this5.loginModel.captcha = '';
        _this5.loginModel2.captcha = '';
      });
    },
    goAnchor: function goAnchor(selector) {
      console.log(this.$parent.$parent.$refs.viewBox.scrollTo);
      var anchor = this.$el.querySelector(selector);

      this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100);
    },
    changeTab: function changeTab(index) {
      this.tabIndex = index;
    },
    change_resourceTabIndex: function change_resourceTabIndex(index) {
      this.tabIndex1 = index;
    },
    change_caseTab: function change_caseTab(index) {
      this.tabIndex2 = index;
    }
  },
  mounted: function mounted() {
    this.getCaptcha();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7d89a10","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/live/index.vue
var live_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('live-page-header',{attrs:{"utm-click":"register_index_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kcb-unique"},[_vm._m(1),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize"},[_c('div',{staticClass:"login-group-li"},[_c('img',{staticClass:"icon_phone",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/live/手机图标@2x.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel, "mobile", $$v)},expression:"loginModel.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('img',{staticClass:"icon_number",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/live/图形码@2x.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"图形验证码","label-width":"200"},model:{value:(_vm.loginModel.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel, "captcha", $$v)},expression:"loginModel.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('img',{staticClass:"icon_identifying",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/live/验证码图标@2.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码","label-width":"200"},model:{value:(_vm.loginModel.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel, "msgcode", $$v)},expression:"loginModel.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha()}},slot:"right-full-height"},[_vm._v("\n            "+_vm._s(_vm.smsCount == 0 ? "获取验证码" : _vm.smsCount)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login()}}},[_vm._v("  一键获取网红直播折扣低价  ")])],1)])],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{ 'new-guest-xhs1-tabbar-li-checked': _vm.tabIndex == 0 },on:{"click":function($event){_vm.changeTab(0)}}},[_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{ 'new-guest-xhs1-tabbar-li-checked': _vm.tabIndex == 1 },on:{"click":function($event){_vm.changeTab(1)}}},[_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{ 'new-guest-xhs1-tabbar-li-checked': _vm.tabIndex == 2 },on:{"click":function($event){_vm.changeTab(2)}}},[_c('p',[_vm._v("母婴")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{ 'new-guest-xhs1-tabbar-li-checked': _vm.tabIndex == 3 },on:{"click":function($event){_vm.changeTab(3)}}},[_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li",class:{ 'new-guest-xhs1-tabbar-li-checked': _vm.tabIndex == 4 },on:{"click":function($event){_vm.changeTab(4)}}},[_vm._m(6)])]),_vm._v(" "),_c('div',{staticClass:"introduction_plate"},[(_vm.tabIndex == 0)?_c('div',{staticClass:"introduction_plate_content"},[_c('div',{staticClass:"introduction_plate_character"}),_vm._v(" "),_vm._m(7)]):_vm._e(),_vm._v(" "),(_vm.tabIndex == 1)?_c('div',{staticClass:"introduction_plate_content"},[_c('div',{staticClass:"introduction_plate_character_one"}),_vm._v(" "),_vm._m(8)]):_vm._e(),_vm._v(" "),(_vm.tabIndex == 2)?_c('div',{staticClass:"introduction_plate_content"},[_c('div',{staticClass:"introduction_plate_character_two"}),_vm._v(" "),_vm._m(9)]):_vm._e(),_vm._v(" "),(_vm.tabIndex == 3)?_c('div',{staticClass:"introduction_plate_content"},[_c('div',{staticClass:"introduction_plate_character_three"}),_vm._v(" "),_vm._m(10)]):_vm._e(),_vm._v(" "),(_vm.tabIndex == 4)?_c('div',{staticClass:"introduction_plate_content"},[_c('div',{staticClass:"introduction_plate_character_four"}),_vm._v(" "),_vm._m(11)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"subtitle_two"},[_vm._v("多种直播形式匹配 定制化玩法")]),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('a',{staticClass:"immediately_btn",attrs:{"href":"#register_top"}},[_vm._v("\n      马上注册 定制新玩法 →\n")]),_vm._v(" "),_c('div',{staticClass:"subtitle_two"},[_vm._v("网红直播一体化服务 为品牌营销赋能")]),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('img',{staticClass:"big_photo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/live/形状828拷贝 2@2x.png","alt":""}}),_vm._v(" "),_c('a',{staticClass:"immediately_btn",attrs:{"href":"#register_top"}},[_vm._v("\n      马上注册 查看资源报价 →\n")]),_vm._v(" "),_c('div',{staticClass:"subtitle_two"},[_vm._v("网红直播 种草案例精选")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar_live"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li_live",class:{ 'new-guest-xhs1-tabbar-li-checked': _vm.tabIndex1 == 0 },on:{"click":function($event){_vm.change_resourceTabIndex(0)}}},[_c('p',[_vm._v("快消案例")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li_live",class:{ 'new-guest-xhs1-tabbar-li-checked': _vm.tabIndex1 == 1 },on:{"click":function($event){_vm.change_resourceTabIndex(1)}}},[_c('p',[_vm._v("金融案例")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li_live",class:{ 'new-guest-xhs1-tabbar-li-checked': _vm.tabIndex1 == 2 },on:{"click":function($event){_vm.change_resourceTabIndex(2)}}},[_c('p',[_vm._v("餐饮案例")])]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li_live",class:{ 'new-guest-xhs1-tabbar-li-checked': _vm.tabIndex1 == 3 },on:{"click":function($event){_vm.change_resourceTabIndex(3)}}},[_c('p',[_vm._v("数码案例")])])]),_vm._v(" "),(_vm.tabIndex1 == 0)?_c('div',{staticClass:"advertising_map_content"},[_c('div',{staticClass:"advertising_map_logo"}),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('div',{staticClass:"advertising_map_introduce"},[_vm._v("\n        网红直播\n        线下打造【果粒梦工厂】活动，邀请多位网红达人参与，并通过直播平台分享美汁源果粒橙活动现场，让没有参加现场的观众也有看\n      ")])]):_vm._e(),_vm._v(" "),(_vm.tabIndex1 == 1)?_c('div',{staticClass:"advertising_map_content"},[_c('div',{staticClass:"advertising_map_logo_two"}),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_c('div',{staticClass:"advertising_map_introduce"},[_vm._v("\n      事件营销×微信营销→→→品牌塑造——价值提升——创造声量——高新人才储备 金融+AI领域数据探索者挑战赛，创造趣味热点，激发探\n      ")])]):_vm._e(),_vm._v(" "),(_vm.tabIndex1 == 2)?_c('div',{staticClass:"advertising_map_content"},[_c('div',{staticClass:"advertising_map_logo_three"}),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_c('div',{staticClass:"advertising_map_introduce"},[_vm._v("\n      网红直播 邀请高人气的网红亲临活动现场，参与“大暑派对”，并直播活动盛况，影响受众，扩散活动，加强麦当劳与“大薯日”的关联性。\n      ")])]):_vm._e(),_vm._v(" "),(_vm.tabIndex1 == 3)?_c('div',{staticClass:"advertising_map_content"},[_c('div',{staticClass:"advertising_map_logo_four"}),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30),_vm._v(" "),_vm._m(31),_vm._v(" "),_vm._m(32),_vm._v(" "),_c('div',{staticClass:"advertising_map_introduce"},[_vm._v("\n       网红直播 针对微软的品牌特点和Surface目标人群分析，邀请了多位不同技能的颜艺达人现场直播解说，利用主播粉丝群的热度，传播\n      ")])]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/live/","alt":""}}),_vm._v(" "),_c('div',{staticClass:"subtitle_two"},[_vm._v("数据驱动业绩增长 专业网红影响力价值分析")]),_vm._v(" "),_c('div',{staticClass:"shadow_title"},[_vm._v("\n      为您提供智能数据化服务 优化营销活动\n\n    ")]),_vm._v(" "),_c('div',{staticClass:"data_insight"}),_vm._v(" "),_c('div',{staticClass:"subtitle_two"},[_vm._v("软盟优势")]),_vm._v(" "),_vm._m(33),_vm._v(" "),_c('div',{staticClass:"subtitle_two"},[_vm._v("软盟精选网红直播套餐")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar_meal"},[_c('div',{staticClass:"new-guest-xhs1-tabbar-li_meal",class:{ 'new-guest-xhs1-tabbar-li_meal-checked': _vm.tabIndex2 == 0 },on:{"click":function($event){_vm.change_caseTab(0)}}},[_c('p',[_vm._v("淘宝直播套餐")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar_line"})]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li_meal",class:{ 'new-guest-xhs1-tabbar-li_meal-checked': _vm.tabIndex2 == 1 },on:{"click":function($event){_vm.change_caseTab(1)}}},[_c('p',[_vm._v("一直播套餐")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar_line"})]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar-li_meal",class:{ 'new-guest-xhs1-tabbar-li_meal-checked': _vm.tabIndex2 == 2 },on:{"click":function($event){_vm.change_caseTab(2)}}},[_c('p',[_vm._v("多平台直播套餐")]),_vm._v(" "),_c('div',{staticClass:"new-guest-xhs1-tabbar_line"})])]),_vm._v(" "),(_vm.tabIndex2 == 0)?_c('div',{staticClass:"new-guest-xhs1-tabbar_meal_out"},[_c('div',{staticClass:"new-guest-xhs1-tabbar_meal_photo_one"}),_vm._v(" "),_c('div',{staticClass:"shout_title_one"},[_vm._v("网红数量：8个")]),_vm._v(" "),_c('div',{staticClass:"shout_content_one"},[_vm._v("根据客户需求，挑选匹配的网红进行直播")]),_vm._v(" "),_c('div',{staticClass:"shout_title_two"},[_vm._v("直播时长：1小时")]),_vm._v(" "),_c('div',{staticClass:"shout_content_two"},[_vm._v("直播时长：1小时")]),_vm._v(" "),_c('div',{staticClass:"shout_title_three"},[_vm._v("产品露出：3个")]),_vm._v(" "),_c('div',{staticClass:"shout_content_three"},[_vm._v("\n        主播讲解产品不超过3个，宝贝数量可以提供10个链接\n      ")]),_vm._v(" "),_c('div',{staticClass:"shout_title_four"},[_vm._v("特殊要求：4选1")]),_vm._v(" "),_vm._m(34)]):_vm._e(),_vm._v(" "),(_vm.tabIndex2 == 1)?_c('div',{staticClass:"new-guest-xhs1-tabbar_meal_out"},[_c('div',{staticClass:"new-guest-xhs1-tabbar_meal_photo_two"}),_vm._v(" "),_c('div',{staticClass:"shout_title_two"},[_vm._v("网红数量：15个")]),_vm._v(" "),_c('div',{staticClass:"shout_content_two"},[_vm._v("根据客户需求，挑选匹配的网红进行直播")]),_vm._v(" "),_c('div',{staticClass:"shout_title_two"},[_vm._v("直播时长：1小时")]),_vm._v(" "),_c('div',{staticClass:"shout_content_two"},[_vm._v("直播时长：1小时")]),_vm._v(" "),_c('div',{staticClass:"shout_title_two"},[_vm._v("特殊要求：4选3")]),_vm._v(" "),_c('div',{staticClass:"shout_content_two"},[_vm._v("\n        主播与粉丝互动，增加抽奖环节（客户提供奖品）\n        主播特殊造型（客户提供正规服装） 主播提前20分钟预热 直播图文信息淘宝发\n      ")])]):_vm._e(),_vm._v(" "),(_vm.tabIndex2 == 2)?_c('div',{staticClass:"new-guest-xhs1-tabbar_meal_out"},[_c('div',{staticClass:"new-guest-xhs1-tabbar_meal_photo_three"}),_vm._v(" "),_c('div',{staticClass:"shout_title_three_type"},[_vm._v("网红数量：25个")]),_vm._v(" "),_c('div',{staticClass:"shout_content_three_type"},[_vm._v("\n        根据客户需求，挑选匹配的网红进行直播 （15个淘宝网红、13个一直播网红）\n      ")]),_vm._v(" "),_c('div',{staticClass:"shout_title_three_type"},[_vm._v("直播时长：1小时")]),_vm._v(" "),_c('div',{staticClass:"shout_content_three"},[_vm._v("直播时长：1小时")]),_vm._v(" "),_c('div',{staticClass:"shout_title_three"},[_vm._v("产品露出：1个")]),_vm._v(" "),_c('div',{staticClass:"shout_content_three"},[_vm._v("\n        淘宝专场2小时、一直播品牌植入\n      ")]),_vm._v(" "),_c('div',{staticClass:"shout_title_four_type"},[_vm._v("特殊要求：全配合")]),_vm._v(" "),_c('div',{staticClass:"shout_content_four_type"},[_vm._v("\n        根据客户需求全全配合\n      ")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"immediately_btn",attrs:{"href":"#register_bottom"}},[_vm._v("\n一键注册 查看网红报价表 →\n")]),_vm._v(" "),_c('div',{staticClass:"subtitle_two"},[_vm._v("广告投放流程")]),_vm._v(" "),_c('div',{staticClass:"advertising_map"}),_vm._v(" "),_c('div',{staticClass:"kcb-unique",attrs:{"id":"register_bottom"}},[_vm._m(35),_vm._v(" "),_c('group',{staticClass:"kcb-free-login-box free-customize"},[_c('div',{staticClass:"login-group-li"},[_c('img',{staticClass:"icon_phone",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/live/手机图标@2x.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"max":11,"placeholder":"请输入手机号","required":""},model:{value:(_vm.loginModel2.mobile),callback:function ($$v) {_vm.$set(_vm.loginModel2, "mobile", $$v)},expression:"loginModel2.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('img',{staticClass:"icon_phone",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/live/图形码@2x.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"图形验证码","label-width":"200"},model:{value:(_vm.loginModel2.captcha),callback:function ($$v) {_vm.$set(_vm.loginModel2, "captcha", $$v)},expression:"loginModel2.captcha"}})],1),_vm._v(" "),_c('img',{staticClass:"login-group-input-pic",attrs:{"slot":"right-full-height","src":_vm.captchaImg},on:{"click":function($event){_vm.getCaptcha()}},slot:"right-full-height"})]),_vm._v(" "),_c('div',{staticClass:"login-group-li"},[_c('div',{staticClass:"login-group-li-left"},[_c('img',{staticClass:"icon_phone",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/live/验证码图标@2.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"line-v"}),_vm._v(" "),_c('x-input',{staticClass:"login-group-input",attrs:{"placeholder":"请输入短信验证码","label-width":"200"},model:{value:(_vm.loginModel2.msgcode),callback:function ($$v) {_vm.$set(_vm.loginModel2, "msgcode", $$v)},expression:"loginModel2.msgcode"}})],1),_vm._v(" "),_c('div',{staticClass:"login-group-input-msg-code",attrs:{"slot":"right-full-height"},on:{"click":function($event){_vm.getTextCaptcha(2)}},slot:"right-full-height"},[_vm._v("\n            "+_vm._s(_vm.smsCount == 0 ? "获取验证码" : _vm.smsCount)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"login-button-outter"},[_c('x-button',{staticClass:"login-button",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.login(2)}}},[_vm._v("一键获取网红直播折扣低价")])],1)])],1),_vm._v(" "),_c('live-page-footer'),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_index_xhs1"}})],1)}
var live_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-flooing-banner"},[_c('a',{attrs:{"id":"register_top"}},[_c('img',{attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/4543543.png","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"wechat-flooing-title-first"},[_vm._v("25000+网红主播等你来约")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kcb_extension"},[_c('div',{staticClass:"extension_title"},[_vm._v("\n        汇聚一手网红资源   为品牌完成精准转化\n      ")]),_vm._v(" "),_c('div',{staticClass:"shadow_rectangle"},[_c('div',{staticClass:"shadow_title"},[_vm._v("\n        免费量身定制推广方案\n      ")])]),_vm._v(" "),_c('div',{staticClass:"introduction_diagram_"},[_c('div',{staticClass:"introduction_diagram_one"},[_c('p',[_vm._v("\n                 "),_c('span',[_vm._v("95%")]),_vm._v("主流资源"),_c('br'),_c('span',[_vm._v("90%")]),_vm._v("重要KOL资源 "),_c('br'),_vm._v("\n                   全网覆盖\n          ")])]),_vm._v(" "),_c('div',{staticClass:"introduction_diagram_two"},[_c('p',[_vm._v("\n                   "),_c('span',[_vm._v(" 100万+")]),_vm._v(" "),_c('br'),_vm._v("优质新媒体大号资源\n          ")]),_vm._v(" "),_c('img',{attrs:{"src":"","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"introduction_diagram_three"},[_c('p',[_vm._v("\n                    专家量身定制推广方案\n            "),_c('br'),_vm._v("\n            覆盖"),_c('span',[_vm._v(" 200+")]),_vm._v(" 行业"),_c('span',[_vm._v(" 500+")]),_vm._v(" 领域 "),_c('br'),_vm._v("\n                           多维度自由投放\n          ")])])]),_vm._v(" "),_c('a',{staticClass:"immediately_btn",attrs:{"href":"#register_top"}},[_vm._v("\n    马上推广 →\n")]),_vm._v(" "),_c('div',{staticClass:"subtitle_one"},[_vm._v("合作网红2万+ 覆盖粉丝10亿")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("女神"),_c('br'),_vm._v("萌妹")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("男神"),_c('br'),_vm._v("鲜肉")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          美妆"),_c('br'),_vm._v("\n          护肤\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("搞笑"),_c('br'),_vm._v("娱乐")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction_plate_character_fans"},[_c('div',[_c('a',{staticClass:"introduction_zero_btn",attrs:{"href":"#register_top"}},[_vm._v("查看报价 ")]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_data"}),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_video"},[_c('video',{attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/%E4%BB%A3%E5%8F%A4%E6%8B%89k.mp4","controls":"controls"}})]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend"},[_c('div',{staticClass:"introduction_plate_character_recommend_title"},[_vm._v("\n                相似推荐\n              ")]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend_ul"},[_c('img',{staticClass:"character_photo",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/live/陈子蜜.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"character_name"},[_vm._v("陈子密")]),_vm._v(" "),_c('div',{staticClass:"character_fans"},[_vm._v("452万+粉丝数")]),_vm._v(" "),_c('a',{staticClass:"character_btn",attrs:{"href":"#register_top"}},[_vm._v("查看报价")])]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend_ul"},[_c('img',{staticClass:"character_photo_one",attrs:{"src":"https://static.xinmeibao.com/assets_mobile/live/脸脸WANG.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"character_name_one"},[_vm._v("脸脸WANG")]),_vm._v(" "),_c('div',{staticClass:"character_fans_one"},[_vm._v("122万+粉丝数")]),_vm._v(" "),_c('a',{staticClass:"character_btn_one",attrs:{"href":"#register_top"}},[_vm._v("查看报价")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction_plate_character_fans_one"},[_c('div',[_c('a',{staticClass:"introduction_one_btn",attrs:{"href":"#register_top"}},[_vm._v("查看报价 ")]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_data"}),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_video"},[_c('video',{attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/%E4%B8%83%E8%88%85%E8%84%91%E7%88%B7.mp4","controls":"controls"}})]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend"},[_c('div',{staticClass:"introduction_plate_character_recommend_title"},[_vm._v("\n                相似推荐\n              ")]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend_ul"},[_c('img',{staticClass:"character_photo",attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/%E7%8E%8B%E8%B5%9EZzzz.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"character_name"},[_vm._v("王赞Zzzz")]),_vm._v(" "),_c('div',{staticClass:"character_fans"},[_vm._v("290万+粉丝数")]),_vm._v(" "),_c('a',{staticClass:"character_btn",attrs:{"href":"#register_top"}},[_vm._v("查看报价")])]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend_ul"},[_c('img',{staticClass:"character_photo_one",attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/%E5%8F%81%E6%9C%A8%E5%A4%A7%E4%BA%BA.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"character_name_one"},[_vm._v("叁木大人")]),_vm._v(" "),_c('div',{staticClass:"character_fans_one"},[_vm._v("170万+粉丝数")]),_vm._v(" "),_c('a',{staticClass:"character_btn_one",attrs:{"href":"#register_top"}},[_vm._v("查看报价")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction_plate_character_fans_two"},[_c('div',[_c('a',{staticClass:"introduction_two_btn",attrs:{"href":"#register_top"}},[_vm._v("查看报价 ")]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_data_two"}),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_video"},[_c('video',{attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/%E8%8B%A5%E7%86%99_%E5%A6%88%E5%92%AA.mp4","controls":"controls"}})]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend"},[_c('div',{staticClass:"introduction_plate_character_recommend_title"},[_vm._v("\n                相似推荐\n              ")]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend_ul"},[_c('img',{staticClass:"character_photo",attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/%E5%B0%8F%E7%B2%BE%E8%B1%86%E5%AD%90%E8%BE%A3%E5%A6%88.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"character_name"},[_vm._v("小精豆子辣妈")]),_vm._v(" "),_c('div',{staticClass:"character_fans"},[_vm._v("284万+粉丝数")]),_vm._v(" "),_c('a',{staticClass:"character_btn",attrs:{"href":"#register_top"}},[_vm._v("查看报价")])]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend_ul"},[_c('img',{staticClass:"character_photo_one",attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/%E5%86%B0%E5%87%8C%E8%8A%B1%E8%AF%AD.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"character_name_one"},[_vm._v("冰凌花语")]),_vm._v(" "),_c('div',{staticClass:"character_fans_one"},[_vm._v("187万+粉丝数")]),_vm._v(" "),_c('a',{staticClass:"character_btn_one",attrs:{"href":"#register_top"}},[_vm._v("查看报价")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction_plate_character_fans_three"},[_c('div',[_c('a',{staticClass:"introduction_three_btn",attrs:{"href":"#register_top"}},[_vm._v("查看报价 ")]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_data_three"}),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_video"},[_c('video',{attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/%E5%BC%A0%E5%87%AF%E6%AF%85KEVIN.mp4","controls":"controls"}})]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend"},[_c('div',{staticClass:"introduction_plate_character_recommend_title"},[_vm._v("\n                相似推荐\n              ")]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend_ul"},[_c('img',{staticClass:"character_photo",attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/%E8%AE%A4%E7%9C%9F%E5%B0%91%E5%A5%B3_%E9%A2%9C%E4%B9%9D.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"character_name_yan"},[_vm._v("认真少女_颜九")]),_vm._v(" "),_c('div',{staticClass:"character_fans"},[_vm._v("434万+粉丝数")]),_vm._v(" "),_c('a',{staticClass:"character_btn",attrs:{"href":"#register_top"}},[_vm._v("查看报价")])]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend_ul"},[_c('img',{staticClass:"character_photo_one",attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/%E9%81%93%E4%B8%8A%E9%83%BD%E5%8F%AB%E6%88%91%E8%B5%A4%E6%9C%A8%E5%88%9A%E5%AE%AA.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"character_name_one_dao"},[_vm._v("道上都叫我赤木刚宪")]),_vm._v(" "),_c('div',{staticClass:"character_fans_one"},[_vm._v("323万+粉丝数")]),_vm._v(" "),_c('a',{staticClass:"character_btn_one",attrs:{"href":"#register_top"}},[_vm._v("查看报价")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction_plate_character_fans_four"},[_c('div',[_c('a',{staticClass:"introduction_four_btn",attrs:{"href":"#register_top"}},[_vm._v("查看报价 ")]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_data_four"}),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_video"},[_c('video',{attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/%E5%8A%9E%E5%85%AC%E5%AE%A4%E5%B0%8F%E9%87%8E.mp4","controls":"controls"}})]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend"},[_c('div',{staticClass:"introduction_plate_character_recommend_title"},[_vm._v("\n                相似推荐\n              ")]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend_ul"},[_c('img',{staticClass:"character_photo",attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/%E5%B0%AC%E6%BC%94%E4%B8%83%E6%AE%B5.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"character_name"},[_vm._v("尬演七段")]),_vm._v(" "),_c('div',{staticClass:"character_fans"},[_vm._v("1081万+粉丝数")]),_vm._v(" "),_c('a',{staticClass:"character_btn",attrs:{"href":"#register_top"}},[_vm._v("查看报价")])]),_vm._v(" "),_c('div',{staticClass:"introduction_plate_character_recommend_ul"},[_c('img',{staticClass:"character_photo_one",attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/%E5%A3%AE%E5%A3%AB%E9%AB%98%E5%AF%92.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"character_name_one"},[_vm._v("壮士高寒")]),_vm._v(" "),_c('div',{staticClass:"character_fans_one"},[_vm._v("106万+粉丝数")]),_vm._v(" "),_c('a',{staticClass:"character_btn_one",attrs:{"href":"#register_top"}},[_vm._v("查看报价")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow_rectangle"},[_c('div',{staticClass:"shadow_title"},[_vm._v("\n       多年深耕 专注提供优质服务\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle_one_bg"},[_c('div',{staticClass:"circle_one"},[_c('p',[_vm._v("直播 "),_c('br'),_vm._v("+"),_c('br'),_vm._v("内容营销")])]),_vm._v(" "),_c('div',{staticClass:"circle_one_content"},[_vm._v("\n    主播以品牌推广和产品宣传为目 的，在直播中亲身试用产品或参 与体验。因此可分为：产品体验/ 新品发布。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle_one_bg"},[_c('div',{staticClass:"circle_two"},[_c('p',[_vm._v("直播 "),_c('br'),_vm._v("+"),_c('br'),_vm._v("互动营销")])]),_vm._v(" "),_c('div',{staticClass:"circle_one_content"},[_vm._v("\n        在直播中需要用户参与互动的环 节加入营销，起到信息的双向交 流传播作用，加深用户对品牌的 印象。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle_one_bg"},[_c('div',{staticClass:"circle_three_online"},[_c('p',[_vm._v("直播 "),_c('br'),_vm._v("+"),_c('br'),_vm._v("电商")])]),_vm._v(" "),_c('div',{staticClass:"circle_one_content"},[_vm._v("\n电商平台展示商品或采购现场进 行直播，让用户对于所售的产品 有更加直观、全方位的了解。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow_rectangle"},[_c('div',{staticClass:"shadow_title"},[_vm._v("\n     聚合场景+渠道+数据\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_big"},[_c('div',{staticClass:"advertising_map_medium"},[_c('div',{staticClass:"advertising_map_small"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_line_one"},[_c('div',{staticClass:"advertising_map_title_one"},[_vm._v("传播效果")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_flow"},[_c('div',{staticClass:"advertising_map_flow_one"},[_c('div',{staticClass:"advertising_map_flow_one_title"},[_vm._v("粉丝数")]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_one_fans_sale"},[_vm._v("924.92W")])]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_two"},[_c('div',{staticClass:"advertising_map_flow_two_title"},[_vm._v("互动量")]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_two_fans"},[_vm._v("8.32W")])]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_three"},[_c('div',{staticClass:"advertising_map_flow_three_title"},[_vm._v("观看量")]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_three_fans"},[_vm._v("37.59W")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_line_two"},[_c('div',{staticClass:"advertising_map_title_two"},[_vm._v("案例亮点")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_big"},[_c('div',{staticClass:"advertising_map_medium"},[_c('div',{staticClass:"advertising_map_small_two"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_line_one"},[_c('div',{staticClass:"advertising_map_title_one"},[_vm._v("传播效果")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_flow"},[_c('div',{staticClass:"advertising_map_flow_one"},[_c('div',{staticClass:"advertising_map_flow_one_title"},[_vm._v("粉丝数")]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_one_fans"},[_vm._v("23.75W")])]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_two"},[_c('div',{staticClass:"advertising_map_flow_two_title"},[_vm._v("互动量")]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_two_fans"},[_vm._v("8.26W")])]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_three"},[_c('div',{staticClass:"advertising_map_flow_three_title"},[_vm._v("观看量")]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_three_fans_finance"},[_vm._v("2.38W")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_line_two"},[_c('div',{staticClass:"advertising_map_title_two"},[_vm._v("案例亮点")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_big"},[_c('div',{staticClass:"advertising_map_medium"},[_c('div',{staticClass:"advertising_map_small_three"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_line_one"},[_c('div',{staticClass:"advertising_map_title_one"},[_vm._v("传播效果")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_flow"},[_c('div',{staticClass:"advertising_map_flow_one"},[_c('div',{staticClass:"advertising_map_flow_one_title"},[_vm._v("粉丝数")]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_one_fans_food"},[_vm._v("103.95W")])]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_two"},[_c('div',{staticClass:"advertising_map_flow_two_title"},[_vm._v("互动量")]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_two_fans_food"},[_vm._v("58.42W")])]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_three"},[_c('div',{staticClass:"advertising_map_flow_three_title"},[_vm._v("观看量")]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_three_fans"},[_vm._v("27.65W")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_line_two"},[_c('div',{staticClass:"advertising_map_title_two"},[_vm._v("案例亮点")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_big"},[_c('div',{staticClass:"advertising_map_medium"},[_c('div',{staticClass:"advertising_map_small_four"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_line_one"},[_c('div',{staticClass:"advertising_map_title_one"},[_vm._v("传播效果")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_flow"},[_c('div',{staticClass:"advertising_map_flow_one"},[_c('div',{staticClass:"advertising_map_flow_one_title"},[_vm._v("粉丝数")]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_one_fans_electronics"},[_vm._v("389.42W")])]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_two"},[_c('div',{staticClass:"advertising_map_flow_two_title"},[_vm._v("互动量")]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_two_fans_electronics"},[_vm._v("84.62W")])]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_three"},[_c('div',{staticClass:"advertising_map_flow_three_title"},[_vm._v("观看量")]),_vm._v(" "),_c('div',{staticClass:"advertising_map_flow_three_fans"},[_vm._v("29.44W")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertising_map_line_two"},[_c('div',{staticClass:"advertising_map_title_two"},[_vm._v("案例亮点")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kcb_advantage_photo_big"},[_c('img',{staticClass:"kcb_advantage_photo",attrs:{"src":"http://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/live/45435421.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shout_content_four"},[_vm._v("\n        主播与粉丝互动，增加抽奖环节（客户提供奖品）"),_c('br'),_vm._v("\n        主播特殊造型（客户提供正规服装）"),_c('br'),_vm._v("\n        主播提前20分钟预热"),_c('br'),_vm._v("\n        直播图文信息淘宝发布\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"wechat-flooing-title"},[_c('div',{staticClass:"wechat-flooing-title-first"},[_vm._v("25000+网红主播等你来约")])])}]
var live_esExports = { render: live_render, staticRenderFns: live_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_live = (live_esExports);
// CONCATENATED MODULE: ./src/pages/live/index.vue
function live_injectStyle (ssrContext) {
  __webpack_require__("+hrM")
  __webpack_require__("MA8l")
}
var live_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var live___vue_template_functional__ = false
/* styles */
var live___vue_styles__ = live_injectStyle
/* scopeId */
var live___vue_scopeId__ = "data-v-b7d89a10"
/* moduleIdentifier (server only) */
var live___vue_module_identifier__ = null
var live_Component = live_normalizeComponent(
  pages_live,
  selectortype_template_index_0_src_pages_live,
  live___vue_template_functional__,
  live___vue_styles__,
  live___vue_scopeId__,
  live___vue_module_identifier__
)

/* harmony default export */ var src_pages_live = (live_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NewMediumHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NewMediumHeader = ({
  name: 'IndexHeader',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_t'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loginStatus: {}
    };
  },

  methods: {
    // getUserInfo () {
    //   fetchUser().then(resp => {
    //     this.userInfo = resp.data
    //   })
    // }
  },
  mounted: function mounted() {
    this.loginStatus = !!getCookie('token');
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NewMediumHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_NewMediumHeader = ({
  name: 'IndexHeader',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_t'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loginStatus: {}
    };
  },

  methods: {
    // getUserInfo () {
    //   fetchUser().then(resp => {
    //     this.userInfo = resp.data
    //   })
    // }
  },
  mounted: function mounted() {
    this.loginStatus = !!getCookie('token');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af2c02a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewMediumHeader.vue
var NewMediumHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-header-container"},[_c('div',{staticClass:"index-header"},[_c('div',{staticClass:"index-header-inner"},[_c('a',{staticClass:"index-header-inner-left",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/v1/logo@2x.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"index-header-line"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.title||'新媒体精准营销平台'))])]),_vm._v(" "),(!_vm.loginStatus)?_c('a',{staticClass:"index-header-inner-login",attrs:{"href":'/register?utm_click='+_vm.utmClick}},[_vm._v("注册")]):_vm._e()])])])}
var NewMediumHeader_staticRenderFns = []
var NewMediumHeader_esExports = { render: NewMediumHeader_render, staticRenderFns: NewMediumHeader_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_NewMediumHeader = (NewMediumHeader_esExports);
// CONCATENATED MODULE: ./src/components/NewMediumHeader.vue
function NewMediumHeader_injectStyle (ssrContext) {
  __webpack_require__("aGne")
}
var NewMediumHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NewMediumHeader___vue_template_functional__ = false
/* styles */
var NewMediumHeader___vue_styles__ = NewMediumHeader_injectStyle
/* scopeId */
var NewMediumHeader___vue_scopeId__ = "data-v-1af2c02a"
/* moduleIdentifier (server only) */
var NewMediumHeader___vue_module_identifier__ = null
var NewMediumHeader_Component = NewMediumHeader_normalizeComponent(
  components_NewMediumHeader,
  selectortype_template_index_0_src_components_NewMediumHeader,
  NewMediumHeader___vue_template_functional__,
  NewMediumHeader___vue_styles__,
  NewMediumHeader___vue_scopeId__,
  NewMediumHeader___vue_module_identifier__
)

/* harmony default export */ var src_components_NewMediumHeader = (NewMediumHeader_Component.exports);

// CONCATENATED MODULE: ./src/components/NewMediumFooter.vue
function NewMediumFooter_injectStyle (ssrContext) {
  __webpack_require__("Sb8w")
}
var NewMediumFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var NewMediumFooter___vue_template_functional__ = false
/* styles */
var NewMediumFooter___vue_styles__ = NewMediumFooter_injectStyle
/* scopeId */
var NewMediumFooter___vue_scopeId__ = "data-v-605630f2"
/* moduleIdentifier (server only) */
var NewMediumFooter___vue_module_identifier__ = null
var NewMediumFooter_Component = NewMediumFooter_normalizeComponent(
  __vue_script__,
  __vue_template__,
  NewMediumFooter___vue_template_functional__,
  NewMediumFooter___vue_styles__,
  NewMediumFooter___vue_scopeId__,
  NewMediumFooter___vue_module_identifier__
)


/* harmony default export */ var NewMediumFooter = (NewMediumFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newmedium/index.vue















/* harmony default export */ var newmedium = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    NewMediumHeader: src_components_NewMediumHeader,
    NewMediumFooter: NewMediumFooter,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    IndexAdvantages: src_components_IndexAdvantages,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      resourceFashion: [],
      resourceFood: [],
      resourceBeauty: []
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com//api/web_video', {}, {
        method: 'get'
      }).then(function (resp) {
        console.log(resp, 1212);
        var transferData = JSON.parse(resp.data);
        console.log(transferData, 666);
        if (transferData.success) {
          _this.resourceFashion = transferData.message.fashion;
          _this.resourceFood = transferData.message.food;
          _this.resourceBeauty = transferData.message.beauty;
        }
        console.log(transferData, 666);
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newmedium/index.vue















/* harmony default export */ var pages_newmedium = ({
  components: {
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    Flexbox: flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    NewMediumHeader: src_components_NewMediumHeader,
    NewMediumFooter: NewMediumFooter,
    IndexSidebar: src_components_IndexSidebar,
    IndexFooter: src_components_IndexFooter,
    IndexAdvantages: src_components_IndexAdvantages,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      resourceFashion: [],
      resourceFood: [],
      resourceBeauty: []
    };
  },

  methods: {
    changeTabContent: function changeTabContent(index) {
      this.tabIndex = index;
    },
    changeResourceTab: function changeResourceTab(index) {
      this.resourceTabIndex = index;
    },
    handleDoubleData: function handleDoubleData() {
      var _this = this;

      var fly = new fly_default.a();

      fly.request('https://www.xinmeibao.com//api/web_video', {}, {
        method: 'get'
      }).then(function (resp) {
        console.log(resp, 1212);
        var transferData = JSON.parse(resp.data);
        console.log(transferData, 666);
        if (transferData.success) {
          _this.resourceFashion = transferData.message.fashion;
          _this.resourceFood = transferData.message.food;
          _this.resourceBeauty = transferData.message.beauty;
        }
        console.log(transferData, 666);
      }).catch(function (e) {
        return console.log('error', e);
      });
    },
    changeTab: function changeTab(index) {
      this.tabIndex1 = index;
    }
  },
  filters: {
    formatNumInTenThousand: function formatNumInTenThousand(value) {
      var num = parseInt(value);
      var num2 = num / 10000;
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万';
      } else {
        return num;
      }
    }
  },
  mounted: function mounted() {
    this.handleDoubleData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-731f71c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newmedium/index.vue
var newmedium_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('new-medium-header',{attrs:{"utm-click":"register_index_t"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('index-sidebar',{attrs:{"utm-click":"register_video_r"}})],1)}
var newmedium_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('a',{staticClass:"promo-banner",attrs:{"href":"https://html.ecqun.com/kf/sdk/openwin.html?corpid=7160771&cstype=rand&mode=0&cskey=vSnqlUT6WltbRcGIda&scheme=0","target":"_blank"}},[_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/banner.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"container_title"},[_vm._v("传统媒体"),_c('span',{staticStyle:{"color":"#FF622BFF"}},[_c('span',{staticStyle:{"font-size":"5vw"}},[_vm._v("PK")]),_vm._v("新媒体")])]),_vm._v(" "),_c('div',{staticClass:"container_title-bm"},[_vm._v("生活的方方面面无处不在")]),_vm._v(" "),_c('a',{staticClass:"title-btn",attrs:{"href":"https://html.ecqun.com/kf/sdk/openwin.html?corpid=7160771&cstype=rand&mode=0&cskey=vSnqlUT6WltbRcGIda&scheme=0"}},[_vm._v("立即体验>>")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"big-title",staticStyle:{"margin-top":"171px"}},[_vm._v("什么是传统媒体")]),_vm._v(" "),_c('div',{staticClass:"title_line"},[_c('div',{staticClass:"title_line-s"})]),_vm._v(" "),_c('div',{staticClass:"title-en"},[_vm._v("WHAT IS TRADITIONAL MEDIA")]),_vm._v(" "),_c('div',{staticClass:"media_content"},[_vm._v("\n       传统媒体即通过某种机械装置定期向社会公众发布信息或提供教育娱乐的交流活的媒体;包括电视、报刊、广播等传统媒体。通常我们又把它们称为“平面媒体”。\n    ")]),_vm._v(" "),_c('div',{staticClass:"media_icon_content"},[_c('div',{staticClass:"media_icon_content-main"},[_c('img',{staticStyle:{"display":"block","margin-left":"15px","width":"100%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/video1.png\n","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"2.4vw","display":"block","margin-left":"42%"},attrs:{"span":""}},[_vm._v("广播")]),_vm._v(" "),_c('div',{staticStyle:{"width":"6vw","height":"0.4vw","background":"rgba(222,222,222,1)","margin-left":"38%","margin-top":"5px"}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1.4vw","display":"block","margin-left":"46%","color":"rgba(102,102,102,1)"}},[_vm._v("RADIO")])]),_vm._v(" "),_c('div',{staticClass:"media_icon_content-main",staticStyle:{"position":"absolute","top":"17vw"}},[_c('img',{staticStyle:{"display":"block","margin-left":"15px","width":"100%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/video1.png\n","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"2.4vw","display":"block","margin-left":"42%"},attrs:{"span":""}},[_vm._v("报刊")]),_vm._v(" "),_c('div',{staticStyle:{"width":"6vw","height":"0.4vw","background":"rgba(222,222,222,1)","margin-left":"38%","margin-top":"5px"}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1.4vw","display":"block","margin-left":"47%","color":"rgba(102,102,102,1)"}},[_vm._v("PRESS")])]),_vm._v(" "),_c('div',{staticClass:"media_icon_content-main",staticStyle:{"position":"absolute","left":"17vw","top":"0"}},[_c('img',{staticStyle:{"display":"block","margin-left":"15px","width":"100%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/video1.png\n","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"2.4vw","display":"block","margin-left":"42%"},attrs:{"span":""}},[_vm._v("户外")]),_vm._v(" "),_c('div',{staticStyle:{"width":"6vw","height":"0.4vw","background":"rgba(222,222,222,1)","margin-left":"38%","margin-top":"5px"}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1.4vw","display":"block","margin-left":"28%","color":"rgba(102,102,102,1)"}},[_vm._v("OUTDOORS")])]),_vm._v(" "),_c('div',{staticClass:"media_icon_content-main",staticStyle:{"position":"absolute","top":"17vw","left":"17vw"}},[_c('img',{staticStyle:{"display":"block","margin-left":"15px","width":"100%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/video1.png\n","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"2.4vw","display":"block","margin-left":"42%"},attrs:{"span":""}},[_vm._v("电视")]),_vm._v(" "),_c('div',{staticStyle:{"width":"6vw","height":"0.4vw","background":"rgba(222,222,222,1)","margin-left":"38%","margin-top":"5px"}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1.4vw","display":"block","margin-left":"28%","color":"rgba(102,102,102,1)"}},[_vm._v("TELEVISION")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-2"},[_c('div',{staticClass:"big-title"},[_vm._v("什么是"),_c('span',{staticStyle:{"color":"#FF622BFF"}},[_vm._v("新媒体")])]),_vm._v(" "),_c('div',{staticClass:"title_line"},[_c('div',{staticClass:"title_line-s"})]),_vm._v(" "),_c('div',{staticClass:"title-en"},[_vm._v("WHAT IS NEW MEDIA")]),_vm._v(" "),_c('div',{staticClass:"media_content-2"},[_vm._v("\n新媒体，是以手机、电脑、平板等为视听终端的、手机上网为平台的个性化信息传播载体;"),_c('br'),_vm._v("\n它是以分众为传播目标，以定向为传播效果，以互动为传播效果，以互动为传播应用的大众传播媒介。"),_c('br'),_vm._v("\n人们利用碎片化时间阅读短内容，如每天的"),_c('span',{staticStyle:{"color":"#FF622BFF"}},[_vm._v(" 刷微博、上抖音、QQ聊天，在今日头条")]),_vm._v("了解资讯等;"),_c('br'),_vm._v("新媒体早已渗透到生活的方方面面无处不在。\n\n "),_c('div',{staticStyle:{"position":"relative","font-size":"2.8vw"}},[_c('img',{staticStyle:{"width":"93%","margin-top":"9%","margin-left":"1%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/\n\npttb.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"99%","left":"15%"}},[_vm._v("微信")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"74%","left":"5%"}},[_vm._v("微博")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"47%","left":"10%"}},[_vm._v("小红书")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"30%","left":"29%"}},[_vm._v("抖音")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"26%","left":"50%"}},[_vm._v("信息流")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"37%","left":"69%"}},[_vm._v("淘宝直播")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"61%","left":"83%"}},[_vm._v("一直播")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"88%","left":"82%"}},[_vm._v("快手")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-3",staticStyle:{"margin-top":"27px"}},[_c('div',{staticClass:"big-title"},[_vm._v("传统媒体与"),_c('span',{staticStyle:{"color":"#FF622BFF"}},[_vm._v("新媒体")]),_vm._v("对比")]),_vm._v(" "),_c('div',{staticClass:"title_line"},[_c('div',{staticClass:"title_line-s"})]),_vm._v(" "),_c('div',{staticClass:"title-en"},[_vm._v("TRADITIONAL MEDIA AND NEW MEDIA")]),_vm._v(" "),_c('div',{staticClass:"media_content-3"},[_vm._v("\n传统媒体劣势：时效性短、信息传递慢、接受被动"),_c('br'),_vm._v("\n新媒体优势：交互性与及时性、海量性与共享性、多媒体与超文本\n")]),_vm._v(" "),_c('div',{staticClass:"media-procedure"},[_c('div',{staticClass:"media-g"},[_c('span',{staticStyle:{"margin-left":"35%"}},[_vm._v("传统媒体")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/bz.png","alt":""}})]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"5%","left":"45%"}},[_vm._v(" 信息源")]),_vm._v(" "),_c('img',{staticStyle:{"position":"absolute","top":"19%","left":"49%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/箭头1.png","alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"position":"absolute","top":"59%","left":"49%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/箭头1.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"45%","left":"47%"}},[_vm._v(" 媒介")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"85%","left":"47%"}},[_vm._v(" 受众")]),_vm._v(" "),_c('div',{staticClass:"media-g"},[_c('span',{staticStyle:{"margin-left":"20%"}},[_vm._v("有限信息采集")]),_vm._v(" "),_c('img',{attrs:{"src":"https://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/assets_mobile/newmedium/dqxh.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"media-g"},[_c('span',{staticStyle:{"margin-left":"35%"}},[_vm._v("单向传播")]),_vm._v(" "),_c('img',{attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/fxb.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"media-w"},[_c('img',{staticStyle:{"width":"32%","margin-top":"0%","margin-left":"8%"},attrs:{"src":"https://kuaichuanbo.oss-cn-hangzhou.aliyuncs.com/newmedium/xmt.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"color":"rgba(255,98,43,1)","font-size":"2.8vw","margin-left":"7%"}},[_vm._v("新媒体")])]),_vm._v(" "),_c('div',{staticClass:"media-w",staticStyle:{"top":"41%"}},[_c('img',{staticStyle:{"width":"32%","margin-top":"0%","margin-left":"8%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/cjxx.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"color":"rgba(255,98,43,1)","font-size":"2.8vw","margin-left":"0%"}},[_vm._v("全方位信息采集")])]),_vm._v(" "),_c('div',{staticClass:"media-w",staticStyle:{"top":"78%"}},[_c('img',{staticStyle:{"width":"32%","margin-top":"0%","margin-left":"8%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/ssjh.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"color":"rgba(255,98,43,1)","font-size":"2.8vw","margin-left":"3%"}},[_vm._v("准确实时交互")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-4"},[_c('div',{staticClass:"big-title",staticStyle:{"margin-top":"10%"}},[_vm._v("2015~2018年占比数据")]),_vm._v(" "),_c('div',{staticClass:"title_line"},[_c('div',{staticClass:"title_line-s"})]),_vm._v(" "),_c('div',{staticClass:"title-en"},[_vm._v("PERCENTAGE DATA FOR 2015-2018")]),_vm._v(" "),_c('div',{staticClass:"form_data"},[_c('div',{staticClass:"form_data_item",staticStyle:{"padding-right":".7vw"}},[_c('img',{staticStyle:{"display":"inline-block","width":"5.5vw","vertical-align":"middle"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/xmt_icon.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v("新媒体")])]),_vm._v(" "),_c('div',{staticClass:"form_data_item"},[_c('img',{staticStyle:{"display":"inline-block","width":"5.5vw","vertical-align":"middle"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/ds_icon.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v("电视")])]),_vm._v(" "),_c('div',{staticClass:"form_data_item"},[_c('img',{staticStyle:{"display":"inline-block","width":"5.5vw","vertical-align":"middle"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/bk_icon.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v("报刊")])]),_vm._v(" "),_c('div',{staticClass:"form_data_item"},[_c('img',{staticStyle:{"display":"inline-block","width":"5.5vw","vertical-align":"middle"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/hw_icon.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v("户外")])]),_vm._v(" "),_c('div',{staticClass:"form_data_item",staticStyle:{"padding-right":"0vw"}},[_c('img',{staticStyle:{"display":"inline-block","width":"5.5vw","vertical-align":"middle"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/qt_icon.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v("其他")])])]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"81%","left":"11%"}},[_vm._v("2015")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"81%","left":"34%"}},[_vm._v("2016")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"81%","left":"57%"}},[_vm._v("2017")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"81%","left":"79%"}},[_vm._v("2018")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-5"},[_c('div',{staticClass:"big-title",staticStyle:{"margin-top":"0%"}},[_vm._v("传统媒体PK"),_c('span',{staticStyle:{"color":"#FF622BFF"}},[_vm._v("新媒体")]),_vm._v("综合评分")]),_vm._v(" "),_c('div',{staticClass:"title_line"},[_c('div',{staticClass:"title_line-s"})]),_vm._v(" "),_c('div',{staticClass:"title-en"},[_vm._v("TRADITIONAL MEDIA PK NEW MEDIA")]),_vm._v(" "),_c('div',{staticClass:"media_content-3"},[_vm._v("\n新媒体正逐渐取代传统媒体，成为未来媒体传播发展的主力军！\n")]),_vm._v(" "),_c('div',{staticClass:"media_text",staticStyle:{"float":"left","margin-left":"13%","color":"rgba(102,102,102,1)","font-size":"3vw","margin-top":"5%"}},[_vm._v("\n  传统媒体综合评分:4分\n")]),_vm._v(" "),_c('div',{staticClass:"media_com",staticStyle:{"color":"#FF622BFF","float":"right","margin-right":"10%","font-size":"3vw","margin-top":"5%"}},[_vm._v("\n  新媒体综合评分:9分\n")]),_vm._v(" "),_c('img',{staticStyle:{"width":"50%","margin-top":"13%","margin-left":"24%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/zhpf.png","alt":""}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-57%","margin-left":"50%","font-size":"3.6vw","font-weight":"600","line-height":"3vw","color":"#999999FF"}},[_vm._v(" 2/ "),_c('span',{staticStyle:{"color":"#FFBB60FF","margin-left":"-1%"}},[_vm._v("3")]),_vm._v(" "),_c('br'),_c('span',{staticStyle:{"font-size":"2.3vw","font-weight":"400","color":"#666666FF"}},[_vm._v(" 交互性")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"16%","margin-left":"76%","font-size":"3.6vw","font-weight":"600","line-height":"3vw","color":"#999999FF"}},[_vm._v(" 2/ "),_c('span',{staticStyle:{"color":"#FFBB60FF","margin-left":"-1%"}},[_vm._v("2")]),_vm._v(" "),_c('br'),_c('span',{staticStyle:{"font-size":"2.3vw","font-weight":"400","color":"#666666FF"}},[_vm._v("   时效性")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"28%","margin-left":"64%","font-size":"3.6vw","font-weight":"600","line-height":"3vw","color":"#999999FF"}},[_vm._v(" 2/ "),_c('span',{staticStyle:{"color":"#FFBB60FF","margin-left":"-1%"}},[_vm._v("3")]),_vm._v(" "),_c('br'),_c('span',{staticStyle:{"font-size":"2.3vw","font-weight":"400","color":"#666666FF"}},[_vm._v("  便捷性")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-6%","margin-left":"28%","font-size":"3.6vw","font-weight":"600","line-height":"3vw","color":"#999999FF"}},[_vm._v(" 2/ "),_c('span',{staticStyle:{"color":"#FFBB60FF","margin-left":"-1%"}},[_vm._v("3")]),_vm._v(" "),_c('br'),_c('span',{staticStyle:{"font-size":"2.3vw","font-weight":"400","color":"#666666FF"}},[_vm._v("  扩散性")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-41%","margin-left":"13%","font-size":"3.6vw","font-weight":"600","line-height":"3vw","color":"#999999FF"}},[_vm._v(" 2/ "),_c('span',{staticStyle:{"color":"#FFBB60FF","margin-left":"-1%"}},[_vm._v("4")]),_vm._v(" "),_c('br'),_c('span',{staticStyle:{"font-size":"2.3vw","font-weight":"400","color":"#666666FF"}},[_vm._v("传播速度")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-6",staticStyle:{"margin-top":"34%","background":"url('https://static.xinmeibao.com/assets_mobile/newmedium/tfqd.png')","background-size":"100% 100%","height":"100.4vw","overflow":"hidden","position":"relative"}},[_c('div',{staticClass:"big-title",staticStyle:{"margin-top":"17%"}},[_vm._v("新媒体投放渠道")]),_vm._v(" "),_c('div',{staticClass:"title_line"},[_c('div',{staticClass:"title_line-s"})]),_vm._v(" "),_c('div',{staticClass:"title-en"},[_vm._v("NEW MEDIA DELIVERY CHANNEL")]),_vm._v(" "),_c('div',{staticClass:"media_content-3"},[_vm._v("我们身边的新媒体\n")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"41%","left":"17%"}},[_vm._v("微信")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"41%","left":"46%"}},[_vm._v("小红书")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"41%","left":"78%"}},[_vm._v("微博")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"79%","left":"28%"}},[_vm._v("直播平台")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","top":"79%","left":"59%"}},[_vm._v("短视频平台")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-7",staticStyle:{"background":"url('https://static.xinmeibao.com/assets_mobile/newmedium/tfal_tp.png') no-repeat","background-size":"60%","height":"100.4vw","margin-top":"10%","padding-top":"1px","position":"relative"}},[_c('div',{staticClass:"big-title",staticStyle:{"margin-top":"0%"}},[_vm._v("新媒体投放案例")]),_vm._v(" "),_c('div',{staticClass:"title_line"},[_c('div',{staticClass:"title_line-s"})]),_vm._v(" "),_c('div',{staticClass:"title-en"},[_vm._v("NEW MEDIA DELIVERY CASES")]),_vm._v(" "),_c('div',{staticClass:"media-item-case"},[_c('div',{staticClass:"media-item-case-t"},[_c('img',{staticStyle:{"width":"8.1vw"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/tgcp_icon.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"line-height":"5vw","position":"absolute","top":"16%","right":"10%"}},[_vm._v("\n  推广产品"),_c('br'),_vm._v("高露洁美牙仪\n")])]),_vm._v(" "),_c('div',{staticClass:"media-item-case-t",staticStyle:{"margin-right":"-8%","margin-top":"16%"}},[_c('img',{staticStyle:{"width":"8.1vw"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/cpsx_icon.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"line-height":"5vw","position":"absolute","top":"28%","right":"10%"}},[_vm._v("\n  产品属性"),_c('br'),_vm._v("科技美妆产品\n")])]),_vm._v(" "),_c('div',{staticClass:"media-item-case-t",staticStyle:{"margin-right":"-8%","margin-top":"28%"}},[_c('img',{staticStyle:{"width":"8.1vw"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/tgpt_icon.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"line-height":"5vw","position":"absolute","top":"40%","right":"13%"}},[_vm._v("\n  推广平台"),_c('br'),_vm._v("全平台投放\n")])]),_vm._v(" "),_c('div',{staticClass:"media-item-case-t",staticStyle:{"margin-right":"-8%","margin-top":"41%"}},[_c('img',{staticStyle:{"width":"8.1vw"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/szrq_icon.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"line-height":"5vw","position":"absolute","top":"53%","right":"4%"}},[_vm._v("\n  受众人群"),_c('br'),_vm._v("对外表颜值高要求\n")])]),_vm._v(" "),_c('div',{staticClass:"media-item-case-t",staticStyle:{"margin-right":"-8%","margin-top":"54%"}},[_c('img',{staticStyle:{"width":"8.1vw"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/tgxs_icon.png","alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"line-height":"5vw","position":"absolute","top":"66%","right":"9%"}},[_vm._v("\n  推广形式"),_c('br'),_vm._v("测评对比实验\n")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-8",staticStyle:{"background":"url('https://static.xinmeibao.com/assets_mobile/newmedium/tgcl.png') no-repeat","background-size":"100% 100%","height":"123vw","margin-top":"-16%","overflow":"hidden"}},[_c('div',{staticClass:"big-title",staticStyle:{"margin-top":"16%"}},[_vm._v("推广策略")]),_vm._v(" "),_c('div',{staticClass:"title_line"},[_c('div',{staticClass:"title_line-s"})]),_vm._v(" "),_c('div',{staticClass:"title-en"},[_vm._v("PROMOTION STRATEGY")]),_vm._v(" "),_c('div',{staticClass:"media-str"},[_vm._v("\n在KOL的选择上，软盟选择了专业美妆类视频科普KOL，与普通美妆博主作为消费者的角度不同;\n"),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n专业科普KOL能从实验与解析成分的角度出发，全方位深度解读产品，具备无可比拟的专业性与权威性;\n"),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n我们计划在内容上进行了一组对比实验，通过实验结果直观反映出产品在科技与效果方面的优势，以达到种草的目的。\n\n  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-9",staticStyle:{"margin-top":"10%","position":"relative","height":"auto"}},[_c('div',{staticClass:"big-title",staticStyle:{"margin-top":"0%"}},[_vm._v("高露洁美牙仪")]),_vm._v(" "),_c('div',{staticClass:"title_line"},[_c('div',{staticClass:"title_line-s"})]),_vm._v(" "),_c('div',{staticClass:"title-en"},[_vm._v("COLGATE DENTAL APPARATUS")]),_vm._v(" "),_c('div',{staticClass:"media-item-colgate"},[_c('img',{staticStyle:{"width":"15vw","height":"15vw","position":"absolute","top":"130%","left":"21%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/cpmdtl_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-ec",staticStyle:{"position":"absolute","top":"264%","left":"18%"}},[_vm._v("\n      产品卖点提炼\n    ")]),_vm._v(" "),_c('div',{staticClass:"item-ideas",staticStyle:{"position":"absolute","top":"306%","left":"20.5%","font-size":"2.5vw"}},[_vm._v("\nNth-Light技术"),_c('br'),_vm._v("\n    科技产品"),_c('br'),_vm._v("\n    美白牙齿\n  ")]),_vm._v(" "),_c('img',{staticStyle:{"width":"15vw","height":"15vw","position":"absolute","top":"130%","left":"68%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/szfx_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-ec",staticStyle:{"position":"absolute","top":"264%","left":"65%"}},[_vm._v("\n      受众分析\n    ")]),_vm._v(" "),_c('div',{staticClass:"item-ideas",staticStyle:{"position":"absolute","top":"306%","left":"61.5%","font-size":"2.5vw"}},[_vm._v("\n    美妆类对外表颜值高"),_c('br'),_vm._v("\n要求对科技产品慎重的群体\n  ")]),_vm._v(" "),_c('img',{staticStyle:{"width":"15vw","height":"15vw","position":"absolute","top":"469%","left":"21%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/kolpp_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-ec",staticStyle:{"position":"absolute","top":"604%","left":"18%"}},[_vm._v("\n      KOL匹配\n    ")]),_vm._v(" "),_c('div',{staticClass:"item-ideas",staticStyle:{"position":"absolute","top":"647%","left":"20.5%","font-size":"2.5vw"}},[_vm._v("\n具有专业性权威"),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"-5vw"}},[_vm._v("能够深度剖析产品的KOL")]),_c('br'),_vm._v("\n     大嘴博士"),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"-9%"}},[_vm._v(" 抖音微博百万粉丝级")])]),_vm._v(" "),_c('img',{staticStyle:{"width":"15vw","height":"15vw","position":"absolute","top":"469%","left":"68%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/nrgh_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-ec",staticStyle:{"position":"absolute","top":"604%","left":"65%"}},[_vm._v("\n 内容规划\n    ")]),_vm._v(" "),_c('div',{staticClass:"item-ideas",staticStyle:{"position":"absolute","top":"647%","left":"61.5%","font-size":"2.5vw"}},[_vm._v("\n             网红测评 "),_c('br'),_vm._v("\n             对比实验\n  ")]),_vm._v(" "),_c('img',{staticStyle:{"width":"15vw","height":"15vw","position":"absolute","top":"834%","left":"21%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/ptdd_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-ec",staticStyle:{"position":"absolute","top":"967%","left":"18%"}},[_vm._v("\n      平台定档\n    ")]),_vm._v(" "),_c('div',{staticClass:"item-ideas",staticStyle:{"position":"absolute","top":"1012%","left":"20.5%","font-size":"2.5vw"}},[_c('span',{staticStyle:{"margin-left":"-24%"}},[_vm._v("统一日期全平台(30个)发送")]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"-5%"}},[_vm._v("主:双微一抖小红书")]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"-6vw"}},[_vm._v(" 辅:自媒体平台和短视频平台")])]),_vm._v(" "),_c('img',{staticStyle:{"width":"15vw","height":"15vw","position":"absolute","top":"834%","left":"68%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/ldzx_icon.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-ec",staticStyle:{"position":"absolute","top":"967%","left":"65%"}},[_vm._v("\n      落地执行\n    ")]),_vm._v(" "),_c('div',{staticClass:"item-ideas",staticStyle:{"position":"absolute","top":"1012%","left":"61.5%","font-size":"2.5vw"}},[_c('span',{staticStyle:{"margin-left":"-3vw"}},[_vm._v("360万触达人群:超过20万点赞")]),_c('br'),_vm._v("\n        seo优化:品牌口碑\n  ")]),_vm._v(" "),_c('img',{staticStyle:{"width":"75%","position":"absolute","top":"1149%","left":"13.5%"},attrs:{"src":"https://static.xinmeibao.com/assets_mobile/newmedium/tp.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-ideas-content"},[_vm._v("\n  规划好内容和档期后，我们充分利用博主的科普影响力，在其所拥有的全部媒体平台进行发布;"),_c('br'),_vm._v("\n最终以时下最热门的双微一抖小红书为主，知乎、百家号、头条号、一点号、网易号、企鹅号等自媒体平台，美拍、火山小视频、快手、全民、AB站等视频平台为辅，总共在30个媒体平台上发布了该产品的宣传视频。\n\n\n   ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-10",staticStyle:{"margin-top":"245%","background":"url('https://static.xinmeibao.com/assets_mobile/newmedium/tgxg.png') no-repeat","background-size":"100% 100%","height":"63.6vw","overflow":"hidden"}},[_c('div',{staticClass:"big-title",staticStyle:{"margin-top":"5%"}},[_vm._v("推广效果")]),_vm._v(" "),_c('div',{staticClass:"title_line"},[_c('div',{staticClass:"title_line-s"})]),_vm._v(" "),_c('div',{staticClass:"title-en"},[_vm._v("POPULARIZATION EFFECT")]),_vm._v(" "),_c('div',{staticClass:"item-eff"},[_vm._v("\n据软盟的不完全统计，\n该视频总共播放量达到360万，\n点赞过20万，\n影响力还在持续作用中。\n\n\n\n\n")])])}]
var newmedium_esExports = { render: newmedium_render, staticRenderFns: newmedium_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_newmedium = (newmedium_esExports);
// CONCATENATED MODULE: ./src/pages/newmedium/index.vue
function newmedium_injectStyle (ssrContext) {
  __webpack_require__("v5hk")
  __webpack_require__("z+Xl")
}
var newmedium_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var newmedium___vue_template_functional__ = false
/* styles */
var newmedium___vue_styles__ = newmedium_injectStyle
/* scopeId */
var newmedium___vue_scopeId__ = "data-v-731f71c6"
/* moduleIdentifier (server only) */
var newmedium___vue_module_identifier__ = null
var newmedium_Component = newmedium_normalizeComponent(
  pages_newmedium,
  selectortype_template_index_0_src_pages_newmedium,
  newmedium___vue_template_functional__,
  newmedium___vue_styles__,
  newmedium___vue_scopeId__,
  newmedium___vue_module_identifier__
)

/* harmony default export */ var src_pages_newmedium = (newmedium_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js




















// import recharge from '@/pages/recharge'








































vue_esm["default"].use(vue_router_esm["a" /* default */]);

var routes = [{
  path: '/',
  name: 'index',
  component: src_pages_index,
  meta: {
    noNav: true,
    title: '软盟'
  }
}, {
  path: '/promotionNews',
  name: 'promotionNews',
  component: src_pages_promotionNews,
  meta: {
    noNav: true,
    title: '软文推广'
  }
}, {
  path: '/promotionWechat',
  name: 'promotionWechat',
  component: src_pages_promotionWechat,
  meta: {
    noNav: true,
    title: '微信推广'
  }
}, {
  path: '/promotionWechatEffect',
  name: 'promotionWechatEffect',
  component: src_pages_promotionWechatEffect,
  meta: {
    noNav: true,
    title: '微信推广'
  }
}, {
  path: '/promotionWeibo',
  name: 'promotionWeibo',
  component: src_pages_promotionWeibo,
  meta: {
    noNav: true,
    title: '微博推广'
  }
}, {
  path: '/promotionLive',
  name: 'promotionLive',
  component: src_pages_promotionLive,
  meta: {
    noNav: true,
    title: '网红直播'
  }
}, {
  path: '/promotionVideo',
  name: 'promotionVideo',
  component: src_pages_promotionVideo,
  meta: {
    noNav: true,
    title: '短视频营销'
  }
}, {
  path: '/promotionWxzf',
  name: 'promotionWxzf',
  component: src_pages_promotionWxzf,
  meta: {
    noNav: true,
    title: '公众号引流'
  }
}, {
  path: '/promotionInfoFlow',
  name: 'promotionInfoFlow',
  component: src_pages_promotionInfoFlow,
  meta: {
    noNav: true,
    title: '信息流广告 '
  }
}, {
  path: '/mediaIndex',
  name: 'mediaIndex',
  component: src_pages_mediaIndex,
  meta: {
    noNav: true,
    title: '投广告'
  }
}, {
  path: '/media',
  name: 'media',
  component: src_pages_media,
  meta: {
    title: '媒体'
  }
}, {
  path: '/media/detail/:id',
  name: 'mediaDetail',
  component: src_pages_mediaDetail,
  meta: {
    title: '媒体详情'
  }
}, {
  path: '/cart',
  name: 'cart',
  component: src_pages_cart,
  meta: {
    noNav: true,
    title: '选号车'
  }
}, {
  path: '/order',
  name: 'order',
  component: src_pages_order,
  meta: {
    noNav: true,
    title: '订单'
  }
}, {
  path: '/order/detail/:id',
  name: 'orderDetail',
  component: src_pages_orderDetail,
  meta: {
    title: '订单详情'
  }
}, {
  path: '/manuscript',
  name: 'manuscript',
  component: src_pages_manuscript,
  meta: {
    title: '选择稿件'
  }
},
// {
//   path: '/recharge',
//   name: 'recharge',
//   component: recharge,
//   meta: {
//     title: '充值'
//   }
// },
{
  path: '/recharge-success',
  name: 'recharge-success',
  component: src_pages_recharge_success,
  meta: {
    title: '充值成功'
  }
}, {
  path: '/pay-success',
  name: 'pay-success',
  component: src_pages_pay_success,
  meta: {
    title: '支付成功'
  }
}, {
  path: '/me',
  name: 'me',
  component: src_pages_me,
  meta: {
    noNav: true,
    title: '个人中心'
  }
}, {
  path: '/profile',
  name: 'profile',
  component: src_pages_profile,
  meta: {
    title: '个人资料'
  }
}, {
  path: '/profile/edit',
  name: 'profile-edit',
  component: src_pages_profileEdit,
  meta: {
    title: '个人资料修改'
  }
}, {
  path: '/changePwd',
  name: 'changePwd',
  component: src_pages_changePwd,
  meta: {
    title: '修改密码'
  }
}, {
  path: '/recharge/history',
  name: 'rechargeHistory',
  component: src_pages_rechargeHistory,
  meta: {
    title: '交易流水'
  }
}, {
  path: '/login',
  name: 'login',
  component: src_pages_login,
  meta: {
    title: '登录'
  }
}, {
  path: '/register',
  name: 'register',
  component: src_pages_register,
  meta: {
    title: '注册'
  }
}, {
  path: '/register-profile',
  name: 'registerProfile',
  component: src_pages_registerProfile,
  meta: {
    title: '注册资料填写'
  }
}, {
  path: '/forgotPwd',
  name: 'forgotPwd',
  component: src_pages_forgotPwd,
  meta: {
    title: '忘记密码'
  }
}, {
  path: '/collect',
  name: 'collect',
  component: src_pages_collect,
  meta: {
    title: '我的收藏'
  }
},
// 解决方案
{
  path: '/solution/finance',
  name: 'solutionFinance',
  component: src_pages_solution_finance,
  meta: {
    noNav: true,
    title: '金融行业推广解决方案'
  }
}, {
  path: '/solution/appPromotion',
  name: 'solutionApp',
  component: src_pages_solution_appPromotion,
  meta: {
    noNav: true,
    title: 'APP推广解决方案'
  }
}, {
  path: '/solution/newProduct',
  name: 'solutionNewProduct',
  component: src_pages_solution_newProduct,
  meta: {
    noNav: true,
    title: '新品推广解决方案'
  }
}, {
  path: '/solution/game',
  name: 'solutionGame',
  component: src_pages_solution_game,
  meta: {
    noNav: true,
    title: '游戏行业解决方案'
  }
}, {
  path: '/solution/motherChild',
  name: 'solutionBaby',
  component: src_pages_solution_motherChild,
  meta: {
    noNav: true,
    title: '母婴行业解决方案'
  }
}, {
  path: '/solution/fashionBeauty',
  name: 'solutionBeauty',
  component: src_pages_solution_fashionBeauty,
  meta: {
    noNav: true,
    title: '时尚美容行业解决方案'
  }
}, {
  path: '/solution/fmcg',
  name: 'solutionFmcg',
  component: src_pages_solution_fmcg,
  meta: {
    noNav: true,
    title: '快消行业解决方案'
  }
}, {
  path: '/solution/tourism',
  name: 'solutionTourism',
  component: src_pages_solution_tourism,
  meta: {
    noNav: true,
    title: '旅游行业解决方案'
  }
}, {
  path: '/solution/car',
  name: 'solutionCar',
  component: src_pages_solution_car,
  meta: {
    noNav: true,
    title: '汽车行业解决方案'
  }
}, {
  path: '/solution/ecommerce',
  name: 'solutionEcommerce',
  component: src_pages_solution_ecommerce,
  meta: {
    noNav: true,
    title: '电商行业解决方案'
  }
}, {
  path: '/solution/microBussiness',
  name: 'solutionWechatBussiness',
  component: src_pages_solution_microBussiness,
  meta: {
    noNav: true,
    title: '微商行业解决方案'
  }
}, {
  path: '/solution/smallProgram',
  name: 'solutionMiniProgram',
  component: src_pages_solution_smallProgram,
  meta: {
    noNav: true,
    title: '微信小程序推广解决方案'
  }
}, {
  path: '/promotionToutiao',
  name: 'promotionToutiao',
  component: src_pages_promotionToutiao,
  meta: {
    noNav: true,
    title: '今日头条'
  }
}, {
  path: '/promotionDouyin',
  name: 'promotionDouyin',
  component: src_pages_promotionDouyin,
  meta: {
    noNav: true,
    title: '抖音推广'
  }
}, {
  path: '/promotionXhs',
  name: 'promotionXhs',
  component: src_pages_promotionXhs,
  meta: {
    noNav: true,
    title: '小红书'
  }
}, {
  path: '/agreement',
  name: 'agreement',
  component: src_pages_agreement,
  meta: {
    noNav: true,
    title: '服务条款'
  }
}, {
  path: '/newguest',
  name: 'newguest',
  component: src_pages_newguest,
  meta: {
    noNav: true,
    title: '新媒体营销,大V推广,大号资源，公众号推广,新媒体推广平台,新媒体营销公司',
    docDesc: '软盟是国内领先的新媒体广告营销平台，签约了100万+优质新媒体大V资源，聚合行业权威意见领袖,明星红人及草根大号,覆盖电商,美妆,母婴,美食旅游等200+行业，帮助广告主实现高效精准快速新媒体广告传播。',
    docKeyword: ' KOL, 大V推广 ,大号资源, 公众号推广,新媒体推广平台,新媒体营销公司'
  }
}, {
  path: '/newguestwx',
  name: 'newguestwx',
  component: src_pages_newguestwx,
  meta: {
    noNav: true,
    title: '微信营销,大V推广,大号资源，公众号推广,新媒体推广平台,新媒体营销公司',
    docDesc: '软盟是国内领先的新媒体广告营销平台，签约了100万+优质新媒体大V资源，聚合行业权威意见领袖,明星红人及草根大号,覆盖电商,美妆,母婴,美食旅游等200+行业，帮助广告主实现高效精准快速新媒体广告传播。',
    docKeyword: ' KOL, 大V推广 ,大号资源, 公众号推广,新媒体推广平台,新媒体营销公司'
  }
}, {
  path: '/new_guest_wx2',
  name: 'newguestwx2',
  component: src_pages_newguestwx2,
  meta: {
    noNav: true,
    title: '微信公众号KOL大号资源平台，电商美妆等全行业精准营销-软盟',
    docDesc: '软盟—覆盖10万+优质微信公众号资源，微信大号资源覆盖电商,美妆,母婴,美食，旅游等200+行业，帮助广告主实现高效精准推广。',
    docKeyword: '微信推广, 微信营销, 社媒营销, 微信大号, 微信KOL'
  }
}, {
  path: '/new_guest_xhs1',
  name: 'newguestxhs1',
  component: src_pages_newguestxhs1,
  meta: {
    noNav: true,
    title: '软盟——小红书推广，专业小红书广告服务商',
    docDesc: '小红书推广,小红书kol,小红书广告,小红书怎么推广,小红书kol报价,小红书kol推广,小红书推广报价,小红书广告投放,小红书达人合作',
    docKeyword: '软盟精准小红书推广平台，整合10万+明星红人、美妆达人等小红书KOL资源，小红书推广专家一对一策划明星推荐、小红书KOL扩散、网红霸屏、红人种草等小红书推广量身定制服务，助力广告主实现小红书推广霸屏营销。'
  }
}, {
  path: '/new_guest_xhs2',
  name: 'newguestxhs2',
  component: src_pages_newguestxhs2,
  meta: {
    noNav: true,
    title: '软盟——小红书推广，专业小红书广告服务商',
    docDesc: '小红书推广,小红书kol,小红书广告,小红书怎么推广,小红书kol报价,小红书kol推广,小红书推广报价,小红书广告投放,小红书达人合作',
    docKeyword: '软盟精准小红书推广平台，整合10万+明星红人、美妆达人等小红书KOL资源，小红书推广专家一对一策划明星推荐、小红书KOL扩散、网红霸屏、红人种草等小红书推广量身定制服务，助力广告主实现小红书推广霸屏营销。'
  }
}, {
  path: '/1212',
  name: 'double12',
  component: src_pages_double12,
  meta: {
    noNav: true,
    title: '软盟双十二 - 新媒体精准营销平台',
    docDesc: '软盟,内容营销,KOL大号,社会化营销,微信营销,自媒体,微博营销,短视频营销,信息流广告',
    docKeyword: '软盟是国内领先的社会化媒体精准营销平台,平台汇聚了超过100万社交新媒体资源,通过整合微信KOL大号、微博大V红人、网红直播,短视频、信息流广告等全网一手优质资源,帮助广告主快速精准匹配到适合渠道资源,致力于为您提供专业的媒体投放解决方案。'
  }
}, {
  path: '/new_guest_kol',
  name: 'newguestkol',
  component: src_pages_newguestkol,
  meta: {
    noNav: true,
    title: '100万+ KOL大号无差价资源平台,电商美妆等全行业精准营销-软盟',
    docDesc: 'KOL资源,KOL平台,KOL大号,微信KOL, KOL推广,小红书KOL,抖音KOL,微博KOL',
    docKeyword: '软盟—覆盖100万+优质KOL资源,KOL大号覆盖电商,美妆,母婴,美食,旅游等200+行业,低成本帮助广告主实现高效精准推广。'
  }
}, {
  path: '/new_guest_xhs3',
  name: 'newguestxhs3',
  component: src_pages_newguestxhs3,
  meta: {
    noNav: true,
    title: '软盟——小红书推广，专业小红书广告服务商',
    docDesc: '小红书推广,小红书kol,小红书广告,小红书怎么推广,小红书kol报价,小红书kol推广,小红书推广报价,小红书广告投放,小红书达人合作',
    docKeyword: '软盟精准小红书推广平台，整合10万+明星红人、美妆达人等小红书KOL资源，小红书推广专家一对一策划明星推荐、小红书KOL扩散、网红霸屏、红人种草等小红书推广量身定制服务，助力广告主实现小红书推广霸屏营销。'
  }
}, {
  path: '/live',
  name: 'live',
  component: src_pages_live,
  meta: {
    noNav: true,
    title: '网红推广_网红直播推广_直播推广_网红营销推广_网红直播营销推广平台',
    docDesc: '网红推广,网红直播推广,网红营销推广,网红直播营销推广,直播营销推广,直播推广,网红营销',
    docKeyword: '软盟是国内领先的网红直播营销推广平台,整合网红推广,网红直播推广,网红营销推广等海量网红直播营销推广资源,覆盖亿万垂直粉丝,迅速引起话题与曝光,低成本高回报,广告效果翻倍。。'
  }
}, {
  path: '/newmedium',
  name: 'newmedium',
  component: src_pages_newmedium,
  meta: {
    noNav: true,
    title: '软盟 - 新媒体精准营销平台',
    docDesc: '软盟,内容营销，KOL大号，社会化营销,微信营销,自媒体,微博营销,短视频营销，信息流广告',
    docKeyword: '软盟是国内领先的社会化媒体精准营销平台，平台汇聚了超过100万社交新媒体资源，通过整合微信KOL大号、微博大V红人、网红直播，短视频、信息流广告等全网一手优质资源，帮助广告主快速精准匹配到适合渠道资源，致力于为您提供专业的媒体投放解决方案'
  }
}, {
  path: '/live',
  name: 'live',
  component: src_pages_live,
  meta: {
    noNav: true,
    title: '软盟——小红书推广，专业小红书广告服务商',
    docDesc: '小红书推广,小红书kol,小红书广告,小红书怎么推广,小红书kol报价,小红书kol推广,小红书推广报价,小红书广告投放,小红书达人合作',
    docKeyword: '软盟精准小红书推广平台，整合10万+明星红人、美妆达人等小红书KOL资源，小红书推广专家一对一策划明星推荐、小红书KOL扩散、网红霸屏、红人种草等小红书推广量身定制服务，助力广告主实现小红书推广霸屏营销。'
  }
}];

var router_router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: routes
});

// 判断用户资料是否填写
function isProfileComplete(profile) {
  return !!(profile.attribute.industry && profile.attribute.taxonomies.length !== 0);
}

router_router.beforeEach(function (to, from, next) {
  var profile = store.getters.profile;

  // 不需要权限访问的页面列表   todo 以后有复杂的用户身份权限再转入路由配置文件中
  var authPath = ['index', 'login', 'register', 'forgotPwd', 'mediaIndex', 'media', 'mediaDetail', 'promotionNews', 'promotionWechat', 'promotionWeibo', 'promotionLive', 'promotionVideo', 'promotionInfoFlow', 'promotionWechatEffect', 'promotionXhs', 'promotionDouyin', 'promotionToutiao', 'solutionFinance', 'solutionApp', 'solutionNewProduct', 'solutionGame', 'solutionBaby', 'solutionBeauty', 'solutionFmcg', 'solutionTourism', 'solutionCar', 'solutionEcommerce', 'solutionWechatBussiness', 'solutionMiniProgram', 'agreement', 'newguest', 'newguestwx', 'newguestwx2', 'newguestxhs1', 'newguestxhs2', 'double12', 'newguestkol', 'promotionWxzf', 'newguestxhs3', 'live', 'newmedium'];

  // 设置title
  if (to.meta.title) {
    document.title = to.meta.title;
    store.commit('SET_TITLE', to.meta.title);
  }
  if (to.meta.docKeyword) {
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.docKeyword);
  }
  if (to.meta.docDesc) {
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.docDesc);
  }

  // 通过router的name判断是否需要权限验证
  if (authPath.indexOf(to.name) !== -1) {
    if (to.name === 'login') {
      console.log('非权限页面跳转登录页拦截', from);
      next();
    } else {
      next();
    }
  } else {
    if (!profile.id) {
      fetchUser().then(function (res) {
        store.commit('SET_PROFILE', res.data);
        if (to.path !== '/register-profile' && !isProfileComplete(res.data)) {
          next('/register-profile');
        } else {
          next();
        }
      }).catch(function (e) {
        next('/login');
        console.log('获取用户信息失败，没有token或token过期', e);
      });
    } else {
      if (to.path !== '/register-profile' && !isProfileComplete(profile)) {
        next('/register-profile');
      } else {
        next();
      }
    }
  }
});
/* harmony default export */ var src_router = (router_router);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12306fcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",[_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){_vm.$emit('on-click-title')}}},[_vm._t("default",[_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])])],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){_vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var x_header_staticRenderFns = []
var x_header_esExports = { render: x_header_render, staticRenderFns: x_header_staticRenderFns }
/* harmony default export */ var src_components_x_header = (x_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function x_header_injectStyle (ssrContext) {
  __webpack_require__("6OpF")
}
var x_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_header___vue_template_functional__ = false
/* styles */
var x_header___vue_styles__ = x_header_injectStyle
/* scopeId */
var x_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_header___vue_module_identifier__ = null
var x_header_Component = x_header_normalizeComponent(
  components_x_header,
  src_components_x_header,
  x_header___vue_template_functional__,
  x_header___vue_styles__,
  x_header___vue_scopeId__,
  x_header___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (x_header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue










/* harmony default export */ var App = ({
  name: 'app',
  components: {
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    XHeader: vux_src_components_x_header,
    ViewBox: vux_src_components_view_box
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['title'])),
  data: function data() {
    return {
      tabBarIdx: 0,
      orderTab: '',
      sysInfo: {}
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    changeTabBarIdx: function changeTabBarIdx() {
      if (this.$route.name === 'index') {
        this.tabBarIdx = 0;
      } else if (this.$route.name === 'mediaIndex') {
        this.tabBarIdx = 1;
      } else if (this.$route.name === 'cart') {
        this.tabBarIdx = 2;
      } else if (this.$route.name === 'order') {
        this.tabBarIdx = 3;
      } else if (this.$route.name === 'me') {
        this.tabBarIdx = 4;
      }
    }
  },
  created: function created() {
    setInterval(function () {
      authShake().then(function (resp) {});
    }, 30000);
    this.changeTabBarIdx();
  },
  updated: function updated() {
    this.changeTabBarIdx();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue










/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  components: {
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    XHeader: vux_src_components_x_header,
    ViewBox: vux_src_components_view_box
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['title'])),
  data: function data() {
    return {
      tabBarIdx: 0,
      orderTab: '',
      sysInfo: {}
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    changeTabBarIdx: function changeTabBarIdx() {
      if (this.$route.name === 'index') {
        this.tabBarIdx = 0;
      } else if (this.$route.name === 'mediaIndex') {
        this.tabBarIdx = 1;
      } else if (this.$route.name === 'cart') {
        this.tabBarIdx = 2;
      } else if (this.$route.name === 'order') {
        this.tabBarIdx = 3;
      } else if (this.$route.name === 'me') {
        this.tabBarIdx = 4;
      }
    }
  },
  created: function created() {
    setInterval(function () {
      authShake().then(function (resp) {});
    }, 30000);
    this.changeTabBarIdx();
  },
  updated: function updated() {
    this.changeTabBarIdx();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b454c5f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view-box',{ref:"viewBox",attrs:{"body-padding-top":!_vm.$route.meta.noNav?'92px':'0',"body-padding-bottom":_vm.$route.meta.tabBar?'98px':'0'}},[(!_vm.$route.meta.noNav)?_c('x-header',{staticStyle:{"width":"100%","position":"absolute","top":"0","left":"0","z-index":"100"},attrs:{"slot":"header","left-options":{backText: ''}},slot:"header"},[_c('div',{staticClass:"header-title",attrs:{"slot":"overwrite-title"},slot:"overwrite-title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.$route.meta.tabBar)?_c('tabbar',{attrs:{"slot":"bottom"},slot:"bottom",model:{value:(_vm.tabBarIdx),callback:function ($$v) {_vm.tabBarIdx=$$v},expression:"tabBarIdx"}},[_c('tabbar-item',{attrs:{"link":"/"}},[_c('img',{attrs:{"slot":"icon","src":"https://static.xinmeibao.com/assets_mobile/v2/icon_tabbar_home.png"},slot:"icon"}),_vm._v(" "),_c('img',{attrs:{"slot":"icon-active","src":"https://static.xinmeibao.com/assets_mobile/v2/icon_tabbar_home_active.png"},slot:"icon-active"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("首页")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/mediaIndex"}},[_c('img',{attrs:{"slot":"icon","src":"https://static.xinmeibao.com/assets_mobile/v2/icon_tabbar_media.png"},slot:"icon"}),_vm._v(" "),_c('img',{attrs:{"slot":"icon-active","src":"https://static.xinmeibao.com/assets_mobile/v2/icon_tabbar_media_active.png"},slot:"icon-active"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("投广告")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/cart"}},[_c('img',{attrs:{"slot":"icon","src":"https://static.xinmeibao.com/assets_mobile/v2/icon_tabbar_cart.png"},slot:"icon"}),_vm._v(" "),_c('img',{attrs:{"slot":"icon-active","src":"https://static.xinmeibao.com/assets_mobile/v2/icon_tabbar_cart_active.png"},slot:"icon-active"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("选号车")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/order"}},[_c('img',{attrs:{"slot":"icon","src":"https://static.xinmeibao.com/assets_mobile/v2/icon_tabbar_order.png"},slot:"icon"}),_vm._v(" "),_c('img',{attrs:{"slot":"icon-active","src":"https://static.xinmeibao.com/assets_mobile/v2/icon_tabbar_order_active.png"},slot:"icon-active"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("订单")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/me"}},[_c('img',{attrs:{"slot":"icon","src":"https://static.xinmeibao.com/assets_mobile/v2/icon_tabbar_me.png"},slot:"icon"}),_vm._v(" "),_c('img',{attrs:{"slot":"icon-active","src":"https://static.xinmeibao.com/assets_mobile/v2/icon_tabbar_me_active.png"},slot:"icon-active"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("我的")])])],1):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("P5eq")
  __webpack_require__("CLHC")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/minireset.css/minireset.css
var minireset = __webpack_require__("W5lv");
var minireset_default = /*#__PURE__*/__webpack_require__.n(minireset);

// EXTERNAL MODULE: ./src/css/app.css
var app = __webpack_require__("VXnA");
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// EXTERNAL MODULE: ./src/assets/iconfont/iconfont.css
var iconfont = __webpack_require__("muQq");
var iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont);

// EXTERNAL MODULE: ./src/assets/iconfont/iconfont.js
var iconfont_iconfont = __webpack_require__("f8sx");
var iconfont_iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont_iconfont);

// EXTERNAL MODULE: ./src/assets/iconfont/xmb-wap/iconfont.css
var xmb_wap_iconfont = __webpack_require__("xqBC");
var xmb_wap_iconfont_default = /*#__PURE__*/__webpack_require__.n(xmb_wap_iconfont);

// EXTERNAL MODULE: ./src/assets/iconfont/xmb-wap/iconfont.js
var iconfont_xmb_wap_iconfont = __webpack_require__("WZV6");
var iconfont_xmb_wap_iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont_xmb_wap_iconfont);

// EXTERNAL MODULE: ./src/assets/iconfont/xmb-login/iconfont.css
var xmb_login_iconfont = __webpack_require__("GmEV");
var xmb_login_iconfont_default = /*#__PURE__*/__webpack_require__.n(xmb_login_iconfont);

// EXTERNAL MODULE: ./src/assets/iconfont/xmb-login/iconfont.js
var iconfont_xmb_login_iconfont = __webpack_require__("YzYG");
var iconfont_xmb_login_iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont_xmb_login_iconfont);

// CONCATENATED MODULE: ./src/main.js




























var FastClick = __webpack_require__("v5o6");

vue_esm["default"].use(toast["a" /* default */]);
vue_esm["default"].use(loading["a" /* default */]);
vue_esm["default"].use(plugins_confirm["a" /* default */]);
vue_esm["default"].use(vue_iconfont_default.a);
vue_esm["default"].use(vue_scrollto_default.a);
vue_esm["default"].use(vue_touch_default.a, { name: 'v-touch' });
vue_esm["default"].use(vue_baidu_map_default.a, { ak: 'YddmVINbOUNAY9jOgfk832QOCeAfsfuG' });

vue_esm["default"].component('flexbox', flexbox["a" /* default */]);
vue_esm["default"].component('flexbox-item', flexbox_item["a" /* default */]);

vue_esm["default"].directive('transfer-dom', transfer_dom["a" /* default */]);

vue_esm["default"].config.productionTip = false;
vue_esm["default"].prototype.$store = store;

FastClick.attach(document.body);

vue_esm["default"].config.productionTip = false;

var main_app = new vue_esm["default"]({
  el: '#app-box',
  router: src_router,
  components: { App: src_App },
  template: '<App/>'
});

main_app.$mount();

/***/ }),

/***/ "NJcl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NzE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O0bA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OECo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OXMm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OxkT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P5eq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PylY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QcHK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QzC3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RCUt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RS6h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RuT6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SMmU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SQp4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sb8w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Spra":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "StpQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TavR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UGB3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ULKY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UuM9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VXnA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W5lv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WZV6":
/***/ (function(module, exports) {

!function (o) {
  var c,
      e = '<svg><symbol id="icon-shuju1" viewBox="0 0 1024 1024"><path d="M927.232 886.784h-788.48c-10.752 0-19.968-9.216-19.968-19.968s9.216-19.968 19.968-19.968H926.72c10.752 0 19.968 9.216 19.968 19.968s-8.704 19.968-19.456 19.968z"  ></path><path d="M809.984 870.912c-10.752 0-19.968-9.216-19.968-19.968V409.088c0-10.752 9.216-19.968 19.968-19.968s19.968 9.216 19.968 19.968v441.856c0 11.264-8.704 19.968-19.968 19.968zM266.24 879.104c-10.752 0-19.968-9.216-19.968-19.968v-62.976c0-10.752 9.216-19.968 19.968-19.968s19.968 9.216 19.968 19.968v62.976c0 10.752-9.216 19.968-19.968 19.968z m453.12-8.192c-10.752 0-19.968-9.216-19.968-19.968v-247.296c0-10.752 9.216-19.968 19.968-19.968s19.968 9.216 19.968 19.968v247.296c0 11.264-8.704 19.968-19.968 19.968z m-90.624 8.192c-10.752 0-19.968-9.216-19.968-19.968v-201.216c0-10.752 9.216-19.968 19.968-19.968s19.968 9.216 19.968 19.968v201.216c0 10.752-9.216 19.968-19.968 19.968z m-90.624-8.192c-10.752 0-19.968-9.216-19.968-19.968V629.76c0-10.752 9.216-19.968 19.968-19.968s19.968 9.216 19.968 19.968v221.184c0 11.264-9.216 19.968-19.968 19.968z m-181.248 0c-10.752 0-19.968-9.216-19.968-19.968v-140.8c0-10.752 9.216-19.968 19.968-19.968s19.968 9.216 19.968 19.968v140.8c0 11.264-9.216 19.968-19.968 19.968z m90.624-13.312c-10.752 0-19.968-9.216-19.968-19.968V578.56c0-10.752 9.216-19.968 19.968-19.968s19.968 9.216 19.968 19.968v259.072c0 11.264-9.216 19.968-19.968 19.968z"  ></path><path d="M805.376 268.8m-28.672 0a28.672 28.672 0 1 0 57.344 0 28.672 28.672 0 1 0-57.344 0Z"  ></path><path d="M805.376 200.192c-37.888 0-68.608 30.72-68.608 68.608 0 16.896 6.144 32.256 16.384 44.032l-95.232 135.68c-9.728-5.12-20.992-8.192-32.768-8.192-28.16 0-52.736 17.408-62.976 41.472l-49.664-18.944c1.024-4.608 1.536-9.216 1.536-14.336 0-37.888-30.72-68.608-68.608-68.608s-68.608 30.72-68.608 68.608c0 9.728 2.048 18.432 5.632 26.624l-0.512 0.512-86.016 100.864c-9.216-4.608-18.944-7.168-30.208-7.168-37.888 0-68.608 30.72-68.608 68.608s30.72 68.608 68.608 68.608 68.608-30.72 68.608-68.608c0-12.288-3.584-24.064-9.216-34.304l83.456-97.792c10.752 6.656 23.552 10.752 36.864 10.752 18.432 0 35.328-7.168 47.616-19.456l65.536 25.088c6.656 30.72 34.304 54.272 67.072 54.272 37.888 0 68.608-30.72 68.608-68.608 0-11.264-2.56-22.016-7.68-31.232l100.352-142.848c6.144 1.536 12.288 2.56 18.944 2.56 37.888 0 68.608-30.72 68.608-68.608s-31.232-67.584-69.12-67.584z m-568.32 435.712v0zM135.168 178.688c-10.752 0-19.968 9.216-19.968 19.968v668.16c0 10.752 9.216 19.968 19.968 19.968s19.968-8.704 19.968-19.968V198.656c0-11.264-9.216-19.968-19.968-19.968z"  ></path></symbol><symbol id="icon-shuju" viewBox="0 0 1024 1024"><path d="M435.4 707.4L314.6 828.2c-3.7 3.7-5.7 8.5-5.7 13.7 0 5.2 2 10 5.7 13.7 3.7 3.7 8.5 5.7 13.7 5.7 5.2 0 10-2 13.7-5.7l120.9-120.9c7.5-7.5 7.5-19.8 0-27.4-7.6-7.5-19.9-7.5-27.5 0.1z"  ></path><path d="M328.3 866.7c-6.6 0-12.9-2.6-17.6-7.3-4.7-4.7-7.3-10.9-7.3-17.6 0-6.6 2.6-12.9 7.3-17.6l120.9-120.9c9.7-9.7 25.4-9.7 35.1 0 9.7 9.7 9.7 25.4 0 35.1L345.8 859.5c-4.7 4.7-10.9 7.2-17.5 7.2z m111-155.5L318.5 832.1c-2.6 2.6-4.1 6.1-4.1 9.8 0 3.7 1.4 7.2 4.1 9.8 2.6 2.6 6.1 4.1 9.8 4.1 3.7 0 7.2-1.4 9.8-4.1L459 730.8c5.4-5.4 5.4-14.2 0-19.6-5.5-5.3-14.3-5.3-19.7 0z m272.1 117L590.6 707.4c-7.5-7.5-19.8-7.5-27.4 0-7.5 7.5-7.5 19.8 0 27.4l120.9 120.9c3.7 3.7 8.5 5.7 13.7 5.7s10-2 13.7-5.7c3.7-3.7 5.7-8.5 5.7-13.7-0.1-5.3-2.1-10.1-5.8-13.8z"  ></path><path d="M697.7 866.7c-6.6 0-12.9-2.6-17.6-7.3L559.3 738.6c-9.7-9.7-9.7-25.4 0-35.1 9.7-9.7 25.4-9.7 35.1 0l120.9 120.9c4.7 4.7 7.3 10.9 7.3 17.6 0 6.6-2.6 12.9-7.3 17.6-4.7 4.6-10.9 7.1-17.6 7.1zM576.9 707.2c-3.5 0-7.1 1.3-9.8 4-5.4 5.4-5.4 14.2 0 19.6L688 851.7c2.6 2.6 6.1 4.1 9.8 4.1s7.2-1.4 9.8-4.1c2.6-2.6 4.1-6.1 4.1-9.8s-1.4-7.2-4.1-9.8L586.7 711.2c-2.7-2.7-6.3-4-9.8-4z"  ></path><path d="M900.3 203.2H125.8c-13.7 0-24.8 11.1-24.8 24.8s11.1 24.8 24.8 24.8h17.7v440c0 27.1 22 49.1 49.1 49.1h640.8c27.1 0 49.1-22 49.1-49.1v-440h17.7c13.7 0 24.8-11.1 24.8-24.8s-11-24.8-24.7-24.8z m-67.5 49.7v439.5H193.2V252.9h639.6z"  ></path><path d="M741.3 327.2l-0.2 0.2-166.3 172-181.6-106.1-0.4-0.2c-9.2-4.4-20.3-2.5-27.5 4.7l-0.2 0.2-112.9 133.4c-4.4 4.5-6.8 10.5-6.8 16.8 0.1 6.4 2.6 12.4 7.2 16.9 4.5 4.4 10.5 6.8 16.8 6.8 6.5 0 12.5-2.5 17.1-7.1l0.2-0.2 100.8-120.7 180 105.4 0.4 0.2c8.4 4 18.5 2.8 25.7-3.1l0.2-0.2L772 363.8c4.8-4.1 7.8-9.7 8.4-16 0.6-6.4-1.4-12.6-5.5-17.5-8.4-10-23.5-11.4-33.6-3.1z"  ></path></symbol><symbol id="icon-ico_yishenggongzuozhan_meilifangan" viewBox="0 0 1024 1024"><path d="M832 112a16 16 0 0 1 16 16v768a16 16 0 0 1-16 16H192a16 16 0 0 1-16-16V128a16 16 0 0 1 16-16z m0-48H192a64 64 0 0 0-64 64v768a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64z"  ></path><path d="M636.8 437.92h-2.4a16 16 0 0 1-12.8-11.04L598.24 352l-75.04-23.52a16 16 0 0 1-4.48-28.8l64-45.28-0.8-78.4A16 16 0 0 1 608 163.2l62.88 46.88 74.4-25.12a16 16 0 0 1 19.84 19.84l-25.28 74.24 46.88 63.04a16 16 0 0 1-12.96 25.6l-78.56-1.12-45.28 64a16 16 0 0 1-13.12 7.36z m-73.12-130.4l52.16 16a16 16 0 0 1 10.4 10.56l16 52 32-44.48a14.72 14.72 0 0 1 13.28-6.72h54.56l-32-43.68a16 16 0 0 1-2.24-14.72l17.44-51.68L672 243.2a16 16 0 0 1-14.72-2.4l-43.68-32v54.56a16 16 0 0 1-6.88 13.28zM288 192h176a14.08 14.08 0 0 1 16 16 14.08 14.08 0 0 1-16 16H288a14.08 14.08 0 0 1-16-16 14.08 14.08 0 0 1 16-16z m32 192h176a14.08 14.08 0 0 1 16 16 14.08 14.08 0 0 1-16 16H320a14.08 14.08 0 0 1-16-16 14.08 14.08 0 0 1 16-16z m-80-96h176a14.08 14.08 0 0 1 16 16 14.08 14.08 0 0 1-16 16H240a14.08 14.08 0 0 1-16-16 14.08 14.08 0 0 1 16-16z"  ></path><path d="M264 528h496a21.28 21.28 0 0 1 24 24 21.28 21.28 0 0 1-24 24H264a21.28 21.28 0 0 1-24-24 21.28 21.28 0 0 1 24-24z m0 144h496a24 24 0 0 1 0 48H264a24 24 0 0 1 0-48z m0 144h496a24 24 0 0 1 0 48H264a24 24 0 0 1 0-48z"  ></path></symbol><symbol id="icon-youhuayunhang" viewBox="0 0 1131 1024"><path d="M647.61 946.508H559.05V816.432H669.75c-5.535-24.908-8.302-52.583-8.302-77.491h-523.07c-35.979 0-63.655-30.444-63.655-66.422V146.68c0-35.978 27.676-66.422 63.654-66.422h802.595c35.978 0 63.654 30.444 63.654 66.422v235.243c24.908 0 52.584 2.768 74.724 8.303V143.914C1079.351 63.654 1018.465 0 940.973 0H138.378C63.654 0 0 63.654 0 143.914V669.75c0 80.26 63.654 143.914 138.378 143.914H478.79V943.74h-88.562c-22.14 0-38.746 16.605-38.746 38.745s16.605 38.746 38.746 38.746h254.616c22.14 0 38.746-16.605 38.746-38.746s-13.838-35.978-35.978-35.978z"  ></path><path d="M888.39 799.827c-85.795 0-157.752-71.957-157.752-157.751s71.957-157.752 157.751-157.752v-77.492c-130.075 0-235.243 105.168-235.243 235.244s105.168 235.243 235.243 235.243 235.243-105.168 235.243-235.243h-77.491c0 88.562-69.19 157.751-157.752 157.751z"  ></path><path d="M965.881 392.995h-24.908v190.962h190.962v-24.908c0-94.098-74.724-166.054-166.054-166.054z m27.676 138.378v-83.027c41.513 11.07 71.957 41.513 83.027 83.027h-83.027zM772.15 257.383l-301.665 251.85-135.61-132.844c-13.838-13.838-35.979-13.838-49.817 0s-13.837 35.979 0 49.816L442.811 581.19c5.535 5.535 16.605 11.07 24.908 11.07s16.605-2.767 22.14-8.302l326.573-271.222c13.838-11.07 16.606-33.21 5.536-47.049-11.07-19.372-33.211-22.14-49.817-8.302z"  ></path></symbol><symbol id="icon-koubei" viewBox="0 0 1024 1024"><path d="M910.336 113.664c0-62.464-51.2-113.664-113.664-113.664H170.496C108.032 0 56.832 50.688 56.832 113.664v796.672C56.832 972.8 107.52 1024 170.496 1024h256c15.872 0 28.16-12.8 28.16-28.672 0-15.872-12.8-28.672-28.16-28.672h-256c-31.232 0-56.832-25.6-56.832-56.832V113.664c0-31.232 25.6-56.832 56.832-56.832h625.664c31.232 0 56.832 25.6 56.832 56.832v369.664c0 15.872 12.8 28.672 28.672 28.672 15.872 0 28.672-12.8 28.672-28.672V113.664z"  ></path><path d="M953.344 645.12L890.88 582.656c-18.432-18.432-48.128-18.432-66.56 0l-288.768 289.792c-13.824 13.824-23.552 37.888-23.552 56.832v48.64c0 26.112 20.992 47.104 47.104 45.568h48.128c19.456 1.536 43.52-8.192 56.832-22.016l288.768-289.792c18.944-18.432 18.944-48.128 0.512-66.56z m-316.416 314.368c-4.608 4.608-15.872 9.216-22.528 9.216h-45.568v-46.08c0-6.656 4.608-17.92 9.216-22.528l272.896-273.92 58.88 59.392-272.896 273.92zM247.296 796.672h159.232c10.752 0 19.968 12.8 19.968 28.672s-9.216 28.672-19.968 28.672H247.296c-10.752 0-19.968-12.8-19.968-28.672 0-16.384 9.216-28.672 19.968-28.672zM227.328 654.336c0-15.872 10.24-28.672 23.04-28.672h295.424c12.8 0 23.04 12.8 23.04 28.672 0 15.872-10.24 28.672-23.04 28.672H250.368c-12.8-0.512-23.04-12.8-23.04-28.672zM370.176 534.528c-9.728 0-18.432-3.072-25.6-8.704-11.264-9.216-16.896-23.552-14.848-40.448L337.92 400.896l-52.736-81.92c-9.216-13.824-11.264-29.184-5.632-42.496 6.144-13.312 18.944-22.528 35.84-25.088l76.8-10.752 45.568-71.168c8.704-13.824 22.016-22.016 36.352-22.528 14.848-0.512 28.672 7.68 37.376 22.016l45.568 70.144 81.408 10.752c16.384 2.048 29.184 10.752 35.84 23.552 6.144 13.312 4.608 29.184-4.096 43.52L617.984 399.36l9.216 84.48c2.048 16.384-3.584 31.232-14.848 40.448-11.264 9.216-26.624 11.264-42.496 6.144l-91.648-30.72-91.136 31.232c-5.632 2.56-11.264 3.584-16.896 3.584zM325.632 296.96l55.296 86.016c3.072 4.608 4.096 9.728 3.584 14.848L375.296 486.4l95.232-32.768c4.608-1.536 10.24-1.536 14.848 0l95.232 32.256-9.728-89.088c-0.512-5.12 0.512-10.24 3.584-14.848l54.272-86.016-88.576-11.776c-6.656-1.024-12.8-4.608-16.384-10.24l-49.152-76.288-49.152 77.312c-3.584 5.632-9.728 9.728-16.384 10.24L325.632 296.96z"  ></path></symbol></svg>',
      t = (c = document.getElementsByTagName("script"))[c.length - 1].getAttribute("data-injectcss");if (t && !o.__iconfont__svg__cssinject__) {
    o.__iconfont__svg__cssinject__ = !0;try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (c) {
      console && console.log(c);
    }
  }!function (c) {
    if (document.addEventListener) {
      if (~["complete", "loaded", "interactive"].indexOf(document.readyState)) setTimeout(c, 0);else {
        var t = function t() {
          document.removeEventListener("DOMContentLoaded", t, !1), c();
        };document.addEventListener("DOMContentLoaded", t, !1);
      }
    } else document.attachEvent && (e = c, a = o.document, n = !1, l = function l() {
      n || (n = !0, e());
    }, (_h = function h() {
      try {
        a.documentElement.doScroll("left");
      } catch (c) {
        return void setTimeout(_h, 50);
      }l();
    })(), a.onreadystatechange = function () {
      "complete" == a.readyState && (a.onreadystatechange = null, l());
    });var e, a, n, l, _h;
  }(function () {
    var c, t;(c = document.createElement("div")).innerHTML = e, e = null, (t = c.getElementsByTagName("svg")[0]) && (t.setAttribute("aria-hidden", "true"), t.style.position = "absolute", t.style.width = 0, t.style.height = 0, t.style.overflow = "hidden", function (c, t) {
      t.firstChild ? function (c, t) {
        t.parentNode.insertBefore(c, t);
      }(c, t.firstChild) : t.appendChild(c);
    }(t, document.body));
  });
}(window);

/***/ }),

/***/ "Wmg/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X+PL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XdBe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d806436","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function injectStyle (ssrContext) {
  __webpack_require__("uWFK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YzYG":
/***/ (function(module, exports) {

!function (e) {
  var c,
      t = '<svg><symbol id="icon-wenbenshuru" viewBox="0 0 1024 1024"><path d="M943.104 216.064q-8.192 9.216-15.36 16.384l-12.288 12.288q-6.144 6.144-11.264 10.24l-138.24-139.264q8.192-8.192 20.48-19.456t20.48-17.408q20.48-16.384 44.032-14.336t37.888 9.216q15.36 8.192 34.304 28.672t29.184 43.008q5.12 14.336 6.656 33.792t-15.872 36.864zM551.936 329.728l158.72-158.72 138.24 138.24q-87.04 87.04-158.72 157.696-30.72 29.696-59.904 58.88t-53.248 52.224-39.424 38.4l-18.432 18.432q-7.168 7.168-16.384 14.336t-20.48 12.288-31.232 12.288-41.472 13.824-40.96 12.288-29.696 6.656q-19.456 2.048-20.992-3.584t1.536-25.088q1.024-10.24 5.12-30.208t8.192-40.448 8.704-38.4 7.68-25.088q5.12-11.264 10.752-19.456t15.872-18.432zM899.072 478.208q21.504 0 40.96 10.24t19.456 41.984l0 232.448q0 28.672-10.752 52.736t-29.184 41.984-41.984 27.648-48.128 9.728l-571.392 0q-24.576 0-48.128-10.752t-41.472-29.184-29.184-43.52-11.264-53.76l0-570.368q0-20.48 11.264-42.496t29.184-39.936 40.448-29.696 45.056-11.776l238.592 0q28.672 0 40.448 20.992t11.776 42.496-11.776 41.472-40.448 19.968l-187.392 0q-21.504 0-34.816 14.848t-13.312 36.352l0 481.28q0 20.48 13.312 34.304t34.816 13.824l474.112 0q21.504 0 36.864-13.824t15.36-34.304l0-190.464q0-14.336 6.656-24.576t16.384-16.384 21.504-8.704 23.04-2.56z"  ></path></symbol><symbol id="icon-qianjin" viewBox="0 0 1024 1024"><path d="M795.10335 512 281.764913 1024l-68.164691-68.116889 444.169919-444.169919-444.169919-444.122117 67.638876-67.591075L795.10335 512 795.10335 512z"  ></path></symbol><symbol id="icon-tel" viewBox="0 0 1024 1024"><path d="M776.676 1010.080h-479.92c-28.332 0-51.33-22.999-51.33-51.33v-891.12c0-28.332 22.999-51.33 51.33-51.33h479.92c28.332 0 51.33 22.999 51.33 51.33v891.12c0 28.332-22.999 51.33-51.33 51.33v0zM536.576 958.751c19.073 0 34.221-15.426 34.221-34.221s-15.426-34.221-34.221-34.221-34.221 15.426-34.221 34.221 15.426 34.221 34.221 34.221v0zM776.676 118.96h-479.92v719.742h479.641v-719.742h0.279z"  ></path></symbol><symbol id="icon-zhuceyaoqing" viewBox="0 0 1024 1024"><path d="M493.411643 554.452881c-132.722814 0-240.718457-107.974154-240.718457-240.696967 0-132.701325 107.995643-240.675478 240.718457-240.675478s240.675478 107.974154 240.675478 240.675478C734.087121 446.478727 626.134457 554.452881 493.411643 554.452881zM493.411643 139.247414c-96.235808 0-174.551478 78.294181-174.551478 174.508499 0 96.235808 78.31567 174.529989 174.551478 174.529989s174.508499-78.294181 174.508499-174.529989C667.920142 217.541595 589.647451 139.247414 493.411643 139.247414z"  ></path><path d="M96.92347 950.919565c-18.264992 0-33.083489-14.818497-33.083489-33.083489 0-236.863662 192.686511-429.550173 429.571662-429.550173 104.808044 0 205.739804 38.188764 284.22739 107.521852 13.699 12.0832 14.991436 32.997532 2.929726 46.696532-12.147668 13.72049-33.040511 14.925944-46.696532 2.885723-66.425875-58.650795-151.806451-90.937129-240.460584-90.937129-200.398146 0-363.404684 163.006538-363.404684 363.383194C130.007983 936.101067 115.188462 950.919565 96.92347 950.919565z"  ></path><path d="M927.075507 837.861626 701.003632 837.861626c-18.264992 0-33.083489-14.818497-33.083489-33.083489s14.818497-33.083489 33.083489-33.083489l226.071875 0c18.264992 0 33.083489 14.818497 33.083489 33.083489S945.340499 837.861626 927.075507 837.861626z"  ></path><path d="M814.040081 950.898075c-18.264992 0-33.083489-14.818497-33.083489-33.083489L780.956591 691.741687c0-18.264992 14.818497-33.083489 33.083489-33.083489s33.083489 14.818497 33.083489 33.083489l0 226.071875C847.12357 936.079578 832.305073 950.898075 814.040081 950.898075z"  ></path></symbol><symbol id="icon-21shuru" viewBox="0 0 1024 1024"><path d="M863.898914 438.098143c-18.405996 0-31.992992 14.926996-31.992992 33.314992v407.5209c0 43.811989-33.926992 81.06198-77.725981 81.061981H158.885086c-43.794989 0-94.747977-37.249991-94.747977-81.061981V282.588181c0-43.849989 50.952988-90.596978 94.747977-90.596978H499.160003c18.399996 0 33.275992-13.596997 33.275992-32.001992 0-18.405996-14.874996-32.000992-33.275992-32.000992H158.886086C71.380108 127.988219 0.151125 194.880202 0.151125 282.590181v596.344854C0.150125 966.627014 71.378108 1024 158.886086 1024h595.295855c87.536979 0 141.709965-57.372986 141.709965-145.064965V471.413135c0-18.387996-13.590997-33.314992-31.992992-33.314992zM995.049882 76.676231l-48.736988-48.809988c-37.085991-37.154991-102.252975-37.154991-139.329966 0l-92.096978 108.284974L224.08707 606.090102v11.469997l-0.365 1.963-61.739985 209.317949 45.331989 40.46599 198.033952-69.841983 2.497999 0.525h9.716998L886.889908 308.506175l108.158974-88.340979c38.398991-38.460991 38.398991-104.999974 0-143.489965zM249.175064 782.868059l28.832993-91.841978 57.604986 57.682986-86.437979 34.158992z m145.020965-68.502983l-84.78598-84.90198 438.772893-436.598893 82.06998 82.20298-436.056893 439.297893zM948.629893 169.697209l-65.389984 65.432984-95.190976-95.337977 65.354984-65.429984c6.181998-6.173998 14.405996-9.557998 23.239994-9.557998 8.812998 0 17.052996 3.383999 23.213994 9.558998l48.702988 48.796988c12.845997 12.847997 12.845997 33.719992 0.069 46.536989z" fill="" ></path></symbol><symbol id="icon-dianhua" viewBox="0 0 1024 1024"><path d="M791.1104234 894.03252951c-13.74075318 5.36684346-29.22855843-1.42026535-34.59540185-15.16101852-5.36684346-13.73918207 1.42026535-29.22855843 15.16101851-34.59540187 14.39746878-5.62450222 27.85699685-13.2505731 39.42493255-22.30947805 1.09976302-0.86095732 2.24822979-1.62450706 3.43597384-2.28907812l27.22384757-26.65354191c12.95835034-13.08717973 13.29613469-33.47364362 1.4328341-45.37465038l-113.10276934-113.11062478c-11.94656837-11.89943568-32.39116259-11.5192319-45.43592289 1.52709948l-56.99286097 56.9834344a26.70853004 26.70853004 0 0 1-31.75172895 4.51845488c-3.42968948-1.885308-7.10289789-3.92772502-11.32755893-6.29378656-29.14371956-16.14609196-44.59381865-25.24741635-64.65978016-38.86719559-27.59776701-18.73367719-53.40134919-39.77685671-78.37539588-64.76504319-25.03689029-25.03689029-46.11149158-50.88917628-64.88287495-78.54350252-13.61977923-20.06124827-22.58756097-35.27882602-38.96303209-64.76975648-3.36213261-6.08640267-4.38334111-7.92143579-5.92615148-10.61271296a26.70853004 26.70853004 0 0 1 4.29693115-32.18692091l38.23404632-38.17748707 18.81537388-18.83108479c13.06361339-13.06832662 13.42967735-33.47992797 1.51610183-45.41078545l-113.12947784-113.1546153c-11.8962935-11.8962935-32.32674789-11.51608972-45.34322858 1.50824641l-26.23406087 26.38645662c-0.75569429 1.45640044-1.65592886 2.8593838-2.7007037 4.19481031-9.05733388 11.55222479-16.6755493 24.97090451-22.37232165 39.4783496-5.31028421 14.01412284-8.58286469 27.21913429-10.06911584 40.38801071-13.79417023 114.32507734 39.20340885 220.34380185 187.58029093 368.73011046 60.94415231 60.94258122 121.68877619 105.97473398 181.27393564 137.19857669 40.49798702 21.21914159 78.87814469 35.22540896 114.60473138 43.27253195 14.39118443 3.23958759 23.42966523 17.53336443 20.18850654 31.92454888-3.24115867 14.38961334-17.53336443 23.42809412-31.92454887 20.18693543-40.23247279-9.06047605-83.00382704-24.67082634-127.66048928-48.06906973-64.4335432-33.76272418-129.53794185-82.02660908-194.25271018-146.74294846-158.78692444-158.79320879-218.94710284-279.10413905-202.87799428-412.59337227 2.00785302-17.72189523 6.37391214-35.27725493 13.24585981-53.3856383 6.62371546-16.90492844 15.09346165-32.55926924 25.18300165-46.62209585a26.60483811 26.60483811 0 0 1 6.24979605-9.93871535l31.93554649-32.12250621c33.62132607-33.63389478 87.86477951-34.64567674 120.9456506-1.56323456l113.14361767 113.16718403c33.06201802 33.10915073 32.09108442 87.30547147-1.51924401 120.92679754l-18.83265587 18.84993785-23.96226474 23.92770074c13.32284321 23.84914625 21.29141174 37.15784965 32.74937111 54.04078285 16.94420567 24.95990686 35.89783549 48.21046784 58.4649723 70.77760463 22.50115102 22.51371974 45.69829491 41.43121447 70.60007147 58.33457181 16.90492844 11.4752414 30.4100181 19.550644 54.21517382 32.82007017l42.74464571-42.73836135c33.58361991-33.58204881 87.77836956-34.59383078 120.94250845-1.56166348l113.17032618 113.17818167c33.01331423 33.12171945 32.03452516 87.30547147-1.51453077 120.93622407l-32.52941849 31.85227872a26.63311773 26.63311773 0 0 1-8.72897606 5.70305671c-14.28120813 10.35819639-30.23876929 19.04161083-47.11384703 25.6323334z"  ></path></symbol><symbol id="icon-changjianwenti" viewBox="0 0 1024 1024"><path d="M395.3 407.3h184.9v53.5H395.3zM395.3 532.2h142.4v53.5H395.3zM395.3 650.6h233.5v53.5H395.3z" fill="#00AC4E" ></path><path d="M780.5 829.7h-537V233.9h206.7v40h123.4v-40h206.7v595.8z m-483.4-53.5H727V287.4h-99.7v40H396.7v-40H297v488.8z" fill="#232323" ></path><path d="M627.3 327.4H396.7V194.3h230.5v133.1z m-177-53.5h123.4v-26.1H450.3v26.1z" fill="#232323" ></path></symbol><symbol id="icon-kefu" viewBox="0 0 1024 1024"><path d="M798.758 373.71h48.743c-24.974-62.793-66.801-115.811-119.227-154.443-59.578-43.906-132.905-69.244-210.781-69.244-77.877 0-151.202 25.338-210.781 69.244-52.428 38.633-94.252 91.65-119.226 154.443h36.649c13.824 0 26.473 5.69 35.683 14.855l0.049 0.057 0.055 0.047c9.179 9.209 14.857 21.853 14.857 35.683v261.945c0 13.838-5.69 26.472-14.857 35.684l-0.055 0.044-0.049 0.058c-9.21 9.179-21.854 14.854-35.683 14.854h-59.029c-30.113 0-57.505-12.332-77.369-32.188l-0.102-0.102c-19.852-19.864-32.188-47.255-32.188-77.363V483.375c0-30.186 12.331-57.607 32.194-77.471l0.053 0.053c12.058-12.052 26.866-21.333 43.356-26.781 26.933-82.614 78.645-152.116 145.341-201.27 68.221-50.273 152.092-79.282 241.101-79.282 89.004 0 172.881 29.008 241.102 79.282 68.225 50.279 120.78 121.851 147.162 206.96a110.937 110.937 0 0 1 29.441 21.09l0.053-0.053c19.864 19.864 32.196 47.285 32.196 77.471v143.909c0 30.108-12.336 57.499-32.188 77.363l-0.102 0.102c-19.864 19.855-47.259 32.188-77.371 32.188h-16.381l6.668 4.748c-38.188 53.37-88.051 95.872-144.725 125-56.787 29.189-120.37 45.037-185.856 45.037l-2.038-0.004c-8.404 8.768-20.244 14.229-33.354 14.229-25.525 0-46.211-20.69-46.211-46.213s20.686-46.209 46.211-46.209c18.563 0 34.57 10.949 41.918 26.74 55.055-1.005 108.27-14.709 155.845-39.162a355.11 355.11 0 0 0 107.883-85.391c-9.464-2.136-17.972-6.958-24.673-13.63l-0.049-0.058-0.053-0.044c-9.179-9.212-14.859-21.838-14.859-35.684V424.352c0-13.83 5.681-26.473 14.859-35.683l0.053-0.047 0.049-0.057c9.214-9.179 21.839-14.855 35.686-14.855zM223.38 425.108h-58.274c-16.059 0-30.619 6.528-41.125 17.034v0.102c-10.571 10.57-17.136 25.136-17.136 41.131v143.909c0 16.03 6.549 30.609 17.083 41.172 10.563 10.533 25.143 17.084 41.178 17.084h58.274V425.108z m634.407 0h-58.273V685.54h58.273c16.034 0 30.617-6.551 41.18-17.084 10.533-10.563 17.08-25.142 17.08-41.172V483.375c0-15.995-6.566-30.561-17.134-41.131v-0.102c-10.505-10.505-25.067-17.034-41.126-17.034z" fill="#999999" ></path></symbol><symbol id="icon-zixun" viewBox="0 0 1024 1024"><path d="M868 621.1c-19.2 42.3-46.8 80.5-82 113.3-35.3 32.9-76.5 58.8-122.5 76.9-47.7 18.8-98.3 28.3-150.5 28.3-45.7 0-90.6-7.3-133.1-21.9-8.6-2.9-17.9-2-25.7 2.4l-100.5 57.1-15.9-135.3c-0.8-7-3.9-13.5-8.8-18.5-65-65.8-100.8-151.1-100.8-240.3 0-47.8 10.1-94.2 29.9-137.9 19.2-42.3 46.8-80.5 82-113.3 35.3-32.9 76.5-58.8 122.5-76.9 47.6-18.7 98.2-28.3 150.4-28.3s102.9 9.5 150.5 28.3c45.9 18.1 87.1 43.9 122.5 76.9 35.2 32.8 62.8 70.8 82 113.3 19.9 43.7 29.9 90.1 29.9 137.9 0 47.9-10.1 94.2-29.9 138z m57.4-302c-22.7-49.9-55.1-94.8-96.5-133.3-41.1-38.3-89-68.4-142.2-89.4-55-21.6-113.4-32.6-173.6-32.6-60.2 0-118.6 11-173.6 32.6-53.3 21-101.1 51.1-142.2 89.4-41.3 38.5-73.7 83.3-96.5 133.3-23.5 52-35.5 107.1-35.5 164 0 102.3 39.4 200 111.3 276.7l20.2 172c1.2 10.5 7.6 19.7 17.1 24.4 4.4 2.2 9.2 3.4 14.2 3.4 5.3 0 10.8-1.4 15.6-4.1l129.7-73.7c45 13.8 91.9 20.8 139.8 20.8 60.2 0 118.6-11 173.6-32.6 53.3-21 101.1-51.1 142.2-89.4 41.3-38.5 73.7-83.3 96.5-133.3 23.6-52 35.5-107.1 35.5-164-0.1-57-12.1-112.2-35.6-164.2z"  ></path><path d="M513 435.5c-26.6 0-48.1 21.5-48.1 48.1s21.6 48.1 48.1 48.1 48.1-21.5 48.1-48.1-21.6-48.1-48.1-48.1zM705.5 435.5c-26.6 0-48.1 21.5-48.1 48.1s21.6 48.1 48.1 48.1 48-21.5 48.1-48.1c0-26.5-21.6-48.1-48.1-48.1zM320.6 435.5c-26.6 0-48.1 21.5-48.1 48.1s21.6 48.1 48.1 48.1c26.6 0 48.1-21.5 48.1-48.1s-21.5-48.1-48.1-48.1z"  ></path></symbol><symbol id="icon-tupianyanzhengma" viewBox="0 0 1024 1024"><path d="M811.3 205.1c-96.9-9.3-187-41.9-264.7-92C536.1 106.4 524 103 512 103s-24.1 3.4-34.6 10.2c-77.6 50.1-167.8 82.7-264.7 92-32.8 3.2-57.7 30.8-57.7 63.7v295.6c0 197 267.8 356.6 357 356.6s357-159.6 357-356.6V268.8c0-32.9-25-60.5-57.7-63.7zM693 421.5L466.8 647.8c-12.5 12.4-32.8 12.4-45.3 0L331 557.3c-12.4-12.4-12.4-32.8 0-45.3 6.2-6.2 14.4-9.3 22.6-9.3s16.4 3.1 22.6 9.3l67.9 67.9 203.6-203.6c12.5-12.5 32.8-12.5 45.3 0 6.2 6.2 9.3 14.4 9.3 22.6 0 8.2-3.1 16.4-9.3 22.6z"  ></path></symbol><symbol id="icon-ziyuanxhdpi" viewBox="0 0 1024 1024"><path d="M808.43536 370.238386H215.56464A127.218476 127.218476 0 0 0 88.889833 496.913194V897.053358a126.946642 126.946642 0 0 0 126.674807 126.402973h592.87072A126.946642 126.946642 0 0 0 935.110167 897.053358V496.913194a127.218476 127.218476 0 0 0-126.674807-126.674808z m-244.650916 347.947969v131.295992h-104.384391v-131.567826a105.743563 105.743563 0 1 1 105.199894 0z"  ></path><path d="M790.766127 373.772233h-81.550305v-95.142023a197.079904 197.079904 0 0 0-394.159809 0v95.142023h-81.550306v-95.142023a278.63021 278.63021 0 0 1 557.26042 0z"  ></path></symbol><symbol id="icon-qitafuwu" viewBox="0 0 1024 1024"><path d="M858.4 885.7H603.1c-35.2 0-63.8-28.7-63.8-63.8V603.1c0-35.2 28.7-63.8 63.8-63.8h218.7c35.2 0 63.8 28.7 63.8 63.8V749c0 15.1-12.3 27.3-27.3 27.3-15.1 0-27.3-12.3-27.3-27.3V603.1c0-5-4.1-9.1-9.1-9.1H603.1c-5 0-9.1 4.1-9.1 9.1v218.7c0 5 4.1 9.1 9.1 9.1h255.2c15.1 0 27.3 12.3 27.3 27.3 0.1 15.2-12.2 27.5-27.2 27.5zM420.9 885.7H202.2c-35.2 0-63.8-28.7-63.8-63.8V603.1c0-35.2 28.7-63.8 63.8-63.8h218.7c35.2 0 63.8 28.7 63.8 63.8v218.7c0 35.2-28.7 63.9-63.8 63.9zM202.2 594c-5 0-9.1 4.1-9.1 9.1v218.7c0 5 4.1 9.1 9.1 9.1h218.7c5 0 9.1-4.1 9.1-9.1V603.1c0-5-4.1-9.1-9.1-9.1H202.2zM821.8 484.7H603.1c-35.2 0-63.8-28.7-63.8-63.8V202.2c0-35.2 28.7-63.8 63.8-63.8h218.7c35.2 0 63.8 28.7 63.8 63.8v218.7c0.1 35.1-28.6 63.8-63.8 63.8zM603.1 193c-5 0-9.1 4.1-9.1 9.1v218.7c0 5 4.1 9.1 9.1 9.1h218.7c5 0 9.1-4.1 9.1-9.1V202.2c0-5-4.1-9.1-9.1-9.1H603.1zM457.3 484.7H202.2c-35.2 0-63.8-28.7-63.8-63.8V202.2c0-35.2 28.7-63.8 63.8-63.8h218.7c35.2 0 63.8 28.7 63.8 63.8V348c0 15.1-12.3 27.3-27.3 27.3-15.1 0-27.3-12.3-27.3-27.3V202.2c0-5-4.1-9.1-9.1-9.1H202.2c-5 0-9.1 4.1-9.1 9.1v218.7c0 5 4.1 9.1 9.1 9.1h255.2c15.1 0 27.3 12.3 27.3 27.3 0 15.1-12.3 27.4-27.4 27.4z"  ></path></symbol><symbol id="icon-fuwuzhongxin" viewBox="0 0 1024 1024"><path d="M880.7 184.1c-85.4-83.3-213.6-99.3-315.3-48.3l-0.6 0.3c-0.8 0.4-1.6 1-2.5 1.4-23.1 12-44.2 27.4-62.6 45.8l-4.6 4.6-13.4 13.4-150.3 150.4c-8.3 8.3-8.3 21.9 0 30.2s21.9 8.3 30.2 0l180.7-180.8c90.2-73.6 225.1-67.9 308.5 13.4 43 41.8 66.5 97.3 66.5 156.5 0 52.8-19.3 103.8-54.9 144.2-2.9 3.2-5.9 6.5-9.1 9.7l-2.4 2.4L512 857.9 173 527.3c-4.5-4.5-7.8-8.1-10.4-11.3l-0.8-0.8-0.5-0.8c-77.2-87.2-72.9-215.3 9.7-297.8l2.1-2.1c43-42.1 100.6-65.3 161.9-65.3 11.1 0 22.2 0.9 33.1 2.5 6.7 1 13.5-1.1 18.3-5.9 12.1-12.1 5.8-33.5-11.2-36.1-13.3-2-26.8-3-40.2-3-69.2-0.2-138.8 25.6-191.7 77.4l-2.4 2.4C42.4 285 38.6 440 129.2 542.7c4.4 5.3 9.1 10.3 14 15.2L512 917.3l368.7-359.4 2.9-2.9c4.1-4.1 7.7-8 11.3-12.2 43.4-49.2 65.2-110.7 65.2-172-0.1-67.5-26.5-135.3-79.4-186.7zM783.1 381l1.6 1.6c12 12 33.2 5.8 35.8-10.9 6-38.9-6-79.9-35.9-109.8-20.5-20.5-46.1-32.4-72.7-36-20-2.7-31.5 22.4-17.2 36.6 3.4 3.4 7.9 5.3 12.6 6 17.2 2.5 33.8 10.3 47.1 23.5 19.8 19.8 27.5 46.8 23.7 72.5-0.9 6.1 0.7 12.2 5 16.5z" fill="#000000" ></path></symbol><symbol id="icon-qiyefuwu" viewBox="0 0 1024 1024"><path d="M263.1 433.5c-8.3-8.3-21.9-8.3-30.2 0s-8.3 21.9 0 30.2l120.7 120.7c8.3 8.3 21.9 8.3 30.2 0s8.3-21.9 0-30.2L263.1 433.5z" fill="#000000" ></path><path d="M947.8 405.7l-118.2-118c-8.2-8.1-21.4-8.1-29.5 0-8.2 8.1-8.2 21.4 0 29.5l103.4 103.3c8.2 8.1 8.2 21.4 0 29.5L800 553.2l-14.8-14.8-14.8-14.8-14.7-14.6-132.9-132.8 14.8-14.8c8.2-8.1 8.2-21.4 0-29.5-8.2-8.1-21.4-8.1-29.5 0l-29.5 29.5c-32.6 32.6-85.5 32.6-118.2 0l44.3-44.3 14.8-14.8 14.8-14.8 7.4-7.4 7.4-7.4 29.5-29.5 59.1-59c8.2-8.1 21.4-8.1 29.5 0l29.5 29.5c8.2 8.1 21.4 8.1 29.5 0 8.2-8.1 8.2-21.4 0-29.5l-44.3-44.3c-16.3-16.3-42.8-16.3-59.1 0L548.9 214l-44.3 44.3L401.2 155c-16.3-16.3-42.8-16.3-59.1 0L76.2 420.5c-16.3 16.3-16.3 42.7 0 59L475 877.8c24.4 24.3 64.3 24.3 88.6 0 11.2-11.2 17.4-26 18.2-40.9 14.9-0.7 29.7-6.9 40.9-18.1 11.3-11.3 17.2-26 18-40.9h0.2c14.9-0.7 29.7-6.9 40.9-18.1 11.3-11.3 17.2-26 18-40.9h0.2c14.9-0.7 29.7-6.9 40.9-18.1 11.3-11.3 17.2-26 18-40.9h0.2c14.9-0.7 29.7-6.9 40.9-18.1 13-13 18.8-30.4 18-47.5l129.7-129.6c16.4-16.3 16.4-42.7 0.1-59zM770.5 612.2c-8.1 8.1-21.4 8.1-29.5 0l-14.8-14.8-14.8-14.8-14.8-14.6c-8.1-8.1-21.4-8.1-29.5 0-8.1 8.1-8.1 21.4 0 29.5l14.8 14.8 14.8 14.8 14.8 14.8c8.1 8.1 8.1 21.4 0 29.5-8.1 8.1-21.4 8.1-29.5 0l-14.8-14.8-14.8-14.8-14.8-14.8c-8.1-8.1-21.4-8.1-29.5 0-8.1 8.1-8.1 21.4 0 29.5l14.8 14.8 14.8 14.8 14.8 14.8c8.1 8.1 8.1 21.4 0 29.5-8.1 8.1-21.4 8.1-29.5 0l-15-14.9-14.8-14.8-14.7-14.7c-8.1-8.1-21.4-8.1-29.5 0-8.1 8.1-8.1 21.4 0 29.5l14.8 14.8 14.8 14.8 14.8 14.8c8.1 8.1 8.1 21.4 0 29.5-8.1 8.1-21.4 8.1-29.5 0l-14.8-14.8-14.8-14.8-14.9-14.8c-8.1-8.1-21.4-8.1-29.5 0-8.1 8.1-8.1 21.4 0 29.5l29.5 29.5 14.8 14.8c8.1 8.1 8.1 21.4 0 29.5-8.1 8.1-21.4 8.1-29.5 0L120.6 464.7c-8.2-8.1-8.2-21.4 0-29.5l236.3-236c8.2-8.1 21.4-8.1 29.5 0l88.6 88.5-44.2 44.3c-16.5 16.5-16 43.2 0.6 59.6 44 43.4 112.1 47.5 160.9 12.6 0.4 0.5 0.6 1.1 1 1.5l132.9 132.8 14.8 14.8 14.8 14.8 14.8 14.8c8 7.9 8 21.2-0.1 29.3z" fill="#000000" ></path></symbol><symbol id="icon-xieboke" viewBox="0 0 1024 1024"><path d="M815.616 695.296l-33.28 35.328v0.512l-0.512 0.512c-12.288 12.288-21.504 22.016-29.696 30.72-9.216 9.216-16.384 17.408-22.528 23.552L716.8 798.72c-3.072 3.072-7.168 6.144-10.752 9.216-6.144 4.608-12.288 8.704-18.944 11.776-5.12 2.56-11.776 5.12-20.48 8.704-8.192 3.072-16.384 6.144-25.088 9.216-9.216 3.072-17.92 5.632-25.6 7.68-9.216 2.56-15.872 4.096-20.48 4.608h-2.048c-3.072 0.512-6.144 0.512-9.216 0.512-23.552 0-36.864-12.288-42.496-19.456-10.24-12.8-13.824-29.184-10.752-48.64 1.024-6.144 2.56-13.312 5.12-23.552 2.048-7.68 4.608-15.872 6.656-24.064 2.56-8.704 5.12-16.896 7.168-24.064 2.56-8.704 5.12-14.336 7.168-19.456 2.56-5.632 5.12-11.264 8.192-15.872 3.584-5.632 8.192-11.776 14.336-17.92l1.536-1.536 10.24-10.752c6.144-6.656 14.336-14.848 23.552-24.576l30.72-31.744 33.792-35.328 90.112-93.184 2.048-2.048-1.024-1.024 25.6-24.576 2.56-2.56 3.072-3.072c3.072-3.072 7.168-6.656 11.776-11.264 5.12-5.12 9.728-9.216 13.312-12.288l0.512-0.512 0.512-0.512c4.096-3.584 8.704-6.144 13.312-8.704V179.2c0-44.032-35.84-79.36-79.36-79.36H164.352c-44.032 0-79.36 35.84-79.36 79.36v664.064c0 44.032 35.84 79.36 79.36 79.36h596.992c44.032 0 79.36-35.84 79.36-79.36v-174.592l-25.088 26.624zM270.848 305.664H655.36c18.432 0 33.28 14.848 33.28 33.28s-14.848 33.28-33.28 33.28H270.848c-18.432 0-33.28-14.848-33.28-33.28s14.848-33.28 33.28-33.28z m145.92 411.648H270.848c-18.432 0-33.28-14.848-33.28-33.28s14.848-33.28 33.28-33.28h145.92c18.432 0 33.28 14.848 33.28 33.28s-15.36 33.28-33.28 33.28z m-145.92-172.544c-18.432 0-33.28-14.848-33.28-33.28s14.848-33.28 33.28-33.28h251.904c18.432 0 33.28 14.848 33.28 33.28s-14.848 33.28-33.28 33.28H270.848z"  ></path><path d="M786.432 665.088l-33.28 35.328c-11.264 11.264-20.992 21.504-30.208 31.232-8.704 9.216-16.384 16.896-22.016 23.04-6.144 6.144-9.216 9.728-10.752 10.24-2.56 2.56-6.144 5.632-9.728 8.192-3.584 3.072-7.168 5.12-11.264 7.168-4.096 2.048-9.728 4.608-17.408 7.168-7.68 3.072-15.36 5.632-23.552 8.192-8.192 2.56-15.872 5.12-23.552 7.168-7.168 2.048-12.8 3.072-16.384 4.096-1.536 0-3.072 0.512-4.608 0.512-5.12 0-8.704-1.024-10.752-3.584-2.56-3.072-3.072-8.704-2.048-15.872 0.512-4.096 2.048-9.728 4.096-17.408s4.096-15.36 6.656-23.552c2.56-8.192 4.608-15.872 6.656-23.04 2.048-6.656 4.096-11.776 5.632-14.336 1.536-4.096 3.584-7.68 5.632-10.752s5.12-7.168 9.216-10.752c1.536-2.048 5.632-6.144 11.776-12.288 6.144-6.656 13.824-14.336 23.04-24.064l30.72-31.744 33.792-35.328L798.72 490.496l78.336 81.408-90.624 93.184zM936.96 506.88c-1.536 3.584-3.584 7.168-6.656 10.752-3.072 3.584-6.144 6.656-9.216 9.216l-6.656 6.656-6.144 6.144-78.336-80.896c3.584-3.072 7.168-7.168 11.776-11.264 4.608-4.608 8.704-8.192 11.264-10.752 4.096-3.072 8.192-5.632 12.288-6.656 3.584-1.024 7.68-2.048 11.264-2.048h1.024c4.096 0 8.192 1.024 11.776 2.048 3.584 1.024 7.168 2.56 9.728 4.096 6.144 3.072 12.288 8.704 19.456 16.384 7.168 7.68 12.8 16.384 16.384 25.088 1.024 2.56 2.048 5.632 2.56 9.216 0.512 3.584 1.024 7.168 1.024 10.752 0.512 3.584 0 7.168-1.536 11.264z"  ></path></symbol><symbol id="icon-shouji" viewBox="0 0 1024 1024"><path d="M705.536 27.136H300.544c-61.44 0-111.616 50.176-111.616 111.616v735.232c0 61.44 50.176 111.616 111.616 111.616h404.992c61.44 0 111.616-50.176 111.616-111.616V138.752c0-61.44-50.176-111.616-111.616-111.616z m-239.104 36.352h72.704c9.216 0 18.432 9.216 18.432 18.432s-9.216 18.432-18.432 18.432H466.432c-9.216 0-18.432-9.216-18.432-18.432s9.216-18.432 18.432-18.432z m36.352 876.544c-25.088 0-47.616-20.48-47.616-47.616 0-25.088 20.48-47.616 47.616-47.616 25.088 0 47.616 20.48 47.616 47.616 0.512 27.136-19.968 47.616-47.616 47.616z m239.104-152.576H264.192v-20.48h477.696v20.48z"  ></path></symbol><symbol id="icon-sadasuande" viewBox="0 0 1024 1024"><path d="M873.984 50.688H177.152c-35.84 0-65.024 29.184-65.024 65.024v659.456c0 35.84 29.184 65.024 65.024 65.024h110.08V926.72c0 38.912 44.544 60.928 75.264 37.376l163.328-123.904h348.672c35.84 0 65.024-29.184 65.024-65.024V115.2c-0.512-35.84-29.696-64.512-65.536-64.512zM552.448 476.16H296.96v-48.128h255.488V476.16z m201.728-165.376H296.96v-48.128h457.216v48.128z"  ></path></symbol><symbol id="icon-shouji_icon" viewBox="0 0 1024 1024"><path d="M512 775.168c-24.576 0-44.544 19.968-44.544 44.544 0 24.576 19.968 44.544 44.544 44.544 24.576 0 44.544-19.968 44.544-44.544 0-24.576-19.968-44.544-44.544-44.544z"  ></path><path d="M292.352 952.832c-39.936 0-72.192-32.256-72.192-72.192V143.36c0-39.936 32.256-72.192 72.192-72.192H732.16c39.936 0 72.192 32.256 72.192 72.192v737.28c0 39.936-32.256 72.192-72.192 72.192H292.352zM274.944 880.64c0 9.728 7.68 17.408 17.408 17.408H732.16c9.728 0 17.408-7.68 17.408-17.408v-131.584H274.944V880.64z m474.112-189.952V143.36c0-9.728-7.68-17.408-17.408-17.408H292.352c-9.728 0-17.408 7.68-17.408 17.408v547.84h474.112z"  ></path></symbol><symbol id="icon-renwu_icon" viewBox="0 0 1024 1024"><path d="M713.216 548.352c50.176-50.176 78.336-117.248 78.336-189.952 0-156.16-122.88-279.04-279.04-279.04S232.96 202.24 232.96 358.4c0 72.704 28.16 139.776 78.336 189.952-134.144 72.704-217.6 212.48-217.6 368.64 0 16.896 11.264 28.16 28.16 28.16s28.16-11.264 28.16-28.16c0-134.144 78.336-257.024 189.952-324.096 5.632 0 11.264 0 11.264-5.632 50.176 33.28 100.352 50.176 161.792 50.176s117.248-16.896 161.792-50.176c0 5.632 5.632 5.632 5.632 5.632 117.248 67.072 195.584 189.952 195.584 324.096 0 16.896 11.264 28.16 28.16 28.16s28.16-11.264 28.16-28.16c-1.536-156.672-84.992-295.936-219.136-368.64z m-201.216 33.28C389.12 581.632 288.768 481.28 288.768 358.4S389.12 135.168 512 135.168 735.232 235.52 735.232 358.4 634.88 581.632 512 581.632z"  ></path></symbol><symbol id="icon-qian_icon" viewBox="0 0 1024 1024"><path d="M973.824 512c0-34.816-17.92-67.584-52.736-96.256l-14.848-12.288 14.848-12.288c34.816-29.184 52.736-61.44 52.736-96.256 0-114.688-198.656-201.216-461.824-201.216S50.176 180.224 50.176 294.912c0 34.816 17.92 67.072 52.736 96.256l14.336 12.288-14.848 12.288c-34.816 29.184-52.736 61.44-52.736 96.256 0 34.816 17.92 67.072 52.736 96.256l14.336 12.288-14.848 12.288c-34.816 28.672-52.736 61.44-52.736 96.256 0 114.688 198.656 201.216 461.824 201.216s461.824-86.528 461.824-201.216c0-34.816-17.92-67.584-52.736-96.256l-14.848-12.288 14.848-12.288c36.352-29.184 53.76-61.44 53.76-96.256zM105.472 294.912C105.472 217.088 295.424 148.48 512 148.48c216.576 0 406.528 68.096 406.528 145.92S728.576 440.832 512 440.832c-216.576 0-406.528-68.096-406.528-145.92z m813.056 434.176c0 77.824-189.952 145.92-406.528 145.92-216.576 0-406.528-68.096-406.528-145.92 0-24.576 20.992-50.176 60.928-73.728l14.336-1.024C266.24 692.736 384 713.216 512 713.216s245.76-20.992 331.264-58.368l7.168-3.072 7.168 4.096c39.936 23.04 60.928 48.64 60.928 73.216zM512 657.92c-216.576 0-406.528-68.096-406.528-145.92 0-24.576 20.992-50.176 60.928-73.728l7.168-4.096 7.168 3.072C266.24 475.136 384 496.128 512 496.128s245.76-20.992 331.264-58.368l7.168-3.072 7.168 4.096c39.936 23.552 60.928 48.64 60.928 73.728 0 77.312-189.952 145.408-406.528 145.408z"  ></path></symbol><symbol id="icon-suo_icon" viewBox="0 0 1024 1024"><path d="M821.76 388.096h-61.952V305.664c0-136.704-111.104-247.808-247.808-247.808S264.192 168.96 264.192 305.664v82.432H202.24c-34.304 0-61.952 27.648-61.952 61.952v454.144c0 34.304 27.648 61.952 61.952 61.952h619.52c34.304 0 61.952-27.648 61.952-61.952V450.048c0-34.304-27.648-61.952-61.952-61.952zM326.144 305.664c0-102.4 83.456-185.856 185.856-185.856s185.856 83.456 185.856 185.856v82.432H326.144V305.664z m495.616 598.528h-619.52V450.048h619.52v454.144z"  ></path><path d="M512 790.528c16.896 0 31.232-13.824 31.232-30.72v-165.376c0-16.896-13.824-30.72-31.232-30.72s-31.232 13.824-31.232 30.72v165.376c0 16.896 14.336 30.72 31.232 30.72z"  ></path></symbol><symbol id="icon-duihua" viewBox="0 0 1024 1024"><path d="M610.816 853.504L437.76 721.92H180.736V212.48H860.16V721.92h-249.344v131.584z m-378.88-182.784h223.232l104.448 79.36V670.72H808.96V263.68H231.936V670.72z" fill="#232323" ></path><path d="M313.856 329.216h364.544v51.2H313.856zM313.856 444.928h217.6v51.2H313.856zM313.856 555.008h317.44v51.2h-317.44z" fill="#00AC4E" ></path></symbol><symbol id="icon-dianhua-copy" viewBox="0 0 1024 1024"><path d="M850.73667978 975.64599729c-16.67618519 6.51336023-35.47264454-1.72367612-41.98600473-18.39986129-6.51336023-16.67427844 1.72367612-35.47264454 18.39986127-41.98600475 17.4731947-6.82606254 33.80807677-16.08128813 47.84726629-27.07544359 1.33470498-1.04488331 2.72851829-1.9715499 4.16999965-2.77809304l33.03966804-32.34752819c15.72663792-15.88298909 16.13658302-40.62460571 1.73892993-55.06802013l-137.26487206-137.27440566c-14.49870934-14.44150771-39.31087466-13.98008114-55.14238227 1.85333317l-69.16822476 69.1567844a32.41426342 32.41426342 0 0 1-38.53483904 5.48373072c-4.16237278-2.28806565-8.62028734-4.76680346-13.74746115-7.63832586-35.36968158-19.59537561-54.12037961-30.64101255-78.47302505-47.17038018-33.49346775-22.73574571-64.80945965-48.27437188-95.11870266-78.60077539-30.38551189-30.38551189-55.96227245-61.76061216-78.7437795-95.32272187-16.52936762-24.3469253-27.41293326-42.81542855-47.28669021-78.60649556-4.08038375-7.38663862-5.31975265-9.61368918-7.19215302-12.8799029a32.41426342 32.41426342 0 0 1 5.21488296-39.06300091l46.40197147-46.33332949 22.83489523-22.85396247c15.85438828-15.86010839 16.29865435-40.63223259 1.8399861-55.11187472l-137.29728629-137.32779385c-14.43769427-14.43769427-39.23269907-13.9762677-55.0298857 1.83045253l-31.83843358 32.02338558c-0.91713298 1.76753072-2.00968433 3.47023291-3.27765403 5.09094608-10.99224877 14.02012229-20.23794073 30.3054296-27.15171244 47.91209479-6.44471826 17.00795472-10.41641889 33.03394786-12.22017732 49.01608649-16.74101371 138.74830127 47.57841856 267.41576663 227.65299899 447.50178739 73.963629 73.96172227 147.68510437 128.61407715 219.99941939 166.50825782 49.14955698 25.75217895 95.72885353 42.75060003 139.08769769 52.51682691 17.46556784 3.93165949 28.43493594 21.27901058 24.50136972 38.74457844-3.93356619 17.46366111-21.27901058 28.43302918-38.74457842 24.49946298-48.82732105-10.9960622-100.73590387-29.94124583-154.93255233-58.3380473-78.19845717-40.97544244-157.21108439-99.5499232-235.75084471-178.0915902-192.7085163-192.71614317-265.72069133-338.7290529-246.21874505-500.73554157 2.43678992-21.50781714 7.73556863-42.81352185 16.07556793-64.79039243 8.03873734-20.51632204 18.31787228-39.51489387 30.56283696-56.58195693a32.28841982 32.28841982 0 0 1 7.58493767-12.06191942l38.75792546-38.98482532c40.8038375-40.81909126 106.63529982-42.04701983 146.78322514-1.89718778l137.31444682 137.34304764c40.12504468 40.18224635 38.9466909 105.956507-1.84379956 146.76034452l-22.85586916 22.87684308-29.0813145 29.03936659c16.16899727 28.94403053 25.83988815 45.09586732 39.74560714 65.58549528 20.56399005 30.29208252 43.56667679 58.50965223 70.95482268 85.89779809 27.30806357 27.32331735 55.46080473 50.28214947 85.68233859 70.79656479 20.51632204 13.92669297 36.90649901 23.72724084 65.79714132 39.83140959l51.87616855-51.86854166c40.75807619-40.75616945 106.53043013-41.98409804 146.77941174-1.89528105l137.34686105 137.35639469c40.06593633 40.19750011 38.87804891 105.956507-1.83807943 146.77178484l-39.47866611 38.65686921a32.3227408 32.3227408 0 0 1-10.59374398 6.92139861c-17.33209733 12.57101405-36.69866637 23.10946309-57.17876072 31.10815928z"  ></path></symbol></svg>',
      l = (c = document.getElementsByTagName("script"))[c.length - 1].getAttribute("data-injectcss");if (l && !e.__iconfont__svg__cssinject__) {
    e.__iconfont__svg__cssinject__ = !0;try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (c) {
      console && console.log(c);
    }
  }!function (c) {
    if (document.addEventListener) {
      if (~["complete", "loaded", "interactive"].indexOf(document.readyState)) setTimeout(c, 0);else {
        var l = function l() {
          document.removeEventListener("DOMContentLoaded", l, !1), c();
        };document.addEventListener("DOMContentLoaded", l, !1);
      }
    } else document.attachEvent && (h = c, o = e.document, i = !1, (_a = function a() {
      try {
        o.documentElement.doScroll("left");
      } catch (c) {
        return void setTimeout(_a, 50);
      }t();
    })(), o.onreadystatechange = function () {
      "complete" == o.readyState && (o.onreadystatechange = null, t());
    });function t() {
      i || (i = !0, h());
    }var h, o, i, _a;
  }(function () {
    var c, l;(c = document.createElement("div")).innerHTML = t, t = null, (l = c.getElementsByTagName("svg")[0]) && (l.setAttribute("aria-hidden", "true"), l.style.position = "absolute", l.style.width = 0, l.style.height = 0, l.style.overflow = "hidden", function (c, l) {
      l.firstChild ? function (c, l) {
        l.parentNode.insertBefore(c, l);
      }(c, l.firstChild) : l.appendChild(c);
    }(l, document.body));
  });
}(window);

/***/ }),

/***/ "ZbPA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZdbJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a3SX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a761":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aGne":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "akPl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b4zm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b8fh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bLMB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bPw3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "boBm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwKU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c/XZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cpHA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "csIS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d1Qw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dcES":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ejnP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eoOV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f8sx":
/***/ (function(module, exports) {

!function (o) {
  var c,
      l = '<svg><symbol id="icon-code" viewBox="0 0 1024 1024"><path d="M140.17146 140.076292l148.672064 0 0 148.672064-148.672064 0 0-148.672064Z"  ></path><path d="M735.735667 140.076292l148.672064 0 0 148.672064-148.672064 0 0-148.672064Z"  ></path><path d="M140.17146 736.152153l148.672064 0 0 148.672064-148.672064 0 0-148.672064Z"  ></path><path d="M102.820784 512.502443l74.308403 0 0 74.308403-74.308403 0 0-74.308403Z"  ></path><path d="M475.348242 656.284127l74.308403 0 0 79.219249-74.308403 0 0-79.219249Z"  ></path><path d="M661.514245 656.284127l74.308403 0 0 79.219249-74.308403 0 0-79.219249Z"  ></path><path d="M475.348242 885.474017l74.308403 0 0 74.308403-74.308403 0 0-74.308403Z"  ></path><path d="M661.066037 885.474017l77.848019 0 0 74.308403-77.848019 0 0-74.308403Z"  ></path><path d="M724.186633 661.194974l86.348624 0 0 74.308403-86.348624 0 0-74.308403Z"  ></path><path d="M810.754245 736.152153l74.308403 0 0 74.308403-74.308403 0 0-74.308403Z"  ></path><path d="M885.057531 587.029834l74.308403 0 0 148.846026-74.308403 0 0-148.846026Z"  ></path><path d="M885.057531 811.051003l74.308403 0 0 148.846026-74.308403 0 0-148.846026Z"  ></path><path d="M587.197656 736.037543l74.308403 0 0 148.846026-74.308403 0 0-148.846026Z"  ></path><path d="M400.653029 736.037543l74.308403 0 0 148.846026-74.308403 0 0-148.846026Z"  ></path><path d="M736.226854 811.051003l74.308403 0 0 148.846026-74.308403 0 0-148.846026Z"  ></path><path d="M661.066037 660.94324l75.203796 0 0 149.517315-75.203796 0 0-149.517315Z"  ></path><path d="M810.754245 438.07943l74.308403 0 0 148.846026-74.308403 0 0-148.846026Z"  ></path><path d="M474.845799 437.94333l74.308403 0 0 80.326467-74.308403 0 0-80.326467Z"  ></path><path d="M623.911836 437.94333l74.308403 0 0 80.326467-74.308403 0 0-80.326467Z"  ></path><path d="M326.783625 464.549292l74.308403 0 0 80.326467-74.308403 0 0-80.326467Z"  ></path><path d="M549.154201 363.634928l74.308403 0 0 74.308403-74.308403 0 0-74.308403Z"  ></path><path d="M475.348242 275.776927l74.308403 0 0 87.279832-74.308403 0 0-87.279832Z"  ></path><path d="M400.61005 140.076292l74.308403 0 0 83.000366-74.308403 0 0-83.000366Z"  ></path><path d="M474.845799 65.399499l74.308403 0 0 74.308403-74.308403 0 0-74.308403Z"  ></path><path d="M400.653029 214.412324l223.698828 0 0 74.308403-223.698828 0 0-74.308403Z"  ></path><path d="M624.37744 437.94333l260.803911 0 0 74.308403-260.803911 0 0-74.308403Z"  ></path><path d="M177.38092 437.94333l223.229131 0 0 74.308403-223.229131 0 0-74.308403Z"  ></path><path d="M326.783625 512.502443l371.436614 0 0 74.308403-371.436614 0 0-74.308403Z"  ></path><path d="M475.230562 586.810846l260.996293 0 0 74.308403-260.996293 0 0-74.308403Z"  ></path><path d="M65.835428 65.820078 65.835428 363.287003l297.466925 0L363.302353 65.820078 65.835428 65.820078zM326.708923 326.693574 102.429881 326.693574 102.429881 102.414531l224.279043 0L326.708923 326.693574z"  ></path><path d="M65.835428 661.754722l0 297.466925 297.466925 0L363.302353 661.754722 65.835428 661.754722zM326.708923 922.628218 102.429881 922.628218 102.429881 698.349175l224.279043 0L326.708923 922.628218z"  ></path><path d="M661.33926 65.820078 661.33926 363.287003l297.466925 0L958.806185 65.820078 661.33926 65.820078zM922.211732 326.693574 697.93269 326.693574 697.93269 102.414531l224.279043 0L922.211732 326.693574z"  ></path></symbol><symbol id="icon-checked" viewBox="0 0 1024 1024"><path d="M512 128C299.92 128 128 299.92 128 512s171.92 384 384 384 384-171.92 384-384S724.08 128 512 128zM732.624 392.4 472.4 652.624c-9.36 9.376-24.56 9.376-33.936 0l-147.072-147.088c-9.376-9.376-9.376-24.576 0-33.936 9.376-9.376 24.576-9.376 33.936 0l130.112 130.112 243.264-243.264c9.36-9.376 24.56-9.376 33.936 0S742 383.024 732.624 392.4z"  ></path></symbol><symbol id="icon-unchecked" viewBox="0 0 1024 1024"><path d="M512 143.984c202.912 0 368 165.088 368 368 0 202.912-165.088 368-368 368S144 714.912 144 512C144 309.072 309.072 143.984 512 143.984M512 111.984c-220.912 0-400 179.088-400 400s179.072 400 400 400 400-179.072 400-400S732.912 111.984 512 111.984L512 111.984z"  ></path></symbol><symbol id="icon-4" viewBox="0 0 1024 1024"><path d="M711.841477 976.738462l88.300308-86.171569L404.393354 513.969231 800.141785 137.371569 711.841477 51.2 227.796677 513.969231 711.841477 976.738462z"  ></path></symbol><symbol id="icon-yanzhengma" viewBox="0 0 1024 1024"><path d="M849.548294 820.698734l-49.879014 0 0 70.864978c-2.350534 16.980743-24.951275 23.639396-24.951275 23.639396L151.259494 915.203108c-16.386202-1.469468-24.952298-23.639396-24.952298-23.639396L126.307196 135.534859c-2.350534-16.980743 24.952298-23.639396 24.952298-23.639396L774.718005 111.895463c20.259416 0.738827 24.951275 23.639396 24.951275 23.639396l0 307.152519 49.879014 0L849.548294 88.266299c-5.478781-21.393239-24.963555-23.61893-24.963555-23.61893l-723.221656 0c-19.47454 1.476631-24.932856 23.61893-24.932856 23.61893l0 850.555739c1.563612 16.978696 24.932856 23.62814 24.932856 23.62814l723.221656 0c25.719778-5.918803 24.963555-23.62814 24.963555-23.62814L849.548294 820.698734z"  ></path><path d="M240.767064 388.848169l444.450535 0 0 60.255339-444.450535 0 0-60.255339Z"  ></path><path d="M894.304637 493.904876 669.847539 718.344578l-99.762121-124.685767c-85.488023-28.511357-49.873897 49.876967-49.873897 49.876967l99.749842 124.704187c46.336328 53.452399 99.763145 0 99.763145 0l224.458121-224.458121C962.004529 465.394543 894.304637 493.904876 894.304637 493.904876z"  ></path></symbol><symbol id="icon-search" viewBox="0 0 1024 1024"><path d="M922.666667 876.373333 702.677333 648.405333C805.290667 511.701333 796.245333 314.133333 675.008 188.501333 609.344 120.448 523.264 86.421333 437.205333 86.421333 351.146667 86.421333 265.066667 120.448 199.402667 188.501333 68.074667 324.608 68.074667 545.258667 199.402667 681.344 265.066667 749.397333 351.146667 783.424 437.205333 783.424 510.058667 783.424 582.762667 758.762667 643.221333 710.016L863.210667 937.984 922.666667 876.373333ZM258.858667 619.733333C160.512 517.824 160.512 352.021333 258.858667 250.112 306.496 200.746667 369.834667 173.546667 437.205333 173.546667 504.576 173.546667 567.914667 200.746667 615.552 250.112 713.898667 352.021333 713.898667 517.824 615.552 619.733333 567.914667 669.098667 504.576 696.298667 437.205333 696.298667 369.834667 696.298667 306.496 669.098667 258.858667 619.733333Z"  ></path></symbol><symbol id="icon-clock" viewBox="0 0 1024 1024"><path d="M 512 62.587 c -247.813 0 -449.413 201.6 -449.413 449.413 s 201.6 449.413 449.413 449.413 s 449.411 -201.6 449.411 -449.413 c 0 -247.813 -201.598 -449.413 -449.411 -449.413 Z M 512 902.718 c -215.432 0 -390.718 -175.285 -390.718 -390.718 s 175.285 -390.718 390.718 -390.718 s 390.718 175.285 390.718 390.718 c 0 215.432 -175.266 390.718 -390.718 390.718 Z"  ></path><path d="M 738.546 482.652 h -197.198 v -262.507 c 0 -16.22 -13.148 -29.347 -29.348 -29.347 s -29.348 13.128 -29.348 29.347 v 285.966 c 0 1.859 0.216 3.639 0.547 5.4 c 0 0.157 -0.039 0.313 -0.039 0.47 c 0 16.22 13.147 29.347 29.347 29.347 h 226.057 c 16.2 0 29.347 -13.128 29.347 -29.348 s -13.167 -29.328 -29.367 -29.328 Z"  ></path></symbol><symbol id="icon-v" viewBox="0 0 1240 1024"><path d="M0.269389 0C0.269389 0 0.269389 91.053352 0.269389 91.053352 0.269389 91.053352 145.146585 91.053352 145.146585 91.053352 145.146585 91.053352 628.860781 972.115753 628.860781 972.115753 628.860781 972.115753 1126.583184 91.053352 1126.583184 91.053352 1126.583184 91.053352 1228.19657 91.053352 1228.19657 91.053352 1228.19657 91.053352 1228.19657 0 1228.19657 0 1228.19657 0 1042.857203 0 1042.857203 0 1042.857203 0 726.541092 530.264548 726.541092 530.264548 726.541092 530.264548 428.866674 0 428.866674 0 428.866674 0 0.269389 0 0.269389 0Z"  ></path></symbol><symbol id="icon-dianhua2" viewBox="0 0 1024 1024"><path d="M81.275072 759.350504c0 160.76959 73.698512 160.441109 429.574732 160.441109 355.852684 0 429.553243 0.327458 429.553243-160.441109 0-175.470407-192.32119-525.560854-429.553243-525.560854C273.601378 233.789651 81.275072 583.880097 81.275072 759.350504L81.275072 759.350504zM509.594207 309.032332c100.805894 0 182.513824 82.199117 182.513824 183.594435 0 101.406574-81.70793 183.589318-182.513824 183.589318-100.787474 0-182.501544-82.182744-182.501544-183.589318C327.092663 391.230426 408.806733 309.032332 509.594207 309.032332L509.594207 309.032332zM892.134717 444.175265C817.311591 323.689147 687.97285 195.140399 511.744173 195.140399c-176.174442 0-313.924759 139.115408-376.3536 247.971651-32.261775 54.019311-94.216825 48.300053-121.219829 0C-3.183506 406.969898-57.409524 104.208387 511.744173 104.208387c575.547315 0.771573 516.074805 312.818565 495.866554 338.903663C971.814454 497.853815 904.376529 469.946208 892.134717 444.175265L892.134717 444.175265zM892.134717 444.175265"  ></path></symbol><symbol id="icon-weixinzhifu" viewBox="0 0 1025 1024"><path d="M537.622015 410.308169"  ></path><path d="M316.914611 320.110779c-19.899085 0-39.991474 13.179462-39.991474 33.147073 0 19.835673 20.03 33.141959 39.991474 33.141959 19.960451 0 33.141959-13.374812 33.141959-33.210485C350.055547 333.226829 336.811651 320.110779 316.914611 320.110779L316.914611 320.110779zM502.466215 386.335376c20.03 0 33.210485-13.3114 33.210485-33.141959 0-19.967611-13.180485-33.147073-33.210485-33.147073-19.835673 0-39.732712 13.11605-39.732712 33.147073C462.733503 373.023976 482.693954 386.335376 502.466215 386.335376L502.466215 386.335376zM588.659445 512.512921c-13.180485 0-26.491884 13.180485-26.491884 26.428472 0 13.369698 13.3114 26.484725 26.491884 26.484725 20.087275 0 33.208439-13.11605 33.208439-26.484725C621.867884 525.693406 608.810133 512.512921 588.659445 512.512921L588.659445 512.512921zM734.604138 512.512921c-13.11605 0-26.427449 13.242874-26.427449 26.48677 0 13.374812 13.3114 26.490861 26.427449 26.490861 19.962497 0 33.205371-13.11605 33.205371-26.490861C767.746096 525.693406 754.503223 512.512921 734.604138 512.512921L734.604138 512.512921zM827.32471 1.022774 197.701132 1.022774c-108.570496 0-196.678359 88.113999-196.678359 196.678359l0 629.618463c0 108.57561 88.044451 196.680404 196.678359 196.680404L827.32471 1024c96.745187 0 177.243613-69.948516 193.678563-161.95826l3.06423-160.683884L1024.067503 197.701132C1024.067503 89.130636 935.958618 1.022774 827.32471 1.022774L827.32471 1.022774zM403.09966 658.396247c-33.141959 0-59.695209-6.656211-92.842282-13.242874l-92.710344 46.453358 26.554273-79.726232c-66.41381-46.452336-106.153682-106.217094-106.153682-179.033467 0-126.173454 119.396556-225.476598 265.215447-225.476598 130.4016 0 244.548259 79.404059 267.580099 186.194928-8.571866-0.963453-17.081343-1.538252-25.589798-1.538252-125.989355 0-225.35591 93.995971-225.419322 209.801568 0 19.393835 3.006955 37.947972 8.19344 55.667527-8.256852 0.516501-16.507567 0.894927-24.826809 0.894927L403.100682 658.396247zM794.10502 751.365353l20.03 66.2921-72.74887-39.934199c-26.490861 6.656211-53.170936 13.247988-79.530882 13.247988-126.177545 0-225.480689-86.122659-225.480689-192.334639 0-106.021744 99.303144-192.404187 225.480689-192.404187 119.138817 0 225.287384 86.382443 225.287384 192.404187C887.078217 658.396247 847.408917 711.378993 794.10502 751.365353L794.10502 751.365353zM794.10502 751.365353"  ></path></symbol><symbol id="icon-dianhua" viewBox="0 0 1024 1024"><path d="M490.607477 623.643546C489.940086 623.643546 484.600571 615.133794 474.58906 598.114162 464.57755 581.09453 453.564952 562.406548 441.551012 542.049704 429.537199 521.692859 418.357754 503.004877 408.012548 485.985245 397.667213 468.965613 392.494675 460.122166 392.494675 459.454774 382.483164 437.429323 375.475171 416.405343 371.470567 396.382195 367.465834 376.359045 373.806436 361.341972 390.492372 351.330461L251.332378 117.060989C241.988258 123.735414 230.641991 138.251944 217.293242 160.611091 203.944493 182.970238 195.768509 214.506272 192.765041 255.219961 189.761572 295.933523 195.601562 346.491234 210.285185 406.894248 224.968806 467.297391 256.337889 538.878954 304.393383 621.641116 354.451191 709.075526 403.17332 775.48455 450.561436 820.87024 497.949551 866.255974 541.165444 898.292486 580.210527 916.980736 619.255611 935.668986 652.293274 944.345542 679.324416 943.010662 706.355686 941.675789 724.876819 938.33865 734.888333 932.999155L598.73179 703.735629C582.713245 713.07975 566.861932 710.576774 551.177084 696.226963 535.492362 681.877024 515.302621 657.68281 490.607477 623.643546L490.607477 623.643546 490.607477 623.643546ZM827.995443 843.89671C827.995443 843.89671 822.489082 834.552736 811.476352 815.864544 800.463629 797.176179 788.283098 776.65287 774.934374 754.293728 761.585651 731.934579 749.40512 711.411142 738.39239 692.722906 727.379667 674.034662 721.873306 664.690675 721.873306 664.690675 717.868698 658.01625 711.86192 653.67808 703.852717 651.675776 695.843379 649.673344 688.167994 650.67456 680.826176 654.679162L616.752509 692.722906 751.907962 922.987642C751.907962 922.987642 762.753587 916.48023 784.445338 903.46519 806.136966 890.450163 816.98272 883.942752 816.98272 883.942752 824.324538 879.938125 828.996531 873.931283 830.998835 865.922035 833.001133 857.912787 832.000045 850.571085 827.995443 843.89671L827.995443 843.89671 827.995443 843.89671ZM472.586758 303.275212 472.586758 302.273996C479.928575 298.269392 484.600571 292.262486 486.602873 284.253277 488.605175 276.244069 487.604088 268.90238 483.599484 262.227955 483.599484 262.227955 477.926273 252.550268 466.579852 233.19451 455.233431 213.838881 442.719203 192.8149 429.036656 170.122058 415.354237 147.429216 402.840009 126.405236 391.493588 107.049606 380.147038 87.693849 374.473956 78.016162 374.473956 78.016162 370.469352 71.341736 364.462445 67.003565 356.453237 65.001135 348.444029 62.998832 340.768516 64.000047 333.426699 68.004652L269.353096 106.048391 407.512004 341.318823C407.512004 341.318823 418.357626 334.978349 440.049381 322.297017 461.741009 309.615685 472.586758 303.275212 472.586758 303.275212L472.586758 303.275212 472.586758 303.275212Z"  ></path></symbol><symbol id="icon-close" viewBox="0 0 1024 1024"><path d="M828.324924 194.494693c-175.027315-175.028339-458.803427-175.028339-633.830743 0-175.027315 175.027315-175.027315 458.803427 0 633.831766 175.028339 175.027315 458.803427 175.026292 633.830743-0.001023S1003.352239 369.522008 828.324924 194.494693zM510.324336 539.26804 262.148024 787.444353l-28.943193-28.943193 248.176312-248.176312L233.203808 262.147512l28.943193-28.943193 248.177336 248.176312L758.501672 233.204319l28.943193 28.943193L539.267529 510.324848l248.176312 248.176312-28.943193 28.943193L510.324336 539.26804z"  ></path></symbol><symbol id="icon-checkcircleoutline" viewBox="0 0 1024 1024"><path d="M337.066667 430.933333l-59.733333 59.733333L469.333333 682.666667 896 256l-59.733333-59.733333L469.333333 563.2 337.066667 430.933333zM853.333333 512c0 187.733333-153.6 341.333333-341.333333 341.333333s-341.333333-153.6-341.333333-341.333333 153.6-341.333333 341.333333-341.333333c34.133333 0 64 4.266667 93.866667 12.8l68.266667-68.266667C622.933333 98.133333 567.466667 85.333333 512 85.333333 277.333333 85.333333 85.333333 277.333333 85.333333 512s192 426.666667 426.666667 426.666667 426.666667-192 426.666667-426.666667L853.333333 512z"  ></path></symbol><symbol id="icon-dizhi" viewBox="0 0 1025 1024"><path d="M839.946482 389.336542c0-179.917116-147.043874-325.820973-328.561518-325.820973-181.460336 0-328.561518 145.903857-328.561518 325.820973 0 59.446709 16.307166 114.955546 44.308214 162.939652l-0.351011 0 284.574638 407.316894 284.690277-407.316894-0.379665 0C823.757001 504.292088 839.946482 448.783251 839.946482 389.336542M511.413617 552.215816c-90.716353 0-164.280247-72.922251-164.280247-162.907928 0-89.927346 73.563895-162.907928 164.280247-162.907928 90.802315 0 164.280247 72.980582 164.280247 162.907928C675.693865 479.293565 602.215932 552.215816 511.413617 552.215816"  ></path></symbol><symbol id="icon-arrow-down" viewBox="0 0 1036 1024"><path d="M1020.403079 280.746102 969.751469 230.094492 507.243673 692.603311 54.205553 239.565191 3.553942 290.216801 507.243673 793.904485Z"  ></path></symbol><symbol id="icon-icon_arrow_left" viewBox="0 0 1024 1024"><path d="M272.448 472.064l399.232-399.232c22.080-22.080 57.792-22.080 79.872 0 22.016 22.016 22.080 57.792 0 79.872l-359.296 359.296 359.296 359.296c22.016 22.016 22.080 57.792 0 79.872s-57.792 22.016-79.872 0l-399.232-399.232c-22.016-22.080-22.016-57.792 0-79.872z"  ></path></symbol><symbol id="icon-jiantouyou" viewBox="0 0 1024 1024"><path d="M751.552 551.936l-399.232 399.232c-22.08 22.08-57.792 22.08-79.872 0-22.016-22.016-22.08-57.792 0-79.872l359.296-359.296-359.296-359.296c-22.016-22.016-22.08-57.792 0-79.872s57.792-22.016 79.872 0l399.232 399.232c22.016 22.08 22.016 57.792 0 79.872z"  ></path></symbol><symbol id="icon-hearto" viewBox="0 0 1024 1024"><path d="M950.857143 340.571429q0-46.285714-12.285714-81.714286t-31.428571-56.285714-46.571429-34-53.714286-17.714286-56-4.571429-64 14.571429-63.142857 36.571429-49.428571 41.142857-34.285714 35.142857q-10.285714 12.571429-28 12.571429t-28-12.571429q-13.714286-16-34.285714-35.142857t-49.428571-41.142857-63.142857-36.571429-64-14.571429-56 4.571429-53.714286 17.714286-46.571429 34-31.428571 56.285714-12.285714 81.714286q0 96 106.857143 202.857143l332 320 331.428571-319.428571q107.428571-107.428571 107.428571-203.428571zm73.142857 0q0 126.285714-130.857143 257.142857l-356 342.857143q-10.285714 10.285714-25.142857 10.285714t-25.142857-10.285714l-356.571429-344q-5.714286-4.571429-15.714286-14.857143t-31.714286-37.428571-38.857143-55.714286-30.571429-69.142857-13.428571-78.857143q0-125.714286 72.571429-196.571429t200.571429-70.857143q35.428571 0 72.285714 12.285714t68.571429 33.142857 54.571429 39.142857 43.428571 38.857143q20.571429-20.571429 43.428571-38.857143t54.571429-39.142857 68.571429-33.142857 72.285714-12.285714q128 0 200.571429 70.857143t72.571429 196.571429z"  ></path></symbol><symbol id="icon-kefu1" viewBox="0 0 1024 1024"><path d="M673.44128 658.25536c5.9904-6.9952 3.99616-17.984-2.99904-23.9744-6.99264-5.99424-17.98144-3.99616-23.97056 2.99392-35.96544 39.95648-74.91968 58.93888-129.86112 58.93888-54.94272 0-89.90464-14.98496-129.8624-58.93888-5.99424-6.99136-16.98304-8.98944-23.9744-2.99392-6.99264 5.9904-8.99072 16.9792-3.00032 23.9744 46.95296 52.94336 90.9056 72.9216 156.83712 72.9216C582.53952 731.17696 631.48544 707.20384 673.44128 658.25536L673.44128 658.25536zM386.74816 481.44128l0-59.93472c0-15.9808-12.98688-29.96864-29.96992-29.96864-15.9808 0-29.96864 12.9856-29.96864 29.96864l0 59.93472c0 15.9872 12.98688 29.96992 29.96864 29.96992C372.76032 511.4112 386.74816 498.42432 386.74816 481.44128L386.74816 481.44128zM914.18368 418.51136C869.23264 236.70272 708.40448 101.84832 516.61056 101.84832c-191.7952 0-352.62336 134.8544-397.57824 316.66176C71.08224 436.49152 37.12 489.4336 37.12 551.36896c0 70.92352 44.94976 129.86112 103.88864 138.85184 0 0 0 0.99712 1.00224 0.99712l66.92608 0c-26.9696-50.94528-41.95456-108.88192-41.95456-169.81888 0-198.78656 156.83072-359.61472 349.62816-359.61472 192.79104 0 349.62304 160.82816 349.62304 359.61472 0 133.85856-70.92352 249.73696-176.81024 311.66976-3.99744-1.00096-8.99072-1.99808-13.984-1.99808-32.96512 0-59.93984 26.9696-59.93984 59.93472 0 32.9664 26.97472 59.936 59.93984 59.936 32.96512 0 59.93472-26.9696 59.93472-59.936 0-4.99328-1.00096-9.98656-1.99808-13.98272 68.92544-44.95488 124.86784-109.88288 157.83424-186.80064 58.93248-9.99168 104.88448-67.92832 104.88448-138.85184C996.09472 489.4336 961.13152 436.49152 914.18368 418.51136L914.18368 418.51136zM706.4064 481.44128l0-59.93472c0-15.9808-12.9856-29.96864-29.96864-29.96864-15.98208 0-29.96608 12.9856-29.96608 29.96864l0 59.93472c0 15.9872 12.98176 29.96992 29.96608 29.96992C692.41856 511.4112 706.4064 498.42432 706.4064 481.44128L706.4064 481.44128zM706.4064 481.44128"  ></path></symbol><symbol id="icon-mianfeizixun" viewBox="0 0 1024 1024"><path d="M751.418858 1021.981017c-65.934688 0-151.054321-43.922349-210.858382-80.777745-80.08292-49.350988-166.356842-117.623931-242.933915-192.232163l-0.277316-0.273223-24.312732-24.321942C198.423165 647.802966 130.154315 561.522903 80.803327 481.441007 43.953048 421.642063 0.021489 336.517313 0.021489 270.584672c0-70.560032 50.457182-145.44558 72.14718-174.368306 16.924461-22.573111 76.06542-96.216365 126.312824-96.216365 20.633946 0 42.849924 13.502525 72.055083 43.791365 25.828248 26.776853 50.612725 60.066027 66.855664 83.276658 21.812795 31.159674 41.987277 63.785745 56.811914 91.870384 24.000624 45.471634 26.7789 64.973804 26.7789 75.68475 0 21.617343-11.292184 40.36943-33.558303 55.729256-14.662955 10.112312-32.260751 17.723663-49.27731 25.087375-11.481496 4.967128-29.80891 12.889565-36.802184 18.464537 2.441609 10.331299 13.103436 35.281551 41.913599 77.581959 26.846438 39.413662 61.563124 82.129532 92.927459 114.334002 32.203446 31.360242 74.910107 66.079998 114.340141 92.927459 42.285059 28.800953 67.230194 39.467897 77.571726 41.909505 5.564739-6.988158 13.498432-25.316595 18.459421-36.792974 7.363711-17.021675 14.976086-34.623565 25.092491-49.287543 15.359826-22.26612 34.111912-33.552164 55.729256-33.552164 10.716063 0 30.213116 2.778276 75.69089 26.773783 28.084639 14.823614 60.714803 34.999119 91.870384 56.811914 23.206538 16.244986 56.493665 41.032532 83.277682 66.855664 30.280654 29.205159 43.785226 51.42216 43.785226 72.060199 0 50.242288-73.638137 109.386316-96.206132 126.308731C896.869554 971.532021 821.97889 1021.981017 751.418858 1021.981017L751.418858 1021.981017 751.418858 1021.981017zM339.876828 705.886849c73.465199 71.558779 155.967214 136.87846 232.349859 183.943382 74.048483 45.638433 139.363048 71.811536 179.193195 71.811536 35.481096 0 86.060051-21.668509 135.313825-57.956993 21.587668-15.915481 41.237193-33.634028 55.329143-49.89641 13.221116-15.265682 18.056238-25.223474 19.284205-29.244045-5.112438-10.979052-35.462676-45.301765-106.293885-94.16566-27.786857-19.163455-56.515155-36.779671-80.890308-49.598628-30.609135-16.089443-43.366693-18.868743-46.285163-19.328207-1.134847 0.780783-4.468778 3.567245-9.538237 12.063757-5.672186 9.512654-11.125385 22.116717-16.398482 34.307364-6.485715 15.006785-13.20065 30.525224-21.437242 43.049468-13.392008 20.361747-29.833469 30.698163-48.869011 30.710442-0.340761 0-0.701988-0.007163-1.071402-0.021489-9.259898-0.194428-37.459147-0.791016-114.018823-52.930513-42.264593-28.795836-88.166015-66.126047-122.766045-99.878778l-0.541329-0.531096c-33.743522-34.614355-71.069639-80.505545-99.862405-122.766045-52.145637-76.556607-52.751435-104.759949-52.945863-114.02701-0.414439-19.380396 9.81453-36.107359 30.388101-49.732681 12.582573-8.327666 28.230971-15.095813 43.3626-21.644973 12.1886-5.269004 24.790616-10.722202 34.302247-16.389272 8.493441-5.062296 11.291161-8.401344 12.060687-9.53619-0.457418-2.920516-3.234671-15.678074-19.327184-46.286186-12.814864-24.370037-30.432103-53.102429-49.594535-80.885192-48.867988-70.841442-83.188654-101.186564-94.163613-106.299001-4.021593 1.233084-13.981433 6.067182-29.246091 19.288299-16.265452 14.083763-33.983999 33.741475-49.89027 55.331189-36.290531 49.242518-57.956993 99.82659-57.956993 135.308709 0 39.827077 26.170033 105.139595 71.801303 179.191148 47.075155 76.382645 112.391766 158.886707 183.943382 232.349859L339.876828 705.886849 339.876828 705.886849 339.876828 705.886849z"  ></path></symbol><symbol id="icon-qq1" viewBox="0 0 1024 1024"><path d="M116.435 593.714c-33.54 78.964-38.985 154.297-12.059 168.37 18.572 9.696 47.686-12.382 74.936-52.909 10.791 44.157 37.493 84.137 75.633 116.21-40.004 14.768-66.135 38.886-66.135 66.232 0 44.954 70.709 81.302 157.978 81.302 78.716 0 143.907-29.538 155.94-68.371 3.232-0.049 15.663-0.049 18.796 0 12.083 38.784 77.324 68.371 155.989 68.371 87.267 0 157.978-36.398 157.978-81.302 0-27.297-26.105-51.464-66.135-66.232 38.089-32.123 64.889-72.053 75.631-116.21 27.251 40.527 56.29 62.605 74.887 52.909 26.95-14.073 21.631-89.456-12.032-168.37-26.355-62.058-62.11-107.754-89.457-117.848 0.398-3.929 0.596-7.958 0.596-11.935 0-23.968-6.661-46.146-18.049-64.196 0.199-1.393 0.199-2.834 0.199-4.227 0-11.038-2.636-21.381-7.114-30.332-6.909-161.309-111.93-289.402-281.866-289.402-170.036 0-275.106 128.093-281.943 289.402-4.525 9.001-7.135 19.343-7.135 30.332 0 1.393 0.099 2.835 0.15 4.227-11.288 18.05-17.951 40.178-17.951 64.196 0 3.978 0.15 7.955 0.498 11.935-27.151 10.094-63.028 55.841-89.333 117.848z"  ></path></symbol><symbol id="icon-shoucang" viewBox="0 0 1024 1024"><path d="M722.10963 865.09037 722.10963 865.09037c-7.300741 0-14.506667-1.801481-20.859259-5.30963l-0.18963-0.094815-169.339259-93.866667c-2.844444-1.611852-6.352593-1.611852-9.197037 0l-169.623704 93.297778c-6.352593 3.508148-13.558519 5.30963-20.859259 5.30963-9.007407 0-17.635556-2.74963-24.936296-7.964444-13.368889-9.481481-20.385185-26.074074-17.73037-42.287407l33.185185-201.860741c0.474074-2.939259-0.474074-5.973333-2.56-8.154074L181.096296 461.179259c-11.377778-11.662222-15.17037-28.539259-9.955556-43.994074 5.214815-15.454815 18.394074-26.453333 34.512593-28.918519l190.388148-28.728889c3.128889-0.474074 5.783704-2.465185 7.205926-5.30963l85.997037-181.94963c7.111111-15.075556 22.471111-24.746667 39.063704-24.746667l0.094815 0c16.687407 0 32.047407 9.860741 39.063704 24.936296l85.238519 182.423704c1.327407 2.844444 3.982222 4.835556 7.111111 5.404444l190.008889 29.297778c16.023704 2.465185 29.297778 13.558519 34.417778 29.013333 5.12 15.454815 1.232593 32.237037-10.05037 43.899259L734.814815 604.918519c-2.085926 2.180741-3.034074 5.214815-2.56 8.154074l31.478519 195.602963c0 0 0 0 0 0 1.991111 6.162963 2.465185 12.61037 1.611852 19.247407C762.500741 849.351111 743.727407 865.09037 722.10963 865.09037zM719.36 826.500741c0.853333 0.474074 1.801481 0.663704 2.654815 0.663704l0.474074 0c2.654815 0 4.93037-1.896296 5.214815-4.456296 0.094815-1.042963 0-1.991111-0.284444-2.74963l-0.663704-1.801481-35.081481-217.979259c-0.474074-2.939259 0.474074-5.973333 2.56-8.154074l152.746667-156.065185c1.327407-1.422222 1.801481-3.508148 1.232593-5.404444-0.663704-1.896296-2.275556-3.223704-4.266667-3.508148l-210.10963-32.426667c-3.128889-0.474074-5.783704-2.465185-7.111111-5.404444l-93.771852-200.722963c-0.853333-1.896296-2.74963-3.034074-4.835556-3.034074-2.085926 0-3.887407 1.232593-4.835556 3.034074L428.847407 388.740741c-1.327407 2.844444-4.077037 4.835556-7.205926 5.30963l-210.394074 31.668148c-1.991111 0.284444-3.602963 1.706667-4.266667 3.602963-0.663704 1.896296-0.18963 3.982222 1.232593 5.404444l152.367407 156.728889c2.085926 2.180741 3.034074 5.214815 2.56 8.154074l-36.314074 220.728889c-0.284444 1.991111 0.474074 3.982222 2.180741 5.214815 1.137778 0.853333 2.275556 0.948148 3.034074 0.948148 0.853333 0 1.801481-0.18963 2.56-0.663704L522.619259 722.488889c2.844444-1.611852 6.352593-1.611852 9.197037 0L719.36 826.500741z"  ></path></symbol><symbol id="icon-yonghu2" viewBox="0 0 1024 1024"><path d="M843.282963 870.115556c-8.438519-140.515556-104.296296-257.422222-233.908148-297.14963C687.881481 536.272593 742.4 456.533333 742.4 364.088889c0-127.241481-103.158519-230.4-230.4-230.4S281.6 236.847407 281.6 364.088889c0 92.444444 54.518519 172.183704 133.12 208.877037-129.611852 39.727407-225.46963 156.634074-233.908148 297.14963-0.663704 10.903704 7.964444 20.195556 18.962963 20.195556l0 0c9.955556 0 18.299259-7.774815 18.962963-17.73037C227.745185 718.506667 355.65037 596.385185 512 596.385185s284.254815 122.121481 293.357037 276.195556c0.568889 9.955556 8.912593 17.73037 18.962963 17.73037C835.318519 890.311111 843.946667 881.019259 843.282963 870.115556zM319.525926 364.088889c0-106.287407 86.186667-192.474074 192.474074-192.474074s192.474074 86.186667 192.474074 192.474074c0 106.287407-86.186667 192.474074-192.474074 192.474074S319.525926 470.376296 319.525926 364.088889z"  ></path></symbol><symbol id="icon-xinwen1" viewBox="0 0 1024 1024"><path d="M895.582235 290.577005c-0.002047-0.040932-0.007163-0.080841-0.00921-0.121773-0.033769-0.627287-0.092098-1.251503-0.164752-1.87265-0.019443-0.165776-0.039909-0.331551-0.061398-0.49835-0.085958-0.649799-0.186242-1.297552-0.313132-1.938142-0.001023-0.007163-0.002047-0.013303-0.00307-0.020466-0.12996-0.652869-0.288572-1.299599-0.459464-1.941212-0.041956-0.156566-0.085958-0.312108-0.12996-0.468674-0.169869-0.596588-0.353041-1.190105-0.558725-1.774413-0.016373-0.046049-0.029676-0.092098-0.046049-0.138146-0.220011-0.61603-0.465604-1.222851-0.724501-1.823532-0.069585-0.162706-0.14224-0.323365-0.214894-0.485047-0.243547-0.540306-0.500397-1.075495-0.775666-1.601474-0.035816-0.067538-0.066515-0.137123-0.102331-0.204661-0.305969-0.575098-0.636496-1.136893-0.979304-1.692548-0.095167-0.153496-0.191358-0.305969-0.289596-0.457418-0.333598-0.518816-0.678452-1.030469-1.043772-1.529843-0.032746-0.044002-0.062422-0.091074-0.095167-0.135076-0.398066-0.539282-0.820692-1.061169-1.255597-1.574868-0.107447-0.12689-0.215918-0.251733-0.325411-0.3776-0.451278-0.515746-0.913812-1.023306-1.400906-1.5104L688.452781 72.233138c-0.485047-0.485047-0.989537-0.945535-1.503237-1.393743-0.12996-0.113587-0.260943-0.227174-0.39295-0.338714-0.509606-0.430812-1.028423-0.850367-1.562589-1.245364-0.053212-0.038886-0.107447-0.074701-0.160659-0.112564-0.48914-0.357134-0.99056-0.695848-1.49812-1.022283-0.158612-0.102331-0.318248-0.203638-0.477884-0.301875-0.550539-0.339738-1.107217-0.667196-1.676176-0.970094-0.076748-0.040932-0.155543-0.076748-0.232291-0.116657-0.514723-0.26913-1.038656-0.51984-1.566682-0.759293-0.168846-0.075725-0.336668-0.151449-0.506537-0.224104-0.595564-0.255827-1.197268-0.499373-1.807159-0.717338-0.056282-0.019443-0.112564-0.036839-0.168846-0.056282-0.573051-0.200568-1.153266-0.38067-1.738597-0.547469-0.162706-0.046049-0.325411-0.092098-0.48914-0.1361-0.63752-0.169869-1.278109-0.327458-1.926886-0.456395-0.016373-0.00307-0.033769-0.005117-0.050142-0.00921-0.630357-0.124843-1.267876-0.223081-1.907443-0.308015-0.169869-0.022513-0.339738-0.044002-0.51063-0.063445-0.61296-0.070608-1.227967-0.127913-1.847068-0.161682-0.048095-0.00307-0.097214-0.008186-0.145309-0.011256-0.51063-0.025583-1.023306-0.038886-1.537006-0.038886L159.900803 63.24237c-16.95516 0-30.699186 13.744026-30.699186 30.699186l0 834.942133c0 16.954137 13.744026 30.699186 30.699186 30.699186L864.922958 959.582875c16.954137 0 30.699186-13.745049 30.699186-30.699186L895.622144 292.119127C895.622144 291.603381 895.607818 291.089681 895.582235 290.577005zM697.444573 168.05553l93.363388 93.363388-93.363388 0L697.444573 168.05553zM190.599989 898.184503 190.599989 124.640742l445.446211 0 0 167.478386c0 16.954137 13.745049 30.699186 30.699186 30.699186L834.223772 322.818313l0 575.36619L190.599989 898.184503z"  ></path><path d="M287.332101 381.480364l197.455117 0c16.954137 0 30.699186-13.745049 30.699186-30.699186s-13.745049-30.699186-30.699186-30.699186L287.332101 320.081992c-16.954137 0-30.699186 13.745049-30.699186 30.699186S270.377964 381.480364 287.332101 381.480364z"  ></path><path d="M287.332101 542.235628l259.913635 0c16.954137 0 30.699186-13.745049 30.699186-30.699186s-13.745049-30.699186-30.699186-30.699186L287.332101 480.837256c-16.954137 0-30.699186 13.745049-30.699186 30.699186S270.377964 542.235628 287.332101 542.235628z"  ></path><path d="M679.258375 640.444371l-391.926274 0c-16.954137 0-30.699186 13.745049-30.699186 30.699186s13.745049 30.699186 30.699186 30.699186l391.926274 0c16.954137 0 30.699186-13.745049 30.699186-30.699186S696.212512 640.444371 679.258375 640.444371z"  ></path></symbol><symbol id="icon-tel" viewBox="0 0 1024 1024"><path d="M766.438946 943.5579c-4.429893 0-7.181563-0.145309-7.476275-0.160659l-0.290619-0.01842c-42.736337-3.02387-90.967828-17.787108-139.483798-42.693358l-0.587378-0.315178-54.078663-30.248931c-102.549607-56.177464-259.853259-218.356147-266.500657-225.233787l-11.432377-11.828396 0.092098-0.11461c-27.666106-29.688159-84.594677-94.66094-133.902686-175.60753-55.477522-91.075275-81.612763-169.619142-77.67815-233.44889 2.922563-47.425126 22.463618-85.97307 58.07979-114.573455 38.268582-30.728862 73.250304-43.540655 106.933451-39.162952 36.108383 4.690836 69.019956 28.681226 103.573937 75.497485 2.307555 3.127224 4.591575 6.207375 6.842849 9.244548 25.679869 34.643008 47.857984 64.562435 55.935963 95.558379 9.42772 36.173874-1.87572 69.727061-34.558074 102.576213l-1.133823 1.139963-0.239454 0.143263c-1.543146 1.576915-8.922207 10.053983-9.100262 28.119431-0.180102 18.291598 6.823406 40.11565 20.814048 64.866357 19.22076 34.000372 51.161217 72.403007 94.934163 114.14162 73.369008 69.476351 120.596635 88.594781 147.289578 92.391247 23.400966 3.329838 33.67803-4.653997 35.45756-6.243191l0.306992-0.428765-0.25071 0.378623c0.052189-0.048095 0.096191-0.088004 0.12996-0.12075 27.874861-32.115442 63.648622-42.73122 106.3297-31.54853 30.785144 8.064676 64.736397 26.939559 110.083188 61.199851 34.673707 26.194592 55.872518 52.227502 64.805982 79.588663 9.91379 30.357402 5.175883 61.742203-14.482853 95.946212-5.145184 8.953929-16.573467 12.040221-25.526373 6.892991-8.951883-5.145184-12.039197-16.573467-6.892991-25.526373 14.275121-24.837688 17.885346-45.717228 11.357675-65.705468-6.482645-19.854187-23.427572-39.926338-51.800783-61.36051-53.480029-40.404222-80.984453-50.661843-97.019661-54.862515-29.009707-7.600095-50.218752-1.410116-68.768223 20.064988-2.236947 2.578732-16.8559 18.027585-47.285956 19.762089-50.306756 2.858094-114.064872-31.898501-189.489702-103.322204C364.582509 505.738389 321.769424 435.174264 324.130192 378.769626c1.333368-31.846312 17.013489-48.312332 21.691021-52.538587 46.799886-47.340191 27.248597-78.138638-25.329898-149.069107-2.266623-3.057639-4.564969-6.15928-6.887874-9.30697-28.097942-38.068014-52.979632-57.33073-78.30646-60.621682-23.048949-2.994194-48.796356 7.223518-78.70248 31.237445-27.442002 22.037922-41.891086 50.730405-44.171012 87.718831-3.406586 55.261605 21.591761 128.46586 72.290443 211.69647 55.645344 91.351568 121.350812 161.615864 140.164297 180.974771l2.491751 2.564405c20.531616 20.967544 164.28874 166.17981 255.178797 215.937051l0.149403 0.082888 53.862745 30.126134c43.889603 22.49227 86.947258 35.799344 124.561947 38.494733 1.385557 0.062422 16.679891 0.665149 33.288151-2.122337 5.990434-1.004887 12.458753-2.228761 19.305695-3.52222 25.75764-4.867868 57.81373-10.927887 100.929714-12.644995 10.296507-0.403183 19.015076 7.619538 19.425422 17.936511 0.411369 10.316973-7.618515 19.015076-17.936511 19.425422-40.364313 1.608637-70.922283 7.385201-95.474468 12.025894-7.04137 1.330298-13.690814 2.586918-20.058848 3.656273C786.892791 943.120948 774.135232 943.5579 766.438946 943.5579z"  ></path></symbol><symbol id="icon-youjiantou" viewBox="0 0 1024 1024"><path d="M326.4 838.4l352-352c12.8-12.8 32-12.8 44.8 0l0 0c12.8 12.8 12.8 32 0 44.8l-352 352c-12.8 12.8-32 12.8-44.8 0l0 0C313.6 876.8 313.6 851.2 326.4 838.4z"  ></path><path d="M678.4 531.2 326.4 185.6c-12.8-12.8-12.8-32 0-44.8l0 0C339.2 128 358.4 128 371.2 134.4l352 352c12.8 12.8 12.8 32 0 44.8l0 0C710.4 544 684.8 544 678.4 531.2z"  ></path></symbol><symbol id="icon-bofang" viewBox="0 0 1085 1024"><path d="M546.904228 18.10573c-277.76918 0-502.94529 225.17611-502.94529 502.94529 0 277.77164 225.17488 502.94775 502.94529 502.94775 277.76795 0 502.94529-225.17611 502.94529-502.94775C1049.849518 243.28307 824.672178 18.10573 546.904228 18.10573L546.904228 18.10573zM546.904228 973.701659c-249.992631 0-452.651868-202.659237-452.651868-452.651868 0-249.990172 202.659237-452.649408 452.651868-452.649408s452.650638 202.659237 452.650638 452.649408C999.554866 771.042422 796.896859 973.701659 546.904228 973.701659L546.904228 973.701659zM775.203924 485.406478c-78.267962-53.25591-220.1919-132.967608-301.004232-182.358388-33.132146-20.893592-60.993549-12.502952-63.667043 24.399633-1.938099 98.840588 0 289.550264 0 390.101445 1.681079 37.462125 34.709926 42.403293 63.37559 27.362121 80.72133-48.906255 219.456505-132.95777 300.588574-182.112436C773.968017 562.476656 836.097862 528.305364 775.203924 485.406478L775.203924 485.406478z"  ></path></symbol><symbol id="icon-heartcoloring" viewBox="0 0 1024 1024"><path d="M1013.409014 357.432997c0 76.132307-29.572899 147.762166-83.49995 201.484561l-372.884581 374.317178c-11.870091 11.870091-27.526332 18.316778-44.308184 18.316778l0 0c-16.781853 0-32.438093-6.446687-44.308184-18.316778l-374.317178-374.317178c-53.722394-53.722394-83.49995-125.352253-83.49995-201.484561s29.572899-147.762166 83.49995-201.484561 125.352253-83.49995 201.484561-83.49995 147.762166 29.572899 201.484561 83.49995c5.116419 5.116419 10.335165 10.539822 15.04227 16.167882 4.707105-5.62806 9.823524-10.949136 15.04227-16.167882 53.722394-53.722394 125.352253-83.49995 201.484561-83.49995s147.762166 29.572899 201.484561 83.49995C983.836115 209.67083 1013.409014 281.30069 1013.409014 357.432997z"  ></path></symbol><symbol id="icon-arrowup" viewBox="0 0 1025 1024"><path d="M84.883165 690.682324c-0.108532-6.288704 2.1819-12.616315 6.896892-17.497176l386.129681-399.638824c25.107716-25.985186 66.674388-26.700882 92.661622-1.594189 0.125938 0.121842 0.250852 0.244709 0.374742 0.369623l397.182524 400.527557c9.555922 9.636809 9.491417 25.19577-0.146416 34.751692-9.636809 9.555922-25.196794 9.490393-34.752716-0.146416L536.272226 307.154335c-3.12797-2.94879-7.209177-4.529669-11.515638-4.455949-4.375062 0.075768-8.459341 1.850161-11.50028 4.99656L127.126626 707.334795c-9.431008 9.759675-24.986897 10.026909-34.747596 0.597949C87.499192 703.217752 84.991697 696.970003 84.883165 690.682324z"  ></path><path d="M970.115987 251.532788"  ></path></symbol><symbol id="icon-checkboxround1" viewBox="0 0 1024 1024"><path d="M512 64C264.576 64 64 264.576 64 512s200.576 448 448 448 448-200.576 448-448S759.424 64 512 64zM717.952 438.592l-256.448 256.256c-8 8.064-19.328 10.752-29.632 8.576-10.496 2.816-22.016 0.192-30.272-8.064L264.96 558.72C252.672 546.496 253.312 526.08 265.344 513.92c12.544-12.48 32.384-12.864 44.864-0.448l121.088 121.152 241.344-241.344c12.416-12.544 33.152-12.16 45.312 0C730.432 405.76 730.496 425.92 717.952 438.592z"  ></path></symbol><symbol id="icon-checkboxround0" viewBox="0 0 1024 1024"><path d="M512 64C264.576 64 64 264.576 64 512s200.576 448 448 448 448-200.576 448-448S759.424 64 512 64zM512 896c-212.096 0-384-171.968-384-384 0-212.096 171.904-384 384-384 212.032 0 384 171.904 384 384C896 724.032 724.032 896 512 896z"  ></path></symbol><symbol id="icon-dui" viewBox="0 0 1024 1024"><path d="M356.633486 866.60326a43.335582 43.335582 0 0 1-30.655697-12.70156L16.595837 544.519749a43.342807 43.342807 0 0 1 0-61.296945 43.328357 43.328357 0 0 1 61.30417 0L356.626261 761.949058l590.788683-590.795908a43.342807 43.342807 0 0 1 61.296945 0 43.335582 43.335582 0 0 1 0 61.30417l-621.437155 621.44438a43.277782 43.277782 0 0 1-30.641248 12.70156z" fill="#231815" ></path></symbol><symbol id="icon-jia" viewBox="0 0 1024 1024"><path d="M980.700543 468.454893H557.401933V45.156283a43.350032 43.350032 0 0 0-86.700063 0v423.29861H47.396035a43.350032 43.350032 0 0 0 0 86.700064h423.305835v423.31306a43.350032 43.350032 0 0 0 86.700063 0v-423.31306h423.29861a43.350032 43.350032 0 0 0 0-86.700064z" fill="#231815" ></path></symbol><symbol id="icon-qq2" viewBox="0 0 1024 1024"><path d="M897.031 626.742s-26.016-96.832-73.711-155.853c0 0 26.016-48.877-17.344-116.198 0 0-10.406-290.496-293.977-290.496S218.023 354.69 218.023 354.69c-43.359 67.321-17.344 116.198-17.344 116.198-47.695 59.021-73.711 155.853-73.711 155.853-24.281 118.043 21.68 139.254 28.617 141.098s22.547-16.6 27.75-24.9c5.203-8.3 16.477-35.044 19.078-36.888s6.938 13.833 6.938 13.833c18.211 59.944 57.234 103.288 57.234 103.288-39.023 14.755-65.906 43.344-65.906 43.344s-49.43 75.621 82.383 90.377 218.531-31.355 218.531-31.355h20.813s86.719 46.111 218.531 31.355 82.383-90.377 82.383-90.377-26.883-28.589-65.906-43.344c0 0 39.023-43.344 57.234-103.288 0 0 4.336-15.678 6.938-13.833s13.875 28.589 19.078 36.888c5.203 8.3 20.813 26.744 27.75 24.9s52.898-23.054 28.617-141.097z"  ></path></symbol><symbol id="icon-zhifubaozhifu" viewBox="0 0 1024 1024"><path d="M1024.0512 701.0304V196.864A196.9664 196.9664 0 0 0 827.136 0H196.864A196.9664 196.9664 0 0 0 0 196.864v630.272A196.9152 196.9152 0 0 0 196.864 1024h630.272a197.12 197.12 0 0 0 193.8432-162.0992c-52.224-22.6304-278.528-120.32-396.4416-176.64-89.7024 108.6976-183.7056 173.9264-325.3248 173.9264s-236.1856-87.2448-224.8192-194.048c7.4752-70.0416 55.552-184.576 264.2944-164.9664 110.08 10.3424 160.4096 30.8736 250.1632 60.5184 23.1936-42.5984 42.496-89.4464 57.1392-139.264H248.064v-39.424h196.9152V311.1424H204.8V267.776h240.128V165.632s2.1504-15.9744 19.8144-15.9744h98.4576V267.776h256v43.4176h-256V381.952h208.8448a805.9904 805.9904 0 0 1-84.8384 212.6848c60.672 22.016 336.7936 106.3936 336.7936 106.3936zM283.5456 791.6032c-149.6576 0-173.312-94.464-165.376-133.9392 7.8336-39.3216 51.2-90.624 134.4-90.624 95.5904 0 181.248 24.4736 284.0576 74.5472-72.192 94.0032-160.9216 150.016-253.0816 150.016z"  ></path></symbol><symbol id="icon-mobile-channel" viewBox="0 0 1024 1024"><path d="M704 64H320c-70.7 0-128 57.3-128 128v512h640V192c0-70.7-57.3-128-128-128z m-128 96c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32zM192 768v64c0 70.7 57.3 128 128 128h384c70.7 0 128-57.3 128-128v-64H192z m320 143.8c-26.5 0-48-21.4-48-47.8s21.5-47.8 48-47.8 48 21.4 48 47.8-21.5 47.8-48 47.8z" fill="" ></path></symbol><symbol id="icon-yonghu1" viewBox="0 0 1024 1024"><path d="M612.916411 496.931816c-0.327458 0.741897-32.029484 73.867358-96.576569 73.867358-63.845097 0-90.376357-69.986981-91.497901-73.011874-3.576455-9.853415-14.509459-14.950504-24.321942-11.375071-9.890254 3.576455-14.987343 14.47262-11.4334 24.344454 1.447978 3.994987 36.479843 98.075713 127.234823 98.075713 90.089831 0 130.010029-93.246731 131.663692-97.220229 4.050246-9.698896-0.514723-20.786419-10.17678-24.840758-9.680477-4.065596-20.824281 0.49835-24.891923 10.160407z" fill="#C4C6CF" ></path><path d="M860.741729 430.470125c0-189.930747-154.490583-344.449983-344.391654-344.449983-189.9594 0-344.449983 154.520259-344.449983 344.449983 0 139.910517 85.826737 266.61015 214.741829 319.014684C302.972313 802.800086 281.600563 896.587122 279.325753 907.613246c-1.422396 7.846712 0.283456 15.631002 4.833075 22.00006 5.226025 7.387247 13.980409 12.389168 25.461905 14.093996 14.668071 0 27.284413-10.459213 30.070876-24.951275 1.080611-5.913687 28.589129-143.861502 176.659489-143.861501 146.022725 0 187.287547 131.241067 191.492312 146.077983 3.524267 13.414521 15.689331 22.793122 29.559223 22.793122 1.191128 0 7.218402-0.852414 7.957229-1.025353 7.90197-2.101871 14.550391-7.15905 18.585287-14.266935 4.149507-7.045463 5.230118-15.343453 3.068895-23.531949-3.124154-10.797927-32.283264-103.673198-119.532397-156.081825 128.057561-52.80567 213.260082-179.217754 213.260082-318.389444z m-62.908772 68.509327c-31.000038 127.077234-145.030118 222.036979-281.482882 222.036979-136.455835 0-250.482845-94.959745-281.482883-222.036979-5.384637-22.076808-9.036817-44.804439-9.036817-68.51342 0-160.161746 130.358977-290.428625 290.520723-290.428625 160.157653 0 290.520723 130.266879 290.520723 290.428625-0.001023 23.708981-3.654226 46.436612-9.038864 68.51342z" fill="#C4C6CF" ></path></symbol><symbol id="icon-yonghu" viewBox="0 0 1024 1024"><path d="M621.8 601.2c86.8-49.5 146.1-141.9 146.1-249 0-158.9-128.8-287.7-287.7-287.7S192.5 193.3 192.5 352.2c0 107.1 59.2 199.5 146.1 249-150 54.5-259.7 192.7-272.3 358.3h63.9c16.2-178.9 166.9-319.6 350-319.6s333.8 140.7 350 319.6h63.9c-12.6-165.6-122.3-303.8-272.3-358.3z m-365.4-249c0-123.4 100.4-223.7 223.8-223.7S704 228.8 704 352.2 603.6 575.9 480.2 575.9 256.4 475.6 256.4 352.2z"  ></path></symbol><symbol id="icon-fensi" viewBox="0 0 1024 1024"><path d="M477.7 496c-119.1 0-216-96.9-216-216s96.9-216 216-216 216 96.9 216 216-96.9 216-216 216z m0-400c-101.5 0-184.1 82.6-184.1 184.1s82.6 184.1 184.1 184.1 184.1-82.6 184.1-184.1S579.2 96 477.7 96z"  ></path><path d="M94.5 960.1c-8.8 0-15.9-7.1-15.9-15.9 0-322.9 130.6-479.9 399.1-479.9 8.8 0 15.9 7.1 15.9 15.9s-7.1 15.9-15.9 15.9c-250.5 0-367.2 142.4-367.2 448 0 8.9-7.2 16-16 16zM731.6 939.4c-3.9 0-7.8-1.4-10.8-4.2L564.1 790.6c-51.7-51.6-51.7-132-2.2-181.4 44.7-44.7 121.6-48 169.8-8.5 50.7-40.9 125.3-35.8 169.6 8.5 49.4 49.4 49.4 129.8 0 179.2L742.4 935.2c-3.1 2.8-7 4.2-10.8 4.2z m-80.2-335.2c-25.4 0-49.2 9.8-67 27.6-37 37-37 97.1 0 134.1l147.1 135.9 147.6-136.3c36.5-36.5 36.5-96.7-0.5-133.6-35.7-35.6-98.5-35.6-134.1 0-6.2 6.2-18 8-24.3 1.8-19.5-19.7-43.3-29.5-68.8-29.5z"  ></path></symbol><symbol id="icon-zaixianzixun" viewBox="0 0 1024 1024"><path d="M512 87.04c-256 0-460.8 168.96-460.8 384 0 122.88 71.68 235.52 184.32 307.2l-46.08 128c-5.12 10.24 10.24 20.48 20.48 15.36l174.08-81.92c40.96 10.24 81.92 15.36 128 15.36 256 0 460.8-174.08 460.8-384 0-215.04-204.8-384-460.8-384z m-230.4 322.56c30.72 0 51.2 20.48 51.2 51.2 0 25.6-20.48 51.2-51.2 51.2-25.6 0-51.2-20.48-51.2-51.2 0-25.6 20.48-51.2 51.2-51.2z m230.4 102.4c-25.6 0-51.2-20.48-51.2-51.2 0-25.6 20.48-51.2 51.2-51.2 25.6 0 51.2 20.48 51.2 51.2 0 25.6-20.48 51.2-51.2 51.2z m235.52 0c-25.6 0-51.2-20.48-51.2-51.2 0-25.6 20.48-51.2 51.2-51.2s51.2 20.48 51.2 51.2c0 25.6-25.6 51.2-51.2 51.2z"  ></path></symbol><symbol id="icon-shipin11" viewBox="0 0 1024 1024"><path d="M938.666667 42.666667H85.333333C49.066667 42.666667 21.333333 70.4 21.333333 106.666667v810.666666c0 36.266667 27.733333 64 64 64h853.333334c36.266667 0 64-27.733333 64-64V106.666667c0-36.266667-27.733333-64-64-64z m-185.6 42.666666l123.733333 128h-164.266667l-123.733333-128h164.266667z m-213.333334 0l123.733334 128h-164.266667l-123.733333-128h164.266666z m-213.333333 0l123.733333 128h-164.266666L162.133333 85.333333h164.266667zM64 106.666667c0-12.8 8.533333-21.333333 21.333333-21.333334h27.733334l123.733333 128H64V106.666667z m896 810.666666c0 12.8-8.533333 21.333333-21.333333 21.333334H85.333333c-12.8 0-21.333333-8.533333-21.333333-21.333334V256h896v661.333333z m0-704h-34.133333l-123.733334-128H938.666667c12.8 0 21.333333 8.533333 21.333333 21.333334v106.666666z" fill="#666767" ></path><path d="M426.666667 800c10.666667 0 23.466667-2.133333 34.133333-8.533333L704 650.666667c42.666667-23.466667 42.666667-83.2 0-106.666667l-243.2-140.8c-10.666667-6.4-21.333333-8.533333-34.133333-8.533333-34.133333 0-64 17.066667-64 53.333333v298.666667c0 36.266667 29.866667 53.333333 64 53.333333z m-21.333334-343.466667c0-12.8 10.666667-21.333333 21.333334-21.333333 4.266667 0 8.533333 0 10.666666 2.133333l243.2 140.8c8.533333 6.4 10.666667 14.933333 10.666667 17.066667 0 4.266667 0 12.8-10.666667 17.066667l-243.2 140.8c-4.266667 2.133333-6.4 2.133333-10.666666 2.133333-10.666667 0-21.333333-8.533333-21.333334-21.333333v-277.333334z" fill="#666767" ></path></symbol><symbol id="icon-dingwei" viewBox="0 0 1024 1024"><path d="M614.035456 743.01952l-17.227776 36.404224c92.55424 12.097536 148.478976 42.637312 148.478976 65.246208 0 28.771328-90.273792 70.569984-231.701504 70.569984-141.428736 0-231.650304-41.798656-231.650304-70.569984 0-26.728448 77.940736-64.587776 202.35264-69.855232l29.227008 60.908544L714.418176 417.25952l-0.2304 0c19.808256-35.221504 31.328256-75.978752 31.328256-119.561216 0-132.042752-103.860224-239.105024-231.897088-239.105024-128.052224 0-231.914496 107.062272-231.914496 239.105024 0 43.583488 11.521024 84.340736 31.223808 119.561216l-0.159744 0 153.549824 320.05632c-116.478976 7.744512-221.668352 44.296192-221.668352 107.353088 0 71.553024 135.279616 108.99456 268.934144 108.99456 133.653504 0 268.949504-37.441536 268.949504-108.99456C782.533632 791.41376 707.525632 757.086208 614.035456 743.01952zM416.187392 268.255232c0-55.48032 43.609088-100.48512 97.395712-100.48512 53.85728 0 97.446912 45.0048 97.446912 100.48512 0 55.445504-43.589632 100.412416-97.446912 100.412416C459.79648 368.6656 416.187392 323.699712 416.187392 268.255232z" fill="#FF4444" ></path></symbol><symbol id="icon-tupian" viewBox="0 0 1024 1024"><path d="M826.785185 944.355556H183.940741c-62.577778 0-113.777778-51.2-113.777778-113.777778V189.62963c0-62.577778 51.2-113.777778 113.777778-113.777778h640.948148c62.577778 0 113.777778 51.2 113.777778 113.777778v640.948148c1.896296 62.577778-49.303704 113.777778-111.881482 113.777778zM183.940741 113.777778c-41.718519 0-75.851852 34.133333-75.851852 75.851852v640.948148c0 41.718519 34.133333 75.851852 75.851852 75.851852h640.948148c41.718519 0 75.851852-34.133333 75.851852-75.851852V189.62963c0-41.718519-34.133333-75.851852-75.851852-75.851852H183.940741z" fill="" ></path><path d="M676.977778 944.355556c-5.688889 0-9.481481-1.896296-13.274074-5.688889L329.955556 614.4 109.985185 834.37037c-7.585185 7.585185-18.962963 7.585185-26.548148 0s-7.585185-18.962963 0-26.548148l233.244444-233.244444c7.585185-7.585185 18.962963-7.585185 26.548149 0l348.918518 337.540741c7.585185 7.585185 7.585185 18.962963 0 26.548148-3.792593 3.792593-9.481481 5.688889-15.17037 5.688889z" fill="" ></path><path d="M458.903704 730.074074c-3.792593 0-9.481481-1.896296-13.274074-5.688889-7.585185-7.585185-7.585185-18.962963-1.896297-26.548148L705.422222 417.185185c3.792593-3.792593 7.585185-5.688889 13.274074-5.688889 5.688889 0 9.481481 1.896296 13.274074 5.688889l195.318519 185.837037c7.585185 7.585185 7.585185 18.962963 0 26.548148s-18.962963 7.585185-26.548148 0l-182.044445-172.562963L474.074074 724.385185c-3.792593 3.792593-9.481481 5.688889-15.17037 5.688889zM282.548148 420.977778c-53.096296 0-98.607407-43.614815-98.607407-98.607408 0-53.096296 43.614815-98.607407 98.607407-98.607407s98.607407 43.614815 98.607408 98.607407c0 54.992593-45.511111 98.607407-98.607408 98.607408z m0-159.288889c-32.237037 0-60.681481 26.548148-60.681481 60.681481s26.548148 60.681481 60.681481 60.681482 60.681481-26.548148 60.681482-60.681482-28.444444-60.681481-60.681482-60.681481z" fill="" ></path></symbol><symbol id="icon-xinwen" viewBox="0 0 1024 1024"><path d="M752.967662 428.467682V256.173962c0-46.898029-38.373906-74.619339-85.271935-74.619339h-432.857657c-46.898029 0-85.271935 27.711076-85.271935 74.619339v500.989247a85.527761 85.527761 0 0 0 85.271935 85.271935h552.768438a86.847823 86.847823 0 0 0 86.806891-86.858056V428.467682H752.967662zM253.91246 302.898029h216.94048v70.352161h-216.94048V302.898029zM643.678778 702.549466H255.171124v-66.371507H643.678778v66.371507z m0-155.347803H255.171124v-66.371508H643.678778v66.371508z m177.440941 208.375425a33.502978 33.502978 0 1 1-67.016189 0V481.761362h67.016189v273.815726z" fill="#F4941D" ></path></symbol><symbol id="icon-xiaohongshu" viewBox="0 0 1700 1024"><path d="M1556.58367989 666.84618125c-29.0770875 60.29219619-60.07839434 76.86185977-124.32592969 66.70625977-41.2638082-6.52096406-63.81993076-30.68060362-69.91329112-78.89298047 24.90794648 0 49.49518974-0.64140645 73.97553165 0.21380273 16.46276308 0.64140645 23.94583682-4.91744883 23.30443036-22.23542021-0.96210967-25.01484698 0.21380185-50.24349668-0.64140644-75.25834453-0.74830781-20.95260732-12.1867207-34.63594278-33.56693174-35.06354649-42.9742248-0.96210967-85.94844961-0.32070323-133.0918163-0.32070322v212.84000508h-95.67644591V523.38496221h-96.53165507v-98.34897218h93.85912793v-83.48972607h-62.32331602v-96.10404961c20.52500273-0.96210967 40.19479717-2.03111982 63.28542569-3.10013086v-33.35312987H1291.36215693c-3.7415373 26.83216494 6.7347668 35.49115107 34.63594278 35.91875477 74.082433 1.17591152 113.10131865 42.86732432 114.49103203 117.27045968 0.42760459 20.41810224 0.10690137 40.83620362 0.10690136 63.28542656 59.8645916-2.77942763 96.74545693 21.91471699 115.98764678 72.69271875v168.68986787zM1292.00356338 336.94951924c0 29.39779073-1.17591152 51.31250771 0.74830781 72.9065206 0.53450508 5.55885527 10.79700645 14.43164238 16.56966358 14.43164239 11.65221562 0.10690137 33.03242666-3.7415373 33.46003036-7.91067744 2.45872441-22.3423207 3.42083408-46.39505888-3.20703134-67.34766622-2.24492256-7.26927188-27.47357138-7.37617324-47.57097041-12.07981933zM357.3676206 208.88205224c-0.21380185 146.34754717-0.10690137 292.8019957-0.85520829 439.14954287-0.32070323 62.64401924-39.55339072 96.10405049-98.6696754 86.26915284-38.69818242-6.41406357-59.65078974-32.60482208-61.14740449-78.7860791h64.24753448V208.98895362c32.17721836-0.10690137 64.35443672-0.10690137 96.4247537-0.10690138zM767.11937276 208.88205224c-23.62513359 47.14336582-50.02969482 93.11082099-66.81316026 137.90236378 39.33958886-2.24492256 74.61693808-4.27604238 116.73595372-6.7347668-22.23542021 44.89844414-42.01211513 84.6656376-61.78881094 124.53973154-2.67252627 5.34505254-5.23815205 10.90390781-7.91067833 16.24896124-20.73880547 41.58451143-20.63190411 41.69141191 25.33555107 42.9742248 4.81054747 0.10690137 9.51419443 0.74830781 18.28008018 1.49661474-12.93502763 25.33555019-24.26654003 48.42617871-36.45325986 71.08920264-2.03111982 3.7415373-7.48307373 8.01757969-11.3315124 8.01757968-33.99453633-0.10690137-68.30977588 1.06901016-102.09050948-2.67252626-24.4803419-2.77942763-33.78073448-21.27331055-24.26654003-44.57774092 11.65221562-28.75638428 25.44245156-56.65756026 38.2705787-84.87943946 4.38294375-9.72799629 8.76588662-19.45599258 15.28685069-33.88763495-18.9214875 0-32.60482208 0.42760459-46.28815752-0.10690138-40.62240176-1.38971338-54.09193448-19.45599258-37.41536953-56.33685703 26.40456123-58.36797685 55.90925244-115.4531417 84.02423027-173.07281162h96.42475372zM62.10690137 576.40788653c6.09336036-33.78073448 13.79023594-67.4545667 17.85247646-101.44910304 5.13125068-42.76042295 7.16237051-85.84154912 10.69010508-130.73999237h101.44910391c-17.21107002 115.98764678 3.42083408 238.81696172-72.58581827 345.50421679-20.31120088-35.70495293-38.91198516-68.52357773-57.51276855-101.34220254 0.10690137-3.84843779 0.10690137-7.91067832 0.10690137-11.97291885zM1556.58367989 305.30680596c-21.70091426 37.73607276-56.01615381 38.69818242-92.79011778 32.92552529-11.01080918-47.89167363-3.10013086-79.32058418 22.44922207-90.97279893 23.83893545-10.90390781 45.64675107-2.24492256 70.34089571 28.00807647v30.03919717z" fill="#ff0000" ></path><path d="M998.6670626 639.47951035c26.40456123 0 51.20560635 0.53450508 76.00665146-0.21380186 15.60755391-0.42760459 20.41810224 5.98645898 21.38021192 21.27331055 4.81054747 76.11355283 5.23815205 76.11355283-71.73060996 76.11355284H752.36702715c16.8903668-33.35312989 30.57370224-62.64401924 46.7157621-90.43829473 2.99322949-5.23815205 16.03515849-6.20026172 24.4803419-6.41406358 23.94583682-0.8552083 47.998575-0.32070323 74.29623487-0.32070321V341.33246211h-61.46810772v-94.60743575h223.10250556v93.11082101h-60.93360263c0.10690137 100.59389472 0.10690137 198.19455996 0.10690137 299.64366298zM425.89119834 343.36358281h95.03504033c4.5967456 58.68868008 2.56562578 117.80496474 15.28685068 173.6073167 14.96614834 65.3165455-8.87278799 115.88074629-39.76719345 167.40705499-46.18125703-40.4085999-71.30300537-161.42059599-70.55469756-341.01437169zM597.03979062 638.30359883h153.93752227c-17.21107002 33.6738331-30.7875041 61.1474045-45.64675107 87.97957031-2.77942763 4.91744883-10.90390781 9.62109492-16.67656495 9.72799629-44.89844414 0.74830781-89.79688828 0.42760459-141.32319785 0.42760371 19.56289307-38.80508378 35.59805244-70.3408957 49.70899161-98.13517031z" fill="#ff0000" ></path></symbol><symbol id="icon-yanzhengma1" viewBox="0 0 1024 1024"><path d="M511.9 960c-140.1 0-400.8-200.8-400.8-390.7V206.8c0-8.8 7.6-15.9 17.1-16.1l22.7-0.4c0.9 0 89.8-1.7 181.6-36.7 94.2-35.8 154.8-76.9 155.5-77.4l13.4-9.1c3-2.1 6.7-3.2 10.4-3.2 3.6 0 7.3 1 10.3 3.1l13.6 9.2c0.6 0.4 61.4 41.6 155.5 77.4 91.8 34.9 180.8 36.7 181.7 36.7l22.5 0.4c9.5 0.2 17.1 7.3 17.1 16.1l0.2 362.5C912.8 759.2 652.2 960 511.9 960zM851 249c-34.5-2.5-106.9-11-182.2-39.7-77-29.3-133.5-62.1-156.8-76.6-23.2 14.5-79.9 47.4-156.8 76.6-75.2 28.6-147.5 37.1-182.4 39.7v320.3c0 148.9 227.1 331 339.1 331 43.4 0 128-33.9 211.2-108.3 80.2-71.7 128-155 128-222.7L851 249zM479.8 630.2c-6 5.9-13.9 8.8-21.8 8.8s-15.8-2.9-21.8-8.8l-92.5-89.5c-12-11.7-12-30.6 0-42.2 12.1-11.7 31.6-11.7 43.6 0L458 567l178.6-173c12.1-11.7 31.6-11.7 43.6 0 12.1 11.6 12.1 30.5 0 42.2l-200.4 194z" fill="#666666" ></path></symbol><symbol id="icon-zhifubao" viewBox="0 0 1024 1024"><path d="M582.892308 659.692308s-70.892308 57.107692-96.492308 70.892307c-21.661538 13.784615-43.323077 21.661538-63.015385 27.569231-19.692308 5.907692-35.446154 9.846154-49.230769 11.815385-13.784615 1.969231-25.6 1.969231-35.446154 3.938461h-13.784615c-23.630769 0-47.261538-1.969231-68.923077-7.876923-21.661538-5.907692-39.384615-13.784615-55.138462-25.6-15.753846-11.815385-27.569231-25.6-37.415384-43.323077-9.846154-17.723077-13.784615-37.415385-13.784616-59.076923 0-19.692308 5.907692-37.415385 15.753847-53.169231 9.846154-15.753846 23.630769-29.538462 39.384615-41.353846 15.753846-11.815385 33.476923-19.692308 53.169231-25.6 19.692308-5.907692 39.384615-7.876923 59.076923-7.876923s37.415385 3.938462 57.107692 7.876923c17.723077 3.938462 35.446154 7.876923 51.2 13.784616l47.261539 17.723077c15.753846 5.907692 29.538462 11.815385 41.353846 17.723077 5.907692 1.969231 11.815385 3.938462 15.753846 5.907692l17.723077 5.907692c13.784615-15.753846 23.630769-31.507692 33.476923-47.261538 7.876923-15.753846 15.753846-29.538462 21.661538-43.323077 5.907692-13.784615 9.846154-23.630769 13.784616-33.476923 3.938462-7.876923 5.907692-15.753846 5.907692-17.723077H334.769231v-31.507693h135.876923v-72.861538h-189.046154v-31.507692h189.046154v-59.076923c0-3.938462 1.969231-7.876923 5.907692-9.846154 3.938462-1.969231 9.846154-3.938462 15.753846-5.907693 5.907692-1.969231 13.784615-1.969231 21.661539-1.96923h51.2v76.8h194.953846v31.507692h-194.953846v72.861538h153.6c-3.938462 19.692308-7.876923 41.353846-15.753846 63.015385-5.907692 19.692308-15.753846 41.353846-27.569231 64.984615-11.815385 23.630769-27.569231 49.230769-47.261539 74.83077 0 0 151.630769 72.861538 313.107693 98.461538 27.569231-59.076923 41.353846-124.061538 41.353846-194.953846C984.615385 250.092308 773.907692 39.384615 512 39.384615 250.092308 39.384615 39.384615 250.092308 39.384615 512s210.707692 472.615385 472.615385 472.615385c161.476923 0 305.230769-80.738462 389.907692-204.8-86.646154-19.692308-179.2-57.107692-319.015384-120.123077z m-372.184616-21.661539c-1.969231 80.738462 90.584615 86.646154 104.369231 86.646154 47.261538 1.969231 84.676923-15.753846 114.215385-33.476923 29.538462-17.723077 76.8-63.015385 78.76923-64.984615l5.907693-5.907693c-13.784615-7.876923-25.6-13.784615-37.415385-19.692307-11.815385-5.907692-74.830769-39.384615-131.938461-45.292308-106.338462-7.876923-133.907692 57.107692-133.907693 82.707692z" fill="#009FE9" ></path></symbol><symbol id="icon-gou" viewBox="0 0 1024 1024"><path d="M981.674667 189.44c-13.084444-13.880889-31.175111-21.959111-50.289778-22.186667-19.114667-0.227556-37.432889 7.281778-50.858667 20.821334l-487.424 489.244444L141.425778 418.588444c-26.168889-26.851556-69.973333-25.372444-97.962667 3.299556-27.989333 28.785778-29.354667 73.841778-3.185778 100.693333l307.655111 316.302223c26.168889 26.851556 70.087111 25.372444 97.962667-3.299556 6.371556-6.599111 534.528-542.264889 534.528-542.264889 28.330667-28.444444 28.899556-74.865778 1.251556-103.879111z"  ></path></symbol><symbol id="icon-sangedian" viewBox="0 0 1024 1024"><path d="M926.459 621.333c-52.766 0-95.541-42.775-95.541-95.541s42.775-95.541 95.541-95.541S1022 473.026 1022 525.792s-42.775 95.541-95.541 95.541z m-382.162 0c-52.766 0-95.541-42.775-95.541-95.541s42.775-95.541 95.541-95.541 95.541 42.775 95.541 95.541-42.776 95.541-95.541 95.541z m-445.857 0c-52.766 0-95.541-42.775-95.541-95.541s42.775-95.541 95.541-95.541 95.541 42.775 95.541 95.541-42.775 95.541-95.541 95.541z" fill="" ></path></symbol><symbol id="icon-weibo1" viewBox="0 0 1024 1024"><path d="M755.400953 514.799788c-11.560416-2.34821-18.966308-5.96084-22.75957-10.295995-3.431999-4.696419-3.973893-8.850944-1.806315-12.824837l3.431999-5.96084c0.722526-0.722526 1.445052-1.986947 2.348209-3.431999 0.722526-1.625684 2.34821-4.877051 4.696419-9.934732s3.973893-9.934733 5.238314-14.992415c1.264421-5.057682 1.986947-11.199153 2.890104-18.424414 0.722526-7.22526 0.361263-14.45052-0.541895-20.953254-1.083789-6.502734-3.431999-13.727994-6.863997-21.314518-3.431999-7.767155-8.309049-14.811783-14.45052-20.953254-11.018522-10.657259-24.927148-17.882519-42.448404-20.953255-17.159993-3.070736-34.681249-3.251367-52.021873-0.541894-17.521256 2.709473-33.59746 6.141471-49.312401 10.295995-15.353678 4.335156-28.178515 8.309049-38.113247 12.102311l-14.992415 6.863997c-7.767155 2.34821-14.269889 3.793262-19.327571 4.69642-5.057682 0.722526-8.850944 0.541895-11.560417-0.541895s-4.877051-2.34821-6.322102-3.431999c-1.445052-1.083789-1.986947-3.793262-1.806315-8.128417 0.361263-4.335156 0.722526-7.947786 1.083789-11.018522 0.361263-3.070736 1.445052-7.947786 2.890104-14.45052 1.445052-6.502734 2.709473-11.741048 3.431998-15.53431 0-9.392838-0.541895-17.882519-1.806315-26.191568-1.083789-8.128418-3.61263-17.159993-7.586523-27.094726-3.793262-9.934733-9.392838-18.243782-16.79873-24.385253-7.22526-6.141471-16.618098-11.199153-27.817251-14.992415-11.199153-3.793262-25.830305-5.057682-43.351562-3.431998-17.882519 1.445052-37.932616 6.141471-60.150291 13.727994-27.094726 9.392838-54.370083 22.940201-82.006703 41.003352-27.817252 18.243782-51.841242 36.848827-72.433233 56.718292-20.050097 20.050097-38.655142 39.377668-55.815135 57.802082S101.153643 442.185923 92.122067 453.74634l-12.824836 18.424413c-25.469042 33.055565-44.43535 66.291762-56.718293 99.527959-12.282942 33.055565-18.243782 58.163345-17.521256 75.142706v24.385253c4.696419 37.029458 16.076204 70.085024 34.139355 99.527959 18.243782 29.442935 39.738931 53.105662 64.84671 71.168813 25.107779 18.06315 54.731346 33.416828 88.509437 46.422297 34.139354 12.824837 66.472394 22.037044 97.721644 27.817252 31.24925 5.96084 64.304816 9.934733 98.986065 12.102311 57.079555 4.696419 116.326689 0.180632 177.560769-13.366732 61.23408-13.366731 118.313636-36.848827 171.238666-70.085024 52.925031-33.055565 90.135121-72.975128 111.63027-119.216793 13.1861-27.094726 19.869466-52.563768 20.230729-76.407126 0.361263-23.843359-3.61263-43.351561-12.102311-58.343976s-19.508203-28.359146-33.055566-39.919563c-13.366731-11.560416-26.191568-20.050097-38.113247-25.469042-11.741048-6.141471-22.037044-9.392838-31.24925-10.657259zM402.446992 874.617746c-83.271124 3.793262-154.078673-12.282942-212.422649-48.589875C131.860998 789.720938 102.598695 743.840536 102.598695 688.206033c0-54.731346 28.901041-102.237432 86.703122-141.6151 57.802081-39.738931 128.970894-61.595343 212.964544-65.388605 84.174281-3.793262 154.981831 9.934733 212.964544 41.545247 57.802081 31.610513 86.703122 74.962074 86.703122 129.69342 0 55.453872-29.623567 105.66943-88.509437 149.924149-58.705239 44.254719-129.151526 68.278709-210.977598 72.252602z m-33.597459-320.620921c-22.217675 2.34821-42.448404 7.586523-60.150292 15.534309s-31.610513 17.159993-41.545246 27.817252c-9.934733 10.295996-18.424413 21.675781-25.469042 33.416828-6.863997 11.921679-11.741048 23.662727-14.45052 35.223144s-4.515788 22.037044-5.238314 31.791145c-0.722526 9.754101-1.083789 17.159993-1.083789 22.578938l1.083789 9.392838v4.696419c0 2.34821 0.722526 6.863997 2.34821 13.727994s3.61263 13.366731 6.502734 19.327571c2.709473 5.96084 7.044629 12.102311 13.366731 19.327571 6.322103 7.044629 13.366731 12.824837 22.037044 17.521256 50.938084 24.746516 98.263539 32.152408 142.337626 22.578938 44.074087-9.754101 79.477862-31.791145 106.391956-66.472393 10.657259-13.1861 17.882519-29.442935 21.314517-48.589875 3.431999-19.327571 2.709473-38.655142-2.348209-58.343976-5.057682-19.688834-13.727994-37.571353-26.191568-53.647557-12.282942-16.256835-30.526724-28.720409-54.911978-37.571353-24.385253-9.754101-52.383136-12.102311-83.993649-8.309049z m-41.545247 218.744752c-4.696419 0.722526-9.031575 1.083789-13.366731 0.541895-4.335156-0.361263-8.128418-1.083789-11.560416-2.34821-3.61263-1.264421-7.044629-2.709473-10.295996-3.973893-3.431999-1.445052-6.322103-3.61263-8.670312-6.502734-2.34821-2.709473-4.515788-5.418945-6.502734-8.128418-1.806315-2.709473-3.431999-5.96084-4.696419-9.392838-1.264421-3.61263-1.806315-7.22526-1.806316-11.018522 0-8.489681 2.34821-16.79873 6.863998-24.927148 4.696419-8.128418 11.018522-14.992415 19.327571-20.953254 8.128418-5.96084 17.159993-9.031575 27.094725-9.934733 6.863997-0.722526 13.727994-0.541895 20.230729 0.541895 6.502734 1.083789 12.102311 3.070736 16.79873 5.960839 4.696419 2.709473 8.670312 5.96084 12.102311 9.392838 3.431999 3.431999 5.96084 7.586523 7.586523 12.102311 1.445052 4.696419 2.34821 9.754101 2.348209 14.992415 0 8.489681-2.34821 16.618098-7.586523 24.385253-5.057682 7.767155-11.741048 14.269889-20.230728 19.688834-8.489681 5.780208-17.521256 8.850944-27.636621 9.57347z m98.263539-83.271124c-5.418945 3.793262-11.018522 5.418945-16.79873 5.238314-5.96084-0.361263-9.754101-2.890104-12.102311-7.586523l-2.348209-4.696419c-0.722526-1.625684-1.083789-3.070736-1.083789-4.696419v-4.69642c0-2.34821 0.361263-4.335156 1.083789-5.960839l2.348209-4.696419c0.722526-1.625684 1.986947-2.709473 3.431999-3.431999l3.431998-4.696419c6.141471-4.696419 12.102311-6.502734 17.882519-5.96084 5.96084 0.722526 9.754101 3.793262 12.102311 9.392839 2.34821 3.070736 3.251367 6.502734 2.890104 10.295995-0.361263 3.793262-1.625684 7.586523-3.431998 11.018522-1.986947 4.154525-4.335156 7.405892-7.405892 10.476627z m410.756042-242.046216c4.696419 0 8.850944-1.083789 12.824836-3.431999 3.793262-2.34821 6.863997-5.238314 9.392839-8.670312s3.793262-7.044629 4.696419-11.018522c0.722526-0.722526 1.083789-1.986947 1.083789-3.431998 9.392838-87.967543-21.675781-138.183101-92.663962-150.466044-20.953255-3.793262-40.100194-4.335156-57.802082-1.083789-5.418945 0-9.934733 1.445052-13.727994 3.973894-3.793262 2.709473-7.044629 6.141471-9.934733 10.295995-2.709473 4.335156-3.973893 8.670312-3.973893 13.366732 0 7.767155 2.709473 14.45052 8.128418 19.688834 5.418945 5.418945 11.921679 8.128418 19.688834 8.128417 60.150291-13.727994 92.663962 5.418945 97.179749 57.802082 1.625684 13.1861 0.722526 25.469042-2.348209 37.029458 0 7.767155 2.709473 14.45052 8.128418 19.688834 5.057682 5.418945 11.560416 8.128418 19.327571 8.128418zM816.815664 121.20374c-34.139354-7.767155-79.477862-6.141471-136.557417 4.696419-0.722526 0-1.445052 0.361263-2.34821 1.083789l-1.083789 2.348209-1.083789 1.083789c-8.489681 2.34821-15.353678 7.044629-20.953255 14.450521-5.418945 7.22526-8.128418 15.173046-8.128417 23.662727 0 11.560416 3.793262 21.314518 11.560416 28.901041 7.767155 7.767155 16.979361 11.560416 27.817252 11.560416h3.431998c0.722526 0 2.34821-0.361263 5.238314-1.083789 2.709473-0.722526 5.418945-1.445052 8.670312-1.806315 3.070736-0.361263 6.322103-1.083789 9.934733-2.34821 3.431999-1.083789 6.502734-2.34821 9.392838-3.431998 2.709473-1.083789 7.947786-1.806315 15.53431-1.806315 7.767155 0 17.159993 0.541895 28.359146 1.806315 11.199153 1.083789 23.482096 3.973893 37.029458 8.670312 13.366731 4.696419 27.094726 10.295996 40.461457 17.521256 13.366731 6.863997 26.914094 16.618098 40.461457 28.901041 13.547363 12.282942 25.288411 26.552831 35.223144 42.809666 20.050097 45.338508 23.843359 89.412595 11.560416 132.04163 0 0.722526-0.180632 1.445052-0.541894 2.34821-0.361263 0.722526-1.083789 2.709473-1.806315 5.960839-0.722526 2.890104-1.445052 5.96084-2.34821 8.670313-0.722526 2.709473-1.625684 6.141471-2.34821 10.295995-0.722526 4.335156-1.083789 7.947786-1.083789 11.018522 0 6.863997 1.986947 12.824837 5.96084 17.521256s8.670312 7.947786 14.45052 9.934733c5.96084 1.986947 12.644205 2.890104 20.230729 2.890104 21.675781 0 34.500617-13.1861 38.113247-39.5583 9.392838-29.98483 14.45052-58.705239 15.53431-86.341859s-0.722526-51.479979-5.96084-72.433233c-5.057682-20.953255-12.644205-40.280826-22.759569-58.343976-9.934733-18.243782-21.675781-33.416828-34.681249-46.241665-12.824837-12.824837-27.455989-24.385253-43.712824-34.861881-16.256835-10.476627-31.791145-18.785676-46.964192-24.927147-14.811783-5.96084-30.526724-11.018522-46.602928-14.992415z" fill="#D02B28" ></path></symbol><symbol id="icon-zhibo" viewBox="0 0 1024 1024"><path d="M808.4 204.4H640.5l53.1-95.2c6.4-11.2 2.3-25.6-8.7-31.6-11-6.5-25.2-2.3-31.1 8.8l-65.9 118H422.8l-65.9-118c-6.4-11.1-20.1-14.9-31.1-8.8-11 6.5-14.6 20.4-8.7 31.6l53.1 95.2H215.6c-84.2 0-152.3 69.7-152.3 154.7v435.8c0 85.5 68.6 154.7 152.3 154.7h592.9c84.2 0 152.3-69.7 152.3-154.7V359.1c0-85.5-68.2-154.7-152.4-154.7zM668 597.4L450.7 726.1c-3.7 2.3-7.8 3.3-11.9 3.3-4.1 0-8.2-0.9-11.9-3.3-7.3-4.2-11.9-12.1-11.9-20.9V448.3c0-8.4 4.6-16.7 11.9-20.9 7.3-4.2 16.5-4.2 23.8 0L668 556c6.9 4.2 11.4 12.5 11.9 20.4 0 8.4-4.6 16.8-11.9 21z m0 0"  ></path></symbol><symbol id="icon-yiwancheng" viewBox="0 0 1025 1024"><path d="M1.024 503.296c6.4512 0.6144 11.776-3.3792 17.92-4.1984 1.8432-0.2048 3.9936-1.536 5.3248-0.8192 4.5056 2.1504 6.7584 0.2048 9.8304-3.072 1.9456-2.048 6.144-0.6144 9.3184-1.2288 5.7344-1.2288 11.5712-1.6384 16.0768-6.2464 0.9216-1.024 2.6624-1.7408 3.9936-1.8432 20.1728-2.048 39.0144-9.8304 58.9824-12.5952 4.1984-0.6144 9.3184-0.512 12.0832 4.4032 0.3072 0.512 1.1264 0.9216 1.6384 0.8192 1.4336-0.2048 0.4096-1.3312 0.4096-1.9456 0.1024-1.6384-0.3072-3.4816 2.1504-3.8912 13.0048-1.7408 24.6784-7.68 37.2736-10.6496 3.2768-0.8192 6.5536-1.3312 9.9328-1.536 3.8912-0.3072 7.68 0.512 10.5472-3.9936 1.8432-2.9696 6.7584-2.6624 10.24-3.6864 11.3664-3.1744 22.6304-6.8608 34.0992-8.9088 40.6528-7.4752 80.0768-20.3776 120.4224-29.2864 22.1184-4.9152 43.8272-11.5712 65.8432-17.408 4.8128-1.3312 9.8304-2.1504 14.7456-3.3792 1.4336-0.3072 3.072-0.2048 2.4576-3.072-0.4096-2.048 1.6384-4.4032 3.6864-5.632 2.2528-1.3312 3.6864-0.1024 4.5056 2.2528 1.6384 4.608 8.0896 5.7344 11.1616 1.9456 2.9696-3.584 7.5776-2.3552 11.3664-3.9936 31.9488-13.824 66.2528-19.456 99.6352-28.5696 51.6096-14.0288 103.3216-27.5456 155.0336-40.8576 18.5344-4.8128 37.0688-9.5232 55.7056-14.0288 23.9616-5.8368 47.9232-11.3664 71.68-18.3296 9.9328-2.9696 20.8896-2.56 31.1296-5.632 8.192-2.4576 16.4864-4.7104 24.7808-6.9632 2.4576-0.7168 4.8128-1.9456 7.7824-0.6144 1.2288 0.6144 3.4816-1.1264 4.4032-2.8672 0.6144-1.2288 1.1264-2.2528 2.048-3.2768 3.3792-3.584 6.656-5.3248 11.9808-3.6864 3.1744 0.9216 6.7584 2.56 10.6496 1.3312 2.1504-0.6144 2.4576 1.536 2.6624 3.3792 0.512 6.144 1.536 12.9024 3.584 18.0224 3.6864 9.216 4.8128 18.944 8.6016 28.0576 0.512 1.2288 1.024 2.6624 0.9216 3.8912-1.4336 15.2576 5.9392 28.672 9.4208 42.9056 0.9216 3.7888 4.3008 7.168 5.632 11.1616 1.024 2.8672 1.536 5.8368 1.3312 8.9088-0.1024 1.6384-0.7168 3.7888 2.4576 3.4816 1.2288-0.2048 1.4336 1.2288 1.536 2.2528 0.4096 5.12 2.2528 9.8304 4.1984 14.4384 1.8432 4.5056 2.4576 9.1136 1.7408 13.824-0.2048 1.2288-0.4096 2.2528 0.3072 3.3792 6.3488 10.1376 7.5776 21.8112 9.9328 33.0752 1.4336 6.7584 2.8672 13.5168 6.8608 19.3536 4.1984 6.144 3.2768 13.6192 5.12 20.3776 3.2768 12.1856 7.3728 24.064 11.0592 36.1472v6.0416c-21.6064 5.3248-42.496 13.0048-63.488 19.968-9.216 3.072-18.5344 6.4512-28.0576 8.0896-8.192 1.4336-16.7936 0.512-25.2928 0.6144-3.1744 0-6.3488 0.7168-9.5232 0.9216-15.5648 1.024-28.4672 10.752-43.6224 12.6976-4.5056 0.6144-8.9088 1.6384-13.4144 2.4576-3.8912 0.7168-6.8608-0.512-8.3968-4.4032 1.2288 6.144 0.9216 6.8608-5.12 8.192-7.7824 1.6384-15.1552 4.5056-22.7328 6.8608-2.4576 0.7168-3.7888 1.9456-4.4032 4.7104-5.632 24.2688-14.9504 47.104-26.7264 69.0176-2.9696 5.632-6.0416 11.264-9.4208 16.6912-1.9456 3.072-3.9936 6.3488-8.3968 6.5536-2.048 0.1024-1.7408 1.536-1.8432 2.8672-0.1024 2.3552-0.2048 4.7104-0.512 7.0656-0.6144 4.8128-2.2528 8.4992-8.2944 7.3728-1.536-0.3072-2.8672 0.2048-3.3792 2.1504-1.7408 6.4512-6.4512 11.6736-10.24 16.384-6.144 7.5776-13.2096 14.9504-21.2992 20.6848-4.7104 3.2768-7.4752 8.4992-13.0048 11.1616-5.2224 2.4576-4.9152 3.072-10.3424 1.4336 3.4816 4.608 1.6384 4.608-2.7648 6.2464-5.0176 1.8432-10.9568 3.3792-15.0528 7.0656-11.5712 10.5472-25.3952 17.2032-39.1168 24.3712-6.8608 3.6864-13.5168 6.5536-21.1968 7.0656-0.3072 0-0.6144 0.2048-0.9216 0.4096-14.336 11.264-32.0512 13.312-48.64 18.6368-7.4752 2.4576-15.4624 2.048-23.04 3.9936-17.5104 4.7104-35.6352 3.1744-53.3504 5.4272-5.7344 0.7168-10.3424-0.4096-15.2576-1.3312-3.2768-0.7168-7.7824 3.584-10.0352-1.9456-4.4032 5.3248-8.192 2.2528-11.9808-0.9216-23.8592 3.8912-44.6464-7.5776-66.4576-13.824-6.4512-1.8432-12.5952-5.5296-19.1488-7.68-3.584-1.1264-1.2288-4.4032-2.3552-6.4512-5.12 3.1744-10.6496 2.048-13.9264-2.9696-1.024-1.6384-2.4576-1.4336-3.8912-1.6384-7.3728-1.1264-13.1072-4.8128-18.944-9.4208-3.9936-3.1744-6.7584-6.2464-8.6016-10.8544 0.3072 1.3312 1.1264 2.4576-0.1024 3.4816-0.8192 0.7168-1.9456 0.512-2.8672 0-2.56-1.3312-5.0176-2.8672-6.9632-4.9152-2.2528-2.3552-3.8912-5.0176-7.4752-6.2464-2.6624-0.9216-3.4816-5.3248-5.0176-7.9872-1.024-1.7408 4.1984-2.2528 5.12-5.3248 0.3072-1.1264 1.9456 0.3072 2.8672 0.9216 13.4144 8.9088 24.9856 20.2752 39.3216 27.7504 4.5056 2.3552-0.3072 4.3008-0.6144 6.4512 0.3072 0.2048 0.8192 0.4096 0.8192 0.4096 2.9696-5.0176 6.656-2.9696 10.4448-1.1264 4.9152 2.3552 8.8064 6.2464 13.5168 8.9088 6.8608 3.7888 13.312 8.0896 21.7088 7.7824 2.56-0.1024 5.5296 0.7168 7.7824 1.9456 6.2464 3.584 13.312 0.3072 19.5584 2.8672 2.1504 0.9216 4.1984 2.1504 6.4512 2.8672 1.4336 0.512 3.1744 4.096 4.7104-0.1024 0.3072-0.9216 1.8432 0 2.7648 0.3072 10.3424 4.5056 21.504 4.5056 32.3584 6.0416 1.6384 0.2048 3.4816-0.4096 4.1984 1.8432 0.4096 1.3312 1.4336 1.2288 2.4576 1.024 10.24-1.9456 20.5824-0.8192 30.8224-0.8192 10.0352 0 19.8656-0.512 29.696-2.3552 6.2464-1.1264 12.4928-0.512 18.6368-0.7168 1.024 0 2.1504 0.3072 2.9696 0 11.8784-4.8128 24.7808-6.4512 36.4544-11.3664 5.3248-2.2528 11.4688-2.4576 15.7696-4.7104 8.704-4.608 18.8416-5.8368 26.7264-12.0832 2.4576-1.9456 5.4272-3.584 8.3968-4.608 8.6016-3.1744 16.896-6.8608 23.2448-13.9264 0.8192-0.9216 2.2528-1.536 3.584-1.8432 11.9808-1.9456 19.968-10.5472 28.7744-17.7152 16.6912-13.6192 30.6176-29.7984 44.3392-46.2848 2.048-2.56 4.096-3.6864 7.2704-2.4576 3.3792 1.3312 4.608-0.1024 4.3008-3.584-0.2048-2.3552 0.3072-4.8128-0.2048-7.0656-0.7168-2.9696 0.2048-5.0176 1.9456-7.3728 13.312-18.1248 24.9856-37.1712 32.256-58.5728 2.3552-6.9632 4.3008-14.1312 6.0416-21.2992 0.9216-3.7888 1.1264-7.7824 6.656-7.68-4.7104-1.3312-9.3184 0-13.7216-1.3312-0.3072-0.1024-0.7168-0.1024-0.9216 0.1024-11.5712 9.4208-26.3168 10.24-39.7312 14.0288-43.7248 12.288-87.6544 23.7568-131.4816 35.6352-14.7456 3.9936-29.4912 8.2944-44.2368 12.288-2.9696 0.8192-6.3488 2.4576-8.2944-1.9456-0.8192 2.1504-1.3312 4.1984-4.096 4.4032-10.1376 0.7168-19.6608 4.4032-29.696 5.5296-1.1264 0.1024-2.3552 0.4096-3.4816 0.512-2.3552 0.1024-5.632 0.512-6.3488-1.8432-0.8192-2.56 2.9696-1.9456 4.096-3.2768 1.9456-2.2528 3.584-2.1504 6.4512-2.048 1.9456 0.1024 4.096-3.4816 3.4816-6.7584-0.7168-4.1984 1.7408-8.704 5.7344-8.8064 8.3968-0.3072 15.872-4.1984 23.9616-5.9392 24.576-5.12 48.0256-14.5408 72.4992-19.5584 11.5712-2.3552 22.4256-6.7584 33.6896-9.6256 8.3968-2.1504 16.896-6.4512 26.112-5.5296 2.56 0.2048 3.584-1.4336 4.7104-3.1744 2.2528-3.2768 5.3248-5.0176 9.1136-3.584 2.048 0.8192 6.2464-3.2768 6.0416 2.7648 0.512-0.512 0.8192-0.7168 0.9216-0.9216 0.512-7.8848 0.512-7.8848 8.3968-9.9328 18.5344-4.608 36.6592-11.1616 55.7056-14.1312 4.096-0.6144 8.2944-1.2288 12.4928-1.536 2.4576-0.2048 4.8128-0.512 6.7584-1.7408 7.5776-4.7104 16.1792-6.3488 24.6784-8.6016 2.2528-0.6144 4.5056-1.4336 6.656-2.4576 2.3552-1.1264 4.5056-1.7408 7.2704-0.9216 4.096 1.2288 7.9872-0.6144 11.776-2.048 7.0656-2.6624 14.1312-5.4272 21.7088-6.4512 2.4576-0.3072 4.1984-3.8912 5.5296-2.6624 3.1744 2.9696 5.2224-0.1024 7.8848-0.3072 12.0832-1.1264 23.4496-5.0176 35.1232-7.68 2.7648-0.6144 5.632-1.2288 8.3968-1.536 1.6384-0.2048 2.9696-0.2048 3.072-2.3552 0-0.512 0.7168-1.4336 1.1264-1.4336 8.2944 0.2048 15.6672-4.5056 23.8592-4.3008 10.6496 0.2048 20.0704-3.7888 29.696-7.2704 8.9088-3.1744 17.7152-6.7584 27.4432-4.3008 2.2528 0.6144 3.4816-0.8192 4.1984-2.6624 1.024-2.6624 0.7168-4.9152-2.048-6.3488-1.1264 0.7168-0.6144 1.8432-0.8192 2.7648-0.3072 1.4336-1.2288 1.8432-2.56 1.7408-1.2288-0.1024-1.7408-0.9216-1.8432-2.048-1.2288-16.9984-9.3184-32.256-12.8-48.64-1.3312-6.0416-1.024-12.288-0.512-18.5344 0.2048-2.6624 2.8672-3.072 4.608-5.12-2.1504-0.3072-3.7888-1.536-4.9152 0.8192-0.4096 0.8192-0.1024 2.2528-1.536 2.2528-1.7408 0-1.8432-1.536-2.3552-2.8672-5.3248-12.5952-8.2944-25.9072-11.9808-39.0144-2.1504-7.5776-3.2768-15.5648-7.0656-22.528-1.8432-3.3792-3.3792-6.7584-4.3008-10.4448-0.1024-0.512-0.6144-1.024-0.512-1.4336 1.8432-9.0112-4.8128-15.872-6.0416-24.2688-1.2288-8.6016-4.5056-16.896-6.7584-25.2928-2.3552-8.6016-4.5056-17.2032-6.9632-25.8048-1.9456-6.656-3.2768-7.3728-9.0112-6.2464-26.624 5.2224-52.4288 13.5168-78.6432 20.1728-14.0288 3.4816-28.0576 7.168-42.2912 9.6256-1.1264 0.2048-2.8672 0.4096-3.2768 1.1264-3.584 6.4512-10.5472 6.144-16.1792 7.5776-35.5328 9.4208-71.3728 18.3296-106.9056 27.648-34.9184 9.216-69.7344 18.944-104.3456 29.3888-6.3488 1.9456-12.5952 4.5056-19.6608 4.4032-3.3792 0-6.7584 1.8432-10.0352 3.1744-3.072 1.1264-6.144 2.3552-9.3184 1.4336-2.8672-0.8192-5.12-1.4336-6.656 1.8432-0.4096 0.9216-1.536 1.4336-2.6624 0.8192-5.632-2.8672-10.4448 0.3072-15.36 2.1504-3.3792 1.2288-6.7584 2.6624-6.8608-4.608-3.9936 7.9872-10.8544 4.8128-15.9744 6.9632-1.2288 0.512-3.072-0.2048-3.2768 2.1504-0.1024 1.6384-1.024 3.1744-2.9696 2.4576-1.9456-0.7168-2.7648-2.3552-2.56-4.5056 0.3072-2.4576 2.3552-3.9936 3.4816-6.2464-2.56-0.512-2.6624 1.536-3.4816 2.7648-1.536 2.2528-1.9456 2.2528-4.1984 0.1024-0.512-0.4096-0.8192-0.6144-1.2288-0.3072-0.6144 0.512-1.7408 0.7168-1.536 1.7408 0.2048 0.9216 0.8192 1.7408 1.1264 2.56-1.2288 1.024-2.2528 0.3072-2.9696-0.2048-1.3312-0.8192-1.6384-0.2048-2.1504 0.8192-0.6144 1.1264-0.3072 1.4336 0.7168 2.2528 2.9696 2.3552 1.9456 3.9936-1.1264 5.9392-4.5056 2.9696-8.192 1.1264-11.776-1.024-4.3008-2.4576-6.8608 0.4096-7.2704 3.4816-0.7168 4.608-3.6864 5.2224-6.8608 6.0416-29.4912 7.4752-59.0848 14.848-88.4736 22.4256-44.6464 11.4688-89.2928 22.8352-133.4272 36.0448-10.4448 3.072-21.6064 3.072-31.8464 7.3728-1.8432 0.7168-4.5056 0.9216-5.2224-2.2528-0.3072-1.4336-1.536-1.536-2.8672-1.3312 1.1264 2.56 3.2768 4.3008-2.048 5.4272-6.2464 1.3312-13.2096 0.9216-18.6368 5.7344-2.8672 2.56-7.168 2.3552-11.0592 2.048-2.7648-0.2048-5.12-0.8192-7.7824 1.7408-2.8672 2.7648-4.096-1.7408-6.0416-3.3792 0.1024 1.6384 1.4336 3.6864-1.3312 4.1984-1.9456 0.4096-3.9936 1.024-5.9392 1.024-1.536 0-3.6864 1.4336-4.4032-0.7168-0.8192-2.4576 2.1504-2.4576 4.4032-4.5056-8.0896 2.8672-15.0528 4.5056-20.5824 9.728-2.8672 2.7648-6.2464 5.12-10.752 4.7104-0.6144-0.1024-1.6384-0.1024-1.9456 0.3072-4.5056 6.144-11.776 4.7104-17.8176 6.3488-2.56 0.7168-4.9152 0.7168-7.2704 2.6624-2.3552 1.9456-4.7104 0.2048-5.9392-3.4816-2.4576 6.2464-7.7824 4.9152-11.8784 6.144-2.56 0.8192-5.3248 1.1264-7.7824 2.048-3.3792 1.2288-6.5536 2.8672-6.2464-4.096-1.3312 2.4576-1.9456 3.7888-2.6624 5.12-0.8192 1.536-1.9456 2.1504-2.8672 0.2048-2.1504-4.5056-2.56-1.4336-3.6864 0.6144-2.048 3.7888-5.8368 1.536-8.704 2.2528-2.6624 0.7168-2.9696-1.7408-3.072-3.9936-2.7648 6.7584 0.7168 13.0048 1.2288 19.3536 0.2048 3.1744 0.512 4.608-3.4816 2.8672-2.4576-1.024-5.5296-0.7168-8.2944-0.9216-1.8432-0.1024-3.584-0.512-3.3792-2.7648 0.512-6.2464-2.8672-11.3664-4.8128-16.7936-1.024-2.7648-1.024-5.7344-1.024-8.8064z"  ></path><path d="M451.6864 663.7568c-1.3312-2.56-2.56-4.3008-0.7168-5.9392 2.8672-2.4576 6.4512-3.584 9.8304-2.56 3.2768 1.024 5.12 1.024 6.8608-2.2528 0.9216-1.7408 3.584-1.9456 5.5296-1.9456 6.0416 0 11.6736-1.8432 17.3056-3.4816 4.1984-1.2288 8.3968-1.024 12.4928-1.536 3.072-0.4096 4.7104 2.2528 4.9152 4.8128 0.2048 2.3552-0.512 4.8128-4.1984 4.9152-5.5296 0.1024-10.9568 2.1504-16.0768-2.7648-1.8432-1.7408-4.4032 2.3552-5.8368 4.7104 4.3008 0.1024 6.4512 4.608 10.6496 5.3248 0.8192 0.1024 0 2.1504-0.9216 2.2528-7.168 1.1264-13.4144 5.7344-20.8896 5.632-3.1744 0-8.0896 1.3312-5.9392-2.4576-1.3312 6.9632-9.4208 6.9632-16.896 8.8064-12.6976 3.1744-25.2928 6.8608-37.888 10.4448-3.8912 1.1264-7.8848 1.6384-11.9808 1.536-3.072-0.1024-5.5296 1.3312-8.3968 2.6624-6.656 3.072-14.0288 5.8368-21.7088 5.0176-2.2528-0.2048-3.7888-0.512-4.9152 1.8432-0.8192 1.7408-2.7648 1.8432-4.4032 2.2528-36.2496 8.704-72.0896 19.456-108.1344 28.7744-24.8832 6.4512-50.2784 10.3424-75.3664 16.0768-10.24 2.3552-19.7632 6.656-29.184 11.0592-11.264 5.4272-23.552 7.0656-35.5328 8.9088-10.24 1.6384-20.5824 3.2768-30.72 5.5296-6.656 1.4336-9.0112 0.3072-9.5232-6.2464-0.3072-4.3008-0.6144-8.2944-2.7648-12.288-1.3312-2.56-0.4096-6.2464-0.3072-9.5232 0-0.6144 0.512-1.2288 0.9216-1.6384 0.8192-0.9216 2.8672 1.9456 2.9696-0.9216 0-1.6384-1.8432-0.9216-2.7648-1.6384-2.048-1.536-2.56-3.8912-3.1744-6.144-2.7648-9.8304-4.608-20.0704-8.3968-29.5936-9.0112-22.1184-13.6192-45.568-20.48-68.3008-0.8192-2.7648-2.4576-5.632-0.3072-8.704 0.8192-1.2288-0.4096-2.56-0.9216-3.6864-3.072-7.0656-6.4512-14.1312-4.7104-22.2208 0.1024-0.7168-0.2048-1.7408-0.8192-2.2528-6.4512-5.8368-7.8848-13.9264-9.8304-21.7088-1.4336-6.0416-3.072-12.0832-5.5296-17.8176-1.2288-2.8672-0.9216-4.7104 2.6624-5.8368-6.9632-1.7408-2.8672-10.24-9.4208-12.0832 2.048-1.6384 3.9936-2.048 5.0176-3.9936 1.6384-3.072 4.1984-3.4816 6.3488-0.512 2.3552 3.2768 3.072 0.4096 3.4816-1.024 0.512-1.9456 0.2048-3.9936 0.3072-6.0416 0.1024-0.9216 0-2.2528 1.4336-2.2528 1.1264 0 2.1504 0.9216 1.9456 1.8432-1.4336 5.7344 2.7648 9.9328 3.9936 14.9504 3.6864 14.848 9.8304 28.9792 12.8 44.032 1.4336 7.2704 2.8672 14.5408 0.512 22.8352 3.1744-2.9696 4.096-1.8432 4.1984 1.1264 0 1.7408-0.4096 3.7888 1.7408 4.9152 1.4336 0.8192 1.024 2.2528 0.2048 2.9696-2.8672 2.6624-1.4336 5.0176 0.2048 7.4752 9.1136 14.0288 12.3904 30.0032 14.9504 46.1824 0.1024 0.512 0.2048 1.024 0 1.536-1.7408 5.5296-0.4096 9.5232 5.12 11.9808 0.4096 0.2048 0.8192 1.1264 0.8192 1.7408 0.2048 9.5232 5.3248 18.2272 5.7344 27.5456 0.2048 5.3248 1.9456 10.3424 4.096 13.9264 3.7888 6.5536 2.7648 12.5952 2.56 19.1488 0 1.536 0.512 2.9696 1.9456 4.3008 1.536-2.8672 3.072-5.5296 4.5056-8.2944 0.8192-1.536 1.6384-2.8672 3.6864-2.9696 2.3552-0.1024 3.4816 2.1504 5.3248 2.4576 0.9216 0.2048 1.1264-2.7648 3.1744-2.9696 1.9456-0.2048 3.8912-0.9216 5.8368-1.536 28.4672-7.9872 57.4464-14.1312 86.3232-20.2752 24.3712-5.2224 48.2304-12.1856 72.2944-18.5344 18.2272-4.8128 36.864-8.2944 55.1936-12.9024 9.1136-2.2528 18.2272-4.7104 27.2384-7.4752 4.7104-1.536 9.6256-1.536 14.336-2.4576 2.8672-0.6144 5.632-0.9216 7.7824-3.072 1.1264-1.1264 2.3552-0.9216 3.6864-0.3072 2.048 0.8192 3.9936 0.2048 5.8368-0.8192 2.048-1.1264 3.6864-2.56 6.4512-1.2288 1.6384 0.8192 3.072-1.2288 3.8912-2.56 1.7408-2.7648 3.2768-4.096 6.2464-1.2288 1.6384 1.536 3.8912 1.2288 4.4032-1.024 0.7168-2.9696 2.6624-2.6624 4.8128-3.1744 7.8848-1.8432 15.5648-4.096 23.3472-6.2464 1.6384-0.512 3.3792-1.1264 4.9152-0.512 2.4576 1.024 4.1984 0.1024 5.8368-1.6384 1.4336-1.6384 3.4816-2.2528 5.4272-2.3552 2.048-0.1024 4.608 0.6144 2.9696 3.4816-2.1504 3.7888 1.1264 3.8912 3.584 5.9392zM506.6752 922.112c-1.1264-0.9216-2.048-1.2288-2.1504-1.7408-1.536-6.9632-4.9152-3.072-7.68-1.2288-1.3312 0.9216-2.2528 2.8672-4.1984 1.4336-1.8432-1.3312-1.4336-3.1744-0.4096-5.4272h-4.096c-2.3552-0.1024-2.9696-1.1264-1.9456-3.2768 0.8192-1.8432 1.536-3.7888 0.4096-5.8368-0.7168-1.3312-2.048-2.7648-0.512-3.9936 1.6384-1.4336 3.2768 0 4.608 1.3312 1.1264-3.072-0.8192-3.6864-2.56-4.3008-1.1264-0.4096-2.4576-0.9216-2.3552-2.2528 0.2048-1.8432 2.048-1.6384 3.2768-1.4336 3.3792 0.6144 8.192-2.4576 9.5232 4.096-0.1024-2.1504-0.3072-4.096 2.2528-3.9936 5.5296 0.2048 10.752-1.6384 16.0768-2.8672 1.9456-0.512 3.2768 0.4096 3.2768 2.6624v9.0112c2.3552-2.56 3.8912-4.3008 5.4272-5.8368 0.7168-0.8192 1.8432-1.024 2.7648-0.4096 1.024 0.7168 1.024 1.7408 0.3072 2.6624-1.024 1.3312-1.6384 2.3552 0.6144 2.7648 1.7408 0.3072 2.4576-0.4096 2.56-2.1504 0.1024-2.1504 2.1504-3.8912 1.6384-6.2464-0.3072-1.7408 0.8192-2.4576 2.2528-2.6624 1.3312-0.2048 2.6624-0.512 3.9936-0.512 11.4688 0.512 22.4256-3.584 33.6896-3.6864 2.048 0 4.096 0.2048 5.9392-0.9216 5.0176-2.9696 8.0896-0.8192 10.24 3.8912 0.512-0.512 0.9216-0.8192 0.9216-0.9216-2.56-6.144-2.56-6.0416 3.8912-7.3728 9.5232-1.8432 19.2512-3.1744 28.3648-6.9632 8.8064-3.6864 17.5104-7.5776 27.0336-9.728 4.7104-1.024 8.8064-4.8128 13.2096-7.2704 15.872-8.4992 31.8464-16.9984 47.7184-25.3952 2.7648-1.4336 5.5296-2.56 5.632-6.3488 0-0.512 0.512-1.4336 1.024-1.536 14.9504-4.608 23.9616-17.2032 35.5328-26.3168 1.8432-1.4336 3.8912-2.6624 5.8368-3.8912 2.7648-1.8432 7.3728-1.3312 7.3728-6.3488 6.0416-1.7408 6.7584-8.704 11.5712-11.776 5.12-3.2768 8.2944-8.704 13.6192-12.288 3.1744-2.1504 6.5536-6.144 8.4992-10.8544 3.1744-7.5776 7.7824-14.9504 13.0048-21.4016 5.9392-7.4752 9.9328-15.4624 11.776-24.6784 0.4096-2.3552 0.8192-4.7104 4.4032-4.096 0.9216 0.1024 4.4032-0.6144 1.4336-3.4816-1.536-1.536 0.1024-3.072 1.2288-4.3008 9.5232-11.0592 17.3056-23.2448 23.4496-36.352 10.8544-23.3472 17.408-48.0256 22.2208-73.216 0.8192-4.3008 1.4336-8.6016 2.1504-12.9024 0.6144-3.6864 2.048-5.8368 6.4512-4.3008 3.7888 1.3312 7.8848 1.7408 11.776 2.6624 2.6624 0.6144 3.7888 1.7408 2.8672 5.0176-3.4816 11.6736-3.8912 23.8592-5.3248 35.84-0.2048 1.8432 0 4.096-1.4336 5.2224-6.0416 4.7104-5.632 11.3664-5.632 17.92 0 4.1984 0.7168 8.6016-4.096 11.0592-1.1264 0.6144-1.024 2.048-1.024 3.2768 0 2.56 0.1024 5.12-2.8672 6.4512-1.2288 0.512-1.2288 1.9456-1.1264 3.072 0.2048 2.9696-0.7168 5.12-3.584 6.5536-2.3552 1.1264-2.3552 3.1744-1.8432 5.632 0.6144 2.7648 1.536 6.144-3.072 7.168-1.7408 0.4096-2.1504 2.4576-2.6624 4.096-2.6624 8.192-4.608 16.2816-10.5472 23.552-3.7888 4.5056-9.0112 9.728-9.1136 17.3056 0 4.1984-3.8912 6.4512-7.3728 8.2944-3.072 1.7408-5.0176 3.8912-4.5056 7.68 0.3072 2.6624-1.024 4.608-3.3792 5.632-4.096 1.7408-6.0416 5.12-7.68 9.0112-2.3552 5.5296-4.608 11.3664-11.1616 13.5168-0.7168 0.2048-1.3312 1.024-1.7408 1.7408-8.9088 13.0048-21.1968 22.6304-32.3584 33.28-5.8368 5.5296-10.1376 12.5952-16.4864 17.6128-14.2336 11.1616-27.3408 23.8592-44.6464 30.8224-5.2224 2.048-10.4448 5.2224-15.0528 8.9088-1.1264 0.9216-2.8672 2.1504-2.9696 3.2768-0.2048 4.9152-3.3792 4.7104-6.7584 4.5056-5.3248-0.4096-8.9088 3.4816-13.4144 5.3248-3.072 1.2288-6.8608 2.4576-8.704 4.9152-3.584 4.9152-8.8064 3.9936-13.4144 5.632-9.4208 3.3792-18.432 7.68-28.3648 9.9328-5.2224 1.2288-10.8544 2.1504-15.4624 4.1984-4.3008 1.9456-9.1136 3.3792-13.2096 6.0416-2.1504 1.3312-4.5056 2.2528-5.3248-1.536-0.3072-1.3312-0.9216-1.7408-2.1504-0.9216-6.7584 4.608-14.9504 4.8128-22.528 6.8608-2.2528 0.6144-4.608 1.7408-7.2704 0-1.8432-1.1264-2.8672 0.9216-2.9696 2.7648-0.1024 1.6384-0.3072 3.1744-2.4576 3.1744-1.6384 0.1024-3.584 0.512-4.1984-1.7408-0.6144-2.048-1.8432-1.8432-3.584-1.4336-3.4816 0.7168-6.9632 1.4336-10.4448 1.8432-4.608 0.512-9.0112 1.6384-13.824 0-6.3488-2.1504-13.0048 0.7168-19.5584 0.512-1.4336 0-0.9216 0.9216-1.024 1.7408 0.7168 1.8432 0.6144 3.6864 0.4096 6.2464zM290.7136 863.9488c-3.8912-0.2048-7.168-0.512-10.1376-2.4576-0.512-0.3072-1.6384-0.512-1.8432-0.3072-4.096 4.4032-7.2704 0.2048-10.1376-1.536-9.6256-5.8368-19.3536-11.6736-27.9552-18.8416-2.9696-2.4576-6.656-4.096-9.3184-6.9632-0.7168-0.7168-1.4336-1.8432-2.2528-1.9456-4.3008-0.7168-4.5056-3.6864-4.4032-7.168 0.1024-3.1744 0.6144-5.7344 3.584-7.7824 2.3552-1.6384 3.9936-4.4032 6.0416-6.5536 0.7168-0.7168 1.6384-1.4336 2.56-0.4096 0.6144 0.7168 0.6144 1.8432 0 2.3552-3.7888 2.8672-2.048 5.8368-0.1024 8.4992-1.1264 1.6384-4.1984 0.3072-3.9936 2.7648 0.3072 3.072 3.4816 2.4576 6.144 4.096-1.2288-3.584 2.56-6.8608-1.8432-9.4208-1.1264-0.6144 0.2048-1.7408 1.024-2.3552 1.024-0.8192 2.6624-1.1264 3.072 0.2048 1.1264 3.2768 2.6624 3.072 5.0176 1.3312 0.3072-0.2048 1.7408 0.2048 1.7408 0.3072 0 4.096 5.3248 3.9936 5.8368 7.5776 0.3072 1.9456 2.1504 2.048 3.3792 2.6624 3.3792 1.6384 6.8608 2.8672 10.1376 4.608 4.096 2.048 7.0656 4.9152 7.8848 9.8304 0.7168 4.096 5.0176 5.632 8.0896 2.8672 1.9456-1.6384 3.584-1.6384 5.4272-0.512 5.8368 3.6864 11.5712 7.3728 17.3056 11.264 1.3312 0.9216 2.4576 1.6384 4.096 1.536 4.1984-0.1024 7.9872 1.3312 11.1616 3.9936 4.5056 3.7888 8.704 7.68 15.0528 8.704 10.0352 1.7408 18.5344 7.68 28.16 10.8544 8.2944 2.8672 16.6912 5.0176 25.2928 6.656 3.072 0.6144 5.632 2.3552 9.3184 1.9456 2.8672-0.3072 1.9456 4.1984 1.4336 6.2464-0.4096 1.8432-1.4336 3.2768-0.8192 5.4272 0.4096 1.536-0.512 3.3792-2.3552 3.2768-2.56-0.2048-3.7888-0.1024-3.4816 2.9696 0.2048 1.7408-1.6384 1.4336-2.6624 1.1264-7.2704-1.9456-14.5408-3.9936-21.8112-6.0416-0.2048 0-0.4096-0.1024-0.512-0.1024-1.2288-5.12-6.7584-6.5536-9.3184-10.9568-1.3312 5.4272-4.9152 4.3008-8.6016 2.8672-2.56-1.024-5.0176-1.9456-7.8848-1.6384-2.9696 0.3072-4.4032-1.536-5.0176-3.8912-0.6144-2.1504-1.8432-4.096 1.024-6.5536 2.4576-2.048-0.6144-4.096-3.2768-6.7584 1.4336 5.4272-3.584 8.2944-1.4336 13.0048 0.6144 1.3312-1.6384 2.1504-3.3792 1.3312-7.168-3.072-14.5408-5.3248-21.9136-7.5776-2.56-0.8192-5.12-2.56-7.0656-4.5056-3.6864-3.6864-7.4752-6.144-12.9024-5.5296-1.9456 0.2048-2.7648-1.3312-2.3552-3.072 0.6144-2.048 0.7168-4.7104 3.9936-5.4272zM465.92 917.7088c2.1504-1.4336 3.7888-2.6624 5.5296-3.584 1.024-0.6144 2.3552-0.6144 3.1744 0.4096 1.1264 1.3312 0 2.2528-0.8192 2.9696-1.9456 1.6384-3.584 3.2768-3.4816 6.2464 0.1024 2.048-2.2528 1.6384-3.6864 1.536-1.7408 0-4.3008 0.7168-4.4032-1.9456-0.1024-3.584-2.048-2.6624-3.8912-2.048-4.096 1.3312-8.2944 1.024-12.4928 0.9216-2.048 0-4.8128 1.024-6.0416-1.2288-1.4336-2.6624 1.8432-3.8912 2.9696-6.4512-3.2768-0.6144-6.3488-0.6144-9.3184 0.1024-1.1264 0.3072-2.8672 0.3072-1.4336 2.56 0.6144 1.024-0.4096 2.3552-1.6384 2.6624-2.1504 0.6144-4.4032 0.9216-6.2464-0.8192-5.3248-5.2224-12.5952-4.8128-19.1488-7.0656l-0.1024-0.512c5.3248-1.9456 5.9392-6.4512 6.5536-11.1616 0.4096-3.2768 1.6384-6.144 5.8368-3.8912 1.024 0.512 2.6624 1.024 2.8672 1.8432 0.3072 1.3312-1.2288 1.6384-2.3552 2.048-1.1264 0.4096-2.2528 1.1264-1.6384 2.56 0.4096 0.9216 1.3312 1.4336 2.4576 1.536 1.2288 0.1024 2.7648-0.2048 2.6624-1.6384-0.1024-5.4272 2.6624-4.9152 6.5536-3.7888 1.536 0.4096 3.6864-1.3312 5.2224-0.9216 1.8432 0.4096 2.9696 0.4096 4.9152-0.2048 2.1504-0.7168 4.608 1.4336 6.656 2.9696 1.1264 0.9216 2.56 0.1024 3.8912 0 5.5296-0.512 11.0592-1.024 16.5888 0.3072 2.2528 0.512 3.8912 1.4336 2.56 4.096-0.512 1.024-0.6144 1.9456 0.2048 2.7648 1.536 1.7408 1.2288 2.4576-0.9216 3.584-2.1504 1.2288-1.1264 3.6864-1.024 6.144zM113.2544 348.8768c3.072-1.6384 3.072-4.7104 4.3008-7.2704 1.1264-2.2528-0.512-5.9392 3.3792-6.9632 0.2048-0.1024 0.4096-1.024 0.3072-1.4336-3.1744-7.4752 3.9936-12.288 4.8128-18.7392 0.3072-2.4576 2.048-4.608 2.7648-7.0656 1.024-3.6864 2.7648-5.8368 7.0656-5.5296 2.3552 0.2048 4.4032-1.1264 2.56-4.096-1.6384-2.7648 0-10.6496 2.56-12.5952 5.4272-3.9936 9.3184-9.1136 10.752-15.872 0.1024-0.6144 0.1024-1.7408 0.4096-1.9456 5.0176-1.7408 5.12-8.6016 10.1376-10.0352 3.1744-0.9216 2.2528-5.0176 5.3248-5.7344-1.1264-3.7888 2.3552-5.3248 4.096-7.168 28.8768-31.9488 59.904-61.5424 96.5632-84.5824 15.6672-9.9328 32.256-18.2272 49.152-25.8048 5.2224-2.3552 9.5232-6.3488 15.1552-8.2944 11.776-4.096 23.9616-6.9632 35.5328-11.3664 0.6144-0.2048 1.6384-0.6144 1.8432-0.4096 3.8912 4.608 7.2704 0.3072 10.5472-0.9216 8.192-3.072 16.0768-7.0656 25.1904-6.7584 0.512 0 1.024 0 1.536-0.2048 15.2576-6.144 31.4368-5.632 47.4112-6.8608 3.8912-0.3072 5.9392 0.9216 4.5056 5.4272 2.2528-5.5296 6.5536-7.5776 11.9808-8.4992 10.752-1.8432 21.4016-4.1984 32.4608-2.048 3.1744 0.6144 6.7584 0.6144 10.0352-0.6144 1.1264-0.4096 2.6624-0.512 3.3792 0.4096 3.072 4.4032 7.0656 2.7648 10.9568 1.8432 2.3552-0.6144 4.7104-0.3072 7.0656-0.512 3.7888-0.3072 6.3488 0.512 5.8368 5.12-0.3072 2.7648 1.9456 3.072 3.072 1.536 3.2768-4.608 7.4752-2.3552 11.6736-2.6624 9.216-0.8192 17.8176 1.4336 26.4192 3.3792 10.4448 2.3552 21.0944 3.8912 30.9248 8.704 0.4096 0.2048 1.024 0.4096 1.4336 0.3072 10.8544-2.2528 18.944 6.3488 28.9792 7.2704 1.2288 0.1024 1.536 1.024 1.8432 2.1504 0.1024 0.6144 0.6144 1.6384 0.8192 1.6384 10.752-0.8192 18.3296 6.4512 26.9312 10.752 16.0768 7.9872 31.6416 17.3056 47.4112 25.9072 4.3008 2.3552 6.656 6.9632 11.1616 8.9088 0.7168 0.3072 1.2288 1.4336 1.9456 1.536 6.8608 0.9216 5.2224 5.4272 4.4032 9.728-0.9216 4.608 0.3072 9.4208-1.4336 14.0288-1.1264 3.072-5.7344 3.8912-7.8848 1.4336-2.048-2.2528 1.2288-2.56 2.1504-5.4272-5.12 5.9392-8.704 2.1504-12.0832-0.1024-13.7216-8.9088-27.3408-17.8176-41.3696-26.2144-13.2096-7.8848-27.136-14.2336-41.472-19.6608-4.608-1.7408-9.1136-3.4816-13.5168-5.7344-1.7408-0.9216-2.1504 2.9696-3.4816 0.6144-0.6144-1.1264 0-2.9696-0.7168-3.7888-0.9216-1.024-2.6624-0.2048-4.1984-0.8192-11.1616-4.7104-23.2448-5.632-34.7136-8.9088-7.5776-2.1504-16.1792 1.024-22.7328-5.0176-7.2704 1.4336-14.2336-1.8432-21.4016-1.6384-2.8672 0.1024-5.4272-0.2048-6.8608-3.1744-0.4096-1.024-1.3312-2.1504-2.1504-0.9216-1.9456 3.072-4.8128 1.9456-7.2704 1.9456-7.2704 0.1024-14.5408 0-21.8112 0.1024-18.3296 0-36.6592 1.8432-54.8864 2.8672-5.7344 0.3072-11.4688 0.7168-17.2032-0.4096-1.024-0.2048-2.6624-0.6144-2.6624 0.3072 0.1024 7.168-6.0416 4.608-8.9088 4.9152-22.9376 3.1744-44.2368 11.1616-65.536 19.7632-10.752 4.3008-21.4016 9.0112-32.3584 12.8-6.8608 2.4576-11.8784 7.4752-18.0224 10.9568-9.9328 5.632-20.6848 10.1376-29.2864 17.7152-3.6864 3.2768-7.9872 5.7344-11.4688 9.216-1.1264 1.1264-2.4576 1.7408-4.096 1.8432-1.6384 0-3.3792 0.4096-3.8912 1.8432-2.1504 5.5296-7.168 7.4752-11.776 10.1376-6.656 3.8912-9.9328 11.3664-16.2816 15.7696-6.656 4.608-12.1856 10.3424-16.6912 17.408-2.1504 3.3792-5.7344 6.5536-8.9088 9.3184-5.2224 4.5056-8.3968 10.4448-13.312 15.0528-0.2048 0.2048-0.6144 0.512-0.6144 0.8192 0.4096 8.0896-6.8608 11.264-10.9568 16.1792-11.8784 14.4384-20.7872 30.6176-28.9792 47.2064-1.1264 2.3552-1.3312 5.7344-5.3248 5.9392-0.7168 0-1.8432 1.7408-0.4096 3.2768 1.024 1.024 1.024 2.6624-0.2048 3.584-1.1264 0.9216-2.56 0.6144-3.7888-0.2048-0.9216-0.6144-1.7408-2.1504-2.9696-0.8192-1.024 1.024-0.9216 2.6624-0.1024 3.7888 2.9696 3.7888 1.536 7.168-0.3072 10.8544-1.536 3.072-3.4816 6.0416-2.4576 10.0352 0.6144 2.56-2.6624 3.3792-3.4816 5.7344-7.168 21.1968-15.7696 41.8816-18.944 64.2048-1.3312 9.1136-2.3552 18.3296-2.56 27.5456-0.1024 3.7888-1.1264 5.632-5.2224 5.3248-4.7104-0.3072-9.4208-0.1024-14.2336-0.1024-2.048 0-4.096-0.6144-3.3792-3.072 4.096-13.7216 1.7408-28.16 5.0176-41.984 2.2528-9.3184 5.5296-18.3296 7.2704-27.8528 0.4096-2.1504 0.512-4.3008 0.6144-6.5536 0.1024-1.1264 0.1024-3.072 0.6144-3.2768 8.192-3.072 4.5056-10.24 5.4272-15.6672 0.8192-4.9152 0.512-5.2224 5.12-2.6624 0.9216 0.512 1.7408 1.024 2.8672 0.7168 0.8192-0.3072 1.6384-0.512 2.3552 0.2048 0.7168 1.8432-1.6384 2.4576-1.536 3.9936 3.584-0.2048 3.584-0.2048 3.4816-5.0176-0.1024-2.8672 0-5.7344 0-9.728-0.6144 2.7648 0 5.9392-2.3552 5.7344-2.4576-0.2048-4.9152-1.8432-7.0656-3.2768-1.1264-0.7168 2.7648-6.7584 4.608-6.8608 2.9696-0.2048 6.144-0.2048 2.6624-4.4032-0.9216-1.1264-0.512-2.048 0.4096-3.072 1.024-1.1264 1.7408-2.4576 1.2288-4.1984-0.512-1.4336-1.024-3.1744 0.512-4.096 1.8432-1.024 3.9936-0.7168 5.9392-0.3072 1.7408 0.4096 1.2288 1.6384 0.8192 2.8672-0.6144 2.8672-1.536 5.5296-2.4576 8.2944z"  ></path><path d="M450.1504 194.048c0-4.9152 3.584-5.7344 6.9632-6.0416 4.3008-0.4096 8.4992-1.7408 13.0048-0.4096 2.8672 0.8192 5.9392 1.2288 8.9088 0.2048 2.8672-1.024 6.0416 2.4576 7.2704 1.4336 3.072-2.4576 6.0416-0.9216 9.0112-1.4336 0.6144-0.1024 1.3312 0 2.048 0.2048 1.2288 0.2048 1.7408 1.1264 1.2288 2.2528-1.024 2.1504-2.4576 3.9936 0 6.4512 1.024 1.024-0.9216 1.7408-2.1504 1.8432-3.3792 0.1024-6.8608 0.512-10.1376 0-7.4752-1.3312-14.6432 0.7168-21.9136 1.7408-2.3552 0.3072-4.7104 1.4336-6.9632 1.2288-14.7456-1.4336-28.3648 4.3008-42.5984 6.5536-9.0112 1.4336-17.8176 4.5056-25.7024 9.4208-5.632 3.4816-12.4928 3.8912-18.5344 6.2464-16.896 6.5536-31.9488 16.4864-47.2064 26.112-5.12 3.2768-10.3424 6.3488-15.5648 9.3184-1.2288 0.7168-2.7648 1.8432-4.1984 0.512-1.4336-1.3312 0.1024-2.7648 0.3072-4.1984 0.4096-2.2528 5.5296-4.608-0.1024-6.9632-0.8192-0.3072 0.512-1.7408 1.2288-2.3552 14.4384-10.8544 29.4912-20.5824 45.9776-28.0576 5.5296-2.56 12.288-3.072 15.872-9.0112 0.2048-0.4096 0.8192-0.7168 1.2288-0.8192 9.6256-0.6144 17.7152-6.144 26.9312-8.2944 4.096-0.9216 8.2944-2.3552 12.5952-1.9456 0.6144 0.1024 1.3312-0.2048 1.8432-0.6144 9.216-7.3728 19.456-8.4992 30.3104-4.5056 1.7408 0.6144 2.8672 0.512 3.7888-1.024 1.024-1.6384 2.2528-2.4576 4.1984-2.048 2.3552 0.6144 1.024 2.6624 2.3552 4.1984zM754.5856 194.56c4.5056 1.4336 9.216 1.536 13.6192 3.4816 7.9872 3.3792 13.0048 10.0352 18.2272 16.2816 4.3008 5.0176 8.6016 9.9328 14.336 13.2096 0.6144 0.3072 1.6384 0.8192 1.6384 1.1264-0.9216 6.3488 6.144 6.2464 8.192 10.1376 2.2528 4.1984 6.5536 6.7584 9.6256 10.24 4.608 5.3248 9.6256 10.4448 12.3904 16.9984 0.8192 1.9456 3.1744 0 3.584 2.8672-7.5776 2.1504-15.1552 4.4032-22.8352 6.4512-1.9456 0.512-8.4992-7.0656-8.2944-9.1136 0.2048-1.9456 2.2528-1.024 3.1744-1.9456-1.9456-0.4096-4.9152 1.3312-5.5296-2.2528-0.4096-2.4576 0.1024-4.3008 3.1744-4.608 1.4336-0.1024 1.9456-1.536 1.4336-2.6624-0.7168-1.7408-0.4096-4.3008-3.072-4.7104-0.6144-0.1024-1.3312 0-2.048 0.1024-6.144 1.3312-10.4448-2.9696-15.0528-5.632-5.12-2.9696-9.0112-7.5776-11.9808-12.9024-0.2048-0.4096-0.7168-0.7168-1.1264-0.9216-10.0352-3.3792-15.4624-12.0832-22.4256-19.0464-0.8192-0.8192-1.6384-1.7408-2.56-2.4576-6.8608-5.12-7.68-8.0896-4.3008-16.0768 1.024-2.4576 3.1744-4.608-0.7168-7.0656-2.2528-1.4336 0.512-2.7648 1.9456-3.2768 4.5056-1.6384 11.5712 1.024 14.336 5.2224 2.3552 3.584 1.6384 5.2224-2.7648 5.8368-1.024 0.3072-1.9456 0.512-2.9696 0.7168zM230.6048 339.968c-4.1984-1.2288-4.3008-3.3792-2.56-6.9632 1.6384-3.3792 4.7104-5.12 7.0656-7.5776 6.656-7.0656 10.5472-15.872 15.6672-23.8592 1.4336-2.2528 4.3008-3.4816 6.144-5.632 3.7888-4.4032 7.8848-8.6016 11.9808-12.6976 1.4336-1.4336 3.584-3.3792 5.7344-1.4336 1.9456 1.8432 4.096 3.4816 2.4576 7.5776-2.2528 5.8368-6.144 10.0352-10.3424 14.2336-9.4208 9.4208-16.6912 20.6848-24.4736 31.4368-5.3248 7.168-10.752 14.2336-17.2032 20.3776-1.6384 1.536-3.584 3.584-4.3008-0.8192-0.2048-1.1264-0.8192-1.7408-1.9456-2.048-2.3552-0.7168-1.8432-1.9456-0.7168-3.3792 2.048-2.3552 5.0176-4.1984 4.9152-7.8848 0-0.9216 1.024-1.536 1.8432-0.7168 2.3552 2.56 3.6864-1.2288 5.7344-0.6144zM214.6304 355.9424c3.584-0.2048 5.5296-0.2048 5.2224 5.8368-0.3072 7.2704-5.8368 11.264-7.5776 17.3056-2.4576 8.2944-5.2224 16.5888-10.0352 24.1664-1.536 2.3552-0.6144 6.656-2.56 9.8304-1.024 1.6384-2.1504 2.4576-4.096 1.9456-4.4032-1.1264-5.12-0.512-4.3008 3.9936 1.024 5.7344-0.512 7.5776-5.9392 7.4752-2.9696-0.1024-4.096-0.7168-3.3792-4.3008 2.2528-11.9808 7.2704-23.04 11.776-34.304 2.4576-6.0416 5.3248-11.9808 7.7824-18.1248 1.024-2.4576 2.1504-4.096 5.0176-3.8912 2.56 0.1024 3.1744-0.8192 2.2528-3.4816-2.1504-5.7344-1.2288-6.656 5.8368-6.4512zM616.1408 226.7136c-2.1504-0.4096-5.0176-0.3072-6.656-1.536-5.12-3.7888-11.264-3.9936-16.9984-5.5296-1.3312-0.3072-2.7648-0.7168-3.6864-1.536-6.4512-5.8368-14.6432-6.144-22.528-7.4752-1.8432-0.3072-2.7648-1.024-2.7648-2.8672 0-1.6384-0.1024-3.3792-0.1024-5.0176 0.1024-2.2528-0.512-5.7344 2.7648-5.3248 2.4576 0.3072 5.8368 1.6384 5.2224 5.7344-0.512 2.9696 1.2288 3.8912 3.7888 3.8912 5.9392 0.1024 11.6736-1.4336 17.6128-1.024 4.9152 0.3072 9.6256 0.8192 13.5168 4.3008 2.3552 2.1504 5.3248 3.4816 8.6016 3.7888 5.2224 0.6144 7.5776 6.2464 4.9152 10.8544-0.8192 1.536-1.9456 1.8432-3.6864 1.7408zM555.9296 201.0112c1.7408-0.1024 1.7408-2.3552 3.3792-2.1504 1.024 0.2048 2.1504 0 2.8672 0.512 1.024 0.8192 0 1.7408-0.4096 2.6624-2.56 6.0416-4.1984 6.656-10.9568 4.4032-2.048-0.7168-3.8912-2.048-6.2464-2.048-1.1264 0-2.8672 1.1264-3.1744-1.1264-0.3072-2.56 1.6384-2.4576 3.2768-2.6624 0.4096 0 0.8192-0.3072 1.8432-0.7168-3.072-1.024-5.632-0.1024-6.144 1.8432-1.024 3.8912-2.9696 2.2528-5.12 1.536-4.9152-1.6384-10.0352-0.9216-15.0528-0.9216-7.2704 0-12.0832-2.8672-13.824-8.4992-0.4096-1.4336-1.4336-3.1744 0.6144-3.8912 1.9456-0.6144 5.12-1.536 5.8368 0.9216 1.536 5.12 4.3008 2.3552 5.9392 0.9216 2.56-2.3552 5.0176-2.3552 7.7824-1.1264 7.3728 3.4816 15.4624 2.6624 23.2448 3.584 4.608 0.8192 7.168 1.7408 6.144 6.7584zM280.8832 275.7632c0.8192-1.9456 0.6144-4.8128 0.7168-7.68 0.1024-4.096 3.584-4.5056 6.2464-5.2224 1.9456-0.512 2.56-0.9216 2.9696-2.9696 0.9216-4.4032 5.12-6.3488 8.192-8.8064 1.9456-1.536 3.6864 0.6144 3.072 3.1744-1.024 4.3008-3.6864 8.3968-2.4576 13.2096 0.1024 0.4096-0.3072 1.1264-0.6144 1.3312-5.4272 2.6624-8.8064 8.3968-14.6432 10.5472-2.1504 0.8192-4.4032 0.9216-3.4816-3.584zM646.3488 237.2608c1.4336-1.4336 2.4576-2.56 0.1024-4.3008-1.536-1.1264-3.7888-2.6624-2.2528-4.9152 1.2288-1.6384 3.9936-1.3312 5.632-0.6144 2.6624 1.2288 5.2224 2.9696 7.4752 4.9152 2.1504 1.8432-0.6144 3.9936-0.4096 6.144 1.536-1.536 1.3312-4.9152 3.9936-4.608 1.4336 0.2048 3.9936 2.8672 3.7888 3.3792-1.3312 2.7648 2.6624 8.192-4.608 8.2944-5.0176 0.1024-12.5952-2.56-14.6432-7.4752 0.3072-0.2048 0.6144-0.512 0.9216-0.8192zM683.6224 252.928c0.7168 4.608-3.1744 5.2224-5.8368 6.144-4.608 1.4336-9.9328-2.6624-11.3664-7.3728-1.024-3.3792 0.8192-6.656-0.4096-9.8304-0.2048-0.4096 0.3072-1.4336 0.7168-1.7408 0.8192-0.512 1.8432-0.1024 2.1504 0.7168 1.9456 5.3248 7.3728 5.0176 11.3664 6.9632 2.4576 1.1264 3.8912 2.3552 3.3792 5.12zM714.1376 278.9376c-0.8192 1.9456-1.4336 4.096-2.4576 6.0416-1.1264 1.9456-2.4576 3.072-4.608 0.512-1.1264-1.3312-3.072-1.9456-4.7104-2.7648-3.072-1.536-6.0416-8.2944-5.3248-11.5712 0.9216-4.1984 3.1744-4.608 6.5536-2.9696 1.7408 0.8192 3.072 1.9456 4.3008 3.3792 1.4336 1.7408 1.4336 5.0176 5.2224 4.3008 1.2288-0.3072 0.7168 1.8432 1.024 3.072z"  ></path><path d="M645.4272 238.08c-3.1744-1.024-6.3488-2.048-9.1136-4.096-0.8192-0.6144-1.4336-1.2288-2.6624-0.7168-2.56 1.024-5.2224 1.024-6.0416-2.2528-1.024-3.8912 2.56-3.4816 4.608-4.3008 0.7168-1.3312-0.3072-1.9456-0.9216-2.6624-0.8192-1.024-1.3312-2.1504-0.4096-3.1744 0.9216-1.1264 2.1504-0.6144 3.2768-0.1024 2.2528 1.024 4.5056 2.3552 7.0656 2.56 0.512 0 1.4336 0.8192 1.4336 1.1264-0.7168 4.8128 3.1744 8.2944 3.584 12.8-0.2048 0.3072-0.512 0.6144-0.8192 0.8192zM192 434.2784c0 4.9152-2.8672 6.9632-10.0352 7.2704-1.2288 0-2.2528 0-2.3552-1.7408-0.1024-4.5056 5.0176-10.752 8.9088-10.752 3.9936-0.1024 3.2768 2.7648 3.4816 5.2224z"  ></path><path d="M238.1824 519.5776l96.0512-25.088 3.1744-9.3184 13.6192 6.2464-4.7104 6.144c6.8608 26.3168 11.6736 43.6224 14.2336 51.8144l-8.8064 6.5536-2.56-9.8304-83.5584 21.8112 14.9504 57.2416c1.4336 7.168 5.9392 9.4208 13.7216 6.9632l78.9504-20.6848c7.9872-1.6384 11.5712-5.8368 10.752-12.6976-0.8192-6.7584-2.6624-16.384-5.4272-28.7744l3.2768-0.8192c5.8368 22.3232 12.1856 33.1776 18.944 32.256-1.8432 8.9088-8.6016 14.4384-20.2752 16.5888l-91.4432 23.9616c-9.1136 2.8672-14.9504-1.4336-17.5104-13.0048-11.776-45.1584-18.8416-71.168-21.0944-78.1312l16.6912 1.9456-4.096 5.9392 1.3312 5.2224 83.5584-21.8112-11.5712-44.032-75.6736 19.7632c-5.7344 1.536-10.752 3.4816-15.2576 6.144l-7.2704-4.4032zM549.1712 474.0096l2.4576-17.5104-109.1584 28.5696c1.8432 3.2768 2.8672 5.5296 3.1744 6.8608 0.7168 2.6624 0.2048 5.4272-1.3312 8.3968-1.536 2.9696-3.8912 4.7104-7.168 5.0176-3.1744 0.4096-4.9152 0.1024-5.12-0.8192-0.3072-1.3312-0.2048-2.56 0.4096-3.584 1.536-3.1744 2.4576-6.9632 2.9696-11.3664 0.512-4.3008 0.4096-9.5232-0.2048-15.4624l3.2768-0.8192 2.7648 7.68 107.9296-28.2624 3.584-7.9872 14.7456 8.0896c-6.3488 2.56-11.6736 9.8304-16.0768 21.8112l-2.2528-0.6144z m-108.9536 64.3072l111.8208-29.2864 7.2704-12.4928 17.408 10.24-49.9712 13.1072 11.5712 44.032c1.2288 6.656 6.0416 8.9088 14.4384 6.7584l24.3712-6.3488c4.3008-1.536 6.3488-4.4032 6.2464-8.2944-0.1024-3.9936-1.6384-12.5952-4.608-25.8048l2.6624-0.7168c2.2528 6.8608 4.5056 13.1072 6.656 18.6368 2.1504 5.5296 5.8368 8.4992 11.1616 9.0112-1.8432 7.4752-7.5776 12.288-17.3056 14.336l-30.3104 7.8848c-11.776 3.4816-18.944 0.3072-21.504-9.8304l-12.3904-47.4112-23.6544 6.2464c1.9456 12.5952 2.56 23.6544 2.048 33.1776-0.512 9.5232-3.8912 18.0224-9.8304 25.3952-6.0416 7.4752-17.3056 16.1792-33.8944 26.112l-1.3312-2.4576c18.944-13.4144 30.1056-25.4976 33.3824-36.1472 3.2768-10.6496 3.2768-25.1904-0.1024-43.52l-28.2624 7.3728-8.9088 3.6864-6.9632-3.6864z m9.8304-32.0512l73.728-19.2512 5.8368-9.9328 14.9504 8.704-72.3968 18.944c-6.144 1.6384-11.0592 3.584-14.6432 5.9392l-7.4752-4.4032z m25.2928-62.1568l0.9216-1.6384c8.3968 1.536 14.2336 3.2768 17.5104 5.2224 3.2768 1.9456 5.2224 3.9936 5.8368 6.2464 0.6144 2.1504 0.3072 4.8128-0.7168 7.8848s-2.048 4.7104-2.8672 5.0176c-1.3312 0.3072-2.9696-1.536-5.0176-5.7344-3.3792-5.632-8.6016-11.3664-15.6672-16.9984zM780.0832 506.368l0.512-30.3104h2.7648c1.8432 14.0288 3.2768 23.2448 4.4032 27.648 1.1264 4.4032 3.2768 8.2944 6.5536 11.6736 1.3312 1.536 1.1264 2.56-0.6144 2.9696-3.072 0.8192-9.216 0.7168-18.3296-0.1024-9.1136-0.9216-20.992-6.656-35.5328-17.408-9.9328 17.6128-22.1184 32.0512-36.4544 43.3152l-1.3312-2.4576c14.5408-15.9744 24.7808-31.5392 30.6176-46.6944-13.0048-13.9264-24.8832-36.1472-35.7376-66.56L645.12 441.856l7.5776 31.744 30.3104-7.8848 4.1984-8.0896 12.288 6.656-4.7104 6.144c5.5296 26.624 7.7824 42.3936 6.656 47.104-1.1264 4.7104-4.4032 9.216-9.8304 13.5168-2.9696-5.8368-10.1376-9.3184-21.7088-10.4448l-0.7168-2.6624c8.704-0.8192 14.7456-1.536 18.1248-1.9456 3.3792-0.4096 5.0176-2.8672 4.8128-7.2704-0.2048-4.4032-2.6624-17.408-7.4752-39.2192l-30.9248 8.0896c8.192 36.7616 5.632 64.6144-7.68 83.5584l-1.8432-1.6384c7.168-19.2512 8.6016-38.1952 4.4032-57.0368-4.1984-18.8416-7.5776-33.0752-10.1376-42.7008-2.56-9.6256-4.9152-17.92-7.168-24.7808l13.4144 2.8672 50.688-13.2096c-5.12-14.1312-9.3184-25.7024-12.5952-34.7136l18.8416 2.1504-3.2768 6.4512c1.8432 7.0656 4.3008 14.848 7.4752 23.3472l36.1472-9.4208 6.7584-11.5712 16.5888 9.728-58.5728 15.36c10.24 28.2624 20.1728 47.4112 29.7984 57.5488 2.1504-6.144 3.8912-13.9264 5.2224-23.1424 1.3312-9.216 2.3552-19.5584 3.1744-31.0272l16.5888 6.8608-5.0176 4.8128c-2.7648 19.968-6.5536 36.6592-11.4688 50.0736 12.0832 8.3968 23.7568 13.5168 35.0208 15.2576z m-68.5056-121.9584c10.5472 2.8672 17.8176 5.3248 21.6064 7.3728 3.7888 2.048 5.7344 4.608 5.8368 7.5776 0.1024 3.072-0.6144 5.3248-2.048 6.8608s-2.4576 2.3552-2.8672 2.4576c-1.7408 0.4096-3.4816-0.9216-5.3248-4.1984-2.56-4.5056-8.8064-10.3424-18.6368-17.6128l1.4336-2.4576z"  ></path></symbol><symbol id="icon-duanshipin" viewBox="0 0 1070 1024"><path d="M467.79187 186.173537L309.556699 0.011227H130.32032l158.291025 186.16231z m465.433701 0L774.990401 0.011227h-179.180525L754.045046 186.173537z m-232.688923 0L542.245623 0.011227H363.065098l158.23517 186.16231zM1000.753394 0.011227h-172.254595l158.291025 186.16231h83.781418V69.829075A68.589054 68.589054 0 0 0 1000.753394 0.011227zM76.811921 0.011227H69.830136A68.589054 68.589054 0 0 0 0.012288 69.829075v116.344462h235.034804zM0.012288 954.169864a68.5332 68.5332 0 0 0 69.817848 69.817848h930.923258a68.5332 68.5332 0 0 0 69.817848-69.817848V232.756005H0.012288z m372.380474-511.960315c0-39.600683 32.563044-58.200158 69.817848-58.200158a73.560085 73.560085 0 0 1 37.198949 9.327664l265.307823 153.599266a65.908048 65.908048 0 0 1 0 116.344461l-265.307823 153.599266a68.14222 68.14222 0 0 1-37.198949 9.327664c-37.254804 0-69.817848-18.655329-69.817848-58.200158z" fill="#EF9796" ></path></symbol><symbol id="icon-dianhua1" viewBox="0 0 1046 1024"><path d="M796.526848 478.655091c2.514 16.512997 16.756997 28.307995 32.935994 28.307995a33.019995 33.019995 0 0 0 5.118999-0.379c18.225997-2.804 30.732995-19.849997 27.929996-38.054994-44.286993-288.441952-302.88495-301.99495-305.489949-302.10595-17.913997-0.957-33.936994 13.597998-34.671995 32.023995-0.734 18.426997 13.619998 33.960994 32.023995 34.694994 2.07 0.09 206.099966 10.859998 242.15296 245.51296z m74.543987-318.386948C643.806873-66.839819 436.415908 12.853168 427.692909 16.369167c-17.091997 6.876999-25.392996 26.327996-18.515997 43.419993 6.898999 17.112997 26.304996 25.413996 43.417993 18.514997 1.736-0.69 174.899971-67.097989 371.273938 129.164979 180.88497 180.79697 127.784979 364.37494 125.492979 371.963938-5.496999 17.602997 4.272999 36.340994 21.853997 41.859993a33.213994 33.213994 0 0 0 9.991998 1.514c14.220998 0 27.395995-9.124998 31.868995-23.389997 2.893-9.257998 68.543989-228.731962-142.005977-439.149927z m-78.173987 786.29787c-3.204999 3.204999-13.663998 10.659998-41.971993 10.659998-91.755985 0-267.589956-77.089987-436.857927-246.312959C91.832965 488.633089 41.292973 269.203125 78.413967 232.105131c23.989996-24.011996 73.884988-73.951988 121.06398-73.951987 26.104996 0 50.851992 15.021998 75.621987 45.911992 71.391988 88.950985 40.479993 119.46198-10.749998 170.001972l-9.523998 9.435998c-12.840998 12.818998-19.628997 29.731995-19.628997 48.937992-0.022 30.666995 14.799998 86.236986 142.985976 214.311965 128.207979 128.141979 183.755969 142.962976 214.399965 142.962976h0.023c19.138997 0 36.029994-6.742999 48.869992-19.539997l9.413998-9.501998c27.862995-28.240995 51.942991-52.653991 82.386986-52.653992 23.589996 0 53.099991 14.086998 87.682986 41.859994 29.464995 23.701996 44.441993 47.201992 45.754992 71.949988 2.649 48.358992-48.981992 99.944983-73.817988 124.735979z m69.879989-248.716959c-47.402992-38.099994-89.775985-56.592991-129.499979-56.59299-58.37399 0-96.384984 38.544994-129.921978 72.549987l-10.771998 9.145999c-10.258998 0-52.609991-8.879999-167.197973-123.42398C291.656932 465.890093 302.02793 430.772098 302.02793 430.705098l9.212998-9.123998c52.765991-52.053991 125.047979-123.35698 15.933998-259.287957-37.743994-47.023992-80.716987-70.902988-127.696979-70.902988-74.819988 0-135.640977 60.84399-168.288972 93.490984-96.539984 96.606984 44.776993 382.311937 235.675961 573.233905 183.68997 183.64397 375.456938 265.874956 484.059919 265.874956 39.167993 0 69.189989-10.192998 89.195986-30.199995 31.645995-31.644995 97.519984-97.451984 93.268984-175.587971-2.381-44.129993-26.149996-84.633986-70.613988-120.35298" fill="" ></path></symbol><symbol id="icon-hudong" viewBox="0 0 1024 1024"><path d="M764.752532 0l0.005 0.006c-96.444058 0-171.764323 72.293294-185.764186 166.226377H107.368951c-13.026873 0-24.799758 7.815924-29.814708 19.816806-5.033951 12.027883-2.356977 22.849777 6.759934 32.127686l334.996728 353.179551v395.596137h-80.543213c-17.849826 0-32.333684 11.399889-32.333685 29.282714 0 17.877825 14.483859 27.754729 32.333685 27.754729h213.553914c17.849826 0 32.331684-9.876904 32.331684-27.754729 0-17.882825-14.487859-29.282714-32.331684-29.282714h-80.544213v-395.596137L814.407047 218.14787c9.115911-9.281909 17.899825-20.105804 12.855874-32.127687-5.044951-11.998883-16.816836-19.820806-29.816709-19.820806H637.370776c13.093872-58.039433 63.821377-106.138963 124.575783-106.138964 70.61631 0 131.12172 63.260382 131.12172 135.431678 0 54.101472-46.329548 101.679007-92.252099 121.590812l0.004999 0.027c-13.016873 3.156969-22.695778 14.854855-22.695778 28.842719 0 16.40984 13.30187 29.71071 29.71071 29.710709 1.370987 0 2.709974-0.124999 4.031961-0.303997 0.022 0.015 0.042 0.025 0.059999 0.02 0.053999-0.017 0.106999-0.036 0.159998-0.053999a29.475712 29.475712 0 0 0 11.066892-3.949962c72.326294-28.186725 125.801771-96.755055 125.801772-178.693255C948.955733 84.872171 871.029494 0 764.752532 0z m-56.437449 235.287702L447.723628 500.373114 187.103173 235.287702h521.21091z" fill="" ></path></symbol><symbol id="icon-jingzhunxing" viewBox="0 0 1024 1024"><path d="M448 435.2h3.2c19.2 0 32-16 32-32 0-19.2-16-32-32-32-112 0-201.6 89.6-201.6 201.6s89.6 201.6 201.6 201.6 201.6-89.6 201.6-201.6v-3.2c0-19.2-16-32-32-32-19.2 0-32 16-32 32 0 83.2-51.2 137.6-137.6 137.6-83.2 0-134.4-51.2-134.4-137.6 0-80 51.2-131.2 131.2-134.4z m419.2 54.4c0-19.2-16-32-32-32-19.2 0-32 16-32 32 0 6.4 0 9.6 3.2 12.8 3.2 12.8 6.4 35.2 6.4 67.2 0 204.8-150.4 355.2-355.2 355.2-208 3.2-358.4-147.2-358.4-355.2 0-204.8 150.4-355.2 355.2-355.2 32 0 38.4 0 67.2 3.2h3.2c16 0 32-16 32-32s-9.6-28.8-25.6-32c-35.2-6.4-38.4-6.4-76.8-6.4-233.6 0-422.4 192-422.4 422.4C32 803.2 220.8 992 454.4 992c233.6 0 422.4-188.8 422.4-422.4 0-35.2-3.2-51.2-9.6-80z" fill="#bfbfbf" ></path><path d="M992 233.6l-185.6-16-16-185.6-67.2 67.2-134.4 118.4V384L403.2 553.6s-6.4 32 0 41.6c6.4 9.6 38.4 6.4 38.4 6.4L640 419.2h166.4l134.4-134.4 51.2-51.2z" fill="#bfbfbf" ></path></symbol><symbol id="icon-guangfan" viewBox="0 0 1024 1024"><path d="M943.81 719.475A453.248 453.248 0 0 0 969.22 569.28c0-98.965-31.254-193.044-90.377-272.079a456.2 456.2 0 0 0-101.132-98.712 452.39 452.39 0 0 0-118.786-60.44C655.539 61.353 592.09 0 514.574 0S373.617 61.371 370.24 138.067a452.02 452.02 0 0 0-116.358 58.707 456.02 456.02 0 0 0-102.378 98.838c-59.908 79.36-91.569 173.999-91.569 273.677A452.516 452.516 0 0 0 84.3 716.422c-36.708 26.243-60.684 69.2-60.684 117.658 0 79.676 64.83 144.488 144.487 144.488 34.722 0 66.609-12.3 91.55-32.781a452.688 452.688 0 0 0 106.687 53.424 453.654 453.654 0 0 0 148.226 24.717c90.485 0 177.376-26.342 252.112-76.272a143.729 143.729 0 0 0 89.212 30.912c79.676 0 144.505-64.812 144.505-144.488 0-46.642-22.206-88.164-56.585-114.605zM514.564 59.709c46.768 0 84.796 38.037 84.796 84.796 0 46.751-38.028 84.787-84.796 84.787-42.299 0-78.43-31.543-84.038-73.381a86.096 86.096 0 0 1-0.75-11.406c0.01-46.76 38.046-84.796 84.788-84.796zM83.325 834.08c0-46.76 38.035-84.805 84.786-84.805 46.76 0 84.796 38.037 84.796 84.805 0 46.75-38.036 84.787-84.796 84.787-46.76 0-84.787-38.036-84.787-84.787z m213.822 64.956a143.584 143.584 0 0 0 15.451-64.956c0-79.675-64.82-144.505-144.496-144.505-9.88 0-19.542 1.002-28.88 2.908a393.81 393.81 0 0 1-19.586-123.203c0-165.745 106.144-315.506 260.6-371.486a144.605 144.605 0 0 0 134.329 91.199c60.874 0 113.07-37.838 134.319-91.235 156.624 56.377 260.619 203.483 260.619 371.522 0 42.597-6.719 84.318-19.958 124.26a144.722 144.722 0 0 0-33.665-3.965c-79.667 0-144.487 64.83-144.487 144.505 0 24.346 6.059 47.31 16.751 67.458-63.683 41.061-137.155 62.68-213.588 62.68-78.303 0-152.913-22.459-217.409-65.182z m558.75 19.831c-46.759 0-84.786-38.036-84.786-84.787 0-46.769 38.027-84.805 84.787-84.805 46.75 0 84.796 38.037 84.796 84.805 0 46.75-38.045 84.787-84.796 84.787z" fill="" ></path></symbol><symbol id="icon-chuanbo" viewBox="0 0 1100 1024"><path d="M485.555 281.754c35.84-19.943 48.64-65.05 28.519-100.583-20.148-35.507-65.69-48.179-101.556-28.237-35.84 19.968-48.64 65.076-28.492 100.608 20.121 35.508 65.69 48.18 101.53 28.212z m-46.899-82.714a21.35 21.35 0 0 1 28.877 8.013 20.94 20.94 0 0 1-8.115 28.62 21.35 21.35 0 0 1-28.877-8.038 20.94 20.94 0 0 1 8.115-28.595z m-21.862 506.445c57.932-32.205 78.592-105.114 46.08-162.509-32.564-57.344-106.138-77.824-164.07-45.594-57.908 32.23-78.593 105.14-46.03 162.484 32.512 57.395 106.112 77.85 164.02 45.619zM324.94 543.437a67.533 67.533 0 0 1 91.392 25.42 66.227 66.227 0 0 1-25.677 90.548 67.533 67.533 0 0 1-91.392-25.421 66.227 66.227 0 0 1 25.677-90.522z m429.465-98.355a67.686 67.686 0 0 0 26.215-92.519 69.018 69.018 0 0 0-93.389-25.958 67.686 67.686 0 0 0-26.214 92.493 69.043 69.043 0 0 0 93.388 25.984z m-41.036-72.397a15.334 15.334 0 0 1 20.736 5.76 15.027 15.027 0 0 1-5.837 20.557 15.309 15.309 0 0 1-20.736-5.76 15.027 15.027 0 0 1 5.837-20.557z" fill="" ></path><path d="M1038.746 46.208C981.76-14.515 870.374-14.848 730.93 42.24a509.918 509.918 0 0 1 65.792 32.256c94.055-30.72 168.167-29.235 202.88 7.757 34.407 36.659 31.923 109.389-6.4 201.472-4.352 10.393-9.165 21.069-14.413 31.949a480.717 480.717 0 0 0-21.12-42.036C827.98 44.928 534.656-36.608 303.77 91.828 72.883 220.287-9.472 510.898 120.218 739.583a475.187 475.187 0 0 0 194.124 187.213A653.824 653.824 0 0 1 281.14 938.7c-94.029 30.745-168.115 29.26-202.854-7.731-34.483-36.762-31.719-109.03 6.707-200.858a497.664 497.664 0 0 1-27.7-67.072c-2.098 4.173-4.3 8.371-6.297 12.544-62.592 129.382-66.79 232.883-11.827 291.43 56.96 60.672 168.371 60.98 307.789 3.943 11.366-4.634 22.989-9.805 34.688-15.207 125.363 43.008 267.98 34.893 392.473-34.38 195.175-108.596 284.16-333.005 228.71-537.984a847.176 847.176 0 0 0 17.767-33.28c2.125-4.148 4.301-8.346 6.298-12.493 62.592-129.408 66.816-232.909 11.853-291.43zM166.758 713.702c-115.276-203.29-42.086-461.593 163.15-575.77 205.209-114.2 465.97-41.702 581.196 161.588a421.35 421.35 0 0 1 34.304 77.824 958.134 958.134 0 0 1-18.944 30.464c-54.246 83.789-130.944 175.411-229.965 266.65-87.398 80.512-181.401 149.657-271.872 200.012l-0.051 0.026a933.094 933.094 0 0 1-45.67 23.86 423.5 423.5 0 0 1-212.173-184.654zM748.006 875.29a428.467 428.467 0 0 1-296.448 44.928c11.981-6.682 23.808-13.568 35.584-20.66 82.663-49.868 166.912-113.664 245.76-186.342 79.77-73.472 149.684-151.808 205.517-229.376a1224.702 1224.702 0 0 0 23.45-33.843 422.246 422.246 0 0 1-213.837 425.267z" fill="" ></path></symbol><symbol id="icon-qinggan" viewBox="0 0 1024 1024"><path d="M601.4 822.2h-3.7c-99.3 0-342.6-19.7-457.1-201.6-48.7-77.4-28.5-178.2 45.1-224.8 25.5-16.1 54.7-24.7 84.5-24.7 37.3 0 73.6 13.2 102.1 37.1 8 6.7 19.3 7.7 28.4 2.5 9-5.2 13.9-15.5 12.1-25.8-12-68.3 21.1-135.7 82.5-167.9 22-11.5 45.7-17.4 70.4-17.4 60.2 0 117.8 35.6 146.9 90.7 18.9 35.9 30.6 72.8 36.7 109.7 15.4 3.4 30.3 8.8 44 16.8 3.1 1.8 5.9 4 8.9 6-4.8-51.8-18.7-104.5-45.6-155.6-37.7-71.1-112.6-117.1-191-117.1-32.8 0-64.3 7.7-93.5 23C407 207.2 366 271.6 361 342.4c-28.2-13.6-59.3-20.9-91-20.9-39.2 0-77.7 11.2-111.1 32.3-96.5 61.3-123.7 192.8-60.5 293.3C226.2 850 490.1 871.9 597.6 871.9h4c30.9-0.1 60.1-13.1 81.3-34.8-18.2-3.8-35-12-49.1-23.9-9.7 5.7-20.9 8.9-32.4 9z m305.3-282.4c-20.1-11.6-43.9-16.1-67.1-12.8l-19.3 2.8-7.3-18.1c-8.8-22-24.2-39.9-44.7-51.7-15.9-9.2-33.8-14-52-14-36.6 0-69.9 18.6-89.1 49.8l-0.9 1.4-3.1 5.5c-51.7 98.7-3.6 203.8 29.7 257.8 11.1 18 30.3 29 51.3 29.6 3.8 0.1 7.8 0.2 12 0.2 60 0 169.1-13.3 225.4-102.1l4.5-8c27.2-50.4 9.8-112-39.4-140.4z" fill="#EF6D64" ></path></symbol><symbol id="icon-chuangyibiaoti" viewBox="0 0 1024 1024"><path d="M382.4896 936.96a57.5488 57.5488 0 0 0 34.2528 52.6336l60.7744 26.88a86.1696 86.1696 0 0 0 70.0928 0l59.8016-26.6752a57.6 57.6 0 0 0 34.0992-52.5824v-13.6192H382.4896V936.96z m129.536-784.9472a345.3952 345.3952 0 0 0-129.536 665.6v39.424h96.4096c-0.8192-168.96-47.6672-303.8208-73.216-313.088-10.24 0-24.1152 15.36-35.84 40.96a33.024 33.024 0 1 1-60.0576-27.4432c29.952-65.536 69.3248-79.3088 97.28-79.3088 49.7152 0 83.4048 58.6752 105.0624 133.6832 21.6064-75.008 55.3472-133.6832 105.0112-133.6832 27.7504 0 67.1744 13.7728 97.28 79.3088a33.024 33.024 0 0 1-60.1088 27.4432c-11.6224-25.6-25.6-40.6528-37.0176-40.6528-24.2688 9.1136-71.0656 144.0768-71.68 312.9344h96.4096v-39.424a345.3952 345.3952 0 0 0-129.4848-665.6zM103.6544 464.0256H47.9488a33.024 33.024 0 0 0 0 66.048h55.7056a33.024 33.024 0 0 0 0-66.048z m872.3968 0h-60.5184a33.024 33.024 0 0 0 0 66.048h60.5184a33.024 33.024 0 0 0 0-66.048zM512.0256 120.576a33.024 33.024 0 0 0 33.024-33.024V33.024a33.024 33.024 0 0 0-66.048 0V87.552a33.024 33.024 0 0 0 33.024 33.024zM202.1632 760.1664l-41.6256 41.6768a33.024 33.024 0 1 0 46.6432 46.7456l41.6256-41.6256a33.024 33.024 0 1 0-46.592-46.7968z" fill="#040000" ></path><path d="M816.768 145.5616l-40.4992 40.5504a33.024 33.024 0 1 0 46.592 46.7456l40.4992-40.4992a33.024 33.024 0 0 0-46.592-46.7968zM198.5792 230.4A33.024 33.024 0 1 0 245.376 183.6544l-38.0416-38.0928a33.024 33.024 0 0 0-46.6944 46.7456z m620.9024 527.36a33.024 33.024 0 0 0-46.6944 46.7456l43.9808 43.9808a33.024 33.024 0 0 0 46.7456-46.6944l-43.9808-44.032z" fill="#040000" ></path></symbol><symbol id="icon-zidingyifabushijian" viewBox="0 0 1024 1024"><path d="M514.710779 68.483527A477.501395 477.501395 0 0 0 36.981106 545.870783a1.42674 1.42674 0 0 0 0 0.456557 477.387255 477.387255 0 0 0 477.216047 477.672603h0.456556a477.387255 477.387255 0 0 0 477.672604-477.158977v-0.513626A477.444325 477.444325 0 0 0 515.167336 68.483527z m0 904.039631a426.309958 426.309958 0 1 1 426.252888-426.309958 426.595306 426.595306 0 0 1-426.252888 426.424097z" fill="" ></path><path d="M761.251477 546.32734h-210.586846s-25.738392 0-25.738393-25.681323V310.002101s-5.136265-20.430919-25.624253-20.430919-25.738392 20.430919-25.738392 20.430919v251.734032s0 35.896782 35.953852 35.896782h251.676963s20.545058-5.079195 20.545058-25.624253-20.487989-25.681323-20.487989-25.681322z m-1.084322-542.161259S740.820558 9.016998 740.820558 28.078246s19.517805 24.140443 19.517806 24.140444 169.49673-24.65407 192.609921 135.597384c0 0 5.136265 19.517805 24.711139 19.517805s24.597-19.517805 24.597-19.517805S979.029095-19.175388 760.167155 3.937803zM73.106167 197.00428C97.132471 27.56462 273.306345 53.245943 273.306345 53.245943s20.545058-5.079195 20.545058-25.624254-20.545058-25.681323-20.545058-25.681322C55.414589-21.286963 23.912166 179.65512 21.743521 195.862888v1.655019c0.741905 2.396923 6.848353 20.088501 25.567184 20.088501 20.487989 0 25.795462-20.602128 25.795462-20.602128z" fill="" ></path></symbol><symbol id="icon-yuanwenlianjie" viewBox="0 0 1024 1024"><path d="M1021.045071 768.725358c-2.84058-67.353305-30.867634-129.088573-81.366831-179.587771l-81.366832-81.366832a65.459585 65.459585 0 0 0-92.602904 92.602904L847.075336 681.74049c25.249599 25.249599 42.103706 58.894689 42.103706 92.602904 0 22.409019-2.84058 56.117233-30.867634 84.144287a108.82577 108.82577 0 0 1-78.589376 30.867635c-33.64509 0-70.13076-16.854107-98.157815-42.103706l-204.83737-204.774246c-50.499197-50.499197-56.054109-129.088573-11.172947-173.969735A65.459585 65.459585 0 0 0 372.950997 375.96785a234.884392 234.884392 0 0 0-70.130761 171.129155 272.885038 272.885038 0 0 0 81.366832 190.760718l204.774246 204.774246a274.905006 274.905006 0 0 0 190.760718 81.366832 242.143651 242.143651 0 0 0 171.192279-70.130761 234.442524 234.442524 0 0 0 70.13076-185.142682z" fill="" ></path><path d="M263.55711 423.626468l-56.117233-56.117233L179.160327 339.48218a145.185192 145.185192 0 0 1-44.881162-89.762323c0-22.472143 2.84058-56.117233 30.867635-84.207412a108.82577 108.82577 0 0 1 78.589375-30.867634A140.955885 140.955885 0 0 1 342.083362 176.748516l204.83737 204.774246c50.499197 50.499197 56.054109 129.088573 11.172947 173.969735a65.459585 65.459585 0 0 0 92.602903 92.602903 235.136888 235.136888 0 0 0 70.130761-171.129155 272.948162 272.948162 0 0 0-81.366832-190.823842L434.686266 81.368157A274.905006 274.905006 0 0 0 243.925547 0.001326a241.891155 241.891155 0 0 0-171.129155 70.13076A245.047355 245.047355 0 0 0 2.413136 252.497313c3.029952 67.353305 31.057006 129.088573 81.556204 179.524646l28.090178 28.090179 53.276654 56.117233a66.090825 66.090825 0 0 0 92.602903 0c28.027055-25.249599 30.867634-67.353305 5.618035-92.602903z" fill="" ></path></symbol><symbol id="icon-tuwenbingmao" viewBox="0 0 1050 1024"><path d="M0.799308 643.011635s59.923813-498.364906 176.506076-490.245626c33.800914 2.559338 79.427734 60.276825 170.24011 281.350685 14.208739 35.301215 90.106352 157.708179 144.823235 67.866586 21.621994-35.301215 33.536154-105.903646 69.543394-117.641299 19.062656-6.618978 80.663277 10.943377 195.127467 258.669654zM523.257293 88.253038a88.253038 88.253038 0 1 0 88.253038-88.253038 88.253038 88.253038 0 0 0-88.253038 88.253038zM344.191879 1023.735241H51.015286a50.304232 50.304232 0 1 1 0-100.608463H344.191879a50.304232 50.304232 0 0 1 0 100.608463z m656.073084-182.683789H51.015286a50.304232 50.304232 0 0 1-1.412048-100.608463h950.573472a50.304232 50.304232 0 0 1 0 100.608463z" fill="" ></path></symbol><symbol id="icon-kefu" viewBox="0 0 1109 1024"><path d="M58.367344 560.974695v112.425736c0 46.505477 39.252559 84.180054 87.594015 84.180054 48.383456 0 87.593015-37.674577 87.593016-84.180054V560.973695c0-46.506477-39.252559-84.180054-87.593016-84.180054-48.383456 0-87.594015 37.716576-87.594015 84.180054z m804.939952 214.440589a137.214458 137.214458 0 0 1-45.909484-101.972854V560.974695c0.043-77.055134 64.768272-139.603431 144.938371-140.158425C947.359351 217.000561 770.551339 56.106369 554.659765 56.106369S161.96018 217.000561 146.984348 420.81527c80.169099 0.596993 144.851372 63.14629 144.936371 140.158425v112.425736c0 77.481129-65.364265 140.286423-145.91836 140.286423C65.322266 813.686854 0 750.924559 0 673.400431V560.973695c0-55.892372 34.559612-106.366804 87.892012-128.595555C96.894911 192.12584 302.376601 0 554.659765 0s457.722855 192.12584 466.768754 432.37914c53.332401 22.22975 87.849013 72.745182 87.892012 128.595555v112.425736c0 45.609487-23.082741 88.319007-61.866305 114.558712a150.953303 150.953303 0 0 1-133.032504 17.492804 499.279388 499.279388 0 0 1-199.251761 122.878618c-1.407984 53.332401-46.932472 95.828923-102.398849 95.657925h-87.039021c-56.659363 0-102.483848-43.775508-102.483848-98.174896 0-54.357389 45.652487-98.217896 102.483848-98.217896h86.997022c36.863586 0 69.119223 18.516792 87.16702 46.420478a440.912044 440.912044 0 0 0 163.411163-98.558892z m12.45886-214.440589v112.425736c0 46.505477 39.252559 84.180054 87.593016 84.180054 48.383456 0 87.594015-37.674577 87.594015-84.180054V560.973695c0-46.506477-39.252559-84.180054-87.594015-84.180054-48.383456 0-87.593015 37.716576-87.593016 84.180054zM525.77409 967.882121h86.996022c24.575724 0 44.074505-18.772789 44.074505-42.069527 0-23.379737-19.626779-42.110527-44.074505-42.110527h-87.039021c-24.532724 0-44.073505 18.772789-44.073505 42.111527 0 23.337738 19.625779 42.068527 44.116504 42.068527z"  ></path></symbol><symbol id="icon-xiayiye" viewBox="0 0 1024 1024"><path d="M970.24 280.064c-9.728-9.728-25.6-9.728-35.328 0l-415.744 415.744-425.984-415.744c-9.728-9.728-25.6-9.728-35.328 0-9.728 9.728-9.728 25.6 0 35.328L499.2 747.52c9.728 9.728 25.6 9.728 35.328 0l435.2-432.128c10.24-12.8 10.24-25.6 0.512-35.328z" fill="" ></path></symbol><symbol id="icon-ziyuan" viewBox="0 0 1024 1024"><path d="M732.973358 948.015247a12.59068 12.59068 0 0 1-6.29534-23.355712 413.352023 413.352023 0 1 0-434.378458-3.14767 12.59068 12.59068 0 1 1-13.346121 21.278249 438.470429 438.470429 0 1 1 461.007746 3.399484 12.59068 12.59068 0 0 1-6.987827 1.825649z" fill="#F5F7FD" ></path><path d="M493.246812 1024c-54.139924 0-145.674167-10.450264-145.674167-49.481372s91.534243-49.481372 145.674167-49.481372 145.674167 10.387311 145.674167 49.481372-91.597197 49.481372-145.674167 49.481372zM372.942865 974.518628c5.162179 8.813476 49.292512 24.300012 120.303947 24.300012S608.38858 983.332104 613.550759 974.518628c-5.099225-8.813476-49.229559-24.300012-120.303947-24.300012s-115.141768 15.486536-120.303947 24.300012z" fill="#F5F7FD" ></path><path d="M709.932414 44.06738h-31.854421V12.59068a12.59068 12.59068 0 0 0-12.59068-12.59068h-4.343784a12.59068 12.59068 0 0 0-12.59068 12.59068v31.4767h-31.85442a12.59068 12.59068 0 0 0-12.59068 12.59068v4.343784a12.59068 12.59068 0 0 0 12.59068 12.59068h31.85442v31.4767a12.59068 12.59068 0 0 0 12.59068 12.59068h4.343784a12.59068 12.59068 0 0 0 12.59068-12.59068v-31.4767h31.854421a12.59068 12.59068 0 0 0 12.59068-12.59068V56.65806a12.59068 12.59068 0 0 0-12.59068-12.59068z" fill="#D7DDE8" ></path><path d="M916.860239 162.482725h-24.362966v-24.362966a12.59068 12.59068 0 0 0-12.59068-12.59068h-4.532645a12.59068 12.59068 0 0 0-12.59068 12.59068v24.362966h-24.362966a12.59068 12.59068 0 0 0-12.590679 12.59068v4.343784a12.59068 12.59068 0 0 0 12.590679 12.59068h24.362966v24.174106a12.59068 12.59068 0 0 0 12.59068 12.59068h4.532645a12.59068 12.59068 0 0 0 12.59068-12.59068V192.007869H916.860239a12.59068 12.59068 0 0 0 12.590679-12.59068v-4.343784a12.59068 12.59068 0 0 0-12.590679-12.59068z" fill="#D6DDE8" ></path><path d="M508.733348 853.6481a5.288086 5.288086 0 0 1-3.462437-1.070207 7.680315 7.680315 0 0 1-2.140415-2.140416L238.852123 518.29534a25.496127 25.496127 0 0 1-1.573835-24.677733l76.866102-144.478052a27.195869 27.195869 0 0 1 21.718922-12.9684h352.853806a26.692241 26.692241 0 0 1 21.215296 12.59068l76.866101 147.436862a25.55908 25.55908 0 0 1-2.644043 24.614779l-245.518259 301.420878h-1.636788L514.525061 849.870896a6.29534 6.29534 0 0 1-5.791713 3.777204z m16.430837-71.326202l9.002337 5.288086 233.557113-285.241854H636.465796z m-42.178777 2.39223l9.002336-5.288086-109.475962-276.994959H257.423376z m25.999754-28.32903l100.725439-254.268782H406.937701zM399.257386 478.445838L485.62945 361.100701H350.279641z m246.2737-1.007254H746.886059l-56.658059-110.860937z m-225.121358 0h179.480143L510.307183 357.38645z m-146.555514 0h98.836837l-42.115824-107.02078z m345.677118-1.888602l46.900282-114.512235h-130.943071z" fill="#FE6E45" ></path></symbol><symbol id="icon-zhuanyeguifan" viewBox="0 0 1024 1024"><path d="M617.328762 951.498747c-5.774436 0-10.907268-3.849624-12.190476-9.62406-1.924812-7.057644 2.566416-14.115288 8.982456-15.398497 6.41604-1.924812 12.83208-3.20802 19.24812-5.132832 223.919799-68.651629 350.315789-306.686717 281.664161-531.24812-1.924812-7.057644 1.924812-14.115288 8.340852-16.0401 7.057644-1.924812 14.115288 1.924812 16.0401 8.340852 73.142857 237.393484-60.952381 490.185464-298.987469 563.328321-6.41604 1.924812-13.473684 3.849624-20.531328 5.774436h-2.566416zM99.554326 665.984962c-5.132832 0-10.265664-3.20802-12.190476-8.982456C49.509213 542.796992 57.850065 420.250627 111.744802 313.102757 165.639539 205.313283 258.030516 125.112782 372.23603 86.616541c14.756892-5.132832 30.155388-8.982456 45.553885-12.83208 7.057644-1.283208 13.473684 2.566416 15.398496 9.62406 1.283208 7.057644-2.566416 13.473684-9.62406 15.398497-14.756892 3.20802-28.87218 7.057644-42.987469 12.190476C272.787409 146.927318 185.529263 222.636591 134.842546 324.010025s-59.027569 216.862155-23.097744 324.651629c2.566416 6.41604-1.283208 14.115288-8.340852 16.0401-1.283208 0.641604-2.566416 1.283208-3.849624 1.283208z" fill="#F2F6FD" ></path><path d="M509.539288 141.794486c-39.137845 0-70.576441-31.438596-70.576441-70.576441s31.438596-70.576441 70.576441-70.576441 70.576441 31.438596 70.576441 70.576441-31.438596 70.576441-70.576441 70.576441z m0-116.130326c-25.022556 0-44.912281 20.531328-44.91228 44.912281s20.531328 44.912281 44.91228 44.912281 44.912281-20.531328 44.912281-44.912281-19.889724-44.912281-44.912281-44.912281zM509.539288 1023.358396c-39.137845 0-70.576441-31.438596-70.576441-70.576441s31.438596-70.576441 70.576441-70.576441 70.576441 31.438596 70.576441 70.576441-31.438596 70.576441-70.576441 70.576441z m0-116.130326c-25.022556 0-44.912281 20.531328-44.91228 44.912281s20.531328 44.912281 44.91228 44.912281 44.912281-20.531328 44.912281-44.912281-19.889724-44.912281-44.912281-44.912281z" fill="#D7DDE8" ></path><path d="M371.594426 764.79198c-7.699248-3.849624-10.265664-13.473684-6.41604-21.172932 3.849624-7.699248 13.473684-10.265664 21.172932-6.41604 19.24812 10.265664 39.779449 18.606516 61.593985 23.739348 21.172932 5.132832 42.987469 8.340852 65.443609 8.340852 73.784461 0 140.511278-30.155388 189.273183-78.275689 48.120301-48.120301 78.275689-115.488722 78.275689-189.273183S750.782396 361.223058 702.662095 313.102757C654.541794 264.982456 587.173373 234.827068 513.388912 234.827068s-140.511278 30.155388-189.273183 78.275689-78.275689 115.488722-78.275689 189.273183c0 32.721805 5.774436 63.518797 16.0401 92.390977 10.907268 30.155388 26.947368 57.102757 47.478697 80.842106 5.774436 6.41604 4.491228 16.0401-1.924812 21.814536-6.41604 5.774436-16.0401 4.491228-21.814536-1.924812-22.45614-26.305764-41.062657-57.102757-52.611529-90.466166-11.548872-32.080201-18.606516-66.726817-18.606516-102.656641 0-82.125313 33.363409-157.192982 87.258145-211.087719 53.894737-53.894737 128.320802-87.258145 211.087719-87.258146s157.192982 33.363409 211.08772 87.258146c53.894737 53.894737 87.258145 128.320802 87.258145 211.087719s-33.363409 157.192982-87.258145 211.087719c-53.894737 53.894737-128.320802 87.258145-211.08772 87.258146-25.022556 0-49.403509-3.20802-73.142857-8.982457-23.739348-6.41604-46.195489-15.398496-68.010025-26.947368z" fill="#FE6E45" ></path><path d="M618.61197 512l-96.240602 98.807018c-2.566416 2.566416-5.774436 3.849624-9.62406 3.849624s-7.057644-1.283208-9.62406-3.849624l-96.240601-98.807018c-12.83208-13.473684-20.531328-30.796992-20.531329-50.045113s7.057644-37.854637 20.531329-51.328321c13.473684-13.473684 30.796992-21.172932 49.403508-21.172932 17.323308 0 34.646617 7.057644 47.478697 19.24812l8.340852 8.340853 8.982456-7.699249c13.473684-12.190476 30.155388-18.606516 47.478697-18.606516 18.606516 0 36.571429 7.699248 50.045113 21.172932 13.473684 13.473684 21.172932 32.080201 20.531328 51.328321 0.641604 17.964912-6.41604 35.288221-20.531328 48.761905z m40.421053-87.258145c-5.132832-12.190476-12.190476-23.739348-21.814537-33.363409-17.964912-18.606516-42.345865-28.230576-68.010025-28.230576-19.889724 0-39.779449 6.41604-56.461153 17.964912-16.681704-12.190476-35.929825-18.606516-56.461153-18.606516-25.66416 0-50.045113 10.265664-68.010025 28.87218-8.982456 9.62406-16.0401 20.531328-21.172932 32.721805-3.849624 12.190476-6.41604 25.022556-6.41604 37.854636 0 12.83208 2.566416 25.022556 7.057644 36.571429 4.491228 12.190476 11.548872 23.097744 21.172932 32.0802l96.240602 98.807018c7.057644 7.699248 17.323308 11.548872 27.588972 11.548872 10.907268 0 20.531328-3.849624 27.588973-11.548872l96.240601-98.807018c9.62406-8.982456 16.681704-19.889724 21.814537-32.0802 5.132832-11.548872 7.699248-24.380952 7.699248-37.213033 0-12.190476-1.924812-24.380952-7.057644-36.571428z" fill="#FE6E45" ></path><path d="M456.286155 411.909774c-12.190476 0-23.097744 5.132832-32.0802 13.473685-8.340852 8.982456-13.473684 20.531328-13.473684 32.721804 0 5.132832 3.849624 8.982456 8.982456 8.982456 5.132832 0 8.982456-3.849624 8.982456-8.982456 0-7.057644 2.566416-14.115288 7.699248-19.24812 5.132832-5.132832 11.548872-8.340852 18.606516-8.340852 4.491228 0 8.340852-3.20802 8.982457-8.340852 0.641604-2.566416 0.641604-5.132832-0.641605-7.057645-0.641604-1.924812-3.849624-3.20802-7.057644-3.20802z" fill="#FE6E45" ></path></symbol><symbol id="icon-quanwangluofugai" viewBox="0 0 1024 1024"><path d="M512 1024c-7.04 0-14.08-2.56-19.2-7.68l-88.96-88.96c-5.12-5.12-5.12-12.8 0-17.92 5.12-5.12 12.8-5.12 17.92 0L510.72 998.4c0.64 0.64 1.28 0.64 1.28 0.64 0.64 0 1.28 0 1.28-0.64l91.52-91.52c5.12-5.12 12.8-5.12 17.92 0s5.12 12.8 0 17.92L531.2 1016.32c-5.12 4.48-11.52 7.68-19.2 7.68zM106.24 624.64c-3.2 0-6.4-1.28-8.96-3.84L8.32 531.2C3.2 526.72 0 519.68 0 512s2.56-14.72 8.32-19.84l90.88-91.52c5.12-5.12 12.8-5.12 17.92 0 5.12 5.12 5.12 12.8 0 17.92L26.24 510.08c-0.64 1.28-0.64 1.28-0.64 1.92 0 0.64 0 1.28 0.64 1.28l88.96 89.6c5.12 5.12 5.12 12.8 0 17.92-1.92 2.56-5.76 3.84-8.96 3.84z m813.44-1.92c-3.2 0-6.4-1.28-8.96-3.84-5.12-5.12-5.12-12.8 0-17.92l87.04-87.04c0.64-0.64 0.64-2.56 0-3.2l-87.04-87.04c-5.12-5.12-5.12-12.8 0-17.92 5.12-5.12 12.8-5.12 17.92 0L1015.68 492.8c10.88 10.88 10.88 28.16 0 39.04l-87.04 87.04c-2.56 2.56-5.76 3.84-8.96 3.84zM412.8 118.4c-3.2 0-6.4-1.28-8.96-3.84-5.12-5.12-5.12-12.8 0-17.92L492.16 8.32C497.28 3.2 504.32 0 512 0c7.68 0 14.08 3.2 19.84 8.32l86.4 86.4c5.12 5.12 5.12 12.8 0 17.92-5.12 5.12-12.8 5.12-17.92 0L513.28 26.24c0-0.64-0.64-0.64-1.28-0.64s-1.28 0-1.28 0.64L422.4 114.56c-3.2 2.56-6.4 3.84-9.6 3.84z" fill="#D7DDE8" ></path><path d="M169.6 882.56c-15.36 0-27.52-12.16-27.52-27.52v-128.64c0-7.04 5.76-12.8 12.8-12.8s12.8 5.76 12.8 12.8v128.64c0 1.28 1.28 2.56 1.92 2.56h126.08c7.04 0 12.8 5.76 12.8 12.8s-5.76 12.8-12.8 12.8H169.6v-0.64z m684.8 0h-126.08c-7.04 0-12.8-5.76-12.8-12.8s5.76-12.8 12.8-12.8h126.08c1.28 0 2.56-1.28 2.56-1.92v-129.92c0-7.04 5.76-12.8 12.8-12.8s12.8 5.76 12.8 12.8v129.92c-0.64 14.72-12.8 27.52-28.16 27.52zM154.24 307.84c-7.04 0-12.8-5.76-12.8-12.8V169.6c0-7.68 3.2-14.72 8.32-19.84 5.12-5.12 12.16-8.32 19.84-8.32h122.24c7.04 0 12.8 5.76 12.8 12.8s-5.76 12.8-12.8 12.8H169.6c-1.28 0-2.56 1.28-2.56 1.92V294.4c0 7.68-5.12 13.44-12.8 13.44z m714.88-1.92c-7.04 0-12.8-5.76-12.8-12.8V169.6c0-0.64-0.64-1.28-0.64-1.28s-0.64-0.64-1.28-0.64h-122.88c-7.04 0-12.8-5.76-12.8-12.8s5.76-12.8 12.8-12.8h122.88c7.68 0 14.08 3.2 19.84 8.32 5.12 5.12 8.32 12.16 8.32 19.84v122.88c-0.64 7.04-6.4 12.8-13.44 12.8z" fill="#F9FAFD" ></path><path d="M517.12 789.76c-43.52 0-87.04-10.24-127.36-30.08-56.96-28.16-103.68-74.88-131.2-131.84-3.2-7.04-0.64-16 6.4-19.2s16-0.64 19.2 6.4c24.96 51.2 67.2 93.44 118.4 118.4 62.08 30.72 132.48 35.2 198.4 12.8s119.04-69.12 149.12-131.2c3.2-7.04 12.16-10.24 19.2-6.4 7.04 3.2 10.24 12.16 6.4 19.2-33.92 69.12-92.8 120.96-165.76 145.28-30.08 10.88-61.44 16.64-92.8 16.64zM270.08 406.4c-1.92 0-4.48-0.64-6.4-1.28-7.04-3.2-10.24-12.16-7.04-19.2 33.28-69.76 91.52-121.6 164.48-147.2 72.96-25.6 151.04-21.12 220.16 12.16 55.68 26.88 102.4 71.68 130.56 126.08 3.84 7.04 1.28 16-5.76 19.2-7.04 3.84-16 1.28-19.2-5.76-25.6-49.28-67.84-89.6-117.76-113.92-62.72-30.08-133.12-33.92-198.4-10.88-65.28 23.04-117.76 70.4-147.84 132.48-1.92 5.12-7.04 8.32-12.8 8.32z" fill="#FE6E45" ></path><path d="M706.56 687.36c-2.56 0-5.12-0.64-7.68-2.56-107.52-69.76-247.68-71.68-357.12-4.48-7.04 3.84-15.36 1.92-19.84-4.48-3.84-7.04-1.92-15.36 4.48-19.84 118.4-72.96 270.72-71.04 387.84 4.48 6.4 4.48 8.32 13.44 4.48 19.84-3.2 5.12-7.68 7.04-12.16 7.04zM514.56 373.76h-1.92c-60.8 0-120.32-16-172.8-47.36-7.04-3.84-8.96-12.8-5.12-19.84 3.84-7.04 12.8-8.96 19.84-5.12 48 28.16 103.04 42.88 158.72 42.88h1.92c58.24 0 115.2-16 164.48-46.72 7.04-4.48 15.36-1.92 19.84 4.48 4.48 7.04 1.92 15.36-4.48 19.84-55.04 33.92-117.12 51.84-180.48 51.84zM298.24 494.72h423.68v21.76H298.24z" fill="#FE6E45" ></path><path d="M516.48 782.08c-67.84 0-104.32-142.72-104.32-276.48s36.48-276.48 104.32-276.48S620.8 371.84 620.8 505.6s-36.48 276.48-104.32 276.48z m0-524.16C485.12 257.92 441.6 352 441.6 505.6s44.16 247.68 75.52 247.68S592 659.2 592 505.6s-43.52-247.68-75.52-247.68zM234.88 561.92c-31.36 0-56.32-25.6-56.32-56.32 0-31.36 25.6-56.32 56.32-56.32s56.32 25.6 56.32 56.32c0.64 31.36-24.96 56.32-56.32 56.32z m0-87.68c-17.28 0-31.36 14.08-31.36 31.36s14.08 31.36 31.36 31.36 31.36-14.08 31.36-31.36-14.08-31.36-31.36-31.36zM784.64 561.92c-31.36 0-56.32-25.6-56.32-56.32 0-31.36 25.6-56.32 56.32-56.32s56.32 25.6 56.32 56.32c0.64 31.36-24.96 56.32-56.32 56.32z m0-87.68c-17.28 0-31.36 14.08-31.36 31.36s14.08 31.36 31.36 31.36 31.36-14.08 31.36-31.36-14.08-31.36-31.36-31.36z" fill="#FE6E45" ></path></symbol><symbol id="icon-gaoxiaoyiyong" viewBox="0 0 1024 1024"><path d="M722.379487 469.333333c-129.312821 0-233.682051-105.025641-233.682051-234.338461C488.697436 105.025641 593.723077 0 722.379487 0c129.312821 0 233.682051 105.025641 233.682051 234.338462 0 129.312821-104.369231 234.994872-233.682051 234.994871z m0-443.076923C608.164103 26.25641 514.953846 119.466667 514.953846 234.338462s93.210256 208.082051 207.425641 208.082051 207.425641-93.210256 207.425641-208.082051S837.251282 26.25641 722.379487 26.25641z" fill="#F9FAFD" ></path><path d="M89.6 990.523077H796.553846c7.220513 0 13.128205 5.907692 13.128205 13.128205v7.220513c0 7.220513-5.907692 13.128205-13.128205 13.128205H89.6c-7.220513 0-13.128205-5.907692-13.128205-13.128205v-7.220513c0-7.220513 5.907692-13.128205 13.128205-13.128205z" fill="#D7DDE8" ></path><path d="M573.374359 745.025641c-3.282051 0-7.220513-1.312821-9.846154-3.938462-30.851282-33.476923-41.353846-26.912821-61.046154-13.784615-11.158974 7.220513-24.94359 16.410256-43.979487 18.379487-3.938462 0.65641-7.220513-0.65641-9.846154-3.282051-49.887179-44.635897-63.671795-31.507692-80.738461-14.441026-5.907692 5.907692-12.471795 12.471795-20.348718 16.410257-4.594872 2.625641-10.502564 1.969231-14.441026-1.312821-57.107692-46.605128-72.861538-32.820513-93.210256-15.753846-7.876923 6.564103-15.753846 13.784615-26.912821 17.723077-4.594872 1.969231-9.846154 1.312821-13.128205-1.969231-24.94359-21.005128-47.917949-30.194872-68.266667-26.91282-24.287179 2.625641-37.415385 22.317949-37.415384 22.974359-3.938462 5.907692-11.815385 7.876923-17.723077 4.594872-5.907692-3.938462-7.876923-11.815385-4.594872-17.723077 0.65641-1.312821 19.035897-30.194872 54.482051-36.102565 26.25641-4.594872 53.825641 5.251282 83.364103 27.569231 4.594872-2.625641 8.533333-6.564103 13.128205-9.846154 27.569231-23.630769 56.451282-39.384615 118.810256 9.189744 2.625641-1.969231 5.251282-4.594872 7.876924-7.220513 24.94359-24.287179 52.512821-42.010256 112.246153 9.846154 9.846154-1.969231 18.379487-7.876923 26.912821-13.128205 26.25641-17.066667 49.230769-26.912821 86.646154 9.846154 1.312821-1.312821 2.625641-1.969231 4.594872-3.282052 28.225641-22.974359 59.733333-39.384615 128 5.251283 1.312821-1.312821 3.282051-2.625641 4.594871-3.938462 17.723077-14.441026 59.733333-49.230769 112.246154 10.502564 4.594872 5.251282 3.938462 13.784615-1.31282 18.379487-5.251282 4.594872-13.784615 3.938462-18.379488-1.31282-35.446154-40.697436-57.107692-22.974359-76.143589-7.220513-7.876923 6.564103-13.784615 11.158974-21.005128 11.815385-3.282051 0-5.907692-0.65641-8.533334-1.969231-63.015385-43.323077-82.051282-27.569231-103.05641-11.158975-5.251282 3.938462-9.846154 7.876923-15.753846 11.815385-2.625641-0.65641-5.251282 0-7.220513 0z m129.969231-25.6z" fill="#F9FAFD" ></path><path d="M233.353846 227.117949h-36.758974V190.358974c0-5.251282-4.594872-9.846154-9.846154-9.846153h-11.815385c-5.251282 0-9.846154 4.594872-9.846154 9.846153v37.415385H128.328205c-5.251282 0-9.846154 4.594872-9.846154 9.846154V249.435897c0 5.251282 4.594872 9.846154 9.846154 9.846154h37.415385V295.384615c0 5.251282 4.594872 9.846154 9.846154 9.846154h11.815384c5.251282 0 9.846154-4.594872 9.846154-9.846154v-37.415384h36.758974c5.251282 0 9.846154-4.594872 9.846154-9.846154V236.307692c-0.65641-4.594872-5.251282-9.189744-10.502564-9.189743z" fill="#D7DDE8" ></path><path d="M755.85641 164.758974c-5.907692-4.594872-13.128205-7.220513-21.005128-7.220512-5.251282 0-9.846154 1.312821-14.441026 3.282051L134.235897 454.235897c-10.502564 5.251282-17.066667 15.097436-17.723076 26.912821-1.312821 11.158974 3.938462 22.317949 13.784615 28.882051l149.005128 103.05641V776.533333c0 14.441026 9.189744 26.912821 22.317949 30.851282 3.282051 1.312821 6.564103 1.312821 9.846154 1.312821 10.502564 0 20.348718-4.594872 26.25641-13.784615l68.266667-94.523077L553.682051 803.446154c5.251282 3.938462 11.815385 5.907692 18.379487 5.907692 3.938462 0 7.220513-0.65641 11.158975-1.969231 9.846154-3.282051 17.723077-11.815385 20.348718-21.661538l162.789743-586.174359c3.282051-13.128205-0.65641-26.25641-10.502564-34.789744zM295.05641 584.205128L148.676923 483.117949 642.953846 236.307692l-347.897436 347.897436z m16.410257 192.328205V613.74359L734.851282 190.358974l-423.384615 586.174359z m260.594871 0l-147.035897-101.743589 284.882051-394.502565-137.846154 496.246154z" fill="#FE6E45" ></path></symbol><symbol id="icon-ruanwen_dagou" viewBox="0 0 1024 1024"><path d="M825.856 375.808L476.16 731.648c-8.192 8.192-19.456 13.824-32.256 13.824s-24.064-5.12-32.256-13.824l-197.632-201.216c-8.192-8.192-13.312-19.968-13.312-32.768 0-25.6 20.48-46.592 45.568-46.592 12.8 0 24.064 5.12 32.256 13.824l165.376 167.936 317.44-323.072c8.192-8.192 19.456-13.312 32.256-13.312 25.088 0 45.568 20.992 45.568 46.592 0 12.8-5.12 24.576-13.312 32.768z" fill="" ></path></symbol><symbol id="icon-meiti" viewBox="0 0 1024 1024"><path d="M96.768 512c0 229.376 185.856 415.232 415.232 415.232s414.72-186.368 414.72-415.232-185.856-415.232-415.232-415.232-414.72 185.856-414.72 415.232z" fill="#FCE8E8" ></path><path d="M222.208 512c0 159.744 129.536 289.28 289.28 289.28s289.28-129.536 289.28-289.28-129.536-289.28-289.28-289.28S222.208 351.744 222.208 512z" fill="#F98A8A" ></path><path d="M603.648 474.112v25.088h-9.216V435.712c0-34.304-21.504-65.536-53.76-77.312-9.216-3.584-18.944-5.12-28.672-5.12-24.576 0-48.64 11.264-64 29.696-12.288 14.848-19.456 33.792-19.456 53.248v63.488H419.84v-25.088h-16.384v36.352c0 56.832 43.52 103.424 99.84 107.52v32.768H455.68v18.944h111.616v-18.944h-47.616v-32.768c56.32-4.096 99.84-50.688 99.84-107.52v-36.352l-15.872-0.512m-50.176 6.144l-60.928 38.4c-3.584 2.048-8.704 0-8.704-5.12v-81.92c0-3.584 3.072-5.632 5.632-5.632 1.024 0 2.048 0.512 3.072 1.024l60.928 43.52c1.536 1.024 2.56 3.072 2.56 4.608 0.512 2.56-0.512 4.608-2.56 5.12z m-41.984 122.368c-48.64 0-89.088-38.912-91.648-87.04h9.216c2.048 32.256 23.552 60.928 53.76 72.192 9.216 3.072 18.432 5.12 28.16 5.12 24.064 0 47.104-10.24 62.976-28.16 11.776-13.824 18.944-30.72 19.968-48.64h9.216c-2.048 48.128-42.496 86.528-91.648 86.528" fill="#FFFFFF" ></path></symbol><symbol id="icon-wechat_youzhiziyuan_icon" viewBox="0 0 1024 1024"><path d="M512 1024c-7.68 0-14.08-3.2-19.84-8.32L403.2 926.72c-5.12-5.12-5.12-12.8 0-17.92 5.12-5.12 12.8-5.12 17.92 0l88.96 88.96c0.64 0.64 1.28 0.64 1.28 0.64 0.64 0 1.28 0 1.28-0.64l91.52-91.52c5.12-5.12 12.8-5.12 17.92 0 5.12 5.12 5.12 12.8 0 17.92l-91.52 91.52c-3.84 5.12-10.88 8.32-18.56 8.32zM106.24 624.64c-3.2 0-6.4-1.28-8.96-3.84L8.32 531.2c-10.88-10.88-10.88-28.16 0-39.04l91.52-91.52c5.12-5.12 12.8-5.12 17.92 0 5.12 5.12 5.12 12.8 0 17.92L26.24 510.72c-0.64 0.64-0.64 2.56 0 3.2l89.6 89.6c5.12 5.12 5.12 12.8 0 17.92-2.56 1.92-6.4 3.2-9.6 3.2z m813.44-1.92c-3.2 0-6.4-1.28-8.96-3.84-5.12-5.12-5.12-12.8 0-17.92l87.04-87.04c0.64-0.64 0.64-1.28 0.64-1.28 0-0.64 0-1.28-0.64-1.28l-87.04-87.04c-5.12-5.12-5.12-12.8 0-17.92 5.12-5.12 12.8-5.12 17.92 0l87.04 87.04c5.12 5.12 8.32 12.16 8.32 19.84 0 7.68-3.2 14.72-8.32 19.84l-87.04 87.04c-1.92 1.28-5.76 2.56-8.96 2.56zM412.8 118.4c-3.2 0-6.4-1.28-8.96-3.84-5.12-5.12-5.12-12.8 0-17.92L492.16 8.32C497.92 3.2 504.32 0 512 0c7.68 0 14.08 3.2 19.84 8.32l86.4 86.4c5.12 5.12 5.12 12.8 0 17.92-5.12 5.12-12.8 5.12-17.92 0L513.92 26.24c-0.64-0.64-1.28-0.64-1.92-0.64-0.64 0-1.28 0-1.28 0.64L422.4 114.56c-3.2 2.56-6.4 3.84-9.6 3.84z" fill="#D7DDE8" ></path><path d="M169.6 882.56c-15.36 0-27.52-12.16-27.52-27.52v-129.28c0-7.04 5.76-12.8 12.8-12.8s12.8 5.76 12.8 12.8v128.64c0 0.64 0.64 1.28 0.64 1.28s0.64 0.64 1.28 0.64h126.08c7.04 0 12.8 5.76 12.8 12.8s-5.76 12.8-12.8 12.8H169.6v0.64z m684.8 0h-126.08c-7.04 0-12.8-5.76-12.8-12.8s5.76-12.8 12.8-12.8h126.08c1.28 0 2.56-1.28 2.56-2.56v-129.92c0-7.04 5.76-12.8 12.8-12.8s12.8 5.76 12.8 12.8v129.92c0 15.36-12.8 28.16-28.16 28.16zM154.88 307.84c-7.04 0-12.8-5.76-12.8-12.8V169.6c0-15.36 12.8-28.16 27.52-28.16h122.24c7.04 0 12.8 5.76 12.8 12.8s-5.76 12.8-12.8 12.8H169.6c-1.28 0-2.56 1.28-2.56 2.56v125.44c0.64 7.04-5.12 12.8-12.16 12.8z m714.88-1.92c-7.04 0-12.8-5.76-12.8-12.8V169.6c0-0.64-0.64-1.28-0.64-1.28s-0.64-0.64-1.28-0.64h-122.88c-7.04 0-12.8-5.76-12.8-12.8s5.76-12.8 12.8-12.8h122.88c7.68 0 14.72 3.2 19.84 8.32 5.12 5.12 8.32 12.16 8.32 19.84v122.88c-0.64 7.04-6.4 12.8-13.44 12.8z" fill="#F9FAFD" ></path><path d="M353.28 564.48l88.96 15.36-17.92-81.28-13.44 12.16z" fill="#FE6E45" ></path><path d="M371.2 533.76l22.4-19.84-2.56-3.2c-10.24-13.44-32.64-49.92-32-99.84 1.28-78.08 60.8-136.96 140.16-136.96h0.64c78.08 0.64 140.8 61.44 141.44 112v3.84c0.64 3.84 0.64 8.96 0.64 14.08v5.12h5.12c4.48 0 12.16 0 19.2 1.28l5.76 1.28V390.4c-0.64-47.36-43.52-145.92-172.16-145.92-107.52 0-172.16 84.48-172.16 165.76 0 59.52 23.04 96.64 40.96 119.68l2.56 3.84zM578.56 660.48L555.52 569.6 486.4 615.04z" fill="#FE6E45" ></path><path d="M646.4 428.16c-49.92 0-71.04 15.36-72.32 16l-5.12 3.2-16.64-33.28L503.68 499.2l96 8.32-17.28-32.64 3.84-1.92h0.64c8.96-3.84 28.16-10.24 58.24-10.24h7.68c78.08 2.56 132.48 58.88 132.48 137.6 0 84.48-71.04 137.6-136.96 138.24h-1.92c-40.32 0-78.08-19.84-102.4-36.48l-3.84-2.56-21.12 26.88 3.2 3.2c46.08 42.88 113.92 43.52 120.96 43.52v-0.64h2.56c64 0 104.32-29.44 127.36-54.4 29.44-32 46.08-74.88 46.08-118.4 0-82.56-60.16-171.52-172.8-171.52z" fill="#FE6E45" ></path><path d="M542.08 653.44l-27.52-13.44-2.56 3.84c-5.76 8.32-16.64 26.24-33.28 44.16-32 35.2-68.48 53.76-106.24 53.76-39.04 0-72.32-14.08-96.64-39.68-26.24-28.16-41.6-69.12-39.68-106.88 1.92-49.92 40.96-99.2 75.52-120.32l3.2-1.92-5.76-17.28-2.56-21.12-5.76 3.84c-30.08 17.92-98.56 69.76-98.56 156.16 0 105.6 71.04 178.56 172.16 178.56 85.76 0 145.28-69.76 165.76-115.2l1.92-4.48z" fill="#FE6E45" ></path></symbol><symbol id="icon-zhuanyetuandui" viewBox="0 0 1024 1024"><path d="M617.328762 951.498747c-5.774436 0-10.907268-3.849624-12.190476-9.62406-1.924812-7.057644 2.566416-14.115288 8.982456-15.398497 6.41604-1.924812 12.83208-3.20802 19.24812-5.132832 223.919799-68.651629 350.315789-306.686717 281.664161-531.24812-1.924812-7.057644 1.924812-14.115288 8.340852-16.0401 7.057644-1.924812 14.115288 1.924812 16.0401 8.340852 73.142857 237.393484-60.952381 490.185464-298.987469 563.328321-6.41604 1.924812-13.473684 3.849624-20.531328 5.774436h-2.566416zM99.554326 665.984962c-5.132832 0-10.265664-3.20802-12.190476-8.982456C49.509213 542.796992 57.850065 420.250627 111.744802 313.102757 165.639539 205.313283 258.030516 125.112782 372.23603 86.616541c14.756892-5.132832 30.155388-8.982456 45.553885-12.83208 7.057644-1.283208 13.473684 2.566416 15.398496 9.62406 1.283208 7.057644-2.566416 13.473684-9.62406 15.398497-14.756892 3.20802-28.87218 7.057644-42.987469 12.190476C272.787409 146.927318 185.529263 222.636591 134.842546 324.010025s-59.027569 216.862155-23.097744 324.651629c2.566416 6.41604-1.283208 14.115288-8.340852 16.0401-1.283208 0.641604-2.566416 1.283208-3.849624 1.283208z" fill="#F2F6FD" ></path><path d="M509.539288 141.794486c-39.137845 0-70.576441-31.438596-70.576441-70.576441s31.438596-70.576441 70.576441-70.576441 70.576441 31.438596 70.576441 70.576441-31.438596 70.576441-70.576441 70.576441z m0-116.130326c-25.022556 0-44.912281 20.531328-44.91228 44.912281s20.531328 44.912281 44.91228 44.912281 44.912281-20.531328 44.912281-44.912281-19.889724-44.912281-44.912281-44.912281zM509.539288 1023.358396c-39.137845 0-70.576441-31.438596-70.576441-70.576441s31.438596-70.576441 70.576441-70.576441 70.576441 31.438596 70.576441 70.576441-31.438596 70.576441-70.576441 70.576441z m0-116.130326c-25.022556 0-44.912281 20.531328-44.91228 44.912281s20.531328 44.912281 44.91228 44.912281 44.912281-20.531328 44.912281-44.912281-19.889724-44.912281-44.912281-44.912281z" fill="#D7DDE8" ></path><path d="M371.594426 764.79198c-7.699248-3.849624-10.265664-13.473684-6.41604-21.172932 3.849624-7.699248 13.473684-10.265664 21.172932-6.41604 19.24812 10.265664 39.779449 18.606516 61.593985 23.739348 21.172932 5.132832 42.987469 8.340852 65.443609 8.340852 73.784461 0 140.511278-30.155388 189.273183-78.275689 48.120301-48.120301 78.275689-115.488722 78.275689-189.273183S750.782396 361.223058 702.662095 313.102757C654.541794 264.982456 587.173373 234.827068 513.388912 234.827068s-140.511278 30.155388-189.273183 78.275689-78.275689 115.488722-78.275689 189.273183c0 32.721805 5.774436 63.518797 16.0401 92.390977 10.907268 30.155388 26.947368 57.102757 47.478697 80.842106 5.774436 6.41604 4.491228 16.0401-1.924812 21.814536-6.41604 5.774436-16.0401 4.491228-21.814536-1.924812-22.45614-26.305764-41.062657-57.102757-52.611529-90.466166-11.548872-32.080201-18.606516-66.726817-18.606516-102.656641 0-82.125313 33.363409-157.192982 87.258145-211.087719 53.894737-53.894737 128.320802-87.258145 211.087719-87.258146s157.192982 33.363409 211.08772 87.258146c53.894737 53.894737 87.258145 128.320802 87.258145 211.087719s-33.363409 157.192982-87.258145 211.087719c-53.894737 53.894737-128.320802 87.258145-211.08772 87.258146-25.022556 0-49.403509-3.20802-73.142857-8.982457-23.739348-6.41604-46.195489-15.398496-68.010025-26.947368z" fill="#FE6E45" ></path><path d="M618.61197 512l-96.240602 98.807018c-2.566416 2.566416-5.774436 3.849624-9.62406 3.849624s-7.057644-1.283208-9.62406-3.849624l-96.240601-98.807018c-12.83208-13.473684-20.531328-30.796992-20.531329-50.045113s7.057644-37.854637 20.531329-51.328321c13.473684-13.473684 30.796992-21.172932 49.403508-21.172932 17.323308 0 34.646617 7.057644 47.478697 19.24812l8.340852 8.340853 8.982456-7.699249c13.473684-12.190476 30.155388-18.606516 47.478697-18.606516 18.606516 0 36.571429 7.699248 50.045113 21.172932 13.473684 13.473684 21.172932 32.080201 20.531328 51.328321 0.641604 17.964912-6.41604 35.288221-20.531328 48.761905z m40.421053-87.258145c-5.132832-12.190476-12.190476-23.739348-21.814537-33.363409-17.964912-18.606516-42.345865-28.230576-68.010025-28.230576-19.889724 0-39.779449 6.41604-56.461153 17.964912-16.681704-12.190476-35.929825-18.606516-56.461153-18.606516-25.66416 0-50.045113 10.265664-68.010025 28.87218-8.982456 9.62406-16.0401 20.531328-21.172932 32.721805-3.849624 12.190476-6.41604 25.022556-6.41604 37.854636 0 12.83208 2.566416 25.022556 7.057644 36.571429 4.491228 12.190476 11.548872 23.097744 21.172932 32.0802l96.240602 98.807018c7.057644 7.699248 17.323308 11.548872 27.588972 11.548872 10.907268 0 20.531328-3.849624 27.588973-11.548872l96.240601-98.807018c9.62406-8.982456 16.681704-19.889724 21.814537-32.0802 5.132832-11.548872 7.699248-24.380952 7.699248-37.213033 0-12.190476-1.924812-24.380952-7.057644-36.571428z" fill="#FE6E45" ></path><path d="M456.286155 411.909774c-12.190476 0-23.097744 5.132832-32.0802 13.473685-8.340852 8.982456-13.473684 20.531328-13.473684 32.721804 0 5.132832 3.849624 8.982456 8.982456 8.982456 5.132832 0 8.982456-3.849624 8.982456-8.982456 0-7.057644 2.566416-14.115288 7.699248-19.24812 5.132832-5.132832 11.548872-8.340852 18.606516-8.340852 4.491228 0 8.340852-3.20802 8.982457-8.340852 0.641604-2.566416 0.641604-5.132832-0.641605-7.057645-0.641604-1.924812-3.849624-3.20802-7.057644-3.20802z" fill="#FE6E45" ></path></symbol><symbol id="icon-wechat_zhineng_icon" viewBox="0 0 1024 1024"><path d="M628.873046 739.021889c-3.202001 0-7.044403-1.280801-9.606004-3.842402-31.379612-33.300813-41.626016-26.896811-61.478424-14.088805-11.527205 7.044403-24.97561 16.010006-44.187617 17.931207-3.842402 0.6404-7.044403-0.6404-9.606004-3.202002-49.95122-44.828018-64.040025-31.379612-81.330832-14.088805-6.404003 5.763602-12.808005 12.167605-20.492808 16.010006-4.482802 2.561601-10.246404 1.921201-14.088805-1.2808-56.995622-46.749218-73.005629-33.300813-93.498437-16.010007-7.684803 6.404003-16.010006 13.448405-26.25641 17.931207-4.482802 1.921201-9.606004 1.280801-12.808005-1.9212-25.61601-21.133208-48.670419-30.098812-69.163227-26.896811-23.694809 3.842402-36.502814 23.694809-36.502814 23.694809-3.842402 5.763602-11.527205 7.684803-17.290807 3.842402-5.763602-3.842402-7.684803-11.527205-4.482802-17.290807 0.6404-1.280801 18.571607-30.098812 53.793621-35.862414 26.25641-4.482802 53.793621 5.123202 83.252033 27.537211 4.482802-2.561601 8.965604-6.404003 13.448405-10.246404 27.537211-23.694809 56.355222-39.064415 119.114446 9.606004 2.561601-1.921201 5.123202-4.482802 8.325204-7.044403 24.97561-23.694809 52.512821-40.985616 111.429643 9.606004 10.246404-1.921201 18.571607-7.684803 27.537211-13.448406 25.61601-16.650407 48.670419-26.25641 86.454034 10.246404 1.280801-1.280801 3.202001-2.561601 4.482801-3.842401 28.177611-22.414009 59.557223-39.064415 127.43965 5.763602 1.280801-1.280801 3.202001-2.561601 5.123202-3.842401 17.931207-14.729206 59.557223-48.670419 112.070044 10.246404 4.482802 5.123202 4.482802 13.448405-1.280801 17.931207-5.123202 4.482802-13.448405 4.482802-17.931207-1.280801-35.862414-40.345216-57.636023-23.054409-76.207629-7.684803-7.684803 6.404003-13.448405 10.886804-21.133209 11.527205-3.202001 0-5.763602-0.6404-8.325203-1.921201-63.399625-42.906817-82.611632-27.537211-103.74484-10.886804-5.123202 3.842402-10.246404 8.325203-16.010007 11.527204-2.561601 0.6404-4.482802 1.280801-7.044402 1.280801z" fill="#F9FAFD" ></path><path d="M162.021263 990.699187h707.642277c7.044403 0 12.808005 5.763602 12.808005 12.808005v7.684803c0 7.044403-5.763602 12.808005-12.808005 12.808005H162.021263c-7.044403 0-12.808005-5.763602-12.808005-12.808005v-7.684803c0-7.044403 5.763602-12.808005 12.808005-12.808005z" fill="#D7DDE8" ></path><path d="M761.435897 910.008755c-4.482802 0-8.325203-1.921201-10.886804-6.404002-3.842402-5.763602-1.921201-14.088806 4.482802-17.290807 138.326454-83.252033 224.140088-235.026892 224.140087-396.407755C979.171982 233.746091 769.761101 25.61601 512.3202 25.61601S44.828018 233.746091 44.828018 489.906191c0 161.380863 81.971232 308.03252 218.376485 393.205754 5.763602 3.842402 7.684803 11.527205 3.842401 17.931207-3.842402 5.763602-11.527205 7.684803-17.931207 3.842401C105.666041 814.589118 19.212008 659.612258 19.212008 489.906191 19.212008 219.657286 240.150094 0 511.6798 0c271.529706 0 492.467792 219.657286 492.467792 489.906191 0 170.346467-90.936836 331.086929-236.948092 418.821764-1.280801 0.6404-3.842402 1.280801-5.763603 1.2808z" fill="#F9FAFD" ></path><path d="M422.664165 778.726704c-9.606004 0-17.290807-7.684803-17.290807-17.290807v-98.621638l-2.561601-1.280801C336.210131 623.109443 294.584115 551.384615 294.584115 474.536585c0-119.114447 96.700438-216.455285 216.455285-216.455284 119.114447 0 216.455285 96.700438 216.455284 216.455284 0 76.84803-41.626016 148.572858-108.227642 186.996873l-2.561601 1.280801V762.076298c0 9.606004-7.684803 17.290807-17.290807 17.290806H422.664165z m166.504065-261.283302a17.495735 17.495735 0 0 1 17.290807 17.290807c0 4.482802-1.921201 8.965604-5.123202 12.167605L528.330206 619.267042v124.878049h53.793621v-101.18324l19.212008-10.886804c61.478424-35.222014 96.700438-103.744841 90.296435-173.548468-8.965604-94.138837-85.813634-165.223265-181.233271-165.223264-5.123202 0-10.886804 0.6404-16.650406 1.2808-79.409631 6.404003-146.011257 65.961226-161.380863 144.090056-15.369606 76.84803 19.212008 154.976861 87.734834 194.041276l19.212008 10.886804v101.18324H493.108193V619.907442L420.742964 546.901814c-3.202001-3.202001-5.123202-7.684803-5.123202-12.167605a17.495735 17.495735 0 0 1 17.290807-17.290807c4.482802 0 8.965604 1.921201 12.167605 5.123202l65.961226 65.961226 65.961225-65.961226c3.202001-3.842402 7.044403-5.123202 12.167605-5.123202zM444.437774 806.263915h132.562851v21.773608H444.437774v-21.773608zM466.851782 850.451532h88.375235v21.773609H466.851782v-21.773609zM511.0394 165.223265c6.404003 0 10.886804 5.123202 10.886804 10.886804v44.187617c0 6.404003-5.123202 10.886804-10.886804 10.886804s-11.527205-4.482802-11.527205-10.886804v-44.187617c0-6.404003 5.123202-10.886804 11.527205-10.886804z m249.756097 103.74484c4.482802 4.482802 4.482802 10.886804 0 15.369606l-31.379612 31.379612c-4.482802 4.482802-10.886804 4.482802-15.369606 0.640401-4.482802-4.482802-4.482802-10.886804-0.6404-15.369606l0.6404-0.640401 31.379612-31.379612c4.482802-4.482802 10.886804-4.482802 15.369606 0zM864.540338 518.724203c0 6.404003-5.123202 10.886804-10.886805 10.886804h-44.187617c-6.404003 0-10.886804-5.123202-10.886804-10.886804s5.123202-10.886804 10.886804-10.886805h44.187617c5.763602 0 10.886804 4.482802 10.886805 10.886805z m-103.744841 249.756097c-4.482802 4.482802-10.886804 4.482802-15.369606 0l-31.379612-31.379612c-4.482802-4.482802-4.482802-10.886804-0.6404-15.369606 4.482802-4.482802 10.886804-4.482802 15.369606-0.6404l0.6404 0.6404 31.379612 31.379612c4.482802 4.482802 4.482802 11.527205 0 15.369606z m-500.152595 0c-4.482802-4.482802-4.482802-10.886804 0-15.369606l31.379612-31.379612c4.482802-4.482802 10.886804-4.482802 15.369606-0.6404 4.482802 4.482802 4.482802 10.886804 0.6404 15.369606l-0.6404 0.6404-31.379612 31.379612c-3.842402 4.482802-10.886804 4.482802-15.369606 0zM157.538462 518.724203c0-6.404003 5.123202-10.886804 10.886804-10.886805h44.187617c6.404003 0 10.886804 5.123202 10.886804 10.886805s-5.123202 10.886804-10.886804 10.886804h-44.187617c-6.404003 0-10.886804-4.482802-10.886804-10.886804z m103.10444-249.756098c4.482802-4.482802 10.886804-4.482802 15.369606 0l31.379612 31.379612c4.482802 4.482802 4.482802 10.886804 0.6404 15.369606-4.482802 4.482802-10.886804 4.482802-15.369606 0.640401l-0.6404-0.640401-31.379612-31.379612c-3.842402-4.482802-3.842402-11.527205 0-15.369606z" fill="#FE6E45" ></path></symbol><symbol id="icon-wechat_quanweibaozhang_icon" viewBox="0 0 1024 1024"><path d="M618.328256 951.081645c-5.657459 0-10.686311-3.771639-11.943523-9.429097-1.88582-6.914672 2.514426-13.829343 9.429097-15.086557 143.322284-35.201964 260.243094-145.208103 304.24555-286.01596 25.772867-81.718846 25.772867-168.466544 0.628606-250.813997-1.88582-6.914672 1.88582-13.829343 8.171885-15.715162 6.914672-1.88582 13.829343 1.88582 15.715163 8.171884 27.03008 86.747698 27.03008 179.152855-0.628607 265.900553-46.516882 149.608349-170.352363 265.271946-322.475138 302.988336h-3.143033zM94.699036 665.694291c-5.028852 0-10.057704-3.143033-11.943524-8.800491-30.173112-89.890731-31.430325-185.43892-3.143032-276.586863C128.643787 225.04113 257.508121 108.120319 416.545568 74.175568c6.914672-1.257213 13.200737 3.143033 15.086556 9.429097 1.257213 6.914672-3.143033 13.200737-9.429098 15.086557-150.236955 32.058932-272.186618 142.693677-318.074892 289.158993-27.03008 85.490485-25.772867 176.009822 2.514426 260.8717 2.514426 6.286065-1.257213 13.829343-8.171885 15.715163-0.628607 0.628607-2.514426 1.257213-3.771639 1.257213z" fill="#F2F6FD" ></path><path d="M508.950724 142.065071c-38.973603 0-71.032535-32.058932-71.032535-71.032536C437.918189 31.430325 469.977121 0 508.950724 0c39.60221 0 71.032535 31.430325 71.032535 71.032535 0 38.973603-31.430325 71.032535-71.032535 71.032536z m0-116.920811c-25.14426 0-45.888275 20.744015-45.888275 45.888275s20.744015 45.888275 45.888275 45.888275 45.888275-20.744015 45.888275-45.888275S534.723591 25.14426 508.950724 25.14426zM508.950724 1024c-38.973603 0-71.032535-32.058932-71.032535-71.032535s32.058932-71.032535 71.032535-71.032536c38.973603 0 71.032535 32.058932 71.032535 71.032536s-31.430325 71.032535-71.032535 71.032535z m0-116.92081c-25.14426 0-45.888275 20.744015-45.888275 45.888275s20.744015 45.888275 45.888275 45.888275 45.888275-20.744015 45.888275-45.888275-20.115408-45.888275-45.888275-45.888275z" fill="#D7DDE8" ></path><path d="M520.265641 772.557397c-3.143033 0-6.286065-1.88582-8.171884-3.143032l-116.292204-73.546962c-55.945979-35.830571-90.519337-94.919583-90.519337-159.037446V336.304481c0-10.057704 6.286065-16.343769 16.343769-16.343769 72.289748 0 140.807858-24.515654 186.696133-69.146716 6.286065-6.286065 16.343769-6.286065 23.25844 0 45.888275 44.002455 115.034991 69.146716 186.696133 69.146716 8.171885 0 16.343769 6.286065 16.343769 16.343769l1.88582 65.375077-1.88582 134.521793c0 64.117864-32.687538 123.206875-90.519337 159.037446l-116.292204 73.546961c-0.628607 1.88582-4.400246 3.771639-7.543278 3.771639z m-182.295887-419.909147v183.553101c0 52.17434 27.658686 101.834254 75.432781 131.378759l106.863106 69.146716 106.863106-69.146716c47.774095-29.544506 75.432781-78.575813 75.432781-131.378759l1.88582-134.521793v-49.031308c-72.289748-3.143033-136.407612-26.401473-183.5531-67.260896-48.402701 40.859423-113.777778 64.117864-182.924494 67.260896z" fill="#FE6E45" ></path><path d="M520.265641 592.14733c-10.057704 0-16.343769-6.286065-16.343769-16.34377v-81.718845c0-10.057704 6.286065-16.343769 16.343769-16.34377s16.343769 6.286065 16.343769 16.34377v81.718845c0 9.429098-6.286065 16.343769-16.343769 16.34377z" fill="#FE6E45" ></path><path d="M487.578103 460.76857c0 18.229589 14.45795 32.687538 32.687538 32.687538 18.229589 0 32.687538-14.45795 32.687539-32.687538 0-18.229589-14.45795-32.687538-32.687539-32.687539s-32.687538 14.45795-32.687538 32.687539z" fill="#FE6E45" ></path></symbol><symbol id="icon-tgxs_icon" viewBox="0 0 1024 1024"><path d="M512 1024c-282.482759 0-512-229.517241-512-512S229.517241 0 512 0s512 229.517241 512 512-229.517241 512-512 512zM512 11.770115C235.990805 11.770115 11.770115 235.990805 11.770115 512s224.22069 500.229885 500.229885 500.229885 500.229885-224.22069 500.229885-500.229885S788.009195 11.770115 512 11.770115z" fill="#4CB6FF" ></path><path d="M390.17931 724.450575c-4.708046 0-9.416092-0.588506-14.124138-2.354023-10.004598-3.531034-18.243678-11.181609-22.951724-21.186207L239.521839 455.503448c-9.416092-20.597701-0.588506-44.726437 20.009195-54.142528l332.505748-153.6c20.597701-9.416092 44.726437-0.588506 54.142528 20.009195L759.172414 512.588506c4.708046 10.004598 5.296552 21.186207 1.177011 31.190804-3.531034 10.004598-11.181609 18.243678-20.597701 22.951724h-0.588506l-332.505747 153.6c-5.296552 2.942529-11.181609 4.11954-16.478161 4.119541zM264.23908 411.954023c-14.712644 6.473563-20.597701 24.128736-14.124137 38.252874l113.581609 245.406896c3.531034 7.062069 8.827586 12.358621 16.478161 15.30115 7.062069 2.942529 15.301149 2.354023 22.363218-1.177012l332.505747-153.6c7.062069-3.531034 12.358621-8.827586 14.712644-16.478161 2.942529-7.062069 2.354023-15.301149-1.177012-22.363218l-113.581609-245.406897c-6.473563-14.712644-24.128736-20.597701-38.252873-14.124138L264.23908 411.954023z" fill="#4CB6FF" ></path><path d="M323.678161 420.193103h413.131034c12.947126 0 23.54023 10.593103 23.54023 23.54023v311.908046c0 12.947126-10.593103 23.54023-23.54023 23.54023H323.678161c-12.947126 0-23.54023-10.593103-23.54023-23.54023v-311.908046c0-12.947126 10.593103-23.54023 23.54023-23.54023z" fill="#FFFFFF" ></path><path d="M736.809195 784.478161H323.678161c-16.478161 0-29.425287-12.947126-29.425287-29.425287v-311.908046c0-16.478161 12.947126-29.425287 29.425287-29.425288h413.131034c16.478161 0 29.425287 12.947126 29.425288 29.425288v311.908046c0 16.478161-12.947126 29.425287-29.425288 29.425287zM323.678161 426.078161c-10.004598 0-17.655172 7.650575-17.655172 17.655172v311.908046c0 10.004598 7.650575 17.655172 17.655172 17.655173h413.131034c10.004598 0 17.655172-7.650575 17.655173-17.655173v-311.908046c0-10.004598-7.650575-17.655172-17.655173-17.655172H323.678161z" fill="#4CB6FF" ></path><path d="M572.027586 512.588506c-4.708046-7.650575-14.124138-9.416092-21.186207-4.708046l-131.236781 85.333333-0.588506 0.588506c-7.062069 4.708046-8.827586 14.124138-4.11954 21.186207 2.354023 3.531034 5.885057 5.296552 9.416092 6.473563h2.942528c2.942529 0 5.885057-0.588506 8.239081-2.354023l131.236781-85.333333c3.531034-2.354023 5.885057-5.296552 6.473564-9.416092 1.765517-4.708046 1.177011-8.827586-1.177012-11.770115zM617.931034 576.147126c-4.708046-7.062069-14.124138-8.827586-20.597701-4.708046l-131.236781 85.333334c-7.062069 4.708046-8.827586 13.535632-4.119541 20.597701 2.354023 3.531034 5.296552 5.885057 9.416092 6.473563 1.177011 0 2.354023 0.588506 3.531035 0.588506 2.942529 0 5.296552-0.588506 8.23908-2.354023l131.236782-85.333333c5.885057-4.11954 8.23908-13.535632 3.531034-20.597702z" fill="#4CB6FF" ></path></symbol><symbol id="icon-tgxs_icon1" viewBox="0 0 1024 1024"><path d="M512 1024c-282.482759 0-512-229.517241-512-512S229.517241 0 512 0s512 229.517241 512 512-229.517241 512-512 512zM512 11.770115C235.990805 11.770115 11.770115 235.990805 11.770115 512s224.22069 500.229885 500.229885 500.229885 500.229885-224.22069 500.229885-500.229885S788.009195 11.770115 512 11.770115z" fill="#7DD89A" ></path><path d="M494.933333 787.42069c-142.418391 0-257.765517-115.935632-257.765517-257.765518 0-68.855172 27.071264-133.590805 75.328736-182.436781 48.845977-48.845977 113.581609-75.328736 182.436781-75.328736 20.597701 0 41.783908 2.354023 61.793104 7.650575l-6.473563 18.243678c-18.243678-4.11954-36.487356-6.473563-55.319541-6.473563-131.236782 0-238.344828 107.108046-238.344827 238.344827s107.108046 238.344828 238.344827 238.344828 238.344828-107.108046 238.344828-238.344828c0-20.597701-2.942529-41.195402-7.650575-61.204597l18.243678-7.062069c5.885057 22.363218 8.827586 45.314943 8.827587 68.266666 0 141.829885-115.347126 257.765517-257.765518 257.765518z" fill="#7DD89A" ></path><path d="M494.933333 650.298851c-66.501149 0-120.643678-54.142529-120.643678-120.643679s54.142529-120.643678 120.643678-120.643678c5.296552 0 11.181609 0.588506 16.478161 1.177012l-6.473563 18.832184c-3.531034-0.588506-6.473563-0.588506-9.416092-0.588506h-2.354023c-27.071264 0.588506-52.377011 11.181609-71.209195 30.602299-18.832184 19.42069-28.836782 44.726437-28.836782 71.797701 0.588506 55.31954 45.903448 100.045977 101.222989 100.045977h1.177011c4.708046 0 10.004598-0.588506 15.30115-1.177012 26.482759-4.11954 50.022989-18.243678 66.501149-40.01839 15.301149-20.009195 21.774713-45.314943 18.832184-70.032184l18.832184-7.062069c1.177011 5.885057 1.177011 11.770115 1.177011 17.655172-0.588506 65.912644-54.731034 120.055172-121.232184 120.055173zM822.731034 318.381609zM822.731034 318.381609z" fill="#7DD89A" ></path><path d="M482.574713 528.478161l113.581609-113.581609V321.324138l84.744827-84.744828v-0.588505l19.42069-19.42069v107.696552h107.696552l-19.42069 19.420689-6.473563 6.473564L706.206897 426.078161l-3.531035 2.942529h-92.983908L496.110345 542.013793 482.574713 528.478161z m133.002298-200.68046v80.625288h80.625288l1.765517-1.765518 62.970115-62.970115h-80.625287V263.062069l-64.735633 64.735632z" fill="#7DD89A" ></path></symbol><symbol id="icon-tgxs_icon2" viewBox="0 0 1024 1024"><path d="M512 1024c-282.482759 0-512-229.517241-512-512S229.517241 0 512 0s512 229.517241 512 512-229.517241 512-512 512zM512 11.770115C235.990805 11.770115 11.770115 235.990805 11.770115 512s224.22069 500.229885 500.229885 500.229885 500.229885-224.22069 500.229885-500.229885S788.009195 11.770115 512 11.770115z" fill="#FFB72A" ></path><path d="M355.457471 747.990805c-23.54023 0-42.96092-19.42069-42.960919-42.372414V364.873563c0-23.54023 19.42069-42.372414 42.960919-42.372414h266.593104c23.54023 0 42.96092 19.42069 42.960919 42.372414v215.981609h-11.770115V364.873563c0-17.066667-14.124138-30.602299-31.190804-30.602299H355.457471c-17.066667 0-31.190805 14.124138-31.190804 31.190805V706.206897c0 17.066667 14.124138 30.602299 31.190804 30.602298h223.043678v11.770115H355.457471v-0.588505z" fill="#FFB72A" ></path><path d="M383.117241 456.68046h202.445977v18.243678H383.117241v-18.243678zM383.117241 512h202.445977v18.243678H383.117241V512zM383.117241 567.31954h202.445977v18.243678H383.117241v-18.243678zM383.117241 631.466667h156.542529v18.243678H383.117241v-18.243678zM459.622989 273.066667h59.43908c6.473563 0 11.770115 5.296552 11.770115 11.770115v59.43908c0 6.473563-5.296552 11.770115-11.770115 11.770115H459.622989c-6.473563 0-11.770115-5.296552-11.770115-11.770115V284.836782c0-7.062069 5.296552-11.770115 11.770115-11.770115z" fill="#FFB72A" ></path><path d="M410.777011 346.629885h156.542529v55.31954H410.777011v-55.31954zM557.903448 659.126437h128.882759v18.243678H557.903448V659.126437z" fill="#FFB72A" ></path><path d="M702.675862 662.068966l-46.491954-54.731035c-2.942529-3.531034-8.23908-4.11954-11.770115-1.177011l-0.588506 0.588505c-3.531034 3.531034-3.531034 9.416092-0.588505 12.947127l39.429885 46.491954-45.903449 50.611494c-3.531034 3.531034-2.942529 9.416092 0.588506 12.947126 3.531034 3.531034 9.416092 2.942529 12.947127-0.588505l47.080459-52.377012c1.177011 0 2.354023-0.588506 3.531035-1.765517l0.588506-0.588506c4.11954-2.942529 4.708046-8.23908 1.177011-12.35862z" fill="#FFB72A" ></path></symbol><symbol id="icon-shipin" viewBox="0 0 1024 1024"><path d="M517.632 961.024c-61.44 0-122.368-12.288-178.688-35.84-54.784-23.04-103.936-56.32-145.92-98.304-86.016-86.528-134.656-203.264-134.656-325.12 0-61.44 12.288-122.368 35.84-178.688 23.04-54.784 56.32-103.936 98.304-145.92s91.136-75.264 145.92-98.304c56.32-24.064 117.248-36.352 178.688-35.84 61.44 0 122.368 12.288 178.688 35.84 54.784 23.04 103.936 56.32 145.92 98.304 86.016 86.016 134.656 202.752 134.656 324.608 0 61.44-12.288 122.368-35.84 178.688-23.04 54.784-56.32 103.936-98.304 145.92s-91.136 75.264-145.92 98.304c-56.32 24.064-117.248 36.352-178.688 36.352z m0-878.08C286.72 82.944 98.816 270.848 98.816 501.76s187.904 418.816 418.816 418.816c230.912 0 418.816-187.904 418.816-418.816s-187.904-418.816-418.816-418.816z" fill="" ></path><path d="M517.632 413.184c-66.048 0-119.808-53.76-119.808-119.808s53.76-119.808 119.808-119.808c66.048 0 119.808 53.76 119.808 119.808S583.68 413.184 517.632 413.184z m0-199.168c-43.52 0-79.36 35.84-79.36 79.36s35.84 79.36 79.36 79.36 79.36-35.328 79.36-79.36-35.84-79.36-79.36-79.36z m0 615.936c-66.048 0-119.808-53.76-119.808-119.808 0-66.048 53.76-119.808 119.808-119.808 66.048 0 119.808 53.76 119.808 119.808 0 66.048-53.76 119.808-119.808 119.808z m0-199.168c-43.52 0-79.36 35.328-79.36 79.36 0 43.52 35.84 79.36 79.36 79.36s79.36-35.84 79.36-79.36c0-44.032-35.84-79.36-79.36-79.36zM309.248 621.568C243.2 621.568 189.44 567.808 189.44 501.76s53.76-119.808 119.808-119.808S429.056 435.712 429.056 501.76s-53.76 119.808-119.808 119.808z m0-199.168c-43.52 0-79.36 35.328-79.36 79.36s35.84 79.36 79.36 79.36 79.36-35.328 79.36-79.36-35.84-79.36-79.36-79.36z m416.768 199.168c-66.048 0-119.808-53.76-119.808-119.808s53.76-119.808 119.808-119.808c66.048 0 119.808 53.76 119.808 119.808s-53.76 119.808-119.808 119.808z m0-199.168c-43.52 0-79.36 35.328-79.36 79.36s35.328 79.36 79.36 79.36c43.52 0 79.36-35.328 79.36-79.36s-35.84-79.36-79.36-79.36zM930.816 956.928h-373.76c-11.264 0-19.968-9.216-19.968-19.968 0-11.264 9.216-19.968 19.968-19.968h373.76c11.264 0.512 19.968 9.728 19.456 20.992 0 9.728-8.704 18.432-19.456 18.944z" fill="" ></path></symbol><symbol id="icon-dianpushilibang" viewBox="0 0 1024 1024"><path d="M767.488 949.76c-14.336 0-25.6-11.776-25.6-25.6V162.304l-113.152 113.152c-5.12 4.608-11.264 7.68-18.432 7.68s-13.312-2.56-18.432-7.68c-5.12-4.608-7.68-11.264-7.68-17.92s2.56-13.312 7.68-18.432l156.672-156.672 0.512-0.512c0.512 0 0.512-0.512 1.024-0.512h0.512l1.024-1.024 1.024-0.512 0.512-0.512 0.512-0.512s0.512 0 0.512-0.512c0.512 0 1.536-0.512 1.536-0.512h1.024c0.512 0 1.024-0.512 1.536-0.512l1.536-0.512H761.344l1.024-0.512h10.24l1.536 0.512 2.56 1.024H778.24l0.512 0.512 1.024 0.512h0.512c0.512 0.512 1.024 0.512 1.024 1.024l1.024 0.512s0.512 0.512 1.024 0.512l0.512 0.512 1.024 0.512 0.512 0.512 157.184 157.184c9.728 10.24 10.24 26.624 0 36.352-4.608 4.608-11.264 7.68-18.432 7.68s-13.312-2.56-18.432-7.68l-113.152-113.152v761.856c1.024 13.312-10.752 25.088-25.088 25.088z m-668.16-39.936c-14.336 0-25.6-11.776-25.6-25.6s11.776-25.6 25.6-25.6h503.808c14.336 0 25.6 11.776 25.6 25.6s-11.776 25.6-25.6 25.6H99.328z m0-248.32c-14.336 0-25.6-11.776-25.6-25.6s11.776-25.6 25.6-25.6h437.76c14.336 0 25.6 11.776 25.6 25.6s-11.776 25.6-25.6 25.6H99.328z m0-247.808c-14.336 0-25.6-11.776-25.6-25.6s11.776-25.6 25.6-25.6h348.16c14.336 0 25.6 11.776 25.6 25.6s-11.776 25.6-25.6 25.6h-348.16z m0-247.808c-14.336 0-25.6-11.776-25.6-25.6s11.776-25.6 25.6-25.6h247.808c14.336 0 25.6 11.776 25.6 25.6s-11.776 25.6-25.6 25.6H99.328z" fill="" ></path></symbol><symbol id="icon-koubeiyingxiao" viewBox="0 0 1024 1024"><path d="M842.752 165.888H181.248c-46.08 0-83.968 37.888-83.968 83.968v162.816c0 86.016 25.6 169.984 74.752 241.664 46.08 67.584 108.544 118.784 181.248 148.48v50.176c0 21.504 11.264 33.792 31.744 35.84 13.312 1.024 25.6 1.024 38.912 1.024 123.904 0 249.856-48.128 344.064-133.12 101.376-90.112 157.696-212.992 157.696-345.088V249.856c1.024-46.08-36.864-83.968-82.944-83.968z m47.104 246.784c0 120.832-51.2 234.496-145.408 317.44-88.064 77.824-204.8 123.904-320.512 123.904-11.264 0-22.528 0-33.792-1.024V778.24l-11.264-4.096c-144.384-54.272-244.736-202.752-244.736-361.472V249.856c0-26.624 21.504-47.104 47.104-47.104h660.48c26.624 0 48.128 21.504 48.128 47.104v162.816z" fill="" ></path><path d="M731.136 514.048c-9.216-5.12-20.48-2.048-26.624 7.168-33.792 57.344-83.968 91.136-149.504 101.376-47.104 8.192-86.016 0-91.136-1.024-75.776-23.552-129.024-69.632-160.768-137.216-24.576-52.224-24.576-98.304-24.576-98.304-1.024-10.24-9.216-18.432-20.48-18.432s-19.456 8.192-20.48 19.456c0 3.072 1.024 53.248 27.648 112.64 24.576 55.296 77.824 128 186.368 160.768h1.024c1.024 0 24.576 6.144 59.392 6.144 14.336 0 29.696-1.024 46.08-4.096 77.824-12.288 139.264-53.248 179.2-120.832 7.168-10.24 4.096-22.528-6.144-27.648z m35.84-148.48c-16.384 0-29.696 13.312-29.696 29.696s13.312 29.696 29.696 29.696 29.696-13.312 29.696-29.696c0-16.384-13.312-29.696-29.696-29.696z" fill="" ></path></symbol><symbol id="icon-toufang" viewBox="0 0 1024 1024"><path d="M486.4 949.76c-17.408 0-34.304-4.608-49.152-12.8l-241.664-135.68c-31.744-17.92-51.2-51.2-51.2-87.552V438.784v-2.048c0-13.824 8.704-26.112 22.016-32.256l239.104-103.424c2.048-1.024 4.096-1.536 6.656-1.536 6.656 0 12.8 4.096 15.36 10.24 3.584 8.192-0.512 17.92-8.704 21.504L175.104 436.736l308.224 133.12 310.272-133.12-241.664-104.96c-4.096-1.536-7.168-5.12-8.704-9.216-1.536-4.096-1.536-8.704 0-12.8 2.56-6.144 8.704-9.728 15.36-9.728 2.048 0 4.608 0.512 6.656 1.536l237.056 103.424c13.824 6.144 22.016 18.432 22.016 32.256v276.992c0 35.84-19.456 69.12-50.688 87.04L535.04 936.96c-14.336 8.192-31.232 12.8-48.64 12.8z m12.8-350.208v317.952l14.336-6.144 6.144-3.072 238.592-135.68c20.992-11.776 33.792-34.304 33.792-58.368V474.112l-292.864 125.44z m-321.536 114.176c0 24.064 13.312 46.592 34.304 58.88L465.92 915.456V599.04L177.664 474.624v239.104z" fill="" ></path><path d="M487.424 468.992c-9.216 0-16.384-7.168-16.384-16.384V130.56l-97.28 97.28c-3.072 3.072-7.168 4.608-11.776 4.608-4.608 0-8.704-1.536-11.776-4.608-6.656-6.656-6.656-16.896 0-23.552l125.44-125.44c3.072-3.072 7.168-4.608 11.776-4.608 4.096 0 8.704 1.536 11.776 4.608l128 125.44c3.072 3.072 5.12 7.168 5.12 11.776 0 4.608-1.536 8.704-4.608 11.776s-7.168 5.12-11.776 5.12-8.704-1.536-11.776-4.608L504.32 130.56v322.56c0 8.704-7.68 15.872-16.896 15.872z" fill="" ></path></symbol><symbol id="icon-shijian" viewBox="0 0 1028 1024"><path d="M299.008 565.76c-4.096 0-4.608 0-5.632-1.024l-1.536-1.536-2.048-0.512c-9.728-3.072-10.24-15.36-10.24-15.872V217.6c0-11.264 8.192-19.456 19.456-19.456h175.104c11.264 0 19.456 8.192 19.456 19.456v328.704c0 9.216-7.168 14.336-10.752 15.872-4.096 1.536-7.68 2.048-10.24 2.048s-5.12-0.512-8.704-4.096l-0.512-1.024-79.36-51.2-74.752 55.808-0.512 0.512c-1.024 1.536-1.536 1.536-9.728 1.536z m87.04-92.672c3.072 0 6.144 1.024 8.192 3.584l1.024 1.024 59.392 35.328V228.864H314.368v284.16l58.368-34.816c4.608-3.584 9.216-5.12 13.312-5.12z" fill="#2C2C2C" ></path><path d="M264.704 395.264c-84.992 0-92.16-76.288-92.16-147.456 0-70.144 7.168-139.264 92.16-139.264h725.504c11.264 0 19.456 8.192 19.456 15.36 0 12.8-10.752 15.36-19.456 15.36H264.704c-44.544 0-52.736 37.888-52.736 108.544 0 71.168 8.704 112.64 52.736 112.64 20.992 0 23.552 6.656 24.064 9.728-3.584 12.288-12.8 25.088-24.064 25.088z" fill="#2C2C2C" ></path><path d="M226.304 915.456C145.408 915.456 138.24 839.168 138.24 768c0-70.144 7.168-139.264 92.16-139.264h768c8.704 0 19.456 2.56 19.456 15.36 0 11.264-8.192 19.456-19.456 19.456H230.4c-41.984 0-57.344 27.136-57.344 103.936 0 93.184 33.28 112.64 61.44 112.64h768c11.776 0 14.848 9.216 15.36 17.92-3.584 8.704-12.8 16.896-24.064 16.896l-767.488 0.512zM967.68 412.16c0-0.512-0.512-1.024-0.512-1.536-1.024-3.072-3.072-7.168-6.656-11.264-62.976-132.096-6.144-253.44 0.512-266.752 2.048-4.096 3.072-4.608 3.072-4.608 1.536 0 5.12 1.024 8.192 2.56 3.072 1.024 6.144 2.048 9.728 3.072 12.288 6.144 12.288 9.216 7.68 19.456-11.776 17.408-58.368 119.808 0 227.84 3.072 6.144 3.584 11.776 2.56 16.896-1.024 4.608-4.096 8.192-8.704 10.752-5.632 0.512-9.728 2.048-12.8 3.584-0.512 0.512-1.536 0.512-2.048 1.024-0.512-1.024-1.024-1.024-1.024-1.024z" fill="#2C2C2C" ></path><path d="M972.8 915.456c-10.24 0-13.312-3.584-15.36-10.24l-0.512-1.024-0.512-0.512c-53.76-101.376-30.72-197.12-12.288-245.248l-18.432-8.704c-4.608 8.192-12.288 13.824-16.896 13.824H102.4c-84.992 0-92.16-76.288-92.16-147.456C10.24 444.416 17.408 368.64 102.4 368.64h196.096c5.12 0 11.264 0 11.264 19.456 0 15.36-3.072 15.36-11.264 15.36H102.4c-40.96 0-57.344 30.208-57.344 108.544 0 77.824 19.456 116.736 57.344 116.736h806.4c19.456 0 19.456 6.144 19.456 11.264 0 1.536 0 3.072-0.512 4.608l19.456 6.144c0.512-1.024 0.512-2.048 1.024-2.56 3.584-6.656 9.216-10.24 16.384-10.24 4.096 0 8.192 1.024 12.288 3.072 4.608 2.048 7.168 5.12 8.192 8.704 1.024 4.096 0 9.728-3.584 14.848-10.752 14.848-55.808 113.664 8.192 223.744 3.584 7.168 4.608 12.288 4.096 15.872 0 1.024-0.512 4.096-6.656 7.68-5.632 0.512-9.728 2.048-12.8 3.584 0-0.512-1.024 0-1.536 0z" fill="#2C2C2C" ></path><path d="M883.712 664.064c-7.68 0-9.216-0.512-16.896-11.776-60.416-121.856-11.264-244.736-1.024-261.12l0.512-0.512 0.512-1.536c5.632-11.264 11.264-11.264 13.824-11.264 3.072 0 6.656 1.024 11.264 3.072 14.848 7.168 13.312 16.384 12.288 20.48-12.8 19.456-60.928 124.928 0.512 231.424 5.12 10.752 4.096 21.504-3.072 27.648-4.096 0.512-7.68 1.536-10.24 2.56-3.072 0-5.12 1.024-7.68 1.024z" fill="#2C2C2C" ></path><path d="M486.912 412.16c-11.264 0-19.456-8.192-19.456-19.456 0-12.8 10.752-15.36 19.456-15.36h503.296c8.704 0 19.456 2.56 19.456 15.36 0 7.68-8.704 19.456-19.456 19.456H486.912z" fill="#2C2C2C" ></path></symbol><symbol id="icon-shiliangzhinengduixiang_cfdea-affe" viewBox="0 0 1026 1024"><path d="M996.073 493.165c-4.763-4.762-11.258-7.36-17.969-7.36h-87.03l-0.432-4.763c-14.505-183.8-164.316-333.395-347.9-347.9l-4.763-0.433V45.463c0-6.928-2.598-13.206-7.36-17.969-4.764-4.762-11.258-7.577-17.97-7.577-6.71 0-13.205 2.598-17.968 7.36-4.763 4.764-7.36 11.258-7.36 17.97v87.029l-4.764 0.433c-183.8 14.505-333.395 164.1-347.9 347.9l-0.433 4.763H46.545C32.474 485.372 21 496.846 21 510.918s11.474 25.545 25.545 25.545h87.03l0.433 4.763c14.504 183.8 164.1 333.396 347.9 348.117l4.763 0.433v87.03c0 6.71 2.597 13.205 7.36 17.968s11.258 7.36 17.969 7.36c6.711 0 13.206-2.597 17.969-7.36 4.763-4.763 7.36-11.258 7.36-17.969v-87.03l4.763-0.432c183.8-14.505 333.396-164.1 347.9-348.117l0.433-4.763h87.03c14.071 0 25.545-11.474 25.545-25.545 0.433-6.495-2.164-12.99-6.927-17.753zM486.887 838.901l-5.629-0.433c-156.739-14.722-281.22-139.42-296.159-296.16l-0.433-5.628h302.221V838.9z m0-353.313h-302.22l0.432-5.629c14.938-156.739 139.42-281.22 296.16-295.942l5.628-0.433v302.004z m352.447 56.72c-14.722 156.74-139.204 281.222-296.16 296.16l-5.628 0.433V536.68h302.437l-0.65 5.629z m-301.572-56.72v-302.22l5.63 0.649c156.738 14.721 281.22 139.203 295.942 295.942l0.433 5.63H537.762z" fill="#eb7651" ></path></symbol><symbol id="icon-shiliangzhinengduixiang_fec-aa" viewBox="0 0 1067 1024"><path d="M1004.587678 941.49763H75.708057c-6.794313 0-11.647393-4.853081-11.647393-11.647393v-24.265403c0-6.794313 4.853081-11.647393 11.647393-11.647393h83.472986V464.925118c0-26.206635 21.353555-47.56019 47.560189-47.560189H397.952607v-95.120379c0-26.206635 21.353555-47.56019 47.560189-47.56019h190.240759v-95.120379c0-26.206635 21.353555-47.56019 47.560189-47.56019H873.554502c26.206635 0 47.56019 21.353555 47.56019 47.56019v714.37346h83.472986c6.794313 0 11.647393 4.853081 11.647393 11.647393v24.265403c0.970616 5.823697-4.853081 11.647393-11.647393 11.647393zM397.952607 464.925118H206.741232v429.012323H397.952607V464.925118z m237.800948-142.680568H445.512796v571.692891h190.240759V322.24455zM873.554502 179.563981H683.313744v714.37346H873.554502V179.563981z m0 0" fill="" ></path></symbol><symbol id="icon-shiliangzhinengduixiang_-adf" viewBox="0 0 1024 1024"><path d="M1000.387928 511.826382c0 253.482536-192.716175 461.477111-439.601221 486.130892-16.320109 1.736182-32.640217 2.430654-49.307562 2.430654-16.667345 0-32.987453-0.694473-49.307561-2.430654-246.885046-24.653781-439.601221-232.995592-439.601221-486.130892 0-253.482536 192.716175-461.824347 439.601221-486.478128 16.320109-1.736182 32.640217-2.430654 49.307561-2.430655 16.667345 0 32.987453 0.694473 49.307562 2.430655 246.537809 24.653781 439.601221 232.995592 439.601221 486.478128z m-935.801967-20.486945h182.993557c2.430654-71.877925 17.014581-140.283486 42.015599-203.827738H123.963377c-35.070871 60.766361-56.252289 129.866395-59.377416 203.827738z m893.786369 40.97389h-182.993558c-2.430654 71.530688-17.014581 140.283486-42.015598 203.480501h165.63174c35.070871-60.419125 56.252289-129.519159 59.377416-203.480501z m-223.967447 0h-202.438793v203.480501h156.603595c26.737199-62.84978 43.404544-131.255341 45.835198-203.480501z m-202.438793 244.107155v171.881993c56.599525-47.57138 103.129196-105.907087 137.505595-171.881993h-137.505595z m-40.973889 171.881993v-171.881993h-137.505595c34.723635 65.974907 81.253306 124.310614 137.505595 171.881993z m0-212.508647v-203.480501H288.553408c2.430654 72.225161 19.097999 140.630722 45.835198 203.480501h156.603595z m-243.759919-203.480501H64.585961c3.472364 73.961343 24.306545 143.408613 59.377416 203.480501h165.63174c-25.001017-63.544252-39.93218-131.949813-42.362835-203.480501zM288.553408 491.339437h202.438793V287.858935h-156.256358C307.651407 350.708715 290.984062 419.114276 288.553408 491.339437z m202.438793-244.454391V75.350288c-56.599525 47.57138-103.129196 105.907087-137.505595 171.881994h137.505595z m40.973889-171.534758v171.881994h137.505595c-34.723635-65.974907-81.253306-124.310614-137.505595-171.881994z m0 212.508647v203.827738h202.438793c-2.430654-72.225161-19.097999-140.630722-46.182435-203.827738h-156.256358z m243.759919 203.480502H958.719566c-3.472364-73.961343-24.306545-143.408613-59.377416-203.827738h-165.63174c24.653781 63.544252 39.584944 132.29705 42.015599 203.827738z m96.531705 285.081045H715.65412c-31.945744 66.322143-75.697525 126.046796-128.130214 176.396066 116.671414-19.792472 217.369956-84.72567 284.733808-176.396066z m-436.823329 176.396066c-52.432689-50.349271-96.184469-110.073923-128.130214-176.396066H150.700576c67.016616 91.670397 168.062394 156.603594 284.733809 176.396066z m-284.733809-705.931502h156.603595c31.945744-66.322143 75.697525-126.046796 128.130214-176.396067-116.671414 20.139708-217.717192 85.072906-284.733809 176.396067z m436.82333-176.396067C639.956595 120.83825 683.708376 180.562903 715.65412 246.885046h156.603594c-67.363852-91.32316-168.062394-156.256358-284.733808-176.396067z m0 0" fill="" ></path></symbol><symbol id="icon-shiliangzhinengduixiang_ebd-de" viewBox="0 0 1065 1024"><path d="M615.637462 960.064451H266.054381C154.682779 960.064451 64.966767 869.317221 64.966767 756.914401V284.616314c0-112.40282 90.747231-203.15005 201.087614-203.15005h533.13998C910.565962 81.466264 1000.281974 172.213494 1000.281974 284.616314v285.647533h-58.779456V284.616314c0-79.403827-63.935549-144.370594-143.339376-144.370594H266.054381c-78.372608 0-143.339376 64.966767-143.339376 144.370594v472.298087c0 79.403827 63.935549 144.370594 143.339376 144.370594h349.583081v58.779456z" fill="" ></path><path d="M498.07855 672.354481a28.17289 28.17289 0 0 1-27.8429 27.842901H304.209466c-15.468278 0-27.8429-12.374622-27.8429-27.842901 0-15.468278 12.374622-27.8429 27.8429-27.8429h166.026184c15.468278 1.031219 27.8429 12.374622 27.8429 27.8429zM620.793555 518.70292a28.17289 28.17289 0 0 1-27.8429 27.842901h-288.741189c-15.468278 0-27.8429-12.374622-27.8429-27.842901 0-15.468278 12.374622-27.8429 27.8429-27.8429h288.741189c15.468278 1.031219 27.8429 13.405841 27.8429 27.8429zM762.070493 368.145015c0 15.468278-12.374622 27.8429-27.8429 27.8429H304.209466c-15.468278 0-27.8429-12.374622-27.8429-27.8429 0-15.468278 12.374622-27.8429 27.8429-27.8429h430.018127c15.468278 1.031219 27.8429 12.374622 27.8429 27.8429zM993.063444 714.634441c-5.156093-5.156093-12.374622-8.249748-19.593152-8.249748s-14.437059 3.093656-19.593152 8.249748L836.318228 830.130916l-3.093656 3.093656-65.997986 64.966767-96.934542-98.996978c-7.21853-7.21853-16.499496-10.312185-26.811681-7.21853-9.280967 2.062437-16.499496 9.280967-19.593153 19.593152-3.093656 9.280967 0 19.593152 7.21853 26.811682l116.527694 118.590131c5.156093 5.156093 12.374622 8.249748 19.593152 8.249748 5.156093 0 11.343404-2.062437 15.468278-5.156093 2.062437-1.031219 4.124874-2.062437 6.187311-4.124874L907.472306 839.411883l3.093656-3.093655 83.528701-82.497483c10.312185-11.343404 10.312185-28.874119-1.031219-39.186304zM452.704935 143.339376c-1.031219 19.593152-16.499496 35.06143-36.092649 35.06143s-35.06143-15.468278-36.092649-35.06143V78.372608c0-19.593152 16.499496-36.092649 36.092649-36.092648s36.092649 16.499496 36.092649 36.092648v64.966768zM673.3857 143.339376c0 19.593152-16.499496 35.06143-36.092649 35.06143s-35.06143-15.468278-36.092648-35.06143V78.372608c1.031219-19.593152 16.499496-35.06143 36.092648-35.06143s35.06143 15.468278 36.092649 35.06143v64.966768z" fill="" ></path></symbol><symbol id="icon-shijianyingxiao" viewBox="0 0 1024 1024"><path d="M888.832 76.8h-111.104V32.768h-65.024V76.8H389.12V32.768H324.096V76.8H158.72C80.896 76.8 13.824 135.68 13.824 206.336v657.408c0 69.632 67.072 132.096 144.896 132.096h719.36c69.632 0 132.096-59.392 132.096-132.096V206.336c2.56-70.656-51.712-127.488-121.344-129.536z m56.832 786.432c0 38.912-30.72 67.072-69.632 67.072H158.72c-41.472 0-80.384-33.792-80.384-67.072V206.336c0-36.352 41.472-65.024 80.384-65.024h165.376v98.304H389.12V141.312h323.584v98.304h65.024V141.312H885.76c33.792 2.56 59.392 30.72 59.392 65.024l0.512 656.896z"  ></path><path d="M202.752 490.496h595.456v65.024H202.752V490.496z m0-155.136h465.92v65.024h-465.92V335.36z m0 310.784h258.56v65.024H202.752v-65.024z"  ></path></symbol><symbol id="icon-xiaoguokeyuce" viewBox="0 0 1024 1024"><path d="M425.984 515.072c-15.872 0-28.672 12.8-28.672 28.672v401.408c0 15.872 12.8 28.672 28.672 28.672 15.872 0 28.672-12.8 28.672-28.672v-401.408c0-15.872-12.8-28.672-28.672-28.672zM196.608 687.104c-15.872 0-28.672 12.8-28.672 28.672v229.376c0 15.872 12.8 28.672 28.672 28.672s28.672-12.8 28.672-28.672v-229.376c0-15.872-12.8-28.672-28.672-28.672zM655.36 629.76c-15.872 0-28.672 12.8-28.672 28.672v286.72c0 15.872 12.8 28.672 28.672 28.672 15.872 0 28.672-12.8 28.672-28.672v-286.72c0-15.872-12.8-28.672-28.672-28.672zM884.736 515.072c-15.872 0-28.672 12.8-28.672 28.672v401.408c0 15.872 12.8 28.672 28.672 28.672s28.672-12.8 28.672-28.672v-401.408c0-15.872-12.8-28.672-28.672-28.672z"  ></path><path d="M951.296 115.712c-5.632-2.56-12.288-3.072-18.432-2.048h-162.816c-15.872 0-28.672 12.8-28.672 28.672 0 15.872 12.8 28.672 28.672 28.672h98.304l-272.896 273.92-208.384-208.384c0-0.512-0.512-0.512-0.512-1.024-0.512 0-0.512-0.512-1.024-0.512l-0.512-0.512c-8.192-8.192-19.968-10.24-30.208-5.632-4.096 1.536-7.68 3.584-11.264 6.656L61.44 519.168c-11.776 11.776-11.776 30.72 0 42.496 11.776 11.776 30.72 11.776 42.496 0l264.704-266.24L579.584 506.88c10.752 10.752 28.16 10.752 38.912 0 0 0 0-0.512 0.512-0.512 0.512-0.512 1.024-0.512 2.048-1.024l292.864-293.888v103.424c0 15.872 12.8 28.672 28.672 28.672s28.672-12.8 28.672-28.672V142.336c-0.512-12.8-8.704-23.04-19.968-26.624z"  ></path></symbol><symbol id="icon-bingdushichuanbo" viewBox="0 0 1198 1024"><path d="M1024 510.269101c0-92.08384-28.386748-180.013523-82.390805-255.48073-12.462475-17.308993-36.695064-21.463151-54.004056-9.000677s-21.463151 36.695064-9.000677 54.004057c44.311021 61.620014 67.851251 134.317782 67.851251 209.78499 0 75.467208-23.54023 148.164976-67.851251 209.78499-12.462475 17.308993-8.308316 41.541582 9.000677 54.004057 6.923597 4.846518 14.539554 7.615957 22.84787 7.615956 11.770115 0 24.23259-5.538878 31.848546-15.924273 53.311697-74.774848 81.698445-162.70453 81.698445-254.78837zM307.407708 246.480054c-17.308993-12.462475-41.541582-8.308316-54.004057 9.000676-54.004057 74.774848-82.390805 163.39689-82.390804 255.48073s28.386748 180.013523 82.390804 255.480731c7.615957 10.385396 19.386072 15.924273 31.848546 15.924273 7.615957 0 15.924273-2.077079 22.847871-7.615957 17.308993-12.462475 21.463151-36.695064 9.000676-54.004057-44.311021-61.620014-67.851251-134.317782-67.851251-209.78499s23.54023-148.164976 67.851251-209.784989c11.770115-18.001352 7.615957-42.233942-9.693036-54.696417z"  ></path><path d="M1009.460446 58.158215c-13.847194-15.924273-38.772143-18.001352-54.696416-3.461799-15.924273 13.847194-18.001352 38.772143-3.461799 54.696417 97.622718 111.469912 151.626775 253.403651 151.626775 400.876268s-54.004057 289.406356-151.626775 400.876267c-13.847194 15.924273-12.462475 40.849222 3.461799 54.696417 7.615957 6.231237 16.616633 9.693036 25.617309 9.693036 11.077755 0 21.463151-4.154158 29.079107-13.154835 110.085193-125.317106 170.320487-285.944557 170.320487-452.110885s-60.235294-326.10142-170.320487-452.110886zM96.237999 510.96146c0-147.472617 54.004057-289.406356 151.626774-400.876267 13.847194-15.924273 12.462475-40.849222-3.461798-54.696417s-40.849222-12.462475-54.696417 3.461799C78.929006 184.167681 18.693712 344.795132 18.693712 510.269101s60.235294 326.10142 170.320487 452.110885c7.615957 9.000676 18.001352 13.154834 29.079107 13.154835 9.000676 0 18.001352-3.461799 25.617309-9.693036 15.924273-13.847194 18.001352-38.772143 3.461799-54.696417-97.622718-110.777552-150.934415-253.403651-150.934415-400.183908zM597.506423 776.135227C451.418526 776.135227 332.332657 657.049358 332.332657 510.96146c0-146.087897 119.085869-265.173766 265.173766-265.173766s265.173766 119.085869 265.173766 265.173766c0 146.087897-119.085869 265.173766-265.173766 265.173767z m0-461.803922C489.49831 314.331305 401.568627 402.260987 401.568627 510.269101 401.568627 618.277214 489.49831 706.206897 597.506423 706.206897s195.937796-87.929682 195.937796-195.937796c0-108.008114-87.929682-195.937796-195.937796-195.937796z"  ></path></symbol><symbol id="icon-hudongzhudong" viewBox="0 0 1067 1024"><path d="M1022.976 159.232c0-0.512 0-0.512 0 0 0-5.632-0.512-10.752-1.024-15.36-6.144-43.008-46.592-78.336-90.624-78.336h-282.112c-5.632 0-11.264 0.512-16.896 1.536-43.008 8.704-75.264 47.104-75.264 92.672v195.584c0 4.608 0.512 9.216 1.024 13.824 6.144 44.544 47.104 80.384 91.648 79.872 46.592-0.512 93.184 0 139.776 0h139.264c15.36 0 30.208-3.072 43.52-10.24 31.744-17.408 50.176-44.544 50.688-81.408 0.512-66.56 0-132.608 0-198.144z m-46.08 191.488c0 26.624-21.504 47.104-48.128 47.104h-139.264c-46.592 0-92.672 0.512-139.264 0-20.48 0-34.816-10.752-43.52-28.672-2.56-5.632-4.096-12.288-4.096-19.456v-0.512-184.832c0-26.624 21.504-48.64 48.64-48.64h277.504c26.112 0 48.128 20.992 48.128 47.104 0.512 62.464 0.512 125.44 0 187.904z m-447.488 323.072v-2.56c0-6.144-0.512-12.288-1.536-18.432-7.168-44.544-48.128-77.824-91.136-77.312-46.592 0.512-93.184 0-140.288 0H153.6c-5.632 0-10.752 0.512-15.872 1.536-42.496 9.728-74.24 47.616-74.24 92.672v194.048c0 25.6 9.216 48.128 27.136 66.56 16.896 17.408 37.888 28.16 62.464 28.16 95.744 0.512 192 0.512 287.744 0 25.6 0 47.104-11.776 64-30.208 17.408-18.944 25.088-41.984 25.088-68.096-0.512-61.952-0.512-124.416-0.512-186.368z m-45.568 182.784c0 22.016-8.704 38.4-29.184 47.616-6.144 2.56-13.312 4.608-20.48 4.608H158.72c-28.16 0-49.664-21.504-49.664-49.664 0-60.928-0.512-122.368 0-183.296 0-30.208 22.016-49.152 48.128-49.664 46.592-0.512 92.672 0 139.264 0h135.68c18.432 0 33.28 6.656 44.032 22.528 6.144 9.216 7.68 18.944 7.68 29.696v178.176z m427.008-192.512c-1.536 62.976-22.528 119.808-60.928 169.472-37.376 48.128-89.088 83.968-148.992 100.352 18.944-3.584-12.288 6.144-45.056 9.216-5.632 0.512-11.264 1.536-16.384 1.536-29.184 2.048-38.4-48.128 3.072-53.248 26.112-3.072 50.176-9.216 72.704-17.408 11.264-1.536 48.128-24.064 76.8-55.296 16.896-10.24 43.52-50.688 57.344-99.328 5.632-20.48 9.216-40.96 9.216-61.952 0-13.824-12.8-88.576 19.456-120.832 2.048-2.048 3.072-3.584 6.144-0.512 31.744 33.28 27.136 105.472 26.624 128z"  ></path><path d="M856.064 622.592l-49.664 59.392s-14.336 18.944-31.744 8.192c-24.576-15.36-10.752-34.816-10.752-34.816l88.064-107.008s15.36-16.896 36.864-15.36c24.576 1.536 37.888 25.6 37.888 25.6l78.848 111.104s9.216 15.36-7.168 29.184c-18.432 15.872-30.208 2.56-30.208 2.56l-61.44-79.872-50.688 1.024zM176.128 365.056c0-26.624 3.584-52.224 10.752-76.8 14.848-51.2 42.496-96.768 83.968-134.144 40.448-36.864 88.064-60.416 141.824-71.168 15.872-3.072 34.304-4.608 53.248-4.608 9.728-1.536 19.968 48.128-19.968 53.248-23.04 3.072-45.568 7.168-67.072 15.872-41.984 16.896-76.8 44.032-102.4 78.848-5.12-2.56-30.208 38.912-40.96 86.016 1.536-13.824-6.144 17.92-7.168 51.712 0.512-10.752 0-3.584 0 3.584 0 12.288 12.288 87.04-19.456 119.296-2.048 2.048-3.072 3.584-6.144 0.512-32.256-32.768-26.624-107.008-26.624-122.368z"  ></path><path d="M229.888 404.48l49.664-59.392s14.336-18.944 31.744-8.192c24.576 15.36 10.752 34.816 10.752 34.816l-88.064 107.52s-15.36 16.896-36.864 15.36c-24.576-1.536-37.888-25.6-37.888-25.6L79.872 357.376s-9.216-15.36 7.168-29.184c18.432-15.872 30.208-2.56 30.208-2.56l61.44 79.872 51.2-1.024z"  ></path></symbol><symbol id="icon-mubiaojingzhun" viewBox="0 0 1026 1024"><path d="M971.264 481.28h-33.28c-3.584-46.08-13.824-90.112-31.744-133.12a432.4864 432.4864 0 0 0-90.112-134.144c-38.912-38.912-83.968-69.12-134.144-90.112-42.496-17.92-87.04-28.672-133.12-31.744v-33.792c0-17.408-13.824-31.232-31.232-31.232S486.4 40.96 486.4 58.368V92.16c-46.08 3.584-90.112 13.824-133.12 31.744-50.176 21.504-95.744 51.712-134.656 90.624-38.912 38.912-69.632 83.968-90.624 134.144-17.92 42.496-28.672 87.04-31.744 133.12H61.44c-17.408 0-31.232 13.824-31.232 31.232 0 17.408 13.824 31.232 31.232 31.232h34.304c3.584 46.08 13.824 90.112 31.744 133.12 21.504 50.176 51.712 95.232 90.112 134.144 38.912 38.912 83.968 69.12 134.144 90.112 42.496 17.92 87.04 28.672 133.12 31.744v32.256c0 17.408 13.824 31.232 31.232 31.232 17.408 0 31.232-13.824 31.232-31.232v-31.744c46.08-3.584 90.112-13.824 133.12-31.744 50.176-21.504 95.232-51.712 134.144-90.112 38.912-38.912 69.12-83.968 90.112-134.144 17.92-42.496 28.672-87.04 31.744-133.12h33.28c17.408 0 31.232-13.824 31.232-31.232 1.536-17.92-12.288-32.256-29.696-32.256z m-173.568 62.976h76.8c-14.848 173.568-153.088 311.808-326.144 326.656v-73.216c0-17.408-13.824-31.232-31.232-31.232-17.408 0-31.232 13.824-31.232 31.232v73.216c-173.568-15.36-311.808-153.6-327.168-326.656h76.8c17.408 0 31.232-13.824 31.232-31.232 0-17.408-13.824-31.232-31.232-31.232H158.72c15.36-173.056 153.6-311.296 326.656-326.144v70.656c0 17.408 13.824 31.232 31.232 31.232 17.408 0 31.232-13.824 31.232-31.232V155.136c173.568 14.848 311.808 153.6 326.656 326.144h-76.8c-17.408 0-31.232 13.824-31.232 31.232 0 17.408 13.824 31.744 31.232 31.744z"  ></path><path d="M517.12 374.784c-76.288 0-138.24 61.952-138.24 138.24s61.952 138.24 138.24 138.24 138.24-61.952 138.24-138.24c-0.512-76.288-62.464-138.24-138.24-138.24z m0 213.504c-41.472 0-75.264-33.792-75.264-75.264s33.792-75.264 75.264-75.264 75.264 33.792 75.264 75.264-33.792 75.264-75.264 75.264z"  ></path></symbol><symbol id="icon-zhenghechuanbo" viewBox="0 0 1024 1024"><path d="M509.952 286.208c61.44 0 111.616-50.176 111.616-111.616s-50.176-111.616-111.616-111.616-111.616 50.176-111.616 111.616 50.176 111.616 111.616 111.616z m0-166.912c30.72 0 55.808 25.088 55.808 55.808S540.672 230.4 509.952 230.4s-55.808-25.088-55.808-55.808 25.6-55.296 55.808-55.296z m-335.36 463.36c-61.44 0-111.616 50.176-111.616 111.616s50.176 111.616 111.616 111.616 111.616-50.176 111.616-111.616-49.664-111.616-111.616-111.616z m0 166.912c-30.72 0-55.808-25.088-55.808-55.808s25.088-55.808 55.808-55.808 55.808 25.6 55.808 56.32-25.088 55.296-55.808 55.296z m671.232-166.912c-61.44 0-111.616 50.176-111.616 111.616s50.176 111.616 111.616 111.616 111.616-50.176 111.616-111.616-49.664-111.616-111.616-111.616z m0 166.912c-30.72 0-55.808-25.088-55.808-55.808s25.088-55.808 55.808-55.808 55.808 25.088 55.808 55.808c0 31.232-25.088 55.808-55.808 55.808z m-336.384 130.048c-79.872 0-157.184-27.648-218.624-78.336l-35.84 43.008c71.168 58.88 161.792 91.136 254.464 91.136 93.696 0 184.32-32.768 256-92.672l-35.84-43.008c-61.44 51.712-139.776 79.872-220.16 79.872z m344.064-344.064h55.808c0-154.624-90.624-296.96-230.912-362.496l-23.552 50.688c120.32 56.32 198.656 178.688 198.656 311.808zM364.032 223.744l-23.552-50.688c-140.288 65.536-230.912 207.872-230.912 362.496h55.808c0-133.12 78.336-255.488 198.656-311.808z"  ></path></symbol><symbol id="icon-hailiangduanshipinchuangyishuju" viewBox="0 0 1024 1024"><path d="M547.555556 99.555556c-52.622222 0-142.222222-10.666667-142.222223-49.777778s89.6-49.777778 142.222223-49.777778 142.222222 10.666667 142.222222 49.777778-89.6 49.777778-142.222222 49.777778zM434.488889 49.777778c7.822222 7.111111 45.511111 21.333333 113.066667 21.333333s105.244444-14.222222 113.066666-21.333333C652.8 42.666667 615.111111 28.444444 547.555556 28.444444S442.311111 42.666667 434.488889 49.777778z m226.844444 1.422222z" fill="#F5F7FC" ></path><path d="M227.555556 803.555556H206.222222v-21.333334c0-7.822222-6.4-14.222222-14.222222-14.222222s-14.222222 6.4-14.222222 14.222222v21.333334H156.444444c-7.822222 0-14.222222 6.4-14.222222 14.222222s6.4 14.222222 14.222222 14.222222h21.333334v21.333333c0 7.822222 6.4 14.222222 14.222222 14.222223s14.222222-6.4 14.222222-14.222223v-21.333333h21.333334c7.822222 0 14.222222-6.4 14.222222-14.222222s-6.4-14.222222-14.222222-14.222222z" fill="#D8DDE7" ></path><path d="M222.577778 1003.377778c-2.844444 0-4.977778-0.711111-7.822222-2.133334-6.4-4.266667-8.533333-12.8-4.266667-19.911111 0.711111-1.422222 16.355556-26.311111 48.355555-31.288889 22.755556-3.555556 46.933333 3.555556 71.822223 22.044445 2.844444-2.133333 6.4-4.266667 9.244444-7.111111 23.466667-19.2 49.777778-33.422222 103.822222 6.4 1.422222-1.422222 3.555556-2.844444 4.977778-4.266667 21.333333-19.911111 46.933333-35.555556 98.844445 7.111111 7.822222-2.133333 14.222222-5.688889 21.333333-10.666666 22.044444-13.511111 43.377778-22.755556 76.088889 7.111111 0.711111-0.711111 1.422222-0.711111 2.133333-1.422223 24.888889-19.2 51.911111-33.422222 110.933333 3.555556l2.133334-2.133333c15.644444-12.8 53.333333-42.666667 100.266666 9.244444 4.977778 5.688889 4.977778 14.933333-0.711111 19.911111-5.688889 4.977778-14.933333 4.977778-19.911111-0.711111-29.155556-32-45.511111-18.488889-61.155555-5.688889-6.4 4.977778-12.088889 9.955556-19.911111 10.666667-3.555556 0-6.4-0.711111-9.244445-2.133333-51.911111-34.844444-68.266667-22.755556-85.333333-9.244445-4.266667 3.555556-8.533333 7.111111-14.222222 9.955556-5.688889 3.555556-12.8 2.133333-17.066667-2.844445-24.888889-26.311111-32-22.044444-49.066667-11.377778-9.955556 6.4-22.044444 13.511111-39.111111 15.644445-3.555556 0.711111-7.822222-0.711111-10.666667-3.555556-40.533333-35.555556-51.2-25.6-65.422222-12.088889-5.688889 4.977778-11.377778 10.666667-18.488889 14.222223-4.977778 2.133333-10.666667 2.133333-14.933333-1.422223-46.933333-37.688889-59.022222-27.022222-76.088889-13.511111-6.4 5.688889-14.222222 11.377778-23.466667 15.644445-4.977778 2.133333-9.955556 0.711111-14.222222-2.133334-21.333333-17.066667-40.533333-24.888889-56.888889-22.044444-18.488889 2.844444-28.444444 18.488889-28.444444 18.488889-4.266667 3.555556-8.533333 5.688889-13.511111 5.688889z" fill="#F9FAFD" ></path><path d="M450.133333 754.488889h-1.422222 1.422222zM544 903.822222c-56.888889 0-105.955556-44.8-110.933333-100.977778-0.711111-2.133333-0.711111-4.977778-0.711111-7.111111v-75.377777l-1.422223-0.711112c-66.844444-39.822222-108.8-113.066667-108.8-190.577777 0-122.311111 98.844444-221.155556 221.155556-221.155556 121.6 0 221.155556 98.844444 221.155555 221.155556 0 77.511111-41.955556 150.755556-108.8 190.577777l-1.422222 0.711112V795.733333c0 2.133333-0.711111 4.977778-0.711111 7.111111-2.133333 25.6-13.511111 49.777778-32.711111 68.266667-19.2 21.333333-46.933333 32.711111-76.8 32.711111z m-81.066667-110.933333c0 4.977778 0.711111 9.955556 1.422223 13.511111 0.711111 4.977778 2.133333 10.666667 4.266666 15.644444 4.266667 10.666667 10.666667 19.911111 18.488889 28.444445 15.644444 15.644444 35.555556 24.177778 57.6 24.177778s41.955556-8.533333 57.6-24.177778c7.822222-7.822222 14.222222-17.066667 18.488889-27.733333 2.133333-4.977778 3.555556-9.955556 4.266667-15.644445 0.711111-4.266667 1.422222-9.244444 1.422222-13.511111v-9.244444h-163.555556v8.533333z m0-17.777778h162.133334v-42.666667H462.933333v42.666667z m81.066667-437.333333c-25.6 0-51.2 4.977778-74.666667 14.933333-22.755556 9.955556-43.377778 23.466667-60.444444 40.533333-17.777778 17.777778-31.288889 38.4-40.533333 60.444445-9.955556 23.466667-14.933333 48.355556-14.933334 74.666667 0 25.6 4.977778 51.2 14.933334 74.666666 9.955556 22.755556 23.466667 43.377778 40.533333 60.444445 6.4 6.4 13.511111 12.8 20.622222 17.777777 10.666667 7.822222 22.044444 14.933333 34.844445 20.622223l0.711111 0.711111h160v-0.711111c12.088889-5.688889 23.466667-12.8 34.133333-20.622223 7.111111-4.977778 13.511111-10.666667 19.2-17.066666 17.066667-17.066667 31.288889-38.4 41.244444-60.444445 9.955556-23.466667 14.933333-48.355556 14.933334-74.666666s-4.977778-50.488889-14.933334-74.666667c-9.955556-22.755556-23.466667-43.377778-40.533333-60.444444-17.777778-17.777778-37.688889-31.288889-60.444444-40.533334-23.466667-10.666667-49.066667-15.644444-74.666667-15.644444zM448.711111 754.488889h1.422222-1.422222z" fill="#FE6E45" ></path><path d="M544 493.511111c-31.288889 0-56.888889 25.6-56.888889 56.888889 0 29.866667 22.755556 54.044444 51.2 56.888889v98.133333h10.666667V607.288889c28.444444-2.844444 51.2-27.022222 51.2-56.888889 0.711111-32-24.888889-56.888889-56.177778-56.888889z m0 100.977778c-24.177778 0-44.088889-19.911111-44.088889-44.088889s19.911111-44.088889 44.088889-44.088889 44.088889 19.911111 44.088889 44.088889-19.911111 44.088889-44.088889 44.088889zM512.711111 229.688889c0 17.066667 13.511111 31.288889 31.288889 31.288889 17.066667 0 31.288889-13.511111 31.288889-31.288889s-13.511111-31.288889-31.288889-31.288889c-17.066667 0-31.288889 14.222222-31.288889 31.288889zM301.511111 317.155556c0 17.066667 13.511111 31.288889 31.288889 31.288888s31.288889-13.511111 31.288889-31.288888c0-17.066667-13.511111-31.288889-31.288889-31.288889s-31.288889 14.222222-31.288889 31.288889zM213.333333 529.066667c0 17.066667 13.511111 31.288889 31.288889 31.288889s31.288889-13.511111 31.288889-31.288889c0-17.066667-13.511111-31.288889-31.288889-31.288889S213.333333 511.288889 213.333333 529.066667zM812.088889 529.066667c0 17.066667 13.511111 31.288889 31.288889 31.288889 17.066667 0 31.288889-13.511111 31.288889-31.288889 0-17.066667-13.511111-31.288889-31.288889-31.288889-17.066667 0-31.288889 13.511111-31.288889 31.288889zM724.622222 317.155556c0 17.066667 13.511111 31.288889 31.288889 31.288888 17.066667 0 31.288889-13.511111 31.288889-31.288888 0-17.066667-13.511111-31.288889-31.288889-31.288889-17.777778 0-31.288889 14.222222-31.288889 31.288889z" fill="#FE6E45" ></path></symbol><symbol id="icon-kuaisuxunzhaoyouzhiduanshipinkol" viewBox="0 0 1024 1024"><path d="M696.30906 948.120863c-5.156835 0-9.576978-2.210072-12.523741-7.366906-4.420144-6.630216-2.210072-16.207194 5.156835-19.890648 53.778417-33.151079 100.189928-78.825899 134.077698-131.867626 58.198561-92.823022 76.615827-202.589928 52.305035-308.673381-24.310791-106.820144-88.402878-197.433094-181.225899-255.631655-92.823022-58.935252-202.589928-77.352518-309.410072-53.041726s-197.433094 88.402878-255.631654 181.225899-76.615827 202.589928-52.305036 309.410072 88.402878 197.433094 181.225899 255.631655c6.630216 4.420144 8.840288 13.260432 4.420144 20.627338-4.420144 6.630216-13.260432 8.840288-20.627338 4.420144C142.317693 880.345324 73.805463 783.102158 47.2846 668.915108S41.391075 436.857554 103.273089 337.404317C232.930643 132.604317 504.769492 70.722302 709.569492 199.643165c99.453237 62.618705 167.965468 159.861871 194.486331 274.048921 25.784173 114.18705 5.893525 232.057554-55.988489 331.510792-36.097842 57.461871-85.456115 106.083453-143.654677 141.444604-2.946763 0.736691-5.156835 1.473381-8.103597 1.473381z" fill="#E8EEF9" ></path><path d="M457.62129 1024c-54.515108 0-147.338129-11.05036-147.338129-51.568345s92.823022-51.568345 147.338129-51.568346 147.338129 11.05036 147.33813 51.568346-92.823022 51.568345-147.33813 51.568345z m-117.133813-51.568345c8.103597 7.366906 47.148201 22.100719 117.133813 22.100719s109.030216-14.733813 117.133813-22.100719c-8.103597-7.366906-47.148201-22.100719-117.133813-22.10072s-109.030216 14.733813-117.133813 22.10072z m235.004317 1.473381z" fill="#F5F7FC" ></path><path d="M767.031362 44.201439h-29.467626V14.733813c0-8.103597-6.630216-14.733813-14.733813-14.733813s-14.733813 6.630216-14.733812 14.733813v29.467626h-29.467626c-8.103597 0-14.733813 6.630216-14.733813 14.733813s6.630216 14.733813 14.733813 14.733813h29.467626v29.467626c0 8.103597 6.630216 14.733813 14.733812 14.733813s14.733813-6.630216 14.733813-14.733813v-29.467626h29.467626c8.103597 0 14.733813-6.630216 14.733813-14.733813s-6.630216-14.733813-14.733813-14.733813zM973.304744 162.071942h-22.10072v-22.100719c0-8.103597-6.630216-14.733813-14.733813-14.733813s-14.733813 6.630216-14.733813 14.733813v22.100719h-22.100719c-8.103597 0-14.733813 6.630216-14.733813 14.733813s6.630216 14.733813 14.733813 14.733813h22.100719v22.10072c0 8.103597 6.630216 14.733813 14.733813 14.733813s14.733813-6.630216 14.733813-14.733813v-22.10072h22.10072c8.103597 0 14.733813-6.630216 14.733813-14.733813s-6.630216-14.733813-14.733813-14.733813z" fill="#D8DDE7" ></path><path d="M298.496111 520.103597c-7.366906 0-14.733813 7.366906-14.733813 14.733813s7.366906 14.733813 14.733813 14.733813 14.733813-7.366906 14.733812-14.733813-7.366906-14.733813-14.733812-14.733813zM331.64719 421.38705c-25.784173 14.733813-44.201439 40.517986-47.148202 72.932374v7.366907c0 7.366906 7.366906 11.05036 14.733813 11.05036s14.733813-7.366906 11.05036-14.733813v-3.683454c0-22.100719 14.733813-40.517986 33.151079-51.568345 11.05036 0 11.05036-11.05036 7.366906-18.417266-4.420144-2.946763-11.78705-6.630216-19.153956-2.946763z" fill="#FE6E45" ></path><path d="M671.998269 822.146763c-6.630216 0-13.997122-3.683453-21.364029-7.366907l-65.565468-54.515108c-6.630216-6.630216-10.313669-13.997122-10.313669-20.627338v-2.946763l-2.946762 2.210072c-39.781295 33.151079-91.34964 50.831655-145.128058 50.831655-63.355396 0-123.027338-24.310791-167.228777-69.248921-44.201439-44.201439-69.248921-103.873381-69.248921-167.228777s24.310791-123.027338 69.248921-167.228777S364.061578 316.776978 427.416974 316.776978s123.027338 24.310791 167.228777 69.248921 69.248921 103.873381 69.248921 167.228777c0 50.831655-15.470504 98.716547-47.148202 141.444605l-2.210072 2.946762h2.946763c6.630216 0 13.997122 3.683453 16.943885 6.630216L699.992513 758.791367c11.78705 15.470504 13.260432 33.151079 3.683454 45.67482l-7.366907 7.366907c-7.366906 7.366906-13.997122 10.313669-24.310791 10.313669zM597.592513 727.85036c-4.420144 4.420144-4.420144 8.840288 0 13.260431l65.565468 55.251799c2.210072 2.210072 4.420144 2.946763 6.630216 2.946763s4.420144-1.473381 6.630216-2.946763l8.103597-8.103597v-0.736691s0-4.420144-3.683453-15.470503v-0.736691l-67.038849-55.988489h-4.420144l-11.787051 12.523741zM426.680283 349.928058c-53.778417 0-104.610072 21.364029-142.917985 60.408633-39.044604 38.307914-60.408633 89.876259-60.408634 142.917985s21.364029 104.610072 60.408634 142.917986 89.876259 60.408633 142.917985 60.408633 104.610072-21.364029 142.917986-60.408633c38.307914-38.307914 60.408633-89.876259 60.408633-142.917986 0-53.778417-21.364029-104.610072-60.408633-142.917985-38.307914-39.044604-89.139568-60.408633-142.917986-60.408633z" fill="#FE6E45" ></path></symbol><symbol id="icon-yunjisuanxitongquanchenggenzong" viewBox="0 0 1024 1024"><path d="M616.757083 951.648161c-6.644557 0-12.550829-4.429704-14.027398-11.07426-2.214852-8.121125 2.953136-16.242249 11.074261-17.718818 6.644557-1.476568 13.289113-3.69142 20.671954-5.906273 107.789474-33.222783 195.645278-105.574621 248.801731-205.24297 52.418169-99.668349 63.49243-213.364095 30.269646-321.153569-2.214852-8.121125 2.214852-16.242249 9.597693-18.457102 8.121125-2.214852 16.242249 2.214852 18.457102 9.597693 35.437635 115.172314 23.62509 236.989185-32.484499 343.302091s-150.60995 184.571017-265.782264 219.270368c-7.382841 2.214852-14.765681 4.429704-22.148522 5.906272-2.214852 1.476568-3.69142 1.476568-4.429704 1.476568z m-516.798847-284.239365c-5.906273 0-11.812545-3.69142-14.027397-10.335977-38.390771-114.43403-29.531363-236.250901 24.363374-344.040375s146.180245-188.262437 260.614276-225.914924c15.503965-5.167988 31.007931-9.597693 47.25018-13.289113 8.121125-1.476568 15.503965 2.953136 17.718817 11.074261 1.476568 8.121125-2.953136 15.503965-11.074261 17.718817-14.765681 2.953136-29.531363 7.382841-43.55876 11.812545-220.008652 73.828407-339.610671 313.032444-265.782263 533.041096 2.953136 7.382841-1.476568 16.242249-9.597693 18.457102-2.953136 0.738284-4.429704 1.476568-5.906273 1.476568z" fill="#F3F6FC" ></path><path d="M508.967609 146.180245c-19.195386 0-37.652487-7.382841-51.679885-21.410238s-21.410238-31.746215-21.410238-51.679884C435.877486 32.484499 468.361985 0 508.229325 0s73.090123 32.484499 73.090122 72.351839c0.738284 40.605624-31.746215 73.090123-72.351838 73.828406 0.738284 0 0 0 0 0z m0-116.648882c-11.812545 0-22.886806 4.429704-31.007931 12.550829s-12.550829 19.195386-12.550829 30.269647c0 11.812545 4.429704 22.886806 12.550829 31.00793s19.195386 12.550829 30.269647 12.550829c23.62509 0 43.55876-19.93367 43.55876-43.558759 0.738284-23.62509-18.457102-42.820476-42.820476-42.820476z m0-14.765682zM508.967609 1024c-19.195386 0-37.652487-7.382841-51.679885-21.410238s-21.410238-31.746215-21.410238-51.679885c0-40.605624 32.484499-73.090123 72.351839-73.090122 40.605624 0 73.090123 32.484499 73.090122 72.351838 0 19.195386-7.382841 37.652487-21.410237 51.679885-12.550829 14.027397-31.007931 22.148522-50.941601 22.148522 0.738284 0 0 0 0 0z m0-116.648882c-24.363374 0-43.55876 19.195386-43.55876 43.558759 0 11.812545 4.429704 22.886806 12.550829 31.007931s19.195386 12.550829 30.269647 12.550829c11.812545 0 22.148522-4.429704 30.269647-12.550829 8.121125-8.121125 12.550829-19.195386 12.550829-31.007931s-4.429704-22.148522-12.550829-30.269646c-6.644557-8.859409-17.718818-13.289113-29.531363-13.289113z m0-14.765682z" fill="#D8DDE7" ></path><path d="M525.948142 778.88969c-22.148522 0-42.082192-14.027397-49.465032-35.437635h-59.062725v-28.793079H475.744826c5.167988-22.886806 26.578226-39.86734 50.203316-39.867339s44.297044 16.242249 50.203317 39.867339H748.90993v28.793079H575.413175c-7.382841 21.410238-27.31651 35.437635-49.465033 35.437635z m0-74.566691c-12.550829 0-23.62509 10.335977-23.62509 23.62509 0 12.550829 10.335977 23.62509 23.62509 23.625091s23.62509-10.335977 23.625091-23.625091c-0.738284-13.289113-11.074261-23.62509-23.625091-23.62509z m-212.625811 0c-28.793079 0-51.679885-22.886806-51.679884-51.679884s22.886806-51.679885 51.679884-51.679885c23.62509 0 44.297044 16.242249 50.203317 39.129056h101.144917v28.793078H362.04908c-6.644557 21.410238-26.578226 35.437635-48.726749 35.437635z m0-74.56669c-12.550829 0-23.62509 10.335977-23.62509 23.62509 0 12.550829 10.335977 23.62509 23.62509 23.62509s23.62509-10.335977 23.62509-23.62509c-0.738284-13.289113-11.074261-23.62509-23.62509-23.62509z m268.735401 39.129055v-28.793078h66.445565v28.793078h-66.445565zM417.420385 579.552992c-22.148522 0-36.175919 0-51.679885-0.738284-30.269647-1.476568-53.894737-4.429704-73.090122-9.597693-50.203317-14.027397-74.566691-44.297044-74.566691-93.023792 0-26.578226 7.382841-48.726748 21.410238-64.968998 12.550829-14.027397 30.269647-22.886806 50.9416-26.578226 4.429704-0.738284 9.597693-1.476568 14.027398-1.476569 1.476568-38.390771 23.62509-80.472963 58.324441-112.957462 37.652487-34.699351 85.640952-53.894737 135.844268-53.894737 4.429704 0 9.597693 0 14.765681 0.738285 56.847873 4.429704 104.836337 31.007931 131.414564 73.090122 6.644557 11.074261 11.812545 22.886806 15.503966 34.699351 43.55876 0 78.996395 13.289113 103.359769 37.652488 22.148522 22.886806 34.699351 55.371305 34.699351 93.023792 0 28.054795-8.121125 55.371305-22.148522 76.781543-20.671954 31.007931-55.371305 47.25018-98.930065 47.25018H417.420385zM309.630911 411.962509c-4.429704 0-9.597693 0-13.289113 0.738284-14.765681 2.214852-25.839942 8.121125-33.961067 16.980534-9.597693 11.074261-14.027397 25.839942-14.027397 45.773612 0 35.437635 15.503965 55.371305 53.894736 65.707282 16.980534 4.429704 37.652487 7.382841 66.445566 8.859408 15.503965 0.738284 28.793079 0.738284 50.941601 0.738284h34.699351-0.738284H488.295655c33.961067 0 63.49243-22.886806 90.070656-69.398702-11.074261-9.597693-16.980534-23.62509-16.980533-38.390771 0-28.793079 22.886806-51.679885 51.679884-51.679885 5.906273 0 11.074261 0.738284 16.980534 2.953136 13.289113-28.793079 11.074261-61.277578-6.644557-89.332372-21.410238-34.699351-62.015862-56.109589-110.004326-59.801009-4.429704 0-8.121125-0.738284-12.550829-0.738284-42.820476 0-84.164384 16.242249-115.910598 46.511896-30.269647 27.31651-48.726748 63.49243-50.203317 94.500361 16.980534 2.953136 33.222783 9.597693 46.511896 17.718817 9.597693-7.382841 20.671954-11.812545 33.222783-11.812545 28.793079 0 51.679885 23.62509 51.679885 51.679885s-22.886806 51.679885-51.679885 51.679884-51.679885-22.886806-51.679884-51.679884c0-5.906273 0.738284-11.074261 2.953136-16.24225-16.242249-8.859409-36.914203-14.765681-56.109589-14.765681z m369.142033 139.535689c34.699351 0 59.062725-11.074261 75.304975-34.699352 11.074261-16.242249 17.718818-38.390771 17.718818-60.539293 0-30.269647-8.859409-55.371305-26.578227-73.090123-18.457102-18.457102-44.297044-28.054795-78.996395-29.531362 0.738284 19.93367-3.69142 39.86734-13.289113 58.324441 7.382841 8.859409 11.074261 20.671954 11.074261 32.484499 0 28.793079-22.886806 51.679885-51.679885 51.679885-2.953136 0-5.906273 0-8.859409-0.738284-13.289113 23.62509-28.793079 42.820476-44.297044 56.847873l119.602019-0.738284z m-66.445566-131.414564c-12.550829 0-23.62509 10.335977-23.62509 23.62509s10.335977 23.62509 23.62509 23.62509c12.550829 0 23.62509-10.335977 23.62509-23.62509s-11.074261-23.62509-23.62509-23.62509z m-199.336698 0c-12.550829 0-23.62509 10.335977-23.62509 23.62509s10.335977 23.62509 23.62509 23.62509 23.62509-10.335977 23.62509-23.62509-10.335977-23.62509-23.62509-23.62509z" fill="#FE6E45" ></path><path d="M477.221394 717.612112c4.429704-22.886806 25.101658-39.86734 48.726748-39.867339 23.62509 0 44.297044 16.980534 48.726749 39.867339h172.020187v25.101659H573.198323c-6.644557 20.671954-25.101658 35.437635-47.250181 35.437635s-41.343908-14.765681-47.25018-35.437635h-59.062725v-25.101659h57.586157zM362.04908 642.307138h101.144917v25.101658H360.572512c-6.644557 20.671954-25.101658 35.437635-47.988465 35.437635-27.31651 0-50.203317-22.148522-50.203316-50.203316s22.148522-50.203317 50.203316-50.203317c24.363374 0.738284 44.297044 16.980534 49.465033 39.86734z m217.793799-160.945927c-11.074261-9.597693-17.718818-22.886806-17.718817-37.652487 0-27.31651 22.148522-50.203317 50.203316-50.203317 6.644557 0 12.550829 1.476568 17.718818 2.953137 14.027397-28.793079 11.812545-63.49243-6.644557-92.285509-21.410238-33.961067-61.277578-56.847873-110.74261-60.539293s-95.238645 14.027397-129.937995 46.511896c-31.007931 28.793079-49.465032 66.445566-50.203317 97.453497 17.718818 2.953136 34.699351 9.597693 48.726748 18.457101 8.859409-7.382841 19.93367-11.812545 32.484499-11.812545 27.31651 0 50.203317 22.148522 50.203317 50.203317s-22.148522 50.203317-50.203317 50.203316c-27.31651 0-50.203317-22.148522-50.203316-50.203316 0-5.906273 1.476568-11.812545 2.953136-17.718818-18.457102-11.812545-47.25018-18.457102-70.87527-14.765681-14.765681 2.214852-26.578226 8.121125-35.437635 17.718818-9.597693 11.074261-14.765681 26.578226-14.765682 47.25018 0 36.914203 16.980534 56.847873 54.633021 67.18385 17.718818 4.429704 39.129056 8.121125 67.18385 8.859409 21.410238 0.738284 39.86734 0.738284 84.902668 0.738284h34.699351c35.437635-0.738284 65.707282-23.62509 93.023792-72.351839z m22.886806 11.074261c-14.765681 25.839942-30.269647 46.511896-47.988464 60.539294h124.031723c36.175919 0 61.277578-12.550829 76.781543-35.437636 11.812545-17.718818 17.718818-40.605624 17.718818-62.015861 0-31.007931-9.597693-56.109589-26.578227-74.566691-18.457102-18.457102-45.773612-28.793079-81.949531-29.531362 0.738284 20.671954-3.69142 41.343908-14.027397 59.801009 7.382841 8.859409 11.812545 19.93367 11.812545 31.746215 0 27.31651-22.148522 50.203317-50.203317 50.203316-2.953136 0-6.644557 0-9.597693-0.738284zM487.557371 578.076424h-34.699351c-45.773612 0-64.230714 0-86.379236-0.738284-29.531363-1.476568-53.156453-4.429704-72.351838-9.597693-47.988464-13.289113-73.090123-42.820476-73.090123-91.547224 0-26.578226 7.382841-47.988464 21.410238-63.49243 12.550829-14.027397 30.269647-22.148522 50.203317-25.839942 5.167988-0.738284 10.335977-1.476568 15.503965-1.476568 1.476568-37.652487 22.886806-81.211247 58.324441-113.695747 39.86734-37.652487 92.285508-57.586157 148.395097-53.894736 57.586157 4.429704 104.836337 31.007931 130.67628 72.351838 7.382841 11.074261 12.550829 23.62509 15.503966 35.437635 44.297044 0 78.996395 12.550829 103.359769 37.652488 22.148522 22.886806 33.961067 54.633021 33.961067 91.547224 0 25.839942-6.644557 53.156453-22.148522 75.304975-19.93367 29.531363-52.418169 46.511896-97.453497 46.511896l-191.215573 1.476568z m95.976929 89.332372V642.307138h62.754145v25.101658h-62.754145zM412.99068 468.810382c14.027397 0 25.101658-11.074261 25.101659-25.101658s-11.074261-25.101658-25.101659-25.101658-25.101658 11.074261-25.101658 25.101658 11.812545 25.101658 25.101658 25.101658z m199.336698 0c14.027397 0 25.101658-11.074261 25.101658-25.101658s-11.074261-25.101658-25.101658-25.101658-25.101658 11.074261-25.101658 25.101658 11.074261 25.101658 25.101658 25.101658z m-86.379236 283.501082c14.027397 0 25.101658-11.074261 25.101659-25.101659s-11.074261-25.101658-25.101659-25.101658-25.101658 11.074261-25.101658 25.101658 11.074261 25.101658 25.101658 25.101659zM313.322331 677.744773c14.027397 0 25.101658-11.074261 25.101659-25.101658S327.349729 627.541456 313.322331 627.541456s-25.101658 11.074261-25.101658 25.101659 11.074261 25.101658 25.101658 25.101658z" fill="#FE6E45" ></path></symbol><symbol id="icon-shichangfenxi" viewBox="0 0 1024 1024"><path d="M517.12 915.456c-92.16 0-184.832 0.512-276.992-0.512-10.752 0-22.016-1.536-32.768-5.632-17.408-6.144-30.208-17.408-39.424-32.768-6.656-11.264-11.264-23.04-11.776-36.864-4.096-74.752-0.512-149.504-1.536-224.768 0-5.632-2.048-9.728-6.144-12.288-17.92-11.776-32.256-27.136-44.544-44.032-6.144-8.704-11.264-17.92-15.872-27.648-5.12-11.264-9.216-23.04-12.8-34.816-2.56-8.192-3.072-16.896-4.096-25.088-0.512-4.608-1.024-9.216-1.536-13.312-2.048-16.896 2.048-33.792 5.12-50.176 2.048-11.776 5.12-23.552 11.776-33.792 3.072-5.12 4.096-11.264 6.144-16.384 1.536-4.096 3.072-7.68 5.12-11.776 4.096-9.216 8.192-17.92 12.288-27.136 3.584-8.192 6.656-16.896 10.24-25.6 4.096-9.728 8.704-19.456 12.288-29.184 3.584-9.216 7.168-18.432 11.264-28.16 3.072-8.192 6.656-15.872 10.24-23.552 2.56-5.632 5.12-10.752 7.168-16.384 6.656-16.896 16.896-30.72 31.744-41.472 10.24-7.68 21.504-13.312 33.792-16.896 8.192-2.56 16.384-3.072 25.088-4.608 6.144-1.024 12.8-1.536 18.944-1.536h500.736c7.68 0 15.36 1.536 23.04 3.072 8.704 1.536 16.896 3.072 25.088 6.144 7.68 2.56 14.336 7.168 21.504 11.264 12.8 7.68 22.528 18.944 30.208 31.232 4.608 7.168 7.68 15.36 10.752 23.552 2.56 6.656 5.12 12.8 7.68 19.456 2.048 5.12 4.096 10.752 6.144 15.872 2.56 6.144 5.12 12.8 7.68 18.944 2.048 5.632 4.608 11.264 6.656 16.896 2.56 5.632 4.608 11.776 7.168 17.408 2.048 4.096 3.584 8.704 5.632 12.8l10.752 29.184c3.584 9.728 8.192 18.944 11.776 28.16l6.144 16.896c2.56 7.68 5.12 15.872 7.68 23.552 0.512 1.024 0.512 1.536 0.512 2.56 2.048 17.408 6.144 35.328 3.584 53.248-2.048 12.288-1.024 25.088-6.144 37.376-4.608 10.24-6.144 21.504-10.752 31.232-9.728 19.456-20.992 37.888-37.376 52.736-8.704 8.192-17.92 15.36-27.136 23.552-2.048 2.048-3.584 5.12-3.584 7.68v216.576c0 11.776-1.536 23.552-6.656 34.304-4.608 10.24-11.264 19.456-19.456 27.648-8.704 8.704-19.456 12.8-29.696 18.432-1.024 0.512-1.536 0.512-2.56 0.512-12.288 1.024-24.064 3.072-36.352 3.072-88.064 1.024-177.664 1.024-266.752 1.024z m1.536-749.568H266.752c-15.872 0-31.232 2.048-45.056 10.24-5.632 3.584-11.264 7.68-16.384 12.288-9.728 9.216-13.824 20.992-18.432 33.28-2.048 4.608-3.584 9.728-6.144 14.336-4.096 9.216-8.192 17.92-12.288 27.136-4.096 9.216-7.68 18.944-11.776 28.16-3.584 8.704-7.68 17.408-11.264 26.112-2.048 5.632-4.096 11.264-6.656 16.384-5.632 12.8-11.264 25.088-16.384 37.888-4.096 9.728-8.192 19.456-11.776 29.696-3.072 9.216-5.632 18.944-6.656 28.672-1.024 9.216-0.512 18.432-0.512 27.648 0 7.168 0.512 14.336 2.048 20.992 1.536 7.68 4.096 15.872 7.168 23.04 3.072 8.704 6.144 17.92 11.264 25.6 7.168 10.752 14.848 20.992 23.552 30.72 8.704 9.728 19.456 16.896 30.208 24.064 12.288 7.68 25.6 12.8 39.424 16.384 10.752 2.56 21.504 3.072 32.768 4.608 15.872 2.048 30.72-2.048 45.568-5.12 13.824-3.072 26.624-8.704 38.912-16.384 13.824-8.704 27.136-17.92 37.376-30.72 8.192-10.24 19.456-11.264 29.184-2.56 2.56 2.56 4.608 5.632 7.168 8.192 12.8 11.776 26.112 23.04 42.496 29.696 10.24 4.096 20.48 9.728 31.744 12.288 15.36 3.584 31.232 6.144 47.104 4.608 8.704-1.024 17.92-2.048 26.112-4.608 13.312-4.096 26.624-9.216 38.4-16.384 13.824-8.704 27.136-18.432 37.376-31.232 7.68-9.728 20.48-10.24 29.184-1.536l10.24 10.24c11.264 11.264 24.064 20.48 38.912 27.648 8.192 4.096 16.896 7.68 25.6 9.728 11.776 3.072 24.576 5.632 36.864 6.656 18.432 1.536 36.864-2.048 54.784-7.168 15.36-4.096 29.184-11.776 41.984-20.992 22.528-16.896 39.936-38.4 51.2-64.512 5.632-13.312 9.728-27.136 11.264-40.96 3.584-27.648-0.512-54.272-11.776-80.384-5.12-11.776-9.728-23.552-14.336-35.84-1.536-4.096-3.584-8.704-5.12-12.8-3.584-9.216-7.168-18.944-10.752-28.16-3.584-9.728-8.192-18.944-11.776-28.16-3.584-9.728-7.168-18.944-10.752-28.672-1.536-4.608-3.584-8.704-5.12-12.8-2.56-6.656-5.12-13.312-7.68-19.456-3.584-8.192-7.168-16.384-11.776-23.552-7.168-11.264-16.896-19.968-30.208-24.576-8.192-3.072-16.896-6.144-25.6-7.68-7.68-1.536-15.872-0.512-24.064-0.512-82.432-1.536-162.816-1.536-243.712-1.536z m-1.536 716.288h269.312c9.216 0 17.92-0.512 26.624-3.584 14.848-5.12 23.552-15.872 28.672-28.672 3.584-8.704 4.096-18.432 4.096-27.648 0.512-62.976 0-125.952 0-188.928 0-6.656-2.56-8.192-8.192-6.656-9.216 3.072-18.432 6.144-27.648 7.168-16.384 1.536-32.768 1.024-49.152 1.536-13.312 0.512-26.112-3.072-38.912-6.656-9.728-2.56-19.456-7.68-28.672-11.776-15.872-6.656-29.696-16.384-41.984-28.16-3.072-2.56-6.656-4.096-10.24-0.512-10.752 10.752-23.04 18.944-35.84 26.112-7.68 4.608-16.384 7.68-24.576 10.752-7.168 2.56-14.848 3.072-22.016 6.144-9.728 4.608-20.48 4.096-30.72 4.096-19.456 0-38.912 2.048-57.856-4.608-7.168-2.56-15.36-4.096-22.528-6.656-8.192-3.072-15.872-7.168-23.04-11.776-10.752-6.656-20.992-14.336-31.232-22.016-4.608-3.584-8.704-4.096-13.312 0-5.12 4.608-10.24 8.704-15.36 12.8-14.848 10.24-30.208 18.432-47.616 24.064-12.8 4.096-25.6 8.192-39.424 8.704-5.12 0-10.24-0.512-14.336 1.024-5.12 2.048-9.728 1.536-14.848 0-2.048-0.512-4.096-1.024-6.656-1.024-16.896 0.512-33.28-2.56-49.152-8.192-3.584-1.024-5.12 0-6.144 3.072-0.512 1.536-0.512 3.584-0.512 5.632v194.048c0 11.776 4.096 22.528 10.752 31.744 10.24 14.336 24.576 20.48 41.984 20.48 93.696-0.512 186.368-0.512 278.528-0.512z" fill="" ></path><path d="M517.12 371.712h247.808c5.12 0 10.24 0 15.36 0.512 6.656 0 12.288 4.608 13.824 10.24 2.048 7.168 0 15.872-6.144 18.944-3.584 1.536-8.192 2.048-12.288 2.048H260.096c-2.56 0-5.632-0.512-8.192-0.512-9.728-0.512-11.776-6.656-12.8-13.312-1.024-9.216 4.096-17.408 14.336-17.408 7.68 0 14.848-0.512 22.528-0.512H517.12z" fill="" ></path></symbol><symbol id="icon-jingpinfenxi" viewBox="0 0 1024 1024"><path d="M895.488 310.272c0-19.968-12.288-44.544-28.16-55.808L591.872 50.688c8.704-3.072 17.92-5.12 28.16-5.12 15.872 0 31.232 4.608 41.984 12.8L890.88 226.816c24.064 17.408 44.032 56.832 44.032 86.528v477.696c0 32.256-14.336 62.976-38.912 83.456V310.272h-0.512z" fill="#252525" ></path><path d="M227.84 976.896c-76.288 0-138.24-61.44-138.24-137.216V361.984c0-38.912 25.6-86.016 58.368-107.52l261.12-172.032c16.384-10.752 37.376-16.896 59.904-16.896 22.528 0 43.52 6.144 59.392 16.896l255.488 172.032c32.256 21.504 57.344 68.608 57.344 107.52V839.68c0 36.352-13.824 70.656-39.424 96.256-26.112 26.112-60.928 40.96-98.304 40.96H227.84zM468.992 102.4c-15.36 0-29.184 3.584-39.424 10.752l-261.12 172.032c-20.992 13.312-39.936 47.616-41.984 73.728V839.68c0 55.296 45.568 100.352 101.376 100.352h476.16c55.808 0 101.376-45.056 101.376-100.352V361.984c0-26.624-19.456-62.464-41.472-77.312L508.416 112.64c-10.24-6.656-24.064-10.24-39.424-10.24z m-1.536 417.792c-75.776 0-137.728-61.952-137.728-137.728s61.952-137.728 137.728-137.728 137.728 61.952 137.728 137.728c0 75.776-61.952 137.728-137.728 137.728z m0-238.592c-55.808 0-100.864 45.056-100.864 100.864s45.056 100.864 100.864 100.864S568.32 438.272 568.32 382.464 523.264 281.6 467.456 281.6z" fill="#252525" ></path></symbol><symbol id="icon-yonghufenxi" viewBox="0 0 1024 1024"><path d="M854.016 957.44c-3.072 0-6.144-1.024-8.704-3.072l-1.536-1.024-1.536-0.512c-5.632-2.048-9.216-7.168-9.216-13.312 0-3.584 1.024-6.656 3.584-9.216l3.072-3.584-0.512-4.608c-10.752-90.624-87.04-158.72-178.176-158.72-31.744 0-62.464 8.192-90.112 24.064-2.048 1.024-4.608 2.048-7.168 2.048-1.024 0-2.56 0-3.584-0.512l-7.68-2.048-2.048-7.68c-1.536-6.144 1.024-12.288 6.656-15.36 6.144-3.584 12.288-6.656 18.432-9.216l15.872-7.168-14.336-10.24c-6.144-4.608-11.776-9.216-17.408-14.848-2.56-2.56-4.096-6.144-4.096-9.728s1.536-7.168 4.096-9.728 6.144-4.096 9.728-4.096 7.168 1.536 9.728 4.096c20.992 20.992 48.64 32.768 78.336 33.792h5.632c62.464-1.536 112.64-53.248 112.64-115.2 0-63.488-51.712-115.2-115.2-115.2-33.28 0-64.512 14.336-86.528 38.912-2.56 3.072-6.656 4.608-10.24 4.608s-6.656-1.024-9.216-3.584-4.608-5.632-4.608-9.728c0-3.584 1.024-7.168 3.584-10.24 27.136-30.72 66.048-48.64 107.52-48.64 78.848 0 142.848 64 142.848 142.848 0 45.568-22.016 89.088-59.392 115.712l-14.336 10.24 15.872 7.168c63.488 28.672 108.032 87.04 119.296 155.648l2.048 13.824 12.288-6.144c25.6-12.8 41.472-38.4 41.472-67.584V181.76c0-38.912-28.672-80.384-71.68-80.384H181.248c-40.96 0-78.336 38.4-78.336 80.384v254.464h156.672L384 304.128c2.56-2.56 6.144-4.096 9.728-4.608 4.096 0 7.168 1.536 10.24 4.096L522.24 419.328 769.536 168.96c2.56-2.56 6.144-4.096 9.728-4.096h0.512c4.096 0 7.68 2.048 10.24 4.608L920.576 317.44l-14.336 8.704c-2.048 1.024-4.608 2.048-7.168 2.048-4.096 0-7.68-1.536-10.752-4.608L778.752 199.68 532.48 448.512c-2.56 2.56-6.144 4.096-9.728 4.096s-7.168-1.536-9.728-4.096L394.24 333.312 275.456 459.776c-2.56 2.56-6.144 4.096-10.24 4.096H102.4V849.92c0 39.936 34.816 74.752 75.776 75.264h9.216l1.024-9.216c9.216-70.656 55.296-132.608 120.32-162.304l15.872-7.168-14.336-10.24c-37.376-27.136-59.392-70.144-59.392-115.712 0-78.848 64-142.848 142.848-142.848s142.848 64 142.848 142.848c0 45.568-22.016 89.088-59.392 115.712l-14.336 10.24 15.872 7.168c19.456 8.704 37.376 20.48 53.248 35.328l8.704 7.68 7.68 8.704c33.792 37.888 52.224 87.04 52.224 137.216 0 7.68-6.144 13.824-13.824 13.824s-13.824-6.144-13.824-13.824c0-98.816-80.384-179.712-179.712-179.712S215.04 844.288 215.04 943.104c0 7.68-6.144 13.824-13.824 13.824-3.072 0-6.144-1.024-8.704-3.072l-4.096-3.072-5.12 1.536c-1.024 0.512-2.56 0.512-4.096 0.512-57.856 0-104.96-46.08-104.96-102.912V181.76c0-57.856 49.664-108.544 106.496-108.544H849.92c54.784 0 99.84 48.64 99.84 108.544V849.92c0 48.128-33.792 90.624-80.896 100.864l-2.56 0.512-2.048 2.048c-3.072 2.56-6.656 4.096-10.24 4.096zM394.24 505.344c-63.488 0-115.2 51.712-115.2 115.2s51.712 115.2 115.2 115.2 115.2-51.712 115.2-115.2S457.728 505.344 394.24 505.344z" fill="" ></path></symbol><symbol id="icon-hangyefenxi" viewBox="0 0 1024 1024"><path d="M936.96 943.616H87.04c-12.288 0-23.04-10.24-23.04-23.04s10.24-22.528 23.04-22.528h850.432c12.8 0 23.04 10.24 23.04 22.528-0.512 12.8-10.752 23.04-23.552 23.04zM330.24 292.352H246.272c-12.288 0-22.528-10.24-22.528-23.04s10.24-22.528 22.528-22.528h84.48c12.8 0 23.04 10.24 23.04 22.528-0.512 12.8-10.752 23.04-23.552 23.04z m182.784 0H428.544c-12.8 0-22.528-10.24-22.528-23.04s10.24-22.528 22.528-22.528h84.48c12.8 0 23.04 10.24 23.04 22.528-0.512 12.8-10.24 23.04-23.04 23.04z m200.704 238.592V446.976c0-12.288 10.24-23.04 23.04-23.04s23.04 10.24 23.04 23.04v84.48c0 12.8-10.24 23.04-23.04 23.04s-23.04-10.752-23.04-23.552z m0 228.352v-84.48c0-12.8 10.24-22.528 23.04-22.528s23.04 10.24 23.04 22.528v84.48c0 12.8-10.24 22.528-23.04 22.528s-23.04-9.728-23.04-22.528zM330.24 495.104H246.272c-12.288 0-22.528-10.24-22.528-22.528 0-12.8 10.24-23.04 22.528-23.04h84.48c12.8 0 23.04 10.24 23.04 23.04-0.512 12.288-10.752 22.528-23.552 22.528z m182.784 0H428.544c-12.8 0-22.528-10.24-22.528-22.528 0-12.8 10.24-23.04 22.528-23.04h84.48c12.8 0 23.04 10.24 23.04 23.04-0.512 12.288-10.24 22.528-23.04 22.528z m-182.784 202.752H246.272c-12.288 0-22.528-10.24-22.528-22.528 0-12.8 10.24-23.04 22.528-23.04h84.48c12.8 0 23.04 10.24 23.04 23.04-0.512 12.288-10.752 22.528-23.552 22.528z m182.784 0H428.544c-12.8 0-22.528-10.24-22.528-22.528 0-12.8 10.24-23.04 22.528-23.04h84.48c12.8 0 23.04 10.24 23.04 23.04-0.512 12.288-10.24 22.528-23.04 22.528z m-395.776 223.232v-773.12c0-37.376 30.72-68.096 68.096-68.096h386.56c37.376 0 68.096 30.72 68.096 68.096v757.248c0 12.8-10.24 23.04-22.528 23.04-12.8 0-23.04-10.24-23.04-23.04V147.968c0-12.288-10.24-22.528-22.528-22.528H185.344c-12.288 0-22.528 10.24-22.528 22.528v772.608h-45.568m503.296-628.224h209.408c37.376 0 68.096 30.72 68.096 68.096v548.864c0 12.8-10.24 23.04-22.528 23.04-12.8 0-23.04-10.24-23.04-23.04V360.448c0-12.288-10.24-22.528-22.528-22.528h-209.408v-45.568z"  ></path></symbol><symbol id="icon-zishenfenxiyouxi" viewBox="0 0 1366 1024"><path d="M809.472 970.752h-274.432c-194.56 0-354.304-159.744-354.304-354.304s159.744-354.304 354.304-354.304h96.256c10.24 0 18.432-8.192 18.432-18.432V40.96c0-12.288 8.192-20.48 20.48-20.48s20.48 8.192 20.48 20.48v202.752c0 32.768-26.624 59.392-59.392 59.392h-96.256c-172.032 0-313.344 141.312-313.344 313.344s141.312 313.344 313.344 313.344h274.432c172.032 0 313.344-141.312 313.344-313.344s-141.312-313.344-313.344-313.344c-12.288 0-20.48-8.192-20.48-20.48s8.192-20.48 20.48-20.48c194.56 0 354.304 159.744 354.304 354.304s-157.696 354.304-354.304 354.304z"  ></path><path d="M475.648 735.232c-65.536 0-118.784-53.248-118.784-118.784s53.248-118.784 118.784-118.784 118.784 53.248 118.784 118.784-53.248 118.784-118.784 118.784z m0-196.608c-43.008 0-77.824 34.816-77.824 77.824s34.816 77.824 77.824 77.824 77.824-34.816 77.824-77.824-34.816-77.824-77.824-77.824zM752.128 616.448c0 21.504 17.408 38.912 38.912 38.912s38.912-17.408 38.912-38.912c0-21.504-17.408-38.912-38.912-38.912s-38.912 17.408-38.912 38.912zM875.008 616.448c0 21.504 17.408 38.912 38.912 38.912s38.912-17.408 38.912-38.912c0-21.504-17.408-38.912-38.912-38.912s-38.912 17.408-38.912 38.912z"  ></path></symbol><symbol id="icon-weishangzishenfenxi" viewBox="0 0 1024 1024"><path d="M189.44 902.144c-37.376 0-67.584-30.208-67.584-67.584 0-2.048 0-3.584 0.512-5.12l53.248-428.544v-0.512c2.048-35.84 31.744-64.512 67.584-64.512H363.52v-66.56c0-81.92 66.56-148.48 148.48-148.48s148.48 66.56 148.48 148.48v66.56h120.32c36.352 0 66.048 28.16 67.584 64.512v0.512l53.248 428.032c0 1.024 0.512 3.072 0 4.608v0.512c0 37.376-30.208 67.584-67.584 67.584H189.44v0.512z m-39.936-68.608v1.024c0 22.016 17.92 39.936 39.936 39.936h645.12c22.016 0 39.936-17.92 39.936-39.936v-1.024l-53.76-430.08c-0.512-21.504-17.92-38.912-39.424-38.912h-537.6c-21.504 0-39.424 17.408-39.936 38.912l-54.272 430.08zM512 149.504c-66.56 0-120.32 53.76-120.32 120.32v66.56h240.64v-66.56c0-66.048-54.272-120.32-120.32-120.32z" fill="" ></path><path d="M553.472 637.44c0 10.24 8.192 18.432 18.432 18.432s18.432-8.192 18.432-18.432-8.192-18.432-18.432-18.432-18.432 8.192-18.432 18.432z m99.84 1.024c0 10.24 8.192 18.432 18.432 18.432s18.432-8.192 18.432-18.432-8.192-18.432-18.432-18.432c-10.24-0.512-18.432 8.192-18.432 18.432z m-285.184-124.928c0 8.192 4.096 15.36 11.264 19.456 7.168 4.096 15.872 4.096 22.528 0 7.168-4.096 11.264-11.776 11.264-19.456s-4.096-15.36-11.264-19.456c-7.168-4.096-15.872-4.096-22.528 0-6.656 4.096-11.264 11.264-11.264 19.456z m122.368 1.024c0 12.288 10.24 22.528 22.528 22.528s22.528-10.24 22.528-22.528-10.24-22.528-22.528-22.528-22.528 9.728-22.528 22.528z" fill="" ></path><path d="M769.024 625.664c-8.192-16.384-19.456-31.232-34.304-44.032-26.624-22.528-60.416-36.352-97.28-39.424-2.56-12.288-6.656-24.576-12.288-36.352-9.728-18.944-23.04-36.352-40.448-51.2-35.328-29.696-82.432-46.08-131.584-46.08-49.664 0-96.768 16.384-131.584 46.08-17.408 14.848-31.232 31.744-40.448 51.2-10.24 19.968-14.848 40.96-14.848 63.488 0 22.016 5.12 43.52 14.848 63.488 7.168 14.848 17.408 28.16 29.184 40.448 0 0 11.264 11.776 13.824 14.336l-12.288 46.592c-1.536 5.12 0.512 10.752 4.608 14.336 2.56 2.048 6.144 3.584 9.216 3.584 2.048 0 3.584-0.512 5.632-1.024l66.048-27.648c6.656 1.024 6.656 1.024 12.288 2.048 14.336 3.072 29.184 4.608 44.032 4.608 7.168 0 14.336-0.512 21.504-1.024l1.536 3.072c8.192 16.384 19.456 31.232 34.304 44.032 29.696 25.6 69.632 39.936 111.616 40.448 16.896 0 33.28-2.048 49.152-6.144l51.712 22.528c1.536 0.512 3.072 1.024 4.608 1.024 2.56 0 5.632-1.024 7.68-2.56 3.584-3.072 5.12-7.168 4.096-11.776l-9.216-37.376c1.536-1.024 3.072-2.56 4.608-3.584 14.848-12.288 26.624-27.136 34.816-43.52 8.704-16.896 13.312-35.328 13.312-53.76-2.048-20.48-6.144-38.912-14.336-55.808z m-316.416 78.336c-15.36 0-30.72-2.048-45.056-5.12-2.56-0.512-5.12-1.536-7.68-2.048-3.584-2.048-8.192-2.56-12.8-1.024l-41.472 17.408 2.048-8.704c1.024-2.56 3.072-10.24 4.608-16.384 0.512-1.536 0.512-2.56 0.512-4.096 0.512-2.56 0-5.632-1.536-7.68v-0.512c-0.512-0.512-0.512-1.536-1.024-2.048-3.584-4.608-9.216-7.168-13.312-10.752-5.12-4.608-9.728-8.704-14.848-14.336-19.968-22.528-31.744-50.176-31.744-80.384 0-74.752 72.704-135.68 162.816-135.68 78.336 0 144.384 46.592 159.232 108.544-37.888 2.048-73.216 15.36-100.864 38.4-14.848 12.288-26.624 27.136-34.816 43.52-8.704 16.896-13.312 35.328-13.312 53.76 0 9.216 1.024 17.92 2.56 26.624-4.608 0.512-9.216 0.512-13.312 0.512z m265.216 55.296c-3.584 3.072-8.192 5.12-11.264 8.704-0.512 0.512-0.512 1.024-1.024 1.536v0.512c-1.024 2.048-1.536 4.096-1.024 6.144 0 1.024 0 2.048 0.512 3.584 1.024 5.12 3.072 11.264 3.584 13.824l1.536 7.168-34.304-14.848c-3.584-1.536-7.68-1.024-10.752 0.512-14.336 4.096-27.136 5.632-43.52 5.632-74.752-0.512-135.168-51.712-135.168-114.688 0.512-62.464 61.952-113.152 136.704-112.64s135.68 52.224 135.168 114.688c-0.512 31.232-15.872 59.392-40.448 79.872z" fill="" ></path></symbol><symbol id="icon-qq" viewBox="0 0 1024 1024"><path d="M175.061333 574.037333c-28.458667 70.912-33.194667 138.496-10.24 151.04 15.829333 8.746667 40.533333-11.221333 63.786667-47.488 9.216 39.722667 31.914667 75.392 64.426667 104.192-34.048 13.226667-56.32 34.944-56.32 59.434667 0 40.362667 60.202667 72.96 134.485333 72.96 66.986667 0 122.496-26.453333 132.736-61.354667h15.957333c10.410667 34.858667 65.792 61.312 132.906667 61.312 74.325333 0 134.442667-32.597333 134.442667-72.96 0-24.448-22.229333-45.952-56.32-59.392 32.341333-28.8 55.253333-64.426667 64.426666-104.192 23.210667 36.266667 47.786667 56.234667 63.701334 47.488 23.04-12.544 18.432-80.128-10.24-151.04-22.485333-55.466667-52.906667-96.426667-76.117334-105.642666a111.317333 111.317333 0 0 0-14.933333-68.224c0.213333-1.28 0.213333-2.517333 0.213333-3.84a62.293333 62.293333 0 0 0-6.058666-27.093334c-5.845333-144.469333-95.232-259.413333-239.957334-259.413333-144.682667 0-234.197333 114.944-240.042666 259.413333a64.554667 64.554667 0 0 0-5.930667 31.061334 112.384 112.384 0 0 0-15.274667 57.472c0 3.626667 0.170667 7.253333 0.426667 10.794666-23.125333 9.088-53.674667 50.005333-76.074667 105.472z"  ></path></symbol><symbol id="icon-baojiahunluanxunjialei" viewBox="0 0 1024 1024"><path d="M251.70385 600.450148h177.911155c15.162883 0 25.271471 10.108588 25.271471 25.271471 0 10.108588-10.108588 20.217177-25.271471 25.271471H251.70385c-15.162883 0-25.271471-10.108588-25.271471-25.271471 5.054294-15.162883 15.162883-25.271471 25.271471-25.271471zM226.432379 316.398815c0-15.162883 10.108588-25.271471 25.271471-25.27147h406.365252c15.162883 0 25.271471 10.108588 25.271471 25.27147s-10.108588 25.271471-25.271471 25.271471H251.70385c-10.108588 0-25.271471-10.108588-25.271471-25.271471zM510.483712 488.244817H251.70385c-15.162883 0-25.271471-10.108588-25.271471-25.271471s10.108588-25.271471 25.271471-25.27147h258.779862c15.162883 0 25.271471 10.108588 25.271471 25.27147s-10.108588 25.271471-25.271471 25.271471z"  ></path><path d="M774.317868 437.701876c-10.108588 0-20.217177-5.054294-20.217177-15.162883V178.922014c0-20.217177-15.162883-30.325765-30.325765-30.325765H196.106614c-20.217177 0-30.325765 10.108588-30.325765 30.325765v623.699901c0 20.217177 15.162883 30.325765 30.325765 30.325765h294.159921c13.141165 2.021718 15.162883 16.173741 15.162883 26.28233s-5.054294 25.271471-15.162883 25.271471H180.943731c-35.380059 0-65.705824-30.325765-65.705824-65.705825V163.759131c0-35.380059 30.325765-65.705824 65.705824-65.705824H734.894373c35.380059 0 65.705824 30.325765 65.705824 65.705824v259.790721c0 12.130306-15.162883 14.152024-26.282329 14.152024z"  ></path><path d="M718.720632 897.642646c-114.227048 0-207.226061-92.999013-207.226061-207.226062s92.999013-207.226061 207.226061-207.226061S925.946693 576.189536 925.946693 690.416584s-94.009872 207.226061-207.226061 207.226062z m0-374.017769c-91.988154 0-167.802567 74.803554-167.802567 167.802566S625.721619 859.23001 718.720632 859.23001 886.523198 784.426456 886.523198 691.427443s-75.814413-167.802567-167.802566-167.802566z"  ></path><path d="M793.524186 607.52616l-46.499507 84.912142h33.358342v24.260612h-40.434354V737.92695h40.434354v24.260612h-40.434354v35.380059h-38.412635v-35.380059h-42.456071V737.92695h42.456071v-21.228036h-42.456071v-24.260612h34.3692l-45.488648-84.912142h40.434354l33.358341 75.814413c1.010859-3.032577 3.032577-7.076012 5.054294-12.130306l27.293189-63.684107h39.423495z"  ></path></symbol><symbol id="icon-baojiaguifan" viewBox="0 0 1024 1024"><path d="M277.384248 635.417661c-7.331742 0-14.663484 8.14638-19.551312 20.365951 0.814638 11.404932 7.331742 17.922037 19.551312 17.922036h179.220366c12.21957-4.07319 20.365951-12.21957 20.365951-19.551312 0-12.21957-7.331742-19.551313-19.551313-19.551313H277.384248zM689.59109 320.967383H277.384248c-12.21957 0-19.551313 7.331742-19.551312 19.551312 0 10.590294 11.404932 19.551313 19.551312 19.551313h411.392204c12.21957 0 19.551313-7.331742 19.551313-19.551313s-7.331742-19.551313-18.736675-19.551312zM540.512331 470.86078H277.384248c-12.21957 0-19.551313 7.331742-19.551312 19.551312s7.331742 19.551313 19.551312 19.551313h262.313445c12.21957 0 19.551313-7.331742 19.551313-19.551313s-7.331742-19.551313-18.736675-19.551312z"  ></path><path d="M766.981702 125.454256H205.696102c-32.585521 0-60.283214 27.697693-60.283214 60.283214v663.929992c0 32.585521 27.697693 60.283214 60.283214 60.283214h313.63564c4.887828 0 8.14638-10.590294 8.146381-19.551312 0-16.292761-4.887828-19.551313-8.961019-20.365951H221.174224c-18.736675 0-37.473349-13.034208-37.473349-37.473349V201.215593c0-24.439141 13.034208-37.473349 37.473349-37.47335H756.391408c18.736675 0 37.473349 13.034208 37.473349 37.47335V448.050915c0 7.331742 8.961018 8.961018 13.848847 8.961018 13.034208 0 19.551313-2.443914 19.551312-8.14638V185.73747c0-32.585521-27.697693-60.283214-60.283214-60.283214z"  ></path><path d="M752.318218 922.984885c-111.60541 0-202.844869-91.239459-202.844869-202.844869s91.239459-202.844869 202.844869-202.844869 202.844869 91.239459 202.844869 202.844869c-0.814638 112.420048-91.239459 202.844869-202.844869 202.844869z m0-379.621321c-97.756563 0-176.776452 79.019889-176.776452 176.776452s79.019889 176.776452 176.776452 176.776452 176.776452-79.019889 176.776452-176.776452c0-96.941925-79.834527-176.776452-176.776452-176.776452z"  ></path><path d="M819.933174 639.490851H788.976929l-26.883055 62.727128c-2.443914 5.702466-4.07319 9.775656-4.887828 12.219571l-0.814638 2.443914h-4.887828l-33.400159-77.390613h-33.400159L730.322991 725.027844h-37.473349v17.922037h42.361177v27.697693h-42.361177v17.922036h42.361177v35.844073h32.585521v-35.844073h41.54654v-17.922036h-41.54654v-27.697693h41.54654V725.027844H772.684169l47.249005-85.536993z"  ></path></symbol><symbol id="icon-liuliangfensanzhaohaolei" viewBox="0 0 1024 1024"><path d="M504.220323 119.612536h-23.339031c-100.163343 2.917379-193.519468 44.733143-263.536563 116.695156C147.327635 308.269706 108.42925 402.598291 108.42925 503.734093c0 211.996201 172.125356 384.121557 384.121557 384.121558 101.135802 0 197.409307-38.898386 269.37132-110.860399 71.962013-70.989554 112.805318-166.290598 114.750238-267.426401v-11.669516C875.699905 398.708452 835.82906 304.379867 765.811966 233.390313A382.565622 382.565622 0 0 0 504.220323 119.612536z m326.746439 384.121557c0 45.705603-8.752137 89.466287-26.256411 131.282051-17.504274 39.870845-41.815764 76.824311-72.934473 107.94302-31.118708 31.118708-67.099715 55.430199-107.94302 72.934473-41.815764 17.504274-85.576448 26.25641-131.282051 26.25641-45.705603 0-89.466287-8.752137-131.282051-26.25641-39.870845-17.504274-76.824311-41.815764-107.94302-72.934473-31.118708-31.118708-55.430199-67.099715-72.934473-107.94302C163.859449 593.20038 154.134853 549.439696 154.134853 503.734093c0-45.705603 8.752137-89.466287 26.25641-131.282051 17.504274-39.870845 41.815764-76.824311 72.934473-107.94302 31.118708-31.118708 67.099715-55.430199 107.94302-72.934473 41.815764-17.504274 85.576448-26.25641 131.282051-26.25641 45.705603 0 89.466287 8.752137 131.282051 26.25641 39.870845 17.504274 76.824311 41.815764 107.94302 72.934473 31.118708 31.118708 55.430199 67.099715 72.934473 107.94302 17.504274 40.843305 26.25641 85.576448 26.256411 131.282051z"  ></path><path d="M659.813865 434.689459c-2.917379-6.807217-8.752137-11.669516-16.531814-12.641976h-0.972459c-7.779677 0-13.614435 4.862298-16.531814 10.697056l-87.521368 199.354226-70.989553-320.91168c-1.944919-7.779677-7.779677-13.614435-15.559355-14.586895h-1.944919c-6.807217 0-13.614435 3.889839-16.531814 9.724596L314.590693 538.74264l-70.989553-0.97246c-9.724596 0-18.476733 8.752137-18.476734 18.476734 0 4.862298 1.944919 9.724596 5.834758 13.614435 3.889839 3.889839 7.779677 5.834758 12.641976 5.834757l82.659069 0.97246c6.807217 0 13.614435-3.889839 16.531814-9.724596L442.955366 369.534663 513.944919 696.281102c1.944919 7.779677 8.752137 13.614435 16.531814 14.586894h0.97246c7.779677 0 13.614435-4.862298 17.504273-10.697056l90.438747-208.106363 31.118708 90.438747c2.917379 7.779677 9.724596 12.641975 17.504274 12.641975l53.48528 1.944919c9.724596 0 18.476733-7.779677 18.476733-18.476733 0-10.697056-7.779677-18.476733-18.476733-19.449193l-40.843305-0.972459L659.813865 434.689459z"  ></path></symbol><symbol id="icon-puguanggaoxiao" viewBox="0 0 1190 1024"><path d="M1059.150858 257.156278h-4.625113l-20.350497-89.72719c-4.625113-19.425474-22.200542-33.300813-41.626016-33.300813h-259.006323c-20.350497 0-37.000903 13.875339-41.626016 33.300813l-20.350497 89.72719H438.460705v-55.501355c0-24.050587-19.425474-43.476061-43.476062-43.476061H271.95664c-11.100271 0-22.200542 4.625113-30.525746 12.950316-8.325203 8.325203-12.950316 18.500452-12.950316 30.525745v55.501355h-55.501355c-11.100271 0-22.200542 4.625113-30.525745 12.950316-8.325203 8.325203-12.950316 18.500452-12.950316 30.525746V841.770551c0 11.100271 4.625113 22.200542 12.950316 30.525745 8.325203 8.325203 18.500452 12.950316 30.525745 12.950316h885.246613c11.100271 0 22.200542-4.625113 30.525745-12.950316 8.325203-8.325203 12.950316-18.500452 12.950316-30.525745V299.707317c0-11.100271-4.625113-22.200542-12.950316-30.525745-7.400181-7.400181-18.500452-12.025294-29.600723-12.025294z m-331.158085-64.751581c4.625113-12.950316 15.725384-21.275519 28.6757-21.275519h210.905149c12.950316 0 24.97561 8.325203 28.6757 21.275519l21.27552 64.751581H705.792231l22.200542-64.751581z m-461.586269 34.225836c0-16.650407 13.875339-30.525745 30.525745-30.525745h74.001807c16.650407 0 30.525745 13.875339 30.525745 30.525745v30.525745H266.406504v-30.525745zM1064.700994 601.264679H813.094851c-10.175248 0-18.500452 8.325203-18.500452 18.500452s8.325203 18.500452 18.500452 18.500452h251.606143v86.0271H739.093044c-10.175248 0-18.500452 8.325203-18.500451 18.500452s8.325203 18.500452 18.500451 18.500451h325.60795v55.501355c0 16.650407-13.875339 30.525745-30.525746 30.525746H197.954833c-16.650407 0-30.525745-13.875339-30.525745-30.525746V324.682927c0-16.650407 13.875339-30.525745 30.525745-30.525745h836.220415c16.650407 0 30.525745 13.875339 30.525746 30.525745V601.264679z"  ></path><path d="M493.037037 779.794038c-115.627823 0-209.055104-94.352304-209.055104-209.055104 0-115.627823 93.427281-209.055104 209.055104-209.055104S703.017164 455.111111 703.017164 570.738934c0 115.627823-94.352304 209.055104-209.980127 209.055104z m0-393.134598c-101.752484 0-184.079494 82.32701-184.079494 184.079494 0 101.752484 82.32701 184.079494 184.079494 184.079494s184.079494-82.32701 184.079494-184.079494c0-101.752484-82.32701-184.079494-184.079494-184.079494z m0 295.082204c-61.051491 0-111.00271-49.95122-111.00271-111.00271s49.95122-111.00271 111.00271-111.00271c39.775971 0 76.776874 21.275519 96.202349 55.501355 19.425474 34.225836 19.425474 76.776874 0 111.00271-19.425474 34.225836-56.426378 55.501355-96.202349 55.501355z m0-197.02981c-47.176152 0-86.0271 38.850949-86.0271 86.0271 0 47.176152 38.850949 86.0271 86.0271 86.0271 30.525745 0 59.201445-16.650407 74.001807-42.551039 15.725384-26.825655 15.725384-59.201445 0-86.0271-14.800361-26.825655-43.476061-43.476061-74.001807-43.476061zM975.898826 462.511292H852.870822c-10.175248 0-19.425474-3.70009-25.900632-11.100271-6.475158-6.475158-11.100271-16.650407-11.100271-25.900633v-24.975609c0-10.175248 3.70009-19.425474 11.100271-25.900633 7.400181-7.400181 16.650407-11.100271 25.900632-11.100271h123.028004c10.175248 0 19.425474 3.70009 25.900632 11.100271 7.400181 7.400181 11.100271 16.650407 11.100271 25.900633V425.510388c0 10.175248-3.70009 19.425474-11.100271 25.900633-6.475158 7.400181-15.725384 11.100271-25.900632 11.100271z m-123.028004-74.001807c-2.775068 0-6.475158 0.925023-8.325203 3.70009-1.850045 1.850045-3.70009 5.550136-3.700091 8.325204V425.510388c0 2.775068 0.925023 6.475158 3.700091 8.325204 1.850045 1.850045 5.550136 3.70009 8.325203 3.70009h123.028004c2.775068 0 6.475158-0.925023 8.325203-3.70009 1.850045-1.850045 3.70009-5.550136 3.70009-8.325204v-24.975609c0-2.775068-0.925023-6.475158-3.70009-8.325204-1.850045-1.850045-5.550136-3.70009-8.325203-3.70009H852.870822z"  ></path></symbol><symbol id="icon-chengbennankongfengxiangao" viewBox="0 0 1029 1024"><path d="M792.8 144l-608.8 0.8c-24.8 0-43.2 20-43.2 45.6v614.4c0 24.8 20 44.8 44.8 44.8l403.2 0.8v-49.6h-400V194.4l601.6-0.8v360h48V189.6c0-24.8-20.8-45.6-45.6-45.6z"  ></path><path d="M887.2 844.8c23.2-21.6 40.8-66.4 37.6-101.6-6.4-85.6-69.6-155.2-155.2-155.2s-155.2 69.6-155.2 155.2 69.6 155.2 155.2 155.2c27.2 0 55.2-8 80-23.2l68.8 68.8 34.4-34.4-65.6-64.8z m-118.4 5.6c-59.2 0-107.2-48-107.2-107.2s48-107.2 107.2-107.2 107.2 48 107.2 107.2-48 107.2-107.2 107.2zM616 470.4c14.4 0 26.4-12 26.4-26.4 0-14.4-12-23.2-26.4-23.2h-70.4l70.4-70.4c10.4-10.4 10.4-26.4 0-36.8-10.4-10.4-26.4-10.4-36.8 0l-96 96-95.2-95.2c-10.4-10.4-26.4-10.4-36.8 0-10.4 10.4-10.4 26.4 0 36.8l69.6 70.4h-65.6c-14.4 0-26.4 8.8-26.4 23.2 0 14.4 12 26.4 26.4 26.4h104v55.2h-104c-14.4 0-26.4 8.8-26.4 23.2 0 14.4 12 26.4 26.4 26.4h104v60.8c0 14.4 12 26.4 26.4 26.4 14.4 0 26.4-12 26.4-26.4V576h104c14.4 0 26.4-12 26.4-26.4 0-14.4-12-23.2-26.4-23.2H512v-55.2h104z"  ></path></symbol><symbol id="icon-xingshiduoyang" viewBox="0 0 1024 1024"><path d="M881.546522 587.389341H596.639566c-4.625113 0-9.250226 1.850045-12.950316 5.550135-3.70009 3.70009-5.550136 8.325203-5.550135 12.950316v290.457091c0 4.625113 1.850045 9.250226 5.550135 12.950317s8.325203 5.550136 12.950316 5.550135h284.906956c10.175248 0 18.500452-8.325203 18.500452-18.500452V605.889792c0-4.625113-1.850045-9.250226-5.550136-12.950316-3.70009-3.70009-8.325203-5.550136-12.950316-5.550135z m-18.500452 290.457091H615.140018V624.390244h247.906052v253.456188zM453.261066 587.389341H169.279133c-4.625113 0-9.250226 1.850045-12.950316 5.550135-3.70009 3.70009-5.550136 8.325203-5.550136 12.950316v290.457091c0 10.175248 8.325203 18.500452 18.500452 18.500452h284.906956c4.625113 0 9.250226-1.850045 12.950316-5.550135 3.70009-3.70009 5.550136-8.325203 5.550135-12.950317V605.889792c0-4.625113-1.850045-9.250226-5.550135-12.950316-3.70009-3.70009-8.325203-5.550136-13.875339-5.550135z m-17.575429 290.457091H186.854562V624.390244h247.906052v253.456188zM453.261066 161.878952H168.35411c-4.625113 0-8.325203 1.850045-12.025293 5.550136-3.70009 3.70009-5.550136 8.325203-5.550136 12.950316v290.457091c0 4.625113 1.850045 9.250226 5.550136 12.950316 3.70009 3.70009 8.325203 5.550136 12.950316 5.550136h284.906956c4.625113 0 9.250226-1.850045 12.950316-5.550136 3.70009-3.70009 5.550136-8.325203 5.550135-12.950316V180.379404c0-4.625113-1.850045-9.250226-5.550135-12.950316-3.70009-3.70009-8.325203-5.550136-13.875339-5.550136z m-17.575429 290.457091H186.854562V197.954833h247.906052v254.38121zM955.548329 309.882565L753.893406 109.152665c-3.70009-3.70009-8.325203-5.550136-12.950317-5.550136-4.625113 0-9.250226 1.850045-12.950316 5.550136L522.63776 314.507678c-7.400181 7.400181-7.400181 18.500452 0 25.900633l201.654923 201.654923c3.70009 3.70009 8.325203 5.550136 12.950316 5.550135 4.625113 0 9.250226-1.850045 12.950316-5.550135l205.355014-205.355014c3.70009-3.70009 5.550136-8.325203 5.550135-12.950316-0.925023-5.550136-2.775068-10.175248-5.550135-13.875339zM737.242999 503.212285l-175.754291-175.75429 9.250226-9.250226L740.943089 148.003613l175.754291 175.754291L737.242999 503.212285z"  ></path></symbol><symbol id="icon-toufangjingzhun" viewBox="0 0 1143 1024"><path d="M1002.276518 504.883687h-89.141185l-0.749086-10.487198c-6.74177-83.1485-42.697879-161.802487-102.624725-221.729335-59.177762-59.177762-137.831748-95.882955-221.729335-102.624725l-10.487198-0.749086V80.152158c0-4.494514-1.498171-8.989027-5.243599-11.985369-2.996342-2.996342-7.490856-5.243599-11.98537-5.2436-4.494514 0-8.989027 1.498171-11.985369 5.2436-2.996342 2.996342-5.243599 7.490856-5.243599 11.985369v89.141185l-10.487198 0.749086c-83.1485 6.74177-161.802487 42.697879-221.729335 102.624725-59.177762 59.177762-95.882955 137.831748-102.624725 221.729335l-0.749086 10.487198H119.104609c-9.738113 0-17.228969 7.490856-17.228969 17.228968 0 9.738113 7.490856 17.228969 17.228969 17.228969h89.141185l0.749085 10.487198c6.74177 83.1485 42.697879 161.802487 102.624726 221.729335 59.177762 59.177762 137.831748 95.882955 221.729334 102.624725l10.487199 0.749086v89.141185c0 4.494514 1.498171 8.989027 5.243599 11.985369 2.996342 2.996342 7.490856 5.243599 11.985369 5.243599 4.494514 0 8.989027-1.498171 11.985369-5.243599 2.996342-2.996342 5.243599-7.490856 5.2436-11.985369v-89.141185l10.487198-0.749086c83.1485-6.74177 161.802487-42.697879 221.729334-102.624725 59.177762-59.177762 95.882955-137.831748 102.624726-221.729335l0.749085-10.487198h89.141186c9.738113 0 17.228969-7.490856 17.228968-17.228969-0.749086-9.738113-8.239941-17.228969-17.978054-17.228968z m-459.189466 335.590344l-12.734455-1.498171c-152.064375-14.232626-272.667154-134.835406-286.899781-286.899781l-1.498171-12.734455h176.784199l1.498171 9.738113c11.236284 56.930505 56.181419 102.624726 113.111924 113.111924l9.738113 1.498171v176.784199z m0-210.493051l-14.981712-5.243599c-32.959766-10.487198-59.177762-36.705194-70.414045-70.414045l-5.243599-14.981712h89.89027v90.639356z m0-125.097293h-89.890271l5.243599-14.981712c10.487198-32.959766 36.705194-59.177762 70.414046-69.66496l14.981712-5.243599v89.890271z m0-124.348208l-9.738113 1.498171c-56.930505 10.487198-102.624726 56.181419-113.111924 113.111924l-1.498171 9.738113H241.954645l1.498171-12.734455c14.232626-152.064375 134.835406-272.667154 286.899781-286.899781l12.734455-1.498171v176.784199z m34.457937 33.708852l14.981712 5.243599c32.959766 10.487198 59.177762 36.705194 70.414045 69.66496l5.243599 14.981711h-89.89027v-89.89027z m0 125.097293h89.890271l-5.243599 14.981712c-10.487198 32.959766-36.705194 59.177762-70.414046 70.414045l-14.981712 5.243599V539.341624z m300.383321 12.734455c-14.232626 152.064375-134.835406 272.667154-286.89978 286.899781l-12.734455 1.498171V663.689832l9.738112-1.498171c56.181419-10.487198 101.87564-56.181419 112.362839-113.111924l1.498171-9.738113h176.784199l-0.749086 12.734455z m-175.286028-47.192392l-1.498171-9.738113C689.907827 438.215069 644.213606 393.269934 587.283102 382.03365l-9.738113-1.498171V203.75128l12.734455 1.498171c152.064375 14.232626 272.667154 134.835406 286.899781 286.899781l1.498171 12.734455H702.642282z"  ></path></symbol><symbol id="icon-koubeichuanbo" viewBox="0 0 1024 1024"><path d="M473.287805 248.507317c-94.907317 0-169.834146 74.926829-169.834146 169.834146s74.926829 169.834146 169.834146 169.834147 169.834146-74.926829 169.834146-169.834147c0-92.409756-77.42439-169.834146-169.834146-169.834146z m59.941463 196.058537l14.985366 84.917073-74.926829-38.712195-77.42439 41.209756 14.985365-84.917073-62.439024-59.941464 87.414634-12.487805 38.712195-77.42439 37.463415 77.42439 87.414634 12.487805-66.185366 57.443903z m0 0"  ></path><path d="M715.55122 579.434146c31.219512-46.204878 48.702439-101.15122 48.702439-159.843902 0-159.843902-131.121951-290.965854-290.965854-290.965854S182.321951 260.995122 182.321951 419.590244c0 58.692683 17.482927 111.141463 46.204878 157.346341L96.156098 770.497561l113.639024-38.712195 4.995122 121.131707L337.170732 676.839024c41.209756 21.229268 87.414634 33.717073 136.117073 33.717074s94.907317-12.487805 133.619512-31.219513l123.629268 176.078049 4.995122-121.131707 113.639025 38.712195-133.619512-193.560976zM231.02439 790.478049v-92.409756l-84.917073 33.717073 97.404878-137.365854c21.229268 28.721951 48.702439 53.697561 77.42439 69.931708l-89.912195 126.126829z m0-372.136586c0-133.619512 108.643902-242.263415 242.263415-242.263414s242.263415 108.643902 242.263415 242.263414-108.643902 242.263415-242.263415 242.263415c-133.619512-1.24878-242.263415-107.395122-242.263415-242.263415z m479.531708 279.72683v92.409756l-87.414635-126.126829c31.219512-19.980488 58.692683-43.707317 79.921952-69.931708l94.907317 136.117073-87.414634-32.468292z m0 0"  ></path></symbol><symbol id="icon-shujujiance" viewBox="0 0 1169 1024"><path d="M216.725644 223.605823h26.37402v409.370661c0 22.933931 18.347144 41.281075 41.281075 41.281075h200.671893l-59.62822 108.93617c-2.293393 3.44009-3.44009 8.026876-2.293393 12.613662 1.146697 4.586786 4.586786 9.173572 10.320269 11.466965 3.44009 1.146697 6.880179 2.293393 10.320269 2.293393 8.026876 0 14.907055-3.44009 18.347144-9.173572l63.068309-114.669653c1.146697-2.293393 2.293393-4.586786 2.293393-8.026876v-3.440089h52.74804v3.440089c0 3.44009 1.146697 5.733483 2.293394 8.026876l63.068309 114.669653c3.44009 5.733483 10.320269 9.173572 18.347144 9.173572 3.44009 0 8.026876-1.146697 10.320269-2.293393 4.586786-2.293393 8.026876-6.880179 10.320269-11.466965 1.146697-4.586786 0-8.026876-2.293394-12.613662l-59.628219-108.93617h200.671893c22.933931 0 41.281075-18.347144 41.281075-41.281075V223.605823h26.37402c9.173572 0 17.200448-6.880179 18.347144-16.053751v-5.733483c-1.146697-9.173572-9.173572-16.053751-18.347144-16.053751H216.725644c-10.320269 0-18.347144 8.026876-18.347145 18.347144 0 11.466965 8.026876 19.493841 18.347145 19.493841z m63.068309 0H829.06159v386.43673c0 14.907055-11.466965 26.37402-26.37402 26.37402H306.167973c-14.907055 0-26.37402-11.466965-26.37402-26.37402V223.605823z"  ></path><path d="M342.862262 536.653975c3.44009 1.146697 5.733483 2.293393 9.173572 2.293393 5.733483 0 11.466965-3.44009 17.200448-10.320268L470.145577 407.077268l107.789473 77.975364c5.733483 4.586786 10.320269 8.026876 13.760359 10.320268 2.293393 1.146697 4.586786 2.293393 6.880179 2.293393 5.733483 0 11.466965-3.44009 17.200448-9.173572L774.020157 344.008959c3.44009-3.44009 5.733483-8.026876 4.586786-12.613662-1.146697-5.733483-4.586786-10.320269-10.320269-13.760359-2.293393-1.146697-4.586786-2.293393-6.880179-2.293393-6.880179 0-13.760358 4.586786-20.640538 11.466966L598.575588 456.385218l-112.37626-80.268757c-1.146697-1.146697-2.293393-1.146697-3.440089-2.293393-6.880179-4.586786-11.466965-6.880179-16.053752-6.880179h-4.586786c-1.146697 0-3.44009 1.146697-4.586786 1.146697h-1.146697-1.146696c-1.146697 1.146697-2.293393 1.146697-3.44009 2.293393-1.146697 1.146697-2.293393 2.293393-2.293393 3.440089 0 0 0 1.146697-1.146696 1.146697l-112.37626 134.163494c-5.733483 10.320269-2.293393 21.787234 6.880179 27.520716z"  ></path></symbol><symbol id="icon-shujufenxi1" viewBox="0 0 1024 1024"><path d="M805.726316 811.115789H219.621053c-10.778947 0-20.210526 9.431579-20.210527 20.210527s9.431579 20.210526 20.210527 20.210526h587.452631c10.778947 0 20.210526-9.431579 20.210527-20.210526-1.347368-12.126316-10.778947-20.210526-21.557895-20.210527zM261.389474 774.736842c10.778947 0 20.210526-9.431579 20.210526-20.210526V579.368421c0-10.778947-9.431579-20.210526-20.210526-20.210526s-20.210526 9.431579-20.210527 20.210526v175.157895c0 10.778947 8.084211 20.210526 20.210527 20.210526zM405.557895 516.042105V754.526316c0 10.778947 9.431579 20.210526 20.210526 20.210526s20.210526-9.431579 20.210526-20.210526V516.042105c0-10.778947-9.431579-20.210526-20.210526-20.210526s-20.210526 9.431579-20.210526 20.210526z m164.378947-72.757894V754.526316c0 10.778947 9.431579 20.210526 20.210526 20.210526s20.210526-9.431579 20.210527-20.210526V443.284211c0-10.778947-9.431579-20.210526-20.210527-20.210527-10.778947 1.347368-20.210526 9.431579-20.210526 20.210527z m0 0M207.494737 357.052632c0 29.642105 22.905263 52.547368 52.547368 52.547368s52.547368-22.905263 52.547369-52.547368-22.905263-52.547368-52.547369-52.547369c-28.294737-1.347368-52.547368 22.905263-52.547368 52.547369z m0 0M385.347368 435.2c0 20.210526 16.168421 37.726316 37.726316 37.726316 20.210526 0 37.726316-16.168421 37.726316-37.726316 0-20.210526-16.168421-37.726316-37.726316-37.726316-21.557895 1.347368-37.726316 17.515789-37.726316 37.726316z m0 0M538.947368 254.652632c0 29.642105 24.252632 53.894737 53.894737 53.894736s53.894737-24.252632 53.894737-53.894736-24.252632-53.894737-53.894737-53.894737c-29.642105-1.347368-53.894737 22.905263-53.894737 53.894737z m0 0M734.315789 344.926316V754.526316c0 10.778947 9.431579 20.210526 20.210527 20.210526S774.736842 765.305263 774.736842 754.526316V344.926316c0-10.778947-9.431579-20.210526-20.210526-20.210527-6.736842 0-12.126316 2.694737-16.168421 8.084211 0 0-4.042105 5.389474-4.042106 12.126316z"  ></path><path d="M591.494737 233.094737l-2.694737-1.347369-165.726316 206.147369L260.042105 350.315789l-6.736842 13.473685 173.810526 92.968421 164.378948-206.147369L746.442105 350.315789l2.694737-4.042105c1.347368-1.347368 2.694737-2.694737 2.694737-5.389473l2.694737-4.042106-163.031579-103.747368z"  ></path></symbol><symbol id="icon-wanghongzhibo" viewBox="0 0 1024 1024"><path d="M567.810427 516.044234l84.120063 51.766193c27.50079 16.176935 50.148499 3.235387 50.148499-30.736177l-1.617694-221.624013c0-33.971564-22.647709-46.913112-50.148499-30.736177l-82.502369 48.530806v182.799368zM469.131122 252.36019H229.71248c-45.295419 0-80.884676 37.206951-80.884676 80.884676V517.661927c0 45.295419 37.206951 80.884676 80.884676 80.884676H469.131122c45.295419 0 80.884676-37.206951 80.884676-80.884676V334.862559c0-45.295419-35.589258-82.50237-80.884676-82.502369z m-46.913113 187.652448l-101.914691 58.236967c-12.941548 6.470774-22.647709 1.617694-22.64771-12.941548v-118.091627c0-14.559242 11.323855-21.030016 22.64771-12.941548l101.914691 59.85466c12.941548 6.470774 12.941548 19.412322 0 25.883096z"  ></path></symbol><symbol id="icon-tuiguangfangan" viewBox="0 0 1035 1024"><path d="M485.537079 719.101124H311.802247c-12.65618 0-23.011236 10.355056-23.011236 23.011236s10.355056 23.011236 23.011236 23.011236h173.734832c12.65618 0 23.011236-10.355056 23.011236-23.011236s-10.355056-23.011236-23.011236-23.011236zM716.8 546.516854H311.802247c-12.65618 0-23.011236 10.355056-23.011236 23.011236s10.355056 23.011236 23.011236 23.011236h403.847191c12.65618 0 23.011236-10.355056 23.011236-23.011236s-9.204494-23.011236-21.860674-23.011236zM946.91236 661.573034c-5.752809 0-11.505618 2.301124-16.107866 6.90337L717.950562 882.480899l-92.044944-104.701124c-4.602247-4.602247-10.355056-8.053933-17.258427-8.053932-5.752809 0-11.505618 2.301124-14.957303 5.752809-9.204494 8.053933-10.355056 23.011236-2.301124 32.21573l108.152809 123.110112c4.602247 4.602247 10.355056 8.053933 16.107865 8.053933h1.150562c5.752809 0 11.505618-2.301124 16.107865-6.903371l231.262922-231.262921c9.204494-9.204494 9.204494-23.011236 0-32.215731-4.602247-4.602247-10.355056-6.903371-17.258427-6.90337zM716.8 372.782022H311.802247c-12.65618 0-23.011236 10.355056-23.011236 23.011236s10.355056 23.011236 23.011236 23.011236h403.847191c12.65618 0 23.011236-10.355056 23.011236-23.011236s-9.204494-23.011236-21.860674-23.011236z"  ></path><path d="M254.274157 938.858427h288.791012c12.65618 0 23.011236-10.355056 23.011235-23.011236s-10.355056-23.011236-23.011235-23.011236H254.274157c-19.559551 0-34.516854-16.107865-34.516854-34.516854V223.208989c0-19.559551 16.107865-34.516854 34.516854-34.516854h37.96854l1.150561 3.451685c11.505618 32.21573 41.420225 54.076404 75.937079 54.076405h288.791011c34.516854 0 64.431461-21.860674 75.937079-54.076405l1.150562-3.451685h37.968539c19.559551 0 34.516854 16.107865 34.516854 34.516854v403.847191c0 12.65618 10.355056 23.011236 23.011236 23.011236s23.011236-10.355056 23.011236-23.011236V223.208989c0-44.87191-35.667416-80.539326-80.539326-80.539326H736.359551l-1.150562-4.602247c-11.505618-32.21573-41.420225-54.076404-75.937079-54.076405H370.480899c-34.516854 0-64.431461 21.860674-75.937079 54.076405l-1.150562 3.451685h-37.968539c-44.87191 0-80.539326 35.667416-80.539326 80.539326v635.110112c-1.150562 44.87191 35.667416 81.689888 79.388764 81.689888z m116.206742-808.844944h288.791011c19.559551 0 34.516854 16.107865 34.516854 34.516854 0 19.559551-16.107865 34.516854-34.516854 34.516854H370.480899c-19.559551 0-34.516854-16.107865-34.516854-34.516854-1.150562-18.408989 14.957303-34.516854 34.516854-34.516854z"  ></path></symbol><symbol id="icon-chuangyitoufang" viewBox="0 0 1024 1024"><path d="M812.521739 198.121739c0-45.634783-36.730435-82.365217-82.365217-82.365217H277.147826c-45.634783 0-82.365217 36.730435-82.365217 82.365217v576.556522c0 45.634783 36.730435 82.365217 82.365217 82.365217h185.878261c11.130435 0 20.034783-8.904348 20.034783-21.147826 0-11.130435-8.904348-21.147826-20.034783-21.147826H277.147826c-22.26087 0-41.182609-18.921739-41.182609-41.182609V198.121739c0-22.26087 18.921739-41.182609 41.182609-41.182609h453.008696c22.26087 0 41.182609 18.921739 41.182608 41.182609v268.243478c0 11.130435 8.904348 21.147826 21.147827 21.147826 11.130435 0 21.147826-8.904348 21.147826-21.147826V198.121739z"  ></path><path d="M596.591304 873.73913h-37.843478c-13.356522 1.113043-25.6-3.33913-34.504348-12.243478-10.017391-8.904348-15.582609-22.26087-15.582608-35.617391V790.26087c0-17.808696 8.904348-38.956522 21.147826-52.313044l209.252174-210.365217c8.904348-8.904348 22.26087-14.469565 34.504347-14.469566 13.356522 0 25.6 5.565217 35.617392 14.469566l45.634782 45.634782c18.921739 18.921739 18.921739 51.2 0 70.121739L645.565217 852.591304c-12.243478 13.356522-32.278261 21.147826-48.973913 21.147826z m-38.956521-31.165217h36.730434c8.904348 1.113043 22.26087-4.452174 28.939131-11.130435l209.252174-210.365217c7.791304-7.791304 7.791304-18.921739 0-26.713044l-45.634783-45.634782c-3.33913-3.33913-7.791304-5.565217-13.356522-5.565218-4.452174 0-10.017391 2.226087-13.356521 5.565218L552.069565 759.095652c-6.678261 6.678261-12.243478 20.034783-12.243478 31.165218v35.617391c0 5.565217 2.226087 10.017391 5.565217 13.356522 3.33913 2.226087 7.791304 3.33913 12.243479 3.33913z"  ></path><path d="M332.8 693.426087h115.756522c7.791304 0 14.469565 8.904348 14.469565 21.147826 0 11.130435-6.678261 21.147826-14.469565 21.147826H332.8c-7.791304 0-14.469565-8.904348-14.469565-21.147826 0-12.243478 6.678261-21.147826 14.469565-21.147826zM318.330435 589.913043c0-11.130435 7.791304-21.147826 16.695652-21.147826h213.704348c8.904348 0 16.695652 8.904348 16.695652 21.147826 0 11.130435-7.791304 21.147826-16.695652 21.147827H335.026087c-10.017391 0-16.695652-8.904348-16.695652-21.147827zM420.730435 501.982609c-6.678261 0-12.243478-2.226087-17.808696-5.565218-7.791304-6.678261-12.243478-16.695652-11.130435-27.826087l6.678261-62.330434-38.956522-60.104348c-6.678261-10.017391-7.791304-20.034783-3.33913-30.052174 4.452174-8.904348 13.356522-15.582609 24.486957-16.695652l56.765217-7.791305 33.391304-52.313043c6.678261-10.017391 15.582609-15.582609 25.6-15.582609 10.017391 0 18.921739 5.565217 25.6 15.582609l33.391305 51.2 60.104347 7.791304c11.130435 1.113043 20.034783 7.791304 24.486957 16.695652 4.452174 8.904348 3.33913 20.034783-3.33913 30.052174l-37.843479 60.104348 6.678261 62.330435c1.113043 11.130435-2.226087 21.147826-10.017391 27.826087-7.791304 6.678261-18.921739 7.791304-30.052174 4.452174l-66.782609-22.26087-66.782608 23.373913c-3.33913 1.113043-6.678261 1.113043-11.130435 1.113044z m-34.504348-171.408696l44.521739 69.008696-7.791304 71.234782 75.686956-25.6 75.686957 25.6-6.678261-72.347826 43.408696-69.008695-73.46087-10.017392-40.069565-63.443478-41.182609 64.556522-70.121739 10.017391z m109.078261-75.686956z"  ></path></symbol><symbol id="icon-xinxiliuguanggao" viewBox="0 0 1239 1024"><path d="M906.327628 260.381418H290.425428c-30.04401 0-55.080685 25.036675-55.080685 55.080685v475.696821c0 30.04401 25.036675 55.080685 55.080685 55.080685h615.9022c30.04401 0 55.080685-25.036675 55.080685-55.080685v-475.696821c-2.503667-30.04401-25.036675-55.080685-55.080685-55.080685zM623.413203 545.799511h-125.183374v-127.687042c62.591687 10.01467 115.168704 62.591687 125.183374 127.687042zM475.696822 718.552567c-77.613692 0-142.709046-60.08802-147.716382-135.198044v-15.022005c0-75.110024 55.080685-137.701711 127.687042-147.716381v167.745721h167.745721c-7.511002 72.606357-70.102689 130.190709-147.716381 130.190709z m388.068459-22.533007h-185.271393v-55.080685h185.271393v55.080685z m0-105.154034h-185.271393v-55.080685h185.271393v55.080685z m0-102.650367h-125.183374v-55.080685h125.183374v55.080685z"  ></path></symbol><symbol id="icon-weibohongren" viewBox="0 0 1043 1024"><path d="M687.465729 518.29877c-10.797891-1.799649-19.796134-7.198594-12.597539-17.996485 7.198594-12.59754 19.796134-46.790861-5.398946-70.186292-23.395431-23.395431-75.585237-14.397188-111.578207 0-35.99297 16.196837-34.193322 5.398946-32.393673-5.398946 1.799649-10.797891 21.595782-73.785589-39.592267-82.783831-79.184534-10.797891-179.964851 89.982425-214.158173 147.571178-53.989455 88.182777-44.991213 145.771529-44.991212 145.771529 7.198594 80.984183 122.376098 145.771529 266.347979 145.771529 122.376098 0 226.755712-48.59051 257.349736-113.377856 3.599297-7.198594 5.398946-14.397188 7.198594-21.595782 3.599297-17.996485 7.198594-43.191564 0-68.386644-16.196837-41.391916-61.188049-57.588752-70.186292-59.3884zM473.307557 748.653779c-100.780316 0-183.564148-55.789104-183.564148-125.975396s82.783831-125.975395 183.564148-125.975395 183.564148 55.789104 183.564148 125.975395-80.984183 125.975395-183.564148 125.975396z"  ></path><path d="M457.110721 543.493849c-53.989455 0-98.980668 39.592267-98.980668 88.182777s43.191564 88.182777 98.980668 88.182776c53.989455 0 98.980668-39.592267 98.980667-88.182776s-44.991213-88.182777-98.980667-88.182777z m-32.393674 145.771529c-19.796134 0-34.193322-16.196837-34.193321-35.99297s16.196837-35.99297 34.193321-35.99297c19.796134 0 34.193322 16.196837 34.193322 35.99297s-16.196837 35.99297-34.193322 35.99297z m64.787347-62.987698c-3.599297 7.198594-12.59754 10.797891-17.996485 7.198594-5.398946-3.599297-7.198594-12.59754-3.599297-19.796133 3.599297-7.198594 12.59754-10.797891 17.996485-7.198594 5.398946 3.599297 7.198594 12.59754 3.599297 19.796133zM723.458699 469.70826c1.799649 0 3.599297 1.799649 5.398946 1.799649 5.398946 0 10.797891-3.599297 14.397188-8.998243 3.599297-8.998243 5.398946-19.796134 5.398946-28.794376 0-41.391916-32.393673-75.585237-73.785589-75.585237-10.797891 0-19.796134 1.799649-28.794376 5.398945-7.198594 3.599297-10.797891 12.59754-7.198594 19.796134 3.599297 7.198594 10.797891 10.797891 19.796133 8.998242 5.398946-1.799649 10.797891-3.599297 16.196837-3.599297 23.395431 0 43.191564 19.796134 43.191564 44.991213 0 5.398946-1.799649 12.59754-3.599297 17.996485-1.799649 5.398946 1.799649 14.397188 8.998242 17.996485z"  ></path><path d="M674.86819 260.949033c-16.196837 0-32.393673 1.799649-48.59051 7.198594-12.59754 3.599297-17.996485 16.196837-14.397188 28.794377 3.599297 12.59754 16.196837 19.796134 26.994728 16.196836 12.59754-3.599297 23.395431-5.398946 35.99297-5.398945 70.186292 0 127.775044 59.388401 127.775044 131.374341 0 12.59754-1.799649 25.195079-5.398946 37.792618-3.599297 12.59754 3.599297 25.195079 14.397188 28.794376 1.799649 0 3.599297 1.799649 7.198594 1.799649 10.797891 0 17.996485-7.198594 21.595782-16.196837 5.398946-16.196837 7.198594-34.193322 7.198594-52.189806 0-97.181019-77.384886-178.165202-172.766256-178.165203z"  ></path></symbol><symbol id="icon-jingpinfenxi1" viewBox="0 0 1371 1024"><path d="M721.828571 224v216.228571h216.228572c0-119.314286-96.457143-216.228571-216.228572-216.228571"  ></path><path d="M688 474.514286V245.028571l-36.571429 0.914286c-128 9.6-229.485714 116.114286-229.485714 246.857143 0 136.685714 111.085714 247.771429 247.771429 247.771429 130.742857 0 237.257143-101.028571 246.857143-229.485715l0.914285-36.571428h-229.485714z m-18.285714 229.485714c-116.571429 0-211.2-94.628571-211.2-211.2 0-110.171429 84.571429-200.685714 192.914285-210.285714v228.571428h228.571429c-9.6 107.885714-100.114286 192.914286-210.285714 192.914286z"  ></path></symbol><symbol id="icon-hangyefenxi1" viewBox="0 0 1118 1024"><path d="M318.012422 232.785093c-38.585507 0-69.538716 31.377226-69.538716 69.538717 0 38.161491 31.377226 69.538716 69.538716 69.538716 38.585507 0 69.538716-31.377226 69.538717-69.538716 0-38.585507-31.377226-69.538716-69.538717-69.538717z m153.493996 302.32381L534.26087 513.060041l5.088198-1.696066 4.664183 2.5441 47.489855 29.681159 39.43354-111.940373 6.360248-16.960662 12.296481 13.144513 36.041408 38.161491 52.578053-90.315528 19.080746 11.024431-59.786336 103.036024-7.208281 12.720497-10.176398-10.600414-33.497308-36.041408-37.737474 108.124224-4.664183 13.144513-11.448447-7.208281-54.698136-34.345342-57.666253 19.928779-8.904348-20.352795z m11.448447 273.490683H695.387164v37.313457h-212.432299v-37.313457z m133.565218-120.844721h228.120911V252.289855H423.16853V296.811594h377.798758v347.269565h-359.566046v44.52174h114.908489v109.396273h60.634368v-110.244307zM199.287785 570.302277l44.097722 33.073292-14.416563 242.961491h63.602485l10.600414-207.344099h27.13706l13.144513 207.344099h59.786336l-9.328365-242.961491-5.088199-148.405797 145.437682-2.120083 31.377225-55.122153L402.391718 390.095238H328.612836l5.512216 9.328364-7.632298 14.416564 15.688612 111.940372-24.168944 25.016978v2.120082l-0.848033-1.272049-1.272049 1.272049v-2.120082l-24.592961-25.440994 15.688613-111.940373-7.208282-14.84058 5.512215-9.328364H232.785093L199.287785 570.302277z m0 0"  ></path></symbol><symbol id="icon-yonghufenxi1" viewBox="0 0 1172 1024"><path d="M790.371072 234.951356h-31.29746c-11.901851 0-20.718037 8.816186-20.718037 20.718037v433.31554c0 11.901851 8.816186 20.718037 20.718037 20.718037h31.29746c11.901851 0 20.718037-8.816186 20.718037-20.718037V255.669393c0-11.901851-10.579423-20.718037-20.718037-20.718037zM296.223848 341.627206h-29.534223c-11.901851 0-20.718037 8.816186-20.718037 20.718037v326.63969c0 11.901851 8.816186 20.718037 20.718037 20.718037h31.297461c11.901851 0 20.718037-8.816186 20.718037-20.718037V362.345243c0-10.138614-10.579423-20.718037-22.481275-20.718037z m602.586311-179.409384h-31.29746c-11.901851 0-20.718037 8.816186-20.718037 20.718037v506.049074c0 11.901851 8.816186 20.718037 20.718037 20.718037h31.29746c11.901851 0 20.718037-8.816186 20.718037-20.718037V182.935859c0-11.901851-9.256995-20.718037-20.718037-20.718037z m-201.890658 516.187688V377.332759c0-3.085665-1.322428-5.730521-3.085665-7.493758L597.296599 273.301765c-4.408093-4.408093-10.579423-4.408093-14.987516 0s-4.408093 10.579423 0 14.987516l80.227292 80.227292h-105.353422v-132.242789c0-5.730521-4.408093-10.579423-10.579423-10.579423H360.141197c-5.730521 1.322428-10.579423 5.730521-10.579423 10.579423v461.527335c0 5.730521 4.408093 10.579423 10.579423 10.579423h304.158416l44.521739 48.929833c5.730521 5.730521 16.309944 5.730521 20.718037 0l14.987516-14.987517c5.730521-5.730521 5.730521-16.309944 0-22.040465l-47.607404-41.876883zM370.279811 688.984933V246.853207h167.507533v130.479552c0 5.730521 4.408093 10.579423 10.579423 10.579424h129.157125v274.624192l-38.350409-32.619888c-1.322428-1.322428-3.085665-3.085665-5.730521-4.408093 17.632372-22.040465 28.211795-50.25226 28.211795-80.227292 0-72.733534-57.746018-130.479552-129.157125-130.479552-70.970297 0-129.157124 57.746018-129.157124 130.479552s57.746018 130.479552 129.157124 130.479552c28.211795 0 55.101162-8.816186 75.8192-25.12613 1.322428 3.085665 4.408093 4.408093 5.730521 5.730521l32.619888 32.619888H370.279811z m250.82049-145.467068c0 48.929832-40.113646 89.043478-89.043478 89.043478s-89.043478-40.113646-89.043478-89.043478 40.113646-89.043478 89.043478-89.043478 89.043478 40.113646 89.043478 89.043478z m0 0"  ></path></symbol><symbol id="icon-zishenfenxi" viewBox="0 0 1325 1024"><path d="M1007.085714 743.771429H458.971429c-10.971429 0-20.114286-9.142857-20.114286-20.114286v-13.257143c0-10.971429 9.142857-20.114286 20.114286-20.114286h548.114285c10.971429 0 20.114286 9.142857 20.114286 20.114286v13.257143c0 10.971429-9.142857 20.114286-20.114286 20.114286z m1.371429-110.171429l-5.485714 3.657143c-7.771429 5.028571-18.285714 3.2-23.314286-4.571429l-59.428572-89.142857c-5.028571-7.771429-3.2-18.285714 4.571429-23.314286l5.485714-3.657142c7.771429-5.028571 18.285714-3.2 23.314286 4.571428l59.428571 89.142857c5.028571 7.771429 2.742857 18.285714-4.571428 23.314286z m-84.571429-120.228571a106.925714 106.925714 0 0 1-148.571428-29.714286 106.925714 106.925714 0 0 1 29.714285-148.571429c49.371429-32.914286 115.657143-19.657143 148.571429 29.714286 32.457143 49.371429 19.2 115.657143-29.714286 148.571429z m7.314286-133.942858c-24.685714-37.028571-74.514286-46.628571-111.085714-22.4-37.028571 24.685714-46.628571 74.514286-22.4 111.085715 24.685714 37.028571 74.514286 46.628571 111.085714 22.4 37.028571-24.228571 47.085714-74.057143 22.4-111.085715z m-61.257143-10.514285c-35.2 0-63.542857 28.342857-63.542857 63.542857 1.371429 23.771429 14.171429 20.571429 13.257143 36.571428-0.457143 8.228571-26.971429-4.571429-26.971429-43.428571s31.542857-70.4 70.4-70.4c31.085714-0.457143 24.685714 11.885714 23.314286 13.257143-0.914286 3.2-9.142857 0.914286-16.457143 0.457143z m-10.057143 188.8v85.485714c0 10.971429-9.142857 20.114286-20.114285 20.114286h-66.742858c-10.971429 0-20.114286-9.142857-20.114285-20.114286V498.285714v0.457143c25.142857 37.028571 65.371429 57.6 106.971428 58.971429zM699.428571 663.314286h-66.742857c-10.971429 0-20.114286-9.142857-20.114285-20.114286V349.257143c0-10.971429 9.142857-20.114286 20.114285-20.114286H699.428571c10.971429 0 20.114286 9.142857 20.114286 20.114286v294.4c0 10.514286-8.685714 19.657143-20.114286 19.657143z m-140.342857 0h-66.742857c-10.971429 0-20.114286-9.142857-20.114286-20.114286V261.942857c0-10.971429 9.142857-20.114286 20.114286-20.114286h66.742857c10.971429 0 20.114286 9.142857 20.114286 20.114286v381.257143c0 10.971429-9.142857 20.114286-20.114286 20.114286z m0 0"  ></path></symbol><symbol id="icon-duanshipinyingxiao" viewBox="0 0 1215 1024"><path d="M622.592 114.688c-218.453333 0-395.946667 177.493333-395.946667 395.946667s177.493333 395.946667 395.946667 395.946666 395.946667-177.493333 395.946667-395.946666c0-221.184-174.762667-395.946667-395.946667-395.946667z m172.032 412.330667l-251.221333 144.725333c-8.192 5.461333-19.114667 2.730667-24.576-8.192-2.730667-2.730667-2.730667-5.461333-2.730667-8.192V365.909333c0-2.730667 0-5.461333 2.730667-8.192 2.730667-2.730667 5.461333-8.192 8.192-8.192 5.461333-2.730667 10.922667-2.730667 16.384 0l251.221333 144.725334c2.730667 2.730667 5.461333 2.730667 8.192 8.192 2.730667 8.192 0 19.114667-8.192 24.576z"  ></path></symbol><symbol id="icon-dianzanliang" viewBox="0 0 1053 1024"><path d="M861.245033 416.277127c-15.127866-19.82272-38.60214-31.299032-63.641365-31.299032h-189.880795l5.738156-10.954661c6.259806-11.476312 11.476312-22.952624 16.171167-33.385635l11.476311-29.73408c26.082527-75.639328 20.866021-142.932247-14.606215-200.313806-19.30107-30.777382-45.383597-48.5135-71.987773-48.513499-16.692817 0-32.342333 7.824758-41.732043 21.387672-13.041263 18.257769-19.30107 41.732043-27.125828 71.466123-7.303107 27.125828-15.649516 58.42486-31.299032 94.418747-23.995925 57.381559-67.292919 104.851758-122.066225 134.585838l-1.564952 1.043301H173.187978c-27.647478 0-50.600102 22.430973-50.600102 50.600102v395.411105c0 13.562914 5.216505 26.082527 14.606215 35.993887 9.38971 9.38971 22.430973 14.606215 35.472236 14.606215h531.040245c35.472236 0 67.292919-23.995925 76.682628-58.42486l93.897096-337.507896c6.781457-23.474274 2.086602-49.556801-13.041263-69.379521zM226.396332 832.554254H171.623026V434.013245h54.773306v398.541009z m600.941416-359.938869l-93.897096 337.507896c-3.651554 13.041263-15.649516 22.430973-29.21243 22.430973H275.431482V434.013245H328.639837c9.38971 0 18.779419-2.608253 27.125828-6.781457 64.163016-34.428935 115.284768-90.767193 143.453897-158.060112 9.38971-21.387672 17.214468-43.296994 23.474274-65.727967 3.129903-10.433011 10.954661-38.60214 14.084564-50.600102v-0.521651c6.259806-21.909322 10.433011-33.385634 15.649516-40.688742l2.608253-3.651553-0.52165-5.216506 9.389709 7.824758c2.086602 1.564952 8.346409 7.303107 20.344371 25.560877 35.993887 57.381559 31.299032 127.282731-14.606215 214.398369-9.38971 17.214468-8.346409 38.60214 1.564952 55.816608 10.433011 16.692817 28.690779 27.125828 48.513499 27.125827h177.361182c9.38971 0 18.779419 4.694855 24.517575 11.997963 6.259806 8.346409 8.346409 18.257769 5.738156 27.125828z"  ></path></symbol><symbol id="icon-guanjiancisousuo" viewBox="0 0 1203 1024"><path d="M966.686567 852.059701L840.597015 725.970149c49.671642-57.313433 76.41791-133.731343 76.41791-213.970149 0-87.880597-34.38806-171.940299-95.522388-233.074627-61.134328-61.134328-145.19403-95.522388-233.074627-95.522388-179.58209 0-328.597015 145.19403-328.597014 328.597015 0 87.880597 34.38806 171.940299 95.522388 233.074627 61.134328 61.134328 145.19403 95.522388 233.074626 95.522388 76.41791 0 152.835821-26.746269 210.149254-76.417911l126.089552 126.089553c11.462687 11.462687 26.746269 11.462687 38.208956 0 11.462687-11.462687 11.462687-30.567164 3.820895-38.208956z m-378.268657-64.955223c-152.835821 0-275.104478-122.268657-275.104477-275.104478 0-72.597015 30.567164-141.373134 80.238806-194.865672 49.671642-49.671642 122.268657-80.238806 194.865671-80.238806 152.835821 0 275.104478 122.268657 275.104478 275.104478 0 72.597015-30.567164 141.373134-80.238806 194.865672-49.671642 49.671642-122.268657 80.238806-194.865672 80.238806z m0 0"  ></path></symbol><symbol id="icon-gongguanruanwen" viewBox="0 0 1242 1024"><path d="M951.020045 75.260579H285.077951c-72.979955 0-132.276169 59.296214-132.276169 132.276169v606.64588c0 72.979955 59.296214 132.276169 132.276169 132.276169h663.66147c72.979955 0 132.276169-59.296214 132.276169-132.276169V207.536748c2.280624-72.979955-57.01559-132.276169-129.995545-132.276169z m72.979955 736.641425c0 38.770601-31.928731 70.699332-72.979955 70.699332H287.358575c-38.770601 0-72.979955-31.928731-72.979956-70.699332V205.256125c0-38.770601 31.928731-70.699332 72.979956-70.699332h663.66147c38.770601 0 72.979955 31.928731 72.979955 70.699332v606.645879z m0 0"  ></path><path d="M348.935412 339.812918H684.187082c15.964365 0 29.648107-13.683742 29.648107-29.648107 0-15.964365-13.683742-29.648107-29.648107-29.648107H348.935412c-15.964365 0-29.648107 13.683742-29.648107 29.648107-2.280624 18.244989 11.403118 29.648107 29.648107 29.648107zM887.162584 478.930958H348.935412c-15.964365 0-29.648107 13.683742-29.648107 29.648107 0 15.964365 13.683742 29.648107 29.648107 29.648106H889.443207c15.964365 0 29.648107-13.683742 29.648107-29.648106 0-15.964365-13.683742-29.648107-31.92873-29.648107zM887.162584 679.625835H348.935412c-15.964365 0-29.648107 13.683742-29.648107 29.648107 0 15.964365 13.683742 29.648107 29.648107 29.648107H889.443207c15.964365 0 29.648107-13.683742 29.648107-29.648107 0-15.964365-13.683742-29.648107-31.92873-29.648107z"  ></path></symbol><symbol id="icon-gaoxiaozhuanshufuwu" viewBox="0 0 1071 1024"><path d="M921.6 204.006202c-26.989147-29.370543-58.741085-54.772093-92.874419-74.617055-51.596899-28.576744-187.336434-59.534884-277.829457 28.576744l-29.370543 29.370543-23.020155-23.020155C390.548837 59.534884 242.108527 98.431008 151.615504 190.511628 65.885271 277.035659 23.813953 419.125581 131.770543 527.082171l48.421705 48.421705-9.525581 8.731783c-29.370543 29.370543-29.370543 77.792248 0 107.162791l6.350387 6.350387c15.082171 15.082171 35.72093 23.020155 57.947287 22.226357-0.793798 19.844961 7.144186 39.689922 22.226357 54.772093l6.350387 6.350387c16.669767 16.669767 39.689922 23.813953 62.710078 21.432559 0.793798 18.257364 7.937984 36.514729 22.226356 50.8031l6.350388 6.350388c15.875969 15.875969 38.896124 23.813953 61.122481 21.432558 0.793798 19.051163 8.731783 37.308527 22.226356 51.596899l6.350388 6.350388c14.288372 14.288372 33.339535 22.226357 53.184496 22.226356 20.63876 0 38.896124-7.937984 53.184496-22.226356l53.184496-53.184496c7.144186-7.144186 11.906977-15.082171 15.875969-23.813954 14.288372 11.906977 30.164341 18.257364 46.834109 18.257365 22.226357 0 43.658915-9.525581 59.534883-24.607752 11.906977-11.906977 20.63876-28.576744 23.020155-46.04031 25.40155 3.175194 52.390698-7.144186 70.648062-24.607752 13.494574-13.494574 23.813953-32.545736 23.813954-53.184496 19.051163 0 36.514729-8.731783 50.009302-21.432559 26.989147-26.195349 38.102326-73.823256 11.113179-108.750387l46.834108-46.834109c104.781395-107.162791 60.328682-253.221705-30.164341-350.858914zM252.427907 665.996899c-11.906977 11.113178-30.95814 11.113178-43.658915 0l-6.350387-6.350387c-11.906977-11.906977-11.906977-31.751938 0-43.658915l79.379845-79.379845c11.906977-11.906977 31.751938-11.906977 43.658914 0l6.350388 6.350388c11.906977 11.906977 11.906977 30.95814 0 43.658914l-79.379845 79.379845z m86.524031 82.555039c-11.906977 11.113178-30.95814 11.113178-43.658915 0l-6.350387-6.350388c-11.906977-11.906977-11.906977-31.751938 0-43.658914l126.213953-126.213954c11.906977-11.906977 31.751938-11.906977 43.658915 0l6.350387 5.556589c11.906977 11.906977 11.906977 30.95814 0 43.658915l-126.213953 127.007752z m91.286822 78.586046c-11.906977 11.906977-30.95814 11.906977-43.658915 0l-6.350388-6.350387c-11.906977-11.906977-11.906977-31.751938 0-43.658915L466.753488 690.604651c11.906977-11.906977 31.751938-11.906977 43.658915 0l6.350388 6.350388c11.906977 11.906977 11.906977 30.95814 0 43.658914l-86.524031 86.524031z m142.089922 26.195349l-53.184496 53.184496c-11.906977 11.113178-30.95814 11.113178-43.658915 0l-6.350387-6.350387c-5.556589-5.556589-8.731783-13.494574-8.731783-21.432558 0-8.731783 3.175194-15.875969 8.731783-21.432558l53.184496-53.184497c8.731783-8.731783 21.432558-11.113178 32.545736-7.144186 0.793798 0.793798 0 1.587597 0.793799 2.381396l23.020155 23.813953c3.968992 10.31938 1.587597 22.226357-6.350388 30.164341zM873.178295 568.35969l-196.862016-206.387597c-8.731783-8.731783-23.020155-9.525581-31.751938-0.793798-8.731783 8.731783-9.525581 23.020155-0.793798 31.751938l222.263566 233.376744c15.875969 16.669767 7.144186 40.483721-3.968993 51.596899-8.731783 8.731783-23.813953 15.082171-43.658914-4.762791L705.686822 557.246512c-8.731783-8.731783-23.020155-9.525581-31.751938-0.793799-8.731783 8.731783-9.525581 23.020155-0.793799 31.751938l7.144186 7.144186 0.793799 0.793799L785.860465 704.099225c21.432558 22.226357 10.31938 38.896124 1.587597 47.627907-11.113178 11.113178-34.927132 19.844961-50.009302 3.968992L623.131783 637.420155c-8.731783-8.731783-23.020155-8.731783-31.751938-0.793798-8.731783 8.731783-8.731783 23.020155-0.793798 31.751938l95.255813 98.431007c0.793798 3.175194 3.175194 6.350388 5.55659 8.731783 21.432558 22.226357 11.113178 38.896124 3.175193 46.834109-11.113178 10.31938-33.339535 18.257364-49.215503 2.381395l-30.164342-30.164341c-3.175194-6.350388-6.350388-11.906977-11.113178-17.463566l-6.350387-6.350387c-9.525581-9.525581-21.432558-16.669767-34.927132-19.844962 14.288372-29.370543 7.937984-63.503876-14.288372-86.524031l-6.350388-5.556589c-9.525581-9.525581-21.432558-15.875969-34.133333-19.844961 17.463566-30.164341 12.700775-67.472868-11.906977-92.08062l-6.350388-5.556589c-28.576744-28.576744-78.586047-28.576744-107.16279 0l-1.587597 1.587597c-3.968992-11.906977-10.31938-23.020155-19.051163-31.751938l-4.762791-6.350388c-28.576744-28.576744-78.586047-28.576744-107.16279 0l-38.102326 38.102326-48.421705-48.421706c-86.524031-86.524031-50.009302-202.418605 19.844961-273.066667 73.029457-73.823256 192.099225-112.71938 282.592248-25.40155l23.020155 22.226357-111.131783 110.337984c-22.226357 22.226357-23.020155 50.803101-2.381395 72.235659 30.95814 31.751938 113.513178 42.071318 164.316279-7.144186l42.865116-42.071318c19.051163-17.463566 39.689922-11.906977 76.99845-0.793798 43.658915 13.494574 103.193798 30.95814 167.491472-19.051163 9.525581-7.937984 11.113178-21.432558 3.175194-30.95814-7.937984-9.525581-21.432558-11.113178-30.958139-3.968992-45.246512 35.72093-84.936434 23.813953-126.213954 11.113178-38.102326-11.906977-81.76124-24.607752-121.451163 11.113179L508.031008 361.972093c-23.020155 22.226357-57.153488 25.40155-81.761241 18.257364-15.082171-4.762791-20.63876-11.113178-21.432558-12.700775 0-0.793798 0.793798-2.381395 3.968993-5.556589L581.060465 190.511628c78.586047-76.99845 198.449612-35.72093 224.644961-21.432558 28.576744 15.875969 56.35969 38.896124 81.761241 65.885271 70.648062 76.204651 121.451163 196.862016 30.164341 287.355039l-44.452713 46.04031z m0 0"  ></path></symbol><symbol id="icon-gaoxiaozhuanshufuwudefuben" viewBox="0 0 1093 1024"><path d="M846.875676 257.383784c-22.140541-24.908108-49.816216-47.048649-80.25946-63.654054-44.281081-24.908108-163.286486-52.583784-240.778378 24.908108l-27.675676 24.908108-19.372973-19.372973c-94.097297-91.32973-221.405405-58.118919-301.664865 22.140541-74.724324 74.724324-110.702703 199.264865-16.605405 293.362162L202.032432 581.189189l-8.302702 8.302703c-24.908108 24.908108-24.908108 66.421622 0 94.097297l5.535135 5.535135c13.837838 13.837838 30.443243 19.372973 49.816216 19.372973 0 16.605405 5.535135 35.978378 19.372973 47.048649l5.535135 5.535135c13.837838 13.837838 35.978378 22.140541 55.351352 19.372973 0 16.605405 8.302703 30.443243 19.372973 44.281081l5.535135 5.535135c13.837838 13.837838 33.210811 19.372973 52.583783 19.372973 0 16.605405 8.302703 33.210811 19.372973 44.281081l5.535136 5.535135c11.07027 11.07027 27.675676 19.372973 47.048648 19.372973 16.605405 0 33.210811-5.535135 47.048649-19.372973l47.048648-47.048648c5.535135-5.535135 11.07027-13.837838 13.837838-19.372973 11.07027 11.07027 27.675676 16.605405 41.513514 16.605405 19.372973 0 38.745946-8.302703 52.583784-22.14054 11.07027-11.07027 19.372973-24.908108 19.372973-41.513514 22.140541 2.767568 44.281081-5.535135 60.886486-22.14054 11.07027-11.07027 19.372973-27.675676 22.140541-47.048649 16.605405 0 33.210811-8.302703 44.281081-19.372973 24.908108-22.140541 33.210811-63.654054 8.302702-94.097297l41.513514-41.513514c88.562162-91.32973 49.816216-218.637838-30.443243-304.432432z m-581.18919 404.064865c-11.07027 11.07027-27.675676 11.07027-38.745945 0l-5.535136-5.535135c-11.07027-11.07027-11.07027-27.675676 0-38.745946l69.18919-69.18919c11.07027-11.07027 27.675676-11.07027 38.745946 0l5.535135 5.535136c11.07027 11.07027 11.07027 27.675676 0 38.745945l-69.18919 69.18919z m74.724325 71.956756c-11.07027 11.07027-27.675676 11.07027-38.745946 0l-5.535135-5.535135c-11.07027-11.07027-11.07027-27.675676 0-38.745946l110.702702-110.702702c11.07027-11.07027 27.675676-11.07027 38.745946 0l5.535136 5.535135c11.07027 11.07027 11.07027 27.675676 0 38.745946l-110.702703 110.702702z m80.259459 66.421622c-11.07027 11.07027-27.675676 11.07027-38.745946 0l-5.535135-5.535135c-11.07027-11.07027-11.07027-27.675676 0-38.745946l74.724325-74.724324c11.07027-11.07027 27.675676-11.07027 38.745945 0l5.535136 5.535135c11.07027 11.07027 11.07027 27.675676 0 38.745946l-74.724325 74.724324z m121.772973 24.908108L498.162162 869.016216c-11.07027 11.07027-27.675676 11.07027-38.745946 0l-5.535135-5.535135c-5.535135-5.535135-8.302703-11.07027-8.302703-19.372973 0-8.302703 2.767568-13.837838 8.302703-19.372973l47.048649-47.048649c8.302703-8.302703 19.372973-11.07027 27.675675-5.535135v2.767568l19.372973 19.372973c5.535135 11.07027 2.767568 22.140541-5.535135 30.443243z m262.918919-249.081081l-171.589189-179.891892c-8.302703-8.302703-19.372973-8.302703-27.675676 0-8.302703 8.302703-8.302703 19.372973 0 27.675676l193.72973 202.032432c13.837838 13.837838 5.535135 35.978378-2.767568 44.281081-8.302703 8.302703-22.140541 13.837838-38.745945-2.767567l-96.864865-99.632433c-8.302703-8.302703-19.372973-8.302703-27.675676 0-8.302703 8.302703-8.302703 19.372973 0 27.675676l5.535135 5.535135 91.32973 94.097297c19.372973 19.372973 8.302703 33.210811 0 41.513514-11.07027 11.07027-30.443243 16.605405-44.281081 2.767568L586.724324 636.540541c-8.302703-8.302703-19.372973-8.302703-27.675675 0-8.302703 8.302703-8.302703 19.372973 0 27.675675l83.027027 85.794595c0 2.767568 2.767568 5.535135 5.535135 8.302703 19.372973 19.372973 8.302703 33.210811 2.767567 41.513513-8.302703 8.302703-30.443243 16.605405-41.513513 2.767568l-27.675676-30.443244c-2.767568-5.535135-5.535135-11.07027-11.07027-13.837837l-5.535135-5.535136c-8.302703-8.302703-19.372973-13.837838-30.443243-16.605405 11.07027-24.908108 8.302703-55.351351-13.837838-74.724324l-5.535135-5.535135c-8.302703-8.302703-19.372973-13.837838-30.443244-16.605406 16.605405-24.908108 11.07027-58.118919-11.07027-80.259459V553.513514c-24.908108-24.908108-69.189189-24.908108-94.097297 0-2.767568-11.07027-8.302703-19.372973-16.605406-27.675676l-5.535135-5.535135c-24.908108-24.908108-69.189189-24.908108-94.097297 0L229.708108 553.513514l-41.513513-41.513514c-74.724324-74.724324-44.281081-177.124324 16.605405-238.010811 63.654054-63.654054 166.054054-99.632432 246.313514-22.14054l19.372972 19.372973-96.864864 96.864864c-19.372973 19.372973-19.372973 44.281081-2.767568 63.654055 27.675676 27.675676 99.632432 35.978378 143.913514-5.535136L553.513514 387.459459c16.605405-13.837838 33.210811-11.07027 66.421621 0 38.745946 11.07027 91.32973 27.675676 146.681081-16.605405 8.302703-5.535135 8.302703-19.372973 2.767568-27.675676-5.535135-8.302703-19.372973-11.07027-27.675676-2.767567-38.745946 30.443243-74.724324 22.140541-110.702703 11.07027-33.210811-11.07027-71.956757-22.140541-105.167567 11.07027l-38.745946 35.978379c-19.372973 19.372973-49.816216 22.140541-71.956757 16.605405-13.837838-2.767568-19.372973-11.07027-19.372973-11.07027s0-2.767568 2.767568-5.535135L547.978378 249.081081c69.189189-66.421622 174.356757-30.443243 196.497298-19.372973 24.908108 13.837838 49.816216 33.210811 71.956756 58.118919 60.886486 66.421622 105.167568 171.589189 27.675676 249.081081l-38.745946 38.745946z m0 0"  ></path></symbol><symbol id="icon-hailiangyouzhiziyuan" viewBox="0 0 1143 1024"><path d="M168.285271 296.086822c-12.700775 6.350388-20.63876 15.082171-20.638759 23.020155s7.144186 16.669767 20.638759 23.020155l349.271318 174.635659c15.082171 7.144186 34.927132 11.906977 56.35969 11.906976 21.432558 0 41.277519-3.968992 56.35969-11.906976l349.271318-174.635659c12.700775-6.350388 20.63876-15.082171 20.63876-23.020155s-7.144186-16.669767-20.63876-23.020155l-349.271318-174.635659c-12.700775-6.350388-30.164341-10.31938-48.421705-11.113179h-16.669768c-18.257364 0.793798-35.72093 4.762791-48.421705 11.113179l-348.47752 174.635659z m405.631008-134.945737c15.875969 0 27.782946 3.175194 33.339535 6.350388l303.231008 151.615504-303.231008 151.615504c-5.556589 3.175194-17.463566 6.350388-33.339535 6.350387s-27.782946-3.175194-33.339535-6.350387L237.345736 319.106977l303.231008-151.615504c5.556589-3.175194 17.463566-6.350388 33.339535-6.350388z"  ></path><path d="M160.347287 555.658915l342.127132 170.666666c19.844961 9.525581 45.246512 15.082171 71.44186 15.082171h2.381395c23.813953 0 47.627907-5.556589 69.060466-15.082171L987.485271 555.658915c6.350388-3.175194 11.113178-8.731783 12.700776-15.082171 2.381395-6.350388 1.587597-13.494574-1.587597-19.844961-4.762791-8.731783-13.494574-14.288372-23.020155-14.288372-3.968992 0-7.937984 0.793798-11.113179 2.381395L622.337984 680.285271c-12.700775 6.350388-29.370543 9.525581-48.421705 9.525582-19.051163 0-35.72093-3.175194-48.421705-9.525582L183.367442 509.618605c-3.968992-1.587597-7.144186-2.381395-11.906977-2.381396-9.525581 0-19.051163 5.556589-23.020155 14.288372-1.587597 3.175194-2.381395 6.350388-2.381395 9.525582v3.175194c0 2.381395 0 4.762791 1.587597 7.937984 2.381395 4.762791 6.350388 10.31938 12.700775 13.494574z"  ></path><path d="M160.347287 763.634109l342.127132 171.460465c19.844961 9.525581 45.246512 15.082171 71.44186 15.08217s51.596899-5.556589 71.441861-15.08217l342.127131-170.666667c6.350388-3.175194 11.113178-8.731783 12.700776-15.082171 2.381395-6.350388 1.587597-13.494574-1.587597-19.844961-4.762791-8.731783-13.494574-14.288372-23.020155-14.288372-3.968992 0-7.937984 0.793798-11.113179 2.381395L622.337984 889.054264c-12.700775 6.350388-29.370543 9.525581-48.421705 9.525581-19.051163 0-35.72093-3.175194-48.421705-9.525581L183.367442 716.8c-3.968992-1.587597-7.144186-2.381395-11.906977-2.381395-9.525581 0-19.051163 5.556589-23.020155 14.288372-1.587597 3.175194-2.381395 6.350388-2.381395 9.525581v1.587597c0 3.175194 0 5.556589 1.587597 7.937985 2.381395 7.144186 6.350388 12.700775 12.700775 15.875969z"  ></path></symbol><symbol id="icon-hongrentuiguang" viewBox="0 0 1024 1024"><path d="M710.121739 373.982609c0-138.017391-111.304348-247.837681-249.321739-247.837681S211.478261 235.965217 211.478261 373.982609c0 93.495652 50.457971 173.634783 127.628985 215.188405-105.368116 41.553623-185.507246 132.081159-207.768116 247.837682-2.968116 13.356522 5.936232 29.681159 22.26087 32.649275h5.936232c13.356522 0 25.228986-8.904348 28.197101-22.26087 25.228986-129.113043 138.017391-222.608696 271.582609-225.576811h4.452174c135.049275 0 246.353623-109.82029 246.353623-247.837681z m-443.733333 0c0-106.852174 86.075362-192.927536 194.411594-192.927537s194.411594 84.591304 194.411594 192.927537c0 103.884058-86.075362 189.95942-191.443478 192.927536h-8.904348c-105.368116-2.968116-188.475362-87.55942-188.475362-192.927536zM873.368116 682.666667c-2.968116-11.872464-11.872464-16.324638-22.26087-19.292754l-72.71884-11.872464-32.649276-68.266666c-5.936232-11.872464-13.356522-16.324638-25.228985-16.324638-11.872464 0-19.292754 5.936232-25.228986 16.324638l-32.649275 68.266666-72.718841 11.872464c-11.872464 2.968116-19.292754 8.904348-22.260869 19.292754-2.968116 11.872464 0 19.292754 5.936232 28.197101l51.942029 51.942029-13.356522 75.686957c-2.968116 11.872464 2.968116 22.26087 11.872464 28.197101 8.904348 5.936232 19.292754 5.936232 31.165217 2.968116l63.814493-35.617391 63.814493 35.617391c5.936232 2.968116 8.904348 2.968116 13.356521 2.968116 5.936232 0 11.872464-2.968116 16.324638-5.936232 8.904348-5.936232 13.356522-16.324638 11.872464-28.197101l-11.872464-77.171015 51.942029-51.942029c8.904348-8.904348 11.872464-19.292754 8.904348-26.713043z m-108.336232 51.942029c-5.936232 5.936232-8.904348 13.356522-8.904348 25.228985l5.936232 32.649276-28.197101-13.356522c-5.936232-2.968116-8.904348-2.968116-13.356522-2.968116-5.936232 0-8.904348 0-13.356522 2.968116l-28.197101 13.356522 5.936232-32.649276c2.968116-8.904348 0-16.324638-8.904348-25.228985l-25.228986-25.228986 32.649276-5.936232c8.904348 0 16.324638-8.904348 22.260869-16.324637l13.356522-28.197102 13.356522 28.197102c2.968116 8.904348 11.872464 13.356522 22.260869 16.324637l32.649276 5.936232-22.26087 25.228986z m0 0"  ></path></symbol><symbol id="icon-jingpinfenxi2" viewBox="0 0 1371 1024"><path d="M721.828571 224v216.228571h216.228572c0-119.314286-96.457143-216.228571-216.228572-216.228571"  ></path><path d="M688 474.514286V245.028571l-36.571429 0.914286c-128 9.6-229.485714 116.114286-229.485714 246.857143 0 136.685714 111.085714 247.771429 247.771429 247.771429 130.742857 0 237.257143-101.028571 246.857143-229.485715l0.914285-36.571428h-229.485714z m-18.285714 229.485714c-116.571429 0-211.2-94.628571-211.2-211.2 0-110.171429 84.571429-200.685714 192.914285-210.285714v228.571428h228.571429c-9.6 107.885714-100.114286 192.914286-210.285714 192.914286z"  ></path></symbol><symbol id="icon-jingzhunyonghuhuoqu1" viewBox="0 0 1024 1024"><path d="M881.197279 495.281633h-76.62585l-1.393198-14.628572c-16.021769-140.016327-129.567347-252.865306-269.583673-268.887075l-14.628572-1.393197V132.353741c0-11.145578-9.055782-20.201361-20.20136-20.20136s-20.201361 9.055782-20.201361 20.20136v77.322449l-15.32517 2.089796C321.828571 228.484354 211.765986 338.546939 195.047619 480.653061l-1.393197 14.628572H115.635374c-11.145578 0-19.504762 8.359184-20.20136 18.808163v2.089796c0.696599 11.145578 9.055782 19.504762 20.20136 19.504762h77.322449l1.393197 14.628571c15.32517 140.016327 128.17415 253.561905 268.190477 269.583674l14.628571 1.393197v75.929252c0 11.145578 9.055782 20.201361 20.201361 20.20136s20.201361-9.055782 20.20136-20.20136V821.986395l14.628572-1.393198c140.712925-15.32517 254.258503-128.870748 270.280272-269.583673l1.393197-14.628572H881.197279c11.145578 0 20.201361-9.055782 20.20136-20.20136 0-11.842177-9.055782-20.897959-20.20136-20.897959z m-119.118367 59.210884c-16.718367 115.635374-109.365986 207.586395-224.304762 224.304762l-18.808164 2.786394V660.37551c0-11.145578-9.055782-20.201361-20.20136-20.20136s-20.201361 9.055782-20.201361 20.20136v121.208163l-18.808163-2.786394C344.816327 761.382313 252.865306 668.734694 236.146939 554.492517l-2.786395-18.808163h119.814966c11.145578 0 20.201361-9.055782 20.201361-20.201361 0-11.145578-9.055782-20.201361-20.201361-20.20136H233.360544l2.786395-18.808164c17.414966-114.242177 109.365986-205.496599 222.911564-222.911564l18.808164-2.786395v119.814966c0 11.145578 9.055782 20.201361 20.20136 20.201361s20.201361-9.055782 20.201361-20.201361V250.77551l18.808163 2.786395c114.938776 16.718367 206.889796 107.972789 224.304762 222.911564l2.786394 18.808164H642.960544c-11.145578 0-20.201361 9.055782-20.20136 20.20136 0 11.145578 9.055782 20.201361 20.20136 20.201361h121.208163l-2.089795 18.808163z"  ></path><path d="M498.764626 477.866667c-20.897959 0-38.312925 17.414966-38.312925 38.312925s17.414966 38.312925 38.312925 38.312925 38.312925-17.414966 38.312925-38.312925c0-21.594558-16.718367-38.312925-38.312925-38.312925z"  ></path></symbol><symbol id="icon-shijian1" viewBox="0 0 1024 1024"><path d="M653.705051 532.169697H511.482828V334.092929c0-13.963636-11.377778-24.824242-24.824242-24.824242S461.834343 320.129293 461.834343 334.092929v222.90101c0 13.963636 11.377778 24.824242 24.824243 24.824243h167.046465c13.963636 0 24.824242-11.377778 24.824242-24.824243 0-13.963636-10.860606-24.824242-24.824242-24.824242z"  ></path><path d="M514.585859 142.222222c-213.591919 0-386.844444 173.769697-386.844445 386.844445s173.769697 386.844444 386.844445 386.844444 386.844444-173.769697 386.844444-386.844444-173.769697-386.844444-386.844444-386.844445z m0 723.523233c-185.664646 0-336.678788-151.014141-336.678788-336.678788s151.014141-336.678788 336.678788-336.678788 336.678788 151.014141 336.678787 336.678788-151.014141 336.678788-336.678787 336.678788z"  ></path></symbol><symbol id="icon-shiliangzhinengduixiang_ebc-dca" viewBox="0 0 1064 1024"><path d="M843.776 233.472H567.296v-16.384c0-10.24-8.192-18.432-18.432-18.432s-18.432 8.192-18.432 18.432v16.384H247.808c-34.816 0-63.488 28.672-63.488 63.488v366.592c0 34.816 28.672 63.488 63.488 63.488h282.624V798.72l-126.976 36.864c-4.096 2.048-8.192 4.096-10.24 8.192-2.048 4.096-2.048 8.192-2.048 14.336 2.048 8.192 8.192 12.288 16.384 12.288h4.096l133.12-38.912 129.024 38.912h6.144c8.192 0 16.384-6.144 16.384-14.336 2.048-8.192-4.096-16.384-12.288-18.432L565.248 798.72v-71.68h278.528c34.816 0 63.488-28.672 63.488-63.488V296.96c0-34.816-28.672-63.488-63.488-63.488z m28.672 430.08c0 16.384-12.288 28.672-28.672 28.672H247.808c-16.384 0-28.672-12.288-28.672-28.672V296.96c0-16.384 12.288-28.672 28.672-28.672h595.968c16.384 0 28.672 12.288 28.672 28.672v366.592z"  ></path><path d="M630.784 403.456c-4.096-4.096-8.192-6.144-12.288-6.144-4.096 0-8.192 2.048-12.288 6.144l-126.976 126.976-129.024-129.024c-4.096-4.096-8.192-4.096-12.288-4.096-4.096 0-8.192 2.048-12.288 6.144-6.144 6.144-6.144 18.432 0 24.576l143.36 143.36c4.096 4.096 8.192 6.144 12.288 6.144 4.096 0 8.192-2.048 12.288-6.144l126.976-126.976 122.88 122.88c4.096 4.096 8.192 4.096 12.288 4.096 4.096 0 8.192-2.048 12.288-6.144 6.144-6.144 6.144-18.432 0-24.576l-137.216-137.216z"  ></path></symbol><symbol id="icon-shiliangzhinengduixiang_ebc-dca1" viewBox="0 0 1193 1024"><path d="M553.890909 919.272727c-51.2 0-100.072727-9.309091-146.618182-30.254545-44.218182-18.618182-86.109091-46.545455-118.690909-81.454546-34.909091-34.909091-62.836364-74.472727-81.454545-118.690909-18.618182-46.545455-30.254545-95.418182-30.254546-146.618182S186.181818 442.181818 207.127273 395.636364c18.618182-44.218182 46.545455-86.109091 81.454545-118.690909 34.909091-34.909091 74.472727-62.836364 118.690909-81.454546 46.545455-18.618182 95.418182-30.254545 146.618182-30.254545 11.636364 0 20.945455 9.309091 20.945455 20.945454s-9.309091 20.945455-20.945455 20.945455C370.036364 209.454545 218.763636 358.4 218.763636 544.581818s148.945455 332.8 332.8 332.8S884.363636 728.436364 884.363636 544.581818c0-11.636364 9.309091-20.945455 20.945455-20.945454s20.945455 9.309091 20.945454 20.945454c0 51.2-9.309091 100.072727-30.254545 146.618182-18.618182 44.218182-46.545455 86.109091-81.454545 118.690909-34.909091 34.909091-74.472727 62.836364-118.69091 81.454546-41.890909 18.618182-90.763636 27.927273-141.963636 27.927272z m0 0"  ></path><path d="M989.090909 500.363636h-372.363636c-11.636364 0-20.945455-9.309091-20.945455-20.945454v-372.363637c0-4.654545 2.327273-11.636364 6.981818-16.290909 4.654545-4.654545 9.309091-6.981818 16.290909-6.981818 53.527273 0 104.727273 9.309091 153.6 30.254546 46.545455 20.945455 88.436364 48.872727 125.672728 83.781818 37.236364 37.236364 65.163636 79.127273 83.781818 125.672727 20.945455 48.872727 30.254545 100.072727 30.254545 153.6-2.327273 13.963636-11.636364 23.272727-23.272727 23.272727z m-351.418182-44.218181h328.145455C956.509091 281.6 814.545455 139.636364 637.672727 128v328.145455z m0 0"  ></path></symbol><symbol id="icon-shiliangzhinengduixiang_ebc-dca2" viewBox="0 0 1024 1024"><path d="M309.527273 795.927273c-4.654545 0-11.636364 0-16.290909-4.654546-11.636364-11.636364-16.290909-27.927273-4.654546-39.563636l111.709091-167.563636c4.654545-4.654545 16.290909-11.636364 23.272727-11.636364h144.290909L616.727273 372.363636c0-4.654545 4.654545-11.636364 11.636363-16.290909l167.563637-111.709091c16.290909-11.636364 32.581818-4.654545 44.218182 4.654546 11.636364 11.636364 4.654545 27.927273-4.654546 39.563636l-162.909091 107.054546-55.854545 211.781818c0 11.636364-11.636364 23.272727-27.927273 23.272727h-151.272727l-104.727273 155.927273c-6.981818 4.654545-11.636364 9.309091-23.272727 9.309091z m0 0"  ></path><path d="M872.727273 907.636364H197.818182c-16.290909 0-27.927273-11.636364-27.927273-27.927273V211.781818c0-16.290909 11.636364-27.927273 27.927273-27.927273s27.927273 11.636364 27.927273 27.927273v640H872.727273c16.290909 0 27.927273 11.636364 27.927272 27.927273S884.363636 907.636364 872.727273 907.636364z m0 0"  ></path></symbol><symbol id="icon-shiliangzhinengduixiang_ebc-dca3" viewBox="0 0 1150 1024"><path d="M341.333333 935.506173c-2.528395 0-5.05679 0-7.585185-2.528395-7.585185-5.05679-12.641975-12.641975-10.11358-20.227161l10.11358-265.481481c0-7.585185 2.528395-12.641975 7.585185-17.698766L783.802469 310.992593c2.528395-2.528395 7.585185-2.528395 10.11358-2.528395 7.585185 0 12.641975 2.528395 15.170371 10.11358 2.528395 5.05679 2.528395 10.11358 2.528395 15.17037 0 5.05679-2.528395 10.11358-7.585185 12.641975L371.674074 662.439506l-7.585185 202.271605 50.567901-53.096296c2.528395-5.05679 7.585185-5.05679 12.641975-5.05679s10.11358 2.528395 12.641976 5.05679c5.05679 5.05679 5.05679 10.11358 5.05679 15.17037 0 5.05679-2.528395 10.11358-5.05679 15.170371l-83.437037 91.022222c-5.05679 2.528395-10.11358 2.528395-15.170371 2.528395z m240.197531-17.698766c-5.05679 0-10.11358-2.528395-12.641975-5.05679l-118.834568-141.590123c-5.05679-5.05679-5.05679-10.11358-5.05679-15.170371 0-5.05679 0-10.11358 5.05679-15.17037 2.528395-5.05679 7.585185-7.585185 12.641975-7.585185s7.585185 2.528395 12.641976 5.05679l103.664197 123.891358L993.659259 187.101235 182.044444 437.412346l98.607408 103.664197c2.528395 5.05679 5.05679 10.11358 5.05679 15.170371 0 5.05679 0 10.11358-5.05679 15.17037-2.528395 5.05679-7.585185 7.585185-12.641975 7.585185s-10.11358-2.528395-12.641976-5.05679l-123.891358-131.476543c-2.528395-5.05679-5.05679-12.641975-2.528395-20.227161 2.528395-7.585185 5.05679-12.641975 12.641975-15.17037L1031.585185 131.476543h5.05679c5.05679 0 12.641975 2.528395 15.170371 7.585185 5.05679 7.585185 5.05679 17.698765 0 25.283951L596.701235 910.222222c-2.528395 2.528395-7.585185 7.585185-15.170371 7.585185z m0 0"  ></path></symbol><symbol id="icon-shiliangzhinengduixiang_ebc-dca4" viewBox="0 0 1224 1024"><path d="M407.218605 400.074419c11.906977 33.339535 35.72093 52.390698 61.916279 52.390697s50.009302-19.051163 59.534883-52.390697c9.525581-7.144186 14.288372-16.669767 16.669768-28.576745 2.381395-14.288372 0-23.813953-7.144186-28.576744l-2.381396-2.381395c-4.762791-35.72093-30.95814-59.534884-66.679069-59.534884-38.102326 0-64.297674 21.432558-69.060465 59.534884-2.381395 0-2.381395 2.381395-4.762791 2.381395-7.144186 9.525581-7.144186 23.813953-4.762791 28.576744 0 11.906977 7.144186 21.432558 16.669768 28.576745z m16.669767-38.102326v-11.906977c2.381395-28.576744 16.669767-40.483721 42.865116-40.483721 33.339535 0 40.483721 26.195349 40.483721 40.483721v11.906977h7.144186v4.762791c0 4.762791-4.762791 9.525581-9.525581 14.288372l-4.762791 2.381395-2.381395 4.762791c-7.144186 23.813953-21.432558 38.102326-35.72093 38.102325s-28.576744-14.288372-35.720931-38.102325l2.381396-4.762791-2.381396-2.381395c-4.762791-2.381395-7.144186-7.144186-9.525581-14.288372v-4.762791h7.144186z"  ></path><path d="M902.548837 180.986047H323.869767c-76.204651 0-140.502326 64.297674-140.502325 140.502325v366.734884c0 47.627907 23.813953 92.874419 64.297674 119.069767 9.525581 7.144186 23.813953 2.381395 28.576744-9.525581 4.762791-9.525581 0-19.051163-7.144186-23.813954-28.576744-19.051163-47.627907-50.009302-47.627907-85.730232V321.488372c0-57.153488 45.246512-102.4 102.4-102.4h576.297675c57.153488 0 102.4 45.246512 102.4 102.4v328.632558c0 57.153488-45.246512 102.4-102.4 102.4H690.604651c-9.525581 0-19.051163 9.525581-19.051163 19.051163s9.525581 19.051163 19.051163 19.051163h211.944186c76.204651 0 140.502326-64.297674 140.502326-140.502326V321.488372c-2.381395-78.586047-64.297674-140.502326-140.502326-140.502325z"  ></path><path d="M738.232558 426.269767h157.172093c7.144186 0 9.525581-7.144186 9.525582-11.906976 0-7.144186-4.762791-11.906977-9.525582-11.906977H738.232558c-7.144186 0-9.525581 7.144186-9.525581 11.906977s4.762791 9.525581 9.525581 11.906976zM897.786047 371.497674c7.144186 0 11.906977-7.144186 11.906976-11.906976 0-7.144186-4.762791-11.906977-9.525581-11.906977h-157.172093c-7.144186 0-9.525581 7.144186-9.525582 11.906977 0 7.144186 4.762791 11.906977 9.525582 11.906976h154.790698zM726.325581 521.525581l-116.688372 116.688372v-107.16279c0-40.483721-28.576744-73.823256-66.679069-80.967442l-35.720931-7.144186-4.76279 9.525581c-4.762791 7.144186-9.525581 14.288372-19.051163 19.051163-19.051163 9.525581-42.865116 0-50.009303-16.669767l-4.76279-11.906977-35.72093 7.144186c-38.102326 7.144186-66.67907 40.483721-66.67907 80.967442v178.604651c0 28.576744 19.051163 52.390698 45.246511 57.153488 2.381395 4.762791 4.762791 9.525581 7.144186 11.906977 7.144186 7.144186 16.669767 11.906977 26.195349 11.906977h123.832558c14.288372 0 28.576744-9.525581 33.339535-23.813954 26.195349-4.762791 45.246512-28.576744 45.246512-57.153488v-28.576744l138.12093-138.12093c4.762791-4.762791 4.762791-14.288372 0-19.051163l-2.381395-2.381396c-2.381395-4.762791-11.906977-4.762791-16.669768 0z m-147.646511 154.790698v35.72093c0 16.669767-11.906977 26.195349-26.195349 26.195349h-16.669768v16.669768c0 2.381395-2.381395 7.144186-7.144186 7.144186H404.837209c-2.381395 0-2.381395 0-4.76279-2.381396 0 0-2.381395-2.381395-2.381396-4.76279V738.232558H381.023256c-16.669767 0-28.576744-11.906977-28.576744-28.576744v-178.604651c0-23.813953 16.669767-45.246512 42.865116-50.009303l11.906977-2.381395c11.906977 16.669767 33.339535 28.576744 57.153488 28.576744s42.865116-11.906977 57.153488-28.576744l11.906977 2.381395c23.813953 4.762791 42.865116 26.195349 42.865116 50.009303v145.265116z"  ></path></symbol><symbol id="icon-shijianyingxiao1" viewBox="0 0 1024 1024"><path d="M840.677966 193.084746h-114.983051V134.508475c0-17.355932-10.847458-28.20339-28.20339-28.20339s-28.20339 10.847458-28.203389 28.20339v56.406779H326.508475V134.508475c0-17.355932-10.847458-28.20339-28.20339-28.20339s-28.20339 10.847458-28.20339 28.20339v56.406779H155.118644c-30.372881 0-56.40678 26.033898-56.40678 56.40678V846.101695c0 30.372881 26.033898 56.40678 56.40678 56.40678h685.559322c30.372881 0 56.40678-26.033898 56.40678-56.40678V249.491525c0-30.372881-26.033898-56.40678-56.40678-56.406779zM155.118644 249.491525H267.932203v30.372882c0 17.355932 10.847458 28.20339 28.20339 28.20339s28.20339-10.847458 28.20339-28.20339v-30.372882h342.779661v30.372882c0 17.355932 10.847458 28.20339 28.20339 28.20339s28.20339-10.847458 28.20339-28.20339v-30.372882h114.983051v114.983051H155.118644v-114.983051z m685.559322 598.779661H155.118644V420.881356h685.559322v427.38983z m0 0"  ></path><path d="M267.932203 592.271186h457.762712c17.355932 0 28.20339-10.847458 28.20339-28.203389s-10.847458-28.20339-28.20339-28.20339H267.932203c-17.355932 0-28.20339 10.847458-28.203389 28.20339s13.016949 28.20339 28.203389 28.203389z m0 143.186441h457.762712c17.355932 0 28.20339-10.847458 28.20339-28.20339s-10.847458-28.20339-28.20339-28.20339H267.932203c-17.355932 0-28.20339 10.847458-28.203389 28.20339 0 15.186441 13.016949 28.20339 28.203389 28.20339z m0 0"  ></path></symbol><symbol id="icon-shiliangzhinengduixiang_ebc-dca5" viewBox="0 0 1223 1024"><path d="M930.909091 800.581818H297.890909c-18.618182 0-34.576623-7.979221-47.875325-21.277922s-21.277922-29.257143-21.277922-47.875325V236.716883c0-18.618182 7.979221-34.576623 21.277922-47.875325s29.257143-21.277922 47.875325-21.277922H930.909091c18.618182 0 34.576623 7.979221 47.875325 21.277922s21.277922 29.257143 21.277922 47.875325v494.711688c0 18.618182-7.979221 34.576623-21.277922 47.875325s-29.257143 21.277922-47.875325 21.277922z m26.597403-577.163636c0-5.319481 0-7.979221-2.659741-10.638961-2.65974-2.65974-5.319481-5.319481-10.638961-5.319481H284.592208c-7.979221 0-13.298701 5.319481-13.298702 13.298702V744.727273c0 2.65974 2.65974 7.979221 5.319481 10.638961 2.65974 2.65974 5.319481 5.319481 10.638961 5.31948h662.275325c7.979221 0 13.298701-5.319481 13.298701-13.298701V223.418182z m-122.348052 454.815584H367.044156c-2.65974 0-7.979221-2.65974-10.638961-5.31948-2.65974-2.65974-5.319481-5.319481-5.319481-10.638961V332.467532c0-7.979221 5.319481-13.298701 13.298702-13.298701h13.298701c7.979221 0 13.298701 5.319481 13.298701 13.298701v303.21039h441.516883c7.979221 0 13.298701 5.319481 13.298702 13.298701v13.298702c0 2.65974-2.65974 7.979221-5.319481 10.638961 0 2.65974-2.65974 5.319481-5.31948 5.31948z m-29.257143-103.72987c-2.65974 5.319481-7.979221 7.979221-10.638961 7.979221h-13.298702c-2.65974 0-7.979221-2.65974-10.638961-5.319481-2.65974-2.65974-5.319481-5.319481-5.31948-10.638961v-178.202597c0-2.65974 2.65974-7.979221 5.31948-10.638961 2.65974-2.65974 5.319481-5.319481 10.638961-5.319481h13.298702c2.65974 0 7.979221 2.65974 10.638961 5.319481 2.65974 2.65974 5.319481 5.319481 5.31948 10.638961v178.202597c-5.319481 2.65974-5.319481 2.65974-5.31948 7.979221 0-2.65974 0-2.65974 0 0z m-122.348052 5.319481h-13.298702c-2.65974 0-7.979221-2.65974-10.638961-5.319481-2.65974-2.65974-5.319481-5.319481-5.31948-10.638961V425.558442c0-2.65974 2.65974-7.979221 5.31948-10.638961 2.65974-2.65974 5.319481-5.319481 10.638961-5.319481h13.298702c2.65974 0 7.979221 2.65974 10.638961 5.319481 2.65974 2.65974 5.319481 5.319481 5.31948 10.638961v138.306493c0 2.65974-2.65974 7.979221-5.31948 10.638961-5.319481 5.319481-7.979221 5.319481-10.638961 5.319481z m-101.07013-2.659741c-2.65974 2.65974-5.319481 5.319481-10.638961 5.319481H558.545455c-2.65974 0-7.979221-2.65974-10.638961-5.319481-2.65974-2.65974-5.319481-5.319481-5.319481-10.638961v-95.750649c0-7.979221 5.319481-13.298701 13.298701-13.298701h13.298702c7.979221 0 13.298701 5.319481 13.298701 13.298701v95.750649c2.65974 5.319481 2.65974 7.979221 0 10.638961z m-119.688312 2.659741h-13.298701c-2.65974 0-7.979221-2.65974-10.638961-5.319481-2.65974-2.65974-5.319481-5.319481-5.319481-10.638961v-42.555844c0-2.65974 2.65974-7.979221 5.319481-10.638961 2.65974-2.65974 5.319481-5.319481 10.638961-5.319481h13.298701c7.979221 0 13.298701 5.319481 13.298701 13.298702v42.555844c0 13.298701-5.319481 18.618182-13.298701 18.618182z m-111.709091 263.314285h523.968831c7.979221 0 13.298701 5.319481 13.298702 13.298702v13.298701c0 7.979221-5.319481 13.298701-13.298702 13.298701H351.085714c-7.979221 0-13.298701-5.319481-13.298701-13.298701v-13.298701c0-7.979221 7.979221-13.298701 13.298701-13.298702z m0 0"  ></path></symbol><symbol id="icon-tishengzhuanhuashuai1" viewBox="0 0 1031 1024"><path d="M520.594724 123.60032c-174.35012 0-330.692246 107.229416-388.808953 266.845723l48.294165 16.370903c51.568345-139.971223 188.265388-233.285372 340.514788-233.285371 85.947242 0 168.620304 30.286171 234.103917 84.310152 64.665068 54.023981 108.047962 127.693046 121.96323 208.729016l1.63709 9.003997-55.661071-36.015987-28.649081 40.927258 99.043965 63.846523c4.092726 2.455635 9.003997 4.092726 13.915268 4.092726 4.092726 0 8.185452-0.818545 12.278177-3.274181 8.185452-4.092726 13.915268-13.096723 13.915268-22.100719 0-219.370104-184.991207-399.45004-412.546763-399.45004zM523.868905 894.669864c-85.947242 0-168.620304-30.286171-234.103917-84.310152-64.665068-54.023981-108.047962-127.693046-121.963229-208.729017l-1.637091-9.003996 55.661071 36.015987 28.649081-41.745804-98.22542-63.027977c-4.092726-2.455635-9.003997-4.092726-13.915267-4.092726-4.092726 0-8.185452 0.818545-12.278178 3.274181-8.185452 4.092726-13.915268 13.096723-13.915268 22.100719 0 221.007194 184.991207 400.268585 411.728218 400.268585 174.35012 0 330.692246-107.229416 388.808953-266.845723l-48.294165-16.370903c-50.7498 138.334133-187.446843 232.466827-340.514788 232.466826z"  ></path><path d="M640.920863 374.07514l-8.185451-5.729816c-2.455635-1.63709-5.729816-2.455635-8.185452-2.455636H622.094325c-4.092726 0.818545-7.366906 2.455635-9.822542 5.729816L400.268585 673.66267c-4.911271 6.548361-3.274181 15.552358 3.274181 20.463629l8.185451 5.729816c2.455635 1.63709 5.729816 2.455635 8.185452 2.455636h2.455636c4.092726-0.818545 7.366906-3.274181 9.822542-5.729817l212.003197-302.043165c2.455635-3.274181 3.274181-7.366906 2.455635-10.641087 0-4.092726-2.455635-8.185452-5.729816-9.822542zM538.602718 618.001599c0 37.653078 30.286171 67.939249 67.939248 67.939248 37.653078 0 67.939249-30.286171 67.939249-67.939248 0-37.653078-30.286171-67.939249-67.939249-67.939249-37.653078 0-67.939249 30.286171-67.939248 67.939249z m69.576339-40.927258c13.915268 0 27.01199 7.366906 34.378897 19.645083 7.366906 12.278177 7.366906 27.830536 0 40.108713-7.366906 12.278177-20.463629 19.645084-34.378897 19.645084h-0.818545c-21.282174-0.818545-39.290168-18.007994-39.290168-40.108713 0-21.282174 17.189448-39.290168 39.290168-40.108713l0.818545 0.818546zM438.740208 382.260592c-23.73781 0-46.657074 13.096723-58.935252 33.560351-12.278177 21.282174-12.278177 46.657074 0 67.939249 12.278177 21.282174 34.378897 33.560352 58.935252 33.560352 37.653078 0 67.939249-30.286171 67.939248-67.939249 0-36.015987-30.286171-67.120703-67.939248-67.120703z m35.197442 87.584332c-7.366906 12.278177-20.463629 19.645084-34.378897 19.645084h-1.63709c-21.282174-0.818545-38.471623-18.007994-38.471623-40.108713 0-21.282174 17.189448-39.290168 38.471623-40.108713h1.63709c13.915268 0 27.01199 7.366906 34.378897 19.645084 7.366906 13.096723 7.366906 28.649081 0 40.927258z"  ></path></symbol><symbol id="icon-xinxiliuguanggao1" viewBox="0 0 1051 1024"><path d="M912.457143 109.714286H111.542857C78.628571 109.714286 53.028571 138.971429 53.028571 175.542857v652.8c0 36.571429 25.6 65.828571 56.685715 65.828572h802.742857c31.085714 0 56.685714-29.257143 56.685714-65.828572V175.542857c1.828571-36.571429-23.771429-65.828571-56.685714-65.828571z m0 718.628571H111.542857V175.542857H914.285714v652.8z m0 0"  ></path><path d="M224.914286 716.8h171.885714c31.085714 0 56.685714-25.6 56.685714-56.685714v-171.885715c0-31.085714-25.6-56.685714-56.685714-56.685714h-171.885714c-31.085714 0-56.685714 25.6-56.685715 56.685714v171.885715c0 31.085714 25.6 56.685714 56.685715 56.685714z m0-228.571429h171.885714v171.885715h-171.885714v-171.885715z m-27.428572-144.457142h630.857143c16.457143 0 29.257143-12.8 29.257143-29.257143 0-16.457143-12.8-29.257143-29.257143-29.257143H197.485714c-16.457143 0-29.257143 12.8-29.257143 29.257143 0 16.457143 12.8 29.257143 29.257143 29.257143z m629.028572 85.942857H541.257143c-16.457143 0-29.257143 12.8-29.257143 29.257143 0 16.457143 12.8 29.257143 29.257143 29.257142h287.085714c16.457143 0 29.257143-12.8 29.257143-29.257142-1.828571-16.457143-14.628571-29.257143-31.085714-29.257143z m0 115.2H541.257143c-16.457143 0-29.257143 12.8-29.257143 29.257143 0 16.457143 12.8 29.257143 29.257143 29.257142h287.085714c16.457143 0 29.257143-12.8 29.257143-29.257142-1.828571-16.457143-14.628571-29.257143-31.085714-29.257143z m0 115.2H541.257143c-16.457143 0-29.257143 12.8-29.257143 29.257143 0 16.457143 12.8 29.257143 29.257143 29.257142h287.085714c16.457143 0 29.257143-12.8 29.257143-29.257142-1.828571-16.457143-14.628571-29.257143-31.085714-29.257143z m0 0"  ></path></symbol><symbol id="icon-weixingongzhonghao" viewBox="0 0 1269 1024"><path d="M827.392 360.448c8.192 0 13.653333 0 21.845333 2.730667-32.768-133.802667-174.762667-232.106667-344.064-232.106667-196.608 0-352.256 131.072-352.256 294.912 0 95.573333 54.613333 182.954667 139.264 234.837333l-32.768 87.381334 120.149334-49.152c38.229333 13.653333 81.92 21.845333 128.341333 21.845333 10.922667 0 21.845333 0 32.768-2.730667-13.653333-27.306667-21.845333-60.074667-21.845333-95.573333-2.730667-144.725333 133.802667-262.144 308.565333-262.144zM628.053333 267.605333c32.768 0 57.344 21.845333 57.344 49.152s-24.576 49.152-57.344 49.152-57.344-21.845333-57.344-49.152 24.576-49.152 57.344-49.152z m-245.76 98.304c-32.768 0-57.344-21.845333-57.344-49.152s24.576-49.152 57.344-49.152 57.344 21.845333 57.344 49.152-27.306667 49.152-57.344 49.152z"  ></path><path d="M1125.034667 630.784c0-136.533333-131.072-248.490667-292.181334-248.490667-161.109333 0-292.181333 109.226667-292.181333 248.490667 0 136.533333 131.072 248.490667 292.181333 248.490667 38.229333 0 73.728-8.192 109.226667-19.114667l98.304 38.229333-27.306667-73.728c68.266667-43.690667 114.688-114.688 111.957334-193.877333z m-398.677334-40.96c-24.576 0-46.421333-16.384-46.421333-38.229333 0-21.845333 21.845333-38.229333 46.421333-38.229334s46.421333 16.384 46.421334 38.229334c0 19.114667-21.845333 38.229333-46.421334 38.229333z m202.069334 0c-24.576 0-46.421333-16.384-46.421334-38.229333 0-21.845333 21.845333-38.229333 46.421334-38.229334 24.576 0 46.421333 16.384 46.421333 38.229334 0 19.114667-21.845333 38.229333-46.421333 38.229333z"  ></path></symbol><symbol id="icon-hangyefenxi2" viewBox="0 0 1118 1024"><path d="M318.012422 232.785093c-38.585507 0-69.538716 31.377226-69.538716 69.538717 0 38.161491 31.377226 69.538716 69.538716 69.538716 38.585507 0 69.538716-31.377226 69.538717-69.538716 0-38.585507-31.377226-69.538716-69.538717-69.538717z m153.493996 302.32381L534.26087 513.060041l5.088198-1.696066 4.664183 2.5441 47.489855 29.681159 39.43354-111.940373 6.360248-16.960662 12.296481 13.144513 36.041408 38.161491 52.578053-90.315528 19.080746 11.024431-59.786336 103.036024-7.208281 12.720497-10.176398-10.600414-33.497308-36.041408-37.737474 108.124224-4.664183 13.144513-11.448447-7.208281-54.698136-34.345342-57.666253 19.928779-8.904348-20.352795z m11.448447 273.490683H695.387164v37.313457h-212.432299v-37.313457z m133.565218-120.844721h228.120911V252.289855H423.16853V296.811594h377.798758v347.269565h-359.566046v44.52174h114.908489v109.396273h60.634368v-110.244307zM199.287785 570.302277l44.097722 33.073292-14.416563 242.961491h63.602485l10.600414-207.344099h27.13706l13.144513 207.344099h59.786336l-9.328365-242.961491-5.088199-148.405797 145.437682-2.120083 31.377225-55.122153L402.391718 390.095238H328.612836l5.512216 9.328364-7.632298 14.416564 15.688612 111.940372-24.168944 25.016978v2.120082l-0.848033-1.272049-1.272049 1.272049v-2.120082l-24.592961-25.440994 15.688613-111.940373-7.208282-14.84058 5.512215-9.328364H232.785093L199.287785 570.302277z m0 0"  ></path></symbol><symbol id="icon-yingyongshangdiantuiguang" viewBox="0 0 1051 1024"><path d="M853.942857 897.828571H629.028571c-38.4 0-69.485714-31.085714-69.485714-69.485714V605.257143c0-38.4 31.085714-69.485714 69.485714-69.485714h224.914286c38.4 0 69.485714 31.085714 69.485714 69.485714v224.914286c0 36.571429-31.085714 67.657143-69.485714 67.657142zM629.028571 601.6c-1.828571 0-1.828571 1.828571-1.828571 1.828571v224.914286c0 1.828571 0 1.828571 1.828571 1.828572h224.914286c1.828571 0 1.828571-1.828571 1.828572-1.828572V605.257143c0-1.828571 0-1.828571-1.828572-1.828572H629.028571zM426.057143 897.828571H201.142857c-38.4 0-69.485714-31.085714-69.485714-69.485714V605.257143c0-38.4 31.085714-69.485714 69.485714-69.485714h226.742857c38.4 0 69.485714 31.085714 69.485715 69.485714v224.914286c-1.828571 36.571429-32.914286 67.657143-71.314286 67.657142zM201.142857 601.6c-1.828571 0-1.828571 1.828571-1.828571 1.828571v224.914286c0 1.828571 1.828571 1.828571 1.828571 1.828572h226.742857c1.828571 0 1.828571-1.828571 1.828572-1.828572V605.257143c0-1.828571-1.828571-1.828571-1.828572-1.828572H201.142857zM853.942857 469.942857H629.028571c-38.4 0-69.485714-31.085714-69.485714-69.485714V177.371429c0-38.4 31.085714-69.485714 69.485714-69.485715h224.914286c38.4 0 69.485714 31.085714 69.485714 69.485715v223.085714c0 38.4-31.085714 69.485714-69.485714 69.485714zM629.028571 175.542857c-1.828571 0-1.828571 0-1.828571 1.828572v223.085714c0 1.828571 0 1.828571 1.828571 1.828571h224.914286c1.828571 0 1.828571 0 1.828572-1.828571V177.371429c0-1.828571 0-1.828571-1.828572-1.828572H629.028571zM426.057143 469.942857H201.142857c-38.4 0-69.485714-31.085714-69.485714-69.485714V177.371429C131.657143 138.971429 162.742857 109.714286 201.142857 109.714286h226.742857c38.4 0 69.485714 31.085714 69.485715 69.485714V402.285714c-1.828571 36.571429-32.914286 67.657143-71.314286 67.657143zM201.142857 175.542857c-1.828571 0-1.828571 1.828571-1.828571 1.828572v223.085714c0 1.828571 1.828571 1.828571 1.828571 1.828571h226.742857c1.828571 0 1.828571-1.828571 1.828572-1.828571V177.371429c0-1.828571-1.828571-1.828571-1.828572-1.828572H201.142857z"  ></path></symbol><symbol id="icon-yonghufenxi2" viewBox="0 0 1172 1024"><path d="M790.371072 234.951356h-31.29746c-11.901851 0-20.718037 8.816186-20.718037 20.718037v433.31554c0 11.901851 8.816186 20.718037 20.718037 20.718037h31.29746c11.901851 0 20.718037-8.816186 20.718037-20.718037V255.669393c0-11.901851-10.579423-20.718037-20.718037-20.718037zM296.223848 341.627206h-29.534223c-11.901851 0-20.718037 8.816186-20.718037 20.718037v326.63969c0 11.901851 8.816186 20.718037 20.718037 20.718037h31.297461c11.901851 0 20.718037-8.816186 20.718037-20.718037V362.345243c0-10.138614-10.579423-20.718037-22.481275-20.718037z m602.586311-179.409384h-31.29746c-11.901851 0-20.718037 8.816186-20.718037 20.718037v506.049074c0 11.901851 8.816186 20.718037 20.718037 20.718037h31.29746c11.901851 0 20.718037-8.816186 20.718037-20.718037V182.935859c0-11.901851-9.256995-20.718037-20.718037-20.718037z m-201.890658 516.187688V377.332759c0-3.085665-1.322428-5.730521-3.085665-7.493758L597.296599 273.301765c-4.408093-4.408093-10.579423-4.408093-14.987516 0s-4.408093 10.579423 0 14.987516l80.227292 80.227292h-105.353422v-132.242789c0-5.730521-4.408093-10.579423-10.579423-10.579423H360.141197c-5.730521 1.322428-10.579423 5.730521-10.579423 10.579423v461.527335c0 5.730521 4.408093 10.579423 10.579423 10.579423h304.158416l44.521739 48.929833c5.730521 5.730521 16.309944 5.730521 20.718037 0l14.987516-14.987517c5.730521-5.730521 5.730521-16.309944 0-22.040465l-47.607404-41.876883zM370.279811 688.984933V246.853207h167.507533v130.479552c0 5.730521 4.408093 10.579423 10.579423 10.579424h129.157125v274.624192l-38.350409-32.619888c-1.322428-1.322428-3.085665-3.085665-5.730521-4.408093 17.632372-22.040465 28.211795-50.25226 28.211795-80.227292 0-72.733534-57.746018-130.479552-129.157125-130.479552-70.970297 0-129.157124 57.746018-129.157124 130.479552s57.746018 130.479552 129.157124 130.479552c28.211795 0 55.101162-8.816186 75.8192-25.12613 1.322428 3.085665 4.408093 4.408093 5.730521 5.730521l32.619888 32.619888H370.279811z m250.82049-145.467068c0 48.929832-40.113646 89.043478-89.043478 89.043478s-89.043478-40.113646-89.043478-89.043478 40.113646-89.043478 89.043478-89.043478 89.043478 40.113646 89.043478 89.043478z m0 0"  ></path></symbol><symbol id="icon-yingyongshangdianyouhua" viewBox="0 0 1223 1024"><path d="M697.024857 626.539197c-39.1587 39.1587-80.275335 74.40153-119.434035 103.770554-41.116635-31.32696-80.275335-66.56979-119.434034-103.770554-39.1587-39.1587-74.40153-78.3174-103.770555-119.434034 31.32696-41.116635 66.56979-80.275335 103.770555-119.434035 39.1587-39.1587 78.3174-74.40153 119.434034-103.770554 39.1587 31.32696 80.275335 66.56979 119.434035 103.770554 39.1587 39.1587 74.40153 80.275335 103.770554 119.434035-29.369025 41.116635-64.611855 80.275335-103.770554 119.434034M248.657744 837.996176c-27.41109-27.41109-23.49522-90.06501 11.74761-170.340344 15.66348-37.200765 39.1587-78.3174 66.569789-117.4761 29.369025 37.200765 62.65392 76.359465 99.854685 111.602295 35.24283 35.24283 74.40153 70.48566 111.602294 99.854684-135.097514 90.06501-250.615679 117.476099-289.774378 76.359465m697.024856-189.919694c-19.57935-45.032505-46.99044-92.022945-80.275334-139.013384 21.537285-31.32696 41.116635-62.65392 58.738049-93.98088 5.873805-11.74761 1.957935-27.41109-9.789674-33.284895-5.873805-3.91587-11.74761-3.91587-19.57935-1.957935-5.873805 1.957935-11.74761 5.873805-15.66348 11.74761-13.705545 25.453155-29.369025 50.90631-45.032505 74.40153-29.369025-37.200765-62.65392-76.359465-99.854685-111.602295-37.200765-37.200765-74.40153-70.48566-111.602294-99.854684 41.116635-27.41109 80.275335-50.90631 117.476099-66.56979 80.275335-35.24283 142.929254-39.1587 170.340345-11.74761 11.74761 11.74761 17.621415 29.369025 17.621414 50.90631 0 13.705545 11.74761 25.453155 25.453155 23.49522 5.873805 0 13.705545-3.91587 17.621415-7.83174 3.91587-3.91587 7.83174-11.74761 5.873805-17.621415-1.957935-35.24283-11.74761-62.65392-33.284895-84.191205-43.07457-45.032505-123.349904-43.07457-225.162524 0-45.032505 19.57935-92.022945 46.99044-139.013384 80.275335-99.854685-70.48566-197.751434-113.560229-272.152964-113.56023-13.705545 0-25.453155 11.74761-25.453154 25.453155 0 13.705545 11.74761 25.453155 25.453154 25.453155 60.695985 0 142.929254 37.200765 231.036329 95.938815-37.200765 29.369025-76.359465 62.65392-111.602294 99.854684-37.200765 37.200765-70.48566 74.40153-99.854685 111.602295-50.90631-74.40153-84.191205-146.845124-93.980879-205.583174-1.957935-13.705545-15.66348-23.49522-27.41109-21.537285-13.705545 1.957935-23.49522 15.66348-21.537285 27.41109 9.789675 68.527725 50.90631 154.676864 111.602295 240.826004-33.284895 46.99044-60.695985 95.938815-80.275335 140.971319-45.032505 101.81262-45.032505 182.087954 0 227.120459 21.537285 21.537285 52.864245 33.284895 92.022944 33.284895s84.191205-11.74761 135.097515-33.284895c93.98088-41.116635 199.709369-117.476099 293.690248-211.456979 37.200765-37.200765 70.48566-74.40153 99.854685-111.602295 90.06501 133.139579 117.476099 248.657744 76.359465 289.774379-29.369025 29.369025-92.022945 23.49522-172.29828-11.74761-5.873805-1.957935-13.705545-1.957935-19.57935 0-5.873805 1.957935-11.74761 7.83174-13.705544 13.705545-5.873805 11.74761 0 27.41109 13.705544 33.284895 50.90631 23.49522 97.89675 33.284895 137.05545 33.284895 37.200765 0 68.527725-11.74761 92.022944-33.284895 39.1587-46.99044 39.1587-127.265774-3.91587-229.078394M581.506692 407.250478c54.82218 0 99.854685 45.032505 99.854685 99.854685S636.328872 606.959847 581.506692 606.959847s-99.854685-45.032505-99.854684-99.854684 45.032505-99.854685 99.854684-99.854685z m0 150.760994c27.41109 0 48.948375-21.537285 48.948375-50.906309 0-27.41109-21.537285-50.90631-48.948375-50.90631s-48.948375 21.537285-48.948375 50.90631c-1.957935 27.41109 21.537285 50.90631 48.948375 50.906309zM211.456979 199.709369c-17.621415 0-33.284895-13.705545-33.284895-33.284895 0-7.83174 3.91587-17.621415 9.789675-23.49522 5.873805-5.873805 13.705545-9.789675 23.49522-9.789675 17.621415 0 33.284895 13.705545 33.284895 33.284895 0 7.83174-3.91587 17.621415-9.789675 23.49522-5.873805 5.873805-15.66348 9.789675-23.49522 9.789675z m691.151052 123.349904c0-7.83174 3.91587-17.621415 9.789675-23.495219 5.873805-5.873805 13.705545-9.789675 23.495219-9.789675 17.621415 0 33.284895 13.705545 33.284895 33.284894 0 7.83174-3.91587 17.621415-9.789675 23.49522-5.873805 5.873805-13.705545 9.789675-23.49522 9.789675-7.83174 0-17.621415-3.91587-23.495219-9.789675-5.873805-7.83174-9.789675-15.66348-9.789675-23.49522zM650.034417 779.258126c7.83174 0 17.621415 3.91587 23.49522 9.789675 5.873805 5.873805 9.789675 13.705545 9.789675 23.49522 0 7.83174-3.91587 17.621415-9.789675 23.49522-5.873805 5.873805-13.705545 9.789675-23.49522 9.789675-17.621415 0-33.284895-13.705545-33.284895-33.284895 0-7.83174 3.91587-17.621415 9.789675-23.49522 7.83174-5.873805 15.66348-9.789675 23.49522-9.789675z m0 0"  ></path></symbol><symbol id="icon-zhinengjingzhunshuju" viewBox="0 0 1024 1024"><path d="M903.229236 864.106312H154.790698c-6.803987 0-10.20598-3.401993-10.20598-10.20598v-20.41196c0-6.803987 3.401993-10.20598 10.20598-10.20598h68.039867v-340.199336c0-23.813953 17.009967-40.82392 37.421927-40.82392h153.089701v-78.245847c0-20.41196 17.009967-37.421927 37.421927-37.421927h153.089701V251.747508c0-20.41196 17.009967-37.421927 37.421927-37.421927h153.089701c20.41196 0 37.421927 17.009967 37.421926 37.421927v574.936877h68.039868c6.803987 0 10.20598 3.401993 10.20598 10.20598v20.411961c3.401993 3.401993-3.401993 6.803987-6.803987 6.803986zM413.342193 483.083056H260.252492v343.601329h153.089701V483.083056z m190.511628-115.667774h-153.089701v459.269103h153.089701V367.415282z m193.913621-115.667774h-153.089701v574.936877h153.089701V251.747508z m0 0"  ></path></symbol><symbol id="icon-shipintoufang" viewBox="0 0 1060 1024"><path d="M550.4 930.742857c223.085714 0 398.628571-173.714286 398.628571-394.971428 0-217.6-179.2-394.971429-398.628571-394.971429C334.628571 140.8 159.085714 314.514286 155.428571 530.285714v10.971429c3.657143 215.771429 179.2 389.485714 394.971429 389.485714z m0-744.228571c193.828571 0 351.085714 155.428571 351.085714 349.257143 0 192-157.257143 349.257143-351.085714 349.257142-192 0-349.257143-155.428571-349.257143-349.257142 1.828571-192 157.257143-349.257143 349.257143-349.257143z"  ></path><path d="M469.942857 660.114286l5.485714 1.828571c5.485714 1.828571 10.971429 3.657143 16.457143 3.657143 3.657143 0 14.628571 0 14.628572-1.828571l1.828571-1.828572 159.085714-91.428571c12.8-7.314286 21.942857-20.114286 21.942858-34.742857 0-12.8-7.314286-25.6-21.942858-32.914286l-157.257142-91.428572c-7.314286-3.657143-12.8-5.485714-20.114286-5.485714-7.314286 0-12.8 1.828571-20.114286 5.485714-12.8 7.314286-21.942857 20.114286-21.942857 34.742858v181.028571c1.828571 12.8 9.142857 23.771429 21.942857 32.914286z m29.257143-201.142857l137.142857 74.971428-137.142857 78.628572v-153.6z"  ></path></symbol><symbol id="icon-zhuanyeyingxiaojingyandefuben" viewBox="0 0 1241 1024"><path d="M1006.990033 309.581395c0-13.607973-10.20598-23.813953-23.813953-23.813953s-23.813953 10.20598-23.813954 23.813953v418.445183c0 51.0299-23.813953 74.843854-74.843854 74.843854H367.415282c-51.0299 0-74.843854-23.813953-74.843853-74.843854V234.737542c0-51.0299 23.813953-74.843854 74.843853-74.843854h295.973422c13.607973 0 23.813953-10.20598 23.813954-23.813954 0-13.607973-10.20598-23.813953-23.813954-23.813953H340.199336C285.767442 108.863787 241.541528 153.089701 241.541528 204.119601v554.524917c0 51.0299 44.225914 95.255814 95.255814 95.255814h571.534884c51.0299 0 95.255814-44.225914 95.255814-95.255814V309.581395z m0 0"  ></path><path d="M415.043189 721.222591c-13.607973 0-23.813953-10.20598-23.813953-23.813953v-71.441861c0-13.607973 10.20598-23.813953 23.813953-23.813953 13.607973 0 23.813953 10.20598 23.813954 23.813953v71.441861c0 13.607973-10.20598 23.813953-23.813954 23.813953z m149.687708 0c-13.607973 0-23.813953-10.20598-23.813953-23.813953v-214.325582c0-13.607973 10.20598-23.813953 23.813953-23.813953s23.813953 10.20598 23.813953 23.813953v214.325582c0 13.607973-10.20598 23.813953-23.813953 23.813953z m272.159468 0c-13.607973 0-23.813953-10.20598-23.813953-23.813953v-309.581395c0-13.607973 10.20598-23.813953 23.813953-23.813954 13.607973 0 23.813953 10.20598 23.813954 23.813954v309.581395c0 13.607973-10.20598 23.813953-23.813954 23.813953z m-142.88372 3.401994c-13.607973 0-23.813953-10.20598-23.813954-23.813954v-153.089701c0-13.607973 10.20598-23.813953 23.813954-23.813953 13.607973 0 23.813953 10.20598 23.813953 23.813953v153.089701c0 10.20598-10.20598 23.813953-23.813953 23.813954z m234.737541-608.956811l-170.099668 40.82392c-20.41196 13.607973-6.803987 30.61794-6.803986 30.617941l47.627907 47.627907-115.667775 115.667774-125.873754-115.667774h-3.401993c-10.20598-6.803987-23.813953-6.803987-30.61794 3.401993l-3.401994 3.401993-170.099667 166.697675c-10.20598 10.20598-10.20598 23.813953 0 34.019933 10.20598 10.20598 23.813953 10.20598 34.019933 0l156.491695-153.089701 125.873754 112.265781 3.401993 3.401993c3.401993 3.401993 10.20598 6.803987 13.607973 6.803987h3.401994c6.803987 0 13.607973-3.401993 17.009967-6.803987 0 0 0-3.401993 3.401993-3.401993L836.890365 272.159468l40.823921 40.823921c13.607973 13.607973 30.61794-3.401993 30.61794-3.401994l40.82392-166.697674c3.401993-27.215947-20.41196-27.215947-20.41196-27.215947z m0 0"  ></path></symbol><symbol id="icon-zishenfenxi1" viewBox="0 0 1325 1024"><path d="M1007.085714 743.771429H458.971429c-10.971429 0-20.114286-9.142857-20.114286-20.114286v-13.257143c0-10.971429 9.142857-20.114286 20.114286-20.114286h548.114285c10.971429 0 20.114286 9.142857 20.114286 20.114286v13.257143c0 10.971429-9.142857 20.114286-20.114286 20.114286z m1.371429-110.171429l-5.485714 3.657143c-7.771429 5.028571-18.285714 3.2-23.314286-4.571429l-59.428572-89.142857c-5.028571-7.771429-3.2-18.285714 4.571429-23.314286l5.485714-3.657142c7.771429-5.028571 18.285714-3.2 23.314286 4.571428l59.428571 89.142857c5.028571 7.771429 2.742857 18.285714-4.571428 23.314286z m-84.571429-120.228571a106.925714 106.925714 0 0 1-148.571428-29.714286 106.925714 106.925714 0 0 1 29.714285-148.571429c49.371429-32.914286 115.657143-19.657143 148.571429 29.714286 32.457143 49.371429 19.2 115.657143-29.714286 148.571429z m7.314286-133.942858c-24.685714-37.028571-74.514286-46.628571-111.085714-22.4-37.028571 24.685714-46.628571 74.514286-22.4 111.085715 24.685714 37.028571 74.514286 46.628571 111.085714 22.4 37.028571-24.228571 47.085714-74.057143 22.4-111.085715z m-61.257143-10.514285c-35.2 0-63.542857 28.342857-63.542857 63.542857 1.371429 23.771429 14.171429 20.571429 13.257143 36.571428-0.457143 8.228571-26.971429-4.571429-26.971429-43.428571s31.542857-70.4 70.4-70.4c31.085714-0.457143 24.685714 11.885714 23.314286 13.257143-0.914286 3.2-9.142857 0.914286-16.457143 0.457143z m-10.057143 188.8v85.485714c0 10.971429-9.142857 20.114286-20.114285 20.114286h-66.742858c-10.971429 0-20.114286-9.142857-20.114285-20.114286V498.285714v0.457143c25.142857 37.028571 65.371429 57.6 106.971428 58.971429zM699.428571 663.314286h-66.742857c-10.971429 0-20.114286-9.142857-20.114285-20.114286V349.257143c0-10.971429 9.142857-20.114286 20.114285-20.114286H699.428571c10.971429 0 20.114286 9.142857 20.114286 20.114286v294.4c0 10.514286-8.685714 19.657143-20.114286 19.657143z m-140.342857 0h-66.742857c-10.971429 0-20.114286-9.142857-20.114286-20.114286V261.942857c0-10.971429 9.142857-20.114286 20.114286-20.114286h66.742857c10.971429 0 20.114286 9.142857 20.114286 20.114286v381.257143c0 10.971429-9.142857 20.114286-20.114286 20.114286z m0 0"  ></path></symbol><symbol id="icon-zhuanyeyingxiaojingyan" viewBox="0 0 1024 1024"><path d="M737.918465 861.928058H352.383693c-12.278177 0-22.919265 9.822542-22.919265 22.919264 0 12.278177 9.822542 22.919265 22.919265 22.919265H737.918465c12.278177 0 22.919265-9.822542 22.919265-22.919265 0-13.096723-10.641087-22.919265-22.919265-22.919264zM800.946443 343.788969c-6.548361 0-13.096723 2.455635-17.189449 7.366906l-106.410871 106.410872-75.306155-75.306155c-4.911271-4.911271-13.096723-8.185452-20.463629-6.548362-7.366906 0.818545-13.915268 5.729816-18.007994 12.278178l-98.225419 172.713029-42.564349-108.047961c-3.274181-7.366906-9.822542-13.096723-18.007993-14.733813-8.185452-1.63709-16.370903 0.818545-22.10072 6.548361L290.174261 535.328537c-4.911271 4.911271-7.366906 10.641087-7.366907 17.189449s2.455635 12.278177 7.366907 17.189448c4.911271 4.911271 10.641087 7.366906 17.189448 7.366907s12.278177-2.455635 17.189448-7.366907l66.302159-66.302158 48.294164 120.326139c3.274181 8.185452 11.459632 14.733813 20.46363 14.733813h0.818545c9.003997 0 17.189448-4.092726 22.100719-12.278178l107.229417-188.265387 70.394884 70.394884c4.911271 4.911271 10.641087 7.366906 17.189448 7.366906s12.278177-2.455635 17.189449-7.366906L818.135891 384.716227c4.911271-4.911271 7.366906-10.641087 7.366907-17.189448s-2.455635-12.278177-7.366907-17.189449c-4.092726-4.092726-10.641087-6.548361-17.189448-6.548361z"  ></path><path d="M917.179856 230.011191c-4.911271-39.290168-37.653078-68.757794-77.76179-68.757794h-589.352518c-43.382894 0-77.761791 35.197442-77.761791 77.761791v503.405276c0 42.564349 35.197442 77.761791 77.761791 77.76179h590.171063c43.382894 0 77.761791-35.197442 77.76179-77.76179v-507.498002l-0.818545-4.911271z m-44.201439 513.227818c0 18.007994-14.733813 32.741807-32.741806 32.741806H250.065548c-18.007994 0-32.741807-14.733813-32.741807-32.741806V239.015188c0-18.007994 14.733813-32.741807 32.741807-32.741807h590.171063c15.552358 0 28.649081 10.641087 31.923261 25.3749l0.818545 3.274181v508.316547z"  ></path></symbol><symbol id="icon-shujufenxi2" viewBox="0 0 1024 1024"><path d="M805.726316 811.115789H219.621053c-10.778947 0-20.210526 9.431579-20.210527 20.210527s9.431579 20.210526 20.210527 20.210526h587.452631c10.778947 0 20.210526-9.431579 20.210527-20.210526-1.347368-12.126316-10.778947-20.210526-21.557895-20.210527zM261.389474 774.736842c10.778947 0 20.210526-9.431579 20.210526-20.210526V579.368421c0-10.778947-9.431579-20.210526-20.210526-20.210526s-20.210526 9.431579-20.210527 20.210526v175.157895c0 10.778947 8.084211 20.210526 20.210527 20.210526zM405.557895 516.042105V754.526316c0 10.778947 9.431579 20.210526 20.210526 20.210526s20.210526-9.431579 20.210526-20.210526V516.042105c0-10.778947-9.431579-20.210526-20.210526-20.210526s-20.210526 9.431579-20.210526 20.210526z m164.378947-72.757894V754.526316c0 10.778947 9.431579 20.210526 20.210526 20.210526s20.210526-9.431579 20.210527-20.210526V443.284211c0-10.778947-9.431579-20.210526-20.210527-20.210527-10.778947 1.347368-20.210526 9.431579-20.210526 20.210527z m0 0M207.494737 357.052632c0 29.642105 22.905263 52.547368 52.547368 52.547368s52.547368-22.905263 52.547369-52.547368-22.905263-52.547368-52.547369-52.547369c-28.294737-1.347368-52.547368 22.905263-52.547368 52.547369z m0 0M385.347368 435.2c0 20.210526 16.168421 37.726316 37.726316 37.726316 20.210526 0 37.726316-16.168421 37.726316-37.726316 0-20.210526-16.168421-37.726316-37.726316-37.726316-21.557895 1.347368-37.726316 17.515789-37.726316 37.726316z m0 0M538.947368 254.652632c0 29.642105 24.252632 53.894737 53.894737 53.894736s53.894737-24.252632 53.894737-53.894736-24.252632-53.894737-53.894737-53.894737c-29.642105-1.347368-53.894737 22.905263-53.894737 53.894737z m0 0M734.315789 344.926316V754.526316c0 10.778947 9.431579 20.210526 20.210527 20.210526S774.736842 765.305263 774.736842 754.526316V344.926316c0-10.778947-9.431579-20.210526-20.210526-20.210527-6.736842 0-12.126316 2.694737-16.168421 8.084211 0 0-4.042105 5.389474-4.042106 12.126316z"  ></path><path d="M591.494737 233.094737l-2.694737-1.347369-165.726316 206.147369L260.042105 350.315789l-6.736842 13.473685 173.810526 92.968421 164.378948-206.147369L746.442105 350.315789l2.694737-4.042105c1.347368-1.347368 2.694737-2.694737 2.694737-5.389473l2.694737-4.042106-163.031579-103.747368z"  ></path></symbol><symbol id="icon-shishiyouhua1" viewBox="0 0 1531 1024"><path d="M536.783943 709.66706h221.242031v56.821724l-78.583235 3.626918c-9.671783 0-15.716647 6.044864-15.716647 15.716647s6.044864 15.716647 15.716647 15.716647H930.909091c9.671783 0 15.716647-6.044864 15.716647-15.716647s-6.044864-15.716647-15.716647-15.716647h-78.583235v-59.239669h221.242031c26.597403 0 47.149941-14.507674 47.149941-39.896104V281.690673c0-25.38843-20.552538-45.940968-47.149941-45.940968H535.57497c-24.179457 0-44.731995 19.343566-45.940968 44.731995v391.707202c1.208973 24.179457 21.761511 37.478158 47.149941 37.478158z m284.108619 60.448642h-31.433294v-59.239669h31.433294v59.239669zM521.067296 282.899646c0-7.253837 9.671783-15.716647 15.716647-15.716647h536.783944c7.253837 0 15.716647 8.46281 15.716647 15.716647v316.750885h-568.217238V282.899646z m0 348.184179h568.217238v31.433294c1.208973 8.46281-8.46281 15.716647-15.716647 15.716647H536.783943c-7.253837 0-15.716647-8.46281-15.716647-15.716647v-31.433294z"  ></path><path d="M957.506494 425.558442l-107.598584 103.971664-41.105076-41.105076c-7.253837-7.253837-14.507674-7.253837-21.761512 0-7.253837 7.253837-7.253837 14.507674 0 21.761511l48.358914 48.358914c3.626919 3.626919 10.880756 3.626919 14.507674 3.626918 3.626919 0 10.880756 0 14.507674-3.626918l114.852421-114.852421c3.626919-3.626919 3.626919-14.507674 0-18.134592-7.253837-8.46281-18.134593-8.46281-21.761511 0zM658.890201 365.109799h221.24203c7.253837 0 15.716647-8.46281 15.716647-15.716647 0-7.253837-8.46281-15.716647-15.716647-15.716647H658.890201c-7.253837 0-15.716647 8.46281-15.716647 15.716647 0 7.253837 8.46281 15.716647 15.716647 15.716647zM816.056671 444.902007c10.880756 0 15.716647-4.835891 15.716647-15.716647 0-7.253837-4.835891-15.716647-15.716647-15.716647h-157.16647c-7.253837 0-15.716647 8.46281-15.716647 15.716647 0 10.880756 8.46281 15.716647 15.716647 15.716647h157.16647z"  ></path></symbol><symbol id="icon-shujujiance1" viewBox="0 0 1169 1024"><path d="M216.725644 223.605823h26.37402v409.370661c0 22.933931 18.347144 41.281075 41.281075 41.281075h200.671893l-59.62822 108.93617c-2.293393 3.44009-3.44009 8.026876-2.293393 12.613662 1.146697 4.586786 4.586786 9.173572 10.320269 11.466965 3.44009 1.146697 6.880179 2.293393 10.320269 2.293393 8.026876 0 14.907055-3.44009 18.347144-9.173572l63.068309-114.669653c1.146697-2.293393 2.293393-4.586786 2.293393-8.026876v-3.440089h52.74804v3.440089c0 3.44009 1.146697 5.733483 2.293394 8.026876l63.068309 114.669653c3.44009 5.733483 10.320269 9.173572 18.347144 9.173572 3.44009 0 8.026876-1.146697 10.320269-2.293393 4.586786-2.293393 8.026876-6.880179 10.320269-11.466965 1.146697-4.586786 0-8.026876-2.293394-12.613662l-59.628219-108.93617h200.671893c22.933931 0 41.281075-18.347144 41.281075-41.281075V223.605823h26.37402c9.173572 0 17.200448-6.880179 18.347144-16.053751v-5.733483c-1.146697-9.173572-9.173572-16.053751-18.347144-16.053751H216.725644c-10.320269 0-18.347144 8.026876-18.347145 18.347144 0 11.466965 8.026876 19.493841 18.347145 19.493841z m63.068309 0H829.06159v386.43673c0 14.907055-11.466965 26.37402-26.37402 26.37402H306.167973c-14.907055 0-26.37402-11.466965-26.37402-26.37402V223.605823z"  ></path><path d="M342.862262 536.653975c3.44009 1.146697 5.733483 2.293393 9.173572 2.293393 5.733483 0 11.466965-3.44009 17.200448-10.320268L470.145577 407.077268l107.789473 77.975364c5.733483 4.586786 10.320269 8.026876 13.760359 10.320268 2.293393 1.146697 4.586786 2.293393 6.880179 2.293393 5.733483 0 11.466965-3.44009 17.200448-9.173572L774.020157 344.008959c3.44009-3.44009 5.733483-8.026876 4.586786-12.613662-1.146697-5.733483-4.586786-10.320269-10.320269-13.760359-2.293393-1.146697-4.586786-2.293393-6.880179-2.293393-6.880179 0-13.760358 4.586786-20.640538 11.466966L598.575588 456.385218l-112.37626-80.268757c-1.146697-1.146697-2.293393-1.146697-3.440089-2.293393-6.880179-4.586786-11.466965-6.880179-16.053752-6.880179h-4.586786c-1.146697 0-3.44009 1.146697-4.586786 1.146697h-1.146697-1.146696c-1.146697 1.146697-2.293393 1.146697-3.44009 2.293393-1.146697 1.146697-2.293393 2.293393-2.293393 3.440089 0 0 0 1.146697-1.146696 1.146697l-112.37626 134.163494c-5.733483 10.320269-2.293393 21.787234 6.880179 27.520716z"  ></path></symbol><symbol id="icon-chuangyitoufang1" viewBox="0 0 1024 1024"><path d="M812.521739 198.121739c0-45.634783-36.730435-82.365217-82.365217-82.365217H277.147826c-45.634783 0-82.365217 36.730435-82.365217 82.365217v576.556522c0 45.634783 36.730435 82.365217 82.365217 82.365217h185.878261c11.130435 0 20.034783-8.904348 20.034783-21.147826 0-11.130435-8.904348-21.147826-20.034783-21.147826H277.147826c-22.26087 0-41.182609-18.921739-41.182609-41.182609V198.121739c0-22.26087 18.921739-41.182609 41.182609-41.182609h453.008696c22.26087 0 41.182609 18.921739 41.182608 41.182609v268.243478c0 11.130435 8.904348 21.147826 21.147827 21.147826 11.130435 0 21.147826-8.904348 21.147826-21.147826V198.121739z"  ></path><path d="M596.591304 873.73913h-37.843478c-13.356522 1.113043-25.6-3.33913-34.504348-12.243478-10.017391-8.904348-15.582609-22.26087-15.582608-35.617391V790.26087c0-17.808696 8.904348-38.956522 21.147826-52.313044l209.252174-210.365217c8.904348-8.904348 22.26087-14.469565 34.504347-14.469566 13.356522 0 25.6 5.565217 35.617392 14.469566l45.634782 45.634782c18.921739 18.921739 18.921739 51.2 0 70.121739L645.565217 852.591304c-12.243478 13.356522-32.278261 21.147826-48.973913 21.147826z m-38.956521-31.165217h36.730434c8.904348 1.113043 22.26087-4.452174 28.939131-11.130435l209.252174-210.365217c7.791304-7.791304 7.791304-18.921739 0-26.713044l-45.634783-45.634782c-3.33913-3.33913-7.791304-5.565217-13.356522-5.565218-4.452174 0-10.017391 2.226087-13.356521 5.565218L552.069565 759.095652c-6.678261 6.678261-12.243478 20.034783-12.243478 31.165218v35.617391c0 5.565217 2.226087 10.017391 5.565217 13.356522 3.33913 2.226087 7.791304 3.33913 12.243479 3.33913z"  ></path><path d="M332.8 693.426087h115.756522c7.791304 0 14.469565 8.904348 14.469565 21.147826 0 11.130435-6.678261 21.147826-14.469565 21.147826H332.8c-7.791304 0-14.469565-8.904348-14.469565-21.147826 0-12.243478 6.678261-21.147826 14.469565-21.147826zM318.330435 589.913043c0-11.130435 7.791304-21.147826 16.695652-21.147826h213.704348c8.904348 0 16.695652 8.904348 16.695652 21.147826 0 11.130435-7.791304 21.147826-16.695652 21.147827H335.026087c-10.017391 0-16.695652-8.904348-16.695652-21.147827zM420.730435 501.982609c-6.678261 0-12.243478-2.226087-17.808696-5.565218-7.791304-6.678261-12.243478-16.695652-11.130435-27.826087l6.678261-62.330434-38.956522-60.104348c-6.678261-10.017391-7.791304-20.034783-3.33913-30.052174 4.452174-8.904348 13.356522-15.582609 24.486957-16.695652l56.765217-7.791305 33.391304-52.313043c6.678261-10.017391 15.582609-15.582609 25.6-15.582609 10.017391 0 18.921739 5.565217 25.6 15.582609l33.391305 51.2 60.104347 7.791304c11.130435 1.113043 20.034783 7.791304 24.486957 16.695652 4.452174 8.904348 3.33913 20.034783-3.33913 30.052174l-37.843479 60.104348 6.678261 62.330435c1.113043 11.130435-2.226087 21.147826-10.017391 27.826087-7.791304 6.678261-18.921739 7.791304-30.052174 4.452174l-66.782609-22.26087-66.782608 23.373913c-3.33913 1.113043-6.678261 1.113043-11.130435 1.113044z m-34.504348-171.408696l44.521739 69.008696-7.791304 71.234782 75.686956-25.6 75.686957 25.6-6.678261-72.347826 43.408696-69.008695-73.46087-10.017392-40.069565-63.443478-41.182609 64.556522-70.121739 10.017391z m109.078261-75.686956z"  ></path></symbol><symbol id="icon-wanghongzhibo1" viewBox="0 0 1024 1024"><path d="M567.810427 516.044234l84.120063 51.766193c27.50079 16.176935 50.148499 3.235387 50.148499-30.736177l-1.617694-221.624013c0-33.971564-22.647709-46.913112-50.148499-30.736177l-82.502369 48.530806v182.799368zM469.131122 252.36019H229.71248c-45.295419 0-80.884676 37.206951-80.884676 80.884676V517.661927c0 45.295419 37.206951 80.884676 80.884676 80.884676H469.131122c45.295419 0 80.884676-37.206951 80.884676-80.884676V334.862559c0-45.295419-35.589258-82.50237-80.884676-82.502369z m-46.913113 187.652448l-101.914691 58.236967c-12.941548 6.470774-22.647709 1.617694-22.64771-12.941548v-118.091627c0-14.559242 11.323855-21.030016 22.64771-12.941548l101.914691 59.85466c12.941548 6.470774 12.941548 19.412322 0 25.883096z"  ></path></symbol><symbol id="icon-weibohongren1" viewBox="0 0 1043 1024"><path d="M687.465729 518.29877c-10.797891-1.799649-19.796134-7.198594-12.597539-17.996485 7.198594-12.59754 19.796134-46.790861-5.398946-70.186292-23.395431-23.395431-75.585237-14.397188-111.578207 0-35.99297 16.196837-34.193322 5.398946-32.393673-5.398946 1.799649-10.797891 21.595782-73.785589-39.592267-82.783831-79.184534-10.797891-179.964851 89.982425-214.158173 147.571178-53.989455 88.182777-44.991213 145.771529-44.991212 145.771529 7.198594 80.984183 122.376098 145.771529 266.347979 145.771529 122.376098 0 226.755712-48.59051 257.349736-113.377856 3.599297-7.198594 5.398946-14.397188 7.198594-21.595782 3.599297-17.996485 7.198594-43.191564 0-68.386644-16.196837-41.391916-61.188049-57.588752-70.186292-59.3884zM473.307557 748.653779c-100.780316 0-183.564148-55.789104-183.564148-125.975396s82.783831-125.975395 183.564148-125.975395 183.564148 55.789104 183.564148 125.975395-80.984183 125.975395-183.564148 125.975396z"  ></path><path d="M457.110721 543.493849c-53.989455 0-98.980668 39.592267-98.980668 88.182777s43.191564 88.182777 98.980668 88.182776c53.989455 0 98.980668-39.592267 98.980667-88.182776s-44.991213-88.182777-98.980667-88.182777z m-32.393674 145.771529c-19.796134 0-34.193322-16.196837-34.193321-35.99297s16.196837-35.99297 34.193321-35.99297c19.796134 0 34.193322 16.196837 34.193322 35.99297s-16.196837 35.99297-34.193322 35.99297z m64.787347-62.987698c-3.599297 7.198594-12.59754 10.797891-17.996485 7.198594-5.398946-3.599297-7.198594-12.59754-3.599297-19.796133 3.599297-7.198594 12.59754-10.797891 17.996485-7.198594 5.398946 3.599297 7.198594 12.59754 3.599297 19.796133zM723.458699 469.70826c1.799649 0 3.599297 1.799649 5.398946 1.799649 5.398946 0 10.797891-3.599297 14.397188-8.998243 3.599297-8.998243 5.398946-19.796134 5.398946-28.794376 0-41.391916-32.393673-75.585237-73.785589-75.585237-10.797891 0-19.796134 1.799649-28.794376 5.398945-7.198594 3.599297-10.797891 12.59754-7.198594 19.796134 3.599297 7.198594 10.797891 10.797891 19.796133 8.998242 5.398946-1.799649 10.797891-3.599297 16.196837-3.599297 23.395431 0 43.191564 19.796134 43.191564 44.991213 0 5.398946-1.799649 12.59754-3.599297 17.996485-1.799649 5.398946 1.799649 14.397188 8.998242 17.996485z"  ></path><path d="M674.86819 260.949033c-16.196837 0-32.393673 1.799649-48.59051 7.198594-12.59754 3.599297-17.996485 16.196837-14.397188 28.794377 3.599297 12.59754 16.196837 19.796134 26.994728 16.196836 12.59754-3.599297 23.395431-5.398946 35.99297-5.398945 70.186292 0 127.775044 59.388401 127.775044 131.374341 0 12.59754-1.799649 25.195079-5.398946 37.792618-3.599297 12.59754 3.599297 25.195079 14.397188 28.794376 1.799649 0 3.599297 1.799649 7.198594 1.799649 10.797891 0 17.996485-7.198594 21.595782-16.196837 5.398946-16.196837 7.198594-34.193322 7.198594-52.189806 0-97.181019-77.384886-178.165202-172.766256-178.165203z"  ></path></symbol><symbol id="icon-tuiguangfangan1" viewBox="0 0 1035 1024"><path d="M485.537079 719.101124H311.802247c-12.65618 0-23.011236 10.355056-23.011236 23.011236s10.355056 23.011236 23.011236 23.011236h173.734832c12.65618 0 23.011236-10.355056 23.011236-23.011236s-10.355056-23.011236-23.011236-23.011236zM716.8 546.516854H311.802247c-12.65618 0-23.011236 10.355056-23.011236 23.011236s10.355056 23.011236 23.011236 23.011236h403.847191c12.65618 0 23.011236-10.355056 23.011236-23.011236s-9.204494-23.011236-21.860674-23.011236zM946.91236 661.573034c-5.752809 0-11.505618 2.301124-16.107866 6.90337L717.950562 882.480899l-92.044944-104.701124c-4.602247-4.602247-10.355056-8.053933-17.258427-8.053932-5.752809 0-11.505618 2.301124-14.957303 5.752809-9.204494 8.053933-10.355056 23.011236-2.301124 32.21573l108.152809 123.110112c4.602247 4.602247 10.355056 8.053933 16.107865 8.053933h1.150562c5.752809 0 11.505618-2.301124 16.107865-6.903371l231.262922-231.262921c9.204494-9.204494 9.204494-23.011236 0-32.215731-4.602247-4.602247-10.355056-6.903371-17.258427-6.90337zM716.8 372.782022H311.802247c-12.65618 0-23.011236 10.355056-23.011236 23.011236s10.355056 23.011236 23.011236 23.011236h403.847191c12.65618 0 23.011236-10.355056 23.011236-23.011236s-9.204494-23.011236-21.860674-23.011236z"  ></path><path d="M254.274157 938.858427h288.791012c12.65618 0 23.011236-10.355056 23.011235-23.011236s-10.355056-23.011236-23.011235-23.011236H254.274157c-19.559551 0-34.516854-16.107865-34.516854-34.516854V223.208989c0-19.559551 16.107865-34.516854 34.516854-34.516854h37.96854l1.150561 3.451685c11.505618 32.21573 41.420225 54.076404 75.937079 54.076405h288.791011c34.516854 0 64.431461-21.860674 75.937079-54.076405l1.150562-3.451685h37.968539c19.559551 0 34.516854 16.107865 34.516854 34.516854v403.847191c0 12.65618 10.355056 23.011236 23.011236 23.011236s23.011236-10.355056 23.011236-23.011236V223.208989c0-44.87191-35.667416-80.539326-80.539326-80.539326H736.359551l-1.150562-4.602247c-11.505618-32.21573-41.420225-54.076404-75.937079-54.076405H370.480899c-34.516854 0-64.431461 21.860674-75.937079 54.076405l-1.150562 3.451685h-37.968539c-44.87191 0-80.539326 35.667416-80.539326 80.539326v635.110112c-1.150562 44.87191 35.667416 81.689888 79.388764 81.689888z m116.206742-808.844944h288.791011c19.559551 0 34.516854 16.107865 34.516854 34.516854 0 19.559551-16.107865 34.516854-34.516854 34.516854H370.480899c-19.559551 0-34.516854-16.107865-34.516854-34.516854-1.150562-18.408989 14.957303-34.516854 34.516854-34.516854z"  ></path></symbol><symbol id="icon-xinxiliuguanggao2" viewBox="0 0 1239 1024"><path d="M906.327628 260.381418H290.425428c-30.04401 0-55.080685 25.036675-55.080685 55.080685v475.696821c0 30.04401 25.036675 55.080685 55.080685 55.080685h615.9022c30.04401 0 55.080685-25.036675 55.080685-55.080685v-475.696821c-2.503667-30.04401-25.036675-55.080685-55.080685-55.080685zM623.413203 545.799511h-125.183374v-127.687042c62.591687 10.01467 115.168704 62.591687 125.183374 127.687042zM475.696822 718.552567c-77.613692 0-142.709046-60.08802-147.716382-135.198044v-15.022005c0-75.110024 55.080685-137.701711 127.687042-147.716381v167.745721h167.745721c-7.511002 72.606357-70.102689 130.190709-147.716381 130.190709z m388.068459-22.533007h-185.271393v-55.080685h185.271393v55.080685z m0-105.154034h-185.271393v-55.080685h185.271393v55.080685z m0-102.650367h-125.183374v-55.080685h125.183374v55.080685z"  ></path></symbol><symbol id="icon-conggaodaodi" viewBox="0 0 1024 1024"><path d="M390.144 88.064c-2.048-4.608-4.608-8.704-8.192-12.288-11.264-11.264-27.136-14.336-41.472-9.216-3.584 1.024-6.656 3.072-9.728 5.12-2.048 1.536-3.584 2.56-5.12 4.608l-183.808 184.32c-15.36 15.36-15.36 40.448 0 55.808s40.448 15.36 55.808 0l116.224-116.224v719.872c0 22.016 17.92 39.424 39.424 39.424 22.016 0 39.424-17.92 39.424-39.424V103.424c0.512-5.12-0.512-10.24-2.56-15.36z m492.032 619.52c-15.36-15.36-40.448-15.36-55.808 0l-116.224 116.224V103.936c0-22.016-17.92-39.424-39.424-39.424-22.016 0-39.424 17.92-39.424 39.424v816.128c0 5.12 1.024 10.752 3.072 15.36 2.048 4.608 4.608 8.704 8.192 12.288 11.264 11.264 27.136 14.336 41.472 9.216 3.584-1.024 6.656-3.072 9.728-5.12 2.048-1.536 3.584-2.56 5.12-4.608l183.808-184.32c14.848-14.336 14.848-39.424-0.512-55.296z" fill="#666666" ></path></symbol><symbol id="icon-paixuxialaanniu" viewBox="0 0 1241 1024"><path d="M620.606061 1024L0 0h1241.212121L620.606061 1024" fill="#999999" ></path></symbol><symbol id="icon-ruanwen-huoyan" viewBox="0 0 1024 1024"><path d="M431.616 902.144s-285.184-41.472-285.184-285.184 373.248-265.728 290.304-568.32c0 0 278.016 87.552 209.92 360.96 0 0 36.352-24.576 66.048-70.656 0 0 141.312 109.568 141.312 275.456s-195.072 287.744-287.744 287.744c0 0 99.84-136.704 9.728-221.696-129.024-124.416-73.216-202.24-73.216-202.24s-317.44 153.088-71.168 423.936" fill="#FF2323" ></path></symbol><symbol id="icon-baiduicon" viewBox="0 0 1024 1024"><path d="M385.536 71.68c15.872-3.072 31.744 1.536 45.056 9.728 20.992 14.336 33.792 35.328 41.472 59.392 12.8 36.864 11.264 76.8-3.072 112.128-6.144 17.408-17.408 33.792-31.744 46.592-11.264 9.728-27.136 15.872-41.472 17.408-15.872 0-30.208-4.608-43.008-14.336-19.456-14.336-31.744-36.864-38.4-59.392-9.728-33.792-9.728-72.192 3.072-105.472 8.192-20.992 19.456-38.4 36.864-51.2 10.24-8.704 19.968-13.312 31.232-14.848zM615.936 89.088c11.264-1.536 22.528 0 31.744 4.608 14.336 6.656 25.6 17.408 35.328 30.208 12.8 17.408 22.528 38.4 25.6 59.392 1.536 15.872 0 30.208-4.608 45.056-3.072 19.456-11.264 36.864-20.992 51.2-9.728 12.8-20.992 25.6-35.328 33.792-12.8 8.192-28.672 11.264-43.008 9.728-17.408-1.536-36.864-8.192-49.664-20.992-14.336-12.8-20.992-30.208-25.6-48.128-3.072-19.456-3.072-38.4-1.536-57.344 3.072-17.408 9.728-33.792 19.456-48.128 9.728-15.872 20.992-28.672 33.792-41.472 9.216-6.656 22.016-14.848 34.816-17.92zM201.728 253.952c15.872-3.072 33.792 0 49.664 8.192 22.528 12.8 38.4 31.744 49.664 54.272 3.072 9.728 8.192 19.456 8.192 30.208 3.072 25.6 1.536 52.736-4.608 76.8-4.608 17.408-14.336 33.792-27.136 45.056-15.872 14.336-38.4 22.528-60.928 22.528-17.408 0-36.864-6.144-49.664-19.456-17.408-15.872-28.672-38.4-35.328-60.928-3.584-15.872-6.656-31.744-3.584-48.128 3.072-27.136 11.264-52.736 27.136-76.8 9.728-15.872 27.136-28.672 46.592-31.744zM740.864 313.344c19.456-3.072 41.472 0 59.392 9.728 15.872 9.728 28.672 24.064 38.4 39.936 6.144 14.336 12.8 28.672 12.8 44.544 0 22.528 1.536 45.056-3.072 65.536-3.072 14.336-9.728 30.208-19.456 41.472-9.728 11.264-22.528 20.992-36.864 24.064-14.336 3.072-30.208 4.608-45.056 3.072-17.408-1.536-35.328-6.144-49.664-17.408-12.8-9.728-20.992-24.064-25.6-38.4-6.656-19.456-6.656-41.472-6.656-62.464 0-22.528 3.072-43.008 12.8-64 6.144-14.336 15.872-27.136 30.208-36.864 10.24-4.608 21.504-7.68 32.768-9.216zM793.6 708.096c-3.072-28.672-14.336-55.808-35.328-76.8-3.072-3.072-8.192-8.192-12.8-11.264-27.136-22.528-52.736-46.592-76.8-70.656-25.6-25.6-49.664-52.736-70.656-82.944-15.872-27.136-38.4-51.2-67.072-64-17.408-8.192-38.4-12.8-59.392-9.728-35.328 3.072-68.608 24.064-89.6 51.2-6.144 6.144-9.728 14.336-14.336 20.992-15.872 24.064-36.864 46.592-57.344 67.072-11.264 11.264-24.064 20.992-35.328 31.744-6.144 8.192-14.336 11.264-20.992 17.408-24.064 19.456-48.128 41.472-62.464 68.608-11.264 17.408-15.872 38.4-17.408 59.392 0 17.408 3.072 35.328 8.192 52.736s14.336 35.328 25.6 49.664c19.456 25.6 49.664 39.936 79.872 41.472 36.864 1.536 75.264 0 112.128-6.144 17.408-3.072 33.792-8.192 49.664-9.728 35.328-3.072 70.656-1.536 105.472 8.192 28.672 9.728 57.344 14.336 88.064 15.872 30.208 0 62.464-3.072 89.6-17.408 19.456-11.264 35.328-27.136 45.056-48.128 10.752-26.624 18.944-56.832 15.872-87.552z m-334.336 81.92H368.128c-9.728 0-19.456 0-28.672-1.536-20.992-4.608-38.4-17.408-51.2-33.792-9.728-11.264-14.336-27.136-17.408-41.472s-3.072-30.208 0-46.592c4.608-17.408 14.336-33.792 27.136-46.592 11.264-9.728 24.064-17.408 38.4-22.528 4.608-1.536 11.264-3.072 17.408-3.072h54.272v-75.264h51.2v270.848z m207.872 0h-124.928c-12.8 0-27.136-4.608-36.864-14.336-11.264-9.728-17.408-25.6-17.408-39.936v-136.192h52.736v126.464c0 4.608 1.536 9.728 4.608 14.336 4.608 4.608 9.728 6.144 15.872 6.144h54.272V599.04h51.2v190.976z" fill="#306CFF" ></path><path d="M350.208 642.56c3.072-1.536 6.144-3.072 11.264-3.072h46.592v107.008h-41.472c-14.336 0-28.672-6.144-36.864-17.408-6.144-9.728-11.264-22.528-9.728-33.792 0-9.728 1.536-19.456 4.608-28.672 6.656-12.8 15.872-18.944 25.6-24.064z" fill="#306CFF" ></path></symbol><symbol id="icon-weixinicon" viewBox="0 0 1024 1024"><path d="M1024 634.88c0-143.36-143.36-261.12-307.2-261.12-168.96 0-307.2 117.76-307.2 261.12s133.12 261.12 307.2 261.12c35.84 0 71.68-10.24 107.52-20.48l97.28 56.32-25.6-92.16c71.68-56.32 128-128 128-204.8z m-404.48-46.08c-20.48 0-35.84-15.36-35.84-35.84 0-15.36 20.48-35.84 35.84-35.84 25.6 0 46.08 15.36 46.08 35.84 0 15.36-20.48 35.84-46.08 35.84z m194.56 0c-15.36 0-35.84-15.36-35.84-35.84 0-15.36 20.48-35.84 35.84-35.84 25.6 0 46.08 15.36 46.08 35.84 0 15.36-15.36 35.84-46.08 35.84z" fill="#13CE66" ></path><path d="M358.4 97.28C158.72 97.28 0 230.4 0 404.48c0 97.28 56.32 179.2 143.36 240.64l-35.84 107.52 128-61.44c46.08 10.24 81.92 20.48 128 20.48h35.84c-5.12-25.6-10.24-51.2-10.24-76.8 0-158.72 133.12-286.72 307.2-286.72h35.84c-40.96-143.36-194.56-250.88-373.76-250.88zM245.76 337.92c-25.6 0-56.32-15.36-56.32-46.08 0-25.6 25.6-46.08 56.32-46.08 25.6 0 46.08 15.36 46.08 46.08-5.12 30.72-20.48 46.08-46.08 46.08z m250.88 0c-25.6 0-56.32-15.36-56.32-46.08 0-25.6 25.6-46.08 56.32-46.08 25.6 0 46.08 15.36 46.08 46.08s-20.48 46.08-46.08 46.08z" fill="#13CE66" ></path></symbol><symbol id="icon-jiaruxuanhaoche-xuanzhong" viewBox="0 0 1024 1024"><path d="M512 1024C229.831111 1024 0 794.168889 0 512S229.831111 0 512 0s512 229.831111 512 512-229.831111 512-512 512z m0-1001.244444C242.346667 22.755556 22.755556 242.346667 22.755556 512s219.591111 489.244444 489.244444 489.244444 489.244444-219.591111 489.244444-489.244444S781.653333 22.755556 512 22.755556z" fill="#ED781E" ></path><path d="M324.266667 480.142222h364.088889c12.515556 0 22.755556 10.24 22.755555 22.755556s-10.24 22.755556-22.755555 22.755555h-364.088889c-12.515556 0-22.755556-10.24-22.755556-22.755555s10.24-22.755556 22.755556-22.755556z" fill="#ED781E" ></path><path d="M502.897778 301.511111c12.515556 0 22.755556 10.24 22.755555 22.755556v364.088889c0 12.515556-10.24 22.755556-22.755555 22.755555s-22.755556-10.24-22.755556-22.755555v-364.088889c0-12.515556 10.24-22.755556 22.755556-22.755556z" fill="#ED781E" ></path></symbol><symbol id="icon-icon_search" viewBox="0 0 1024 1024"><path d="M367.227586 706.206897C173.02069 706.206897 14.124138 547.310345 14.124138 353.103448S173.02069 0 367.227586 0s353.103448 158.896552 353.103448 353.103448-158.896552 353.103448-353.103448 353.103449z m0-635.586207c-155.365517 0-282.482759 127.117241-282.482758 282.482758s127.117241 282.482759 282.482758 282.482759 282.482759-127.117241 282.482759-282.482759-127.117241-282.482759-282.482759-282.482758z" fill="#A6A6A6" ></path><path d="M896.882759 988.689655c-10.593103 0-17.655172-3.531034-24.717242-10.593103l-317.793103-317.793104c-14.124138-14.124138-14.124138-35.310345 0-49.434482s35.310345-14.124138 49.434483 0l317.793103 317.793103c14.124138 14.124138 14.124138 35.310345 0 49.434483-7.062069 7.062069-14.124138 10.593103-24.717241 10.593103z" fill="#A6A6A6" ></path></symbol><symbol id="icon-zonghepaixu" viewBox="0 0 1024 1024"><path d="M649.728 955.904c-63.488 0-115.2-51.712-115.2-115.2v-306.176h306.176c63.488 0 115.2 51.712 115.2 115.2v190.976c0 63.488-51.712 115.2-115.2 115.2h-190.976z m-65.024-115.2c0 35.84 29.184 65.024 65.024 65.024h190.976c35.84 0 65.024-29.184 65.024-65.024v-190.976c0-35.84-29.184-65.024-65.024-65.024h-256v256z m-399.872 115.2c-63.488 0-115.2-51.712-115.2-115.2v-190.976c0-63.488 51.712-115.2 115.2-115.2h304.64v306.176c0 63.488-51.712 115.2-115.2 115.2h-189.44z m0-371.2c-35.84 0-65.024 29.184-65.024 65.024v190.976c0 35.84 29.184 65.024 65.024 65.024h189.44c35.84 0 65.024-29.184 65.024-65.024v-256H184.832z m349.696-95.744V184.32c0-63.488 51.712-115.2 115.2-115.2h190.976c63.488 0 115.2 51.712 115.2 115.2v189.44c0 63.488-51.712 115.2-115.2 115.2h-306.176z m306.176-50.176c35.84 0 65.024-29.184 65.024-65.024V184.32c0-35.84-29.184-65.024-65.024-65.024h-190.976c-35.84 0-65.024 29.184-65.024 65.024v253.952l256 0.512zM184.832 488.96c-63.488 0-115.2-51.712-115.2-115.2V184.32c0-63.488 51.712-115.2 115.2-115.2h189.44c63.488 0 115.2 51.712 115.2 115.2v304.64H184.832z m0-369.664c-35.84 0-65.024 29.184-65.024 65.024v189.44c0 35.84 29.184 65.024 65.024 65.024h253.952V184.32c0-35.84-29.184-65.024-65.024-65.024H184.832z" fill="" ></path><path d="M483.84 483.84H184.832c-60.928 0-110.08-49.152-110.08-110.08V184.32c0-60.928 49.152-110.08 110.08-110.08h189.44c60.928 0 110.08 49.152 110.08 110.08l-0.512 299.52zM184.832 114.176c-38.4 0-70.144 31.232-70.144 70.144v189.44c0 38.4 31.232 70.144 70.144 70.144h259.072V184.32c0-38.4-31.232-70.144-70.144-70.144H184.832z m655.872 369.664h-301.056V184.32c0-60.928 49.152-110.08 110.08-110.08h190.976c60.928 0 110.08 49.152 110.08 110.08v189.44c0 60.416-49.152 110.08-110.08 110.08z m-261.12-39.936h261.12c38.4 0 70.144-31.232 70.144-70.144V184.32c0-38.4-31.232-70.144-70.144-70.144h-190.976c-38.4 0-70.144 31.232-70.144 70.144v259.584z m-205.824 506.88H184.32c-60.928 0-110.08-49.152-110.08-110.08v-190.976c0-60.928 49.152-110.08 110.08-110.08h299.52v301.056c0 60.928-49.152 110.08-110.08 110.08z m-188.928-371.2c-38.4 0-70.144 31.232-70.144 70.144v190.976c0 38.4 31.232 70.144 70.144 70.144h189.44c38.4 0 70.144-31.232 70.144-70.144v-261.12H184.832z m655.872 371.2h-190.976c-60.928 0-110.08-49.152-110.08-110.08v-301.056h301.056c60.928 0 110.08 49.152 110.08 110.08v190.976c0 60.928-49.152 110.08-110.08 110.08z m-261.12-371.2v261.12c0 38.4 31.232 70.144 70.144 70.144h190.976c38.4 0 70.144-31.232 70.144-70.144v-190.976c0-38.4-31.232-70.144-70.144-70.144h-261.12z" fill="" ></path></symbol><symbol id="icon-gouwuche-xuanfu" viewBox="0 0 1031 1024"><path d="M362.186495 868.150054m-42.803858 0a42.803859 42.803859 0 1 0 85.607717 0 42.803859 42.803859 0 1 0-85.607717 0Z" fill="" ></path><path d="M758.39657 909.856377c-24.145766 0-42.803859-18.658092-42.803858-42.803858s18.658092-42.803859 42.803858-42.803859S801.200429 842.906752 801.200429 867.052519s-18.658092 42.803859-42.803859 42.803858zM338.040729 793.517685l-18.658092-2.19507h-2.19507c-2.19507 0-59.266881-10.975348-73.534834-108.655948l-61.461951-458.769561v-1.097535c-7.682744-32.926045-26.340836-41.706324-31.82851-43.901393H94.387996c-13.170418 0-23.048232-10.975348-23.048232-24.145766 1.097535-13.170418 10.975348-23.048232 24.145767-23.048232H154.752412c1.097535 0 2.19507 1.097535 3.292604 1.097535h1.097535c5.487674 1.097535 20.853162 6.585209 35.121115 19.755627 21.950697 20.853162 34.02358 49.389068 37.316184 84.510182v2.19507l58.169346 439.013933c6.585209 47.193998 25.243301 62.559486 35.121115 68.04716h1.097535l15.365487 1.097535 453.281887-2.19507c13.170418 0 24.145766 9.877814 24.145766 21.950697 0 6.585209-2.19507 12.072883-5.487674 16.463022-4.390139 4.390139-10.975348 7.682744-17.560557 7.682744l-455.476957 2.19507h-2.195069z" fill="" ></path><path d="M390.722401 678.276527c-12.072883 0-21.950697-8.780279-23.048232-20.853162-1.097535-13.170418 8.780279-25.243301 20.853162-26.340836l369.869239-32.926045s25.243301-1.097535 30.730976-52.681672v-1.097534c0-1.097535 1.097535-2.19507 1.097534-3.292605l34.02358-227.189711c0-2.19507 0-5.487674 1.097535-7.682743v-2.19507s1.097535-2.19507 1.097535-3.292605l2.19507-10.975348c1.097535-2.19507 1.097535-4.390139 1.097534-5.487674 0-10.975348-1.097535-17.560557-5.487674-21.950697-5.487674-8.780279-16.463023-12.072883-19.755627-12.072883l-475.232583 1.097535h-2.19507c-12.072883 0-21.950697-10.975348-21.950696-23.048232 0-6.585209 2.19507-12.072883 5.487674-16.463022 4.390139-4.390139 10.975348-7.682744 17.560557-7.682744l479.622723-1.097535s35.121115 2.19507 55.974276 30.730976c13.170418 19.755627 16.463023 44.998928 7.682744 75.729903l-39.511254 267.7985c-1.097535 4.390139-2.19507 8.780279-4.390139 10.975348l-1.097535 1.097535v1.097535c-7.682744 20.853162-19.755627 32.926045-28.535906 39.511254-17.560557 13.170418-32.926045 15.365488-36.218649 15.365487l-369.869239 32.926045h-1.097535z" fill="" ></path></symbol><symbol id="icon-meitibeizhu-icon" viewBox="0 0 1024 1024"><path d="M512 928.256c-8.192 0-16.384-3.072-22.528-9.216l-95.744-95.744c-12.8-12.8-12.8-32.768 0-45.056 12.8-12.8 32.768-12.8 45.056 0l73.216 73.216 73.216-73.216c6.144-6.144 14.336-9.216 22.528-9.216h223.744c17.92 0 31.744-14.336 31.744-31.744V225.28c0-17.408-14.336-31.744-31.744-31.744h-640c-17.408 0-31.744 14.336-31.744 31.744v512c0 17.92 14.336 31.744 31.744 31.744h95.744c17.92 0 31.744 14.336 31.744 31.744 0 17.92-14.336 31.744-31.744 31.744H192c-52.736 0-95.744-43.008-95.744-95.744v-512c0-52.736 43.008-95.744 95.744-95.744h640c52.736 0 95.744 43.008 95.744 95.744v512c0 52.736-43.008 95.744-95.744 95.744h-210.944l-86.528 86.528c-6.144 5.632-14.336 9.216-22.528 9.216zM335.872 512c-26.624 0-48.128-21.504-48.128-48.128s21.504-48.128 48.128-48.128 48.128 21.504 48.128 48.128-21.504 48.128-48.128 48.128z m192 0c-26.624 0-48.128-21.504-48.128-48.128s21.504-48.128 48.128-48.128 48.128 21.504 48.128 48.128-21.504 48.128-48.128 48.128z m192 0c-26.624 0-48.128-21.504-48.128-48.128s21.504-48.128 48.128-48.128 48.128 21.504 48.128 48.128-21.504 48.128-48.128 48.128z" fill="" ></path></symbol><symbol id="icon-tishi-tianjiagaojian" viewBox="0 0 1024 1024"><path d="M983.552 312.832c-26.112-60.928-63.488-116.224-110.08-162.816-46.592-46.592-101.888-83.968-162.304-109.568C649.216 13.312 582.656 0 512 0S374.784 13.312 312.832 40.448C252.416 66.56 197.12 103.424 150.528 150.016c-47.104 47.104-83.968 102.4-110.08 162.816C13.312 375.296 0 441.856 0 512.512s13.312 137.216 40.448 199.168c26.112 60.416 63.488 115.712 110.08 162.304 46.592 46.592 101.888 83.968 162.304 109.568 61.952 27.136 128.512 40.448 199.168 40.448s137.216-13.312 199.168-40.448c60.416-26.112 115.712-63.488 162.304-109.568 46.592-46.592 83.968-101.888 110.08-162.304 27.136-61.952 40.448-128 40.448-199.168s-13.312-137.216-40.448-199.68zM512 842.752c-31.744 0-57.856-26.112-57.856-57.856 0-31.744 26.112-57.856 57.856-57.856 31.744 1.024 57.344 27.648 56.32 59.392-1.024 30.72-25.6 55.296-56.32 56.32z m57.856-240.64c0 32.256-26.112 57.856-57.856 57.856-32.256 0-57.856-26.112-57.856-57.856V239.104c0-32.256 26.112-57.856 57.856-57.856 32.256 0 57.856 26.112 57.856 57.856v363.008z" fill="#FFAB00" ></path></symbol><symbol id="icon-dingdan-duanshipin" viewBox="0 0 1024 1024"><path d="M465.6 670.4c6.4 0 12.8-1.6 19.2-4.8l132.8-76.8c6.4-3.2 11.2-8 14.4-14.4 8-16 3.2-36.8-14.4-44.8l-132.8-76.8c-6.4-3.2-12.8-4.8-19.2-4.8-19.2 0-35.2 9.6-35.2 28.8V640c0 20.8 16 30.4 35.2 30.4z" fill="#AE7AF5" ></path><path d="M864 0H160C72 0 0 72 0 160v704c0 88 72 160 160 160h704c88 0 160-72 160-160V160c0-88-72-160-160-160zM632 254.4l80 92.8h-89.6l-80-92.8h89.6z m-116.8 0l80 92.8h-89.6l-80-92.8h89.6z m-116.8 0l80 92.8h-89.6l-80-92.8h89.6z m-155.2 35.2c0-20.8 16-35.2 35.2-35.2h3.2l80 92.8h-118.4v-57.6z m537.6 444.8c0 20.8-16 35.2-35.2 35.2H278.4h-1.6c-19.2 0-33.6-16-33.6-35.2V371.2h537.6v363.2z m0-385.6h-41.6l-80-92.8h88c19.2 0 33.6 16 33.6 35.2v57.6z" fill="#AE7AF5" ></path></symbol><symbol id="icon-dingdan-wanghongzhibo" viewBox="0 0 1024 1024"><path d="M614.4 540.8l-144-84.8c-4.8-3.2-11.2-3.2-16 0-3.2 3.2-6.4 8-6.4 14.4V640c0 6.4 3.2 11.2 8 14.4 3.2 1.6 4.8 1.6 8 1.6s4.8 0 8-1.6l144-84.8c4.8-3.2 8-8 8-14.4-1.6-6.4-4.8-11.2-9.6-14.4z" fill="#F78537" ></path><path d="M864 0H160C72 0 0 72 0 160v704c0 88 72 160 160 160h704c88 0 160-72 160-160V160c0-88-72-160-160-160z m-56 699.2c0 56-44.8 102.4-100.8 102.4H316.8c-54.4 0-100.8-46.4-100.8-102.4v-288c0-56 44.8-102.4 100.8-102.4h102.4L384 246.4c-3.2-8-1.6-16 6.4-20.8 8-4.8 16-1.6 20.8 6.4l43.2 78.4h108.8l43.2-78.4c3.2-8 12.8-9.6 20.8-6.4 8 3.2 9.6 12.8 6.4 20.8l-35.2 62.4h110.4c56 0 100.8 46.4 100.8 102.4v288z" fill="#F78537" ></path></symbol><symbol id="icon-dingdan-weixin" viewBox="0 0 1024 1024"><path d="M590.4 513.6c-11.2 0-25.6 14.4-25.6 25.6 0 14.4 11.2 25.6 25.6 25.6 19.2 0 33.6-14.4 33.6-25.6 0-14.4-14.4-25.6-33.6-25.6zM500.8 382.4c19.2 0 33.6-11.2 33.6-33.6 0-22.4-14.4-33.6-33.6-33.6-22.4 0-41.6 14.4-41.6 33.6 0 22.4 22.4 33.6 41.6 33.6zM316.8 315.2c-22.4 0-41.6 14.4-41.6 33.6 0 22.4 22.4 33.6 41.6 33.6 19.2 0 30.4-11.2 33.6-33.6 0-22.4-14.4-33.6-33.6-33.6z" fill="#13CE66" ></path><path d="M864 0H160C72 0 0 72 0 160v704c0 88 72 160 160 160h704c88 0 160-72 160-160V160c0-88-72-160-160-160zM403.2 656c-33.6 0-60.8-8-94.4-14.4l-94.4 44.8L240 608c-64-44.8-105.6-105.6-105.6-176 0-128 116.8-225.6 264-225.6 131.2 0 244.8 78.4 275.2 184h-25.6c-128 0-225.6 94.4-225.6 211.2 0 19.2 3.2 36.8 8 56h-27.2z m390.4 94.4l19.2 67.2-72-41.6c-25.6 8-52.8 14.4-78.4 14.4-128 0-225.6-86.4-225.6-192s100.8-192 225.6-192c120 0 225.6 86.4 225.6 192 0 57.6-41.6 110.4-94.4 152z" fill="#13CE66" ></path><path d="M734.4 513.6c-11.2 0-25.6 14.4-25.6 25.6 0 14.4 14.4 25.6 25.6 25.6 22.4 0 33.6-14.4 33.6-25.6 0-14.4-16-25.6-33.6-25.6z" fill="#13CE66" ></path></symbol><symbol id="icon-dingdan-weibo" viewBox="0 0 1024 1024"><path d="M435.2 603.2c-8 4.8-9.6 16-4.8 22.4 3.2 6.4 12.8 8 20.8 1.6s9.6-16 6.4-22.4c-4.8-6.4-12.8-8-22.4-1.6z" fill="#F56467" ></path><path d="M435.2 480c-116.8 4.8-211.2 67.2-211.2 145.6 0 78.4 94.4 136 211.2 131.2 116.8-4.8 211.2-78.4 211.2-156.8 0-76.8-94.4-124.8-211.2-120z m80 196.8c-35.2 46.4-107.2 68.8-176 32-32-17.6-32-52.8-32-52.8s-14.4-110.4 104-123.2c118.4-14.4 139.2 97.6 104 144z" fill="#F56467" ></path><path d="M379.2 617.6c-22.4 1.6-38.4 20.8-38.4 40 0 17.6 17.6 30.4 40 28.8 22.4-3.2 40-19.2 40-36.8 0-19.2-16-33.6-41.6-32z" fill="#F56467" ></path><path d="M864 0H160C72 0 0 72 0 160v704c0 88 72 160 160 160h704c88 0 160-72 160-160V160c0-88-72-160-160-160z m-112 652.8c-48 102.4-208 152-324.8 142.4-112-8-256-46.4-270.4-180.8 0 0-8-60.8 51.2-140.8 0 0 84.8-118.4 185.6-153.6 99.2-33.6 112 24 112 57.6-4.8 28.8-16 46.4 22.4 33.6 0 0 97.6-44.8 139.2-4.8 32 32 4.8 76.8 4.8 76.8s-12.8 14.4 14.4 20.8c25.6 6.4 113.6 46.4 65.6 148.8z m-97.6-281.6c-11.2 0-19.2-8-19.2-19.2s8-19.2 19.2-19.2c0 0 120-22.4 105.6 107.2v1.6c-1.6 9.6-9.6 16-19.2 16-11.2 0-19.2-8-19.2-19.2 0 0 19.2-86.4-67.2-67.2z m203.2 102.4c-3.2 22.4-14.4 24-27.2 24-16 0-27.2-9.6-27.2-25.6 0-12.8 4.8-27.2 4.8-27.2 1.6-6.4 14.4-40-8-92.8-43.2-72-129.6-72-139.2-68.8-9.6 4.8-25.6 6.4-25.6 6.4-16 0-28.8-12.8-28.8-27.2 0-12.8 8-24 20.8-27.2 1.6 0 1.6-1.6 3.2-1.6 11.2-1.6 54.4-11.2 96-1.6 75.2 17.6 177.6 89.6 131.2 241.6z" fill="#F56467" ></path></symbol><symbol id="icon-dingdan-ruanwen" viewBox="0 0 1024 1024"><path d="M302.4 486.4h318.4v54.4H302.4zM302.4 614.4h318.4v54.4H302.4zM300.8 340.8h177.6v57.6H300.8zM737.6 739.2c14.4 0 27.2-12.8 27.2-27.2v-224h-54.4v224c0 14.4 11.2 27.2 27.2 27.2z" fill="#458FF7" ></path><path d="M864 0H160C72 0 0 72 0 160v704c0 88 72 160 160 160h704c88 0 160-72 160-160V160c0-88-72-160-160-160z m-56 712c0 40-32 70.4-70.4 70.4H284.8c-38.4 0-70.4-32-70.4-70.4V302.4c0-38.4 32-60.8 70.4-60.8H640c38.4 0 70.4 22.4 70.4 60.8v140.8h99.2v268.8z" fill="#458FF7" ></path></symbol><symbol id="icon-mima" viewBox="0 0 1024 1024"><path d="M512 1024c-176.64 0-320-143.36-320-320 0-71.68 24.064-138.24 64-191.488V256c0-141.312 114.688-256 256-256s256 114.688 256 256v256.512c39.936 53.248 64 119.296 64 191.488 0 176.64-143.36 320-320 320z m192-768c0-105.984-86.016-192-192-192S320 150.016 320 256v192.512C373.76 408.064 439.808 384 512 384c72.192 0 138.24 24.064 192 64.512V256z m7.68 288.256l-3.584-4.096-4.096-4.608c-47.104-53.248-115.2-87.04-192-87.04-141.312 0-256 114.688-256 256s114.688 256 256 256 256-114.688 256-256c0-60.928-20.992-116.736-56.32-160.256z m-199.68 287.744c-17.92 0-32.256-14.336-32.256-32.256v-128c0-17.92 14.336-32.256 32.256-32.256s32.256 14.336 32.256 32.256v128c0 17.92-14.336 32.256-32.256 32.256z" fill="" ></path><path d="M512 641.024m-61.44 0a61.44 61.44 0 1 0 122.88 0 61.44 61.44 0 1 0-122.88 0Z" fill="" ></path></symbol><symbol id="icon-xinxiliu" viewBox="0 0 1024 1024"><path d="M802.133333 235.52H217.634133a51.2 51.2 0 0 0-51.2 51.2v450.730667a51.2 51.2 0 0 0 51.2 51.2H802.133333a51.2 51.2 0 0 0 51.2-51.2V286.72a51.2 51.2 0 0 0-51.2-51.2z m-268.8 270.4384h-119.842133V385.706667c61.5424 8.567467 110.216533 57.617067 119.739733 120.183466z m-138.922666 162.372267c-74.820267 0-135.953067-56.285867-140.8-128.7168v-14.472534A141.482667 141.482667 0 0 1 375.125333 385.706667v158.481066h158.856534a141.5168 141.5168 0 0 1-139.6736 124.074667z m367.377066-20.753067h-176.366933v-53.418667h176.264533z m0-98.2016h-176.366933V495.957333h176.264533z m0-98.235733h-117.828266v-53.418667h117.725866z" fill="#6296E2" ></path></symbol><symbol id="icon-QQ4" viewBox="0 0 1024 1024"><path d="M511.99375 736.525c16.0625 0 34.7125 18.75 52.95 25.65 16.7375 6.375 56.9 8.8375 93-4s49.6875-37.7 42.5-55.325-45.7-28.8625-45.7-28.8625C678.75625 659.5625 690.00625 624.275 690.00625 624.275c4.825 16.85 24.8625 33.6875 34.4875 32.8625s27.2625-32.0625 16.7625-84.1625-50.5125-81.8-50.5125-81.8c12.85-45.6625-21.625-70.525-21.625-70.525-1.125-73.925-33.975-115.2875-69.35-138.3875-21.3375-13.9375-54.4-25.3875-87.1875-25.6375-32.025-0.175-63.75 10.5-83.9 22.7875-37.025 22.5-72.75 64.125-73.85 141.25 0 0-34.4875 24.875-21.6625 70.525 0 0-40.0875 29.6875-50.5375 81.8s7.25 83.375 16.8625 84.1625 29.725-16.025 34.5125-32.875c0 0 11.25 35.2875 35.275 49.725 0 0-38.4875 11.25-45.6875 28.8625s6.45 42.5 42.5 55.325 76.25 10.3625 93.0125 4c18.1875-6.9 36.8625-25.65 52.8875-25.65z m0 0"  ></path><path d="M512.01757813 992C247.36132812 992 32.00585938 776.64453125 32.00585938 511.98828125S247.36132812 32 512.01757813 32s479.9765625 215.3203125 479.97656249 479.98828125S776.67382813 992 512.01757813 992z m-2e-8-928.12499999c-247.11328125 0-448.171875 201.046875-448.17187498 448.16015624S264.89257812 960.12499999 512.01757813 960.12499999 960.13085938 759.1015625 960.13085938 511.98828125 759.13085937 63.83984374 512.01757813 63.83984374z m0 0"  ></path></symbol><symbol id="icon-xiaohongshuicon" viewBox="0 0 1024 1024"><path d="M996.152769 56.513497c-7.985603-10.85223-17.609278-20.885423-28.871025-28.871025-23.137772-17.19976-51.189762-27.642472-81.90362-27.642472H138.417117c-30.713857 0-59.175365 10.442711-82.313138 27.642472-10.85223 7.985603-20.885423 17.609278-28.871026 28.871025C10.442711 79.446511 0 107.703259 0 138.621876v746.961007c0 30.713857 10.442711 59.175365 27.642472 81.90362 7.985603 10.85223 17.609278 20.885423 28.871025 28.871025 23.137772 17.19976 51.189762 27.642472 81.90362 27.642472h746.961007c30.713857 0 59.175365-10.442711 81.90362-27.642472 10.85223-7.985603 20.885423-17.609278 28.871025-28.871025 17.19976-23.137772 27.642472-51.189762 27.642472-81.90362V138.621876c0-30.918616-10.85223-59.175365-27.642472-82.108379zM366.518696 467.055389c16.380724-36.242352 34.809038-71.870426 52.213558-107.4985h59.994401c-14.742651 29.280544-31.123375 57.946811-41.566087 85.794041 24.366327-1.433313 46.480304-2.661868 72.484703-4.095181-13.923615 27.847231-26.209158 52.623075-38.494701 77.39892-1.638072 3.276145-3.276145 6.757049-4.914217 10.033193-12.89982 25.79964-12.89982 26.004399 15.766446 26.618677 3.071386 0 5.938012 0.409518 11.466507 1.023795-7.985603 15.766447-15.15217 30.09958-22.728254 44.227954-1.228554 2.25235-4.709458 4.914217-6.961808 4.914217-21.090182 0-42.385123 0.614277-63.475305-1.638072-15.15217-1.638072-21.090182-13.309338-15.152169-27.642471 7.166567-17.814037 15.766447-35.218556 23.752049-52.827835 2.661868-6.142771 5.528494-12.080784 9.418916-21.090182-11.671266 0-20.271146 0.204759-28.871025 0-24.775845-1.023795-33.170966-12.285543-22.933014-35.218556zM76.170366 658.30034c-12.695061-22.113977-24.161568-42.589882-35.832834-63.065787 0-2.457109 22.933013-72.484703 17.814038-151.726455h63.065787s2.25235 148.45031-45.046991 214.792242z m147.221756-7.985603c0.614277 37.061388-24.980604 37.061388-24.980604 37.061388H162.169166L124.083983 637.005399h39.928015V359.556889h59.994401c0 90.913017-0.204759 199.844831-0.614277 290.757848z m87.227354 4.709458c-28.666267-25.185363-44.227954-100.331934-43.818436-211.925615h59.175365c-4.504699 58.765847 14.537892 137.188562 14.537892 137.188563s-17.404519 38.494701-29.894821 74.737052z m129.817237 26.004399c-1.638072 3.071386-6.757049 5.938012-10.442712 6.142772-27.847231 0.409518-55.89922 0.204759-87.841631 0.204759 12.080784-24.161568 22.113977-43.818436 30.918616-61.018197h95.622475c-10.647471 20.885423-19.042591 38.085183-28.256748 54.670666z m244.482303 6.55229H469.717257c10.442711-20.680664 29.075785-57.537293 29.075784-57.537293h61.427715v-188.173565h-38.289942V383.104179h138.621875v57.946811h-37.880423v189.19736h62.24675v57.332534z m284.615077-43.408918c0 43.408918-42.385123 42.180364-42.385123 42.180364h-55.284943l-23.137772-49.756449 59.994401 0.204759s0.614277-45.046991 0-60.608678c-0.409518-13.104579-7.576085-21.4997-20.885423-21.70446-26.618676-0.614277-53.442112-0.204759-82.722656-0.204759v132.274346h-59.380123V555.10178h-59.994402v-61.222956h58.356329v-51.804039h-38.69946v-57.946811h39.313737v-24.571085H804.703059l0.409518 24.571085h47.708859s44.023195-1.023795 44.227954 41.770846c0.204759 12.695061 0.409518 54.261148 0.409518 68.184763 50.575485-0.204759 72.075185 10.033193 72.075185 45.25175v104.836633z m-25.390122-200.459109h-31.942411v-30.509098c0-11.056989 5.528494-21.294941 14.94741-27.232953 10.647471-6.757049 25.390122-11.056989 39.313737 2.252349 0.614277 0.409518 1.023795 1.023795 1.433314 1.638073 19.247351 20.271146 4.095181 53.85163-23.75205 53.851629z" fill="#FF2742" ></path><path d="M805.522096 493.878824h39.723255v-52.008798h-40.132774z" fill="#FF2742" ></path></symbol><symbol id="icon-xuanzhong" viewBox="0 0 1024 1024"><path d="M878.3 63.9H144.8c-44.8 0-81.5 36.7-81.5 81.5v733.5c0 44.8 36.7 81.5 81.5 81.5h733.5c44.8 0 81.5-36.7 81.5-81.5V145.4c0-44.9-36.7-81.5-81.5-81.5z m-491 664L214.1 550.7c-10.9-11.3-10.9-29.1 0-40.4 5.2-5.4 12.3-8.4 19.8-8.4 7.4 0 14.6 3 19.8 8.4L407 667.2l362.5-370.9c5.2-5.4 12.3-8.4 19.8-8.4 7.4 0 14.6 3 19.8 8.4 10.9 11.3 10.9 29.1 0 40.4L426.8 727.9c-5.3 5.4-12.4 8.4-19.8 8.4s-14.5-3.1-19.7-8.4z"  ></path></symbol><symbol id="icon-shujuzhongxin" viewBox="0 0 1024 1024"><path d="M358.404301 932.864v-103.936H102.404301C46.084301 829.44 0.004301 783.36 0.004301 727.04V142.848c-0.512-56.32 44.544-102.912 101.376-103.424H921.604301c56.32 0 102.4 46.08 102.4 102.4V719.872c0.512 56.32-44.544 102.912-100.864 103.936H665.604301V926.72h204.8v57.856H153.604301v-51.712h204.8zM102.404301 91.136c-28.16 1.024-50.688 23.552-51.2 51.712v576.512c-0.512 28.16 22.528 51.712 50.688 51.712H921.604301c28.16-1.024 50.688-23.552 51.2-51.712V142.848c0.512-28.16-22.528-51.712-50.688-51.712h-0.512H102.404301z" fill="#4C91FF" ></path><path d="M154.116301 521.728h102.4v160.256h-102.4v-160.256zM358.404301 468.992h102.4v212.48H358.404301V468.992z m204.8-264.704h102.4v477.184h-102.4V204.288z m204.288 157.184h102.4v316.928h-102.4V361.472z" fill="#FFB849" ></path></symbol><symbol id="icon-shujuliangjiankong" viewBox="0 0 1024 1024"><path d="M785.422643 955.392H239.118643c-16.896 3.584-32.256 13.312-41.984 27.648v40.96h630.272v-40.96c-0.512-22.528-20.48-27.648-41.984-27.648zM905.742643 0H118.286643C51.726643 1.536-1.009357 56.32 0.014643 122.88v573.44c-1.024 66.56 51.712 121.344 118.272 122.88H409.614643v34.304c-2.048 16.896 10.24 32.256 26.624 34.304 2.56 0.512 5.12 0.512 7.168 0h136.704c17.408 1.024 32.768-11.776 34.304-29.696V819.2h291.328c66.56-1.536 119.296-56.32 118.272-122.88V122.88c1.024-66.56-51.712-121.344-118.272-122.88z m9.728 802.816c-16.384 0.512-30.208-12.288-30.72-28.16-0.512-16.384 12.288-30.208 28.16-30.72 16.384-0.512 30.208 12.288 30.72 28.16v1.024c0.512 15.872-12.288 29.184-28.16 29.696z m57.856-176.128c1.024 59.904-46.592 109.568-106.496 110.592H157.198643c-59.904-1.024-107.52-50.688-106.496-110.592V161.792C49.678643 101.888 97.294643 52.224 157.198643 51.2h709.632c59.904 1.024 107.52 50.688 106.496 110.592v464.896z" fill="#0090FF" ></path><path d="M800.270643 174.08l-130.048 135.68L579.598643 215.04c-8.704-9.216-20.992-13.312-33.28-11.776-12.288 2.048-23.04 9.216-29.184 20.48L399.886643 437.76l-48.64-126.464c-4.608-12.8-15.36-22.016-28.672-25.088-13.312-2.56-26.624 1.536-35.84 11.264L167.950643 420.864c-15.36 16.384-15.36 41.984 0 58.368 14.848 15.36 38.912 15.872 54.784 1.536l1.536-1.536L300.046643 399.36l56.832 147.968c5.12 14.336 18.432 24.576 33.792 25.6h2.56c14.336 0 27.648-8.192 34.304-20.48l132.608-241.152 81.92 85.504c14.848 15.36 38.912 16.384 54.272 1.536l1.536-1.536 158.208-164.864c15.36-16.384 15.36-41.984 0-58.368-14.848-15.36-39.424-15.872-54.784-1.536 0 0.512-0.512 1.024-1.024 2.048z" fill="#FFB849" ></path></symbol><symbol id="icon-bangdan" viewBox="0 0 1024 1024"><path d="M104.96 887.808c-6.656 11.776-2.56 26.624 9.216 33.28 5.12 3.072 11.776 4.096 17.408 2.56l86.528-17.92c12.288-2.56 25.088 4.608 29.184 16.384l27.136 81.92c4.608 13.312 18.944 19.968 32.256 15.36 5.632-2.048 10.24-5.632 13.312-10.752l107.52-180.736c-83.456-13.312-161.792-48.64-226.816-101.888l-95.744 161.792zM919.04 887.296l-101.376-168.96a477.29664 477.29664 0 0 1-224.768 108.032l109.568 182.272c7.168 11.776 23.04 15.872 34.816 8.192 5.12-3.072 8.704-7.68 10.752-12.8l27.648-81.92c4.096-11.776 16.384-18.944 28.672-16.384l88.064 17.92c13.312 3.072 26.624-5.12 29.696-18.432 1.024-6.144 0-12.8-3.072-17.92zM504.832 2.56c-204.8 4.608-367.104 175.104-362.496 379.904S317.44 750.08 522.24 744.96c201.728-4.608 362.496-169.472 362.496-371.2C882.176 166.4 712.192 0.512 504.832 2.56z m3.072 681.984c-172.032-3.072-308.224-144.896-305.152-316.416 3.072-171.52 144.896-308.224 316.416-305.152 169.472 3.072 305.152 141.312 305.152 310.784-1.536 173.568-143.36 312.32-316.416 310.784z" fill="#0090FF" ></path><path d="M513.536 373.76m-147.968 0a147.968 147.968 0 1 0 295.936 0 147.968 147.968 0 1 0-295.936 0Z" fill="#FFB849" ></path></symbol><symbol id="icon-jiejuefangan_kuaixiaopinhangyetuiguang" viewBox="0 0 1024 1024"><path d="M392.192 1018.88c-47.104 0-58.88-29.696-67.584-51.2v-0.512c-0.512-3.584-2.56-5.632-3.584-7.168l-0.512-0.512v-1.024l-8.704-16.896v-28.672l-4.096-1.024c-83.968-16.384-147.968-79.36-178.176-115.2-0.512-1.024-1.536-1.536-1.536-2.048l-3.072-7.168V153.6c0-30.208 20.48-73.728 119.296-109.056C314.88 19.456 412.672 5.12 512 5.12c184.32 0 380.416 50.176 387.584 143.36h-4.608v649.216c0 2.56 0 10.752-2.56 13.312l-0.512 0.512-0.512 0.512c-44.544 68.608-140.288 109.568-255.488 109.568-24.064 0-48.128-2.048-72.704-5.632-13.824-1.536-25.088-2.56-34.816-2.56-39.424 0-45.568 15.36-55.808 37.888l-0.512 1.536c-2.56 4.608-3.584 8.192-5.12 11.776-1.024 3.072-2.048 5.632-3.584 9.216-12.8 25.088-41.984 44.032-68.096 44.032h-3.072z m-30.72-93.184c0 4.608 2.048 6.656 3.584 8.192l0.512 0.512c0 3.072 1.024 5.632 2.56 8.192 0.512 1.536 1.536 3.072 1.536 4.096v1.024l0.512 1.024c9.216 17.92 10.752 19.456 26.112 19.456 11.264 0 20.992-5.632 25.6-14.848 3.072-3.072 4.096-6.656 5.12-10.24 1.024-2.56 1.536-5.12 2.56-6.144l1.024-1.024 0.512-1.024c13.824-37.888 32.768-71.68 106.496-71.68 11.264 0 24.064 1.024 37.376 2.56 19.968 3.072 40.448 4.608 60.416 4.608 91.136 0 172.544-31.744 212.48-82.944l1.024-1.536V235.008l-7.68 4.608c-70.144 40.96-199.68 67.584-330.24 67.584-50.176 0-97.28 0-143.872-8.704l-5.632-1.536v628.736zM174.08 769.536l1.024 1.536c13.312 16.896 61.952 73.216 130.56 91.136l6.656 1.536V286.208l-4.096-1.024c-53.76-13.312-93.696-26.112-126.464-46.592l-7.68-5.12v536.064z m337.92-714.752c-203.264 0-337.92 59.392-337.92 98.816 0 46.592 144.384 98.816 337.92 98.816s337.92-52.224 337.92-98.816-144.384-98.816-337.92-98.816z" fill="#FF9B3B" ></path><path d="M375.296 182.784c-10.24 0-24.576-14.848-24.576-29.184 0-13.824 10.752-24.576 24.576-24.576H640c13.824 0 24.576 15.36 24.576 29.184s-10.752 24.576-24.576 24.576H375.296z" fill="#FF9B3B" ></path></symbol><symbol id="icon-jiejuefangan_dianshanghangyetuiguang" viewBox="0 0 1024 1024"><path d="M768 629.248h-192c-35.328 0-64 28.672-64 64v106.496c0 35.328 28.672 64 64 64H768c35.328 0 64-28.672 64-64v-106.496c0-35.328-28.672-64-64-64z m21.504 170.496c0 11.776-9.728 21.504-21.504 21.504h-192c-11.776 0-21.504-9.728-21.504-21.504v-106.496c0-11.776 9.728-21.504 21.504-21.504H768c11.776 0 21.504 9.728 21.504 21.504v106.496z" fill="#9F7AFF" ></path><path d="M931.84 159.744h-57.344v-42.496c0-35.328-28.672-64-64-64H213.504c-35.328 0-64 28.672-64 64v42.496H92.16L0 401.408v4.096c0 52.224 34.816 98.304 85.504 112.64v388.608c0 35.328 28.672 64 64 64h725.504c35.328 0 64-28.672 64-64v-388.608c50.688-14.336 84.992-60.416 85.504-112.64v-4.096L931.84 159.744zM192 117.248c0-11.776 9.728-21.504 21.504-21.504h597.504c11.776 0 21.504 9.728 21.504 21.504v42.496h-640v-42.496z m42.496 810.496v-234.496c0-11.776 9.728-21.504 21.504-21.504h128c11.776 0 21.504 9.728 21.504 21.504v234.496H234.496z m640 0H448v-234.496c0-35.328-28.672-64-64-64H256c-35.328 0-64 28.672-64 64v234.496h-42.496c-11.776 0-21.504-9.728-21.504-21.504v-384c34.304-3.072 65.536-20.992 85.504-49.152 37.376 52.736 111.104 65.024 163.84 27.648 11.264-7.68 20.48-17.408 28.16-28.672 46.08 58.368 130.56 68.608 188.928 22.528 8.192-6.656 15.872-13.824 22.528-22.528 36.864 53.248 110.08 66.56 163.328 29.696 11.264-7.68 20.992-17.408 28.672-28.16 20.48 28.672 52.224 46.592 87.04 49.152v384c0 11.776-9.728 20.992-21.504 20.992z m32.256-448c-41.472 0-74.752-33.28-74.752-74.752h-42.496c0 41.472-33.792 74.752-74.752 74.24-40.96 0-74.24-33.28-74.24-74.24h-42.496c-3.072 44.032-41.472 77.312-85.504 74.752-44.032 2.56-81.92-30.72-85.504-74.752H384c0 41.472-33.792 74.752-74.752 74.24-40.96 0-74.24-33.28-74.24-74.24h-42.496c1.024 41.472-31.744 75.264-72.704 76.288-41.472 1.024-75.264-31.744-76.288-72.704l78.848-206.336h781.312l78.848 206.336c-3.072 40.448-35.84 71.68-75.776 71.168z" fill="#9F7AFF" ></path></symbol><symbol id="icon-jiejuefangan_qichehangyetuiguang" viewBox="0 0 1024 1024"><path d="M999.936 458.752c-15.36-14.848-35.84-23.04-56.832-23.04H921.6c-4.608-30.208-14.848-59.392-30.208-85.504-20.48-35.328-49.664-67.072-87.04-94.208-74.752-54.784-174.592-84.992-279.552-84.992s-204.8 30.208-279.552 84.992c-36.864 26.624-66.56 58.88-87.04 94.208-15.36 26.112-25.6 55.808-30.208 85.504h-46.08c-21.504 0-41.472 8.192-56.832 23.04S1.536 493.056 1.536 514.56v184.832c0 20.992 8.192 40.96 23.552 55.808 15.36 14.848 35.84 23.04 56.832 23.04h26.624c21.504 45.568 67.584 74.24 117.76 74.24 50.688 0 96.768-28.672 117.76-74.24h350.208c21.504 45.568 67.072 74.24 117.76 74.24s96.768-28.672 117.76-74.24h13.312c21.504 0 41.472-8.192 56.832-23.04s23.552-34.304 23.552-55.808v-184.832c0-20.48-8.192-40.448-23.552-55.808z m-125.44-22.528h-327.168V216.576c87.04 3.584 167.424 30.72 229.376 75.264 54.272 39.936 88.064 89.6 97.792 144.384zM271.36 292.352c61.952-45.568 142.848-71.68 229.376-75.264v219.136H173.568c9.728-54.784 43.52-104.448 97.792-143.872z m-45.568 515.584c-46.08 0-83.968-36.352-83.968-81.92s37.888-81.92 83.968-81.92 83.968 36.352 83.968 81.92c-0.512 45.568-37.888 81.92-83.968 81.92z m585.728 0c-46.08 0-83.968-36.352-83.968-81.92s37.888-81.92 83.968-81.92 83.968 36.352 83.968 81.92c-0.512 45.568-37.888 81.92-83.968 81.92z m165.888-108.032c0 8.704-3.584 17.92-10.24 24.064-6.144 6.144-15.36 10.24-25.088 10.24h-2.048v-7.68c0-69.632-58.368-126.464-129.024-126.464-71.68 0-129.024 56.832-129.024 126.464v7.68H355.328v-7.68c0-69.632-58.368-126.464-129.024-126.464-71.68 0-129.024 56.832-129.024 126.464v7.68h-15.36c-8.704 0-17.92-3.584-25.088-10.24-6.144-6.144-10.24-15.36-10.24-24.064v-184.832c0-8.704 3.584-17.92 10.24-24.064 6.144-6.144 15.36-10.24 25.088-10.24h861.184c9.728 0 17.92 3.584 25.088 10.24 6.144 6.144 10.24 15.36 10.24 24.064l-1.024 184.832z" fill="#79A6FF" ></path></symbol><symbol id="icon-jiejuefangan_jinronghangyetuiguang" viewBox="0 0 1024 1024"><path d="M496.128 646.144c-37.376-11.776-60.928-23.552-60.928-53.248 0-31.744 25.6-53.248 60.928-55.296h2.048v108.544h-2.048z m39.424 52.736h2.048c27.648 9.728 57.344 23.552 57.344 57.344 0 11.776-4.096 49.152-57.344 58.88h-2.048v-116.224z m-7.68 199.168h7.68v-47.104h2.048c90.624-9.728 96.256-76.8 96.256-96.256 0-62.976-51.2-82.944-98.304-96.256h-2.048v-116.224h2.048c25.6 6.144 47.104 17.92 65.024 35.328l23.552-27.648c-23.552-23.552-53.248-39.424-88.576-43.52h-2.048v-47.104h-37.376v45.056h-2.048c-60.928 4.096-100.352 41.472-100.352 92.672 0 58.88 45.056 76.8 102.4 92.672h2.048v128h-2.048c-43.52-6.144-70.656-27.648-88.576-47.104l-23.552 29.696c27.648 31.744 67.072 49.152 110.08 51.2h2.048v45.056h31.744v1.536z" fill="#FF8C00" ></path><path d="M176.128 659.456C217.6 549.376 286.208 450.56 378.88 371.712c6.144-4.096 11.776-11.776 15.872-19.456 0 0 0-2.048 2.048-2.048 7.68-17.92 13.824-37.376 11.776-57.344v-2.048h2.048c67.072-9.728 130.048-11.776 185.344-2.048h2.048v6.144c2.048 29.696 13.824 41.472 27.648 55.296l9.728 9.728 2.048 2.048c4.096 4.096 7.68 6.144 9.728 9.728 29.696 29.696 159.744 169.472 202.752 287.744 37.376 102.4 41.472 141.824 39.424 175.104 0 49.152-2.048 141.824-197.12 143.872h-143.872c-45.056 0-106.496 0-216.576-2.048-195.072-2.048-195.072-94.72-197.12-141.824 0.512-31.744 2.048-72.704 41.472-175.104M353.28 180.736c-6.144-6.144-11.776-11.776-15.872-19.456-4.096-4.096-7.68-7.68-11.776-13.824-11.776-13.824-21.504-37.376-27.648-76.8v-2.048h15.872c11.776 0 31.744 2.048 49.152 6.144 23.552 4.096 51.2 7.68 76.8 7.68h2.048c29.696 0 53.248-9.728 74.752-19.456 19.456-7.68 35.328-15.872 55.296-13.824 23.552 2.048 43.52 15.872 62.976 29.696 13.824 9.728 25.6 19.456 41.472 25.6 27.648 7.68 62.976-2.048 72.704-6.144l4.096-2.048-2.048 6.144c-6.144 15.872-33.28 39.424-84.48 80.896-6.144 6.144-13.824 9.728-19.456 15.872-6.144 4.096-9.728 7.68-11.776 9.728l-2.048 2.048c-7.68 6.144-21.504 17.92-29.696 41.472v2.048h-2.048c-57.344-9.728-125.952-7.68-197.12 4.096h-2.048v-2.048c-11.264-34.304-31.232-56.32-49.152-75.776M99.328 834.56c0 49.152 2.048 179.2 232.448 181.248 188.928 2.048 226.304 2.048 328.704 2.048h31.744c228.352-2.048 230.4-134.144 232.448-183.296 0-35.328-2.048-80.896-41.472-186.88-47.104-123.904-173.056-262.144-212.48-301.056-4.096-4.096-7.68-6.144-11.776-9.728l-7.68-7.68 2.048-4.096c9.728 7.68 19.456 11.776 31.744 11.776 17.92 0 35.328-9.728 43.52-27.648V307.2h2.048c70.656 13.824 110.08 37.376 118.272 67.072 2.048 9.728 9.728 15.872 19.456 15.872h4.096c9.728-2.048 17.92-13.824 13.824-23.552-9.728-41.472-47.104-70.656-114.176-88.576h-4.096l2.048-2.048c23.552-21.504 39.424-45.056 41.472-60.928 2.048-9.728-6.144-19.456-15.872-21.504-9.728-2.048-19.456 6.144-21.504 15.872-2.048 11.776-29.696 41.472-47.104 53.248l-2.048-2.048-2.048-2.048c-9.728-13.824-23.552-21.504-39.424-21.504-13.824 0-27.648 6.144-35.328 17.92l-4.096-2.048c6.144-9.728 11.776-15.872 13.824-15.872l7.68-7.68 2.048-2.048c7.68-6.144 15.872-11.776 23.552-19.456 45.056-35.328 84.48-67.072 94.72-94.72 4.096-9.728 6.144-15.872 6.144-19.456 4.096-9.728 6.144-23.552-6.144-29.696-4.096-4.096-7.68-7.68-17.92-7.68-7.68 0-13.824 2.048-23.552 6.144-15.872 6.144-37.376 11.776-53.248 6.144-11.776-6.144-23.552-13.824-35.328-21.504-21.504-15.872-47.104-33.28-80.896-35.328-27.648-2.048-49.152 7.68-70.656 15.872-19.456 7.68-37.376 15.872-62.976 15.872-23.552 0-51.2-4.096-72.704-7.68-21.504-2.048-39.424-6.144-55.296-6.144-6.144 0-11.776 0-13.824 2.048-4.096-2.048-7.68-6.144-11.776-11.776-4.096-5.632-7.68-13.824-19.456-13.824-4.096 0-9.728 4.096-13.824 7.68-6.144 7.68-6.144 7.68 6.144 47.104l2.048 6.144c0 2.048 0 4.096 2.048 6.144v2.048c7.68 41.472 19.456 70.656 37.376 90.624 4.096 4.096 7.68 9.728 11.776 13.824 17.92 21.504 43.52 53.248 55.296 84.48v2.048h-2.048c-2.048 0-4.096 0-7.68 2.048-4.096 0-7.68 2.048-9.728 2.048-9.728 2.048-15.872 11.776-13.824 21.504s11.776 15.872 21.504 13.824c4.096 0 6.144-2.048 9.728-2.048 2.048 0 4.096 0 6.144-2.048h2.048v2.048c0 11.776-2.048 21.504-7.68 31.744-4.096 4.096-6.144 7.68-9.728 11.776C261.632 430.08 188.416 534.016 145.408 650.24c-44.032 105.472-46.08 148.992-46.08 184.32" fill="#FF8C00" ></path></symbol><symbol id="icon-jiejuefangan_muyinghangyetuiguang" viewBox="0 0 1024 1024"><path d="M1018.88 482.304c0-11.776-9.728-21.504-21.504-21.504H257.024L185.856 316.928c-0.512-1.024-1.024-1.536-1.536-2.56-1.024-1.536-1.536-2.56-3.072-3.584-1.024-1.024-2.048-1.536-3.584-2.56-1.024-0.512-2.048-1.536-3.584-2.048-1.536-0.512-3.072-0.512-4.608-1.024-1.024 0-2.048-0.512-3.072-0.512H26.624c-11.776 0.512-21.504 10.24-21.504 22.016S14.848 348.16 26.624 348.16H153.6l67.584 137.216c1.536 218.112 179.712 395.264 398.336 395.264 220.672 0.512 399.36-178.688 399.36-398.336z m-398.848 356.352c-189.44 0-344.064-148.48-355.328-335.36h710.144c-10.752 186.88-165.376 335.36-354.816 335.36z" fill="#FF8DC6" ></path><path d="M409.088 833.024c-44.544 1.536-79.36 38.912-77.312 83.456 1.536 41.984 35.328 75.776 77.312 77.312 44.544 0 80.384-36.352 80.384-80.384s-36.352-80.384-80.384-80.384z m0 119.296c-21.504 0-38.4-17.408-37.888-38.4 0-21.504 17.408-38.4 38.4-38.4 21.504 0 38.4 17.408 37.888 38.4s-17.92 38.4-38.4 38.4z m419.84-119.296c-44.544 1.536-79.36 38.912-77.312 83.456 1.536 41.984 35.328 75.776 77.312 77.312 44.544-1.536 79.36-38.912 77.312-83.456-1.536-41.472-35.328-75.776-77.312-77.312z m0 119.296c-21.504-1.024-37.376-18.944-36.864-39.424 1.024-19.968 16.896-35.84 36.864-36.864 21.504 1.024 37.376 18.944 36.864 39.424-1.024 19.968-17.408 36.352-36.864 36.864zM625.664 407.04c0.512 1.536 1.024 2.56 2.048 4.096 0.512 1.024 1.024 2.048 2.048 3.072 1.024 1.024 2.048 2.048 3.584 3.072 0.512 0.512 1.024 1.024 2.048 1.536h1.024c3.072 1.536 6.144 2.56 9.728 2.56h348.672c11.776 0 21.504-9.728 21.504-21.504 0-131.072-70.144-252.928-183.296-318.976l-1.536-1.536c-0.512-0.512-1.024-0.512-1.536-0.512-55.808-32.256-118.784-49.152-183.296-49.152-11.776 0-21.504 9.728-21.504 21.504v348.16c0 1.024 0.512 2.048 0.512 3.072-0.512 2.048-0.512 3.072 0 4.608z m346.624-28.16h-289.792l144.896-250.88c84.48 56.832 138.24 149.504 144.896 250.88z m-305.152-57.856V73.728c43.008 2.56 84.992 14.336 123.392 32.768l-123.392 214.528z m-290.304 23.04c9.728 7.168 23.04 5.12 29.696-4.608 7.168-9.728 5.12-23.04-4.608-29.696-0.512 0-0.512-0.512-1.024-0.512l-143.36-100.352c-9.216-7.168-23.04-5.632-29.696 3.584-7.168 9.216-5.632 23.04 3.584 29.696 0.512 0.512 1.024 1.024 2.048 1.536l143.36 100.352z m56.32-130.56c4.096 11.264 16.896 16.384 27.136 12.288 11.264-4.096 16.384-16.896 12.288-27.136L429.056 87.04c-4.096-11.264-16.384-16.896-26.624-13.312-11.264 4.096-16.896 16.384-13.312 26.624 0 0.512 0.512 1.024 0.512 1.536l43.52 111.616z m-38.4 68.608c7.168 9.216 20.48 10.752 29.184 3.584 9.216-7.168 10.752-20.992 3.584-29.696L333.824 137.216c-7.168-9.216-20.992-10.752-29.696-3.584-9.216 7.168-10.752 20.992-3.584 29.696l94.208 118.784z" fill="#FF8DC6" ></path></symbol><symbol id="icon-jiejuefangan_lvyouhangyetuiguang" viewBox="0 0 1024 1024"><path d="M183.808 841.216c11.776 19.456 46.592 74.752 72.192 115.2 15.36 24.576 27.648 43.52 28.672 46.08 7.168 12.288 19.456 19.456 34.304 19.968h1.024c13.312 0 27.136-6.656 40.448-19.456 31.744-36.864 30.72-55.296 30.208-64V793.6l119.296-114.688c34.304 93.696 101.888 275.968 106.496 288.256 9.728 25.088 29.184 29.184 37.376 30.208 15.872 1.536 32.256-5.12 46.08-18.432 2.048-2.048 46.08-49.152 65.536-72.704 20.992-25.6 20.48-48.128 19.968-57.856 0-3.072-3.584-57.856-9.216-155.136-5.632-91.648-12.288-201.728-15.872-263.68l205.824-205.824c50.176-49.664 57.856-102.4 57.856-129.024 0-29.696-8.704-55.808-23.04-70.144s-41.984-23.552-71.68-23.552c-26.624 0-78.848 7.68-129.024 57.344l-205.824 205.824c-53.248-3.584-141.312-9.216-223.232-14.336-104.448-6.656-194.56-12.8-198.656-12.8h-5.12c-18.944 0-35.84 6.656-52.224 19.968C92.16 275.968 45.056 320.512 42.496 322.56c-13.312 13.312-19.968 30.208-18.432 46.08 1.024 9.728 6.144 27.648 30.208 37.376 11.776 4.608 194.048 72.704 290.304 108.544l-114.176 117.76c-5.12 0-10.24 0.512-16.896 0-20.992 0-48.64-0.512-73.216-0.512-25.088-0.512-46.592-0.512-54.784-0.512l0.512 7.168-2.048-7.168h-1.536c-11.776 0-29.184 3.584-61.952 31.232l-3.072 2.56c-13.312 13.312-16.384 27.136-16.896 35.84-0.512 13.312 5.12 25.6 15.872 34.304 7.168 6.144 95.744 62.976 167.424 105.984z m30.72-46.592c-59.904-36.352-124.416-77.312-151.552-94.72 12.288-9.728 18.432-12.288 19.968-12.288h10.24c9.216 0 24.576 0 41.472 0.512h4.608c33.792 0.512 74.24 1.024 95.232 0.512 12.8-0.512 25.088-5.632 34.304-14.848l124.416-128c11.776-11.776 16.384-28.672 12.8-45.056-3.584-16.384-15.36-29.184-30.72-35.328-81.92-30.208-241.664-90.112-288.256-107.52 13.824-12.8 47.104-43.52 64-57.856 8.704-7.168 13.824-7.168 16.384-7.168h3.072c7.168 0.512 108.032 6.656 197.12 12.8 83.456 5.632 173.568 11.264 226.816 14.848 14.336 1.024 27.648-4.096 37.888-14.336L839.68 97.792c35.84-35.84 71.68-40.96 89.6-40.96 19.968 0 30.72 6.144 32.256 7.168 8.704 8.704 18.432 67.584-34.816 120.832l-208.384 208.384c-9.728 9.728-14.848 23.552-14.336 37.376 3.584 58.88 9.728 164.352 15.36 254.976l0.512 12.288c4.096 65.536 8.704 147.456 9.216 153.6 0 6.144 0.512 10.752-7.168 19.968-13.824 16.896-43.52 49.152-57.344 64-16.896-45.568-76.288-205.312-104.96-284.672-5.632-15.872-18.944-27.136-34.816-31.232-15.872-3.584-33.28 1.024-45.056 12.288l-129.024 124.416c-9.216 9.216-14.848 21.504-14.848 34.304-0.512 20.48-0.512 56.832-0.512 89.6v56.32c0 1.536 0 3.584 0.512 5.12 0 0-1.536 5.632-11.264 18.432l-20.48-32.768c-26.112-41.472-61.952-98.816-72.704-116.224-4.608-7.168-10.24-12.8-16.896-16.384z" fill="#00D9FF" ></path></symbol><symbol id="icon-jiejuefangan_xiaochengxutuiguang" viewBox="0 0 1024 1024"><path d="M634.88 257.536c81.92 0 148.48 61.44 148.48 137.728 0 23.552-6.656 47.104-19.456 68.096-18.432 30.72-48.64 53.248-84.992 64-9.728 3.072-16.896 4.096-23.552 4.096-15.872 0-28.16-12.288-28.16-28.16s12.288-28.16 28.16-28.16c1.024 0 3.584 0 6.144-1.024 24.064-6.656 43.52-20.992 54.272-39.424 7.168-11.776 10.752-25.088 10.752-38.4 0-44.544-41.472-81.408-91.648-81.408-17.408 0-34.304 4.608-49.664 12.8-26.624 15.36-42.496 40.96-42.496 68.608v237.056c0 48.128-26.624 92.16-70.656 117.248-23.552 13.824-50.176 20.48-77.312 20.48-81.92 0-148.48-61.44-148.48-137.728 0-23.552 6.656-47.104 19.456-68.096 18.432-30.72 48.64-53.248 84.992-64 10.24-3.072 16.896-4.096 23.552-4.096 15.872 0 28.16 12.288 28.16 28.16s-12.288 28.16-28.16 28.16c-1.024 0-3.584 0-6.144 1.024-24.064 7.168-43.52 21.504-54.272 39.424-7.168 11.776-10.752 25.088-10.752 38.4 0 44.544 41.472 81.408 92.16 81.408 17.408 0 34.304-4.608 49.664-12.8 26.624-15.36 42.496-40.96 42.496-68.608V395.264c0-48.128 26.624-92.16 70.656-117.248 23.04-13.824 49.664-20.48 76.8-20.48zM59.392 512c0 249.856 202.24 452.608 452.608 452.608s452.608-202.24 452.608-452.608-202.752-452.608-452.608-452.608S59.392 262.144 59.392 512z m-56.32 0C3.072 230.912 230.912 3.072 512 3.072s508.928 227.84 508.928 508.928-227.84 508.928-508.928 508.928S3.072 793.088 3.072 512z" fill="#00D78D" ></path></symbol><symbol id="icon-jiejuefangan_shishangmeirongtuiguang" viewBox="0 0 1024 1024"><path d="M336.384 1017.344c-47.104 0-81.408-5.632-101.888-16.384-19.456-9.728-24.576-21.504-26.112-28.16v-2.048-3.584l58.88-490.496L38.4 192.512c-4.608-6.144-5.632-14.336-2.048-20.992 0 0 0-0.512 0.512-0.512 7.68-12.8 29.696-46.08 70.656-78.336C151.552 56.32 227.328 11.776 340.48 7.168c5.12-0.512 11.264-0.512 16.384-0.512 85.504 0 164.864 29.696 229.376 84.992 41.472 35.328 65.024 71.168 73.216 84.992 0.512 0.512 0.512 1.024 0.512 1.024 3.584 6.144 2.56 14.848-2.048 20.992l-221.184 281.6 53.248 487.936c1.024 6.144-1.536 11.776-6.144 15.872-6.144 5.632-41.472 33.28-147.456 33.28z m-88.576-52.736l3.072 1.536c8.704 4.608 31.744 12.8 86.016 12.8 59.392 0 93.184-9.216 111.104-16.896l3.584-1.536-43.008-389.12-10.24 0.512v4.096H294.4l-46.592 388.608z m51.2-427.008H404.48l-8.704-74.24-7.68 11.776c-3.584 5.632-9.728 8.704-16.384 8.704l-44.032-0.512c-5.12 0-9.728-2.048-13.312-5.632l-7.68-7.68-7.68 67.584z m120.32-294.4c1.536 0 2.56 0 4.096 0.512 4.608 1.024 9.216 4.096 11.776 8.704 2.56 4.608 3.584 9.728 2.56 14.336l-44.032 190.464 9.216 4.096 217.088-275.456-2.048-3.072c-11.264-15.872-30.208-39.424-57.344-62.976C502.272 70.144 434.176 45.056 357.376 45.056c-2.56 0-5.632 0-8.192 0.512-2.048 0-4.608 0.512-6.656 0.512-81.92 3.584-152.576 29.184-210.432 76.288-25.6 20.48-42.496 40.96-52.224 54.784l-2.048 3.072 215.552 268.8 8.704-4.608-45.568-172.544c-2.56-10.24 4.096-20.992 13.824-23.552 1.024-0.512 2.56-0.512 4.096-0.512 9.216 0 16.896 6.144 19.456 14.336L343.04 445.44h14.336l43.008-187.904c1.536-8.192 9.728-14.336 18.944-14.336z m258.048 769.536c-5.12 0-9.728-2.048-13.312-5.632-3.584-3.584-5.632-8.704-5.632-13.824l3.072-535.04c0-10.24 8.704-18.944 19.456-18.944h43.52V179.2c0-1.536 0.512-3.584 1.024-5.632 4.096-12.8 27.136-75.776 82.432-88.064 33.792-7.68 75.776-42.496 93.184-59.904 3.584-3.584 8.192-5.632 13.824-5.632 2.56 0 5.12 0.512 7.68 1.536 7.168 3.072 11.776 10.24 11.776 17.92v400.384h35.84c10.24 0 19.456 8.704 19.456 18.432V993.28c0 10.752-8.704 19.456-19.456 19.456h-292.864z m19.968-37.888h253.44v-496.64h-250.88l-2.56 496.64z m189.952-886.784c-16.896 12.8-43.52 29.184-71.168 35.328-28.16 6.144-46.592 39.424-52.736 58.368l-0.512 1.024v253.952h132.096V81.92l-7.68 6.144z m-17.92 788.992c-10.752 0-18.944-8.192-19.456-19.456v-301.568c0-10.752 8.704-19.456 19.456-19.456s19.456 8.704 19.456 19.456v301.568c0 10.752-9.216 19.456-19.456 19.456z" fill="#FF43A6" ></path></symbol><symbol id="icon-jiejuefangan_apptuiguang" viewBox="0 0 1024 1024"><path d="M318.976 702.464c-9.728 0-18.944-5.632-23.04-14.848L175.616 419.328l-120.832 268.288c-4.096 9.216-13.312 14.848-23.04 14.848-3.584 0-6.656-1.024-10.752-2.56-12.288-5.632-17.92-20.48-12.288-32.768l143.36-319.488c4.096-9.216 12.8-14.848 23.04-14.848s18.944 5.632 23.04 14.848l143.36 319.488c5.632 12.288 0 27.136-12.8 33.28-2.56 1.024-6.144 2.048-9.728 2.048z" fill="#FFAE00" ></path><path d="M269.824 1008.64c-66.048 0-119.808-53.76-119.808-119.808v-101.888c0-13.824 11.264-25.088 25.088-25.088s25.088 11.264 25.088 25.088v101.888c0 38.4 31.232 69.632 69.632 69.632h475.648c38.4 0 69.632-31.232 69.632-69.632v-101.888c0-13.824 11.264-25.088 25.088-25.088s25.088 11.264 25.088 25.088v101.888c0 66.048-53.76 119.808-119.808 119.808H269.824z m518.144-301.568c-13.824 0-25.088-11.264-25.088-25.088v-327.68c0-13.824 11.264-25.088 25.088-25.088h113.664c63.488 0 115.2 51.712 115.2 115.2s-51.712 115.2-115.2 115.2h-88.064v122.88c-0.512 13.312-11.776 24.576-25.6 24.576z m25.088-198.144H901.12c35.84 0 65.024-29.184 65.024-65.024S936.96 378.88 901.12 378.88h-88.064v130.048z m-382.464 198.144c-13.824 0-25.088-11.264-25.088-25.088v-327.68c0-13.824 11.264-25.088 25.088-25.088h113.152c63.488 0 115.2 51.712 115.2 115.2s-51.712 115.2-115.2 115.2H455.68v122.88c0 13.312-11.264 24.576-25.088 24.576zM455.68 508.928h88.064c35.84 0 65.024-29.184 65.024-65.024S580.096 378.88 544.256 378.88H455.68v130.048z m-363.52 89.088c-13.824 0-25.088-11.264-25.088-25.088s11.264-25.088 25.088-25.088h172.032c13.824 0 25.088 11.264 25.088 25.088s-11.264 25.088-25.088 25.088H92.16z m748.544-329.728c-13.824 0-25.088-11.264-25.088-25.088V135.168c0-38.4-31.232-69.632-69.632-69.632h-476.16c-38.4 0-69.632 31.232-69.632 69.632v108.032c0 13.824-11.264 25.088-25.088 25.088s-25.088-11.264-25.088-25.088V135.168C150.528 69.12 204.288 15.36 269.824 15.36h475.648C811.52 15.36 865.28 69.12 865.28 135.168v108.032c0.512 13.824-10.752 25.088-24.576 25.088z" fill="#FFAE00" ></path></symbol><symbol id="icon-jiejuefangan_weishanghangyetuiguang" viewBox="0 0 1024 1024"><path d="M151.552 970.752c-48.128 0-86.528-38.4-86.528-86.016l-0.512-200.704c0-7.68 3.072-14.336 8.192-19.968 5.632-5.12 12.288-8.192 19.456-8.192 15.36 0 28.16 12.288 28.16 27.648v200.704c0 16.896 13.824 30.72 30.72 30.72l707.584-0.512c16.896 0 31.232-13.824 31.232-30.72v-204.8c0-15.36 12.288-27.648 27.648-27.648s27.648 12.288 27.648 27.648v204.288c0 47.616-38.912 86.016-86.528 86.016l-707.072 1.536z m46.08-369.152c-32.768 0-62.464-6.144-87.552-18.432v-3.584H102.4C38.912 545.28 0 479.232 0 407.552c0-20.48 3.584-40.96 10.24-61.44v-1.024c0-1.536 0.512-3.072 1.024-4.096l94.72-222.72c13.312-39.936 50.688-64.512 97.792-64.512h619.008c48.128 0 87.552 26.112 101.376 66.56l88.064 219.136c0.512 1.024 1.024 3.072 1.536 4.608v2.048c6.144 19.456 9.728 39.936 9.728 60.416 0 71.68-39.424 138.24-102.912 172.544-26.624 14.336-58.368 22.016-94.208 22.016-58.368 0-113.664-25.6-151.04-69.632l-7.168-8.704-7.168 8.704c-36.864 44.032-91.136 69.12-148.992 70.144-57.856 0-112.64-26.112-149.504-69.632l-7.68-8.704-7.168 8.704c-36.864 44.032-91.648 69.632-150.016 69.632zM133.12 532.48c17.92 9.216 39.424 13.824 64.512 13.824 48.64 0 93.696-25.088 119.808-67.072l0.512-0.512 0.512-0.512c1.024-3.072 4.096-8.704 8.704-14.336h0.512c5.12-6.144 15.872-10.752 28.16-10.752s23.552 4.608 29.696 11.776l0.512 0.512c3.584 4.096 6.144 8.704 7.168 11.776l0.512 0.512 0.512 0.512c26.112 41.984 70.656 67.072 119.296 67.584 48.128 0 93.184-25.088 118.784-67.072v-1.024c1.536-3.584 4.096-8.704 8.704-13.312v-0.512c6.144-7.168 16.896-11.776 28.672-11.776 14.848 0 24.064 6.144 28.672 11.776 4.608 4.608 7.168 10.24 8.704 13.312v0.512l0.512 0.512c26.112 41.984 70.656 67.072 120.32 67.072 26.112 0 49.152-5.12 67.584-15.36 45.568-24.576 73.728-72.192 73.728-123.904 0-15.36-2.56-30.72-7.68-45.568-0.512-1.024-0.512-2.048-1.024-3.584v-1.024l-87.552-217.088c-9.728-28.16-37.888-29.696-48.128-30.72H204.8c-23.552 0-38.912 9.728-46.08 28.672l-93.696 220.16v1.024c-0.512 1.024-0.512 1.536-0.512 2.048-5.12 15.36-7.68 30.208-7.68 46.08 0 52.224 28.672 99.84 75.264 124.416l1.024 2.048z m71.68-162.304c-15.36 0-27.648-12.288-27.648-27.648s12.8-27.648 27.648-27.648h602.112c15.36 0 27.648 12.8 27.648 27.648 0 15.36-12.288 27.648-27.648 27.648H204.8z" fill="#00E1A8" ></path></symbol><symbol id="icon-jiejuefangan-youxihangyetuiguang" viewBox="0 0 1024 1024"><path d="M654.848 1007.104H369.152C166.4 1007.104 0 840.704 0 637.952s166.4-369.152 369.152-369.152h100.352c10.752 0 19.456-8.704 19.456-19.456V38.4c0-12.8 8.704-21.504 21.504-21.504s21.504 8.704 21.504 21.504v210.944c0 34.304-27.648 61.952-61.952 61.952H369.152c-179.2 0-326.656 147.456-326.656 326.656s147.456 326.656 326.656 326.656h285.696c179.2 0 326.656-147.456 326.656-326.656s-147.456-326.656-326.656-326.656c-12.8 0-21.504-8.704-21.504-21.504s8.704-21.504 21.504-21.504c202.752 0 369.152 166.4 369.152 369.152s-164.352 369.664-369.152 369.664z" fill="#FF5300" ></path><path d="M307.2 761.856c-68.096 0-123.904-55.296-123.904-123.904 0-68.096 55.296-123.904 123.904-123.904s123.904 55.296 123.904 123.904-55.808 123.904-123.904 123.904z m0-205.312c-45.056 0-80.896 36.352-80.896 80.896 0 44.544 36.352 80.896 80.896 80.896s80.896-36.352 80.896-80.896c0-44.544-36.352-80.896-80.896-80.896zM594.944 637.952c0 22.528 17.92 40.448 40.448 40.448s40.448-17.92 40.448-40.448-17.92-40.448-40.448-40.448c-22.016 0-40.448 17.92-40.448 40.448zM722.944 637.952c0 22.528 17.92 40.448 40.448 40.448s40.448-17.92 40.448-40.448-17.92-40.448-40.448-40.448-40.448 17.92-40.448 40.448z" fill="#FF5300" ></path></symbol><symbol id="icon-jiejuefangan_xinpintuiguang" viewBox="0 0 1024 1024"><path d="M917.504 558.592H106.496C47.616 558.592 0 510.976 0 452.096V343.04c0-58.88 47.616-106.496 106.496-106.496h810.496c58.88 0 106.496 47.616 106.496 106.496v109.056c1.024 58.88-47.104 106.496-105.984 106.496zM106.496 274.432c-37.376 0-68.096 30.208-68.096 68.096v109.056c0 37.376 30.208 68.096 68.096 68.096h810.496c37.376 0 68.096-30.208 68.096-68.096V343.04c0-37.376-30.208-68.096-68.096-68.096H106.496z" fill="#FF5462" ></path><path d="M752.64 1015.296H271.36c-91.136 0-164.864-74.24-164.864-164.864v-330.24h811.008v330.24c0.512 90.624-73.728 164.864-164.864 164.864zM145.408 558.592V849.92c0 69.632 56.32 126.464 126.464 126.464h480.256c69.632 0 126.464-56.32 126.464-126.464v-291.328H145.408z m386.56-284.16h-133.12C336.384 274.432 281.6 230.4 268.8 168.96c-1.536-9.216-3.072-17.92-3.072-27.648 0-73.728 59.392-133.12 133.12-133.12s133.12 59.392 133.12 133.12v133.12zM398.336 47.616c-51.712 0-94.72 41.984-94.72 94.72 0 6.656 0.512 13.312 2.56 19.968 9.216 43.008 47.616 74.752 92.16 74.752h94.72V141.824C492.544 89.6 450.56 47.616 398.336 47.616z" fill="#FF5462" ></path><path d="M625.664 274.432h-133.12v-133.12c0-73.728 59.392-133.12 133.12-133.12s133.12 59.392 133.12 133.12c0 9.216-1.024 18.432-3.072 27.648-12.8 61.44-67.584 105.472-130.048 105.472z m-93.696-38.4h94.72c44.544 0 82.944-31.744 92.16-74.752 1.024-6.656 2.56-12.8 2.56-19.968 0-51.712-41.984-94.72-94.72-94.72s-94.72 42.496-94.72 94.72v94.72z" fill="#FF5462" ></path><path d="M492.544 243.2h38.912v756.736h-38.912V243.2z" fill="#FF5462" ></path></symbol><symbol id="icon-wanghongzhibotuiguangfuwu" viewBox="0 0 1024 1024"><path d="M433.664 387.072c-17.92-12.288-36.352-12.288-48.128 0-12.288 12.288-24.064 24.064-24.064 41.984v301.056c0 17.92 6.144 36.352 24.064 41.984 6.144 6.144 17.92 6.144 24.064 6.144s17.92 0 24.064-6.144c17.92-12.288 228.864-138.752 246.784-150.528 12.288-12.288 24.064-24.064 24.064-41.984s-6.144-30.208-24.064-41.984c-17.92-12.288-234.496-144.384-246.784-150.528z m-11.776 318.976V453.12c48.128 30.208 162.816 102.4 210.944 126.464-42.496 24.064-162.816 96.768-210.944 126.464z" fill="#FF63BC" ></path><path d="M801.28 128h-96.256l72.192-72.192c12.288-12.288 12.288-30.208 0-41.984s-30.208-12.288-41.984 0L620.544 128H403.456L294.912 13.312c-12.288-12.288-30.208-12.288-41.984 0s-12.288 30.208 0 41.984l66.56 72.704H222.72C102.4 128 0 230.4 0 356.864v433.664c0 126.464 102.4 228.864 222.72 228.864h578.048c120.32 0 222.72-102.4 222.72-228.864V363.008C1024 236.544 927.744 128 801.28 128z m162.304 668.672c0 96.256-72.192 168.448-162.816 168.448H222.72c-90.112 0-162.816-78.336-162.816-168.448V363.008c0-96.256 72.192-174.592 162.816-174.592h578.048c90.112 0 162.816 78.336 162.816 168.448v439.808z" fill="#FF63BC" ></path></symbol><symbol id="icon-weibotuiguangfuwu" viewBox="0 0 1025 1024"><path d="M738.420429 485.376c21.504-40.448 36.864-96.256-1.024-134.144-19.968-19.968-48.128-30.208-84.48-30.208-57.856 0-119.808 26.624-130.56 31.232-0.512 0-1.024 0.512-2.048 0.512 0-0.512 0.512-2.048 0.512-2.56 1.024-5.632 2.56-11.264 3.584-17.408l0.512-4.096c0-29.696-6.144-53.76-17.408-72.704-12.288-20.48-37.376-44.544-87.04-44.544-23.04 0-50.176 5.632-79.872 15.872C198.772429 274.944 81.012429 438.784 75.892429 445.44-10.123571 560.64 0.116429 651.264 0.628429 654.848c17.408 157.696 153.088 250.88 391.68 269.824 13.312 1.024 27.136 2.048 40.96 2.048 163.328 0 361.984-72.192 427.008-210.944 19.456-40.448 20.48-79.36 4.608-116.736-25.088-59.904-89.088-96.768-126.464-113.664z m77.824 209.408c-55.808 118.784-239.104 182.784-382.976 182.784-12.8 0-24.576-0.512-36.864-1.024-148.48-11.264-329.216-60.416-347.136-226.816 0-0.512-7.68-76.8 66.048-175.104 1.024-2.048 114.176-157.696 240.64-201.216 25.088-8.192 47.104-12.8 64.512-12.8 25.088 0 54.784 7.68 55.296 66.048-1.024 4.608-2.048 9.728-3.072 13.824-4.096 19.456-8.192 37.376 3.584 51.712 7.168 9.216 22.528 18.432 61.44 6.656l3.072-1.024c0.512 0 60.416-27.648 112.128-27.648 23.04 0 38.912 5.632 50.176 15.872 24.064 24.064-7.168 79.36-20.48 96.768-9.728 13.312-3.584 32.256 12.288 37.376 27.648 9.216 103.424 45.056 126.464 98.304 9.728 23.04 8.192 48.64-5.12 76.288zM990.836429 232.448c-36.352-61.952-102.912-110.08-179.2-127.488-40.448-9.728-88.064-9.216-141.312 1.024 0 0-17.92 12.8-13.312 30.208 4.608 17.92 23.04 17.408 23.04 17.408 46.592-9.216 86.528-9.216 120.32-1.024 24.064 5.632 104.96 29.696 148.48 104.96 30.72 52.736 34.816 117.76 12.8 193.024-1.024 3.072-2.048 6.144-2.048 9.728 0 13.312 10.752 24.064 24.576 24.064h17.92l5.632-17.408c26.624-90.624 21.504-169.472-16.896-234.496z" fill="#FF415B" ></path><path d="M702.068429 241.152c-13.312 2.56-22.528 14.848-19.456 28.16 2.56 13.312 14.848 22.528 28.16 19.456 0.512 0 58.88-9.728 92.16 20.992 20.992 19.456 28.672 52.224 24.064 98.816-1.024 13.312 8.192 25.088 21.504 27.136h3.072c12.288 0 23.04-9.216 24.064-21.504 6.656-61.952-6.144-109.056-38.912-139.776-52.224-48.128-131.072-33.792-134.656-33.28zM377.460429 567.296c-7.68 0-15.872 1.024-23.552 3.072-29.696 6.656-54.784 24.064-69.632 47.616-12.288 19.456-16.384 41.984-11.264 62.976 9.216 40.448 47.616 68.096 94.72 68.096h3.072c7.68 0 15.872-1.024 23.552-3.072 26.624-6.144 49.152-20.48 64.512-40.448 16.384-20.992 22.528-46.592 16.896-70.656-10.24-41.472-50.688-69.12-98.304-67.584z m46.592 111.616c-9.216 12.288-23.552 20.992-40.448 24.576-4.608 1.024-10.24 2.048-14.848 2.048-27.648 0.512-50.176-13.312-54.784-34.304-2.56-10.24 0-20.992 6.144-30.72 9.216-13.824 24.576-24.576 42.496-28.672 4.608-1.024 10.24-2.048 14.848-2.048 27.648-0.512 50.176 13.312 54.784 34.304 3.072 11.264 0 24.064-8.192 34.816z" fill="#FF415B" ></path><path d="M554.612429 526.848c-37.376-21.504-86.016-33.28-137.216-31.744-10.752 0-21.504 1.024-32.256 2.56-57.344 6.656-110.08 28.672-147.968 60.416-40.448 34.304-59.392 76.288-54.272 119.296 4.608 38.4 29.696 72.704 69.632 96.256 35.328 20.48 81.408 31.744 130.048 31.744h7.68c10.752 0 21.504-1.024 32.256-2.56 57.344-7.168 109.568-28.672 147.456-60.928 40.448-34.304 59.392-76.288 54.272-119.296-4.608-37.888-29.184-72.192-69.632-95.744z m-12.8 183.296c-31.232 26.624-75.776 44.544-124.416 50.688-9.728 1.024-18.432 2.048-28.16 2.048-43.52 1.024-84.48-8.192-115.2-26.112-28.16-16.896-45.568-39.936-48.64-64.512-3.584-28.16 10.752-57.344 40.448-82.432 31.232-26.624 75.776-44.544 124.416-50.688 9.728-1.024 18.432-2.048 28.16-2.048 43.52-1.024 84.48 8.192 115.2 26.112 28.16 16.896 45.568 39.936 48.64 64.512 3.584 28.672-10.752 57.856-40.448 82.432z" fill="#FF415B" ></path></symbol><symbol id="icon-xinxiliuguanggaotuiguangfuwu" viewBox="0 0 1024 1024"><path d="M202.394803 256.895552h235.402298c9.211394 0 16.887556-7.676162 16.887557-16.887556v-5.117441c0-9.211394-7.676162-16.887556-16.887557-16.887556h-235.402298c-9.211394 0-16.887556 7.676162-16.887557 16.887556v5.117441c0 9.723138 7.676162 16.887556 16.887557 16.887556z m450.846576 220.561719H202.394803c-9.211394 0-16.887556 7.676162-16.887557 16.887557v5.117441c0 9.211394 7.676162 16.887556 16.887557 16.887556h450.846576c9.211394 0 16.887556-7.676162 16.887557-16.887556v-5.117441c0-9.211394-7.676162-16.887556-16.887557-16.887557z m0 154.034983H202.394803c-9.211394 0-16.887556 7.676162-16.887557 16.887556v5.117441c0 9.211394 7.676162 16.887556 16.887557 16.887557h450.846576c9.211394 0 16.887556-7.676162 16.887557-16.887557v-5.117441c0-9.211394-7.676162-16.887556-16.887557-16.887556z m0 144.823588H202.394803c-9.211394 0-16.887556 7.676162-16.887557 16.887556v5.117442c0 9.211394 7.676162 16.887556 16.887557 16.887556h450.846576c9.211394 0 16.887556-7.676162 16.887557-16.887556v-5.117442c0-9.723138-7.676162-16.887556-16.887557-16.887556z" fill="#49C5F6" ></path><path d="M913.207396 215.444278H854.868566V98.254873C854.868566 44.009995 810.858571 0 756.613693 0H110.28086C56.547726 0 12.537731 44.009995 12.537731 98.254873v827.490254c0 54.244878 44.009995 98.254873 98.254873 98.254873h802.926536c47.08046 0 86.996502-33.775112 96.207896-78.296852h2.046977V313.69915c-0.511744-54.244878-44.521739-98.254873-98.766617-98.254872z m58.850575 469.781109v240.007996c0 32.23988-26.098951 58.338831-58.338831 58.338831h-803.43828c-32.23988 0-58.338831-26.098951-58.338831-58.338831V98.254873c0-32.23988 26.098951-58.338831 58.338831-58.338831h646.332833c32.23988 0 58.338831 26.098951 58.338831 58.338831v721.55922h39.404298V254.848576h58.850574c32.23988 0 58.338831 26.098951 58.338831 58.33883v372.037981h0.511744z" fill="#49C5F6" ></path></symbol><symbol id="icon-weixintuiguangfuwu" viewBox="0 0 1024 1024"><path d="M904.192 932.864c-4.096 0-8.192-1.024-11.776-3.072l-86.528-47.104c-31.744 8.192-65.536 15.36-99.84 15.36-65.024 0-126.464-16.896-180.224-48.64-52.736-31.232-92.672-75.264-116.224-126.464-1.536 1.024-4.096 1.024-6.144 1.536-11.264 1.024-23.04 1.536-34.304 1.536-38.4 0-69.632-6.144-105.472-13.824l-11.776-2.56-112.64 56.832c-3.072 1.536-7.168 2.56-11.264 2.56-5.632 0-11.776-2.56-15.872-6.144-7.168-6.656-10.24-16.896-7.168-26.624l28.672-86.528C47.104 584.704 1.024 500.736 1.024 408.576c0-175.104 165.376-317.44 368.64-317.44 179.2 0 338.432 112.128 371.2 260.096 74.24 7.168 143.872 38.4 196.608 87.04 55.296 51.2 85.504 117.76 85.504 185.856 0 72.704-41.472 146.432-116.736 207.36l20.992 69.632c3.072 9.728 0 19.968-8.192 26.624-4.096 3.584-9.216 5.12-14.848 5.12z m-94.72-100.864c4.096 0 8.192 1.024 11.776 3.072l41.472 22.528-8.704-28.16c-3.072-9.728 1.024-20.992 8.704-26.624 71.168-53.76 110.592-116.736 110.592-178.176 0-121.856-122.368-224.768-267.776-224.768-147.968 0-267.776 100.864-267.776 224.768s119.808 224.768 267.776 224.768c31.744 0 65.024-8.704 96.768-16.896 2.56-0.512 5.12-0.512 7.168-0.512z m-439.808-691.2c-176.128 0-320 119.808-320 267.776 0 81.408 43.008 153.6 126.976 211.968 8.704 6.144 12.8 17.408 9.728 28.16l-15.872 47.104 67.072-33.792c3.072-1.536 7.168-2.56 11.264-2.56 1.536 0 3.072 0 4.608 1.024l19.968 4.096c33.792 7.168 62.464 12.8 95.744 12.8 8.192 0 15.872 0 24.064-1.024-4.096-17.408-6.144-35.328-6.144-52.224 0-72.704 32.768-141.824 92.16-193.024 55.808-48.64 130.56-77.824 209.408-80.896-32.768-121.344-166.912-209.408-318.976-209.408z m430.08 449.024c-22.528 0-43.008-20.992-43.008-43.008s21.504-44.032 43.008-44.032c31.744 0 52.224 22.528 52.224 44.032 1.024 20.48-18.944 43.008-52.224 43.008z m-188.416 0c-22.528 0-43.008-20.992-43.008-43.008s21.504-44.032 43.008-44.032c31.744 0 52.224 22.528 52.224 44.032-0.512 20.48-20.48 43.008-52.224 43.008zM499.2 357.376c-29.696 0-60.928-19.968-60.928-52.224 0-15.36 7.168-28.672 19.968-38.4 11.264-8.704 26.624-13.824 40.96-13.824 31.232 0 52.224 20.992 52.224 52.224 0 30.72-22.016 52.224-52.224 52.224z m-240.64 0c-29.696 0-60.928-19.968-60.928-52.224s31.744-52.224 60.928-52.224c31.232 0 52.224 20.992 52.224 52.224-0.512 30.72-22.016 52.224-52.224 52.224z" fill="#40C85A" ></path></symbol><symbol id="icon-ruanwenyingxiaotuiguangfuwu" viewBox="0 0 1024 1024"><path d="M480.256 1006.592c-4.608 0-9.728-2.048-13.824-5.12-6.656-5.12-10.24-13.312-8.704-22.016l39.424-244.736c0.512-4.096 3.072-8.704 6.656-12.288l1.024-1.024 0.512-1.024 0.512-0.512c0.512-0.512 1.024-1.536 1.536-2.56l267.776-352.768c16.384-22.016 41.472-34.816 69.12-34.816 18.944 0 36.864 6.144 52.736 17.92l92.672 70.144c18.432 14.336 30.72 34.816 33.792 57.856 3.072 23.04-3.072 45.568-17.408 65.536l-269.312 354.304c-0.512 0.512-1.024 1.024-1.536 2.048l-0.512 0.512-0.512 1.024c-2.56 4.096-6.144 7.168-10.752 9.216l-232.448 96.256h-0.512c-4.096 1.024-7.168 2.048-10.24 2.048z m62.976-260.096l-6.656 36.352-26.112 162.304 136.704-57.344 52.736-19.968 9.216-14.336 207.872-272.896L759.296 460.8l-216.064 285.696z m301.056-370.688c-13.312 0-25.088 5.632-32.768 16.384l-24.576 32.256 157.696 119.808 24.576-32.256c6.656-8.704 9.728-19.968 8.192-30.72-1.536-10.24-7.168-19.968-15.872-26.624l-92.672-70.144c-6.144-5.632-14.848-8.704-24.576-8.704z m-650.24 290.816c-10.752 0-19.968-11.776-19.968-25.6s9.216-25.6 19.968-25.6h207.36c10.752 0 18.944 11.776 18.944 25.6s-9.216 25.6-19.968 25.6H194.048z m2.048-201.728c-11.264 0-20.992-11.776-20.992-25.6s9.728-25.6 20.992-25.6h352.768c11.264 0 20.992 11.776 20.992 25.6s-9.728 25.6-20.992 25.6H196.096z m1.024-201.216c-12.288 0-22.528-11.776-22.528-25.6 0-14.336 10.24-25.6 22.528-25.6h471.04c12.288 0 22.528 11.776 22.528 25.6 0 7.168-2.56 13.824-6.656 18.432-4.096 4.608-9.216 7.168-14.848 7.168H197.12z" fill="#409FF6" ></path><path d="M100.864 998.912C45.056 998.912 0 953.344 0 897.536V118.272c0-26.624 10.752-52.224 30.208-71.68 18.432-18.944 43.52-29.184 71.168-29.184h772.096c27.136 0 52.736 10.24 71.68 29.184 19.456 19.456 30.208 44.544 30.208 71.68v125.952l-0.512 11.776c0 13.312-10.752 24.064-24.064 24.064S926.72 269.312 926.72 256v-11.776h-0.512V118.272c0-29.184-24.064-53.248-53.248-53.248H102.4c-14.336 0-27.648 5.12-37.888 15.36-10.24 9.728-15.872 23.04-15.872 37.888v779.264c0 29.184 24.064 53.248 53.248 53.248h268.8c12.8 0.512 22.528 10.752 22.528 24.576 0 12.288-10.24 23.04-23.04 23.552H100.864z" fill="#409FF6" ></path></symbol><symbol id="icon-duanshipintuiguangfuwu" viewBox="0 0 1024 1024"><path d="M512 385.024c64.512 0 116.736-52.224 116.736-116.736S576.512 151.04 512 151.04 395.264 203.776 395.264 267.776 447.488 385.024 512 385.024z m-3.072-189.952c39.936 0 72.704 32.768 72.704 72.704s-32.768 72.704-72.704 72.704-72.704-32.768-72.704-72.704 32.256-72.704 72.704-72.704z m119.808 562.176c0-64.512-52.224-116.736-116.736-116.736s-116.736 52.224-116.736 116.736c0 64.512 52.224 116.736 116.736 116.736 64.512 0 116.736-52.736 116.736-116.736z m-192.512-3.072c0-39.936 32.768-72.704 72.704-72.704s72.704 32.768 72.704 72.704-32.768 72.704-72.704 72.704-72.704-32.768-72.704-72.704z m320-127.488c64.512 0 116.736-52.224 116.736-116.736s-52.224-116.736-116.736-116.736-117.248 52.224-117.248 116.736 52.736 116.736 117.248 116.736z m-3.584-192.512c39.936 0 72.704 32.768 72.704 72.704 0 39.936-32.768 72.704-72.704 72.704-39.936 0-72.704-32.768-72.704-72.704 0-39.936 32.768-72.704 72.704-72.704z m-485.888-35.84c-64.512 0-116.736 52.224-116.736 116.736s52.224 116.736 116.736 116.736S384 579.584 384 515.072 331.264 398.336 266.752 398.336z m-3.072 185.856c-39.936 0-72.704-32.768-72.704-72.704 0-39.936 32.768-72.704 72.704-72.704s72.704 32.768 72.704 72.704c0 40.448-32.256 72.704-72.704 72.704z m722.944 384.512h-242.176c48.128-24.576 91.648-55.808 130.048-94.208 47.104-47.104 83.968-101.888 109.568-162.816 26.624-62.976 40.448-130.048 40.448-199.168s-13.312-136.192-40.448-199.168c-25.6-60.928-62.464-115.712-109.568-162.816S772.608 66.56 711.68 40.96c-63.488-27.648-130.56-40.96-199.68-40.96S375.808 13.312 312.832 40.448c-60.928 25.6-115.712 62.464-162.816 109.568S66.048 251.904 40.448 312.832C13.312 375.808 0 442.88 0 512s13.312 136.192 40.448 199.168c25.6 60.928 62.464 115.712 109.568 162.816s101.888 83.968 162.816 109.568c62.976 26.624 130.048 40.448 199.168 40.448h474.624c15.36 0 27.648-12.288 27.648-27.648 0-15.36-12.288-27.648-27.648-27.648zM179.2 844.8c-43.008-43.008-77.312-93.696-100.864-149.504C53.248 637.44 40.96 575.488 40.96 512s12.288-125.44 36.864-183.296C101.888 272.384 135.68 222.208 179.2 179.2c43.008-43.008 93.696-77.312 149.504-100.864C386.56 53.248 448.512 40.96 512 40.96s125.44 12.288 183.296 36.864c56.32 23.552 106.496 57.856 149.504 100.864 43.008 43.008 77.312 93.696 100.864 149.504 24.576 57.856 36.864 119.808 36.864 183.296s-12.288 125.44-36.864 183.296c-23.552 56.32-57.856 106.496-100.864 149.504-43.008 43.008-93.696 77.312-149.504 100.864-57.856 24.576-119.808 36.864-183.296 36.864-63.488 0-125.44-12.288-183.296-36.864-56.32-23.04-106.496-56.832-149.504-100.352z" fill="#9676FF" ></path></symbol><symbol id="icon-erweima" viewBox="0 0 1024 1024"><path d="M363.008 611.328H114.688c-27.136 0-49.664 22.016-49.664 49.664v248.32c0 27.648 22.016 49.664 49.664 49.664h248.32c27.136 0 49.664-22.016 49.664-49.664v-248.32c0-27.648-22.016-49.664-49.664-49.664z m0 272.896c0 13.824-11.264 24.576-24.576 24.576H139.776c-13.824 0-24.576-11.264-24.576-24.576v-198.656c0-13.824 11.264-24.576 24.576-24.576h198.656c13.824 0 24.576 11.264 24.576 24.576v198.656z m161.28-272.896h-24.576c-6.656 0-12.288 5.632-12.288 12.288v223.232c0 6.656 5.632 12.288 12.288 12.288h24.576c6.656 0 12.288-5.632 12.288-12.288v-223.232c0-6.656-5.12-12.288-12.288-12.288z m-24.576-198.656h24.576c6.656 0 12.288-5.632 12.288-12.288v-322.56c0-6.656-5.632-12.288-12.288-12.288h-24.576c-6.656 0-12.288 5.632-12.288 12.288v322.56c-0.512 6.656 5.12 12.288 12.288 12.288z m-385.024 0h248.32c27.136 0 49.664-22.016 49.664-49.664V114.688c0-27.136-22.016-49.664-49.664-49.664H114.688c-27.136 0-49.664 22.016-49.664 49.664v248.32c0.512 27.648 22.528 49.664 49.664 49.664z m0-272.896c0-13.824 11.264-25.088 24.576-25.088H337.92c13.824 0 24.576 11.264 24.576 25.088v198.656c0 13.824-11.264 25.088-24.576 25.088H139.776c-13.824 0-24.576-11.264-24.576-25.088l-0.512-198.656z m558.592 545.792h-25.088c-6.656 0-12.288 5.632-12.288 12.288v248.32c0 6.656 5.632 12.288 12.288 12.288h25.088c6.656 0 12.288-5.632 12.288-12.288v-248.32c0-6.656-5.632-12.288-12.288-12.288z m272.896-198.656H77.824c-6.656 0-12.288 5.632-12.288 12.288v24.576c0 6.656 5.632 12.288 12.288 12.288h868.352c6.656 0 12.288-5.632 12.288-12.288v-24.576c0-6.656-5.12-12.288-12.288-12.288z m-37.376-421.376H660.48c-27.136 0-49.664 22.016-49.664 49.664V363.52c0 27.136 22.016 49.664 49.664 49.664h248.32c27.648 0 49.664-22.016 49.664-49.664V114.688c0-27.136-22.016-49.152-49.664-49.152z m0 272.896c0 13.824-11.264 25.088-24.576 25.088h-198.656c-13.824 0-24.576-11.264-24.576-25.088V139.776c0-13.824 11.264-25.088 24.576-25.088h198.656c13.824 0 24.576 11.264 24.576 25.088v198.656z m-111.616 347.136h-24.576c-6.656 0-12.288 5.632-12.288 12.288v248.32c0 6.656 5.632 12.288 12.288 12.288h24.576c6.656 0 12.288-5.632 12.288-12.288v-248.32c0.512-6.656-5.12-12.288-12.288-12.288z m124.416-74.24h-24.576c-6.656 0-12.288 5.632-12.288 12.288v322.56c0 6.656 5.632 12.288 12.288 12.288h24.576c6.656 0 12.288-5.632 12.288-12.288v-322.56c0-6.656-5.632-12.288-12.288-12.288z" fill="" ></path></symbol><symbol id="icon-erweima1" viewBox="0 0 1024 1024"><path d="M62.996776 484.061694l423.162696 0L486.159472 60.900022 62.996776 60.900022 62.996776 484.061694zM168.788218 166.69044l211.580836 0 0 211.580836L168.788218 378.271276 168.788218 166.69044zM539.055193 60.900022l0 423.162696 423.162696 0L962.217888 60.900022 539.055193 60.900022zM856.426447 378.271276 644.845611 378.271276 644.845611 166.69044l211.580836 0L856.426447 378.271276zM221.682915 325.376579l105.790418 0L327.473333 219.585137 221.682915 219.585137 221.682915 325.376579zM62.996776 960.120111l423.162696 0L486.159472 536.957415 62.996776 536.957415 62.996776 960.120111zM168.788218 642.747833l211.580836 0 0 211.580836L168.788218 854.328669 168.788218 642.747833zM803.531749 219.585137 697.740308 219.585137l0 105.790418 105.790418 0L803.530726 219.585137zM539.055193 960.120111l105.790418 0L644.845611 854.329692 539.055193 854.329692 539.055193 960.120111zM644.845611 642.747833l0 211.580836 105.790418 0L750.636029 642.747833 644.845611 642.747833zM856.426447 854.329692 750.636029 854.329692 750.636029 960.120111l211.580836 0L962.216865 748.538251 856.426447 748.538251 856.426447 854.329692zM856.426447 642.747833l105.790418 0L962.216865 536.957415 856.426447 536.957415 856.426447 642.747833zM539.055193 536.957415l0 105.790418 105.790418 0L644.845611 536.957415 539.055193 536.957415zM221.682915 801.433972l105.790418 0L327.473333 695.643554 221.682915 695.643554 221.682915 801.433972z" fill="#929292" ></path></symbol><symbol id="icon-chuangyi" viewBox="0 0 1024 1024"><path d="M440.32 1017.856c-77.824 0-143.36-63.488-143.36-141.312v-53.248c-2.048-45.056-20.48-88.064-49.152-124.928-45.056-53.248-71.68-122.88-73.728-194.56 0-180.224 147.456-325.632 327.68-325.632h2.048c180.224 0 325.632 145.408 327.68 325.632-2.048 71.68-26.624 141.312-73.728 194.56-28.672 34.816-47.104 79.872-49.152 126.976v51.2c0 77.824-63.488 143.36-143.36 143.36h-124.928v-2.048z m0-40.96h122.88c55.296 0 102.4-45.056 102.4-102.4v-53.248c4.096-57.344 24.576-108.544 59.392-151.552 40.96-47.104 63.488-106.496 63.488-167.936 0-155.648-129.024-284.672-286.72-284.672s-284.672 126.976-286.72 284.672c2.048 61.44 24.576 120.832 63.488 167.936 34.816 43.008 55.296 94.208 59.392 149.504v55.296c0 55.296 45.056 102.4 102.4 102.4z" fill="#FF622B" ></path><path d="M614.4 462.848c-4.096-14.336-20.48-22.528-36.864-18.432l-12.288 6.144-65.536 65.536-65.536-65.536c-6.144-6.144-16.384-10.24-26.624-8.192-10.24 2.048-18.432 10.24-20.48 18.432l-28.672 86.016c-4.096 14.336 4.096 30.72 18.432 36.864 14.336 4.096 30.72-4.096 36.864-18.432l14.336-43.008 53.248 53.248c10.24 10.24 28.672 12.288 40.96 0l53.248-53.248 14.336 43.008c4.096 14.336 18.432 24.576 34.816 20.48s24.576-18.432 20.48-34.816c0-2.048 0-2.048-2.048-4.096L614.4 462.848z" fill="#FFD8C5" ></path><path d="M202.752 239.616l-34.816-32.768c-12.288-12.288-32.768-12.288-45.056 2.048l-2.048 2.048c-12.288 12.288-10.24 34.816 2.048 49.152l34.816 32.768c14.336 12.288 34.816 12.288 47.104-2.048l2.048-2.048c12.288-14.336 10.24-36.864-4.096-49.152zM821.248 239.616l34.816-32.768c12.288-12.288 34.816-12.288 47.104 2.048l2.048 2.048c12.288 14.336 12.288 36.864-2.048 49.152l-34.816 32.768c-14.336 12.288-34.816 12.288-47.104-2.048l-2.048-2.048c-14.336-14.336-12.288-36.864 2.048-49.152zM546.816 106.496l-2.048-47.104c0-18.432-16.384-32.768-34.816-32.768h-2.048c-18.432 2.048-34.816 18.432-32.768 36.864l2.048 47.104c2.048 18.432 16.384 32.768 34.816 32.768h2.048c18.432-2.048 34.816-18.432 32.768-36.864zM557.056 833.536h-108.544c-12.288-4.096-22.528 4.096-26.624 14.336s4.096 22.528 14.336 26.624c4.096 2.048 8.192 2.048 12.288 0h108.544c12.288 4.096 22.528-4.096 26.624-14.336s-4.096-22.528-14.336-26.624c-4.096-2.048-8.192-2.048-12.288 0z" fill="#FF622B" ></path></symbol><symbol id="icon-jingyan" viewBox="0 0 1024 1024"><path d="M163.84 860.16c-34.816 0-61.44-28.672-61.44-61.44V225.28c0-34.816 26.624-61.44 61.44-61.44h409.6c34.816 0 61.44 26.624 61.44 61.44v573.44c0 32.768-26.624 61.44-61.44 61.44H163.84z m0-655.36c-12.288 0-20.48 10.24-20.48 20.48v573.44c0 10.24 10.24 20.48 20.48 20.48h409.6c10.24 0 20.48-10.24 20.48-20.48V225.28c0-10.24-10.24-20.48-20.48-20.48H163.84z" fill="#FF622B" ></path><path d="M245.76 327.68h245.76c12.288 0 20.48 8.192 20.48 20.48s-8.192 20.48-20.48 20.48H245.76c-12.288 0-20.48-8.192-20.48-20.48s8.192-20.48 20.48-20.48zM245.76 491.52h245.76c12.288 0 20.48 8.192 20.48 20.48s-8.192 20.48-20.48 20.48H245.76c-12.288 0-20.48-8.192-20.48-20.48s8.192-20.48 20.48-20.48zM245.76 655.36h245.76c12.288 0 20.48 8.192 20.48 20.48s-8.192 20.48-20.48 20.48H245.76c-12.288 0-20.48-8.192-20.48-20.48s8.192-20.48 20.48-20.48z" fill="#FF622B" ></path><path d="M778.24 204.8h61.44c22.528 0 40.96 18.432 40.96 40.96v471.04c0 34.816-63.488 122.88-63.488 122.88S737.28 751.616 737.28 716.8V245.76c0-22.528 18.432-40.96 40.96-40.96z" fill="#FFD8C5" ></path><path d="M817.152 860.16c-6.144 0-10.24-2.048-14.336-6.144-20.48-22.528-86.016-96.256-86.016-137.216V245.76c0-34.816 26.624-61.44 61.44-61.44h61.44c34.816 0 61.44 26.624 61.44 61.44v471.04c0 38.912-55.296 118.784-67.584 135.168-2.048 4.096-8.192 8.192-16.384 8.192 2.048 0 0 0 0 0zM778.24 225.28c-12.288 0-20.48 10.24-20.48 20.48v471.04c0 14.336 26.624 53.248 57.344 90.112C839.68 770.048 860.16 731.136 860.16 716.8V245.76c0-10.24-10.24-20.48-20.48-20.48h-61.44z" fill="#FF622B" ></path><path d="M737.28 286.72h143.36c12.288 0 20.48 8.192 20.48 20.48s-8.192 20.48-20.48 20.48h-143.36c-12.288 0-20.48-8.192-20.48-20.48s8.192-20.48 20.48-20.48z" fill="#FF622B" ></path></symbol><symbol id="icon-jishu" viewBox="0 0 1024 1024"><path d="M497.664 778.24c-6.144 0-10.24-2.048-14.336-6.144l-245.76-245.76c-8.192-8.192-8.192-20.48 0-28.672s20.48-8.192 28.672 0l227.328 227.328 292.864-468.992c6.144-10.24 18.432-12.288 28.672-6.144 10.24 6.144 12.288 18.432 6.144 28.672l-307.2 491.52c-2.048 4.096-8.192 8.192-14.336 8.192h-2.048z" fill="#FF622B" ></path><path d="M518.144 778.24m-124.928 0a124.928 124.928 0 1 0 249.856 0 124.928 124.928 0 1 0-249.856 0Z" fill="#FFD8C5" ></path><path d="M518.144 923.648c-79.872 0-145.408-65.536-145.408-145.408s65.536-145.408 145.408-145.408c79.872 0 145.408 65.536 145.408 145.408s-65.536 145.408-145.408 145.408z m0-249.856c-57.344 0-104.448 47.104-104.448 104.448s47.104 104.448 104.448 104.448 104.448-47.104 104.448-104.448-47.104-104.448-104.448-104.448z" fill="#FF622B" ></path><path d="M804.864 245.76m-124.928 0a124.928 124.928 0 1 0 249.856 0 124.928 124.928 0 1 0-249.856 0Z" fill="#FFD8C5" ></path><path d="M804.864 391.168c-79.872 0-145.408-65.536-145.408-145.408s65.536-145.408 145.408-145.408 145.408 65.536 145.408 145.408-65.536 145.408-145.408 145.408z m0-249.856c-57.344 0-104.448 47.104-104.448 104.448s47.104 104.448 104.448 104.448 104.448-47.104 104.448-104.448-47.104-104.448-104.448-104.448z" fill="#FF622B" ></path><path d="M190.464 409.6m-96.256 0a96.256 96.256 0 1 0 192.512 0 96.256 96.256 0 1 0-192.512 0Z" fill="#FFD8C5" ></path><path d="M190.464 526.336c-63.488 0-116.736-51.2-116.736-116.736s51.2-116.736 116.736-116.736S307.2 344.064 307.2 409.6s-53.248 116.736-116.736 116.736z m0-192.512c-40.96 0-75.776 32.768-75.776 75.776 0 40.96 32.768 75.776 75.776 75.776 40.96 0 75.776-32.768 75.776-75.776-2.048-40.96-34.816-75.776-75.776-75.776z" fill="#FF622B" ></path></symbol><symbol id="icon-ziyuan1" viewBox="0 0 1024 1024"><path d="M841.728 718.848H182.272c-34.816 0-61.44-26.624-61.44-61.44V204.8c0-34.816 26.624-61.44 61.44-61.44h659.456c34.816 0 61.44 26.624 61.44 61.44v454.656c0 32.768-28.672 59.392-61.44 59.392zM182.272 184.32c-12.288 0-20.48 8.192-20.48 20.48v454.656c0 12.288 8.192 20.48 20.48 20.48h659.456c12.288 0 20.48-8.192 20.48-20.48V204.8c0-12.288-8.192-20.48-20.48-20.48H182.272z" fill="#FF622B" ></path><path d="M366.592 292.864H655.36c22.528 0 40.96 18.432 40.96 40.96s-18.432 40.96-40.96 40.96H366.592c-22.528 0-40.96-18.432-40.96-40.96s18.432-40.96 40.96-40.96zM366.592 477.184H655.36c22.528 0 40.96 18.432 40.96 40.96s-18.432 40.96-40.96 40.96H366.592c-22.528 0-40.96-18.432-40.96-40.96s18.432-40.96 40.96-40.96z" fill="#FFD8C5" ></path><path d="M471.04 696.32h102.4v163.84h-102.4z" fill="#FF622B" ></path><path d="M368.64 839.68h307.2v40.96H368.64z" fill="#FF622B" ></path></symbol><symbol id="icon-shuju" viewBox="0 0 1024 1024"><path d="M778.24 331.776h61.44c12.288 0 20.48 8.192 20.48 20.48v532.48c0 12.288-8.192 20.48-20.48 20.48h-61.44c-12.288 0-20.48-8.192-20.48-20.48v-532.48c0-12.288 8.192-20.48 20.48-20.48z" fill="#FFD8C5" ></path><path d="M839.68 925.696h-61.44c-22.528 0-40.96-18.432-40.96-40.96v-532.48c0-22.528 18.432-40.96 40.96-40.96h61.44c22.528 0 40.96 18.432 40.96 40.96v532.48c0 22.528-18.432 40.96-40.96 40.96z m-61.44-573.44v532.48h61.44v-532.48h-61.44z" fill="#FF622B" ></path><path d="M532.48 489.472h61.44c12.288 0 20.48 8.192 20.48 20.48v380.928c0 12.288-8.192 20.48-20.48 20.48h-61.44c-12.288 0-20.48-8.192-20.48-20.48V509.952c0-12.288 8.192-20.48 20.48-20.48z" fill="#FFD8C5" ></path><path d="M593.92 931.84h-61.44c-22.528 0-40.96-18.432-40.96-40.96V509.952c0-22.528 18.432-40.96 40.96-40.96h61.44c22.528 0 40.96 18.432 40.96 40.96v380.928c0 22.528-18.432 40.96-40.96 40.96z m-61.44-421.888v380.928h61.44V509.952h-61.44z" fill="#FF622B" ></path><path d="M266.24 671.744h61.44c12.288 0 20.48 8.192 20.48 20.48v204.8c0 12.288-8.192 20.48-20.48 20.48h-61.44c-12.288 0-20.48-8.192-20.48-20.48v-204.8c0-10.24 8.192-20.48 20.48-20.48z" fill="#FFD8C5" ></path><path d="M327.68 937.984h-61.44c-22.528 0-40.96-18.432-40.96-40.96v-204.8c0-22.528 18.432-40.96 40.96-40.96h61.44c22.528 0 40.96 18.432 40.96 40.96v204.8c0 22.528-18.432 40.96-40.96 40.96z m-61.44-245.76v204.8h61.44v-204.8h-61.44z" fill="#FF622B" ></path><path d="M163.84 536.576c-6.144 0-10.24-2.048-14.336-6.144-8.192-8.192-8.192-20.48 0-28.672l286.72-286.72c2.048-2.048 4.096-4.096 8.192-4.096l327.68-122.88c10.24-4.096 22.528 2.048 26.624 12.288 4.096 10.24-2.048 22.528-12.288 26.624L462.848 245.76 178.176 530.432c-4.096 4.096-8.192 6.144-14.336 6.144z" fill="#FF622B" ></path></symbol><symbol id="icon-fuwu" viewBox="0 0 1024 1024"><path d="M509.952 901.12c-22.528 0-43.008-10.24-59.392-26.624L65.536 481.28c-32.768-34.816-32.768-86.016 0-120.832L274.432 149.504c16.384-16.384 36.864-24.576 61.44-26.624h354.304c22.528 0 45.056 10.24 61.44 26.624l208.896 212.992-18.432 14.336 16.384-16.384c32.768 32.768 32.768 86.016 0 120.832L573.44 874.496c-16.384 16.384-36.864 24.576-61.44 26.624h-2.048z m180.224-737.28H333.824c-12.288 0-22.528 4.096-30.72 14.336L94.208 389.12c-16.384 18.432-16.384 45.056 0 63.488l385.024 393.216c8.192 8.192 18.432 14.336 30.72 14.336s24.576-4.096 32.768-14.336l387.072-393.216c16.384-18.432 16.384-45.056 0-63.488L720.896 178.176c-8.192-10.24-20.48-14.336-30.72-14.336z" fill="#FF622B" ></path><path d="M645.12 397.312l-14.336 16.384c-57.344 67.584-157.696 75.776-225.28 18.432l-18.432-18.432-14.336-16.384c-8.192-10.24-22.528-12.288-32.768-4.096l-4.096 4.096c-10.24 12.288-10.24 30.72 0 43.008l16.384 16.384c75.776 88.064 208.896 100.352 296.96 24.576 8.192-8.192 16.384-14.336 24.576-24.576l16.384-16.384c10.24-12.288 10.24-30.72 0-43.008-12.288-10.24-30.72-12.288-45.056 0 2.048 0 2.048 0 0 0" fill="#FFD8C5" ></path></symbol><symbol id="icon-QQ" viewBox="0 0 1024 1024"><path d="M711.371115 632.745887v0z"  ></path><path d="M348.197441 599.04936v0zM692.650823 544.760512c-3.744059-11.232176-7.488117-22.464351-11.232176-31.824497-7.488117-22.464351-14.976234-41.184644-22.464351-56.160878v-35.568556c0-95.473492-69.265082-172.226691-153.506398-172.226691-84.241316 0-153.506399 76.753199-153.506399 172.226691v35.568556c-7.488117 14.976234-14.976234 33.696527-22.464351 56.160878v1.872029c-3.744059 9.360146-7.488117 20.592322-11.232175 31.824497-5.616088 18.720293-28.080439 95.473492-14.976234 102.961609 3.744059 1.872029 14.976234 0 46.800731-44.928702v-3.744059-1.872029 3.744059c0 35.568556 16.848263 67.393053 44.928702 91.729433-31.824497 11.232176-71.137112 37.440585-11.232176 41.184643 37.440585 1.872029 76.753199 1.872029 114.193785-1.872029h14.976234c37.440585 3.744059 74.88117 5.616088 114.193784 1.872029 59.904936-3.744059 20.592322-29.952468-11.232176-41.184643 28.080439-24.33638 44.928702-56.160878 44.928702-91.729433 31.824497 44.928702 43.056673 46.800731 46.800732 44.928702 3.744059-1.872029 3.744059-5.616088 3.744058-11.232176v-3.744058c0-26.20841-14.976234-73.009141-18.720292-87.985375z m-147.890311-235.875686c14.976234 0 28.080439 18.720293 28.080439 39.312615 0 22.464351-13.104205 39.312614-28.080439 39.312614s-28.080439-18.720293-28.080439-39.312614 13.104205-39.312614 28.080439-39.312615z m-80.497258 0c14.976234 0 28.080439 18.720293 28.080439 39.312615 0 22.464351-13.104205 39.312614-28.080439 39.312614s-28.080439-18.720293-28.080439-39.312614 13.104205-39.312614 28.080439-39.312615z m43.056673 89.857404c33.696527 0 91.729433 5.616088 91.729433 18.720293 1.872029 13.104205-46.800731 31.824497-91.729433 31.824497-46.800731 0-95.473492-18.720293-95.473492-31.824497 1.872029-13.104205 59.904936-18.720293 95.473492-18.720293z m86.113345 278.932359c-35.568556 39.312614-86.113346 37.440585-91.729433 37.440585-5.616088 0-52.416819-1.872029-86.113345-39.312615-29.952468-33.696527-29.952468-74.88117-29.952468-104.833638 0-14.976234 1.872029-29.952468 3.744058-43.056672 5.616088 1.872029 11.232176 1.872029 16.848263 3.744058V599.04936c0 1.872029 0 1.872029 1.87203 1.872029 22.464351 3.744059 44.928702 3.744059 67.393053 0 1.872029 0 1.872029-1.872029 1.872029-1.872029v-59.904936h29.952468c37.440585 0 76.753199-3.744059 114.193784-9.360146 1.872029 13.104205 3.744059 26.20841 3.744059 39.312614-1.872029 31.824497-1.872029 74.88117-31.824498 108.577697z"  ></path><path d="M542.888483 348.197441h7.488117c1.872029 0 5.616088 1.872029 7.488117 3.744058 1.872029 1.872029 3.744059 0 5.616087-1.872029 1.872029-1.872029 0-3.744059-1.872029-5.616088-3.744059-1.872029-5.616088-3.744059-9.360146-3.744058-7.488117-1.872029-14.976234 0-20.592322 3.744058-3.744059 1.872029-5.616088 3.744059-7.488117 7.488117v3.744059h3.744059c1.872029-1.872029 3.744059-3.744059 7.488117-5.616088 1.872029 0 5.616088 0 7.488117-1.872029zM479.239488 365.045704c3.744059-3.744059 5.616088-7.488117 5.616088-13.104205s-1.872029-11.232176-5.616088-13.104205c-3.744059-3.744059-7.488117-3.744059-13.104205 0-3.744059 3.744059-5.616088 7.488117-5.616087 13.104205s1.872029 11.232176 5.616087 13.104205c5.616088 3.744059 9.360146 3.744059 13.104205 0z"  ></path><path d="M505.447898 894.829982C284.548446 894.829982 104.833638 715.115174 104.833638 494.215722S282.676417 91.729433 505.447898 91.729433s400.61426 179.714808 400.614259 400.61426-179.714808 402.486289-400.614259 402.486289z m0-771.276051c-204.051188 0-368.789762 166.610603-368.789763 368.789762S303.268739 861.133455 505.447898 861.133455s368.789762-166.610603 368.789762-368.789762S709.499086 123.553931 505.447898 123.553931z"  ></path></symbol><symbol id="icon-cuo" viewBox="0 0 1024 1024"><path d="M794.8 794.8c-14 14-36.9 14-50.9 0L229.2 280.1c-14-14-14-36.9 0-50.9s36.9-14 50.9 0L794.9 744c13.9 13.9 13.9 36.8-0.1 50.8z"  ></path><path d="M794.8 229.2c14 14 14 36.9 0 50.9L280.1 794.8c-14 14-36.9 14-50.9 0s-14-36.9 0-50.9L744 229.1c13.9-13.9 36.8-13.9 50.8 0.1z"  ></path></symbol><symbol id="icon-dashujukeshihuaico-" viewBox="0 0 1024 1024"><path d="M611.413333 516.693333a231.253333 231.253333 0 1 0-199.253333 0 441.173333 441.173333 0 0 0-341.333333 429.653334h882.773333a441.173333 441.173333 0 0 0-342.186667-429.653334z"  ></path><path d="M611.413333 516.693333a231.253333 231.253333 0 1 0-199.253333 0 441.173333 441.173333 0 0 0-341.333333 429.653334h882.773333a441.173333 441.173333 0 0 0-342.186667-429.653334z"  ></path><path d="M611.413333 516.693333a231.253333 231.253333 0 1 0-199.253333 0 441.173333 441.173333 0 0 0-341.333333 429.653334h882.773333a441.173333 441.173333 0 0 0-342.186667-429.653334z"  ></path><path d="M953.6 946.346667a441.173333 441.173333 0 0 0-341.333333-429.653334 229.546667 229.546667 0 0 0 11.093333-409.173333 228.693333 228.693333 0 0 0-32-3.413333 230.4 230.4 0 0 0-99.413333 438.613333 440.32 440.32 0 0 0-341.333334 403.2z"  ></path><path d="M653.653333 334.933333a230.4 230.4 0 0 1-131.413333 207.786667 441.173333 441.173333 0 0 1 341.333333 403.2h90.453334a441.173333 441.173333 0 0 0-341.333334-429.653333 229.546667 229.546667 0 0 0 11.093334-409.173334 228.266667 228.266667 0 0 0-32-3.413333 229.973333 229.973333 0 0 0-85.333334 15.786667 230.826667 230.826667 0 0 1 147.2 215.466666z"  ></path><path d="M104.96 206.08A135.68 135.68 0 0 0 31.146667 131.84a9.813333 9.813333 0 0 1 0-18.346667A135.68 135.68 0 0 0 104.96 39.253333a9.813333 9.813333 0 0 1 18.346667 0 135.68 135.68 0 0 0 74.24 74.24 9.813333 9.813333 0 0 1 0 18.346667 135.68 135.68 0 0 0-74.24 74.24 9.813333 9.813333 0 0 1-18.346667 0z"  ></path><path d="M905.813333 416a69.546667 69.546667 0 0 0-37.973333-37.973333 5.12 5.12 0 0 1 0-9.386667 69.546667 69.546667 0 0 0 37.973333-37.973333 5.12 5.12 0 0 1 9.386667 0 69.546667 69.546667 0 0 0 37.973333 37.973333 5.12 5.12 0 0 1 0 9.386667 69.546667 69.546667 0 0 0-37.973333 37.973333 5.12 5.12 0 0 1-9.386667 0z"  ></path><path d="M42.666667 672a69.546667 69.546667 0 0 0-37.973334-37.973333 5.12 5.12 0 0 1 0-9.386667 69.546667 69.546667 0 0 0 37.973334-38.4 5.12 5.12 0 0 1 9.386666 0 69.546667 69.546667 0 0 0 37.973334 37.973333 5.12 5.12 0 0 1 0 9.386667 69.546667 69.546667 0 0 0-37.973334 37.973333 5.12 5.12 0 0 1-9.386666 0.426667z"  ></path></symbol><symbol id="icon-chuangyitoufang2" viewBox="0 0 1024 1024"><path d="M890.88 112.64c0-61.44-51.2-112.64-112.64-112.64h-614.4C107.52 0 56.32 51.2 56.32 112.64v778.24c0 61.44 51.2 112.64 112.64 112.64h250.88c15.36 0 25.6-10.24 25.6-30.72 0-15.36-10.24-30.72-25.6-30.72H168.96c-30.72 0-56.32-25.6-56.32-56.32V112.64c0-30.72 25.6-56.32 56.32-56.32h614.4c30.72 0 56.32 25.6 56.32 56.32v363.52c0 15.36 10.24 30.72 30.72 30.72 15.36 0 30.72-10.24 30.72-30.72l-10.24-363.52z"  ></path><path d="M599.04 1024h-51.2c-20.48 0-35.84-5.12-46.08-15.36-15.36-10.24-20.48-30.72-20.48-46.08v-46.08c0-25.6 10.24-51.2 30.72-71.68l281.6-281.6c10.24-10.24 30.72-20.48 46.08-20.48 20.48 0 35.84 5.12 46.08 20.48l61.44 61.44c25.6 25.6 25.6 71.68 0 92.16L665.6 993.28c-15.36 20.48-46.08 30.72-66.56 30.72z m-51.2-40.96h51.2c10.24 0 30.72-5.12 40.96-15.36l281.6-281.6c10.24-10.24 10.24-25.6 0-35.84l-61.44-61.44c-5.12-5.12-10.24-5.12-20.48-5.12-5.12 0-15.36 5.12-20.48 5.12L537.6 870.4c-10.24 10.24-15.36 25.6-15.36 40.96v46.08c0 5.12 5.12 15.36 5.12 20.48 5.12 0 15.36 5.12 20.48 5.12zM240.64 778.24h158.72c10.24 0 20.48 10.24 20.48 30.72 0 15.36-10.24 30.72-20.48 30.72H240.64c-10.24 0-20.48-10.24-20.48-30.72s10.24-30.72 20.48-30.72z m-15.36-138.24c0-15.36 10.24-30.72 20.48-30.72h286.72c10.24 0 20.48 10.24 20.48 30.72 0 15.36-10.24 30.72-20.48 30.72H245.76c-15.36 0-20.48-15.36-20.48-30.72z m138.24-117.76c-10.24 0-15.36-5.12-25.6-5.12-10.24-10.24-15.36-25.6-15.36-40.96l10.24-81.92-51.2-81.92c-10.24-15.36-15.36-30.72-5.12-40.96 5.12-10.24 15.36-20.48 30.72-25.6l76.8-10.24 46.08-71.68c10.24-10.24 20.48-20.48 35.84-20.48 15.36 0 25.6 5.12 35.84 20.48l46.08 71.68 81.92 10.24c15.36 0 25.6 10.24 30.72 20.48 5.12 15.36 0 30.72-5.12 40.96l-51.2 81.92 10.24 81.92c0 15.36-5.12 30.72-15.36 35.84-10.24 10.24-25.6 10.24-40.96 5.12l-92.16-25.6-92.16 30.72c0 5.12-5.12 5.12-10.24 5.12z m-46.08-230.4l61.44 92.16-15.36 97.28 102.4-35.84 102.4 35.84-10.24-97.28L614.4 291.84l-97.28-15.36-51.2-87.04L409.6 276.48l-92.16 15.36z"  ></path></symbol><symbol id="icon-shujufenxi" viewBox="0 0 1024 1024"><path d="M114.626866 331.144279c25.472637 0 50.945274-10.189055 66.228855-30.567165l132.457712 71.323384c0 30.567164 25.472637 61.134328 61.134328 61.134328 30.567164 0 61.134328-25.472637 61.134329-61.134328 0-10.189055 0-15.283582-5.094528-25.472637l157.930348-193.59204c15.283582 15.283582 35.661692 20.378109 56.039801 20.378109 30.567164 0 56.039801-15.283582 71.323384-40.756219l147.741293 96.79602V871.164179c0 15.283582 15.283582 30.567164 30.567164 30.567164s30.567164-15.283582 30.567164-30.567164V229.253731c0-15.283582-15.283582-30.567164-30.567164-30.567164-5.094527 0-15.283582 0-20.378109 5.094528-20.378109-15.283582-86.606965-56.039801-152.835821-96.79602v-20.37811c0-45.850746-35.661692-86.606965-86.606965-86.606965-45.850746 0-86.606965 35.661692-86.606965 86.606965 0 15.283582 5.094527 30.567164 15.283582 45.850746L410.109453 326.049751c-10.189055-5.094527-25.472637-15.283582-40.756219-15.283582-25.472637 0-45.850746 15.283582-56.039801 35.661692L191.044776 280.199005c5.094527-10.189055 5.094527-20.378109 5.094527-30.567164 0-45.850746-35.661692-81.512438-81.512437-81.512438-45.850746 0-81.512438 35.661692-81.512438 81.512438 0 45.850746 35.661692 81.512438 81.512438 81.512438z"  ></path><path d="M343.880597 499.263682V871.164179c0 15.283582 15.283582 30.567164 30.567164 30.567164s30.567164-15.283582 30.567164-30.567164V499.263682c0-15.283582-15.283582-30.567164-30.567164-30.567165s-30.567164 15.283582-30.567164 30.567165zM598.606965 387.18408V871.164179c0 15.283582 15.283582 30.567164 30.567164 30.567164s30.567164-15.283582 30.567165-30.567164V387.18408c0-15.283582-15.283582-30.567164-30.567165-30.567165s-30.567164 10.189055-30.567164 30.567165zM84.059701 596.059701V871.164179c0 15.283582 10.189055 30.567164 30.567165 30.567164 15.283582 0 30.567164-15.283582 30.567164-30.567164v-275.104478c0-15.283582-15.283582-30.567164-30.567164-30.567164s-30.567164 15.283582-30.567165 30.567164zM970.507463 962.865672H53.492537c-15.283582 0-30.567164 15.283582-30.567164 30.567164s10.189055 30.567164 30.567164 30.567164h917.014926c15.283582 0 30.567164-15.283582 30.567164-30.567164 0-20.378109-15.283582-30.567164-30.567164-30.567164z"  ></path></symbol><symbol id="icon-tuiguangfangan2" viewBox="0 0 1024 1024"><path d="M440.676617 759.084577H231.800995c-15.283582 0-25.472637 10.189055-25.472637 25.472637s10.189055 25.472637 25.472637 25.472637h208.875622c15.283582 0 25.472637-10.189055 25.472637-25.472637s-10.189055-25.472637-25.472637-25.472637z m275.104478-208.875622H231.800995c-15.283582 0-25.472637 10.189055-25.472637 25.472637s10.189055 25.472637 25.472637 25.472637h478.885572c15.283582 0 25.472637-10.189055 25.472637-25.472637s-5.094527-25.472637-20.378109-25.472637z m275.104477 137.552239c-5.094527 0-15.283582 5.094527-20.378109 10.189055l-254.726368 254.726368-112.079602-122.268657c-5.094527-5.094527-10.189055-10.189055-20.37811-10.189055-5.094527 0-15.283582 5.094527-15.283582 5.094528-10.189055 10.189055-10.189055 25.472637-5.094527 40.756219l127.363184 147.741293c5.094527 5.094527 10.189055 10.189055 20.378109 10.189055 5.094527 0 15.283582-5.094527 20.37811-10.189055l275.104477-275.104477c10.189055-10.189055 10.189055-25.472637 0-40.756219 0-5.094527-10.189055-10.189055-15.283582-10.189055zM715.781095 346.427861H231.800995c-15.283582 0-25.472637 10.189055-25.472637 25.472637s10.189055 25.472637 25.472637 25.472636h478.885572c15.283582 0 25.472637-10.189055 25.472637-25.472636s-5.094527-25.472637-20.378109-25.472637z"  ></path><path d="M165.572139 1018.905473H512c15.283582 0 25.472637-10.189055 25.472637-25.472637s-10.189055-25.472637-25.472637-25.472637H165.572139c-25.472637 0-40.756219-20.378109-40.756219-40.756219V168.119403c0-25.472637 20.378109-40.756219 40.756219-40.756219H206.328358v5.094527c15.283582 40.756219 50.945274 66.228856 91.701493 66.228856h346.42786c40.756219 0 76.41791-25.472637 91.701493-66.228856v-5.094527h45.850746c25.472637 0 40.756219 20.378109 40.756219 40.756219v478.885572c0 15.283582 10.189055 25.472637 25.472637 25.472637s25.472637-10.189055 25.472637-25.472637V168.119403c0-50.945274-40.756219-96.79602-96.79602-96.79602h-45.850746v-5.094527C715.781095 25.472637 680.119403 0 639.363184 0H303.124378c-40.756219 0-76.41791 25.472637-91.701492 66.228856v5.094527h-45.850747c-50.945274 0-96.79602 40.756219-96.79602 96.79602v759.084577c0 45.850746 40.756219 91.701493 96.79602 91.701493zM303.124378 56.039801h346.427861c25.472637 0 40.756219 20.378109 40.756219 40.756219 0 25.472637-20.378109 40.756219-40.756219 40.756219H303.124378c-25.472637 0-40.756219-20.378109-40.756219-40.756219-5.094527-20.378109 15.283582-40.756219 40.756219-40.756219z"  ></path></symbol><symbol id="icon-shishiyouhua" viewBox="0 0 1024 1024"><path d="M76.8 824.32h358.4V921.6H307.2c-15.36 0-25.6 10.24-25.6 25.6s10.24 25.6 25.6 25.6h409.6c15.36 0 25.6-10.24 25.6-25.6s-10.24-25.6-25.6-25.6h-128v-97.28h358.4c40.96 0 76.8-25.6 76.8-66.56V128c0-40.96-35.84-76.8-76.8-76.8h-870.4C35.84 51.2 0 81.92 0 128v634.88c0 35.84 35.84 61.44 76.8 61.44z m460.8 97.28h-51.2v-97.28h51.2V921.6zM51.2 128c0-10.24 15.36-25.6 25.6-25.6h870.4c10.24 0 25.6 15.36 25.6 25.6v512H51.2v-512z m0 568.32h921.6v51.2c0 15.36-15.36 25.6-25.6 25.6h-870.4c-10.24 0-25.6-15.36-25.6-25.6v-51.2z"  ></path><path d="M834.56 404.48l-179.2 174.08-66.56-66.56c-10.24-10.24-25.6-10.24-35.84 0s-10.24 25.6 0 35.84l81.92 81.92c5.12 5.12 20.48 5.12 25.6 5.12 5.12 0 20.48 0 25.6-5.12L870.4 435.2c5.12-5.12 5.12-25.6 0-30.72-15.36-15.36-30.72-15.36-35.84 0z m-496.64-102.4h363.52c10.24 0 25.6-15.36 25.6-25.6s-10.24-25.6-20.48-25.6H337.92c-10.24 0-25.6 15.36-25.6 25.6s15.36 25.6 25.6 25.6z m261.12 133.12c20.48 0 25.6-10.24 25.6-25.6 0-10.24-10.24-25.6-25.6-25.6H337.92c-10.24 0-25.6 10.24-25.6 25.6 0 20.48 15.36 25.6 25.6 25.6h261.12z"  ></path></symbol><symbol id="icon-shujujiance2" viewBox="0 0 1024 1024"><path d="M25.6 117.76h35.84v588.8c0 30.72 25.6 61.44 61.44 61.44H409.6l-81.92 153.6c-5.12 5.12-5.12 10.24-5.12 20.48 0 5.12 5.12 15.36 15.36 15.36 5.12 0 10.24 5.12 15.36 5.12 10.24 0 20.48-5.12 25.6-15.36l92.16-163.84c0-5.12 5.12-5.12 5.12-10.24V768h76.8v5.12c0 5.12 0 10.24 5.12 10.24l92.16 163.84c5.12 10.24 15.36 15.36 25.6 15.36 5.12 0 10.24 0 15.36-5.12l15.36-15.36c0-5.12 0-10.24-5.12-20.48l-92.16-153.6h286.72c30.72 0 61.44-25.6 61.44-61.44V117.76h35.84c15.36 0 25.6-10.24 25.6-25.6v-5.12c0-15.36-15.36-25.6-25.6-25.6H20.48c-10.24 0-20.48 15.36-20.48 25.6 0 20.48 10.24 30.72 25.6 30.72z m92.16 0h793.6v558.08c0 20.48-15.36 35.84-35.84 35.84H153.6c-20.48 0-35.84-15.36-35.84-35.84V117.76z"  ></path><path d="M209.92 568.32c5.12 0 10.24 5.12 15.36 5.12 10.24 0 15.36-5.12 25.6-15.36l143.36-174.08 153.6 112.64c10.24 5.12 15.36 10.24 20.48 15.36 5.12 0 5.12 5.12 10.24 5.12 10.24 0 15.36-5.12 25.6-15.36l230.4-209.92c5.12-5.12 10.24-10.24 5.12-20.48 0-10.24-5.12-15.36-15.36-20.48-5.12 0-5.12-5.12-10.24-5.12-10.24 0-20.48 5.12-30.72 15.36l-204.8 184.32-163.84-107.52s-5.12 0-5.12-5.12c-10.24-5.12-15.36-10.24-25.6-10.24h-5.12-5.12s-5.12 0-5.12 5.12l-5.12 5.12-163.84 194.56c-10.24 15.36-5.12 30.72 10.24 40.96z"  ></path></symbol><symbol id="icon-hangyefenxi3" viewBox="0 0 1024 1024"><path d="M189.44 25.6c-61.44 0-112.64 51.2-112.64 112.64s51.2 112.64 112.64 112.64c61.44 0 112.64-51.2 112.64-112.64C296.96 76.8 250.88 25.6 189.44 25.6z m240.64 481.28l97.28-35.84 10.24-5.12 5.12 5.12 76.8 46.08 61.44-179.2 10.24-25.6 25.6 20.48 56.32 61.44 81.92-143.36 30.72 15.36-97.28 163.84-10.24 20.48-15.36-15.36-51.2-56.32-61.44 174.08-5.12 20.48-20.48-10.24-87.04-56.32-92.16 30.72-15.36-30.72z m20.48 430.08h337.92v61.44H450.56v-61.44z m209.92-189.44H1024V56.32H353.28v71.68h599.04v552.96H384v71.68h184.32V921.6H665.6l-5.12-174.08zM0 563.2l71.68 51.2-20.48 384h102.4l15.36-327.68h40.96l20.48 327.68h97.28L307.2 614.4l-5.12-235.52 230.4-5.12 51.2-87.04-261.12-10.24H204.8l10.24 15.36-15.36 20.48 25.6 179.2-35.84 40.96v5.12-5.12l-40.96-40.96 25.6-179.2-15.36-25.6 10.24-15.36H51.2L0 563.2z"  ></path></symbol><symbol id="icon-zishenfenxi2" viewBox="0 0 1024 1024"><path d="M988.16 947.2H35.84c-20.48 0-35.84-15.36-35.84-35.84v-25.6c0-20.48 15.36-35.84 35.84-35.84h952.32c20.48 0 35.84 15.36 35.84 35.84v25.6c0 20.48-15.36 35.84-35.84 35.84z m5.12-189.44l-10.24 5.12c-15.36 10.24-30.72 5.12-40.96-10.24l-102.4-153.6c-10.24-15.36-5.12-30.72 10.24-40.96l10.24-5.12c15.36-10.24 30.72-5.12 40.96 10.24l102.4 153.6c5.12 15.36 0 30.72-10.24 40.96z m-148.48-209.92c-87.04 56.32-199.68 35.84-256-51.2s-35.84-199.68 51.2-256 199.68-35.84 261.12 51.2c51.2 81.92 30.72 199.68-56.32 256z m10.24-235.52c-40.96-66.56-128-81.92-194.56-40.96-66.56 40.96-81.92 128-40.96 194.56 40.96 66.56 128 81.92 194.56 40.96 66.56-40.96 87.04-128 40.96-194.56z m-102.4-15.36c-61.44 0-112.64 51.2-112.64 112.64 0 40.96 25.6 35.84 25.6 61.44-5.12 15.36-51.2-10.24-51.2-76.8s56.32-122.88 122.88-122.88c56.32 0 40.96 20.48 40.96 25.6 0 5.12-15.36 0-25.6 0z m-20.48 327.68v148.48c0 20.48-15.36 35.84-35.84 35.84h-117.76c-20.48 0-35.84-15.36-35.84-35.84v-250.88c46.08 66.56 117.76 102.4 189.44 102.4z m-276.48 184.32H337.92c-20.48 0-35.84-15.36-35.84-35.84v-512c0-20.48 15.36-35.84 35.84-35.84h117.76c20.48 0 35.84 15.36 35.84 35.84v512c-5.12 20.48-20.48 35.84-35.84 35.84z m-245.76 0H92.16c-20.48 0-35.84-15.36-35.84-35.84v-665.6c0-20.48 15.36-35.84 35.84-35.84h117.76c20.48 0 35.84 15.36 35.84 35.84v665.6c0 20.48-15.36 35.84-35.84 35.84z"  ></path></symbol><symbol id="icon-yonghufenxi3" viewBox="0 0 1024 1024"><path d="M829.44 163.84h-46.08c-20.48 0-30.72 15.36-30.72 30.72v660.48c0 20.48 15.36 30.72 30.72 30.72h46.08c20.48 0 30.72-15.36 30.72-30.72V194.56c0-15.36-15.36-30.72-30.72-30.72zM76.8 327.68H30.72c-15.36 0-30.72 15.36-30.72 30.72v496.64c0 20.48 15.36 30.72 30.72 30.72h46.08c20.48 0 30.72-15.36 30.72-30.72V358.4c5.12-15.36-15.36-30.72-30.72-30.72z m916.48-271.36h-46.08c-20.48 0-30.72 15.36-30.72 30.72v768c0 20.48 15.36 30.72 30.72 30.72h46.08c20.48 0 30.72-15.36 30.72-30.72v-768c0-20.48-15.36-30.72-30.72-30.72z m-307.2 783.36V384c0-5.12 0-10.24-5.12-10.24l-148.48-148.48c-5.12-5.12-15.36-5.12-20.48 0-5.12 5.12-5.12 15.36 0 20.48l122.88 122.88H471.04V168.96c0-10.24-5.12-15.36-15.36-15.36H174.08c-10.24 0-15.36 5.12-15.36 15.36V870.4c0 10.24 5.12 15.36 15.36 15.36h460.8l66.56 76.8c10.24 10.24 25.6 10.24 30.72 0l20.48-20.48c10.24-10.24 10.24-25.6 0-35.84l-66.56-66.56z m-496.64 15.36V184.32h256v199.68c0 10.24 5.12 15.36 15.36 15.36h194.56V819.2l-56.32-51.2s-5.12-5.12-10.24-5.12c25.6-35.84 40.96-76.8 40.96-122.88 0-112.64-87.04-199.68-194.56-199.68-107.52 0-194.56 87.04-194.56 199.68s87.04 199.68 194.56 199.68c40.96 0 81.92-15.36 117.76-35.84 0 5.12 5.12 5.12 10.24 10.24l51.2 51.2H189.44z m378.88-220.16c0 76.8-61.44 133.12-133.12 133.12s-133.12-61.44-133.12-133.12S358.4 501.76 435.2 501.76s133.12 56.32 133.12 133.12z"  ></path></symbol><symbol id="icon-jingpinfenxi3" viewBox="0 0 1024 1024"><path d="M593.92 0v430.08H1024C1024 189.44 834.56 0 593.92 0"  ></path><path d="M527.36 496.64V40.96H455.68C199.68 61.44 0 271.36 0 532.48 0 803.84 220.16 1024 491.52 1024c261.12 0 471.04-199.68 491.52-455.68V496.64h-455.68z m-35.84 455.68c-230.4 0-419.84-189.44-419.84-419.84 0-220.16 168.96-399.36 384-414.72v455.68h455.68c-20.48 209.92-199.68 378.88-419.84 378.88z"  ></path></symbol><symbol id="icon-hailiangyouzhiziyuan1" viewBox="0 0 1026 1024"><path d="M25.6 230.4c-15.36 10.24-25.6 20.48-25.6 30.72s10.24 20.48 25.6 25.6l419.84 209.92c15.36 10.24 40.96 15.36 66.56 15.36s51.2-5.12 66.56-15.36l419.84-209.92c15.36-5.12 25.6-20.48 25.6-25.6s-10.24-20.48-25.6-25.6L578.56 25.6c-15.36-5.12-35.84-10.24-56.32-15.36h-20.48c-20.48 0-40.96 5.12-56.32 10.24L25.6 230.4zM512 71.68c20.48 0 30.72 5.12 40.96 5.12L916.48 256l-363.52 179.2c-5.12 5.12-20.48 5.12-40.96 5.12s-30.72-5.12-40.96-5.12L107.52 261.12l363.52-179.2c10.24-10.24 20.48-10.24 40.96-10.24z"  ></path><path d="M15.36 542.72l409.6 204.8c25.6 10.24 56.32 20.48 87.04 20.48h5.12c30.72 0 56.32-5.12 81.92-20.48l409.6-204.8c5.12-5.12 15.36-10.24 15.36-20.48 5.12-5.12 0-15.36 0-25.6-5.12-10.24-15.36-15.36-25.6-15.36-5.12 0-10.24 0-15.36 5.12l-409.6 204.8c-15.36 5.12-35.84 10.24-56.32 10.24s-40.96-5.12-56.32-10.24l-409.6-204.8c-5.12 0-10.24-5.12-15.36-5.12-10.24 0-20.48 5.12-25.6 15.36-10.24 10.24-10.24 10.24-10.24 15.36V527.36l15.36 15.36z"  ></path><path d="M15.36 793.6l409.6 204.8c25.6 10.24 56.32 20.48 87.04 20.48 30.72 0 61.44-5.12 87.04-20.48l409.6-204.8c5.12-5.12 15.36-10.24 15.36-20.48 5.12-5.12 0-15.36 0-25.6-5.12-10.24-15.36-15.36-25.6-15.36-5.12 0-10.24 0-15.36 5.12l-409.6 204.8c-15.36 5.12-35.84 10.24-56.32 10.24s-40.96-5.12-56.32-10.24l-409.6-204.8c-5.12 0-10.24-5.12-15.36-5.12-10.24 0-20.48 5.12-25.6 15.36-10.24 5.12-10.24 10.24-10.24 15.36v10.24c5.12 10.24 10.24 15.36 15.36 20.48z"  ></path></symbol><symbol id="icon-gaoxiaozhuanshufuwu1" viewBox="0 0 1024 1024"><path d="M926.72 158.72c-30.72-30.72-61.44-61.44-102.4-81.92-56.32-30.72-204.8-66.56-302.08 30.72l-30.72 30.72-25.6-25.6C348.16 0 189.44 46.08 92.16 143.36 0 235.52-46.08 389.12 71.68 506.88l51.2 51.2-10.24 10.24c-30.72 30.72-30.72 81.92 0 117.76l5.12 5.12c15.36 20.48 40.96 25.6 61.44 25.6 0 20.48 10.24 40.96 25.6 61.44l5.12 5.12c20.48 20.48 40.96 25.6 66.56 25.6 0 20.48 10.24 40.96 25.6 56.32l10.24 5.12c15.36 15.36 40.96 25.6 66.56 25.6 0 20.48 10.24 40.96 25.6 56.32H409.6c15.36 15.36 35.84 25.6 56.32 25.6 20.48 0 40.96-10.24 56.32-25.6l56.32-56.32c10.24-10.24 15.36-15.36 15.36-25.6 15.36 15.36 30.72 20.48 51.2 20.48 25.6 0 46.08-10.24 66.56-25.6 15.36-15.36 20.48-30.72 25.6-51.2 25.6 5.12 56.32-10.24 76.8-25.6 15.36-15.36 25.6-35.84 25.6-56.32 20.48 0 40.96-10.24 56.32-25.6 30.72-30.72 40.96-81.92 10.24-117.76l51.2-51.2c112.64-117.76 66.56-271.36-30.72-378.88zM199.68 660.48c-15.36 10.24-35.84 10.24-46.08 0l-5.12-5.12c-15.36-15.36-15.36-35.84 0-46.08l87.04-87.04c15.36-15.36 35.84-15.36 46.08 0l5.12 5.12c15.36 15.36 15.36 35.84 0 46.08l-87.04 87.04z m92.16 87.04c-15.36 10.24-35.84 10.24-46.08 0l-5.12-5.12c-15.36-15.36-15.36-35.84 0-46.08l138.24-138.24c15.36-15.36 35.84-15.36 46.08 0l5.12 5.12c15.36 15.36 15.36 35.84 0 46.08l-138.24 138.24z m102.4 87.04c-15.36 15.36-35.84 15.36-46.08 0l-5.12-5.12c-15.36-15.36-15.36-35.84 0-46.08l92.16-92.16c15.36-15.36 35.84-15.36 46.08 0l5.12 5.12c15.36 15.36 15.36 35.84 0 46.08l-92.16 92.16z m153.6 25.6L491.52 921.6c-15.36 10.24-35.84 10.24-46.08 0l-5.12-5.12c-5.12-5.12-10.24-15.36-10.24-25.6s5.12-15.36 10.24-25.6l56.32-56.32c10.24-10.24 25.6-10.24 35.84-10.24v5.12l25.6 25.6c0 10.24 0 25.6-10.24 30.72z m327.68-307.2l-215.04-225.28c-10.24-10.24-25.6-10.24-35.84 0s-10.24 25.6 0 35.84l240.64 250.88c15.36 20.48 10.24 46.08-5.12 56.32-10.24 10.24-25.6 15.36-46.08-5.12l-122.88-128c-10.24-10.24-25.6-10.24-35.84 0-10.24 10.24-10.24 25.6 0 35.84l10.24 10.24 112.64 117.76c25.6 25.6 10.24 40.96 0 51.2-10.24 10.24-35.84 20.48-56.32 5.12l-122.88-128c-10.24-10.24-25.6-10.24-35.84 0-10.24 10.24-10.24 25.6 0 35.84l102.4 107.52c0 5.12 5.12 5.12 5.12 10.24 25.6 25.6 10.24 40.96 5.12 51.2-10.24 10.24-35.84 20.48-51.2 5.12l-30.72-30.72c-5.12-5.12-5.12-15.36-10.24-20.48l-5.12-5.12c-10.24-10.24-25.6-20.48-35.84-20.48 15.36-30.72 10.24-66.56-15.36-92.16l-15.36-20.48c-10.24-10.24-25.6-15.36-35.84-20.48 20.48-30.72 15.36-71.68-15.36-97.28l-5.12-5.12c-30.72-30.72-87.04-30.72-117.76 0 0-15.36-10.24-25.6-20.48-35.84l-5.12-5.12c-30.72-30.72-87.04-30.72-117.76 0l-40.96 40.96-51.2-51.2C10.24 378.88 51.2 256 128 179.2 204.8 97.28 337.92 56.32 435.2 153.6l25.6 25.6-122.88 112.64c-25.6 25.6-25.6 56.32-5.12 81.92 35.84 30.72 122.88 40.96 179.2-10.24l46.08-46.08c20.48-20.48 40.96-15.36 81.92 0 46.08 15.36 112.64 35.84 179.2-20.48 10.24-10.24 10.24-25.6 5.12-35.84-10.24-10.24-25.6-10.24-35.84-5.12-51.2 40.96-92.16 25.6-138.24 10.24-35.84-10.24-81.92-20.48-128 15.36l-46.08 46.08c-25.6 25.6-61.44 30.72-87.04 20.48-15.36-5.12-20.48-10.24-25.6-15.36 0 0 0-5.12 5.12-5.12l184.32-184.32c87.04-81.92 215.04-40.96 245.76-25.6 30.72 15.36 61.44 40.96 87.04 71.68 76.8 81.92 133.12 215.04 30.72 312.32l-40.96 51.2z"  ></path></symbol><symbol id="icon-zhuanyeyingxiaojingyan1" viewBox="0 0 1024 1024"><path d="M778.24 962.56H245.76c-15.36 0-30.72 15.36-30.72 30.72s15.36 30.72 30.72 30.72h527.36c15.36 0 30.72-15.36 30.72-30.72 5.12-20.48-10.24-30.72-25.6-30.72z m87.04-711.68c-10.24 0-20.48 5.12-25.6 10.24L691.2 409.6l-102.4-102.4c-5.12-5.12-20.48-10.24-25.6-10.24-10.24 0-20.48 10.24-25.6 15.36l-133.12 235.52-61.44-148.48c-5.12-10.24-10.24-15.36-25.6-20.48-10.24 0-20.48 0-30.72 10.24L163.84 512c-10.24 10.24-10.24 15.36-10.24 25.6s5.12 15.36 10.24 25.6 15.36 10.24 25.6 10.24 15.36-5.12 25.6-10.24L307.2 471.04l66.56 163.84c5.12 10.24 15.36 20.48 25.6 20.48s25.6-5.12 30.72-15.36l148.48-256 97.28 97.28c5.12 5.12 15.36 10.24 25.6 10.24s15.36-5.12 25.6-10.24L885.76 307.2c5.12-5.12 10.24-15.36 10.24-25.6s-5.12-15.36-10.24-25.6c-5.12 0-15.36-5.12-20.48-5.12z"  ></path><path d="M1024 92.16C1013.76 40.96 972.8 0 916.48 0H107.52C46.08 0 0 46.08 0 107.52v691.2c0 56.32 46.08 107.52 107.52 107.52h808.96c61.44 0 107.52-46.08 107.52-107.52V92.16z m-61.44 706.56c0 25.6-20.48 46.08-46.08 46.08H107.52c-25.6 0-46.08-20.48-46.08-46.08V107.52c0-25.6 20.48-46.08 46.08-46.08h808.96c20.48 0 40.96 15.36 46.08 35.84v701.44z"  ></path></symbol><symbol id="icon-jingzhunyonghuhuoqu" viewBox="0 0 1024 1024"><path d="M998.4 486.4h-97.28v-20.48c-20.48-179.2-163.84-322.56-343.04-343.04h-20.48V25.6c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v97.28l-20.48 5.12c-179.2 20.48-317.44 158.72-337.92 343.04v20.48h-102.4c-15.36-5.12-25.6 5.12-25.6 20.48 0 15.36 10.24 25.6 25.6 25.6h97.28v20.48c20.48 179.2 163.84 322.56 343.04 343.04h20.48v97.28c0 15.36 10.24 25.6 25.6 25.6s25.6-10.24 25.6-25.6v-97.28h20.48c179.2-20.48 322.56-163.84 343.04-343.04v-20.48h97.28c15.36 0 25.6-10.24 25.6-25.6s-10.24-25.6-25.6-25.6z m-153.6 76.8c-20.48 148.48-138.24 266.24-286.72 286.72l-25.6 5.12v-153.6c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v153.6l-20.48-5.12c-148.48-20.48-261.12-138.24-281.6-286.72l-5.12-25.6h153.6c15.36 0 25.6-10.24 25.6-25.6s-10.24-25.6-25.6-25.6h-153.6l5.12-25.6C199.68 317.44 317.44 199.68 460.8 179.2l25.6-5.12v153.6c0 15.36 10.24 25.6 25.6 25.6s25.6-10.24 25.6-25.6v-153.6l25.6 5.12c148.48 20.48 261.12 138.24 286.72 281.6l5.12 25.6h-153.6c-15.36 0-25.6 10.24-25.6 25.6s10.24 25.6 25.6 25.6h153.6l-10.24 25.6z"  ></path><path d="M512 460.8c-25.6 0-51.2 20.48-51.2 51.2s20.48 51.2 51.2 51.2c25.6 0 51.2-20.48 51.2-51.2 0-25.6-25.6-51.2-51.2-51.2z"  ></path></symbol><symbol id="icon-tishengzhuanhuashuai" viewBox="0 0 1024 1024"><path d="M512 0C296.96 0 102.4 133.12 25.6 332.8l61.44 20.48C148.48 179.2 317.44 61.44 512 61.44c107.52 0 209.92 35.84 291.84 107.52 81.92 66.56 133.12 158.72 153.6 261.12v10.24l-71.68-46.08-35.84 51.2 122.88 81.92c5.12 5.12 10.24 5.12 15.36 5.12 5.12 0 10.24 0 15.36-5.12 10.24-5.12 15.36-15.36 15.36-25.6C1024 225.28 793.6 0 512 0z m0 962.56c-107.52 0-209.92-35.84-291.84-107.52-81.92-66.56-133.12-158.72-153.6-261.12v-10.24l71.68 46.08 35.84-51.2L51.2 496.64c-5.12 0-10.24-5.12-20.48-5.12-5.12 0-10.24 0-15.36 5.12-10.24 5.12-15.36 15.36-15.36 30.72C0 798.72 230.4 1024 512 1024c215.04 0 409.6-133.12 486.4-332.8l-61.44-20.48c-61.44 174.08-230.4 291.84-424.96 291.84z"  ></path><path d="M660.48 312.32l-10.24-5.12c-5.12 0-5.12-5.12-10.24-5.12h-5.12c-5.12 0-10.24 5.12-10.24 5.12L358.4 686.08c-5.12 10.24-5.12 20.48 5.12 25.6l10.24 5.12c5.12 0 5.12 5.12 10.24 5.12h5.12c5.12 0 10.24-5.12 10.24-5.12L665.6 337.92v-15.36c0-5.12 0-10.24-5.12-10.24zM532.48 614.4c0 46.08 35.84 87.04 87.04 87.04s87.04-35.84 87.04-87.04c0-46.08-35.84-87.04-87.04-87.04s-87.04 40.96-87.04 87.04z m87.04-51.2c15.36 0 35.84 10.24 40.96 25.6 10.24 15.36 10.24 35.84 0 51.2s-25.6 25.6-40.96 25.6c-25.6 0-51.2-20.48-51.2-51.2 0-25.6 20.48-51.2 51.2-51.2zM409.6 322.56c-30.72 0-56.32 15.36-71.68 40.96-15.36 25.6-15.36 56.32 0 87.04 10.24 25.6 40.96 40.96 71.68 40.96 46.08 0 87.04-35.84 87.04-87.04-5.12-40.96-40.96-81.92-87.04-81.92z m40.96 107.52c-10.24 15.36-25.6 25.6-40.96 25.6-30.72 0-51.2-20.48-51.2-51.2 0-25.6 20.48-51.2 46.08-51.2 15.36 0 35.84 10.24 40.96 25.6 15.36 15.36 15.36 35.84 5.12 51.2z"  ></path></symbol><symbol id="icon-tianjiadaoxuanhaoche" viewBox="0 0 1024 1024"><path d="M606.72 777.728c-4.096 0-8.192 1.024-11.776 3.072-33.28 18.432-60.416 31.232-77.312 38.912-1.536 0.512-2.56 1.024-4.096 1.024s-3.072-0.512-4.096-1.024c-56.832-25.088-342.528-162.304-364.032-393.728C139.776 369.152 157.696 312.32 194.56 270.336c34.304-38.912 81.408-61.44 132.608-63.488h7.68c64 0 123.904 31.744 159.232 85.504 4.096 6.144 11.776 10.24 19.456 10.24s14.848-3.584 19.456-10.24c35.328-53.76 94.72-85.504 158.72-85.504h7.68c51.2 1.536 98.304 24.576 132.608 63.488 36.352 41.984 54.272 98.816 49.152 155.648-4.096 43.52-17.408 86.528-40.448 127.488-6.144 11.264-2.048 25.6 9.216 31.744 3.584 2.048 7.168 3.072 11.264 3.072 8.192 0 16.384-4.608 20.48-12.288 25.6-47.104 41.472-96.256 46.08-145.92 6.144-69.632-15.872-139.264-60.928-190.976-43.008-49.152-101.888-77.312-166.4-79.872h-9.728c-68.608 0-133.12 29.696-178.176 80.896-45.056-51.712-110.08-80.896-178.688-80.896h-9.216c-64.512 2.56-123.392 30.72-166.4 79.872C112.64 290.816 90.624 360.448 97.28 430.08c24.576 257.024 330.752 405.504 392.192 432.64 7.68 3.072 15.36 4.608 23.04 4.608s15.36-1.536 24.576-4.096c17.92-8.192 46.592-21.504 81.408-41.472 11.264-6.656 15.36-20.992 8.704-32.256-4.096-7.168-12.288-11.776-20.48-11.776z" fill="" ></path><path d="M905.216 725.504h-87.552v-87.04c0-12.8-10.752-23.552-23.552-23.552s-23.552 10.752-23.552 23.552v87.04h-87.04c-12.8 0-23.552 10.752-23.552 23.552s10.752 23.552 23.552 23.552h87.04V860.16c0 12.8 10.752 23.552 23.552 23.552s23.552-10.752 23.552-23.552v-87.552h87.552c12.8 0 23.552-10.752 23.552-23.552s-10.752-23.552-23.552-23.552z" fill="" ></path></symbol><symbol id="icon-jiantou" viewBox="0 0 1024 1024"><path d="M1010.80577 455.530292a29.72694 29.72694 0 0 1 0 42.037895L758.668226 749.785575a29.714963 29.714963 0 0 1-42.017934-42.027914l252.137544-252.227369a29.720951 29.720951 0 0 1 42.017934 0zM758.668226 203.312904l252.137544 252.217388a29.717957 29.717957 0 0 1-42.017934 42.037895l-252.137544-252.207407a29.721949 29.721949 0 0 1 42.017934-42.047876zM27.945419 447.20655h955.693411a20.460039 20.460039 0 0 1 20.460039 20.460039v18.254347a20.460039 20.460039 0 0 1-20.460039 20.460039H27.945419A20.460039 20.460039 0 0 1 7.48538 485.920936v-18.254347a20.460039 20.460039 0 0 1 20.460039-20.460039z" fill="#E61D15" ></path></symbol><symbol id="icon-xiaoshi-" viewBox="0 0 1024 1024"><path d="M24.807193 981.546454h974.385614v-239.376624H24.807193v239.376624zM341.93007 797.922078h601.510489v127.872128H341.93007v-127.872128zM24.807193 74.677323v239.888112h974.385614V74.677323H24.807193z m918.121878 183.624375H342.953047v-127.872128h599.976024v127.872128zM24.807193 648.055944h974.385614V408.167832H24.807193v239.888112z m317.122877-183.624376h601.510489v127.36064H341.93007V464.431568z"  ></path></symbol><symbol id="icon-xiaoshi-1" viewBox="0 0 1024 1024"><path d="M544.991009 116.619381h449.086913V250.629371l-56.263736 4.603396v526.833167h-333.49051l-3.068931 8.183816 204.083916 154.981019-34.26973 49.614386c-81.838162-61.89011-161.118881-120.711289-239.376623-181.578422-19.948052-15.344655-32.735265-14.833167-52.171828 0-78.257742 60.867133-157.538462 119.688312-238.353647 181.066933l-35.804196-49.102897L418.653347 784.623377H87.208791V254.20979H27.876124V114.573427l313.542457 3.068931c43.988012 0.511489 87.464535 0 134.00999 0l4.091909-88.999001h65.982018v87.976024zM142.961039 724.779221H878.993007V256.255744H142.961039v468.523477z m205.106893-137.078921c-63.936064 3.58042-115.084915-45.522478-118.665335-109.97003-3.58042-69.562438 45.010989-125.314685 112.527473-128.895105 63.936064-3.58042 116.619381 46.545455 121.734266 121.222777H348.067932v117.642358z m251.652348-164.699301v-37.338661h146.797203v37.338661h-146.797203z m146.797203 45.522478l2.045954 36.315684h-149.354646v-36.315684h147.308692z m-147.308692 119.176823v-35.804196h147.308692v35.804196h-147.308692z m-208.687312 35.804196V506.885115h112.015984c5.626374 63.424575-45.010989 116.619381-112.015984 116.619381z"  ></path></symbol><symbol id="icon-xiaoshi-2" viewBox="0 0 1024 1024"><path d="M41.686314 484.891109c12.275724 7.672328 29.154845 7.672328 41.430569-1.022977l86.953047-58.821179c17.390609-11.764236 21.994006-35.292707 10.22977-53.194805-11.764236-17.390609-35.292707-21.994006-53.194805-10.22977l-4.091908 3.068931c60.867133-158.04995 216.35964-265.974026 387.196803-265.974026 207.152847 0 383.104895 153.958042 410.213786 359.064935 2.557443 18.925075 18.925075 32.735265 37.338662 32.735265h4.603396c20.971029-2.557443 35.292707-21.994006 32.735265-42.965035-15.856144-116.619381-72.631369-224.543457-161.63037-302.289711C744.471528 66.493506 629.386613 23.528472 509.698302 23.528472S275.436563 67.516484 186.437562 145.774226 40.151848 330.933067 23.784216 447.552448c-1.534466 14.833167 5.114885 29.666334 17.902098 37.338661zM977.198801 542.689311c-12.275724-7.672328-29.154845-7.672328-41.430569 1.022977l-86.953047 58.821179c-17.390609 11.764236-21.994006 35.292707-10.22977 53.194805 11.764236 17.390609 35.292707 21.994006 53.194805 10.22977l4.091908-3.068931c-60.867133 158.04995-216.35964 265.974026-387.196803 265.974026-207.152847 0-383.104895-153.958042-410.213787-359.064935-2.557443-18.925075-18.925075-32.735265-37.338661-32.735265h-4.603396c-20.971029 2.557443-35.292707 21.994006-32.735265 42.965035 15.856144 116.619381 72.631369 224.543457 161.630369 302.28971 88.999001 78.769231 204.083916 121.734266 323.772228 121.734266s234.773227-43.988012 323.772228-121.734266 146.285714-185.158841 162.653347-301.778221c1.534466-15.344655-5.626374-30.177822-18.413587-37.85015z"  ></path><path d="M668.25974 512v-0.511489c17.390609-4.091908 30.689311-18.925075 30.689311-37.338661 0-20.971029-17.390609-38.361638-38.361638-38.361638h-59.332668l55.752248-55.752248c14.833167-14.833167 14.833167-38.873127 0-53.706294-7.160839-7.160839-16.367632-10.741259-26.597403-10.741258s-19.436563 4.091908-26.597402 10.741258L509.698302 419.932068 415.072927 324.283716c-14.833167-14.833167-38.873127-14.833167-53.706294 0-14.833167 14.833167-14.833167 38.873127 0 53.706294L418.653347 435.276723H358.809191c-20.971029 0-38.361638 17.390609-38.361639 38.361639s17.390609 38.361638 38.361639 38.361638h112.527472v44.4995h-112.527472c-20.971029 0-38.361638 17.390609-38.361639 38.361639s17.390609 38.361638 38.361639 38.361638h112.527472V716.083916c0 20.971029 17.390609 38.361638 38.361639 38.361638s38.361638-17.390609 38.361638-38.361638v-83.884116h112.527473c20.971029 0 38.361638-17.390609 38.361638-38.361638s-17.390609-37.338661-38.361638-37.338662h-112.527473v-44.4995h120.1998z"  ></path></symbol><symbol id="icon-xiaoshi-3" viewBox="0 0 1024 1024"><path d="M966.969031 588.211788c-20.971029 0-37.85015 16.879121-37.85015 38.361639s16.879121 38.361638 37.85015 38.361638c20.971029 0 37.85015-16.879121 37.85015-38.361638s-16.879121-38.361638-37.85015-38.361639z m-37.85015-155.492507c0 20.971029 16.879121 38.361638 37.85015 38.361638 20.971029 0 37.85015-16.879121 37.85015-38.361638s-16.879121-38.361638-37.85015-38.361639c-20.971029 0-37.85015 17.390609-37.85015 38.361639z m37.338661-115.596404C892.291708 135.544456 715.828172 8.183816 510.721279 8.183816 238.097902 8.183816 17.134865 232.727273 17.134865 510.465534 17.134865 787.692308 238.097902 1012.747253 510.721279 1012.747253h0.511488v-69.050949c-235.796204 0-427.092907-194.365634-427.092907-434.253747S275.436563 75.188811 511.744256 75.188811c168.27972 0 313.030969 98.717283 383.104895 241.934066h71.608391zM428.371628 359.064935c21.482517 19.436563 32.223776 44.4995 32.223777 76.211788 0 30.689311-11.764236 57.798202-34.269731 82.861139-13.81019 14.833167-38.361638 33.246753-72.631368 56.775225-35.804196 23.528472-57.286713 44.4995-65.47053 61.89011h172.883117v50.637362H216.103896c0-35.804196 11.252747-67.004995 34.781219-93.602397 12.787213-14.833167 39.896104-36.315684 80.815185-64.447553 22.505495-15.856144 38.361638-29.154845 48.07992-39.384615 15.344655-17.390609 23.016983-35.804196 23.016983-55.752248 0-18.925075-5.626374-33.246753-15.344656-42.965035-10.22977-9.206793-25.574426-13.81019-45.522477-13.81019-21.482517 0-37.85015 7.160839-48.591409 21.994006-10.741259 13.81019-16.879121 34.781219-17.902098 62.401599H218.14985c0.511489-39.384615 11.764236-70.585415 34.26973-95.136863 23.016983-25.574426 53.706294-38.361638 91.556444-38.361639 34.26973 1.022977 62.401598 10.741259 84.395604 30.689311z m291.548452-23.016983v230.16983h52.171828v45.522478h-52.171828v75.188811h-54.729271v-75.188811H495.376623v-54.729271l171.86014-221.474525 52.683317 0.511488z m-177.486514 230.16983h122.757243V408.679321h-1.534465l-121.222778 157.538461z m135.544456 158.04995v117.642358c7.160839-13.298701 16.879121-23.016983 28.643357-29.666334 11.252747-6.137862 23.528472-9.718282 37.338661-9.718281 24.03996 0 42.453546 6.649351 55.240759 20.971028 12.787213 13.81019 18.925075 34.26973 18.925075 60.355645v129.918082H786.925075v-124.803197c0-18.925075-4.603397-33.758242-13.298701-43.988012-9.718282-10.22977-22.505495-15.344655-39.896104-15.344655-15.856144 0-29.154845 6.137862-39.384616 18.925075-10.741259 12.787213-15.856144 29.154845-15.856144 48.07992v117.130869h-31.712287v-289.502498h31.200799z m307.916084 82.861139v31.712288c-10.22977-3.068931-20.45954-4.603397-30.689311-4.603397-15.856144 0-29.666334 6.649351-40.407592 20.971029-11.252747 13.298701-16.367632 29.666334-16.367633 49.102897v108.947053h-31.200799v-205.618381h31.200799v35.804195c5.626374-11.764236 12.787213-21.482517 21.482518-28.131868 10.741259-8.695305 23.016983-13.298701 37.338661-13.298701 11.764236 0.511489 20.971029 2.045954 28.643357 5.114885z"  ></path></symbol><symbol id="icon-xinmeitizhanghao" viewBox="0 0 1024 1024"><path d="M356.864 199.68h200.704c6.656 0 12.288-5.632 12.288-12.288 0-6.656-5.632-12.288-12.288-12.288H356.864c-6.656 0-12.288 5.632-12.288 12.288-0.512 6.656 5.12 12.288 12.288 12.288z m102.4 689.664H183.808V199.68H271.36c6.656 0 12.288-5.632 12.288-12.288 0-6.656-5.632-12.288-12.288-12.288H171.008c-6.656 0-12.288 5.632-12.288 12.288v714.24c0 6.656 5.632 12.288 12.288 12.288h288.256c6.656 0 12.288-5.632 12.288-12.288 0-6.656-5.632-12.288-12.288-12.288zM650.752 199.68h93.696v279.04c0 6.656 5.632 12.288 12.288 12.288 6.656 0 12.288-5.632 12.288-12.288V187.392c0-6.656-5.632-12.288-12.288-12.288h-105.984c-6.656 0-12.288 5.632-12.288 12.288 0 6.656 5.632 12.288 12.288 12.288z"  ></path><path d="M306.176 264.192c6.656 0 12.288-5.632 12.288-12.288V128c0-6.656-5.632-12.288-12.288-12.288-6.656 0-12.288 5.632-12.288 12.288v123.392c-0.512 7.168 5.12 12.8 12.288 12.8z m303.104 0c6.656 0 12.288-5.632 12.288-12.288V128c0-6.656-5.632-12.288-12.288-12.288-6.656 0-12.288 5.632-12.288 12.288v123.392c0 7.168 5.632 12.8 12.288 12.8z m77.312 112.128c0-6.656-5.632-12.288-12.288-12.288H243.712c-6.656 0-12.288 5.632-12.288 12.288 0 6.656 5.632 12.288 12.288 12.288h430.592c7.168 0 12.288-5.632 12.288-12.288zM243.712 477.696H409.6c6.656 0 12.288-5.632 12.288-12.288 0-6.656-5.632-12.288-12.288-12.288H243.712c-6.656 0-12.288 5.632-12.288 12.288 0 6.656 5.632 12.288 12.288 12.288z m0 81.408H409.6c6.656 0 12.288-5.632 12.288-12.288 0-6.656-5.632-12.288-12.288-12.288H243.712c-6.656 0-12.288 5.632-12.288 12.288 0 6.656 5.632 12.288 12.288 12.288z m295.936-0.512c6.656-1.024 11.264-7.68 10.24-14.336-1.024-6.656-7.68-11.264-14.336-10.24-46.08 7.68-79.36 47.616-79.36 94.208 0 20.992 7.168 41.472 19.968 58.368-47.616 25.6-77.312 74.752-77.312 129.536 0 11.776 1.536 23.04 4.096 34.304 1.536 5.632 6.656 9.728 12.288 9.728 1.024 0 2.048 0 3.072-0.512 6.656-1.536 10.752-8.192 9.216-14.848-2.048-9.216-3.584-18.944-3.584-28.672 0-50.688 30.72-95.744 77.824-114.176 0.512 0 0.512-0.512 1.024-0.512s0.512-0.512 1.024-0.512 0.512-0.512 1.024-0.512l0.512-0.512 0.512-0.512c2.048-2.048 3.072-4.608 3.072-7.68v-0.512-0.512-0.512-0.512-0.512-0.512-0.512-0.512-0.512s0-0.512-0.512-0.512c0 0 0-0.512-0.512-0.512 0 0 0-0.512-0.512-0.512l-0.512-0.512v-0.512c0-0.512-0.512-0.512-0.512-1.024l-1.024-1.024c-15.36-13.312-24.064-32.768-24.064-53.248-0.512-35.328 24.064-64.512 58.368-70.656z m304.128 128.512c12.8-16.896 19.968-37.376 19.968-58.368 0-47.104-33.28-86.528-79.36-94.208-6.656-1.024-13.312 3.584-14.336 10.24-1.024 6.656 3.584 13.312 10.24 14.336 34.304 5.632 58.88 35.328 58.88 69.632 0 20.48-8.704 39.424-24.064 53.248l-1.024 1.024s-0.512 0.512-0.512 1.024v0.512l-0.512 0.512s0 0.512-0.512 0.512c0 0 0 0.512-0.512 0.512 0 0 0 0.512-0.512 0.512v0.512s0 0.512-0.512 1.024v3.584c0 3.072 1.024 5.632 3.072 7.68l0.512 0.512 0.512 0.512c0.512 0 0.512 0.512 1.024 0.512s0.512 0.512 1.024 0.512 0.512 0.512 1.024 0.512c47.104 18.432 77.824 62.976 77.824 114.176 0 9.728-1.024 19.456-3.584 28.672-1.536 6.656 2.56 13.312 9.216 14.848 1.024 0 2.048 0.512 3.072 0.512 5.632 0 10.752-4.096 12.288-9.728 2.56-11.264 4.096-23.04 4.096-34.304 0-54.272-29.696-103.424-77.312-129.024z m-121.856 3.584c23.552-19.968 37.888-49.664 37.888-81.92 0-59.392-48.128-107.52-107.52-107.52s-107.52 48.128-107.52 107.52c0 33.28 15.36 64 40.448 83.968A189.952 189.952 0 0 0 466.432 865.28c0 3.584 1.024 6.656 3.584 9.216 2.56 2.56 5.632 3.584 8.704 3.584H834.56c6.656 0 12.288-5.632 12.288-12.288v-0.512c-1.536-78.336-52.224-147.968-124.928-174.592z m-229.376 162.816c6.656-69.632 57.344-128.512 126.464-144.896 6.656-1.536 10.752-8.192 9.216-14.848-1.024-4.096-3.584-7.168-7.168-8.704-30.72-12.8-50.688-42.496-50.688-75.776 0-45.568 36.864-82.432 82.432-82.432 45.568 0 82.432 36.864 82.432 82.432 0 32.256-18.944 61.44-48.128 74.752-5.12 2.048-7.68 7.68-7.168 12.8 0.512 5.632 4.608 9.728 9.728 10.752 71.168 14.336 124.928 74.24 131.584 145.92H492.544z"  ></path></symbol><symbol id="icon-qianyuehongren" viewBox="0 0 1076 1024"><path d="M775.314286 324.266667C775.314286 143.034921 632.279365 1.625397 450.234921 1.625397c-178.793651 0-325.079365 144.660317-325.079365 322.64127 0 141.409524 89.396825 260.063492 216.177777 303.949206C171.479365 671.288889 39.009524 805.384127 4.87619 982.552381l31.695239 6.501587c38.196825-196.673016 208.050794-337.269841 411.225396-342.146031h7.314286c177.168254-5.688889 320.203175-150.349206 320.203175-322.64127zM455.111111 614.4h-13.815873C282.819048 609.52381 158.47619 481.930159 158.47619 324.266667c0-160.101587 130.844444-290.133333 292.571429-290.133334 164.165079 0 292.571429 127.593651 292.571429 290.133334C742.806349 479.492063 613.587302 609.52381 455.111111 614.4z"  ></path><path d="M1066.260317 696.48254c-7.314286-26.819048-28.444444-36.571429-46.323809-41.447619l-108.901587-17.879365-47.949207-100.774604c-12.190476-23.568254-29.257143-34.946032-54.450793-34.946031-23.568254 0-40.634921 11.377778-54.450794 34.133333l-48.761905 101.587302-107.27619 17.879365h-1.625397c-25.193651 6.501587-40.634921 20.31746-47.136508 42.260317-5.688889 24.380952 0 40.634921 11.377778 57.701587l78.831746 78.831746-19.504762 111.339683c-5.688889 23.568254 4.063492 47.136508 26.006349 61.765079 21.942857 14.628571 46.32381 11.377778 62.577778 7.314286l2.438095-0.812698 95.085714-52.825397 94.273016 52.825397c13.003175 6.501587 20.31746 6.501587 28.444445 6.501587 11.377778 0 22.755556-4.063492 34.946031-12.190476 19.504762-13.003175 29.257143-35.75873 26.00635-60.952381l-17.879365-114.590476L1048.380952 755.809524c17.879365-18.692063 25.193651-40.634921 17.879365-59.326984z m-40.63492 35.75873L937.04127 820.825397l20.31746 130.031746c1.625397 12.190476-2.438095 23.568254-11.377778 29.257143-6.501587 4.063492-12.190476 6.501587-17.066666 6.501587-6.501587 0-8.126984 0-13.003175-2.438095l-108.901587-60.952381L698.920635 983.365079c-15.44127 3.250794-26.006349 2.438095-34.133333-3.250793-4.063492-2.438095-16.253968-12.190476-12.190477-27.631746l22.755556-129.219048-87.771429-86.95873c-7.314286-10.565079-9.752381-17.879365-6.501587-30.069841 2.438095-7.314286 6.501587-14.628571 22.755556-19.504762L726.552381 666.412698l55.263492-115.403174c8.126984-14.628571 16.253968-17.066667 26.006349-17.066667 11.377778 0 18.692063 2.438095 25.193651 17.066667l55.263492 116.215873 122.71746 20.31746c14.628571 4.063492 21.130159 8.939683 22.755556 18.692064l0.812698 2.438095c3.250794 4.063492 0.812698 14.628571-8.939682 23.568254z"  ></path></symbol><symbol id="icon-hangye" viewBox="0 0 1024 1024"><path d="M378.164134 1015.285106H119.829787c-60.381763 0-109.558663-49.1769-109.558662-109.558662V647.392097c0-60.381763 49.1769-109.558663 109.558662-109.558662h258.334347c60.381763 0 109.558663 49.1769 109.558662 109.558662v258.334347c0 60.381763-49.1769 109.558663-109.558662 109.558662zM119.829787 568.335562c-42.951976 0-78.434043 35.482067-78.434042 78.434043v258.334346c0 42.951976 35.482067 78.434043 78.434042 78.434043h258.334347c42.951976 0 78.434043-35.482067 78.434042-78.434043v-258.334346c0-42.951976-35.482067-78.434043-78.434042-78.434043H119.829787zM378.164134 490.524012H119.829787C59.448024 490.524012 10.271125 441.347112 10.271125 380.96535V122.631003C10.271125 62.24924 59.448024 13.07234 119.829787 13.07234h258.334347c60.381763 0 109.558663 49.1769 109.558662 109.558663v258.334347c0 60.381763-49.1769 109.558663-109.558662 109.558662zM119.829787 44.19696c-42.951976 0-78.434043 35.482067-78.434042 78.434043v258.334347c0 42.951976 35.482067 78.434043 78.434042 78.434042h258.334347c42.951976 0 78.434043-35.482067 78.434042-78.434042V122.631003c0-42.951976-35.482067-78.434043-78.434042-78.434043H119.829787zM902.925228 1015.285106h-258.334347c-60.381763 0-109.558663-49.1769-109.558662-109.558662V647.392097c0-60.381763 49.1769-109.558663 109.558662-109.558662h258.334347c60.381763 0 109.558663 49.1769 109.558663 109.558662v258.334347c0 60.381763-49.1769 109.558663-109.558663 109.558662z m-258.334347-446.949544c-42.951976 0-78.434043 35.482067-78.434042 78.434043v258.334346c0 42.951976 35.482067 78.434043 78.434042 78.434043h258.334347c42.951976 0 78.434043-35.482067 78.434043-78.434043v-258.334346c0-42.951976-35.482067-78.434043-78.434043-78.434043h-258.334347zM902.925228 490.524012h-258.334347c-60.381763 0-109.558663-49.1769-109.558662-109.558662V122.631003c0-60.381763 49.1769-109.558663 109.558662-109.558663h258.334347c60.381763 0 109.558663 49.1769 109.558663 109.558663v258.334347c0 60.381763-49.1769 109.558663-109.558663 109.558662zM644.590881 44.19696c-42.951976 0-78.434043 35.482067-78.434042 78.434043v258.334347c0 42.951976 35.482067 78.434043 78.434042 78.434042h258.334347c42.951976 0 78.434043-35.482067 78.434043-78.434042V122.631003c0-42.951976-35.482067-78.434043-78.434043-78.434043h-258.334347z" fill="" ></path></symbol></svg>',
      h = (c = document.getElementsByTagName("script"))[c.length - 1].getAttribute("data-injectcss");if (h && !o.__iconfont__svg__cssinject__) {
    o.__iconfont__svg__cssinject__ = !0;try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (c) {
      console && console.log(c);
    }
  }!function (c) {
    if (document.addEventListener) {
      if (~["complete", "loaded", "interactive"].indexOf(document.readyState)) setTimeout(c, 0);else {
        var h = function h() {
          document.removeEventListener("DOMContentLoaded", h, !1), c();
        };document.addEventListener("DOMContentLoaded", h, !1);
      }
    } else document.attachEvent && (l = c, a = o.document, i = !1, z = function z() {
      i || (i = !0, l());
    }, (_s = function s() {
      try {
        a.documentElement.doScroll("left");
      } catch (c) {
        return void setTimeout(_s, 50);
      }z();
    })(), a.onreadystatechange = function () {
      "complete" == a.readyState && (a.onreadystatechange = null, z());
    });var l, a, i, z, _s;
  }(function () {
    var c, h;(c = document.createElement("div")).innerHTML = l, l = null, (h = c.getElementsByTagName("svg")[0]) && (h.setAttribute("aria-hidden", "true"), h.style.position = "absolute", h.style.width = 0, h.style.height = 0, h.style.overflow = "hidden", function (c, h) {
      h.firstChild ? function (c, h) {
        h.parentNode.insertBefore(c, h);
      }(c, h.firstChild) : h.appendChild(c);
    }(h, document.body));
  });
}(window);

/***/ }),

/***/ "fBOH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fGAH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gbDm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iJmC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jSle":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k359":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mEq0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mT/2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mUOd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mUbh":
/***/ (function(module, exports) {



/***/ }),

/***/ "muQq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n65B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nEXI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nUus":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o7jZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p8U2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pU2I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pzpp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q8ob":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qpl0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rIdj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f9fa4da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("RuT6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s3+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sck6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "su3c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "suTl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tRHA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u2uO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uJYL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uRzL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uWFK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ugrf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v5hk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vF4t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vjFQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x39u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xDlu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xLFd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xdSk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xqBC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y8mh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z+Xl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zvuZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.5cf08616bdebd4093503.js